
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire776f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire776f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9zr9G", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $6f7c72613b8aa92a$export$2e2bcd8739ae039);
// Heavily based on this etmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js

var $9t3dO = parcelRequire("9t3dO");

var $zBlxr = parcelRequire("zBlxr");

var $jU5gu = parcelRequire("jU5gu");

var $cVtoA = parcelRequire("cVtoA");

var $klaWo = parcelRequire("klaWo");

var $k0stT = parcelRequire("k0stT");

var $iKZ74 = parcelRequire("iKZ74");

var $a9oRf = parcelRequire("a9oRf");
function init() {
    if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
    if (this.approx) {
        // When '+approx' is set, use tmerc instead
        (0, $9t3dO.default).init.apply(this);
        this.forward = (0, $9t3dO.default).forward;
        this.inverse = (0, $9t3dO.default).inverse;
    }
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    this.cgb = [];
    this.cbg = [];
    this.utg = [];
    this.gtu = [];
    var f = this.es / (1 + Math.sqrt(1 - this.es));
    var n = f / (2 - f);
    var np = n;
    this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
    this.cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
    np = np * n;
    this.cgb[1] = np * (7 / 3 + n * (-1.6 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
    np = np * n;
    this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (1.6 + n * (-12686 / 2835))));
    np = np * n;
    this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    this.cbg[3] = np * (1237 / 630 + n * (-2.4 + n * (-24832 / 14175)));
    np = np * n;
    this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
    np = np * n;
    this.cgb[5] = np * (601676 / 22275);
    this.cbg[5] = np * (444337 / 155925);
    np = Math.pow(n, 2);
    this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
    this.utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
    this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    this.gtu[1] = np * (13 / 48 + n * (-0.6 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
    np = np * n;
    this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
    this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
    np = np * n;
    this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
    np = np * n;
    this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
    np = np * n;
    this.utg[5] = np * (-20648693 / 638668800);
    this.gtu[5] = np * 0.6650675310896665;
    var Z = (0, $klaWo.default)(this.cbg, this.lat0);
    this.Zb = -this.Qn * (Z + (0, $k0stT.default)(this.gtu, 2 * Z));
}
function forward(p) {
    var Ce = (0, $a9oRf.default)(p.x - this.long0);
    var Cn = p.y;
    Cn = (0, $klaWo.default)(this.cbg, Cn);
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);
    Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = Math.atan2(sin_Ce * cos_Cn, (0, $jU5gu.default)(sin_Cn, cos_Cn * cos_Ce));
    Ce = (0, $cVtoA.default)(Math.tan(Ce));
    var tmp = (0, $iKZ74.default)(this.gtu, 2 * Cn, 2 * Ce);
    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];
    var x;
    var y;
    if (Math.abs(Ce) <= 2.623395162778) {
        x = this.a * (this.Qn * Ce) + this.x0;
        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
    } else {
        x = Infinity;
        y = Infinity;
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var Ce = (p.x - this.x0) * (1 / this.a);
    var Cn = (p.y - this.y0) * (1 / this.a);
    Cn = (Cn - this.Zb) / this.Qn;
    Ce = Ce / this.Qn;
    var lon;
    var lat;
    if (Math.abs(Ce) <= 2.623395162778) {
        var tmp = (0, $iKZ74.default)(this.utg, 2 * Cn, 2 * Ce);
        Cn = Cn + tmp[0];
        Ce = Ce + tmp[1];
        Ce = Math.atan((0, $zBlxr.default)(Ce));
        var sin_Cn = Math.sin(Cn);
        var cos_Cn = Math.cos(Cn);
        var sin_Ce = Math.sin(Ce);
        var cos_Ce = Math.cos(Ce);
        Cn = Math.atan2(sin_Cn * cos_Ce, (0, $jU5gu.default)(sin_Ce, cos_Ce * cos_Cn));
        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
        lon = (0, $a9oRf.default)(Ce + this.long0);
        lat = (0, $klaWo.default)(this.cgb, Cn);
    } else {
        lon = Infinity;
        lat = Infinity;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    "Extended_Transverse_Mercator",
    "Extended Transverse Mercator",
    "etmerc",
    "Transverse_Mercator",
    "Transverse Mercator",
    "tmerc"
];
var $6f7c72613b8aa92a$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});
parcelRegister("9t3dO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e495242beb4668f$export$2e2bcd8739ae039);
// Heavily based on this tmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js

var $gqKpL = parcelRequire("gqKpL");

var $hpUQm = parcelRequire("hpUQm");

var $jQUK6 = parcelRequire("jQUK6");

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $6e495242beb4668f$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    if (this.es) {
        this.en = (0, $gqKpL.default)(this.es);
        this.ml0 = (0, $hpUQm.default)(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
}
function $6e495242beb4668f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    var con;
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);
    if (!this.es) {
        var b = cos_phi * Math.sin(delta_lon);
        if (Math.abs(Math.abs(b) - 1) < (0, $gyVUi.EPSLN)) return 93;
        else {
            x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
            y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
            b = Math.abs(y);
            if (b >= 1) {
                if (b - 1 > (0, $gyVUi.EPSLN)) return 93;
                else y = 0;
            } else y = Math.acos(y);
            if (lat < 0) y = -y;
            y = this.a * this.k0 * (y - this.lat0) + this.y0;
        }
    } else {
        var al = cos_phi * delta_lon;
        var als = Math.pow(al, 2);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var tq = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(lat) : 0;
        var t = Math.pow(tq, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        al = al / Math.sqrt(con);
        var ml = (0, $hpUQm.default)(lat, sin_phi, cos_phi, this.en);
        x = this.a * (this.k0 * al * (1 + als / 6 * (1 - t + c + als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c + als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) + this.x0;
        y = this.a * (this.k0 * (ml - this.ml0 + sin_phi * delta_lon * al / 2 * (1 + als / 12 * (5 - t + 9 * c + 4 * cs + als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c + als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) + this.y0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $6e495242beb4668f$export$70ae2c07e401031b(p) {
    var con, phi;
    var lat, lon;
    var x = (p.x - this.x0) * (1 / this.a);
    var y = (p.y - this.y0) * (1 / this.a);
    if (!this.es) {
        var f = Math.exp(x / this.k0);
        var g = 0.5 * (f - 1 / f);
        var temp = this.lat0 + y / this.k0;
        var h = Math.cos(temp);
        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
        lat = Math.asin(con);
        if (y < 0) lat = -lat;
        if (g === 0 && h === 0) lon = 0;
        else lon = (0, $a9oRf.default)(Math.atan2(g, h) + this.long0);
    } else {
        con = this.ml0 + y / this.k0;
        phi = (0, $jQUK6.default)(con, this.es, this.en);
        if (Math.abs(phi) < (0, $gyVUi.HALF_PI)) {
            var sin_phi = Math.sin(phi);
            var cos_phi = Math.cos(phi);
            var tan_phi = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(phi) : 0;
            var c = this.ep2 * Math.pow(cos_phi, 2);
            var cs = Math.pow(c, 2);
            var t = Math.pow(tan_phi, 2);
            var ts = Math.pow(t, 2);
            con = 1 - this.es * Math.pow(sin_phi, 2);
            var d = x * Math.sqrt(con) / this.k0;
            var ds = Math.pow(d, 2);
            con = con * tan_phi;
            lat = phi - con * ds / (1 - this.es) * 0.5 * (1 - ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs - ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c - ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));
            lon = (0, $a9oRf.default)(this.long0 + d * (1 - ds / 6 * (1 + 2 * t + c - ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c - ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi);
        } else {
            lat = (0, $gyVUi.HALF_PI) * (0, $boTd3.default)(y);
            lon = 0;
        }
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $6e495242beb4668f$export$e4b2ac9215619f8d = [
    "Fast_Transverse_Mercator",
    "Fast Transverse Mercator"
];
var $6e495242beb4668f$export$2e2bcd8739ae039 = {
    init: $6e495242beb4668f$export$2cd8252107eb640b,
    forward: $6e495242beb4668f$export$174bb771924e7eb1,
    inverse: $6e495242beb4668f$export$70ae2c07e401031b,
    names: $6e495242beb4668f$export$e4b2ac9215619f8d
};

});
parcelRegister("gqKpL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf6313ff986be9ac$export$2e2bcd8739ae039);
var $bf6313ff986be9ac$var$C00 = 1;
var $bf6313ff986be9ac$var$C02 = 0.25;
var $bf6313ff986be9ac$var$C04 = 0.046875;
var $bf6313ff986be9ac$var$C06 = 0.01953125;
var $bf6313ff986be9ac$var$C08 = 0.01068115234375;
var $bf6313ff986be9ac$var$C22 = 0.75;
var $bf6313ff986be9ac$var$C44 = 0.46875;
var $bf6313ff986be9ac$var$C46 = 0.01302083333333333333;
var $bf6313ff986be9ac$var$C48 = 0.00712076822916666666;
var $bf6313ff986be9ac$var$C66 = 0.36458333333333333333;
var $bf6313ff986be9ac$var$C68 = 0.00569661458333333333;
var $bf6313ff986be9ac$var$C88 = 0.3076171875;
function $bf6313ff986be9ac$export$2e2bcd8739ae039(es) {
    var en = [];
    en[0] = $bf6313ff986be9ac$var$C00 - es * ($bf6313ff986be9ac$var$C02 + es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    en[1] = es * ($bf6313ff986be9ac$var$C22 - es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    var t = es * es;
    en[2] = t * ($bf6313ff986be9ac$var$C44 - es * ($bf6313ff986be9ac$var$C46 + es * $bf6313ff986be9ac$var$C48));
    t *= es;
    en[3] = t * ($bf6313ff986be9ac$var$C66 - es * $bf6313ff986be9ac$var$C68);
    en[4] = t * es * $bf6313ff986be9ac$var$C88;
    return en;
}

});

parcelRegister("hpUQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae0dd692f473684$export$2e2bcd8739ae039);
function $cae0dd692f473684$export$2e2bcd8739ae039(phi, sphi, cphi, en) {
    cphi *= sphi;
    sphi *= sphi;
    return en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4])));
}

});

parcelRegister("jQUK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e73ee39023f9c198$export$2e2bcd8739ae039);

var $hpUQm = parcelRequire("hpUQm");

var $gyVUi = parcelRequire("gyVUi");
var $e73ee39023f9c198$var$MAX_ITER = 20;
function $e73ee39023f9c198$export$2e2bcd8739ae039(arg, es, en) {
    var k = 1 / (1 - es);
    var phi = arg;
    for(var i = $e73ee39023f9c198$var$MAX_ITER; i; --i){
        var s = Math.sin(phi);
        var t = 1 - es * s * s;
        //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
        //phi -= t * (t * Math.sqrt(t)) * k;
        t = ((0, $hpUQm.default)(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
        phi -= t;
        if (Math.abs(t) < (0, $gyVUi.EPSLN)) return phi;
    }
    //..reportError("cass:pj_inv_mlfn: Convergence error");
    return phi;
}

});
parcelRegister("gyVUi", function(module, exports) {

$parcel$export(module.exports, "PJD_3PARAM", () => $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27);
$parcel$export(module.exports, "PJD_7PARAM", () => $c0ecbd71ed29ee86$export$8cab19b7f383a7a7);
$parcel$export(module.exports, "PJD_GRIDSHIFT", () => $c0ecbd71ed29ee86$export$83d26ae02793dd10);
$parcel$export(module.exports, "PJD_WGS84", () => $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb);
$parcel$export(module.exports, "PJD_NODATUM", () => $c0ecbd71ed29ee86$export$8df4c7729d8ed58d);
$parcel$export(module.exports, "SRS_WGS84_SEMIMAJOR", () => $c0ecbd71ed29ee86$export$d612c03b7390d945);
$parcel$export(module.exports, "SRS_WGS84_SEMIMINOR", () => $c0ecbd71ed29ee86$export$59af086d7527ec46);
$parcel$export(module.exports, "SRS_WGS84_ESQUARED", () => $c0ecbd71ed29ee86$export$9b798f9d78b99fc0);
$parcel$export(module.exports, "SEC_TO_RAD", () => $c0ecbd71ed29ee86$export$e0b9011552f3b2f7);
$parcel$export(module.exports, "HALF_PI", () => $c0ecbd71ed29ee86$export$f504979d7e0a75c7);
$parcel$export(module.exports, "SIXTH", () => $c0ecbd71ed29ee86$export$d7977f56a0faa834);
$parcel$export(module.exports, "RA4", () => $c0ecbd71ed29ee86$export$9e703428410a9c7b);
$parcel$export(module.exports, "RA6", () => $c0ecbd71ed29ee86$export$bb54dde5565ed6e3);
$parcel$export(module.exports, "EPSLN", () => $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb);
$parcel$export(module.exports, "D2R", () => $c0ecbd71ed29ee86$export$ed6012a68c0f4a70);
$parcel$export(module.exports, "R2D", () => $c0ecbd71ed29ee86$export$456934b8be7498c3);
$parcel$export(module.exports, "FORTPI", () => $c0ecbd71ed29ee86$export$10cb69dd603c11b0);
$parcel$export(module.exports, "TWO_PI", () => $c0ecbd71ed29ee86$export$6eec49b1a6289c4e);
$parcel$export(module.exports, "SPI", () => $c0ecbd71ed29ee86$export$703a92fc6506ffb9);
var $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27 = 1;
var $c0ecbd71ed29ee86$export$8cab19b7f383a7a7 = 2;
var $c0ecbd71ed29ee86$export$83d26ae02793dd10 = 3;
var $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb = 4; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$8df4c7729d8ed58d = 5; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$d612c03b7390d945 = 6378137.0; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$59af086d7527ec46 = 6356752.314; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$9b798f9d78b99fc0 = 0.0066943799901413165; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$e0b9011552f3b2f7 = 4.84813681109535993589914102357e-6;
var $c0ecbd71ed29ee86$export$f504979d7e0a75c7 = Math.PI / 2;
var $c0ecbd71ed29ee86$export$d7977f56a0faa834 = 0.1666666666666666667;
var $c0ecbd71ed29ee86$export$9e703428410a9c7b = 0.04722222222222222222;
var $c0ecbd71ed29ee86$export$bb54dde5565ed6e3 = 0.02215608465608465608;
var $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb = 1.0e-10;
var $c0ecbd71ed29ee86$export$ed6012a68c0f4a70 = 0.01745329251994329577;
var $c0ecbd71ed29ee86$export$456934b8be7498c3 = 57.29577951308232088;
var $c0ecbd71ed29ee86$export$10cb69dd603c11b0 = Math.PI / 4;
var $c0ecbd71ed29ee86$export$6eec49b1a6289c4e = Math.PI * 2;
var $c0ecbd71ed29ee86$export$703a92fc6506ffb9 = 3.14159265359;

});


parcelRegister("a9oRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $763e06e438986b6c$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $763e06e438986b6c$export$2e2bcd8739ae039(x) {
    return Math.abs(x) <= (0, $gyVUi.SPI) ? x : x - (0, $boTd3.default)(x) * (0, $gyVUi.TWO_PI);
}

});
parcelRegister("boTd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ccc316da8510bf$export$2e2bcd8739ae039);
function $84ccc316da8510bf$export$2e2bcd8739ae039(x) {
    return x < 0 ? -1 : 1;
}

});



parcelRegister("zBlxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b03d370063c40e$export$2e2bcd8739ae039);
function $06b03d370063c40e$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r - 1 / r) / 2;
    return r;
}

});

parcelRegister("jU5gu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d754d244264a37$export$2e2bcd8739ae039);
function $e7d754d244264a37$export$2e2bcd8739ae039(x, y) {
    x = Math.abs(x);
    y = Math.abs(y);
    var a = Math.max(x, y);
    var b = Math.min(x, y) / (a ? a : 1);
    return a * Math.sqrt(1 + Math.pow(b, 2));
}

});

parcelRegister("cVtoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $96919c3c2b0cfee9$export$2e2bcd8739ae039);

var $jU5gu = parcelRequire("jU5gu");

var $g1hBf = parcelRequire("g1hBf");
function $96919c3c2b0cfee9$export$2e2bcd8739ae039(x) {
    var y = Math.abs(x);
    y = (0, $g1hBf.default)(y * (1 + y / ((0, $jU5gu.default)(1, y) + 1)));
    return x < 0 ? -y : y;
}

});
parcelRegister("g1hBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a64430787103e$export$2e2bcd8739ae039);
function $ba9a64430787103e$export$2e2bcd8739ae039(x) {
    var y = 1 + x;
    var z = y - 1;
    return z === 0 ? x : x * Math.log(y) / z;
}

});


parcelRegister("klaWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecee41736c9c0e4b$export$2e2bcd8739ae039);
function $ecee41736c9c0e4b$export$2e2bcd8739ae039(pp, B) {
    var cos_2B = 2 * Math.cos(2 * B);
    var i = pp.length - 1;
    var h1 = pp[i];
    var h2 = 0;
    var h;
    while(--i >= 0){
        h = -h2 + cos_2B * h1 + pp[i];
        h2 = h1;
        h1 = h;
    }
    return B + h * Math.sin(2 * B);
}

});

parcelRegister("k0stT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e909e682fc23c405$export$2e2bcd8739ae039);
function $e909e682fc23c405$export$2e2bcd8739ae039(pp, arg_r) {
    var r = 2 * Math.cos(arg_r);
    var i = pp.length - 1;
    var hr1 = pp[i];
    var hr2 = 0;
    var hr;
    while(--i >= 0){
        hr = -hr2 + r * hr1 + pp[i];
        hr2 = hr1;
        hr1 = hr;
    }
    return Math.sin(arg_r) * hr;
}

});

parcelRegister("iKZ74", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7beda932685c15$export$2e2bcd8739ae039);

var $zBlxr = parcelRequire("zBlxr");

var $cz4ED = parcelRequire("cz4ED");
function $da7beda932685c15$export$2e2bcd8739ae039(pp, arg_r, arg_i) {
    var sin_arg_r = Math.sin(arg_r);
    var cos_arg_r = Math.cos(arg_r);
    var sinh_arg_i = (0, $zBlxr.default)(arg_i);
    var cosh_arg_i = (0, $cz4ED.default)(arg_i);
    var r = 2 * cos_arg_r * cosh_arg_i;
    var i = -2 * sin_arg_r * sinh_arg_i;
    var j = pp.length - 1;
    var hr = pp[j];
    var hi1 = 0;
    var hr1 = 0;
    var hi = 0;
    var hr2;
    var hi2;
    while(--j >= 0){
        hr2 = hr1;
        hi2 = hi1;
        hr1 = hr;
        hi1 = hi;
        hr = -hr2 + r * hr1 - i * hi1 + pp[j];
        hi = -hi2 + i * hr1 + r * hi1;
    }
    r = sin_arg_r * cosh_arg_i;
    i = cos_arg_r * sinh_arg_i;
    return [
        r * hr - i * hi,
        r * hi + i * hr
    ];
}

});
parcelRegister("cz4ED", function(module, exports) {

$parcel$export(module.exports, "default", () => $925c5d35b4e59088$export$2e2bcd8739ae039);
function $925c5d35b4e59088$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r + 1 / r) / 2;
    return r;
}

});



parcelRegister("llHto", function(module, exports) {

$parcel$export(module.exports, "ssfn_", () => ssfn_);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $f8ad4802022ce868$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");

var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $a9oRf = parcelRequire("a9oRf");
function ssfn_(phit, sinphi, eccen) {
    sinphi *= eccen;
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen);
}
function init() {
    this.coslat0 = Math.cos(this.lat0);
    this.sinlat0 = Math.sin(this.lat0);
    if (this.sphere) {
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) this.k0 = 0.5 * (1 + (0, $boTd3.default)(this.lat0) * Math.sin(this.lat_ts));
    } else {
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) //North pole
            //trace('stere:north pole');
            this.con = 1;
            else //South pole
            //trace('stere:south pole');
            this.con = -1;
        }
        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) this.k0 = 0.5 * this.cons * (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / (0, $3xC66.default)(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
        this.ms1 = (0, $bi5ZC.default)(this.e, this.sinlat0, this.coslat0);
        this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - (0, $gyVUi.HALF_PI);
        this.cosX0 = Math.cos(this.X0);
        this.sinX0 = Math.sin(this.X0);
    }
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var sinlat = Math.sin(lat);
    var coslat = Math.cos(lat);
    var A, X, sinX, cosX, ts, rh;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= (0, $gyVUi.EPSLN) && Math.abs(lat + this.lat0) <= (0, $gyVUi.EPSLN)) {
        //case of the origine point
        //trace('stere:this is the origin point');
        p.x = NaN;
        p.y = NaN;
        return p;
    }
    if (this.sphere) {
        //trace('stere:sphere case');
        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
        return p;
    } else {
        X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - (0, $gyVUi.HALF_PI);
        cosX = Math.cos(X);
        sinX = Math.sin(X);
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            ts = (0, $3xC66.default)(this.e, lat * this.con, this.con * sinlat);
            rh = 2 * this.a * this.k0 * ts / this.cons;
            p.x = this.x0 + rh * Math.sin(lon - this.long0);
            p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
            //trace(p.toString());
            return p;
        } else if (Math.abs(this.sinlat0) < (0, $gyVUi.EPSLN)) {
            //Eq
            //trace('stere:equateur');
            A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
            p.y = A * sinX;
        } else {
            //other case
            //trace('stere:normal case');
            A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
            p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
        }
        p.x = A * cosX * Math.sin(dlon) + this.x0;
    }
    //trace(p.toString());
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat, ts, ce, Chi;
    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (this.sphere) {
        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
        lon = this.long0;
        lat = this.lat0;
        if (rh <= (0, $gyVUi.EPSLN)) {
            p.x = lon;
            p.y = lat;
            return p;
        }
        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
        if (Math.abs(this.coslat0) < (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y));
            else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y));
        } else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
        p.x = lon;
        p.y = lat;
        return p;
    } else if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
        if (rh <= (0, $gyVUi.EPSLN)) {
            lat = this.lat0;
            lon = this.long0;
            p.x = lon;
            p.y = lat;
            //trace(p.toString());
            return p;
        }
        p.x *= this.con;
        p.y *= this.con;
        ts = rh * this.cons / (2 * this.a * this.k0);
        lat = this.con * (0, $2AZR8.default)(this.e, ts);
        lon = this.con * (0, $a9oRf.default)(this.con * this.long0 + Math.atan2(p.x, -1 * p.y));
    } else {
        ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
        lon = this.long0;
        if (rh <= (0, $gyVUi.EPSLN)) Chi = this.X0;
        else {
            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
        }
        lat = -1 * (0, $2AZR8.default)(this.e, Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + Chi)));
    }
    p.x = lon;
    p.y = lat;
    //trace(p.toString());
    return p;
}
var names = [
    "stere",
    "Stereographic_South_Pole",
    "Polar Stereographic (variant B)"
];
var $f8ad4802022ce868$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    ssfn_: ssfn_
};

});
parcelRegister("bi5ZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8386063044328ea8$export$2e2bcd8739ae039);
function $8386063044328ea8$export$2e2bcd8739ae039(eccent, sinphi, cosphi) {
    var con = eccent * sinphi;
    return cosphi / Math.sqrt(1 - con * con);
}

});

parcelRegister("3xC66", function(module, exports) {

$parcel$export(module.exports, "default", () => $2942018063c2eff1$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $2942018063c2eff1$export$2e2bcd8739ae039(eccent, phi, sinphi) {
    var con = eccent * sinphi;
    var com = 0.5 * eccent;
    con = Math.pow((1 - con) / (1 + con), com);
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) - phi)) / con;
}

});

parcelRegister("2AZR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3eece278ef2a71$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $1e3eece278ef2a71$export$2e2bcd8739ae039(eccent, ts) {
    var eccnth = 0.5 * eccent;
    var con, dphi;
    var phi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts);
    for(var i = 0; i <= 15; i++){
        con = eccent * Math.sin(phi);
        dphi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts * Math.pow((1 - con) / (1 + con), eccnth)) - phi;
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //console.log("phi2z has NoConvergence");
    return -9999;
}

});


parcelRegister("deudM", function(module, exports) {

$parcel$export(module.exports, "S_POLE", () => S_POLE);
$parcel$export(module.exports, "N_POLE", () => N_POLE);
$parcel$export(module.exports, "EQUIT", () => EQUIT);
$parcel$export(module.exports, "OBLIQ", () => OBLIQ);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $9a24067d8ab69621$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");
var S_POLE = 1;
var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;
function init() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
    else if (Math.abs(t) < (0, $gyVUi.EPSLN)) this.mode = this.EQUIT;
    else this.mode = this.OBLIQ;
    if (this.es > 0) {
        var sinphi;
        this.qp = (0, $874JP.default)(this.e, 1);
        this.mmf = 0.5 / (1 - this.es);
        this.apa = authset(this.es);
        switch(this.mode){
            case this.N_POLE:
                this.dd = 1;
                break;
            case this.S_POLE:
                this.dd = 1;
                break;
            case this.EQUIT:
                this.rq = Math.sqrt(0.5 * this.qp);
                this.dd = 1 / this.rq;
                this.xmf = 1;
                this.ymf = 0.5 * this.qp;
                break;
            case this.OBLIQ:
                this.rq = Math.sqrt(0.5 * this.qp);
                sinphi = Math.sin(this.lat0);
                this.sinb1 = (0, $874JP.default)(this.e, sinphi) / this.qp;
                this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
                this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
                this.ymf = (this.xmf = this.rq) / this.dd;
                this.xmf *= this.dd;
                break;
        }
    } else if (this.mode === this.OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
}
function forward(p) {
    /* Forward equations
      -----------------*/ var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0);
    if (this.sphere) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        coslam = Math.cos(lam);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            y = this.mode === this.EQUIT ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            if (y <= (0, $gyVUi.EPSLN)) return null;
            y = Math.sqrt(2 / y);
            x = y * cosphi * Math.sin(lam);
            y *= this.mode === this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) coslam = -coslam;
            if (Math.abs(phi + this.lat0) < (0, $gyVUi.EPSLN)) return null;
            y = (0, $gyVUi.FORTPI) - phi * 0.5;
            y = 2 * (this.mode === this.S_POLE ? Math.cos(y) : Math.sin(y));
            x = y * Math.sin(lam);
            y *= coslam;
        }
    } else {
        sinb = 0;
        cosb = 0;
        b = 0;
        coslam = Math.cos(lam);
        sinlam = Math.sin(lam);
        sinphi = Math.sin(phi);
        q = (0, $874JP.default)(this.e, sinphi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinb = q / this.qp;
            cosb = Math.sqrt(1 - sinb * sinb);
        }
        switch(this.mode){
            case this.OBLIQ:
                b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
                break;
            case this.EQUIT:
                b = 1 + cosb * coslam;
                break;
            case this.N_POLE:
                b = (0, $gyVUi.HALF_PI) + phi;
                q = this.qp - q;
                break;
            case this.S_POLE:
                b = phi - (0, $gyVUi.HALF_PI);
                q = this.qp + q;
                break;
        }
        if (Math.abs(b) < (0, $gyVUi.EPSLN)) return null;
        switch(this.mode){
            case this.OBLIQ:
            case this.EQUIT:
                b = Math.sqrt(2 / b);
                if (this.mode === this.OBLIQ) y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
                else y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
                x = this.xmf * b * cosb * sinlam;
                break;
            case this.N_POLE:
            case this.S_POLE:
                if (q >= 0) {
                    x = (b = Math.sqrt(q)) * sinlam;
                    y = coslam * (this.mode === this.S_POLE ? b : -b);
                } else x = y = 0;
                break;
        }
    }
    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi, cCe, sCe, q, rho, ab;
    if (this.sphere) {
        var cosz = 0, rh, sinz = 0;
        rh = Math.sqrt(x * x + y * y);
        phi = rh * 0.5;
        if (phi > 1) return null;
        phi = 2 * Math.asin(phi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinz = Math.sin(phi);
            cosz = Math.cos(phi);
        }
        switch(this.mode){
            case this.EQUIT:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? 0 : Math.asin(y * sinz / rh);
                x *= sinz;
                y = cosz * rh;
                break;
            case this.OBLIQ:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
                x *= sinz * this.cosph0;
                y = (cosz - Math.sin(phi) * this.sinph0) * rh;
                break;
            case this.N_POLE:
                y = -y;
                phi = (0, $gyVUi.HALF_PI) - phi;
                break;
            case this.S_POLE:
                phi -= (0, $gyVUi.HALF_PI);
                break;
        }
        lam = y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(x, y);
    } else {
        ab = 0;
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            x /= this.dd;
            y *= this.dd;
            rho = Math.sqrt(x * x + y * y);
            if (rho < (0, $gyVUi.EPSLN)) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            sCe = 2 * Math.asin(0.5 * rho / this.rq);
            cCe = Math.cos(sCe);
            x *= sCe = Math.sin(sCe);
            if (this.mode === this.OBLIQ) {
                ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
                q = this.qp * ab;
                y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
            } else {
                ab = y * sCe / rho;
                q = this.qp * ab;
                y = rho * cCe;
            }
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) y = -y;
            q = x * x + y * y;
            if (!q) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            ab = 1 - q / this.qp;
            if (this.mode === this.S_POLE) ab = -ab;
        }
        lam = Math.atan2(x, y);
        phi = authlat(Math.asin(ab), this.apa);
    }
    p.x = (0, $a9oRf.default)(this.long0 + lam);
    p.y = phi;
    return p;
}
/* determine latitude from authalic latitude */ var P00 = 0.33333333333333333333;
var P01 = 0.17222222222222222222;
var P02 = 0.10257936507936507936;
var P10 = 0.06388888888888888888;
var P11 = 0.06640211640211640211;
var P20 = 0.01641501294219154443;
function authset(es) {
    var t;
    var APA = [];
    APA[0] = es * P00;
    t = es * es;
    APA[0] += t * P01;
    APA[1] = t * P10;
    t *= es;
    APA[0] += t * P02;
    APA[1] += t * P11;
    APA[2] = t * P20;
    return APA;
}
function authlat(beta, APA) {
    var t = beta + beta;
    return beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t);
}
var names = [
    "Lambert Azimuthal Equal Area",
    "Lambert_Azimuthal_Equal_Area",
    "laea"
];
var $9a24067d8ab69621$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    S_POLE: S_POLE,
    N_POLE: N_POLE,
    EQUIT: EQUIT,
    OBLIQ: OBLIQ
};

});
parcelRegister("874JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e82a7153665d151$export$2e2bcd8739ae039);
function $5e82a7153665d151$export$2e2bcd8739ae039(eccent, sinphi) {
    var con;
    if (eccent > 1.0e-7) {
        con = eccent * sinphi;
        return (1 - eccent * eccent) * (sinphi / (1 - con * con) - 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    } else return 2 * sinphi;
}

});


parcelRegister("8mhgZ", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "phi1z", () => phi1z);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $615dc6dbd83ac6d5$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function init() {
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);
    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs1 = (0, $874JP.default)(this.e3, this.sin_po, this.cos_po);
    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs2 = (0, $874JP.default)(this.e3, this.sin_po, this.cos_po);
    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = (0, $874JP.default)(this.e3, this.sin_po, this.cos_po);
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    else this.ns0 = this.con;
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);
    var qs = (0, $874JP.default)(this.e3, this.sin_phi, this.cos_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * (0, $a9oRf.default)(lon - this.long0);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh1, qs, con, theta, lon, lat;
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    con = rh1 * this.ns0 / this.a;
    if (this.sphere) lat = Math.asin((this.c - con * con) / (2 * this.ns0));
    else {
        qs = (this.c - con * con) / this.ns0;
        lat = this.phi1z(this.e3, qs);
    }
    lon = (0, $a9oRf.default)(theta / this.ns0 + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
}
function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = (0, $ljPJJ.default)(0.5 * qs);
    if (eccent < (0, $gyVUi.EPSLN)) return phi;
    var eccnts = eccent * eccent;
    for(var i = 1; i <= 25; i++){
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        con = eccent * sinphi;
        com = 1 - con * con;
        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi = phi + dphi;
        if (Math.abs(dphi) <= 1e-7) return phi;
    }
    return null;
}
var names = [
    "Albers_Conic_Equal_Area",
    "Albers",
    "aea"
];
var $615dc6dbd83ac6d5$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    phi1z: phi1z
};

});
parcelRegister("ljPJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8538120e633ea57$export$2e2bcd8739ae039);
function $f8538120e633ea57$export$2e2bcd8739ae039(x) {
    if (Math.abs(x) > 1) x = x > 1 ? 1 : -1;
    return Math.asin(x);
}

});


parcelRegister("6Eu1X", function(module, exports) {

$parcel$export(module.exports, "iterations", () => iterations);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $4d7dc5ed367b221e$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
var iterations = 1;
function init() {
    this.A = [];
    this.A[1] = 0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = 0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = 0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = 0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = 0.00067;
    this.A[10] = -0.00034;
    this.B_re = [];
    this.B_im = [];
    this.B_re[1] = 0.7557853228;
    this.B_im[1] = 0;
    this.B_re[2] = 0.249204646;
    this.B_im[2] = 0.003371507;
    this.B_re[3] = -0.001541739;
    this.B_im[3] = 0.041058560;
    this.B_re[4] = -0.10162907;
    this.B_im[4] = 0.01727609;
    this.B_re[5] = -0.26623489;
    this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;
    this.B_im[6] = -1.1651967;
    this.C_re = [];
    this.C_im = [];
    this.C_re[1] = 1.3231270439;
    this.C_im[1] = 0;
    this.C_re[2] = -0.577245789;
    this.C_im[2] = -0.007809598;
    this.C_re[3] = 0.508307513;
    this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;
    this.C_im[4] = 0.18200602;
    this.C_re[5] = 1.01418179;
    this.C_im[5] = 1.64497696;
    this.C_re[6] = 1.9660549;
    this.C_im[6] = 2.5127645;
    this.D = [];
    this.D[1] = 1.5627014243;
    this.D[2] = 0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = 0.007317;
    this.D[7] = 0.01220;
    this.D[8] = 0.00394;
    this.D[9] = -0.0013;
}
function forward(p) {
    var n;
    var lon = p.x;
    var lat = p.y;
    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;
    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / (0, $gyVUi.SEC_TO_RAD) * 1E-5;
    var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0
    var d_psi = 0;
    for(n = 1; n <= 10; n++){
        d_phi_n = d_phi_n * d_phi;
        d_psi = d_psi + this.A[n] * d_phi_n;
    }
    // 2. Calculate theta
    var th_re = d_psi;
    var th_im = d_lambda;
    // 3. Calculate z
    var th_n_re = 1;
    var th_n_im = 0; // theta^0
    var th_n_re1;
    var th_n_im1;
    var z_re = 0;
    var z_im = 0;
    for(n = 1; n <= 6; n++){
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }
    // 4. Calculate easting and northing
    p.x = z_im * this.a + this.x0;
    p.y = z_re * this.a + this.y0;
    return p;
}
function inverse(p) {
    var n;
    var x = p.x;
    var y = p.y;
    var delta_x = x - this.x0;
    var delta_y = y - this.y0;
    // 1. Calculate z
    var z_re = delta_y / this.a;
    var z_im = delta_x / this.a;
    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;
    var z_n_im = 0; // z^0
    var z_n_re1;
    var z_n_im1;
    var th_re = 0;
    var th_im = 0;
    for(n = 1; n <= 6; n++){
        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
        z_n_re = z_n_re1;
        z_n_im = z_n_im1;
        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }
    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for(var i = 0; i < this.iterations; i++){
        var th_n_re = th_re;
        var th_n_im = th_im;
        var th_n_re1;
        var th_n_im1;
        var num_re = z_re;
        var num_im = z_im;
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        th_n_re = 1;
        th_n_im = 0;
        var den_re = this.B_re[1];
        var den_im = this.B_im[1];
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        // Complex division
        var den2 = den_re * den_re + den_im * den_im;
        th_re = (num_re * den_re + num_im * den_im) / den2;
        th_im = (num_im * den_re - num_re * den_im) / den2;
    }
    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;
    var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0
    var d_phi = 0;
    for(n = 1; n <= 9; n++){
        d_psi_n = d_psi_n * d_psi;
        d_phi = d_phi + this.D[n] * d_psi_n;
    }
    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + d_phi * (0, $gyVUi.SEC_TO_RAD) * 1E5;
    var lon = this.long0 + d_lambda;
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    "New_Zealand_Map_Grid",
    "nzmg"
];
var $4d7dc5ed367b221e$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});


/**
 * @module ol/Map
 */ /**
 * @module ol/Object
 */ /**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ class $aeedce20e9577100$var$BaseEvent {
    /**
   * @param {string} type Type.
   */ constructor(type){
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ preventDefault() {
        this.defaultPrevented = true;
    }
    /**
   * Stop event propagation.
   * @api
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}
function $aeedce20e9577100$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $aeedce20e9577100$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $aeedce20e9577100$export$2e2bcd8739ae039 = $aeedce20e9577100$var$BaseEvent;


/**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $e881b5dca21eb5d4$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: "propertychange"
};


/**
 * @module ol/Observable
 */ /**
 * @module ol/events/Target
 */ /**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ class $3273ed08087da3da$var$Disposable {
    constructor(){
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    /**
   * Clean up.
   */ dispose() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    }
    /**
   * Extension point for disposable objects.
   * @protected
   */ disposeInternal() {}
}
var $3273ed08087da3da$export$2e2bcd8739ae039 = $3273ed08087da3da$var$Disposable;



/**
 * @module ol/functions
 */ /**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $b998d41b678ed5d1$export$2e0ae67339d5f1ac(haystack, needle, comparator) {
    let mid, cmp;
    comparator = comparator || $b998d41b678ed5d1$export$fcb633242ef15540;
    let low = 0;
    let high = haystack.length;
    let found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $b998d41b678ed5d1$export$fcb633242ef15540(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $b998d41b678ed5d1$export$4fa3190a997c3d8f(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $b998d41b678ed5d1$export$8a3786cc03fdb777(arr, target, direction) {
    if (arr[0] <= target) return 0;
    const n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === "function") {
        for(let i = 1; i < n; ++i){
            const candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        return n - 1;
    }
    for(let i = 1; i < n; ++i){
        if (arr[i] == target) return i;
        if (arr[i] < target) {
            if (arr[i - 1] - target < target - arr[i]) return i - 1;
            return i;
        }
    }
    return n - 1;
}
function $b998d41b678ed5d1$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        const tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $b998d41b678ed5d1$export$8b58be045bf06082(arr, data) {
    const extension = Array.isArray(data) ? data : [
        data
    ];
    const length = extension.length;
    for(let i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $b998d41b678ed5d1$export$cd7f480d6b8286c3(arr, obj) {
    const i = arr.indexOf(obj);
    const found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $b998d41b678ed5d1$export$e9bab7fafb253603(arr1, arr2) {
    const len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(let i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $b998d41b678ed5d1$export$c7d3d1f96a700512(arr, compareFnc) {
    const length = arr.length;
    const tmp = Array(arr.length);
    let i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $b998d41b678ed5d1$export$efa610630f9e181(arr, func, strict) {
    const compare = func || $b998d41b678ed5d1$export$fcb633242ef15540;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        const res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}


function $013a1733c226ec50$export$22e23a2304399231() {
    return true;
}
function $013a1733c226ec50$export$8f11cee4bdc7e668() {
    return false;
}
function $013a1733c226ec50$export$1cd1943b3a73bbe8() {}
function $013a1733c226ec50$export$ff83df6f9971435f(fn) {
    let called = false;
    /** @type {ReturnType} */ let lastResult;
    /** @type {Array<any>} */ let lastArgs;
    let lastThis;
    return function() {
        const nextArgs = Array.prototype.slice.call(arguments);
        if (!called || this !== lastThis || !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(nextArgs, lastArgs)) {
            called = true;
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $013a1733c226ec50$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        let value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}


/**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ function $beaefe87199bb537$export$42ffd38884aecdac(object) {
    for(const property in object)delete object[property];
}
function $beaefe87199bb537$export$dd1bc94b04021eeb(object) {
    let property;
    for(property in object)return false;
    return !property;
}


/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ class $08c28d22c0cb5a39$var$Target extends (0, $3273ed08087da3da$export$2e2bcd8739ae039) {
    /**
   * @param {*} [target] Default event target for dispatched events.
   */ constructor(target){
        super();
        /**
     * @private
     * @type {*}
     */ this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ this.listeners_ = null;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ addEventListener(type, listener) {
        if (!type || !listener) return;
        const listeners = this.listeners_ || (this.listeners_ = {});
        const listenersForType = listeners[type] || (listeners[type] = []);
        if (!listenersForType.includes(listener)) listenersForType.push(listener);
    }
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ dispatchEvent(event) {
        const isString = typeof event === "string";
        const type = isString ? event : event.type;
        const listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        const evt = isString ? new (0, $aeedce20e9577100$export$2e2bcd8739ae039)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        const dispatching = this.dispatching_ || (this.dispatching_ = {});
        const pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        let propagate;
        for(let i = 0, ii = listeners.length; i < ii; ++i){
            if ("handleEvent" in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            let pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, $013a1733c226ec50$export$1cd1943b3a73bbe8));
            delete dispatching[type];
        }
        return propagate;
    }
    /**
   * Clean up.
   */ disposeInternal() {
        this.listeners_ && (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.listeners_);
    }
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ getListeners(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    }
    /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ hasListener(type) {
        if (!this.listeners_) return false;
        return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ removeEventListener(type, listener) {
        if (!this.listeners_) return;
        const listeners = this.listeners_[type];
        if (!listeners) return;
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    }
}
var $08c28d22c0cb5a39$export$2e2bcd8739ae039 = $08c28d22c0cb5a39$var$Target;


/**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $294047c5e65f31a3$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: "change",
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: "error",
    BLUR: "blur",
    CLEAR: "clear",
    CONTEXTMENU: "contextmenu",
    CLICK: "click",
    DBLCLICK: "dblclick",
    DRAGENTER: "dragenter",
    DRAGOVER: "dragover",
    DROP: "drop",
    FOCUS: "focus",
    KEYDOWN: "keydown",
    KEYPRESS: "keypress",
    LOAD: "load",
    RESIZE: "resize",
    TOUCHMOVE: "touchmove",
    WHEEL: "wheel"
};


/**
 * @module ol/events
 */ 
function $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, thisArg, once) {
    if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    if (once) {
        const originalListener = listener;
        listener = function() {
            target.removeEventListener(type, listener);
            originalListener.apply(this, arguments);
        };
    }
    const eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $d5bf8abd656a3cdc$export$8d2a95bc11b44725(target, type, listener, thisArg) {
    return $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, thisArg, true);
}
function $d5bf8abd656a3cdc$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(key);
    }
}


/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ class $1f093ab5083c8a1f$var$Observable extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onInternal;
        this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onceInternal;
        this.un = /** @type {ObservableOnSignature<void>} */ this.unInternal;
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ changed() {
        ++this.revision_;
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ getRevision() {
        return this.revision_;
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onInternal(type, listener) {
        if (Array.isArray(type)) {
            const len = type.length;
            const keys = new Array(len);
            for(let i = 0; i < len; ++i)keys[i] = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, type[i], listener);
            return keys;
        }
        return (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, /** @type {string} */ type, listener);
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onceInternal(type, listener) {
        let key;
        if (Array.isArray(type)) {
            const len = type.length;
            key = new Array(len);
            for(let i = 0; i < len; ++i)key[i] = (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(this, type[i], listener);
        } else key = (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    }
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */ unInternal(type, listener) {
        const key = /** @type {Object} */ listener.ol_key;
        if (key) $1f093ab5083c8a1f$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(let i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    }
}
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.un;
function $1f093ab5083c8a1f$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(let i = 0, ii = key.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(key[i]);
    else (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(/** @type {import("./events.js").EventsKey} */ key);
}
var $1f093ab5083c8a1f$export$2e2bcd8739ae039 = $1f093ab5083c8a1f$var$Observable;


/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ function $6c5e11070e371322$export$817eb92a8194bab0() {
    throw new Error("Unimplemented abstract method.");
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ let $6c5e11070e371322$var$uidCounter_ = 0;
function $6c5e11070e371322$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$6c5e11070e371322$var$uidCounter_));
}
const $6c5e11070e371322$export$a4ad2735b021c132 = "9.2.4";



class $b68b3d6e32e3074a$export$cf395d7c4a2d5a17 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */ constructor(type, key, oldValue){
        super(type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
}
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */ class $b68b3d6e32e3074a$var$BaseObject extends (0, $1f093ab5083c8a1f$export$2e2bcd8739ae039) {
    /**
   * @param {Object<string, *>} [values] An object with key-value pairs.
   */ constructor(values){
        super();
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
        /**
     * @private
     * @type {Object<string, *>|null}
     */ this.values_ = null;
        if (values !== undefined) this.setProperties(values);
    }
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ get(key) {
        let value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    }
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ getKeys() {
        return this.values_ && Object.keys(this.values_) || [];
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */ getProperties() {
        return this.values_ && Object.assign({}, this.values_) || {};
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.values_;
    }
    /**
   * @return {boolean} The object has properties.
   */ hasProperties() {
        return !!this.values_;
    }
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ notify(key, oldValue) {
        let eventType;
        eventType = `change:${key}`;
        if (this.hasListener(eventType)) this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ addChangeListener(key, listener) {
        this.addEventListener(`change:${key}`, listener);
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ removeChangeListener(key, listener) {
        this.removeEventListener(`change:${key}`, listener);
    }
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ set(key, value, silent) {
        const values = this.values_ || (this.values_ = {});
        if (silent) values[key] = value;
        else {
            const oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    }
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ setProperties(values, silent) {
        for(const key in values)this.set(key, values[key], silent);
    }
    /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ applyProperties(source) {
        if (!source.values_) return;
        Object.assign(this.values_ || (this.values_ = {}), source.values_);
    }
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ unset(key, silent) {
        if (this.values_ && key in this.values_) {
            const oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.values_)) this.values_ = null;
            if (!silent) this.notify(key, oldValue);
        }
    }
}
var $b68b3d6e32e3074a$export$2e2bcd8739ae039 = $b68b3d6e32e3074a$var$BaseObject;


/**
 * @module ol/Collection
 */ 
/**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $161dd067fe2d672c$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: "add",
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: "remove"
};



/**
 * @enum {string}
 * @private
 */ const $931ffc4e747c14db$var$Property = {
    LENGTH: "length"
};
class $931ffc4e747c14db$export$a87ae6eb2761ec6d extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */ constructor(type, element, index){
        super(type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ this.index = index;
    }
}
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ class $931ffc4e747c14db$var$Collection extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */ constructor(array, options){
        super();
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = array ? array : [];
        if (this.unique_) for(let i = 0, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    /**
   * Remove all elements from the collection.
   * @api
   */ clear() {
        while(this.getLength() > 0)this.pop();
    }
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ extend(arr) {
        for(let i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    }
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ forEach(f) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    }
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ getArray() {
        return this.array_;
    }
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ item(index) {
        return this.array_[index];
    }
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ getLength() {
        return this.get($931ffc4e747c14db$var$Property.LENGTH);
    }
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ insertAt(index, elem) {
        if (index < 0 || index > this.getLength()) throw new Error("Index out of bounds: " + index);
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ pop() {
        return this.removeAt(this.getLength() - 1);
    }
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ push(elem) {
        if (this.unique_) this.assertUnique_(elem);
        const n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    }
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ remove(elem) {
        const arr = this.array_;
        for(let i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    }
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ removeAt(index) {
        if (index < 0 || index >= this.getLength()) return undefined;
        const prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, prev, index));
        return prev;
    }
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ setAt(index, elem) {
        const n = this.getLength();
        if (index >= n) {
            this.insertAt(index, elem);
            return;
        }
        if (index < 0) throw new Error("Index out of bounds: " + index);
        if (this.unique_) this.assertUnique_(elem, index);
        const prev = this.array_[index];
        this.array_[index] = elem;
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, prev, index));
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * @private
   */ updateLength_() {
        this.set($931ffc4e747c14db$var$Property.LENGTH, this.array_.length);
    }
    /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ assertUnique_(elem, except) {
        for(let i = 0, ii = this.array_.length; i < ii; ++i){
            if (this.array_[i] === elem && i !== except) throw new Error("Duplicate item added to a unique collection");
        }
    }
}
var $931ffc4e747c14db$export$2e2bcd8739ae039 = $931ffc4e747c14db$var$Collection;



/**
 * @module ol/renderer/Composite
 */ /**
 * @module ol/layer/BaseVector
 */ /**
 * @module ol/layer/Layer
 */ /**
 * @module ol/layer/Base
 */ 
/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $f6d1853b3fcae320$export$2e2bcd8739ae039 = {
    OPACITY: "opacity",
    VISIBLE: "visible",
    EXTENT: "extent",
    Z_INDEX: "zIndex",
    MAX_RESOLUTION: "maxResolution",
    MIN_RESOLUTION: "minResolution",
    MAX_ZOOM: "maxZoom",
    MIN_ZOOM: "minZoom",
    SOURCE: "source",
    MAP: "map"
};



/**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ function $35d5ec884318008e$export$a7a9523472993e97(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}


/**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $6b000a049d919fe5$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $6b000a049d919fe5$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $6b000a049d919fe5$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $6b000a049d919fe5$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $6b000a049d919fe5$export$8240f01c446270e6(mat) {
    const n = mat.length;
    for(let i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        let maxRow = i;
        let maxEl = Math.abs(mat[i][i]);
        for(let r = i + 1; r < n; r++){
            const absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        const tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(let j = i + 1; j < n; j++){
            const coef = -mat[j][i] / mat[i][i];
            for(let k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    const x = new Array(n);
    for(let l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(let m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $6b000a049d919fe5$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $6b000a049d919fe5$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $6b000a049d919fe5$export$ba467bec01d66def(a, b) {
    const r = a % b;
    return r * b < 0 ? r + b : r;
}
function $6b000a049d919fe5$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $6b000a049d919fe5$export$a81f732198733497(n, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $6b000a049d919fe5$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}


/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */ class $57c5f0299cb9b82f$var$BaseLayer extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Layer options.
   */ constructor(options){
        super();
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ this.background_ = options.background;
        /**
     * @type {Object<string, *>}
     */ const properties = Object.assign({}, options);
        if (typeof options.properties === "object") {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY] === "number", "Layer opacity must be a number");
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX] = options.zIndex;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ this.className_ = properties.className !== undefined ? properties.className : "ol-layer";
        delete properties.className;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
    }
    /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ getBackground() {
        return this.background_;
    }
    /**
   * @return {string} CSS class name.
   */ getClassName() {
        return this.className_;
    }
    /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ getLayerState(managed) {
        /** @type {import("./Layer.js").State} */ const state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: managed === undefined ? true : managed
        };
        const zIndex = this.getZIndex();
        state.opacity = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).EXTENT);
    }
    /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ getMaxResolution() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION);
    }
    /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ getMinResolution() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION);
    }
    /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM);
    }
    /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM);
    }
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ getOpacity() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY);
    }
    /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ getVisible() {
        return /** @type {boolean} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE);
    }
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ getZIndex() {
        return /** @type {number|undefined} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX);
    }
    /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ setBackground(background) {
        this.background_ = background;
        this.changed();
    }
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ setExtent(extent) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).EXTENT, extent);
    }
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ setMaxResolution(maxResolution) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION, maxResolution);
    }
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ setMinResolution(minResolution) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION, minResolution);
    }
    /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ setMaxZoom(maxZoom) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM, maxZoom);
    }
    /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ setMinZoom(minZoom) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM, minZoom);
    }
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ setOpacity(opacity) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof opacity === "number", "Layer opacity must be a number");
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY, opacity);
    }
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ setVisible(visible) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE, visible);
    }
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ setZIndex(zindex) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX, zindex);
    }
    /**
   * Clean up.
   */ disposeInternal() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        super.disposeInternal();
    }
}
var $57c5f0299cb9b82f$export$2e2bcd8739ae039 = $57c5f0299cb9b82f$var$BaseLayer;




/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $f5e92a4d985a2824$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: "prerender",
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: "postrender",
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: "precompose",
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: "postcompose",
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: "rendercomplete"
};


/**
 * @module ol/View
 */ 
/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $7d362782b4ccb93d$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $d35baefbe89be4c5$export$2e2bcd8739ae039 = {
    CENTER: "center",
    RESOLUTION: "resolution",
    ROTATION: "rotation"
};


/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ const $57cd8651d88957a0$export$e98a216cdcc847dc = 42;
const $57cd8651d88957a0$export$6b8cb5cd370bd90c = 256;


/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ 
/**
 * @module ol/proj/epsg3857
 */ /**
 * @module ol/proj/Projection
 */ /**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ const $03edbd434a9e6608$var$unitByCode = {
    "9001": "m",
    "9002": "ft",
    "9003": "us-ft",
    "9101": "radians",
    "9102": "degrees"
};
function $03edbd434a9e6608$export$7f58726df3255edc(code) {
    return $03edbd434a9e6608$var$unitByCode[code];
}
const $03edbd434a9e6608$export$1482081eec883108 = {
    // use the radius of the Normal sphere
    "radians": 6370997 / (2 * Math.PI),
    "degrees": 2 * Math.PI * 6370997 / 360,
    "ft": 0.3048,
    "m": 1,
    "us-ft": 1200 / 3937
};


/**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {function(number, import("../coordinate.js").Coordinate):number} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * Projection definition class. One of these is created for each projection
 * supported in the application and stored in the {@link module:ol/proj} namespace.
 * You can use these in applications, but this is not required, as API params
 * and options use {@link module:ol/proj~ProjectionLike} which means the simple string
 * code will suffice.
 *
 * You can use {@link module:ol/proj.get} to retrieve the object for a particular
 * projection.
 *
 * The library includes definitions for `EPSG:4326` and `EPSG:3857`, together
 * with the following aliases:
 * * `EPSG:4326`: CRS:84, urn:ogc:def:crs:EPSG:6.6:4326,
 *     urn:ogc:def:crs:OGC:1.3:CRS84, urn:ogc:def:crs:OGC:2:84,
 *     http://www.opengis.net/gml/srs/epsg.xml#4326,
 *     urn:x-ogc:def:crs:EPSG:4326
 * * `EPSG:3857`: EPSG:102100, EPSG:102113, EPSG:900913,
 *     urn:ogc:def:crs:EPSG:6.18:3:3857,
 *     http://www.opengis.net/gml/srs/epsg.xml#3857
 *
 * If you use [proj4js](https://github.com/proj4js/proj4js), aliases can
 * be added using `proj4.defs()`. After all required projection definitions are
 * added, call the {@link module:ol/proj/proj4.register} function.
 *
 * @api
 */ class $6dc418afeec7068a$var$Projection {
    /**
   * @param {Options} options Projection options.
   */ constructor(options){
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : "enu";
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {function(number, import("../coordinate.js").Coordinate):number|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ canWrapX() {
        return this.canWrapX_;
    }
    /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ getCode() {
        return this.code_;
    }
    /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ getUnits() {
        return this.units_;
    }
    /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ getMetersPerUnit() {
        return this.metersPerUnit_ || (0, $03edbd434a9e6608$export$1482081eec883108)[this.units_];
    }
    /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getWorldExtent() {
        return this.worldExtent_;
    }
    /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ getAxisOrientation() {
        return this.axisOrientation_;
    }
    /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ isGlobal() {
        return this.global_;
    }
    /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ setGlobal(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    }
    /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ getDefaultTileGrid() {
        return this.defaultTileGrid_;
    }
    /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ setDefaultTileGrid(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    }
    /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ setExtent(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    }
    /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ setWorldExtent(worldExtent) {
        this.worldExtent_ = worldExtent;
    }
    /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ setGetPointResolution(func) {
        this.getPointResolutionFunc_ = func;
    }
    /**
   * Get the custom point resolution function for this projection (if set).
   * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
   * resolution function (if set).
   */ getPointResolutionFunc() {
        return this.getPointResolutionFunc_;
    }
}
var $6dc418afeec7068a$export$2e2bcd8739ae039 = $6dc418afeec7068a$var$Projection;


const $84ad988f04807ab1$export$2d2c9be8b5b863f = 6378137;
const $84ad988f04807ab1$export$f3928063e5e96d35 = Math.PI * $84ad988f04807ab1$export$2d2c9be8b5b863f;
const $84ad988f04807ab1$export$21e6da8a7375dfe8 = [
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35
];
const $84ad988f04807ab1$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
const $84ad988f04807ab1$export$d26945d1ad52feeb = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ class $84ad988f04807ab1$var$EPSG3857Projection extends (0, $6dc418afeec7068a$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   */ constructor(code){
        super({
            code: code,
            units: "m",
            extent: $84ad988f04807ab1$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $84ad988f04807ab1$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / Math.cosh(point[1] / $84ad988f04807ab1$export$2d2c9be8b5b863f);
            }
        });
    }
}
const $84ad988f04807ab1$export$b508d7ad9a891c1b = [
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:3857"),
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:102100"),
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:102113"),
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:900913"),
    new $84ad988f04807ab1$var$EPSG3857Projection("http://www.opengis.net/def/crs/EPSG/0/3857"),
    new $84ad988f04807ab1$var$EPSG3857Projection("http://www.opengis.net/gml/srs/epsg.xml#3857")
];
function $84ad988f04807ab1$export$1ff8bb36c0983070(input, output, dimension) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += dimension){
        output[i] = $84ad988f04807ab1$export$f3928063e5e96d35 * input[i] / 180;
        let y = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $84ad988f04807ab1$export$d26945d1ad52feeb) y = $84ad988f04807ab1$export$d26945d1ad52feeb;
        else if (y < -$84ad988f04807ab1$export$d26945d1ad52feeb) y = -$84ad988f04807ab1$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $84ad988f04807ab1$export$8c71322ec28ed6b4(input, output, dimension) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += dimension){
        output[i] = 180 * input[i] / $84ad988f04807ab1$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $84ad988f04807ab1$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}


/**
 * @module ol/proj/epsg4326
 */ 
const $b58ae362632b32c5$export$2d2c9be8b5b863f = 6378137;
const $b58ae362632b32c5$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
const $b58ae362632b32c5$export$1482081eec883108 = Math.PI * $b58ae362632b32c5$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ class $b58ae362632b32c5$var$EPSG4326Projection extends (0, $6dc418afeec7068a$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */ constructor(code, axisOrientation){
        super({
            code: code,
            units: "degrees",
            extent: $b58ae362632b32c5$export$21e6da8a7375dfe8,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: $b58ae362632b32c5$export$1482081eec883108,
            worldExtent: $b58ae362632b32c5$export$21e6da8a7375dfe8
        });
    }
}
const $b58ae362632b32c5$export$b508d7ad9a891c1b = [
    new $b58ae362632b32c5$var$EPSG4326Projection("CRS:84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("EPSG:4326", "neu"),
    new $b58ae362632b32c5$var$EPSG4326Projection("urn:ogc:def:crs:OGC:1.3:CRS84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("urn:ogc:def:crs:OGC:2:84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("http://www.opengis.net/def/crs/OGC/1.3/CRS84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("http://www.opengis.net/gml/srs/epsg.xml#4326", "neu"),
    new $b58ae362632b32c5$var$EPSG4326Projection("http://www.opengis.net/def/crs/EPSG/0/4326", "neu")
];



/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ let $f5ec5c943d804ecb$var$cache = {};
function $f5ec5c943d804ecb$export$42ffd38884aecdac() {
    $f5ec5c943d804ecb$var$cache = {};
}
function $f5ec5c943d804ecb$export$3988ae62b71be9a3(code) {
    return $f5ec5c943d804ecb$var$cache[code] || $f5ec5c943d804ecb$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, "EPSG:$3")] || null;
}
function $f5ec5c943d804ecb$export$e16d8520af44a096(code, projection) {
    $f5ec5c943d804ecb$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ 
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ let $11b5dd198626e1de$var$transforms = {};
function $11b5dd198626e1de$export$42ffd38884aecdac() {
    $11b5dd198626e1de$var$transforms = {};
}
function $11b5dd198626e1de$export$e16d8520af44a096(source, destination, transformFn) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    if (!(sourceCode in $11b5dd198626e1de$var$transforms)) $11b5dd198626e1de$var$transforms[sourceCode] = {};
    $11b5dd198626e1de$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $11b5dd198626e1de$export$cd7f480d6b8286c3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    const transform = $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    delete $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    if ((0, $beaefe87199bb537$export$dd1bc94b04021eeb)($11b5dd198626e1de$var$transforms[sourceCode])) delete $11b5dd198626e1de$var$transforms[sourceCode];
    return transform;
}
function $11b5dd198626e1de$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    let transform;
    if (sourceCode in $11b5dd198626e1de$var$transforms && destinationCode in $11b5dd198626e1de$var$transforms[sourceCode]) transform = $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    return transform;
}


/**
 * @module ol/extent
 */ /**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $dab4245bc22b806c$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};


function $6da4c8ed3074c92b$export$8aceca7c77505534(coordinates) {
    const extent = $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, dest) {
    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxX = Math.max.apply(null, xs);
    const maxY = Math.max.apply(null, ys);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest);
}
function $6da4c8ed3074c92b$export$ab1029bcae9ddb4a(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $6da4c8ed3074c92b$export$9cd59f9826255e47(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function $6da4c8ed3074c92b$export$cbe64c389534206f(extent, x, y) {
    let dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $6da4c8ed3074c92b$export$ac68c24d37ca240f(extent, coordinate) {
    return $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $6da4c8ed3074c92b$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, coordinate) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const x = coordinate[0];
    const y = coordinate[1];
    let relationship = (0, $dab4245bc22b806c$export$2e2bcd8739ae039).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT;
    else if (x > maxX) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT;
    if (y < minY) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW;
    else if (y > maxY) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE;
    if (relationship === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).UNKNOWN) relationship = (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING;
    return relationship;
}
function $6da4c8ed3074c92b$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $6da4c8ed3074c92b$export$3e2152b047719fa1(dest) {
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function $6da4c8ed3074c92b$export$4838bf78d04a9440(coordinate, dest) {
    const x = coordinate[0];
    const y = coordinate[1];
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(x, y, x, y, dest);
}
function $6da4c8ed3074c92b$export$29e3ad4dbd0cb863(coordinates, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates);
}
function $6da4c8ed3074c92b$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $6da4c8ed3074c92b$export$73b4897e93bc5c83(rings, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings);
}
function $6da4c8ed3074c92b$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $6da4c8ed3074c92b$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $6da4c8ed3074c92b$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings) {
    for(let i = 0, ii = rings.length; i < ii; ++i)$6da4c8ed3074c92b$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $6da4c8ed3074c92b$export$f9ed8a3d123a08e2(extent, callback) {
    let val;
    val = callback($6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $6da4c8ed3074c92b$export$520c40045967cb15(extent) {
    let area = 0;
    if (!$6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) area = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) * $6da4c8ed3074c92b$export$c08559766941f856(extent);
    return area;
}
function $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $6da4c8ed3074c92b$export$a1cfd206661d0801(extent, corner) {
    let coordinate;
    if (corner === "bottom-left") coordinate = $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent);
    else if (corner === "bottom-right") coordinate = $6da4c8ed3074c92b$export$e77c1cf70445e168(extent);
    else if (corner === "top-left") coordinate = $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent);
    else if (corner === "top-right") coordinate = $6da4c8ed3074c92b$export$b84fa077c8b05295(extent);
    else throw new Error("Invalid corner");
    return coordinate;
}
function $6da4c8ed3074c92b$export$7d6fa884b32a3751(extent1, extent2) {
    const minX = Math.min(extent1[0], extent2[0]);
    const minY = Math.min(extent1[1], extent2[1]);
    const maxX = Math.max(extent1[2], extent2[2]);
    const maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $6da4c8ed3074c92b$export$13ba650faf8308(center, resolution, rotation, size, dest) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac(center, resolution, rotation, size);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    const dx = resolution * size[0] / 2;
    const dy = resolution * size[1] / 2;
    const cosRotation = Math.cos(rotation);
    const sinRotation = Math.sin(rotation);
    const xCos = dx * cosRotation;
    const xSin = dx * sinRotation;
    const yCos = dy * cosRotation;
    const ySin = dy * sinRotation;
    const x = center[0];
    const y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $6da4c8ed3074c92b$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $6da4c8ed3074c92b$export$f3fe0e9a60cde324(extent1, extent2) {
    const intersection = $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2);
    return $6da4c8ed3074c92b$export$520c40045967cb15(intersection);
}
function $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2, dest) {
    const intersection = dest ? dest : $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    if ($6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $6da4c8ed3074c92b$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $6da4c8ed3074c92b$export$1bc603050bd777b1(extent) {
    return $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) + $6da4c8ed3074c92b$export$c08559766941f856(extent);
}
function $6da4c8ed3074c92b$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $6da4c8ed3074c92b$export$6a4fe494c558c238(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function $6da4c8ed3074c92b$export$80cbab86674143b6(extent, value) {
    const deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    const deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $6da4c8ed3074c92b$export$a6a5a7a461419425(extent, start, end) {
    let intersects = false;
    const startRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, start);
    const endRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING || endRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING) intersects = true;
    else {
        const minX = extent[0];
        const minY = extent[1];
        const maxX = extent[2];
        const maxY = extent[3];
        const startX = start[0];
        const startY = start[1];
        const endX = end[0];
        const endY = end[1];
        const slope = (endY - startY) / (endX - startX);
        let x, y;
        if (!!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $6da4c8ed3074c92b$export$9f9dcb98c894b623(extent, transformFn, dest, stops) {
    if ($6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) return $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    let coordinates = [];
    if (stops > 1) {
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        for(let i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    const xs = [];
    const ys = [];
    for(let i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, dest);
}
function $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection) {
    const projectionExtent = projection.getExtent();
    const center = $6da4c8ed3074c92b$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        const worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        const worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        const offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $6da4c8ed3074c92b$export$9031237f01de0947(extent, projection, multiWorld) {
    if (projection.canWrapX()) {
        const projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection);
        const worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        if ($6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) > worldWidth && !multiWorld) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}



/**
 * @module ol/coordinate
 */ 

/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $ff7180bdd45ebb19$export$24be126cb0a7bbeb(number, width, precision) {
    const numberString = precision !== undefined ? number.toFixed(precision) : "" + number;
    let decimal = numberString.indexOf(".");
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join("0") + numberString;
}
function $ff7180bdd45ebb19$export$66e1c0999abad646(v1, v2) {
    const s1 = ("" + v1).split(".");
    const s2 = ("" + v2).split(".");
    for(let i = 0; i < Math.max(s1.length, s2.length); i++){
        const n1 = parseInt(s1[i] || "0", 10);
        const n2 = parseInt(s2[i] || "0", 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $1bd0a226f9a16141$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $1bd0a226f9a16141$export$cbe80a3fcd2b99b7(coordinate, circle) {
    const r = circle.getRadius();
    const center = circle.getCenter();
    const x0 = center[0];
    const y0 = center[1];
    const x1 = coordinate[0];
    const y1 = coordinate[1];
    let dx = x1 - x0;
    const dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    const d = Math.sqrt(dx * dx + dy * dy);
    const x = x0 + r * dx / d;
    const y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment) {
    const x0 = coordinate[0];
    const y0 = coordinate[1];
    const start = segment[0];
    const end = segment[1];
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    let x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$35ad6765fe262b6(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, fractionDigits);
    });
}
function $1bd0a226f9a16141$export$6eb0ac5f024d8590(hemispheres, degrees, fractionDigits) {
    const normalizedDegrees = (0, $6b000a049d919fe5$export$ba467bec01d66def)(degrees + 180, 360) - 180;
    const x = Math.abs(3600 * normalizedDegrees);
    const decimals = fractionDigits || 0;
    let deg = Math.floor(x / 3600);
    let min = Math.floor((x - deg * 3600) / 60);
    let sec = (0, $6b000a049d919fe5$export$a81f732198733497)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    let hdms = deg + "\xb0";
    if (min !== 0 || sec !== 0) hdms += " " + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(min, 2) + "\u2032";
    if (sec !== 0) hdms += " " + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(sec, 2, decimals) + "\u2033";
    if (normalizedDegrees !== 0) hdms += " " + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function $1bd0a226f9a16141$export$d9468344d3651243(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace("{x}", coordinate[0].toFixed(fractionDigits)).replace("{y}", coordinate[1].toFixed(fractionDigits));
    return "";
}
function $1bd0a226f9a16141$export$e9bab7fafb253603(coordinate1, coordinate2) {
    let equals = true;
    for(let i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $1bd0a226f9a16141$export$bb628a54ab399bc9(coordinate, angle) {
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    const y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $1bd0a226f9a16141$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2) {
    const dx = coord1[0] - coord2[0];
    const dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $1bd0a226f9a16141$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2));
}
function $1bd0a226f9a16141$export$6985570514055196(coordinate, segment) {
    return $1bd0a226f9a16141$export$88e6ebb4fe54f538(coordinate, $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment));
}
function $1bd0a226f9a16141$export$c883fd238161f841(coordinate, fractionDigits) {
    if (coordinate) return $1bd0a226f9a16141$export$6eb0ac5f024d8590("NS", coordinate[1], fractionDigits) + " " + $1bd0a226f9a16141$export$6eb0ac5f024d8590("EW", coordinate[0], fractionDigits);
    return "";
}
function $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, fractionDigits) {
    return $1bd0a226f9a16141$export$d9468344d3651243(coordinate, "{x}, {y}", fractionDigits);
}
function $1bd0a226f9a16141$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projection.getExtent());
        const worldsAway = $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, sourceExtentWidth) {
    const projectionExtent = projection.getExtent();
    let worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}


/**
 * @module ol/sphere
 */ 
const $fb75384508533d8f$export$63f2df7bd7371262 = 6371008.8;
function $fb75384508533d8f$export$79376507b09a66f(c1, c2, radius) {
    radius = radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const lat1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[1]);
    const lat2 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c2[1]);
    const deltaLatBy2 = (lat2 - lat1) / 2;
    const deltaLonBy2 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c2[0] - c1[0]) / 2;
    const a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $fb75384508533d8f$var$getLengthInternal(coordinates, radius) {
    let length = 0;
    for(let i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $fb75384508533d8f$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $fb75384508533d8f$export$f0d11c074a923179(geometry, options) {
    options = options || {};
    const radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const projection = options.projection || "EPSG:3857";
    const type = geometry.getType();
    if (type !== "GeometryCollection") geometry = geometry.clone().transform(projection, "EPSG:4326");
    let length = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case "Point":
        case "MultiPoint":
            break;
        case "LineString":
        case "LinearRing":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $fb75384508533d8f$var$getLengthInternal(coordinates, radius);
            break;
        case "MultiLineString":
        case "Polygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $fb75384508533d8f$var$getLengthInternal(coordinates[i], radius);
            break;
        case "MultiPolygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $fb75384508533d8f$var$getLengthInternal(coords[j], radius);
            }
            break;
        case "GeometryCollection":
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += $fb75384508533d8f$export$f0d11c074a923179(geometries[i], options);
                break;
            }
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $fb75384508533d8f$var$getAreaInternal(coordinates, radius) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for(let i = 0; i < len; i++){
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area += (0, $6b000a049d919fe5$export$cba01ba138429a1d)(x2 - x1) * (2 + Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(y1)) + Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $fb75384508533d8f$export$520c40045967cb15(geometry, options) {
    options = options || {};
    const radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const projection = options.projection || "EPSG:3857";
    const type = geometry.getType();
    if (type !== "GeometryCollection") geometry = geometry.clone().transform(projection, "EPSG:4326");
    let area = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
        case "LinearRing":
            break;
        case "Polygon":
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[i], radius));
            break;
        case "MultiPolygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($fb75384508533d8f$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coords[j], radius));
            }
            break;
        case "GeometryCollection":
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += $fb75384508533d8f$export$520c40045967cb15(geometries[i], options);
                break;
            }
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return area;
}
function $fb75384508533d8f$export$cc800923e997bb8(c1, distance, bearing, radius) {
    radius = radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const lat1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[1]);
    const lon1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[0]);
    const dByR = distance / radius;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    const lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $6b000a049d919fe5$export$56cb859c01fa134d)(lon),
        (0, $6b000a049d919fe5$export$56cb859c01fa134d)(lat)
    ];
}


/**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ const $8c65b0699f3f3f8e$var$levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ let $8c65b0699f3f3f8e$var$level = $8c65b0699f3f3f8e$var$levels.info;
function $8c65b0699f3f3f8e$export$2c97a59140dbf245(l) {
    $8c65b0699f3f3f8e$var$level = $8c65b0699f3f3f8e$var$levels[l];
}
function $8c65b0699f3f3f8e$export$bef1f36f5486a6a3(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.info) return;
    console.log(...args); // eslint-disable-line no-console
}
function $8c65b0699f3f3f8e$export$c106dd0671a0fc2d(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.warn) return;
    console.warn(...args); // eslint-disable-line no-console
}
function $8c65b0699f3f3f8e$export$a3bc9b8ed74fc(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.error) return;
    console.error(...args); // eslint-disable-line no-console
}


let $9c4744460e43e41b$var$showCoordinateWarning = true;
function $9c4744460e43e41b$export$ed949affbc7c4223(disable) {
    const hide = disable === undefined ? true : disable;
    $9c4744460e43e41b$var$showCoordinateWarning = !hide;
}
function $9c4744460e43e41b$export$dd516654c5f598fb(input, output) {
    if (output !== undefined) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function $9c4744460e43e41b$export$83e8ab53904f8022(input, output) {
    if (output !== undefined && input !== output) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function $9c4744460e43e41b$export$59ae956cd3e343f7(projection) {
    (0, $f5ec5c943d804ecb$export$e16d8520af44a096)(projection.getCode(), projection);
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection, projection, $9c4744460e43e41b$export$dd516654c5f598fb);
}
function $9c4744460e43e41b$export$638ad73f7aafb913(projections) {
    projections.forEach($9c4744460e43e41b$export$59ae956cd3e343f7);
}
function $9c4744460e43e41b$export$3988ae62b71be9a3(projectionLike) {
    return typeof projectionLike === "string" ? (0, $f5ec5c943d804ecb$export$3988ae62b71be9a3)(/** @type {string} */ projectionLike) : /** @type {Projection} */ projectionLike || null;
}
function $9c4744460e43e41b$export$2d8f7b4eec383d44(projection, resolution, point, units) {
    projection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    let pointResolution;
    const getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            const metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $03edbd434a9e6608$export$1482081eec883108)[units];
        }
    } else {
        const projUnits = projection.getUnits();
        if (projUnits == "degrees" && !units || units == "degrees") pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            const toEPSG4326 = $9c4744460e43e41b$export$e3c4995a701c26a3(projection, $9c4744460e43e41b$export$3988ae62b71be9a3("EPSG:4326"));
            if (toEPSG4326 === $9c4744460e43e41b$export$83e8ab53904f8022 && projUnits !== "degrees") // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                let vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                const width = (0, $fb75384508533d8f$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
                const height = (0, $fb75384508533d8f$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            const metersPerUnit = units ? (0, $03edbd434a9e6608$export$1482081eec883108)[units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $9c4744460e43e41b$export$eeb8392580a05a37(projections) {
    $9c4744460e43e41b$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $11b5dd198626e1de$export$e16d8520af44a096)(source, destination, $9c4744460e43e41b$export$dd516654c5f598fb);
        });
    });
}
function $9c4744460e43e41b$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $9c4744460e43e41b$export$4860237d10380594() {
    (0, $f5ec5c943d804ecb$export$42ffd38884aecdac)();
    (0, $11b5dd198626e1de$export$42ffd38884aecdac)();
}
function $9c4744460e43e41b$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $9c4744460e43e41b$export$3988ae62b71be9a3(defaultCode);
    if (typeof projection === "string") return $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    return /** @type {Projection} */ projection;
}
function $9c4744460e43e41b$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimension.
     * @return {Array<number>} Output.
     */ function(input, output, dimension) {
        const length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        output = output !== undefined ? output : new Array(length);
        for(let i = 0; i < length; i += dimension){
            const point = coordTransform(input.slice(i, i + dimension));
            const pointLength = point.length;
            for(let j = 0, jj = dimension; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $9c4744460e43e41b$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    const sourceProj = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    const destProj = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(sourceProj, destProj, $9c4744460e43e41b$export$6b4aafd331159e0d(forward));
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(destProj, sourceProj, $9c4744460e43e41b$export$6b4aafd331159e0d(inverse));
}
function $9c4744460e43e41b$export$b15d9668511529b9(coordinate, projection) {
    $9c4744460e43e41b$export$ed949affbc7c4223();
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, "EPSG:4326", projection !== undefined ? projection : "EPSG:3857");
}
function $9c4744460e43e41b$export$3fb495868742d370(coordinate, projection) {
    const lonLat = $9c4744460e43e41b$export$51186ad6e864892a(coordinate, projection !== undefined ? projection : "EPSG:3857", "EPSG:4326");
    const lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $6b000a049d919fe5$export$ba467bec01d66def)(lon + 180, 360) - 180;
    return lonLat;
}
function $9c4744460e43e41b$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    const equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    const transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(projection1, projection2);
    return transformFunc === $9c4744460e43e41b$export$dd516654c5f598fb && equalUnits;
}
function $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection) {
    const sourceCode = sourceProjection.getCode();
    const destinationCode = destinationProjection.getCode();
    let transformFunc = (0, $11b5dd198626e1de$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (!transformFunc) transformFunc = $9c4744460e43e41b$export$83e8ab53904f8022;
    return transformFunc;
}
function $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination) {
    const sourceProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    const destinationProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    return $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $9c4744460e43e41b$export$51186ad6e864892a(coordinate, source, destination) {
    const transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $9c4744460e43e41b$export$751c68e0e0efff79(extent, source, destination, stops) {
    const transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    return (0, $6da4c8ed3074c92b$export$9f9dcb98c894b623)(extent, transformFunc, undefined, stops);
}
function $9c4744460e43e41b$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    const transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ let $9c4744460e43e41b$var$userProjection = null;
function $9c4744460e43e41b$export$d0aeadbeac54116e(projection) {
    $9c4744460e43e41b$var$userProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
}
function $9c4744460e43e41b$export$1ae11279759d4e8f() {
    $9c4744460e43e41b$var$userProjection = null;
}
function $9c4744460e43e41b$export$3973b77d5f6f2790() {
    return $9c4744460e43e41b$var$userProjection;
}
function $9c4744460e43e41b$export$aa7494edfbe36197() {
    $9c4744460e43e41b$export$d0aeadbeac54116e("EPSG:4326");
}
function $9c4744460e43e41b$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return coordinate;
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) {
        if ($9c4744460e43e41b$var$showCoordinateWarning && !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $9c4744460e43e41b$var$showCoordinateWarning = false;
            (0, $8c65b0699f3f3f8e$export$c106dd0671a0fc2d)("Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.");
        }
        return coordinate;
    }
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$494be3a3a25689ca(extent, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return resolution;
    const sourceMetersPerUnit = $9c4744460e43e41b$export$3988ae62b71be9a3(sourceProjection).getMetersPerUnit();
    const userMetersPerUnit = $9c4744460e43e41b$var$userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function $9c4744460e43e41b$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return resolution;
    const destMetersPerUnit = $9c4744460e43e41b$export$3988ae62b71be9a3(destProjection).getMetersPerUnit();
    const userMetersPerUnit = $9c4744460e43e41b$var$userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function $9c4744460e43e41b$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        let transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            const sourceExtent = sourceProj.getExtent();
            const sourceExtentWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $1bd0a226f9a16141$export$24e2b27d1ff0c1d5)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(destProj.getExtent());
        return transformed;
    };
}
function $9c4744460e43e41b$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $84ad988f04807ab1$export$b508d7ad9a891c1b));
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $b58ae362632b32c5$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $9c4744460e43e41b$export$4856f21c2f184f24((0, $b58ae362632b32c5$export$b508d7ad9a891c1b), (0, $84ad988f04807ab1$export$b508d7ad9a891c1b), (0, $84ad988f04807ab1$export$1ff8bb36c0983070), (0, $84ad988f04807ab1$export$8c71322ec28ed6b4));
}
$9c4744460e43e41b$export$86eed449eb2dcac4();





/**
 * @module ol/centerconstraint
 */ 
function $b21a6e049949bb31$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        const viewWidth = onlyCenter ? 0 : size[0] * resolution;
        const viewHeight = onlyCenter ? 0 : size[1] * resolution;
        const shiftX = centerShift ? centerShift[0] : 0;
        const shiftY = centerShift ? centerShift[1] : 0;
        let minX = extent[0] + viewWidth / 2 + shiftX;
        let maxX = extent[2] - viewWidth / 2 + shiftX;
        let minY = extent[1] + viewHeight / 2 + shiftY;
        let maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        let x = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(center[0], minX, maxX);
        let y = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            const ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $b21a6e049949bb31$export$f883a24d5edde77c(center) {
    return center;
}



/**
 * @module ol/resolutionconstraint
 */ 


/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $bac43a1f4a628548$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    const xResolution = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(maxExtent) / viewportSize[0];
    const yResolution = (0, $6da4c8ed3074c92b$export$c08559766941f856)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    let result = Math.min(resolution, maxResolution);
    const ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(result, minResolution / 2, maxResolution * 2);
}
function $bac43a1f4a628548$export$d65a517690fc4385(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const maxResolution = resolutions[0];
            const minResolution = resolutions[resolutions.length - 1];
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const capped = Math.min(cappedMaxRes, resolution);
            const z = Math.floor((0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function $bac43a1f4a628548$export$22ac0f6b219de91a(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const tolerance = 1e-9;
            const minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            const offset = -direction * (0.5 - tolerance) + 0.5;
            const capped = Math.min(cappedMaxRes, resolution);
            const cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            const zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            const newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function $bac43a1f4a628548$export$1c4e6da9b4b066fe(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
            return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
function $d65f0a322291d127$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function $d65f0a322291d127$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function $d65f0a322291d127$export$9ba78806de831083(n) {
    const theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function $d65f0a322291d127$export$17a6e6f3448b17e8(tolerance) {
    const t = tolerance === undefined ? (0, $6b000a049d919fe5$export$cba01ba138429a1d)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}


/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $c7ccf7e681a9b333$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $c7ccf7e681a9b333$export$57636bb43b1ccbb0(t) {
    return 1 - $c7ccf7e681a9b333$export$929e5a82286172a6(1 - t);
}
function $c7ccf7e681a9b333$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $c7ccf7e681a9b333$export$45db2fc2f15997e7(t) {
    return t;
}
function $c7ccf7e681a9b333$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * t);
    return 1 - $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * (t - 0.5));
}




/**
 * @module ol/geom/Polygon
 */ /**
 * @module ol/geom/LinearRing
 */ /**
 * @module ol/geom/SimpleGeometry
 */ /**
 * @module ol/geom/Geometry
 */ 

/**
 * @module ol/transform
 */ 
/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ const $e22e7611e69f42a9$var$tmp_ = new Array(6);
function $e22e7611e69f42a9$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $e22e7611e69f42a9$export$aad8462122ac592b(transform) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $e22e7611e69f42a9$export$2060d2db72cce88f(transform1, transform2) {
    const a1 = transform1[0];
    const b1 = transform1[1];
    const c1 = transform1[2];
    const d1 = transform1[3];
    const e1 = transform1[4];
    const f1 = transform1[5];
    const a2 = transform2[0];
    const b2 = transform2[1];
    const c2 = transform2[2];
    const d2 = transform2[3];
    const e2 = transform2[4];
    const f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $e22e7611e69f42a9$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $e22e7611e69f42a9$export$5635d7ef4b8fee1c(transform, coordinate) {
    const x = coordinate[0];
    const y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $e22e7611e69f42a9$export$bb628a54ab399bc9(transform, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $e22e7611e69f42a9$export$dcdf75081b88279d(transform, x, y) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, x, 0, 0, y, 0, 0));
}
function $e22e7611e69f42a9$export$3e4e33ea14aeb531(target, x, y) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $e22e7611e69f42a9$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $e22e7611e69f42a9$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $e22e7611e69f42a9$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $e22e7611e69f42a9$export$f84e8e69fd4488a5($e22e7611e69f42a9$export$f672e0b6f7222cd7($e22e7611e69f42a9$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $e22e7611e69f42a9$export$6897c284b6f9f4dc(source) {
    return $e22e7611e69f42a9$export$bd70ea2a93c0fa4(source, source);
}
function $e22e7611e69f42a9$export$bd70ea2a93c0fa4(target, source) {
    const det = $e22e7611e69f42a9$export$a04698f914c55ed9(source);
    (0, $35d5ec884318008e$export$a7a9523472993e97)(det !== 0, "Transformation matrix cannot be inverted");
    const a = source[0];
    const b = source[1];
    const c = source[2];
    const d = source[3];
    const e = source[4];
    const f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $e22e7611e69f42a9$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {Array}
 */ const $e22e7611e69f42a9$var$matrixPrecision = [
    1e6,
    1e6,
    1e6,
    1e6,
    2,
    2
];
function $e22e7611e69f42a9$export$f84e8e69fd4488a5(mat) {
    const transformString = "matrix(" + mat.map((value, i)=>Math.round(value * $e22e7611e69f42a9$var$matrixPrecision[i]) / $e22e7611e69f42a9$var$matrixPrecision[i]).join(", ") + ")";
    return transformString;
}





/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */ function $14c6e714516e527b$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const x = flatCoordinates[j];
        const y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}


/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $50db89a00eb954f6$var$tmpTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ class $50db89a00eb954f6$var$Geometry extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ this.simplifyTransformedInternal = (0, $013a1733c226ec50$export$ff83df6f9971435f)((revision, squaredTolerance, transform)=>{
            if (!transform) return this.getSimplifiedGeometry(squaredTolerance);
            const clone = this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
    }
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ clone() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        const coord = this.getClosestPoint([
            x,
            y
        ]);
        return coord[0] === x && coord[1] === y;
    }
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ getClosestPoint(point, closestPoint) {
        closestPoint = closestPoint ? closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    }
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ getExtent(extent) {
        if (this.extentRevision_ != this.getRevision()) {
            const extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $6da4c8ed3074c92b$export$6a4fe494c558c238)(this.extent_, extent);
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ getType() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ applyTransform(transformFn) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ intersectsExtent(extent) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ const sourceProj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(source);
        const transformFn = sourceProj.getUnits() == "tile-pixels" ? function(inCoordinates, outCoordinates, stride) {
            const pixelExtent = sourceProj.getExtent();
            const projectedExtent = sourceProj.getWorldExtent();
            const scale = (0, $6da4c8ed3074c92b$export$c08559766941f856)(projectedExtent) / (0, $6da4c8ed3074c92b$export$c08559766941f856)(pixelExtent);
            (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)($50db89a00eb954f6$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $14c6e714516e527b$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $50db89a00eb954f6$var$tmpTransform, outCoordinates);
            return (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(sourceProj, destination)(inCoordinates, outCoordinates, stride);
        } : (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    }
}
var $50db89a00eb954f6$export$2e2bcd8739ae039 = $50db89a00eb954f6$var$Geometry;





/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ class $c76e993e57efc8c4$var$SimpleGeometry extends (0, $50db89a00eb954f6$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ this.layout = "XY";
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $6da4c8ed3074c92b$export$be0ab0bf96ca59ca)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ getCoordinates() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getFlatCoordinates() {
        return this.flatCoordinates;
    }
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    }
    /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ getLayout() {
        return this.layout;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        const simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        // Simplification did not actually remove any coordinates.  We now know
        // that any calls to getSimplifiedGeometry with a squaredTolerance less
        // than or equal to the current squaredTolerance will also not have any
        // effect.  This allows us to short circuit simplification (saving CPU
        // cycles) and prevents the cache of simplified geometries from filling
        // up with useless identical copies of this geometry (saving memory).
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride;
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ setFlatCoordinates(layout, flatCoordinates) {
        this.stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    }
    /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ setCoordinates(coordinates, layout) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ setLayout(layout, coordinates, nesting) {
        let stride;
        if (layout) stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        else {
            for(let i = 0; i < nesting; ++i){
                if (coordinates.length === 0) {
                    this.layout = "XY";
                    this.stride = 2;
                    return;
                }
                coordinates = /** @type {Array<unknown>} */ coordinates[0];
            }
            stride = coordinates.length;
            layout = $c76e993e57efc8c4$export$61bb6938093db2c8(stride);
        }
        this.layout = layout;
        this.stride = stride;
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   */ applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.stride);
            this.changed();
        }
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $14c6e714516e527b$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        if (sy === undefined) sy = sx;
        if (!anchor) anchor = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $14c6e714516e527b$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $14c6e714516e527b$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    }
}
function $c76e993e57efc8c4$export$61bb6938093db2c8(stride) {
    let layout;
    if (stride == 2) layout = "XY";
    else if (stride == 3) layout = "XYZ";
    else if (stride == 4) layout = "XYZM";
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout) {
    let stride;
    if (layout == "XY") stride = 2;
    else if (layout == "XYZ" || layout == "XYM") stride = 3;
    else if (layout == "XYZM") stride = 4;
    return /** @type {number} */ stride;
}
function $c76e993e57efc8c4$export$a3767472617c7861(simpleGeometry, transform, dest) {
    const flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    const stride = simpleGeometry.getStride();
    return (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
var $c76e993e57efc8c4$export$2e2bcd8739ae039 = $c76e993e57efc8c4$var$SimpleGeometry;


/**
 * @module ol/geom/flat/closest
 */ 
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $bf5604c1b8258b71$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    const x1 = flatCoordinates[offset1];
    const y1 = flatCoordinates[offset1 + 1];
    const dx = flatCoordinates[offset2] - x1;
    const dy = flatCoordinates[offset2 + 1] - y1;
    let offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(let i = 0; i < stride; ++i)closestPoint[i] = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        const squaredDelta = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        max = $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $bf5604c1b8258b71$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        max = $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    let i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    let index = offset + stride;
    while(index < end){
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        minSquaredDistance = $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        minSquaredDistance = $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}



/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $6b086aa46281540d$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(let i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i){
        const coordinate = coordinates[i];
        for(let j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    let i = 0;
    for(let j = 0, jj = coordinatess.length; j < jj; ++j){
        const end = $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $6b086aa46281540d$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    let i = 0;
    for(let j = 0, jj = coordinatesss.length; j < jj; ++j){
        const ends = $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}


/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

function $8780aae6970f5f65$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    const n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ const markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ const stack = [
        offset,
        end - stride
    ];
    let index = 0;
    while(stack.length > 0){
        const last = stack.pop();
        const first = stack.pop();
        let maxSquaredDistance = 0;
        const x1 = flatCoordinates[first];
        const y1 = flatCoordinates[first + 1];
        const x2 = flatCoordinates[last];
        const y2 = flatCoordinates[last + 1];
        for(let i = first + stride; i < last; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            const squaredDistance = (0, $6b000a049d919fe5$export$251bb0a9cef172e6)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(let i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    let x2 = x1;
    let y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    let x1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    let y1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    let x2, y2;
    do {
        x2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        const x3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        const y3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        const dx1 = x2 - x1;
        const dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        const dx2 = x3 - x1;
        const dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    let i = 0;
    for(let j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    let i = 0;
    for(let j = 0, jj = ends.length; j < jj; ++j){
        const end = ends[j];
        coordinatess[i++] = $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $5454470599558ddd$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    let i = 0;
    for(let j = 0, jj = endss.length; j < jj; ++j){
        const ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    let twiceArea = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        twiceArea += y1 * x2 - x1 * y2;
        x1 = x2;
        y1 = y2;
    }
    return twiceArea / 2;
}
function $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    let area = 0;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        area += $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $01ff26a2f986a1d0$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    let area = 0;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        area += $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}


/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ class $548636579b4087f2$var$LinearRing extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   */ clone() {
        return new $548636579b4087f2$var$LinearRing(this.flatCoordinates.slice(), this.layout);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $01ff26a2f986a1d0$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $548636579b4087f2$var$LinearRing(simplifiedFlatCoordinates, "XY");
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "LinearRing";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return false;
    }
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $548636579b4087f2$export$2e2bcd8739ae039 = $548636579b4087f2$var$LinearRing;


/**
 * @module ol/geom/Point
 */ 



/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ class $6eced4c969949f6b$var$Point extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        this.setCoordinates(coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   */ clone() {
        const point = new $6eced4c969949f6b$var$Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            const stride = this.stride;
            for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   */ getCoordinates() {
        return this.flatCoordinates.slice();
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(this.flatCoordinates, extent);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "Point";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return (0, $6da4c8ed3074c92b$export$805bdfd6d6690e97)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    }
    /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $6eced4c969949f6b$export$2e2bcd8739ae039 = $6eced4c969949f6b$var$Point;







/**
 * @module ol/geom/flat/interiorpoint
 */ 
/**
 * @module ol/geom/flat/contains
 */ 
function $239aa88e7a573859$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    const outside = (0, $6da4c8ed3074c92b$export$f9ed8a3d123a08e2)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    let wn = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(let i = 1, ii = ends.length; i < ii; ++i){
        if ($239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $239aa88e7a573859$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


function $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    let i, ii, x, x1, x2, y1, y2;
    const y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ const intersections = [];
    // Calculate intersections with the horizontal line
    for(let r = 0, rr = ends.length; r < rr; ++r){
        const end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    let pointX = NaN;
    let maxSegmentLength = -Infinity;
    intersections.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        const segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $239aa88e7a573859$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $2166f19777f69377$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ let interiorPoints = [];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        interiorPoints = $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}



/**
 * @module ol/geom/flat/intersectsextent
 */ 
/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $3e64078bffae1cbd$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    let ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}



function $acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent) {
    const coordinatesExtent = (0, $6da4c8ed3074c92b$export$30570204156ffd18)((0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)(), flatCoordinates, offset, end, stride);
    if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(extent, coordinatesExtent)) return false;
    if ((0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(extent, coordinatesExtent)) return true;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2]) return true;
    if (coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $3e64078bffae1cbd$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $6da4c8ed3074c92b$export$a6a5a7a461419425)(extent, point1, point2);
    });
}
function $acee589e5b390c5c$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(let i = 1, ii = ends.length; i < ii; ++i)if ((0, $239aa88e7a573859$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $acee589e5b390c5c$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $155dc783a4ec227e$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(let i = 0; i < stride; ++i){
            const tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    let edge = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $7892dc06ffd23218$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (!$7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        const reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $155dc783a4ec227e$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $7892dc06ffd23218$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i)offset = $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function $7892dc06ffd23218$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    const endss = [];
    let offset = 0;
    let prevEndIndex = 0;
    let startOrientation;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        const orientation = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}







/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ class $40aa8d43bbe572bf$var$Polygon extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
    }
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   */ clone() {
        const polygon = new $40aa8d43bbe572bf$var$Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return (0, $239aa88e7a573859$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    }
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $5454470599558ddd$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * @return {Array<number>} Interior point.
   */ getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            const flatCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoint_ = (0, $2166f19777f69377$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
    }
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoint() {
        return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), "XYM");
    }
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ getLinearRingCount() {
        return this.ends_.length;
    }
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $548636579b4087f2$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ getLinearRings() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const linearRings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const linearRing = new (0, $548636579b4087f2$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $7892dc06ffd23218$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $40aa8d43bbe572bf$var$Polygon(simplifiedFlatCoordinates, "XY", simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "Polygon";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $40aa8d43bbe572bf$export$2e2bcd8739ae039 = $40aa8d43bbe572bf$var$Polygon;
function $40aa8d43bbe572bf$export$f99d756c6d81ae3f(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ const flatCoordinates = [];
    for(let i = 0; i < n; ++i)(0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, (0, $fb75384508533d8f$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, "XY", [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$c16b671815801c75(extent) {
    if ((0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(extent)) throw new Error("Cannot create polygon from empty extent");
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, "XY", [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$2451009d645fb8c2(circle, sides, angle) {
    sides = sides ? sides : 32;
    const stride = circle.getStride();
    const layout = circle.getLayout();
    const center = circle.getCenter();
    const arrayLength = stride * (sides + 1);
    const flatCoordinates = new Array(arrayLength);
    for(let i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(let j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    const ends = [
        flatCoordinates.length
    ];
    const polygon = new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, layout, ends);
    $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, radius, angle) {
    const flatCoordinates = polygon.getFlatCoordinates();
    const stride = polygon.getStride();
    const sides = flatCoordinates.length / stride - 1;
    const startAngle = angle ? angle : 0;
    for(let i = 0; i <= sides; ++i){
        const offset = i * stride;
        const angle = startAngle + (0, $6b000a049d919fe5$export$ba467bec01d66def)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}


/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ const $70364d0195659942$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 */ class $70364d0195659942$var$View extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {ViewOptions} [options] View options.
   */ constructor(options){
        super();
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, "EPSG:3857");
        /**
     * @private
     * @type {import("./size.js").Size}
     */ this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.cancelAnchor_ = undefined;
        if (options.projection) (0, $9c4744460e43e41b$export$ed949affbc7c4223)();
        if (options.center) options.center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.center, this.projection_);
        if (options.extent) options.extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(options.extent, this.projection_);
        this.applyOptions_(options);
    }
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ applyOptions_(options) {
        const properties = Object.assign({}, options);
        for(const key in 0, $d35baefbe89be4c5$export$2e2bcd8739ae039)delete properties[key];
        this.setProperties(properties, true);
        const resolutionConstraintInfo = $70364d0195659942$export$c68d65f9148da196(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        const centerConstraint = $70364d0195659942$export$964345001ee9ac52(options);
        const resolutionConstraint = resolutionConstraintInfo.constraint;
        const rotationConstraint = $70364d0195659942$export$4eeaa08dd550e3c0(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    }
    /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ get padding() {
        return this.padding_;
    }
    set padding(padding) {
        let oldPadding = this.padding_;
        this.padding_ = padding;
        const center = this.getCenterInternal();
        if (center) {
            const newPadding = padding || [
                0,
                0,
                0,
                0
            ];
            oldPadding = oldPadding || [
                0,
                0,
                0,
                0
            ];
            const resolution = this.getResolution();
            const offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
            const offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
            this.setCenterInternal([
                center[0] + offsetX,
                center[1] - offsetY
            ]);
        }
    }
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ getUpdatedOptions_(newOptions) {
        const options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object.assign({}, options, newOptions);
    }
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ animate(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        const args = new Array(arguments.length);
        for(let i = 0; i < args.length; ++i){
            let options = arguments[i];
            if (options.center) {
                options = Object.assign({}, options);
                options.center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object.assign({}, options);
                options.anchor = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    }
    /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ animateInternal(var_args) {
        let animationCount = arguments.length;
        let callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === "function") {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        let i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            const state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) $70364d0195659942$var$animationCallback(callback, true);
            return;
        }
        let start = Date.now();
        let center = this.targetCenter_.slice();
        let resolution = this.targetResolution_;
        let rotation = this.targetRotation_;
        const series = [];
        for(; i < animationCount; ++i){
            const options = /** @type {AnimationOptions} */ arguments[i];
            const animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $c7ccf7e681a9b333$export$9b47139b511b56e4),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                const delta = (0, $6b000a049d919fe5$export$ba467bec01d66def)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($70364d0195659942$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, 1);
        this.updateAnimations_();
    }
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ getAnimating() {
        return this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] > 0;
    }
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ getInteracting() {
        return this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING] > 0;
    }
    /**
   * Cancel any ongoing animations.
   * @api
   */ cancelAnimations() {
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING]);
        let anchor;
        for(let i = 0, ii = this.animations_.length; i < ii; ++i){
            const series = this.animations_[i];
            if (series[0].callback) $70364d0195659942$var$animationCallback(series[0].callback, false);
            if (!anchor) for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    }
    /**
   * Update all animations.
   */ updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        const now = Date.now();
        let more = false;
        for(let i = this.animations_.length - 1; i >= 0; --i){
            const series = this.animations_[i];
            let seriesComplete = true;
            for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (animation.complete) continue;
                const elapsed = now - animation.start;
                let fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                const progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    const x0 = animation.sourceCenter[0];
                    const y0 = animation.sourceCenter[1];
                    const x1 = animation.targetCenter[0];
                    const y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    const x = x0 + progress * (x1 - x0);
                    const y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    const resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        const size = this.getViewportSize_(this.getRotation());
                        const constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    const rotation = progress === 1 ? (0, $6b000a049d919fe5$export$ba467bec01d66def)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        const constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                const callback = series[0].callback;
                if (callback) $70364d0195659942$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    }
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ calculateCenterRotate(rotation, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
            (0, $1bd0a226f9a16141$export$e16d8520af44a096)(center, anchor);
        }
        return center;
    }
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ calculateCenterZoom(resolution, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        const currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            const x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            const y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    }
    /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ getViewportSize_(rotation) {
        const size = this.viewportSize_;
        if (rotation) {
            const w = size[0];
            const h = size[1];
            return [
                Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
            ];
        }
        return size;
    }
    /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ setViewportSize(size) {
        this.viewportSize_ = Array.isArray(size) ? size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    }
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ getCenter() {
        const center = this.getCenterInternal();
        if (!center) return center;
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(center, this.getProjection());
    }
    /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ getCenterInternal() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER);
    }
    /**
   * @return {Constraints} Constraints.
   */ getConstraints() {
        return this.constraints_;
    }
    /**
   * @return {boolean} Resolution constraint is set
   */ getConstrainResolution() {
        return this.get("constrainResolution");
    }
    /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ getHints(hints) {
        if (hints !== undefined) {
            hints[0] = this.hints_[0];
            hints[1] = this.hints_[1];
            return hints;
        }
        return this.hints_.slice();
    }
    /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ calculateExtent(size) {
        const extent = this.calculateExtentInternal(size);
        return (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, this.getProjection());
    }
    /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ calculateExtentInternal(size) {
        size = size || this.getViewportSizeMinusPadding_();
        const center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(center, "The view center is not defined");
        const resolution = /** @type {!number} */ this.getResolution();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(resolution !== undefined, "The view resolution is not defined");
        const rotation = /** @type {!number} */ this.getRotation();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(rotation !== undefined, "The view rotation is not defined");
        return (0, $6da4c8ed3074c92b$export$13ba650faf8308)(center, resolution, rotation, size);
    }
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ getMaxResolution() {
        return this.maxResolution_;
    }
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ getMinResolution() {
        return this.minResolution_;
    }
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    }
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    }
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    }
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    }
    /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ setConstrainResolution(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    }
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ getProjection() {
        return this.projection_;
    }
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ getResolution() {
        return /** @type {number|undefined} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION);
    }
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ getResolutionForExtent(extent, size) {
        return this.getResolutionForExtentInternal((0, $9c4744460e43e41b$export$494be3a3a25689ca)(extent, this.getProjection()), size);
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ getResolutionForExtentInternal(extent, size) {
        size = size || this.getViewportSizeMinusPadding_();
        const xResolution = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / size[0];
        const yResolution = (0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    }
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ getResolutionForValueFunction(power) {
        power = power || 2;
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            const resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    }
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ getRotation() {
        return /** @type {number} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION);
    }
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ getValueForResolutionFunction(power) {
        const logPower = Math.log(power || 2);
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            const value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    }
    /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ getViewportSizeMinusPadding_(rotation) {
        let size = this.getViewportSize_(rotation);
        const padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    }
    /**
   * @return {State} View state.
   */ getState() {
        const projection = this.getProjection();
        const resolution = this.getResolution();
        const rotation = this.getRotation();
        let center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        const padding = this.padding_;
        if (padding) {
            const reducedSize = this.getViewportSizeMinusPadding_();
            center = $70364d0195659942$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    }
    /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ getViewStateAndExtent() {
        return {
            viewState: this.getState(),
            extent: this.calculateExtent()
        };
    }
    /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ getZoom() {
        let zoom;
        const resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    }
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ getZoomForResolution(resolution) {
        let offset = this.minZoom_ || 0;
        let max, zoomFactor;
        if (this.resolutions_) {
            const nearest = (0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    }
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ getResolutionForZoom(zoom) {
        if (this.resolutions_) {
            if (this.resolutions_.length <= 1) return 0;
            const baseLevel = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            const zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(zoom - baseLevel, 0, 1));
        }
        return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    }
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ fit(geometryOrExtent, options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ let geometry;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === "function", "Invalid extent or geometry provided as `geometry`");
        if (Array.isArray(geometryOrExtent)) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(!(0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(geometryOrExtent), "Cannot fit empty extent provided as `geometry`");
            const extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(geometryOrExtent, this.getProjection());
            geometry = (0, $40aa8d43bbe572bf$export$c16b671815801c75)(extent);
        } else if (geometryOrExtent.getType() === "Circle") {
            const extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $40aa8d43bbe572bf$export$c16b671815801c75)(extent);
            geometry.rotate(this.getRotation(), (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(extent));
        } else {
            const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, options);
    }
    /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */ rotatedExtentForGeometry(geometry) {
        const rotation = this.getRotation();
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(-rotation);
        const coords = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        let minRotX = Infinity;
        let minRotY = Infinity;
        let maxRotX = -Infinity;
        let maxRotY = -Infinity;
        for(let i = 0, ii = coords.length; i < ii; i += stride){
            const rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            const rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    }
    /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ fitInternal(geometry, options) {
        options = options || {};
        let size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        const padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        const nearest = options.nearest !== undefined ? options.nearest : false;
        let minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        const rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        let resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        const rotation = this.getRotation();
        const sinAngle = Math.sin(rotation);
        const cosAngle = Math.cos(rotation);
        const centerRot = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        const centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        const centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        const center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        const callback = options.callback ? options.callback : (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $70364d0195659942$var$animationCallback(callback, true);
        }
    }
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ centerOn(coordinate, size, position) {
        this.centerOnInternal((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, this.getProjection()), size, position);
    }
    /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ centerOnInternal(coordinate, size, position) {
        this.setCenterInternal($70364d0195659942$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    }
    /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ calculateCenterShift(center, resolution, rotation, size) {
        let centerShift;
        const padding = this.padding_;
        if (padding && center) {
            const reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            const shiftedCenter = $70364d0195659942$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    }
    /**
   * @return {boolean} Is defined.
   */ isDef() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ adjustCenter(deltaCoordinates) {
        const center = (0, $9c4744460e43e41b$export$698f563af1ba02a5)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ adjustCenterInternal(deltaCoordinates) {
        const center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustResolution(ratio, anchor) {
        anchor = anchor && (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ adjustResolutionInternal(ratio, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const size = this.getViewportSize_(this.getRotation());
        const newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    }
    /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustZoom(delta, anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
    }
    /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ adjustRotation(delta, anchor) {
        if (anchor) anchor = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustRotationInternal(delta, anchor);
    }
    /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ adjustRotationInternal(delta, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    }
    /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ setCenter(center) {
        this.setCenterInternal(center ? (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(center, this.getProjection()) : center);
    }
    /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ setCenterInternal(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    }
    /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    }
    /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ setResolution(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    }
    /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ setRotation(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    }
    /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    }
    /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ applyTargetState_(doNotCancelAnims, forceMoving) {
        const isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
        // compute rotation
        const newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION) !== newRotation) this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION, newRotation);
        if (this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION) !== newResolution) {
            this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION, newResolution);
            this.set("zoom", this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER) || !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER), newCenter)) this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER, newCenter);
        if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    }
    /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ resolveConstraints(duration, resolutionDirection, anchor) {
        duration = duration !== undefined ? duration : 200;
        const direction = resolutionDirection || 0;
        const newRotation = this.constraints_.rotation(this.targetRotation_);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0),
                anchor: anchor
            });
        }
    }
    /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ beginInteraction() {
        this.resolveConstraints(0);
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING, 1);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ endInteraction(duration, resolutionDirection, anchor) {
        anchor = anchor && (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.endInteractionInternal(duration, resolutionDirection, anchor);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ endInteractionInternal(duration, resolutionDirection, anchor) {
        if (!this.getInteracting()) return;
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING, -1);
        this.resolveConstraints(duration, resolutionDirection, anchor);
    }
    /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ getConstrainedCenter(targetCenter, targetResolution) {
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
    }
    /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ getConstrainedZoom(targetZoom, direction) {
        const targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
    }
    /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ getConstrainedResolution(targetResolution, direction) {
        direction = direction || 0;
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    }
}
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $70364d0195659942$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $70364d0195659942$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        const smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $b21a6e049949bb31$export$c2f0af2c946f6897)(options.extent, options.constrainOnlyCenter, smooth);
    }
    const projection = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, "EPSG:3857");
    if (options.multiWorld !== true && projection.isGlobal()) {
        const extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $b21a6e049949bb31$export$c2f0af2c946f6897)(extent, false, false);
    }
    return 0, $b21a6e049949bb31$export$f883a24d5edde77c;
}
function $70364d0195659942$export$c68d65f9148da196(options) {
    let resolutionConstraint;
    let maxResolution;
    let minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    const defaultMaxZoom = 28;
    const defaultZoomFactor = 2;
    let minZoom = options.minZoom !== undefined ? options.minZoom : $70364d0195659942$var$DEFAULT_MIN_ZOOM;
    let maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    const zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    const multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    const smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    const showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    const projection = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, "EPSG:3857");
    const projExtent = projection.getExtent();
    let constrainOnlyCenter = options.constrainOnlyCenter;
    let extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        const resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $bac43a1f4a628548$export$d65a517690fc4385)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $bac43a1f4a628548$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        const size = !projExtent ? 360 * (0, $03edbd434a9e6608$export$1482081eec883108).degrees / projection.getMetersPerUnit() : Math.max((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projExtent), (0, $6da4c8ed3074c92b$export$c08559766941f856)(projExtent));
        const defaultMaxResolution = size / (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        const defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $bac43a1f4a628548$export$22ac0f6b219de91a)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $bac43a1f4a628548$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $70364d0195659942$export$4eeaa08dd550e3c0(options) {
    const enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        const constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $d65f0a322291d127$export$17a6e6f3448b17e8)();
        if (constrainRotation === false) return 0, $d65f0a322291d127$export$f883a24d5edde77c;
        if (typeof constrainRotation === "number") return (0, $d65f0a322291d127$export$9ba78806de831083)(constrainRotation);
        return 0, $d65f0a322291d127$export$f883a24d5edde77c;
    }
    return 0, $d65f0a322291d127$export$e20fbacbb41798b;
}
function $70364d0195659942$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $70364d0195659942$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    const cosAngle = Math.cos(-rotation);
    let sinAngle = Math.sin(-rotation);
    let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    const centerX = rotX * cosAngle - rotY * sinAngle;
    const centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $70364d0195659942$export$2e2bcd8739ae039 = $70364d0195659942$var$View;





/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number | undefined} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @api
 */ class $534f30fce11effcd$var$Layer extends (0, $57c5f0299cb9b82f$export$2e2bcd8739ae039) {
    /**
   * @param {Options<SourceType>} options Layer options.
   */ constructor(options){
        const baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        super(baseOptions);
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) this.render = options.render;
        if (options.map) this.setMap(options.map);
        this.addChangeListener((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE, this.handleSourcePropertyChange_);
        const source = options.source ? /** @type {SourceType} */ options.source : null;
        this.setSource(source);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        array = array ? array : [];
        array.push(this);
        return array;
    }
    /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        states = states ? states : [];
        states.push(this.getLayerState());
        return states;
    }
    /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ getSource() {
        return /** @type {SourceType} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE) || null;
    }
    /**
   * @return {SourceType|null} The source being rendered.
   */ getRenderSource() {
        return this.getSource();
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        const source = this.getSource();
        return !source ? "undefined" : source.getState();
    }
    /**
   * @private
   */ handleSourceChange_() {
        this.changed();
        if (this.sourceReady_ || this.getSource().getState() !== "ready") return;
        this.sourceReady_ = true;
        this.dispatchEvent("sourceready");
    }
    /**
   * @private
   */ handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        this.sourceReady_ = false;
        const source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(source, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleSourceChange_, this);
            if (source.getState() === "ready") {
                this.sourceReady_ = true;
                setTimeout(()=>{
                    this.dispatchEvent("sourceready");
                }, 0);
            }
        }
        this.changed();
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        if (!this.renderer_) return Promise.resolve([]);
        return this.renderer_.getFeatures(pixel);
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    }
    /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ isVisible(view) {
        let frameState;
        const map = this.getMapInternal();
        if (!view && map) view = map.getView();
        if (view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039)) frameState = {
            viewState: view.getState(),
            extent: view.calculateExtent()
        };
        else frameState = view;
        if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
        let layerState;
        if (frameState.layerStatesArray) layerState = frameState.layerStatesArray.find((layerState)=>layerState.layer === this);
        else layerState = this.getLayerState();
        const layerExtent = this.getExtent();
        return $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, frameState.viewState) && (!layerExtent || (0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(layerExtent, frameState.extent));
    }
    /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ getAttributions(view) {
        if (!this.isVisible(view)) return [];
        let getAttributions;
        const source = this.getSource();
        if (source) getAttributions = source.getAttributions();
        if (!getAttributions) return [];
        const frameState = view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039) ? view.getViewStateAndExtent() : view;
        let attributions = getAttributions(frameState);
        if (!Array.isArray(attributions)) attributions = [
            attributions
        ];
        return attributions;
    }
    /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ render(frameState, target) {
        const layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
        return null;
    }
    /**
   * Called when a layer is not visible during a map render.
   */ unrender() {
        this.rendered = false;
    }
    /** @return {string} Declutter */ getDeclutter() {
        return undefined;
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {}
    /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */ renderDeferred(frameState) {
        const layerRenderer = this.getRenderer();
        if (!layerRenderer) return;
        layerRenderer.renderDeferred(frameState);
    }
    /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ setMapInternal(map) {
        if (!map) this.unrender();
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAP, map);
    }
    /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ getMapInternal() {
        return this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAP);
    }
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRECOMPOSE, function(evt) {
                const renderEvent = /** @type {import("../render/Event.js").default} */ evt;
                const layerStatesArray = renderEvent.frameState.layerStatesArray;
                const layerState = this.getLayerState(false);
                (0, $35d5ec884318008e$export$a7a9523472993e97)(!layerStatesArray.some(function(arrayLayerState) {
                    return arrayLayerState.layer === layerState.layer;
                }), "A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.");
                layerStatesArray.push(layerState);
            }, this);
            this.mapRenderKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, map.render, map);
            this.changed();
        }
    }
    /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ setSource(source) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE, source);
    }
    /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ getRenderer() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    }
    /**
   * @return {boolean} The layer has a renderer.
   */ hasRenderer() {
        return !!this.renderer_;
    }
    /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ createRenderer() {
        return null;
    }
    /**
   * Clean up.
   */ disposeInternal() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
        this.setSource(null);
        super.disposeInternal();
    }
}
function $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    const resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    const zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $534f30fce11effcd$export$2e2bcd8739ae039 = $534f30fce11effcd$var$Layer;


var $176ca75ee9f69668$exports = {};
!function(t, i) {
    $176ca75ee9f69668$exports = i();
}($176ca75ee9f69668$exports, function() {
    "use strict";
    function t(t, r, e, a, h) {
        !function t(n, r, e, a, h) {
            for(; a > e;){
                if (a - e > 600) {
                    var o = a - e + 1, s = r - e + 1, l = Math.log(o), f = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * f * (o - f) / o) * (s - o / 2 < 0 ? -1 : 1), m = Math.max(e, Math.floor(r - s * f / o + u)), c = Math.min(a, Math.floor(r + (o - s) * f / o + u));
                    t(n, r, m, c, h);
                }
                var p = n[r], d = e, x = a;
                for(i(n, e, r), h(n[a], p) > 0 && i(n, e, a); d < x;){
                    for(i(n, d, x), d++, x--; h(n[d], p) < 0;)d++;
                    for(; h(n[x], p) > 0;)x--;
                }
                0 === h(n[e], p) ? i(n, e, x) : i(n, ++x, a), x <= r && (e = x + 1), r <= x && (a = x - 1);
            }
        }(t, r, e || 0, a || t.length - 1, h || n);
    }
    function i(t, i, n) {
        var r = t[i];
        t[i] = t[n], t[n] = r;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    var r = function(t) {
        void 0 === t && (t = 9), this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
    };
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(var r = 0; r < i.length; r++)if (n(t, i[r])) return r;
        return -1;
    }
    function a(t, i) {
        h(t, 0, t.children.length, i, t);
    }
    function h(t, i, n, r, e) {
        e || (e = p(null)), e.minX = 1 / 0, e.minY = 1 / 0, e.maxX = -1 / 0, e.maxY = -1 / 0;
        for(var a = i; a < n; a++){
            var h = t.children[a];
            o(e, t.leaf ? r(h) : h);
        }
        return e;
    }
    function o(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function s(t, i) {
        return t.minX - i.minX;
    }
    function l(t, i) {
        return t.minY - i.minY;
    }
    function f(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function u(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function c(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function p(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function d(i, n, r, e, a) {
        for(var h = [
            n,
            r
        ]; h.length;)if (!((r = h.pop()) - (n = h.pop()) <= e)) {
            var o = n + Math.ceil((r - n) / e / 2) * e;
            t(i, o, n, r, a), h.push(n, o, o, r);
        }
    }
    return r.prototype.all = function() {
        return this._all(this.data, []);
    }, r.prototype.search = function(t) {
        var i = this.data, n = [];
        if (!c(t, i)) return n;
        for(var r = this.toBBox, e = []; i;){
            for(var a = 0; a < i.children.length; a++){
                var h = i.children[a], o = i.leaf ? r(h) : h;
                c(t, o) && (i.leaf ? n.push(h) : m(t, o) ? this._all(h, n) : e.push(h));
            }
            i = e.pop();
        }
        return n;
    }, r.prototype.collides = function(t) {
        var i = this.data;
        if (!c(t, i)) return !1;
        for(var n = []; i;){
            for(var r = 0; r < i.children.length; r++){
                var e = i.children[r], a = i.leaf ? this.toBBox(e) : e;
                if (c(t, a)) {
                    if (i.leaf || m(t, a)) return !0;
                    n.push(e);
                }
            }
            i = n.pop();
        }
        return !1;
    }, r.prototype.load = function(t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
            for(var i = 0; i < t.length; i++)this.insert(t[i]);
            return this;
        }
        var n = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
            if (this.data.height === n.height) this._splitRoot(this.data, n);
            else {
                if (this.data.height < n.height) {
                    var r = this.data;
                    this.data = n, n = r;
                }
                this._insert(n, this.data.height - n.height - 1, !0);
            }
        } else this.data = n;
        return this;
    }, r.prototype.insert = function(t) {
        return t && this._insert(t, this.data.height - 1), this;
    }, r.prototype.clear = function() {
        return this.data = p([]), this;
    }, r.prototype.remove = function(t, i) {
        if (!t) return this;
        for(var n, r, a, h = this.data, o = this.toBBox(t), s = [], l = []; h || s.length;){
            if (h || (h = s.pop(), r = s[s.length - 1], n = l.pop(), a = !0), h.leaf) {
                var f = e(t, h.children, i);
                if (-1 !== f) return h.children.splice(f, 1), s.push(h), this._condense(s), this;
            }
            a || h.leaf || !m(h, o) ? r ? (n++, h = r.children[n], a = !1) : h = null : (s.push(h), l.push(n), n = 0, r = h, h = h.children[0]);
        }
        return this;
    }, r.prototype.toBBox = function(t) {
        return t;
    }, r.prototype.compareMinX = function(t, i) {
        return t.minX - i.minX;
    }, r.prototype.compareMinY = function(t, i) {
        return t.minY - i.minY;
    }, r.prototype.toJSON = function() {
        return this.data;
    }, r.prototype.fromJSON = function(t) {
        return this.data = t, this;
    }, r.prototype._all = function(t, i) {
        for(var n = []; t;)t.leaf ? i.push.apply(i, t.children) : n.push.apply(n, t.children), t = n.pop();
        return i;
    }, r.prototype._build = function(t, i, n, r) {
        var e, h = n - i + 1, o = this._maxEntries;
        if (h <= o) return a(e = p(t.slice(i, n + 1)), this.toBBox), e;
        r || (r = Math.ceil(Math.log(h) / Math.log(o)), o = Math.ceil(h / Math.pow(o, r - 1))), (e = p([])).leaf = !1, e.height = r;
        var s = Math.ceil(h / o), l = s * Math.ceil(Math.sqrt(o));
        d(t, i, n, l, this.compareMinX);
        for(var f = i; f <= n; f += l){
            var u = Math.min(f + l - 1, n);
            d(t, f, u, s, this.compareMinY);
            for(var m = f; m <= u; m += s){
                var c = Math.min(m + s - 1, u);
                e.children.push(this._build(t, m, c, r - 1));
            }
        }
        return a(e, this.toBBox), e;
    }, r.prototype._chooseSubtree = function(t, i, n, r) {
        for(; r.push(i), !i.leaf && r.length - 1 !== n;){
            for(var e = 1 / 0, a = 1 / 0, h = void 0, o = 0; o < i.children.length; o++){
                var s = i.children[o], l = f(s), u = (m = t, c = s, (Math.max(c.maxX, m.maxX) - Math.min(c.minX, m.minX)) * (Math.max(c.maxY, m.maxY) - Math.min(c.minY, m.minY)) - l);
                u < a ? (a = u, e = l < e ? l : e, h = s) : u === a && l < e && (e = l, h = s);
            }
            i = h || i.children[0];
        }
        var m, c;
        return i;
    }, r.prototype._insert = function(t, i, n) {
        var r = n ? t : this.toBBox(t), e = [], a = this._chooseSubtree(r, this.data, i, e);
        for(a.children.push(t), o(a, r); i >= 0 && e[i].children.length > this._maxEntries;)this._split(e, i), i--;
        this._adjustParentBBoxes(r, e, i);
    }, r.prototype._split = function(t, i) {
        var n = t[i], r = n.children.length, e = this._minEntries;
        this._chooseSplitAxis(n, e, r);
        var h = this._chooseSplitIndex(n, e, r), o = p(n.children.splice(h, n.children.length - h));
        o.height = n.height, o.leaf = n.leaf, a(n, this.toBBox), a(o, this.toBBox), i ? t[i - 1].children.push(o) : this._splitRoot(n, o);
    }, r.prototype._splitRoot = function(t, i) {
        this.data = p([
            t,
            i
        ]), this.data.height = t.height + 1, this.data.leaf = !1, a(this.data, this.toBBox);
    }, r.prototype._chooseSplitIndex = function(t, i, n) {
        for(var r, e, a, o, s, l, u, m = 1 / 0, c = 1 / 0, p = i; p <= n - i; p++){
            var d = h(t, 0, p, this.toBBox), x = h(t, p, n, this.toBBox), v = (e = d, a = x, o = void 0, s = void 0, l = void 0, u = void 0, o = Math.max(e.minX, a.minX), s = Math.max(e.minY, a.minY), l = Math.min(e.maxX, a.maxX), u = Math.min(e.maxY, a.maxY), Math.max(0, l - o) * Math.max(0, u - s)), M = f(d) + f(x);
            v < m ? (m = v, r = p, c = M < c ? M : c) : v === m && M < c && (c = M, r = p);
        }
        return r || n - i;
    }, r.prototype._chooseSplitAxis = function(t, i, n) {
        var r = t.leaf ? this.compareMinX : s, e = t.leaf ? this.compareMinY : l;
        this._allDistMargin(t, i, n, r) < this._allDistMargin(t, i, n, e) && t.children.sort(r);
    }, r.prototype._allDistMargin = function(t, i, n, r) {
        t.children.sort(r);
        for(var e = this.toBBox, a = h(t, 0, i, e), s = h(t, n - i, n, e), l = u(a) + u(s), f = i; f < n - i; f++){
            var m = t.children[f];
            o(a, t.leaf ? e(m) : m), l += u(a);
        }
        for(var c = n - i - 1; c >= i; c--){
            var p = t.children[c];
            o(s, t.leaf ? e(p) : p), l += u(s);
        }
        return l;
    }, r.prototype._adjustParentBBoxes = function(t, i, n) {
        for(var r = n; r >= 0; r--)o(i[r], t);
    }, r.prototype._condense = function(t) {
        for(var i = t.length - 1, n = void 0; i >= 0; i--)0 === t[i].children.length ? i > 0 ? (n = t[i - 1].children).splice(n.indexOf(t[i]), 1) : this.clear() : a(t[i], this.toBBox);
    }, r;
});


/**
 * @module ol/style/Style
 */ /**
 * @module ol/style/Circle
 */ /**
 * @module ol/style/RegularShape
 */ /**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $7eb75c96a6b6f2c6$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};


/**
 * @module ol/style/Image
 */ 
/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $cc435a5409103773$export$ab1029bcae9ddb4a(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function $cc435a5409103773$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $cc435a5409103773$export$dcdf75081b88279d(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function $cc435a5409103773$export$a71a825ff42fb8e1(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}


/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {import('../style/Style.js').DeclutterMode} declutterMode Declutter mode: `declutter`, `obstacle`, `none`.
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ class $e60011aea38e6239$var$ImageStyle {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $e60011aea38e6239$var$ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ getOpacity() {
        return this.opacity_;
    }
    /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ getDisplacement() {
        return this.displacement_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ getAnchor() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getImage(pixelRatio) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getHitDetectionImage() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return 1;
    }
    /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ getOrigin() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ getSize() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ setDisplacement(displacement) {
        this.displacement_ = displacement;
    }
    /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ setOpacity(opacity) {
        this.opacity_ = opacity;
    }
    /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(scale);
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Load not yet loaded URI.
   * @abstract
   */ load() {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */ ready() {
        return Promise.resolve();
    }
}
var $e60011aea38e6239$export$2e2bcd8739ae039 = $e60011aea38e6239$var$ImageStyle;


/**
 * @module ol/color
 */ /**
 * Cylindrical CIE LUV
 *
 * @module color-space/lchuv
 */ /**
 * CIE LUV (C'est la vie)
 *
 * @module color-space/luv
 */ /**
 * CIE XYZ
 *
 * @module  color-space/xyz
 */ /**
 * RGB space.
 *
 * @module  color-space/rgb
 */ var $3751ab4954229b70$export$2e2bcd8739ae039 = {
    name: "rgb",
    min: [
        0,
        0,
        0
    ],
    max: [
        255,
        255,
        255
    ],
    channel: [
        "red",
        "green",
        "blue"
    ],
    alias: [
        "RGB"
    ]
};


var $3d55e8295660d0b8$var$xyz = {
    name: "xyz",
    min: [
        0,
        0,
        0
    ],
    channel: [
        "X",
        "Y",
        "Z"
    ],
    alias: [
        "XYZ",
        "ciexyz",
        "cie1931"
    ]
};
/**
 * Whitepoint reference values with observer/illuminant
 *
 * http://en.wikipedia.org/wiki/Standard_illuminant
 */ $3d55e8295660d0b8$var$xyz.whitepoint = {
    //1931 2°
    2: {
        //incadescent
        A: [
            109.85,
            100,
            35.585
        ],
        // B:[],
        C: [
            98.074,
            100,
            118.232
        ],
        D50: [
            96.422,
            100,
            82.521
        ],
        D55: [
            95.682,
            100,
            92.149
        ],
        //daylight
        D65: [
            95.045592705167,
            100,
            108.9057750759878
        ],
        D75: [
            94.972,
            100,
            122.638
        ],
        //flourescent
        // F1: [],
        F2: [
            99.187,
            100,
            67.395
        ],
        // F3: [],
        // F4: [],
        // F5: [],
        // F6:[],
        F7: [
            95.044,
            100,
            108.755
        ],
        // F8: [],
        // F9: [],
        // F10: [],
        F11: [
            100.966,
            100,
            64.370
        ],
        // F12: [],
        E: [
            100,
            100,
            100
        ]
    },
    //1964  10°
    10: {
        //incadescent
        A: [
            111.144,
            100,
            35.200
        ],
        C: [
            97.285,
            100,
            116.145
        ],
        D50: [
            96.720,
            100,
            81.427
        ],
        D55: [
            95.799,
            100,
            90.926
        ],
        //daylight
        D65: [
            94.811,
            100,
            107.304
        ],
        D75: [
            94.416,
            100,
            120.641
        ],
        //flourescent
        F2: [
            103.280,
            100,
            69.026
        ],
        F7: [
            95.792,
            100,
            107.687
        ],
        F11: [
            103.866,
            100,
            65.627
        ],
        E: [
            100,
            100,
            100
        ]
    }
};
/**
 * Top values are the whitepoint’s top values, default are D65
 */ $3d55e8295660d0b8$var$xyz.max = $3d55e8295660d0b8$var$xyz.whitepoint[2].D65;
/**
 * Transform xyz to rgb
 *
 * @param {Array} xyz Array of xyz values
 *
 * @return {Array} RGB values
 */ $3d55e8295660d0b8$var$xyz.rgb = function(_xyz, white) {
    //FIXME: make sure we have to divide like this. Probably we have to replace matrix as well then
    white = white || $3d55e8295660d0b8$var$xyz.whitepoint[2].E;
    var x = _xyz[0] / white[0], y = _xyz[1] / white[1], z = _xyz[2] / white[2], r, g, b;
    // assume sRGB
    // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
    r = x * 3.240969941904521 + y * -1.537383177570093 + z * -0.498610760293;
    g = x * -0.96924363628087 + y * 1.87596750150772 + z * 0.041555057407175;
    b = x * 0.055630079696993 + y * -0.20397695888897 + z * 1.056971514242878;
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r = r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g = g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b = b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
/**
 * RGB to XYZ
 *
 * @param {Array} rgb RGB channels
 *
 * @return {Array} XYZ channels
 */ (0, $3751ab4954229b70$export$2e2bcd8739ae039).xyz = function(rgb, white) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.41239079926595 + g * 0.35758433938387 + b * 0.18048078840183;
    var y = r * 0.21263900587151 + g * 0.71516867876775 + b * 0.072192315360733;
    var z = r * 0.019330818715591 + g * 0.11919477979462 + b * 0.95053215224966;
    white = white || $3d55e8295660d0b8$var$xyz.whitepoint[2].E;
    return [
        x * white[0],
        y * white[1],
        z * white[2]
    ];
};
var $3d55e8295660d0b8$export$2e2bcd8739ae039 = $3d55e8295660d0b8$var$xyz;


var $f857682ac15a36ea$export$2e2bcd8739ae039 = {
    name: "luv",
    //NOTE: luv has no rigidly defined limits
    //easyrgb fails to get proper coords
    //boronine states no rigid limits
    //colorMine refers this ones:
    min: [
        0,
        -134,
        -140
    ],
    max: [
        100,
        224,
        122
    ],
    channel: [
        "lightness",
        "u",
        "v"
    ],
    alias: [
        "LUV",
        "cieluv",
        "cie1976"
    ],
    xyz: function(arg, i, o) {
        var _u, _v, l, u, v, x, y, z, xn, yn, zn, un, vn;
        l = arg[0], u = arg[1], v = arg[2];
        if (l === 0) return [
            0,
            0,
            0
        ];
        //get constants
        //var e = 0.008856451679035631; //(6/29)^3
        var k = 0.0011070564598794539; //(3/29)^3
        //get illuminant/observer
        i = i || "D65";
        o = o || 2;
        xn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][0];
        yn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][1];
        zn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][2];
        un = 4 * xn / (xn + 15 * yn + 3 * zn);
        vn = 9 * yn / (xn + 15 * yn + 3 * zn);
        // un = 0.19783000664283;
        // vn = 0.46831999493879;
        _u = u / (13 * l) + un || 0;
        _v = v / (13 * l) + vn || 0;
        y = l > 8 ? yn * Math.pow((l + 16) / 116, 3) : yn * l * k;
        //wikipedia method
        x = y * 9 * _u / (4 * _v) || 0;
        z = y * (12 - 3 * _u - 20 * _v) / (4 * _v) || 0;
        //boronine method
        //https://github.com/boronine/husl/blob/master/husl.coffee#L201
        // x = 0 - (9 * y * _u) / ((_u - 4) * _v - _u * _v);
        // z = (9 * y - (15 * _v * y) - (_v * x)) / (3 * _v);
        return [
            x,
            y,
            z
        ];
    }
};
// http://www.brucelindbloom.com/index.html?Equations.html
// https://github.com/boronine/husl/blob/master/husl.coffee
//i - illuminant
//o - observer
(0, $3d55e8295660d0b8$export$2e2bcd8739ae039).luv = function(arg, i, o) {
    var _u, _v, l, u, v, x, y, z, xn, yn, zn, un, vn;
    //get constants
    var e = 0.008856451679035631; //(6/29)^3
    var k = 903.2962962962961; //(29/3)^3
    //get illuminant/observer coords
    i = i || "D65";
    o = o || 2;
    xn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][0];
    yn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][1];
    zn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][2];
    un = 4 * xn / (xn + 15 * yn + 3 * zn);
    vn = 9 * yn / (xn + 15 * yn + 3 * zn);
    x = arg[0], y = arg[1], z = arg[2];
    _u = 4 * x / (x + 15 * y + 3 * z) || 0;
    _v = 9 * y / (x + 15 * y + 3 * z) || 0;
    var yr = y / yn;
    l = yr <= e ? k * yr : 116 * Math.pow(yr, 1 / 3) - 16;
    u = 13 * l * (_u - un);
    v = 13 * l * (_v - vn);
    return [
        l,
        u,
        v
    ];
};



//cylindrical luv
var $2abac224ee1f2820$var$lchuv = {
    name: "lchuv",
    channel: [
        "lightness",
        "chroma",
        "hue"
    ],
    alias: [
        "LCHuv",
        "cielchuv"
    ],
    min: [
        0,
        0,
        0
    ],
    max: [
        100,
        100,
        360
    ],
    luv: function(luv) {
        var l = luv[0], c = luv[1], h = luv[2], u, v, hr;
        hr = h / 360 * 2 * Math.PI;
        u = c * Math.cos(hr);
        v = c * Math.sin(hr);
        return [
            l,
            u,
            v
        ];
    },
    xyz: function(arg) {
        return (0, $f857682ac15a36ea$export$2e2bcd8739ae039).xyz($2abac224ee1f2820$var$lchuv.luv(arg));
    }
};
var $2abac224ee1f2820$export$2e2bcd8739ae039 = $2abac224ee1f2820$var$lchuv;
(0, $f857682ac15a36ea$export$2e2bcd8739ae039).lchuv = function(luv) {
    var l = luv[0], u = luv[1], v = luv[2];
    var c = Math.sqrt(u * u + v * v);
    var hr = Math.atan2(v, u);
    var h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    return [
        l,
        c,
        h
    ];
};
(0, $3d55e8295660d0b8$export$2e2bcd8739ae039).lchuv = function(arg) {
    return (0, $f857682ac15a36ea$export$2e2bcd8739ae039).lchuv((0, $3d55e8295660d0b8$export$2e2bcd8739ae039).luv(arg));
};


/** @module  color-rgba */ /**
 * @module color-parse
 */ var $96f3bba6e010158e$export$2e2bcd8739ae039 = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};


var $5481cadd51b98557$export$2e2bcd8739ae039 = $5481cadd51b98557$var$parse;
/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */ //FIXME: use external hue detector
var $5481cadd51b98557$var$baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */ function $5481cadd51b98557$var$parse(cstr) {
    var m, parts = [], alpha = 1, space;
    //numeric case
    if (typeof cstr === "number") return {
        space: "rgb",
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    if (typeof cstr === "number") return {
        space: "rgb",
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    cstr = String(cstr).toLowerCase();
    //keyword
    if ((0, $96f3bba6e010158e$export$2e2bcd8739ae039)[cstr]) {
        parts = (0, $96f3bba6e010158e$export$2e2bcd8739ae039)[cstr].slice();
        space = "rgb";
    } else if (cstr === "transparent") {
        alpha = 0;
        space = "rgb";
        parts = [
            0,
            0,
            0
        ];
    } else if (cstr[0] === "#") {
        var base = cstr.slice(1);
        var size = base.length;
        var isShort = size <= 4;
        alpha = 1;
        if (isShort) {
            parts = [
                parseInt(base[0] + base[0], 16),
                parseInt(base[1] + base[1], 16),
                parseInt(base[2] + base[2], 16)
            ];
            if (size === 4) alpha = parseInt(base[3] + base[3], 16) / 255;
        } else {
            parts = [
                parseInt(base[0] + base[1], 16),
                parseInt(base[2] + base[3], 16),
                parseInt(base[4] + base[5], 16)
            ];
            if (size === 8) alpha = parseInt(base[6] + base[7], 16) / 255;
        }
        if (!parts[0]) parts[0] = 0;
        if (!parts[1]) parts[1] = 0;
        if (!parts[2]) parts[2] = 0;
        space = "rgb";
    } else if (m = /^((?:rgba?|hs[lvb]a?|hwba?|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms|oklch|oklab|color))\s*\(([^\)]*)\)/.exec(cstr)) {
        var name = m[1];
        space = name.replace(/a$/, "");
        var dims = space === "cmyk" ? 4 : space === "gray" ? 1 : 3;
        parts = m[2].trim().split(/\s*[,\/]\s*|\s+/);
        // color(srgb-linear x x x) -> srgb-linear(x x x)
        if (space === "color") space = parts.shift();
        parts = parts.map(function(x, i) {
            //<percentage>
            if (x[x.length - 1] === "%") {
                x = parseFloat(x) / 100;
                // alpha -> 0..1
                if (i === 3) return x;
                // rgb -> 0..255
                if (space === "rgb") return x * 255;
                // hsl, hwb H -> 0..100
                if (space[0] === "h") return x * 100;
                // lch, lab L -> 0..100
                if (space[0] === "l" && !i) return x * 100;
                // lab A B -> -125..125
                if (space === "lab") return x * 125;
                // lch C -> 0..150, H -> 0..360
                if (space === "lch") return i < 2 ? x * 150 : x * 360;
                // oklch/oklab L -> 0..1
                if (space[0] === "o" && !i) return x;
                // oklab A B -> -0.4..0.4
                if (space === "oklab") return x * 0.4;
                // oklch C -> 0..0.4, H -> 0..360
                if (space === "oklch") return i < 2 ? x * 0.4 : x * 360;
                // color(xxx) -> 0..1
                return x;
            }
            //hue
            if (space[i] === "h" || i === 2 && space[space.length - 1] === "h") {
                //<base-hue>
                if ($5481cadd51b98557$var$baseHues[x] !== undefined) return $5481cadd51b98557$var$baseHues[x];
                //<deg>
                if (x.endsWith("deg")) return parseFloat(x);
                //<turn>
                if (x.endsWith("turn")) return parseFloat(x) * 360;
                if (x.endsWith("grad")) return parseFloat(x) * 360 / 400;
                if (x.endsWith("rad")) return parseFloat(x) * 180 / Math.PI;
            }
            if (x === "none") return 0;
            return parseFloat(x);
        });
        alpha = parts.length > dims ? parts.pop() : 1;
    } else if (/[0-9](?:\s|\/|,)/.test(cstr)) {
        parts = cstr.match(/([0-9]+)/g).map(function(value) {
            return parseFloat(value);
        });
        space = cstr.match(/([a-z])/ig)?.join("")?.toLowerCase() || "rgb";
    }
    return {
        space: space,
        values: parts,
        alpha: alpha
    };
}



/**
 * @module color-space/hsl
 */ 
var $4b161c5b6bfbd933$export$2e2bcd8739ae039 = {
    name: "hsl",
    min: [
        0,
        0,
        0
    ],
    max: [
        360,
        100,
        100
    ],
    channel: [
        "hue",
        "saturation",
        "lightness"
    ],
    alias: [
        "HSL"
    ],
    rgb: function(hsl) {
        var h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100, t1, t2, t3, rgb, val, i = 0;
        if (s === 0) return val = l * 255, [
            val,
            val,
            val
        ];
        t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        t1 = 2 * l - t2;
        rgb = [
            0,
            0,
            0
        ];
        for(; i < 3;){
            t3 = h + 1 / 3 * -(i - 1);
            t3 < 0 ? t3++ : t3 > 1 && t3--;
            val = 6 * t3 < 1 ? t1 + (t2 - t1) * 6 * t3 : 2 * t3 < 1 ? t2 : 3 * t3 < 2 ? t1 + (t2 - t1) * (2 / 3 - t3) * 6 : t1;
            rgb[i++] = val * 255;
        }
        return rgb;
    }
};
//extend rgb
(0, $3751ab4954229b70$export$2e2bcd8739ae039).hsl = function(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min, h, s, l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};


function $6f2ac7eebd53949d$export$2e2bcd8739ae039(color) {
    // template literals
    if (Array.isArray(color) && color.raw) color = String.raw(...arguments);
    if (color instanceof Number) color = +color;
    var values, i, l;
    //attempt to parse non-array arguments
    var parsed = (0, $5481cadd51b98557$export$2e2bcd8739ae039)(color);
    if (!parsed.space) return [];
    const min = parsed.space[0] === "h" ? (0, $4b161c5b6bfbd933$export$2e2bcd8739ae039).min : (0, $3751ab4954229b70$export$2e2bcd8739ae039).min;
    const max = parsed.space[0] === "h" ? (0, $4b161c5b6bfbd933$export$2e2bcd8739ae039).max : (0, $3751ab4954229b70$export$2e2bcd8739ae039).max;
    values = Array(3);
    values[0] = Math.min(Math.max(parsed.values[0], min[0]), max[0]);
    values[1] = Math.min(Math.max(parsed.values[1], min[1]), max[1]);
    values[2] = Math.min(Math.max(parsed.values[2], min[2]), max[2]);
    if (parsed.space[0] === "h") values = (0, $4b161c5b6bfbd933$export$2e2bcd8739ae039).rgb(values);
    values.push(Math.min(Math.max(parsed.alpha, 0), 1));
    return values;
}





function $322346e1ff7894ca$export$590567be997858b6(color) {
    if (typeof color === "string") return color;
    return $322346e1ff7894ca$export$f84e8e69fd4488a5(color);
}
/**
 * @type {number}
 */ const $322346e1ff7894ca$var$MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ const $322346e1ff7894ca$var$cache = {};
/**
 * @type {number}
 */ let $322346e1ff7894ca$var$cacheSize = 0;
function $322346e1ff7894ca$export$138c09bdd6bd797c(color) {
    if (color.length === 4) return color;
    const output = color.slice();
    output[3] = 1;
    return output;
}
function $322346e1ff7894ca$export$44fb54fa2e0c0d4(color) {
    const output = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).lchuv((0, $3751ab4954229b70$export$2e2bcd8739ae039).xyz(color));
    output[3] = color[3];
    return output;
}
function $322346e1ff7894ca$export$27cc94530c050f00(color) {
    const output = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).rgb((0, $2abac224ee1f2820$export$2e2bcd8739ae039).xyz(color));
    output[3] = color[3];
    return output;
}
function $322346e1ff7894ca$export$3004f64547af360e(s) {
    if ($322346e1ff7894ca$var$cache.hasOwnProperty(s)) return $322346e1ff7894ca$var$cache[s];
    if ($322346e1ff7894ca$var$cacheSize >= $322346e1ff7894ca$var$MAX_CACHE_SIZE) {
        let i = 0;
        for(const key in $322346e1ff7894ca$var$cache)if ((i++ & 3) === 0) {
            delete $322346e1ff7894ca$var$cache[key];
            --$322346e1ff7894ca$var$cacheSize;
        }
    }
    const color = (0, $6f2ac7eebd53949d$export$2e2bcd8739ae039)(s);
    if (color.length !== 4) throw new Error('Failed to parse "' + s + '" as color');
    for (const c of color){
        if (isNaN(c)) throw new Error('Failed to parse "' + s + '" as color');
    }
    $322346e1ff7894ca$export$a3295358bff77e(color);
    $322346e1ff7894ca$var$cache[s] = color;
    ++$322346e1ff7894ca$var$cacheSize;
    return color;
}
function $322346e1ff7894ca$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    return $322346e1ff7894ca$export$3004f64547af360e(color);
}
function $322346e1ff7894ca$export$a3295358bff77e(color) {
    color[0] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[0] + 0.5 | 0, 0, 255);
    color[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[1] + 0.5 | 0, 0, 255);
    color[2] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[2] + 0.5 | 0, 0, 255);
    color[3] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[3], 0, 1);
    return color;
}
function $322346e1ff7894ca$export$f84e8e69fd4488a5(color) {
    let r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    let g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    let b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    const a = color[3] === undefined ? 1 : Math.round(color[3] * 1000) / 1000;
    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
}
function $322346e1ff7894ca$export$40dd713d7775a0b1(s) {
    try {
        $322346e1ff7894ca$export$3004f64547af360e(s);
        return true;
    } catch (_) {
        return false;
    }
}


/**
 * @module ol/colorlike
 */ 
/**
 * @module ol/has
 */ const $67c66761d21428d0$var$ua = typeof navigator !== "undefined" && typeof navigator.userAgent !== "undefined" ? navigator.userAgent.toLowerCase() : "";
const $67c66761d21428d0$export$8442bdfd18b7b8a6 = $67c66761d21428d0$var$ua.includes("firefox");
const $67c66761d21428d0$export$3227bfbdaa9275de = $67c66761d21428d0$var$ua.includes("safari") && !$67c66761d21428d0$var$ua.includes("chrom");
const $67c66761d21428d0$export$b23eed0e325a206a = $67c66761d21428d0$export$3227bfbdaa9275de && ($67c66761d21428d0$var$ua.includes("version/15.4") || /cpu (os|iphone os) 15_4 like mac os x/.test($67c66761d21428d0$var$ua));
const $67c66761d21428d0$export$39dfd62a25e0fe93 = $67c66761d21428d0$var$ua.includes("webkit") && !$67c66761d21428d0$var$ua.includes("edge");
const $67c66761d21428d0$export$76c0a3b101d93136 = $67c66761d21428d0$var$ua.includes("macintosh");
const $67c66761d21428d0$export$6b83a0446fc26f94 = typeof devicePixelRatio !== "undefined" ? devicePixelRatio : 1;
const $67c66761d21428d0$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== "undefined" && typeof OffscreenCanvas !== "undefined" && self instanceof WorkerGlobalScope; //eslint-disable-line
const $67c66761d21428d0$export$716f8695eedb9bad = typeof Image !== "undefined" && Image.prototype.decode;
const $67c66761d21428d0$export$7478563940788376 = typeof createImageBitmap === "function";
const $67c66761d21428d0$export$f751ce96c6c4e4fc = function() {
    let passive = false;
    try {
        const options = Object.defineProperty({}, "passive", {
            get: function() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener("_", null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener("_", null, options);
    } catch (error) {
    // passive not supported
    }
    return passive;
}();


function $075f937d7366f1a2$export$9e05d10eae75c464(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ let canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, $67c66761d21428d0$export$98fcef3dc9973292) canvas = new OffscreenCanvas(width || 300, height || 300);
    else canvas = document.createElement("canvas");
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    //FIXME Allow OffscreenCanvasRenderingContext2D as return type
    return /** @type {CanvasRenderingContext2D} */ canvas.getContext("2d", settings);
}
/** @type {CanvasRenderingContext2D} */ let $075f937d7366f1a2$var$sharedCanvasContext;
function $075f937d7366f1a2$export$fcb72ce088a6632c() {
    if (!$075f937d7366f1a2$var$sharedCanvasContext) $075f937d7366f1a2$var$sharedCanvasContext = $075f937d7366f1a2$export$9e05d10eae75c464(1, 1);
    return $075f937d7366f1a2$var$sharedCanvasContext;
}
function $075f937d7366f1a2$export$e918ac6a1026a12a(context) {
    const canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $075f937d7366f1a2$export$e823f88e4111159a(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $075f937d7366f1a2$export$fc5b8aac72846d1e(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $075f937d7366f1a2$export$5542201de9311ab2(newNode, oldNode) {
    const parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $075f937d7366f1a2$export$1d0aa160432dfea5(node) {
    return node && node.parentNode ? node.parentNode.removeChild(node) : null;
}
function $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.removeChild(node.lastChild);
}
function $075f937d7366f1a2$export$caeacfe04f52533a(node, children) {
    const oldChildren = node.childNodes;
    for(let i = 0;; ++i){
        const oldChild = oldChildren[i];
        const newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}


/**
 * @module ol/style/IconImage
 */ 




/**
 * @module ol/Image
 */ 





/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ class $b54439be79d4619a$var$ImageWrapper extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|Array<number>|undefined} resolution Resolution. If provided as array, x and y
   * resolution will be assumed.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default|import("./Image.js").Loader} stateOrLoader State.
   */ constructor(extent, resolution, pixelRatio, stateOrLoader){
        super();
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = typeof stateOrLoader === "function" ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ this.image_ = null;
        /**
     * @protected
     * @type {import("./Image.js").Loader}
     */ this.loader = typeof stateOrLoader === "function" ? stateOrLoader : null;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ getExtent() {
        return this.extent;
    }
    /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ getImage() {
        return this.image_;
    }
    /**
   * @return {number} PixelRatio.
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * @return {number|Array<number>} Resolution.
   */ getResolution() {
        return /** @type {number} */ this.resolution;
    }
    /**
   * @return {import("./ImageState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) {
            if (this.loader) {
                this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
                this.changed();
                const resolution = this.getResolution();
                const requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                (0, $013a1733c226ec50$export$4dbaaf6c79705e6c)(()=>this.loader(this.getExtent(), requestResolution, this.getPixelRatio())).then((image)=>{
                    if ("image" in image) this.image_ = image.image;
                    if ("extent" in image) this.extent = image.extent;
                    if ("resolution" in image) this.resolution = image.resolution;
                    if ("pixelRatio" in image) this.pixelRatio_ = image.pixelRatio;
                    if (image instanceof HTMLImageElement || image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) this.image_ = image;
                    this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
                }).catch((error)=>{
                    this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR;
                    console.error(error); // eslint-disable-line no-console
                }).finally(()=>this.changed());
            }
        }
    }
    /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number|Array<number>} resolution Resolution.
   */ setResolution(resolution) {
        this.resolution = resolution;
    }
}
function $b54439be79d4619a$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    const img = /** @type {HTMLImageElement} */ image;
    let listening = true;
    let decoding = false;
    let loaded = false;
    const listenerKeys = [
        (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(img, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $67c66761d21428d0$export$716f8695eedb9bad)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(img, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
    };
}
function $b54439be79d4619a$export$11e63f7b0f3d9900(image, src) {
    return new Promise((resolve, reject)=>{
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error("Image load error"));
        }
        function unlisten() {
            image.removeEventListener("load", handleLoad);
            image.removeEventListener("error", handleError);
        }
        image.addEventListener("load", handleLoad);
        image.addEventListener("error", handleError);
        if (src) image.src = src;
    });
}
function $b54439be79d4619a$export$a9e5af241c1bd389(image, src) {
    if (src) image.src = src;
    return image.src && (0, $67c66761d21428d0$export$716f8695eedb9bad) ? new Promise((resolve, reject)=>image.decode().then(()=>resolve(image)).catch((e)=>image.complete && image.width ? resolve(image) : reject(e))) : $b54439be79d4619a$export$11e63f7b0f3d9900(image);
}
function $b54439be79d4619a$export$2f872c0f2117be69(image, src) {
    if (src) image.src = src;
    return image.src && (0, $67c66761d21428d0$export$716f8695eedb9bad) && (0, $67c66761d21428d0$export$7478563940788376) ? image.decode().then(()=>createImageBitmap(image)).catch((e)=>{
        if (image.complete && image.width) return image;
        throw e;
    }) : $b54439be79d4619a$export$a9e5af241c1bd389(image);
}
var $b54439be79d4619a$export$2e2bcd8739ae039 = $b54439be79d4619a$var$ImageWrapper;


/**
 * @module ol/style/IconImageCache
 */ 


/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ class $f351daabfe6e2d22$var$IconImageCache {
    constructor(){
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {!Object<string, CanvasPattern>}
     * @private
     */ this.patternCache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 32;
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.cache_ = {};
        this.patternCache_ = {};
        this.cacheSize_ = 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.cacheSize_ > this.maxCacheSize_;
    }
    /**
   * FIXME empty description for jsdoc
   */ expire() {
        if (this.canExpireCache()) {
            let i = 0;
            for(const key in this.cache_){
                const iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    delete this.patternCache_[key];
                    --this.cacheSize_;
                }
            }
        }
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ get(src, crossOrigin, color) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.cache_ ? this.cache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */ getPattern(src, crossOrigin, color) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.patternCache_ ? this.patternCache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */ set(src, crossOrigin, color, iconImage, pattern) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        const update = key in this.cache_;
        this.cache_[key] = iconImage;
        if (pattern) {
            if (iconImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) iconImage.load();
            if (iconImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) iconImage.ready().then(()=>{
                this.patternCache_[key] = (0, $075f937d7366f1a2$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), "repeat");
            });
            else this.patternCache_[key] = (0, $075f937d7366f1a2$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), "repeat");
        }
        if (!update) ++this.cacheSize_;
    }
    /**
   * Set the cache size of the icon cache. Default is `32`. Change this value when
   * your map uses more than 32 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ setSize(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    }
}
function $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color) {
    const colorString = color ? (0, $322346e1ff7894ca$export$75093a47a9fa838d)(color) : "null";
    return crossOrigin + ":" + src + ":" + colorString;
}
var $f351daabfe6e2d22$export$2e2bcd8739ae039 = $f351daabfe6e2d22$var$IconImageCache;
const $f351daabfe6e2d22$export$747ccdf771a87ab8 = new $f351daabfe6e2d22$var$IconImageCache();


/**
 * @type {CanvasRenderingContext2D}
 */ let $0e5ad1d3b638689e$var$taintedTestContext = null;
class $0e5ad1d3b638689e$var$IconImage extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */ constructor(image, src, crossOrigin, imageState, color){
        super();
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null}
     */ this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color|string|null}
     */ this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState === undefined ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     */ this.tainted_;
        /**
     * @private
     * @type {Promise<void>|null}
     */ this.ready_ = null;
    }
    /**
   * @private
   */ initializeImage_() {
        this.image_ = new Image();
        if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
    }
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) {
            if (!$0e5ad1d3b638689e$var$taintedTestContext) $0e5ad1d3b638689e$var$taintedTestContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1, undefined, {
                willReadFrequently: true
            });
            $0e5ad1d3b638689e$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $0e5ad1d3b638689e$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch (e) {
                $0e5ad1d3b638689e$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    }
    /**
   * @private
   */ dispatchChangeEvent_() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @private
   */ handleImageError_() {
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR;
        this.dispatchChangeEvent_();
    }
    /**
   * @private
   */ handleImageLoad_() {
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.dispatchChangeEvent_();
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element or image bitmap.
   */ getImage(pixelRatio) {
        if (!this.image_) this.initializeImage_();
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ getPixelRatio(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        if (!this.image_) this.initializeImage_();
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                const width = this.size_[0];
                const height = this.size_[1];
                const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ getSize() {
        return this.size_;
    }
    /**
   * @return {string|undefined} Image src.
   */ getSrc() {
        return this.src_;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.imageState_ !== (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) return;
        if (!this.image_) this.initializeImage_();
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
        try {
            if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
        } catch (e) {
            this.handleImageError_();
        }
        if (this.image_ instanceof HTMLImageElement) (0, $b54439be79d4619a$export$a9e5af241c1bd389)(this.image_, this.src_).then((image)=>{
            this.image_ = image;
            this.handleImageLoad_();
        }).catch(this.handleImageError_.bind(this));
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ replaceColor_(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        const image = this.image_;
        const canvas = document.createElement("canvas");
        canvas.width = Math.ceil(image.width * pixelRatio);
        canvas.height = Math.ceil(image.height * pixelRatio);
        const ctx = canvas.getContext("2d");
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(image, 0, 0);
        ctx.globalCompositeOperation = "multiply";
        ctx.fillStyle = (0, $322346e1ff7894ca$export$590567be997858b6)(this.color_);
        ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
        ctx.globalCompositeOperation = "destination-in";
        ctx.drawImage(image, 0, 0);
        this.canvas_[pixelRatio] = canvas;
    }
    /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */ ready() {
        if (!this.ready_) this.ready_ = new Promise((resolve)=>{
            if (this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) resolve();
            else this.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, function onChange() {
                if (this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) {
                    this.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, onChange);
                    resolve();
                }
            });
        });
        return this.ready_;
    }
}
function $0e5ad1d3b638689e$export$3988ae62b71be9a3(image, cacheKey, crossOrigin, imageState, color, pattern) {
    let iconImage = cacheKey === undefined ? undefined : (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).get(cacheKey, crossOrigin, color);
    if (!iconImage) {
        iconImage = new $0e5ad1d3b638689e$var$IconImage(image, image && "src" in image ? image.src || undefined : cacheKey, crossOrigin, imageState, color);
        (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage, pattern);
    }
    if (pattern && iconImage && !(0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(cacheKey, crossOrigin, color)) (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage, pattern);
    return iconImage;
}
var $0e5ad1d3b638689e$export$2e2bcd8739ae039 = $0e5ad1d3b638689e$var$IconImage;




function $e0807f400ec9a0a9$export$dc5b1400ac3a10a8(color) {
    if (!color) return null;
    if (Array.isArray(color)) return (0, $322346e1ff7894ca$export$f84e8e69fd4488a5)(color);
    if (typeof color === "object" && "src" in color) return $e0807f400ec9a0a9$var$asCanvasPattern(color);
    return color;
}
/**
 * @param {PatternDescriptor} pattern Pattern descriptor.
 * @return {CanvasPattern|null} Canvas pattern or null if the pattern referenced in the
 * PatternDescriptor was not found in the icon image cache.
 */ function $e0807f400ec9a0a9$var$asCanvasPattern(pattern) {
    if (!pattern.offset || !pattern.size) return (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(pattern.src, "anonymous", pattern.color);
    const cacheKey = pattern.src + ":" + pattern.offset;
    const canvasPattern = (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(cacheKey, undefined, pattern.color);
    if (canvasPattern) return canvasPattern;
    const iconImage = (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).get(pattern.src, "anonymous", null);
    if (iconImage.getImageState() !== (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return null;
    const patternCanvasContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(pattern.size[0], pattern.size[1]);
    patternCanvasContext.drawImage(iconImage.getImage(1), pattern.offset[0], pattern.offset[1], pattern.size[0], pattern.size[1], 0, 0, pattern.size[0], pattern.size[1]);
    (0, $0e5ad1d3b638689e$export$3988ae62b71be9a3)(patternCanvasContext.canvas, cacheKey, undefined, (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED, pattern.color, true);
    return (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(cacheKey, undefined, pattern.color);
}



/**
 * @module ol/render/canvas
 */ 



/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ const $ce07df6d5d4656f1$export$981241db82723ce2 = "ol-hidden";
const $ce07df6d5d4656f1$export$99b49471b0394319 = "ol-selectable";
const $ce07df6d5d4656f1$export$1afde3d6e16a7b29 = "ol-unselectable";
const $ce07df6d5d4656f1$export$68eede0dd8c6c1da = "ol-unsupported";
const $ce07df6d5d4656f1$export$4d4f8be70b656192 = "ol-control";
const $ce07df6d5d4656f1$export$e16017ac68d14492 = "ol-collapsed";
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ const $ce07df6d5d4656f1$var$fontRegEx = new RegExp([
    "^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)",
    "(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?",
    "(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))",
    "(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))",
    "?\\s*([-,\\\"\\'\\sa-z]+?)\\s*$"
].join(""), "i");
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ const $ce07df6d5d4656f1$var$fontRegExMatchIndex = [
    "style",
    "variant",
    "weight",
    "size",
    "lineHeight",
    "family"
];
const $ce07df6d5d4656f1$export$5abde8a6aec4a131 = function(fontSpec) {
    const match = fontSpec.match($ce07df6d5d4656f1$var$fontRegEx);
    if (!match) return null;
    const style = /** @type {FontParameters} */ {
        lineHeight: "normal",
        size: "1.2em",
        style: "normal",
        weight: "normal",
        variant: "normal"
    };
    for(let i = 0, ii = $ce07df6d5d4656f1$var$fontRegExMatchIndex.length; i < ii; ++i){
        const value = match[i + 1];
        if (value !== undefined) style[$ce07df6d5d4656f1$var$fontRegExMatchIndex[i]] = value;
    }
    style.families = style.family.split(/,\s?/);
    return style;
};


const $d4aabc5c971073f1$export$3847dfea4f8d4dfa = "10px sans-serif";
const $d4aabc5c971073f1$export$c495d52ee3fd74b2 = "#000";
const $d4aabc5c971073f1$export$17bd0c38d6ae694e = "round";
const $d4aabc5c971073f1$export$e21b4112fdc612fc = [];
const $d4aabc5c971073f1$export$e06efc2409049f76 = 0;
const $d4aabc5c971073f1$export$365eb9648cf19bd0 = "round";
const $d4aabc5c971073f1$export$80c1c01844597b7b = 10;
const $d4aabc5c971073f1$export$1eb2eaecacf2031e = "#000";
const $d4aabc5c971073f1$export$94d53b95641b5766 = "center";
const $d4aabc5c971073f1$export$cf2279a1bff62eb = "middle";
const $d4aabc5c971073f1$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
const $d4aabc5c971073f1$export$79661f132c62010e = 1;
const $d4aabc5c971073f1$export$1d36981fcadac93b = new (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039)();
/**
 * @type {CanvasRenderingContext2D}
 */ let $d4aabc5c971073f1$var$measureContext = null;
/**
 * @type {string}
 */ let $d4aabc5c971073f1$var$measureFont;
const $d4aabc5c971073f1$export$7fdcec604f0b1fa7 = {};
const $d4aabc5c971073f1$export$a534074a28fa87ff = function() {
    const retries = 100;
    const size = "32px ";
    const referenceFonts = [
        "monospace",
        "serif"
    ];
    const len = referenceFonts.length;
    const text = "wmytzilWMYTZIL@#/&?$%10\uF013";
    let interval, referenceWidth;
    /**
   * @param {string} fontStyle Css font-style
   * @param {string} fontWeight Css font-weight
   * @param {*} fontFamily Css font-family
   * @return {boolean} Font with style and weight is available
   */ function isAvailable(fontStyle, fontWeight, fontFamily) {
        let available = true;
        for(let i = 0; i < len; ++i){
            const referenceFont = referenceFonts[i];
            referenceWidth = $d4aabc5c971073f1$export$4ea92329b673abd1(fontStyle + " " + fontWeight + " " + size + referenceFont, text);
            if (fontFamily != referenceFont) {
                const width = $d4aabc5c971073f1$export$4ea92329b673abd1(fontStyle + " " + fontWeight + " " + size + fontFamily + "," + referenceFont, text);
                // If width and referenceWidth are the same, then the fallback was used
                // instead of the font we wanted, so the font is not available.
                available = available && width != referenceWidth;
            }
        }
        if (available) return true;
        return false;
    }
    function check() {
        let done = true;
        const fonts = $d4aabc5c971073f1$export$1d36981fcadac93b.getKeys();
        for(let i = 0, ii = fonts.length; i < ii; ++i){
            const font = fonts[i];
            if ($d4aabc5c971073f1$export$1d36981fcadac93b.get(font) < retries) {
                if (isAvailable.apply(this, font.split("\n"))) {
                    (0, $beaefe87199bb537$export$42ffd38884aecdac)($d4aabc5c971073f1$export$7fdcec604f0b1fa7);
                    // Make sure that loaded fonts are picked up by Safari
                    $d4aabc5c971073f1$var$measureContext = null;
                    $d4aabc5c971073f1$var$measureFont = undefined;
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, retries);
                } else {
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, $d4aabc5c971073f1$export$1d36981fcadac93b.get(font) + 1, true);
                    done = false;
                }
            }
        }
        if (done) {
            clearInterval(interval);
            interval = undefined;
        }
    }
    return function(fontSpec) {
        const font = (0, $ce07df6d5d4656f1$export$5abde8a6aec4a131)(fontSpec);
        if (!font) return;
        const families = font.families;
        for(let i = 0, ii = families.length; i < ii; ++i){
            const family = families[i];
            const key = font.style + "\n" + font.weight + "\n" + family;
            if ($d4aabc5c971073f1$export$1d36981fcadac93b.get(key) === undefined) {
                $d4aabc5c971073f1$export$1d36981fcadac93b.set(key, retries, true);
                if (!isAvailable(font.style, font.weight, family)) {
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(key, 0, true);
                    if (interval === undefined) interval = setInterval(check, 32);
                }
            }
        }
    };
}();
const $d4aabc5c971073f1$export$4feaf6852ff92513 = function() {
    /**
   * @type {HTMLDivElement}
   */ let measureElement;
    return function(fontSpec) {
        let height = $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $67c66761d21428d0$export$98fcef3dc9973292) {
                const font = (0, $ce07df6d5d4656f1$export$5abde8a6aec4a131)(fontSpec);
                const metrics = $d4aabc5c971073f1$var$measureText(fontSpec, "\u017Dg");
                const lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement("div");
                    measureElement.innerHTML = "M";
                    measureElement.style.minHeight = "0";
                    measureElement.style.maxHeight = "none";
                    measureElement.style.height = "auto";
                    measureElement.style.padding = "0";
                    measureElement.style.border = "none";
                    measureElement.style.position = "absolute";
                    measureElement.style.display = "block";
                    measureElement.style.left = "-99999px";
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $d4aabc5c971073f1$var$measureText(font, text) {
    if (!$d4aabc5c971073f1$var$measureContext) $d4aabc5c971073f1$var$measureContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1);
    if (font != $d4aabc5c971073f1$var$measureFont) {
        $d4aabc5c971073f1$var$measureContext.font = font;
        $d4aabc5c971073f1$var$measureFont = $d4aabc5c971073f1$var$measureContext.font;
    }
    return $d4aabc5c971073f1$var$measureContext.measureText(text);
}
function $d4aabc5c971073f1$export$4ea92329b673abd1(font, text) {
    return $d4aabc5c971073f1$var$measureText(font, text).width;
}
function $d4aabc5c971073f1$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    const width = text.split("\n").reduce((prev, curr)=>Math.max(prev, $d4aabc5c971073f1$export$4ea92329b673abd1(font, curr)), 0);
    cache[text] = width;
    return width;
}
function $d4aabc5c971073f1$export$7d7c13020df1e791(baseStyle, chunks) {
    const widths = [];
    const heights = [];
    const lineWidths = [];
    let width = 0;
    let lineWidth = 0;
    let height = 0;
    let lineHeight = 0;
    for(let i = 0, ii = chunks.length; i <= ii; i += 2){
        const text = chunks[i];
        if (text === "\n" || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            lineHeight = 0;
            continue;
        }
        const font = chunks[i + 1] || baseStyle.font;
        const currentWidth = $d4aabc5c971073f1$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        const currentHeight = $d4aabc5c971073f1$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $d4aabc5c971073f1$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        if (context.globalAlpha === undefined) context.globalAlpha = (context)=>context.globalAlpha *= opacity;
        else context.globalAlpha *= opacity;
    }
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $d4aabc5c971073f1$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */ function $d4aabc5c971073f1$var$executeLabelInstructions(label, context) {
    const contextInstructions = label.contextInstructions;
    for(let i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}


/**
 * Specify radius for regular polygons, or both radius and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} radius Radius of a regular polygon.
 * @property {number} [radius2] Second radius to make a star instead of a regular polygon.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius` and `radius2`.
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when both `radius` and
 * `radius2` are provided.
 * @api
 */ class $3e99c452138b2224$var$RegularShape extends (0, $e60011aea38e6239$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            opacity: 1,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ this.canvases_;
        /**
     * @private
     * @type {HTMLCanvasElement|null}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius_ = options.radius;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ this.renderOptions_;
        this.imageState_ = this.fill_ && this.fill_.loading() ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING : (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        if (this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) this.ready().then(()=>this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED);
        this.render();
    }
    /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        const style = new $3e99c452138b2224$var$RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   */ getAnchor() {
        const size = this.size_;
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            size[0] / 2 - displacement[0] / scale[0],
            size[1] / 2 + displacement[1] / scale[1]
        ];
    }
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ getAngle() {
        return this.angle_;
    }
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
        this.render();
    }
    /**
   * @return {HTMLCanvasElement} Image element.
   */ getHitDetectionImage() {
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement} Image or Canvas element.
   * @api
   */ getImage(pixelRatio) {
        let image = this.canvases_[pixelRatio];
        if (!image) {
            const renderOptions = this.renderOptions_;
            const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(renderOptions.size * pixelRatio, renderOptions.size * pixelRatio);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            this.canvases_[pixelRatio] = image;
        }
        return image;
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return this.size_;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   */ getOrigin() {
        return this.origin_;
    }
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ getPoints() {
        return this.points_;
    }
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return this.radius_;
    }
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ getRadius2() {
        return this.radius2_;
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   */ getSize() {
        return this.size_;
    }
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
        this.render();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {}
    /**
   * Load not yet loaded URI.
   */ load() {}
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {}
    /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== "bevel" && lineJoin !== "miter") return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        let r1 = this.radius_;
        let r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            const tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        const points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        const alpha = 2 * Math.PI / points;
        const a = r2 * Math.sin(alpha);
        const b = Math.sqrt(r2 * r2 - a * a);
        const d = r1 - b;
        const e = Math.sqrt(a * a + d * d);
        const miterRatio = e / a;
        if (lineJoin === "miter" && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distance from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        const k = strokeWidth / 2 / miterRatio;
        const l = strokeWidth / 2 * (d / e);
        const maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        const bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === "bevel") return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        const aa = r1 * Math.sin(alpha);
        const bb = Math.sqrt(r1 * r1 - aa * aa);
        const dd = r2 - bb;
        const ee = Math.sqrt(aa * aa + dd * dd);
        const innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            const innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    }
    /**
   * @return {RenderOptions}  The render options
   * @protected
   */ createRenderOptions() {
        let lineCap = (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
        let lineJoin = (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
        let miterLimit = 0;
        let lineDash = null;
        let lineDashOffset = 0;
        let strokeStyle;
        let strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(this.stroke_.getColor() ?? (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            strokeWidth = this.stroke_.getWidth() ?? (0, $d4aabc5c971073f1$export$79661f132c62010e);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset() ?? 0;
            lineJoin = this.stroke_.getLineJoin() ?? (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
            lineCap = this.stroke_.getLineCap() ?? (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
            miterLimit = this.stroke_.getMiterLimit() ?? (0, $d4aabc5c971073f1$export$80c1c01844597b7b);
        }
        const add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        const maxRadius = Math.max(this.radius_, this.radius2_ || 0);
        const size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    }
    /**
   * @protected
   */ render() {
        this.renderOptions_ = this.createRenderOptions();
        const size = this.renderOptions_.size;
        this.canvases_ = {};
        this.hitDetectionCanvas_ = null;
        this.size_ = [
            size,
            size
        ];
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ draw_(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) color = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
            context.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(color);
            context.fill();
        }
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement} Canvas containing the icon
   */ createHitDetectionCanvas_(renderOptions) {
        let context;
        if (this.fill_) {
            let color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            let opacity = 0;
            if (typeof color === "string") color = (0, $322346e1ff7894ca$export$75093a47a9fa838d)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        return context ? context.canvas : this.getImage(1);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context The context to draw in.
   */ createPath_(context) {
        let points = this.points_;
        const radius = this.radius_;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            const radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            const startAngle = this.angle_ - Math.PI / 2;
            const step = 2 * Math.PI / points;
            for(let i = 0; i < points; i++){
                const angle0 = startAngle + i * step;
                const radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   */ drawHitDetectionCanvas_(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
        context.fill();
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    ready() {
        return this.fill_ ? this.fill_.ready() : Promise.resolve();
    }
}
var $3e99c452138b2224$export$2e2bcd8739ae039 = $3e99c452138b2224$var$RegularShape;


/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ class $06150d8570b7481b$var$CircleStyle extends (0, $3e99c452138b2224$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {
            radius: 5
        };
        super({
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        const style = new $06150d8570b7481b$var$CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Set the circle radius.
   *
   * @param {number} radius Circle radius.
   * @api
   */ setRadius(radius) {
        this.radius_ = radius;
        this.render();
    }
}
var $06150d8570b7481b$export$2e2bcd8739ae039 = $06150d8570b7481b$var$CircleStyle;


/**
 * @module ol/style/Fill
 */ 

/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} [color=null] A color,
 * gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats. For polygon fills (not for {@link import("./RegularShape.js").default} fills),
 * a pattern can also be provided as {@link module:ol/colorlike~PatternDescriptor}.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ class $d61d1dcaf3c44610$var$Fill {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("./IconImage.js").default|null}
     */ this.patternImage_ = null;
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null}
     */ this.color_ = null;
        if (options.color !== undefined) this.setColor(options.color);
    }
    /**
   * Clones the style. The color is not cloned if it is an {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $d61d1dcaf3c44610$var$Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    }
    /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */ setColor(color) {
        if (color !== null && typeof color === "object" && "src" in color) {
            const patternImage = (0, $0e5ad1d3b638689e$export$3988ae62b71be9a3)(null, color.src, "anonymous", undefined, color.offset ? null : color.color ? color.color : null, !(color.offset && color.size));
            patternImage.ready().then(()=>{
                this.patternImage_ = null;
            });
            if (patternImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) patternImage.load();
            if (patternImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) this.patternImage_ = patternImage;
        }
        this.color_ = color;
    }
    /**
   * @return {boolean} The fill style is loading an image pattern.
   */ loading() {
        return !!this.patternImage_;
    }
    /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */ ready() {
        return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
    }
}
var $d61d1dcaf3c44610$export$2e2bcd8739ae039 = $d61d1dcaf3c44610$var$Fill;


/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ class $f9d0329c5c745263$var$Stroke {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $f9d0329c5c745263$var$Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            width: this.getWidth()
        });
    }
    /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ getLineCap() {
        return this.lineCap_;
    }
    /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ getLineDash() {
        return this.lineDash_;
    }
    /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ getLineDashOffset() {
        return this.lineDashOffset_;
    }
    /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ getLineJoin() {
        return this.lineJoin_;
    }
    /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ getMiterLimit() {
        return this.miterLimit_;
    }
    /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ getWidth() {
        return this.width_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ setColor(color) {
        this.color_ = color;
    }
    /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ setLineCap(lineCap) {
        this.lineCap_ = lineCap;
    }
    /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ setLineDash(lineDash) {
        this.lineDash_ = lineDash;
    }
    /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ setLineDashOffset(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    }
    /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ setLineJoin(lineJoin) {
        this.lineJoin_ = lineJoin;
    }
    /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ setMiterLimit(miterLimit) {
        this.miterLimit_ = miterLimit;
    }
    /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ setWidth(width) {
        this.width_ = width;
    }
}
var $f9d0329c5c745263$export$2e2bcd8739ae039 = $f9d0329c5c745263$var$Stroke;



/**
 * Defines how symbols and text are decluttered on layers ith `declutter` set to `true`
 * * **declutter**: Overlapping symbols and text are decluttered.
 * * **obstacle**: Symbols and text are rendered, but serve as obstacle for subsequent attempts
 *   to place a symbol or text at the same location.
 * * **none**: No decluttering is done.
 *
 * @typedef {"declutter"|"obstacle"|"none"} DeclutterMode
 */ /**
 * A function that takes an {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes an {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ class $8c7f6dda98e8cb9c$var$Style {
    /**
   * @param {Options} [options] Style options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ clone() {
        let geometry = this.getGeometry();
        if (geometry && typeof geometry === "object") geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new $8c7f6dda98e8cb9c$var$Style({
            geometry: geometry ?? undefined,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer() ?? undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setRenderer(renderer) {
        this.renderer_ = renderer;
    }
    /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setHitDetectionRenderer(renderer) {
        this.hitDetectionRenderer_ = renderer;
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getHitDetectionRenderer() {
        return this.hitDetectionRenderer_;
    }
    /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ getGeometry() {
        return this.geometry_;
    }
    /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ getGeometryFunction() {
        return this.geometryFunction_;
    }
    /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ getZIndex() {
        return this.zIndex_;
    }
    /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ setGeometry(geometry) {
        if (typeof geometry === "function") this.geometryFunction_ = geometry;
        else if (typeof geometry === "string") this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    }
    /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ setZIndex(zIndex) {
        this.zIndex_ = zIndex;
    }
}
function $8c7f6dda98e8cb9c$export$c314ea3f6b164147(obj) {
    let styleFunction;
    if (typeof obj === "function") styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ let styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === "function", "Expected an `Style` or an array of `Style`");
            const style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ let $8c7f6dda98e8cb9c$var$defaultStyles = null;
function $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$8c7f6dda98e8cb9c$var$defaultStyles) {
        const fill = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255,255,255,0.4)"
        });
        const stroke = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: "#3399CC",
            width: 1.25
        });
        $8c7f6dda98e8cb9c$var$defaultStyles = [
            new $8c7f6dda98e8cb9c$var$Style({
                image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $8c7f6dda98e8cb9c$var$defaultStyles;
}
function $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ const styles = {};
    const white = [
        255,
        255,
        255,
        1
    ];
    const blue = [
        0,
        153,
        255,
        1
    ];
    const width = 3;
    styles["Polygon"] = [
        new $8c7f6dda98e8cb9c$var$Style({
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles["MultiPolygon"] = styles["Polygon"];
    styles["LineString"] = [
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles["MultiLineString"] = styles["LineString"];
    styles["Circle"] = styles["Polygon"].concat(styles["LineString"]);
    styles["Point"] = [
        new $8c7f6dda98e8cb9c$var$Style({
            image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles["MultiPoint"] = styles["Point"];
    styles["GeometryCollection"] = styles["Polygon"].concat(styles["LineString"], styles["Point"]);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $8c7f6dda98e8cb9c$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $8c7f6dda98e8cb9c$export$2e2bcd8739ae039 = $8c7f6dda98e8cb9c$var$Style;


/**
 * @module ol/render/canvas/style
 */ 

/**
 * @module ol/style/Icon
 */ 






/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {import("./Style.js").DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function $8463d325b53eeb0c$var$calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ class $8463d325b53eeb0c$var$Icon extends (0, $e60011aea38e6239$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @type {number}
     */ const opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ const rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ const scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : "top-left";
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : "fraction";
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : "fraction";
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        const image = options.img !== undefined ? options.img : null;
        let cacheKey = options.src;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(cacheKey !== undefined && image), "`image` and `src` cannot be provided at the same time");
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, $6c5e11070e371322$export$5e82334337e0f204)(image);
        (0, $35d5ec884318008e$export$a7a9523472993e97)(cacheKey !== undefined && cacheKey.length > 0, "A defined and non-empty `src` or `image` must be provided");
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), "`width` or `height` cannot be provided together with `scale`");
        let imageState;
        if (options.src !== undefined) imageState = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE;
        else if (image !== undefined) {
            if ("complete" in image) {
                if (image.complete) imageState = image.src ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED : (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE;
                else imageState = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
            } else imageState = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, $322346e1ff7894ca$export$75093a47a9fa838d)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, $0e5ad1d3b638689e$export$3988ae62b71be9a3)(image, /** @type {string} */ cacheKey, this.crossOrigin_, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : "top-left";
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            let width, height;
            if (options.size) [width, height] = options.size;
            else {
                const image = this.getImage(1);
                if (image.width && image.height) {
                    width = image.width;
                    height = image.height;
                } else if (image instanceof HTMLImageElement) {
                    this.initialOptions_ = options;
                    const onload = ()=>{
                        this.unlistenImageChange(onload);
                        if (!this.initialOptions_) return;
                        const imageSize = this.iconImage_.getSize();
                        this.setScale($8463d325b53eeb0c$var$calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    this.listenImageChange(onload);
                    return;
                }
            }
            if (width !== undefined) this.setScale($8463d325b53eeb0c$var$calculateScale(width, height, options.width, options.height));
        }
    }
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   */ clone() {
        let scale, width, height;
        if (this.initialOptions_) {
            width = this.initialOptions_.width;
            height = this.initialOptions_.height;
        } else {
            scale = this.getScale();
            scale = Array.isArray(scale) ? scale.slice() : scale;
        }
        return new $8463d325b53eeb0c$var$Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale: scale,
            width: width,
            height: height,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   */ getAnchor() {
        let anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            const size = this.getSize();
            if (this.anchorXUnits_ == "fraction" || this.anchorYUnits_ == "fraction") {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == "fraction") anchor[0] *= size[0];
                if (this.anchorYUnits_ == "fraction") anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != "top-left") {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == "top-right" || this.anchorOrigin_ == "bottom-right") anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == "bottom-left" || this.anchorOrigin_ == "bottom-right") anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            anchor[0] - displacement[0] / scale[0],
            anchor[1] + displacement[1] / scale[1]
        ];
    }
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    }
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   */ getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    }
    /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   */ getPixelRatio(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    }
    /**
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return this.iconImage_.getSize();
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.iconImage_.getImageState();
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        return this.iconImage_.getHitDetectionImage();
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   */ getOrigin() {
        if (this.origin_) return this.origin_;
        let offset = this.offset_;
        if (this.offsetOrigin_ != "top-left") {
            const size = this.getSize();
            const iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == "top-right" || this.offsetOrigin_ == "bottom-right") offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == "bottom-left" || this.offsetOrigin_ == "bottom-right") offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    }
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ getSrc() {
        return this.iconImage_.getSrc();
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   */ getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    }
    /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ getWidth() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[0] * scale[0];
        if (this.iconImage_.getImageState() == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[0] * scale[0];
        return undefined;
    }
    /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ getHeight() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[1] * scale[1];
        if (this.iconImage_.getImageState() == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[1] * scale[1];
        return undefined;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        delete this.initialOptions_;
        super.setScale(scale);
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        this.iconImage_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   */ load() {
        this.iconImage_.load();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        this.iconImage_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, listener);
    }
    ready() {
        return this.iconImage_.ready();
    }
}
var $8463d325b53eeb0c$export$2e2bcd8739ae039 = $8463d325b53eeb0c$var$Icon;





/**
 * @module ol/style/Text
 */ 

/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ const $944be50faeff5321$var$DEFAULT_FILL_COLOR = "#333";
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 * @property {import('../style/Style.js').DeclutterMode} [declutterMode] Declutter mode: `declutter`, `obstacle`, `none`
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ class $944be50faeff5321$var$Text {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: $944be50faeff5321$var$DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : "point";
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $944be50faeff5321$var$Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            repeat: this.getRepeat(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined,
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ getOverflow() {
        return this.overflow_;
    }
    /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ getFont() {
        return this.font_;
    }
    /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ getMaxAngle() {
        return this.maxAngle_;
    }
    /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ getPlacement() {
        return this.placement_;
    }
    /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ getRepeat() {
        return this.repeat_;
    }
    /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ getOffsetX() {
        return this.offsetX_;
    }
    /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ getOffsetY() {
        return this.offsetY_;
    }
    /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ getTextAlign() {
        return this.textAlign_;
    }
    /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ getJustify() {
        return this.justify_;
    }
    /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ getTextBaseline() {
        return this.textBaseline_;
    }
    /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getBackgroundFill() {
        return this.backgroundFill_;
    }
    /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getBackgroundStroke() {
        return this.backgroundStroke_;
    }
    /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ getPadding() {
        return this.padding_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ setOverflow(overflow) {
        this.overflow_ = overflow;
    }
    /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ setFont(font) {
        this.font_ = font;
    }
    /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ setMaxAngle(maxAngle) {
        this.maxAngle_ = maxAngle;
    }
    /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ setOffsetX(offsetX) {
        this.offsetX_ = offsetX;
    }
    /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ setOffsetY(offsetY) {
        this.offsetY_ = offsetY;
    }
    /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ setPlacement(placement) {
        this.placement_ = placement;
    }
    /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ setRepeat(repeat) {
        this.repeat_ = repeat;
    }
    /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(scale !== undefined ? scale : 1);
    }
    /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ setTextAlign(textAlign) {
        this.textAlign_ = textAlign;
    }
    /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ setJustify(justify) {
        this.justify_ = justify;
    }
    /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ setTextBaseline(textBaseline) {
        this.textBaseline_ = textBaseline;
    }
    /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setBackgroundFill(fill) {
        this.backgroundFill_ = fill;
    }
    /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setBackgroundStroke(stroke) {
        this.backgroundStroke_ = stroke;
    }
    /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ setPadding(padding) {
        this.padding_ = padding;
    }
}
var $944be50faeff5321$export$2e2bcd8739ae039 = $944be50faeff5321$var$Text;


/**
 * @module ol/expr/expression
 */ 

/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * See below for details on the available operators (with notes for those that are WebGL or Canvas only).
 *
 * * Reading operators:
 *   * `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels (WebGL only).
 *   * `['get', 'attributeName', typeHint]` fetches a feature property value, similar to `feature.get('attributeName')`
 *     A type hint can optionally be specified, in case the resulting expression contains a type ambiguity which
 *     will make it invalid. Type hints can be one of: 'string', 'color', 'number', 'boolean', 'number[]'
 *   * `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection (WebGL only).
 *   * `['resolution']` returns the current resolution
 *   * `['time']` The time in seconds since the creation of the layer (WebGL only).
 *   * `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   * `['zoom']` The current zoom level (WebGL only).
 *
 * * Math operators:
 *   * `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   * `['/', value1, value2]` divides `value1` by `value2`
 *   * `['+', value1, value2, ...]` adds the values
 *   * `['-', value1, value2]` subtracts `value2` from `value1`
 *   * `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   * `['abs', value1]` returns the absolute value of `value1`
 *   * `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *   * `['string', value1, value2, ...]` returns the first value in the list that evaluates to a string.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 'default value']]`
 *     (Canvas only).
 *   * `['number', value1, value2, ...]` returns the first value in the list that evaluates to a number.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 42]]`
 *     (Canvas only).
 *   * `['coalesce', value1, value2, ...]` returns the first value in the list which is not null or undefined.
 *     An example would be to provide a default value for get: `['coalesce', ['get','propertyname'], 'default value']]`
 *     (Canvas only).
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4 (WebGL only).
 *   * `['color', red, green, blue, alpha]` or `['color', shade, alpha]` creates a `color` value from `number` values;
 *     the `alpha` parameter is optional; if not specified, it will be set to 1 (WebGL only).
 *     Note: `red`, `green` and `blue` or `shade` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range) (WebGL only).
 *   * `['to-string', value]` converts the input value to a string. If the input is a boolean, the result is "true" or "false".
 *     If the input is a number, it is converted to a string as specified by the "NumberToString" algorithm of the ECMAScript
 *     Language Specification. If the input is a color, it is converted to a string of the form "rgba(r,g,b,a)". (Canvas only)
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ let $778943ec39690f8e$var$numTypes = 0;
const $778943ec39690f8e$export$267d7ad6fa96ffaf = 0;
const $778943ec39690f8e$export$240f7fffab1b25a0 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$86a7aca748b1e260 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$2b93044cbf134323 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$2cd82751acc0e609 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$d701d0e49f4bcb39 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$52725c8a6d4c61d1 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$ec4c9a150bae86cd = Math.pow(2, $778943ec39690f8e$var$numTypes) - 1;
const $778943ec39690f8e$var$typeNames = {
    [$778943ec39690f8e$export$240f7fffab1b25a0]: "boolean",
    [$778943ec39690f8e$export$86a7aca748b1e260]: "number",
    [$778943ec39690f8e$export$2b93044cbf134323]: "string",
    [$778943ec39690f8e$export$2cd82751acc0e609]: "color",
    [$778943ec39690f8e$export$d701d0e49f4bcb39]: "number[]",
    [$778943ec39690f8e$export$52725c8a6d4c61d1]: "size"
};
const $778943ec39690f8e$var$namedTypes = Object.keys($778943ec39690f8e$var$typeNames).map(Number).sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
function $778943ec39690f8e$export$b2afc7c96b2b4a45(type) {
    const names = [];
    for (const namedType of $778943ec39690f8e$var$namedTypes)if ($778943ec39690f8e$export$9fdcb8b441c4f2b4(type, namedType)) names.push($778943ec39690f8e$var$typeNames[namedType]);
    if (names.length === 0) return "untyped";
    if (names.length < 3) return names.join(" or ");
    return names.slice(0, -1).join(", ") + ", or " + names[names.length - 1];
}
function $778943ec39690f8e$export$9fdcb8b441c4f2b4(broad, specific) {
    return (broad & specific) === specific;
}
function $778943ec39690f8e$export$3252d368d784c970(oneType, otherType) {
    return !!(oneType & otherType);
}
function $778943ec39690f8e$export$26b9f946b448f23e(type, expected) {
    return type === expected;
}
class $778943ec39690f8e$export$eb63e96e0913dda4 {
    /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */ constructor(type, value){
        this.type = type;
        this.value = value;
    }
}
class $778943ec39690f8e$export$6f3d80189eb72cd4 {
    /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */ constructor(type, operator, ...args){
        this.type = type;
        this.operator = operator;
        this.args = args;
    }
}
function $778943ec39690f8e$export$1c8b4c1584800354() {
    return {
        variables: new Set(),
        properties: new Set(),
        featureId: false,
        geometryType: false,
        style: {}
    };
}
/**
 * @param {string} typeHint Type hint
 * @return {number} Resulting value type (will be a single type)
 */ function $778943ec39690f8e$var$getTypeFromHint(typeHint) {
    switch(typeHint){
        case "string":
            return $778943ec39690f8e$export$2b93044cbf134323;
        case "color":
            return $778943ec39690f8e$export$2cd82751acc0e609;
        case "number":
            return $778943ec39690f8e$export$86a7aca748b1e260;
        case "boolean":
            return $778943ec39690f8e$export$240f7fffab1b25a0;
        case "number[]":
            return $778943ec39690f8e$export$d701d0e49f4bcb39;
        default:
            throw new Error(`Unrecognized type hint: ${typeHint}`);
    }
}
function $778943ec39690f8e$export$98e6a39c04603d36(encoded, context, typeHint) {
    switch(typeof encoded){
        case "boolean":
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, encoded);
        case "number":
            return new $778943ec39690f8e$export$eb63e96e0913dda4(typeHint === $778943ec39690f8e$export$52725c8a6d4c61d1 ? $778943ec39690f8e$export$52725c8a6d4c61d1 : $778943ec39690f8e$export$86a7aca748b1e260, encoded);
        case "string":
            {
                let type = $778943ec39690f8e$export$2b93044cbf134323;
                if ((0, $322346e1ff7894ca$export$40dd713d7775a0b1)(encoded)) type |= $778943ec39690f8e$export$2cd82751acc0e609;
                // apply the given type hint only if it won't result in an empty type
                if (!$778943ec39690f8e$export$26b9f946b448f23e(type & typeHint, $778943ec39690f8e$export$267d7ad6fa96ffaf)) type &= typeHint;
                return new $778943ec39690f8e$export$eb63e96e0913dda4(type, encoded);
            }
        default:
    }
    if (!Array.isArray(encoded)) throw new Error("Expression must be an array or a primitive value");
    if (encoded.length === 0) throw new Error("Empty expression");
    if (typeof encoded[0] === "string") return $778943ec39690f8e$var$parseCallExpression(encoded, context, typeHint);
    for (const item of encoded){
        if (typeof item !== "number") throw new Error("Expected an array of numbers");
    }
    let type = $778943ec39690f8e$export$d701d0e49f4bcb39;
    if (encoded.length === 2) type |= $778943ec39690f8e$export$52725c8a6d4c61d1;
    else if (encoded.length === 3 || encoded.length === 4) type |= $778943ec39690f8e$export$2cd82751acc0e609;
    if (typeHint) type &= typeHint;
    return new $778943ec39690f8e$export$eb63e96e0913dda4(type, encoded);
}
const $778943ec39690f8e$export$2655e45458bc48f3 = {
    Get: "get",
    Var: "var",
    Concat: "concat",
    GeometryType: "geometry-type",
    Any: "any",
    All: "all",
    Not: "!",
    Resolution: "resolution",
    Zoom: "zoom",
    Time: "time",
    Equal: "==",
    NotEqual: "!=",
    GreaterThan: ">",
    GreaterThanOrEqualTo: ">=",
    LessThan: "<",
    LessThanOrEqualTo: "<=",
    Multiply: "*",
    Divide: "/",
    Add: "+",
    Subtract: "-",
    Clamp: "clamp",
    Mod: "%",
    Pow: "^",
    Abs: "abs",
    Floor: "floor",
    Ceil: "ceil",
    Round: "round",
    Sin: "sin",
    Cos: "cos",
    Atan: "atan",
    Sqrt: "sqrt",
    Match: "match",
    Between: "between",
    Interpolate: "interpolate",
    Coalesce: "coalesce",
    Case: "case",
    In: "in",
    Number: "number",
    String: "string",
    Array: "array",
    Color: "color",
    Id: "id",
    Band: "band",
    Palette: "palette",
    ToString: "to-string"
};
/**
 * @typedef {function(Array, ParsingContext, number):Expression} Parser
 * Third argument is a type hint
 */ /**
 * @type {Object<string, Parser>}
 */ const $778943ec39690f8e$var$parsers = {
    [$778943ec39690f8e$export$2655e45458bc48f3.Get]: $778943ec39690f8e$var$createParser(([_, typeHint])=>{
        if (typeHint !== undefined) return $778943ec39690f8e$var$getTypeFromHint(/** @type {string} */ /** @type {LiteralExpression} */ typeHint.value);
        return $778943ec39690f8e$export$ec4c9a150bae86cd;
    }, $778943ec39690f8e$var$withArgsCount(1, 2), $778943ec39690f8e$var$withGetArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Var]: $778943ec39690f8e$var$createParser(([firstArg])=>firstArg.type, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$withVarArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Id]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2b93044cbf134323, $778943ec39690f8e$var$withNoArgs, $778943ec39690f8e$var$usesFeatureId),
    [$778943ec39690f8e$export$2655e45458bc48f3.Concat]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2b93044cbf134323, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GeometryType]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2b93044cbf134323, $778943ec39690f8e$var$withNoArgs, $778943ec39690f8e$var$usesGeometryType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Resolution]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Zoom]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Time]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Any]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.All]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Not]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Equal]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.NotEqual]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.GreaterThan]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.GreaterThanOrEqualTo]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.LessThan]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.LessThanOrEqualTo]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Multiply]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        let outputType = $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2cd82751acc0e609;
        for(let i = 0; i < parsedArgs.length; i++)outputType &= parsedArgs[i].type;
        return outputType;
    }, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2cd82751acc0e609), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Coalesce]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        let type = $778943ec39690f8e$export$ec4c9a150bae86cd;
        for(let i = 1; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
        type &= parsedArgs[parsedArgs.length - 1].type;
        return type;
    }, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd), $778943ec39690f8e$var$narrowArgsType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Divide]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Add]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(2, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Subtract]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Clamp]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(3, 3), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Mod]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Pow]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Abs]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Floor]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Ceil]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Round]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Sin]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Cos]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Atan]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 2), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Sqrt]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Match]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        let type = $778943ec39690f8e$export$ec4c9a150bae86cd;
        for(let i = 2; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
        type &= parsedArgs[parsedArgs.length - 1].type;
        return type;
    }, $778943ec39690f8e$var$withArgsCount(4, Infinity), $778943ec39690f8e$var$withEvenArgs, $778943ec39690f8e$var$parseMatchArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Between]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(3, 3), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Interpolate]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        let type = $778943ec39690f8e$export$2cd82751acc0e609 | $778943ec39690f8e$export$86a7aca748b1e260;
        for(let i = 3; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
        return type;
    }, $778943ec39690f8e$var$withArgsCount(6, Infinity), $778943ec39690f8e$var$withEvenArgs, $778943ec39690f8e$var$parseInterpolateArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Case]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        let type = $778943ec39690f8e$export$ec4c9a150bae86cd;
        for(let i = 1; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
        type &= parsedArgs[parsedArgs.length - 1].type;
        return type;
    }, $778943ec39690f8e$var$withArgsCount(3, Infinity), $778943ec39690f8e$var$withOddArgs, $778943ec39690f8e$var$parseCaseArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.In]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$240f7fffab1b25a0, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parseInArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Number]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.String]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2b93044cbf134323, $778943ec39690f8e$var$withArgsCount(1, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Array]: $778943ec39690f8e$var$createParser((parsedArgs)=>{
        return parsedArgs.length === 2 ? $778943ec39690f8e$export$d701d0e49f4bcb39 | $778943ec39690f8e$export$52725c8a6d4c61d1 : parsedArgs.length === 3 || parsedArgs.length === 4 ? $778943ec39690f8e$export$d701d0e49f4bcb39 | $778943ec39690f8e$export$2cd82751acc0e609 : $778943ec39690f8e$export$d701d0e49f4bcb39;
    }, $778943ec39690f8e$var$withArgsCount(1, Infinity), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Color]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2cd82751acc0e609, $778943ec39690f8e$var$withArgsCount(1, 4), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Band]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$86a7aca748b1e260, $778943ec39690f8e$var$withArgsCount(1, 3), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Palette]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2cd82751acc0e609, $778943ec39690f8e$var$withArgsCount(2, 2), $778943ec39690f8e$var$parsePaletteArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.ToString]: $778943ec39690f8e$var$createParser($778943ec39690f8e$export$2b93044cbf134323, $778943ec39690f8e$var$withArgsCount(1, 1), $778943ec39690f8e$var$parseArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0 | $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$2cd82751acc0e609))
};
/**
 * @typedef {function(Array<EncodedExpression>, ParsingContext, Array<Expression>, number?):Array<Expression>|void} ArgValidator
 * An argument validator applies various checks to an encoded expression arguments
 * Returns the parsed arguments if any.
 * Third argument is the array of parsed arguments from previous validators
 * Fourth argument is an optional type hint
 */ /**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withGetArgs(encoded, context) {
    const arg = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], context);
    if (!(arg instanceof $778943ec39690f8e$export$eb63e96e0913dda4)) throw new Error("Expected a literal argument for get operation");
    if (typeof arg.value !== "string") throw new Error("Expected a string argument for get operation");
    context.properties.add(arg.value);
    if (encoded.length === 3) {
        const hint = $778943ec39690f8e$export$98e6a39c04603d36(encoded[2], context);
        return [
            arg,
            hint
        ];
    }
    return [
        arg
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withVarArgs(encoded, context, parsedArgs, typeHint) {
    const varName = encoded[1];
    if (typeof varName !== "string") throw new Error("Expected a string argument for var operation");
    context.variables.add(varName);
    if (!("variables" in context.style) || context.style.variables[varName] === undefined) return [
        new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$ec4c9a150bae86cd, varName)
    ];
    const initialValue = context.style.variables[varName];
    const arg = /** @type {LiteralExpression} */ $778943ec39690f8e$export$98e6a39c04603d36(initialValue, context);
    arg.value = varName;
    if (typeHint && !$778943ec39690f8e$export$3252d368d784c970(typeHint, arg.type)) throw new Error(`The variable ${varName} has type ${$778943ec39690f8e$export$b2afc7c96b2b4a45(arg.type)} but the following type was expected: ${$778943ec39690f8e$export$b2afc7c96b2b4a45(typeHint)}`);
    return [
        arg
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$usesFeatureId(encoded, context) {
    context.featureId = true;
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$usesGeometryType(encoded, context) {
    context.geometryType = true;
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withNoArgs(encoded, context) {
    const operation = encoded[0];
    if (encoded.length !== 1) throw new Error(`Expected no arguments for ${operation} operation`);
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function $778943ec39690f8e$var$withArgsCount(minArgs, maxArgs) {
    return function(encoded, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                const plural = minArgs === 1 ? "" : "s";
                throw new Error(`Expected ${minArgs} argument${plural} for ${operation}, got ${argCount}`);
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            const range = maxArgs === Infinity ? `${minArgs} or more` : `${minArgs} to ${maxArgs}`;
            throw new Error(`Expected ${range} arguments for ${operation}, got ${argCount}`);
        }
    };
}
/**
 * @param {number} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function $778943ec39690f8e$var$parseArgsOfType(argType) {
    return function(encoded, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        for(let i = 0; i < argCount; ++i){
            const expression = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], context);
            if (!$778943ec39690f8e$export$3252d368d784c970(argType, expression.type)) {
                const gotType = $778943ec39690f8e$export$b2afc7c96b2b4a45(argType);
                const expectedType = $778943ec39690f8e$export$b2afc7c96b2b4a45(expression.type);
                throw new Error(`Unexpected type for argument ${i} of ${operation} operation` + `, got ${gotType} but expected ${expectedType}`);
            }
            expression.type &= argType;
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$narrowArgsType(encoded, context, parsedArgs) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    // first pass to determine a narrowed down type
    let sameType = $778943ec39690f8e$export$ec4c9a150bae86cd;
    for(let i = 0; i < parsedArgs.length; ++i)sameType &= parsedArgs[i].type;
    if (sameType === $778943ec39690f8e$export$267d7ad6fa96ffaf) throw new Error(`No common type could be found for arguments of ${operation} operation`);
    // re-parse args
    const args = new Array(argCount);
    for(let i = 0; i < argCount; ++i)args[i] = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], context, sameType);
    return args;
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withOddArgs(encoded, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error(`An odd amount of arguments was expected for operation ${operation}, got ${JSON.stringify(argCount)} instead`);
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withEvenArgs(encoded, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error(`An even amount of arguments was expected for operation ${operation}, got ${JSON.stringify(argCount)} instead`);
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$parseMatchArgs(encoded, context, parsedArgs, typeHint) {
    const argsCount = encoded.length - 1;
    const input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], context);
    let inputType = input.type;
    const fallback = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], context);
    let outputType = typeHint !== undefined ? typeHint & fallback.type : fallback.type;
    // first parse args to figure out possible types
    const args = new Array(argsCount - 2);
    for(let i = 0; i < argsCount - 2; i += 2){
        const match = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], context);
        const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], context);
        inputType &= match.type;
        outputType &= output.type;
        args[i] = match;
        args[i + 1] = output;
    }
    // check input and output types validity
    const expectedInputType = $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$240f7fffab1b25a0;
    if (!$778943ec39690f8e$export$3252d368d784c970(expectedInputType, inputType)) throw new Error(`Expected an input of type ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedInputType)} for the interpolate operation` + `, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(inputType)} instead`);
    inputType &= expectedInputType;
    if ($778943ec39690f8e$export$26b9f946b448f23e(outputType, $778943ec39690f8e$export$267d7ad6fa96ffaf)) throw new Error(`Could not find a common output type for the following match operation: ` + JSON.stringify(encoded));
    // parse again inputs and outputs with common type
    for(let i = 0; i < argsCount - 2; i += 2){
        const match = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], context, inputType);
        const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], context, outputType);
        args[i] = match;
        args[i + 1] = output;
    }
    return [
        $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], context, inputType),
        ...args,
        $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], context, outputType)
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$parseInterpolateArgs(encoded, context, parsedArgs, typeHint) {
    const interpolationType = encoded[1];
    let interpolation;
    switch(interpolationType[0]){
        case "linear":
            interpolation = 1;
            break;
        case "exponential":
            interpolation = interpolationType[1];
            if (typeof interpolation !== "number") throw new Error(`Expected a number base for exponential interpolation` + `, got ${JSON.stringify(interpolation)} instead`);
            break;
        default:
            interpolation = null;
    }
    if (!interpolation) throw new Error(`Invalid interpolation type: ${JSON.stringify(interpolationType)}`);
    interpolation = $778943ec39690f8e$export$98e6a39c04603d36(interpolation, context);
    // check input types
    let input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[2], context);
    if (!$778943ec39690f8e$export$3252d368d784c970($778943ec39690f8e$export$86a7aca748b1e260, input.type)) throw new Error(`Expected an input of type number for the interpolate operation` + `, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(input.type)} instead`);
    input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[2], context, $778943ec39690f8e$export$86a7aca748b1e260); // parse again with narrower output
    const args = new Array(encoded.length - 3);
    for(let i = 0; i < args.length; i += 2){
        let stop = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], context);
        if (!$778943ec39690f8e$export$3252d368d784c970($778943ec39690f8e$export$86a7aca748b1e260, stop.type)) throw new Error(`Expected all stop input values in the interpolate operation to be of type number` + `, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(stop.type)} at position ${i + 2} instead`);
        let output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 4], context);
        if (!$778943ec39690f8e$export$3252d368d784c970($778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2cd82751acc0e609, output.type)) throw new Error(`Expected all stop output values in the interpolate operation to be a number or color` + `, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(output.type)} at position ${i + 3} instead`);
        // parse again with narrower types
        stop = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], context, $778943ec39690f8e$export$86a7aca748b1e260);
        output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 4], context, $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2cd82751acc0e609);
        args[i] = stop;
        args[i + 1] = output;
    }
    return [
        interpolation,
        input,
        ...args
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$parseCaseArgs(encoded, context, parsedArgs, typeHint) {
    const fallback = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], context, typeHint);
    let outputType = typeHint !== undefined ? typeHint & fallback.type : fallback.type;
    // first parse args to figure out possible types
    const args = new Array(encoded.length - 1);
    for(let i = 0; i < args.length - 1; i += 2){
        const condition = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], context);
        const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], context, typeHint);
        if (!$778943ec39690f8e$export$3252d368d784c970($778943ec39690f8e$export$240f7fffab1b25a0, condition.type)) throw new Error(`Expected all conditions in the case operation to be of type boolean` + `, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(condition.type)} at position ${i} instead`);
        outputType &= output.type;
        args[i] = condition;
        args[i + 1] = output;
    }
    if ($778943ec39690f8e$export$26b9f946b448f23e(outputType, $778943ec39690f8e$export$267d7ad6fa96ffaf)) throw new Error(`Could not find a common output type for the following case operation: ` + JSON.stringify(encoded));
    // parse again args with common output type
    for(let i = 0; i < args.length - 1; i += 2)args[i + 1] = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], context, outputType);
    args[args.length - 1] = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], context, outputType);
    return args;
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$parseInArgs(encoded, context) {
    /** @type {Array<number|string>} */ let haystack = /** @type {any} */ encoded[2];
    if (!Array.isArray(haystack)) throw new Error(`The "in" operator was provided a literal value which was not an array as second argument.`);
    if (typeof haystack[0] === "string") {
        if (haystack[0] !== "literal") throw new Error(`For the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions.`);
        if (!Array.isArray(haystack[1])) throw new Error(`The "in" operator was provided a literal value which was not an array as second argument.`);
        haystack = haystack[1];
    }
    let needleType = $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$86a7aca748b1e260;
    const args = new Array(haystack.length);
    for(let i = 0; i < args.length; i++){
        const arg = $778943ec39690f8e$export$98e6a39c04603d36(haystack[i], context);
        needleType &= arg.type;
        args[i] = arg;
    }
    if ($778943ec39690f8e$export$26b9f946b448f23e(needleType, $778943ec39690f8e$export$267d7ad6fa96ffaf)) throw new Error(`Could not find a common type for the following in operation: ` + JSON.stringify(encoded));
    const needle = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], context, needleType);
    return [
        needle,
        ...args
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$parsePaletteArgs(encoded, context) {
    const index = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], context, $778943ec39690f8e$export$86a7aca748b1e260);
    if (index.type !== $778943ec39690f8e$export$86a7aca748b1e260) throw new Error(`The first argument of palette must be an number, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(index.type)} instead`);
    const colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error("The second argument of palette must be an array");
    const parsedColors = new Array(colors.length);
    for(let i = 0; i < parsedColors.length; i++){
        const color = $778943ec39690f8e$export$98e6a39c04603d36(colors[i], context, $778943ec39690f8e$export$2cd82751acc0e609);
        if (!(color instanceof $778943ec39690f8e$export$eb63e96e0913dda4)) throw new Error(`The palette color at index ${i} must be a literal value`);
        if (!$778943ec39690f8e$export$3252d368d784c970(color.type, $778943ec39690f8e$export$2cd82751acc0e609)) throw new Error(`The palette color at index ${i} should be of type color, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(color.type)} instead`);
        parsedColors[i] = color;
    }
    return [
        index,
        ...parsedColors
    ];
}
/**
 * @param {number|function(Array<Expression>):number} returnType The return type of the operator; can be a fixed value or a callback taking the parsed
 * arguments
 * @param {Array<ArgValidator>} argValidators A chain of argument validators; the return value of the last validator
 * will be used as parsed arguments
 * @return {Parser} The parser.
 */ function $778943ec39690f8e$var$createParser(returnType, ...argValidators) {
    return function(encoded, context, typeHint) {
        const operator = encoded[0];
        let parsedArgs = [];
        for(let i = 0; i < argValidators.length; i++)parsedArgs = argValidators[i](encoded, context, parsedArgs, typeHint) || parsedArgs;
        let actualType = typeof returnType === "function" ? returnType(parsedArgs) : returnType;
        if (typeHint !== undefined) {
            if (!$778943ec39690f8e$export$3252d368d784c970(actualType, typeHint)) throw new Error(`The following expression was expected to return ${$778943ec39690f8e$export$b2afc7c96b2b4a45(typeHint)}, but returns ${$778943ec39690f8e$export$b2afc7c96b2b4a45(actualType)} instead: ${JSON.stringify(encoded)}`);
            actualType &= typeHint;
        }
        if (actualType === $778943ec39690f8e$export$267d7ad6fa96ffaf) throw new Error(`No matching type was found for the following expression: ${JSON.stringify(encoded)}`);
        return new $778943ec39690f8e$export$6f3d80189eb72cd4(actualType, operator, ...parsedArgs);
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {ParsingContext} context The parsing context.
 * @param {number} [typeHint] Optional type hint
 * @return {Expression} The parsed expression.
 */ function $778943ec39690f8e$var$parseCallExpression(encoded, context, typeHint) {
    const operator = encoded[0];
    const parser = $778943ec39690f8e$var$parsers[operator];
    if (!parser) throw new Error(`Unknown operator: ${operator}`);
    return parser(encoded, context, typeHint);
}
function $778943ec39690f8e$export$8da88d86d10c1295(geometry) {
    if (!geometry) return "";
    const type = geometry.getType();
    switch(type){
        case "Point":
        case "LineString":
        case "Polygon":
            return type;
        case "MultiPoint":
        case "MultiLineString":
        case "MultiPolygon":
            return /** @type {'Point'|'LineString'|'Polygon'} */ type.substring(5);
        case "Circle":
            return "Polygon";
        case "GeometryCollection":
            return $778943ec39690f8e$export$8da88d86d10c1295(/** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries()[0]);
        default:
            return "";
    }
}


/**
 * @module ol/expr/cpu
 */ 

function $d597295b1f166e98$export$c18f39f0e136c26() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null,
        geometryType: ""
    };
}
function $d597295b1f166e98$export$b5f535122a9211f0(encoded, type, context) {
    const expression = (0, $778943ec39690f8e$export$98e6a39c04603d36)(encoded, context);
    if (!(0, $778943ec39690f8e$export$3252d368d784c970)(type, expression.type)) {
        const expected = (0, $778943ec39690f8e$export$b2afc7c96b2b4a45)(type);
        const actual = (0, $778943ec39690f8e$export$b2afc7c96b2b4a45)(expression.type);
        throw new Error(`Expected expression to be of type ${expected}, got ${actual}`);
    }
    return $d597295b1f166e98$var$compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileExpression(expression, context) {
    if (expression instanceof (0, $778943ec39690f8e$export$eb63e96e0913dda4)) {
        // convert colors to array if possible
        if (expression.type === (0, $778943ec39690f8e$export$2cd82751acc0e609) && typeof expression.value === "string") {
            const colorValue = (0, $322346e1ff7894ca$export$3004f64547af360e)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    const operator = expression.operator;
    switch(operator){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Number:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).String:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Coalesce:
            return $d597295b1f166e98$var$compileAssertionExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Get:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Var:
            return $d597295b1f166e98$var$compileAccessorExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Id:
            return (context)=>context.featureId;
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GeometryType:
            return (context)=>context.geometryType;
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Concat:
            {
                const args = expression.args.map((e)=>$d597295b1f166e98$var$compileExpression(e, context));
                return (context)=>"".concat(...args.map((arg)=>arg(context).toString()));
            }
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Resolution:
            return (context)=>context.resolution;
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Any:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).All:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Between:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).In:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Not:
            return $d597295b1f166e98$var$compileLogicalExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Equal:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).NotEqual:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThan:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThanOrEqualTo:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThan:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return $d597295b1f166e98$var$compileComparisonExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Multiply:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Divide:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Add:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Subtract:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Clamp:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Mod:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Pow:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Abs:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Floor:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Ceil:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Round:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sin:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Cos:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Atan:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sqrt:
            return $d597295b1f166e98$var$compileNumericExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Case:
            return $d597295b1f166e98$var$compileCaseExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Match:
            return $d597295b1f166e98$var$compileMatchExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Interpolate:
            return $d597295b1f166e98$var$compileInterpolateExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).ToString:
            return $d597295b1f166e98$var$compileConvertExpression(expression, context);
        default:
            throw new Error(`Unsupported operator ${operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileAssertionExpression(expression, context) {
    const type = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(type){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Coalesce:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value !== "undefined" && value !== null) return value;
                }
                throw new Error("Expected one of the values to be non-null");
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Number:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).String:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value === type) return value;
                }
                throw new Error(`Expected one of the values to be a ${type}`);
            };
        default:
            throw new Error(`Unsupported assertion operator ${type}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileAccessorExpression(expression, context) {
    const nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    const name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Get:
            return (context)=>context.properties[name];
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Var:
            return (context)=>context.variables[name];
        default:
            throw new Error(`Unsupported accessor operator ${expression.operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileComparisonExpression(expression, context) {
    const op = expression.operator;
    const left = $d597295b1f166e98$var$compileExpression(expression.args[0], context);
    const right = $d597295b1f166e98$var$compileExpression(expression.args[1], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Equal:
            return (context)=>left(context) === right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).NotEqual:
            return (context)=>left(context) !== right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThan:
            return (context)=>left(context) < right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThanOrEqualTo:
            return (context)=>left(context) <= right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThan:
            return (context)=>left(context) > right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return (context)=>left(context) >= right(context);
        default:
            throw new Error(`Unsupported comparison operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileLogicalExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Any:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).All:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Between:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                const max = args[2](context);
                return value >= min && value <= max;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).In:
            return (context)=>{
                const value = args[0](context);
                for(let i = 1; i < length; ++i){
                    if (value === args[i](context)) return true;
                }
                return false;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Not:
            return (context)=>!args[0](context);
        default:
            throw new Error(`Unsupported logical operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileNumericExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Multiply:
            return (context)=>{
                let value = 1;
                for(let i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Divide:
            return (context)=>args[0](context) / args[1](context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Add:
            return (context)=>{
                let value = 0;
                for(let i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Subtract:
            return (context)=>args[0](context) - args[1](context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Clamp:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                if (value < min) return min;
                const max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Mod:
            return (context)=>args[0](context) % args[1](context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Pow:
            return (context)=>Math.pow(args[0](context), args[1](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Abs:
            return (context)=>Math.abs(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Floor:
            return (context)=>Math.floor(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Ceil:
            return (context)=>Math.ceil(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Round:
            return (context)=>Math.round(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sin:
            return (context)=>Math.sin(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Cos:
            return (context)=>Math.cos(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Atan:
            if (length === 2) return (context)=>Math.atan2(args[0](context), args[1](context));
            return (context)=>Math.atan(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sqrt:
            return (context)=>Math.sqrt(args[0](context));
        default:
            throw new Error(`Unsupported numeric operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileCaseExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        for(let i = 0; i < length - 1; i += 2){
            const condition = args[i](context);
            if (condition) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileMatchExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const value = args[0](context);
        for(let i = 1; i < length; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileInterpolateExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const base = args[0](context);
        const value = args[1](context);
        let previousInput;
        let previousOutput;
        for(let i = 2; i < length; i += 2){
            const input = args[i](context);
            let output = args[i + 1](context);
            const isColor = Array.isArray(output);
            if (isColor) output = (0, $322346e1ff7894ca$export$138c09bdd6bd797c)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return $d597295b1f166e98$var$interpolateColor(base, value, previousInput, previousOutput, input, output);
                return $d597295b1f166e98$var$interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileConvertExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).ToString:
            return (context)=>{
                const value = args[0](context);
                if (expression.args[0].type === (0, $778943ec39690f8e$export$2cd82751acc0e609)) return (0, $322346e1ff7894ca$export$f84e8e69fd4488a5)(value);
                return value.toString();
            };
        default:
            throw new Error(`Unsupported convert operator ${op}`);
    }
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function $d597295b1f166e98$var$interpolateNumber(base, value, input1, output1, input2, output2) {
    const delta = input2 - input1;
    if (delta === 0) return output1;
    const along = value - input1;
    const factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function $d597295b1f166e98$var$interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    const delta = input2 - input1;
    if (delta === 0) return rgba1;
    const lcha1 = (0, $322346e1ff7894ca$export$44fb54fa2e0c0d4)(rgba1);
    const lcha2 = (0, $322346e1ff7894ca$export$44fb54fa2e0c0d4)(rgba2);
    let deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    const lcha = [
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + $d597295b1f166e98$var$interpolateNumber(base, value, input1, 0, input2, deltaHue),
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, $322346e1ff7894ca$export$a3295358bff77e)((0, $322346e1ff7894ca$export$27cc94530c050f00)(lcha));
}




/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function $6000539d86fde80c$var$always(context) {
    return true;
}
function $6000539d86fde80c$export$fc6a94152b1b05a8(rules) {
    const parsingContext = (0, $778943ec39690f8e$export$1c8b4c1584800354)();
    const evaluator = $6000539d86fde80c$export$d6ae6a4799989976(rules, parsingContext);
    const evaluationContext = (0, $d597295b1f166e98$export$c18f39f0e136c26)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, $778943ec39690f8e$export$8da88d86d10c1295)(feature.getGeometry());
        return evaluator(evaluationContext);
    };
}
function $6000539d86fde80c$export$5a130bc4f0a0420b(flatStyles) {
    const parsingContext = (0, $778943ec39690f8e$export$1c8b4c1584800354)();
    const length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ const evaluators = new Array(length);
    for(let i = 0; i < length; ++i)evaluators[i] = $6000539d86fde80c$export$a6e5f510497b7388(flatStyles[i], parsingContext);
    const evaluationContext = (0, $d597295b1f166e98$export$c18f39f0e136c26)();
    /**
   * @type {Array<Style>}
   */ const styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        let nonNullCount = 0;
        for(let i = 0; i < length; ++i){
            const style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function $6000539d86fde80c$export$d6ae6a4799989976(rules, context) {
    const length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ const compiledRules = new Array(length);
    for(let i = 0; i < length; ++i){
        const rule = rules[i];
        const filter = "filter" in rule ? (0, $d597295b1f166e98$export$b5f535122a9211f0)(rule.filter, (0, $778943ec39690f8e$export$240f7fffab1b25a0), context) : $6000539d86fde80c$var$always;
        /**
     * @type {Array<StyleEvaluator>}
     */ let styles;
        if (Array.isArray(rule.style)) {
            const styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(let j = 0; j < styleLength; ++j)styles[j] = $6000539d86fde80c$export$a6e5f510497b7388(rule.style[j], context);
        } else styles = [
            $6000539d86fde80c$export$a6e5f510497b7388(rule.style, context)
        ];
        compiledRules[i] = {
            filter: filter,
            styles: styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ const styles = [];
        let someMatched = false;
        for(let i = 0; i < length; ++i){
            const filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            for (const styleEvaluator of compiledRules[i].styles){
                const style = styleEvaluator(context);
                if (!style) continue;
                styles.push(style);
            }
        }
        return styles;
    };
}
function $6000539d86fde80c$export$a6e5f510497b7388(flatStyle, context) {
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, "", context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, "", context);
    const evaluateText = $6000539d86fde80c$var$buildText(flatStyle, context);
    const evaluateImage = $6000539d86fde80c$var$buildImage(flatStyle, context);
    const evaluateZIndex = $6000539d86fde80c$var$numberEvaluator(flatStyle, "z-index", context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, $beaefe87199bb537$export$dd1bc94b04021eeb)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error("No fill, stroke, point, or text symbolizer properties in style: " + JSON.stringify(flatStyle));
    const style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)();
    return function(context) {
        let empty = true;
        if (evaluateFill) {
            const fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            const stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            const text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            const image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function $6000539d86fde80c$var$buildFill(flatStyle, prefix, context) {
    let evaluateColor;
    if (prefix + "fill-pattern-src" in flatStyle) evaluateColor = $6000539d86fde80c$var$patternEvaluator(flatStyle, prefix + "fill-", context);
    else evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + "fill-color", context);
    if (!evaluateColor) return null;
    const fill = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)();
    return function(context) {
        const color = evaluateColor(context);
        if (color === "none") return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context) {
    const evaluateWidth = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "stroke-width", context);
    const evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + "stroke-color", context);
    if (!evaluateWidth && !evaluateColor) return null;
    const evaluateLineCap = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "stroke-line-cap", context);
    const evaluateLineJoin = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "stroke-line-join", context);
    const evaluateLineDash = $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, prefix + "stroke-line-dash", context);
    const evaluateLineDashOffset = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "stroke-line-dash-offset", context);
    const evaluateMiterLimit = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "stroke-miter-limit", context);
    const stroke = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)();
    return function(context) {
        if (evaluateColor) {
            const color = evaluateColor(context);
            if (color === "none") return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            const lineCap = evaluateLineCap(context);
            if (lineCap !== "butt" && lineCap !== "round" && lineCap !== "square") throw new Error("Expected butt, round, or square line cap");
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            const lineJoin = evaluateLineJoin(context);
            if (lineJoin !== "bevel" && lineJoin !== "round" && lineJoin !== "miter") throw new Error("Expected bevel, round, or miter line join");
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function $6000539d86fde80c$var$buildText(flatStyle, context) {
    const prefix = "text-";
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    const evaluateValue = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "value", context);
    if (!evaluateValue) return null;
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateBackgroundFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix + "background-", context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateBackgroundStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix + "background-", context);
    const evaluateFont = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "font", context);
    const evaluateMaxAngle = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "max-angle", context);
    const evaluateOffsetX = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "offset-x", context);
    const evaluateOffsetY = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "offset-y", context);
    const evaluateOverflow = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "overflow", context);
    const evaluatePlacement = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "placement", context);
    const evaluateRepeat = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "repeat", context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateAlign = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "align", context);
    const evaluateJustify = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "justify", context);
    const evaluateBaseline = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "baseline", context);
    const evaluatePadding = $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, prefix + "padding", context);
    // The following properties are not currently settable
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const text = new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        declutterMode: declutterMode
    });
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            const placement = evaluatePlacement(context);
            if (placement !== "point" && placement !== "line") throw new Error("Expected point or line for text-placement");
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            const textAlign = evaluateAlign(context);
            if (textAlign !== "left" && textAlign !== "center" && textAlign !== "right" && textAlign !== "end" && textAlign !== "start") throw new Error("Expected left, right, center, start, or end for text-align");
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            const justify = evaluateJustify(context);
            if (justify !== "left" && justify !== "right" && justify !== "center") throw new Error("Expected left, right, or center for text-justify");
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            const textBaseline = evaluateBaseline(context);
            if (textBaseline !== "bottom" && textBaseline !== "top" && textBaseline !== "middle" && textBaseline !== "alphabetic" && textBaseline !== "hanging") throw new Error("Expected bottom, top, middle, alphabetic, or hanging for text-baseline");
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function $6000539d86fde80c$var$buildImage(flatStyle, context) {
    if ("icon-src" in flatStyle) return $6000539d86fde80c$var$buildIcon(flatStyle, context);
    if ("shape-points" in flatStyle) return $6000539d86fde80c$var$buildShape(flatStyle, context);
    if ("circle-radius" in flatStyle) return $6000539d86fde80c$var$buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function $6000539d86fde80c$var$buildIcon(flatStyle, context) {
    const prefix = "icon-";
    // required property
    const srcName = prefix + "src";
    const src = $6000539d86fde80c$var$requireString(flatStyle[srcName], srcName);
    // settable properties
    const evaluateAnchor = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "anchor", context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateOpacity = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "opacity", context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining symbolizer properties are not currently settable
    const anchorOrigin = $6000539d86fde80c$var$optionalIconOrigin(flatStyle, prefix + "anchor-origin");
    const anchorXUnits = $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, prefix + "anchor-x-units");
    const anchorYUnits = $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, prefix + "anchor-y-units");
    const color = $6000539d86fde80c$var$optionalColorLike(flatStyle, prefix + "color");
    const crossOrigin = $6000539d86fde80c$var$optionalString(flatStyle, prefix + "cross-origin");
    const offset = $6000539d86fde80c$var$optionalNumberArray(flatStyle, prefix + "offset");
    const offsetOrigin = $6000539d86fde80c$var$optionalIconOrigin(flatStyle, prefix + "offset-origin");
    const width = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "width");
    const height = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "height");
    const size = $6000539d86fde80c$var$optionalSize(flatStyle, prefix + "size");
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const icon = new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
        src: src,
        anchorOrigin: anchorOrigin,
        anchorXUnits: anchorXUnits,
        anchorYUnits: anchorYUnits,
        color: color,
        crossOrigin: crossOrigin,
        offset: offset,
        offsetOrigin: offsetOrigin,
        height: height,
        width: width,
        size: size,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function $6000539d86fde80c$var$buildShape(flatStyle, context) {
    const prefix = "shape-";
    // required property
    const pointsName = prefix + "points";
    const radiusName = prefix + "radius";
    const points = $6000539d86fde80c$var$requireNumber(flatStyle[pointsName], pointsName);
    const radius = $6000539d86fde80c$var$requireNumber(flatStyle[radiusName], radiusName);
    // settable properties
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining properties are not currently settable
    const radius2 = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "radius2");
    const angle = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "angle");
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const shape = new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
        points: points,
        radius: radius,
        radius2: radius2,
        angle: angle,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function $6000539d86fde80c$var$buildCircle(flatStyle, context) {
    const prefix = "circle-";
    // settable properties
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateRadius = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "radius", context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining properties are not currently settable
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const circle = new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
        radius: 5,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function $6000539d86fde80c$var$numberEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return undefined;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$86a7aca748b1e260), context);
    return function(context) {
        return $6000539d86fde80c$var$requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$stringEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$2b93044cbf134323), context);
    return function(context) {
        return $6000539d86fde80c$var$requireString(evaluator(context), name);
    };
}
function $6000539d86fde80c$var$patternEvaluator(flatStyle, prefix, context) {
    const srcEvaluator = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "pattern-src", context);
    const offsetEvaluator = $6000539d86fde80c$var$sizeEvaluator(flatStyle, prefix + "pattern-offset", context);
    const patternSizeEvaluator = $6000539d86fde80c$var$sizeEvaluator(flatStyle, prefix + "pattern-size", context);
    const colorEvaluator = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + "color", context);
    return function(context) {
        return {
            src: srcEvaluator(context),
            offset: offsetEvaluator && offsetEvaluator(context),
            size: patternSizeEvaluator && patternSizeEvaluator(context),
            color: colorEvaluator && colorEvaluator(context)
        };
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$booleanEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$240f7fffab1b25a0), context);
    return function(context) {
        const value = evaluator(context);
        if (typeof value !== "boolean") throw new Error(`Expected a boolean for ${name}`);
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$2cd82751acc0e609) | (0, $778943ec39690f8e$export$2b93044cbf134323), context);
    return function(context) {
        return $6000539d86fde80c$var$requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $6000539d86fde80c$var$requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$coordinateEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39), context);
    return function(context) {
        const array = $6000539d86fde80c$var$requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error(`Expected two numbers for ${name}`);
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$sizeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $6000539d86fde80c$var$requireSize(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39) | (0, $778943ec39690f8e$export$86a7aca748b1e260), context);
    return function(context) {
        return $6000539d86fde80c$var$requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function $6000539d86fde80c$var$optionalNumber(flatStyle, property) {
    const value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== "number") throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function $6000539d86fde80c$var$optionalSize(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === "number") return (0, $cc435a5409103773$export$a71a825ff42fb8e1)(encoded);
    if (!Array.isArray(encoded)) throw new Error(`Expected a number or size array for ${property}`);
    if (encoded.length !== 2 || typeof encoded[0] !== "number" || typeof encoded[1] !== "number") throw new Error(`Expected a number or size array for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function $6000539d86fde80c$var$optionalString(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== "string") throw new Error(`Expected a string for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function $6000539d86fde80c$var$optionalIconOrigin(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== "bottom-left" && encoded !== "bottom-right" && encoded !== "top-left" && encoded !== "top-right") throw new Error(`Expected bottom-left, bottom-right, top-left, or top-right for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== "pixels" && encoded !== "fraction") throw new Error(`Expected pixels or fraction for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function $6000539d86fde80c$var$optionalNumberArray(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $6000539d86fde80c$var$requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import('../../style/Style.js').DeclutterMode} Icon declutter mode.
 */ function $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== "string") throw new Error(`Expected a string for ${property}`);
    if (encoded !== "declutter" && encoded !== "obstacle" && encoded !== "none") throw new Error(`Expected declutter, obstacle, or none for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|Array<number>|undefined} A string or an array of color values or undefined.
 */ function $6000539d86fde80c$var$optionalColorLike(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $6000539d86fde80c$var$requireColorLike(encoded, property);
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function $6000539d86fde80c$var$requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error(`Expected an array for ${property}`);
    const length = value.length;
    for(let i = 0; i < length; ++i){
        if (typeof value[i] !== "number") throw new Error(`Expected an array of numbers for ${property}`);
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function $6000539d86fde80c$var$requireString(value, property) {
    if (typeof value !== "string") throw new Error(`Expected a string for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function $6000539d86fde80c$var$requireNumber(value, property) {
    if (typeof value !== "number") throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function $6000539d86fde80c$var$requireColorLike(value, property) {
    if (typeof value === "string") return value;
    const array = $6000539d86fde80c$var$requireNumberArray(value, property);
    const length = array.length;
    if (length < 3 || length > 4) throw new Error(`Expected a color with 3 or 4 values for ${property}`);
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} A number or an array of two numbers.
 */ function $6000539d86fde80c$var$requireSize(value, property) {
    const size = $6000539d86fde80c$var$requireNumberArray(value, property);
    if (size.length !== 2) throw new Error(`Expected an array of two numbers for ${property}`);
    return size;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function $6000539d86fde80c$var$requireSizeLike(value, property) {
    if (typeof value === "number") return value;
    return $6000539d86fde80c$var$requireSize(value, property);
}


/**
 * @template {import("../source/Vector.js").default<import('../Feature').FeatureLike>|import("../source/VectorTile.js").default<import('../Feature').FeatureLike>} VectorSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $c8d6dc4c09ed9916$var$Property = {
    RENDER_ORDER: "renderOrder"
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default<import('../Feature').FeatureLike>|import("../source/VectorTile.js").default<import('../Feature').FeatureLike>} VectorSourceType
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @extends {Layer<VectorSourceType, RendererType>}
 * @api
 */ class $c8d6dc4c09ed9916$var$BaseVectorLayer extends (0, $534f30fce11effcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options<VectorSourceType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        super(baseOptions);
        /**
     * @private
     * @type {string}
     */ this.declutter_ = options.declutter ? String(options.declutter) : undefined;
        /**
     * @type {number}
     * @private
     */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike}
     * @private
     */ this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
    }
    /**
   * @return {string} Declutter group.
   */ getDeclutter() {
        return this.declutter_;
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * @return {number|undefined} Render buffer.
   */ getRenderBuffer() {
        return this.renderBuffer_;
    }
    /**
   * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
   *     order.
   */ getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($c8d6dc4c09ed9916$var$Property.RENDER_ORDER);
    }
    /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    }
    /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {
        const declutterGroup = this.getDeclutter();
        if (declutterGroup in frameState.declutter === false) frameState.declutter[declutterGroup] = new (0, (/*@__PURE__*/$parcel$interopDefault($176ca75ee9f69668$exports)))(9);
        this.getRenderer().renderDeclutter(frameState, layerState);
    }
    /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ setRenderOrder(renderOrder) {
        this.set($c8d6dc4c09ed9916$var$Property.RENDER_ORDER, renderOrder);
    }
    /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ setStyle(style) {
        this.style_ = style === undefined ? (0, $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6) : style;
        const styleLike = $c8d6dc4c09ed9916$var$toStyleLike(style);
        this.styleFunction_ = style === null ? undefined : (0, $8c7f6dda98e8cb9c$export$c314ea3f6b164147)(styleLike);
        this.changed();
    }
}
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function $c8d6dc4c09ed9916$var$toStyleLike(style) {
    if (style === undefined) return 0, $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6;
    if (!style) return null;
    if (typeof style === "function") return style;
    if (style instanceof (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)) return style;
    if (!Array.isArray(style)) return (0, $6000539d86fde80c$export$5a130bc4f0a0420b)([
        style
    ]);
    if (style.length === 0) return [];
    const length = style.length;
    const first = style[0];
    if (first instanceof (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)) {
        /**
     * @type {Array<Style>}
     */ const styles = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!(candidate instanceof (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039))) throw new Error("Expected a list of style instances");
            styles[i] = candidate;
        }
        return styles;
    }
    if ("style" in first) {
        /**
     * @type Array<import("../style/flat.js").Rule>
     */ const rules = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!("style" in candidate)) throw new Error("Expected a list of rules with a style property");
            rules[i] = candidate;
        }
        return (0, $6000539d86fde80c$export$fc6a94152b1b05a8)(rules);
    }
    const flatStyles = /** @type {Array<import("../style/flat.js").FlatStyle>} */ style;
    return (0, $6000539d86fde80c$export$5a130bc4f0a0420b)(flatStyles);
}
var $c8d6dc4c09ed9916$export$2e2bcd8739ae039 = $c8d6dc4c09ed9916$var$BaseVectorLayer;


/**
 * @module ol/renderer/Map
 */ 







/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ class $b370ab32454a96fd$var$MapRenderer extends (0, $3273ed08087da3da$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super();
        /**
     * @private
     * @type {import("../Map.js").default}
     */ this.map_ = map;
    }
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ calculateMatrices2D(frameState) {
        const viewState = frameState.viewState;
        const coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        const pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $e22e7611e69f42a9$export$bd70ea2a93c0fa4)(pixelToCoordinateTransform, coordinateToPixelTransform);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        let result;
        const viewState = frameState.viewState;
        /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        const projection = viewState.projection;
        const translatedCoordinate = (0, $1bd0a226f9a16141$export$39a9ce3624977b84)(coordinate.slice(), projection);
        const offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            const projectionExtent = projection.getExtent();
            const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        const layerStates = frameState.layerStatesArray;
        const numLayers = layerStates.length;
        const matches = /** @type {Array<HitMatch<T>>} */ [];
        const tmpCoord = [];
        for(let i = 0; i < offsets.length; i++)for(let j = numLayers - 1; j >= 0; --j){
            const layerState = layerStates[j];
            const layer = layerState.layer;
            if (layer.hasRenderer() && (0, $534f30fce11effcd$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                const layerRenderer = layer.getRenderer();
                const source = layer.getSource();
                if (layerRenderer && source) {
                    const coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    const callback = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        const order = 1 / matches.length;
        matches.forEach((m, i)=>m.distanceSq += i * order);
        matches.sort((a, b)=>a.distanceSq - b.distanceSq);
        matches.some((m)=>{
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        const hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $013a1733c226ec50$export$22e23a2304399231), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    }
    /**
   * @return {import("../Map.js").default} Map.
   */ getMap() {
        return this.map_;
    }
    /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ scheduleExpireIconCache(frameState) {
        if ((0, $f351daabfe6e2d22$export$747ccdf771a87ab8).canExpireCache()) frameState.postRenderFunctions.push($b370ab32454a96fd$var$expireIconCache);
    }
}
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function $b370ab32454a96fd$var$expireIconCache(map, frameState) {
    (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).expire();
}
var $b370ab32454a96fd$export$2e2bcd8739ae039 = $b370ab32454a96fd$var$MapRenderer;



/**
 * @module ol/render/Event
 */ 
class $b80dddceb0c42ad4$var$RenderEvent extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */ constructor(type, inversePixelTransform, frameState, context){
        super(type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ this.context = context;
    }
}
var $b80dddceb0c42ad4$export$2e2bcd8739ae039 = $b80dddceb0c42ad4$var$RenderEvent;








/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ class $fa78c97693b12120$var$CompositeMapRenderer extends (0, $b370ab32454a96fd$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super(map);
        /**
     * @type {import("../events.js").EventsKey}
     */ this.fontChangeListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)((0, $d4aabc5c971073f1$export$1d36981fcadac93b), (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, map.redrawText.bind(map));
        /**
     * @private
     * @type {HTMLDivElement}
     */ this.element_ = document.createElement("div");
        const style = this.element_.style;
        style.position = "absolute";
        style.width = "100%";
        style.height = "100%";
        style.zIndex = "0";
        this.element_.className = (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + " ol-layers";
        const container = map.getViewport();
        container.insertBefore(this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        const map = this.getMap();
        if (map.hasListener(type)) {
            const event = new (0, $b80dddceb0c42ad4$export$2e2bcd8739ae039)(type, undefined, frameState);
            map.dispatchEvent(event);
        }
    }
    disposeInternal() {
        (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.fontChangeListenerKey_);
        this.element_.parentNode.removeChild(this.element_);
        super.disposeInternal();
    }
    /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = "none";
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
        const layerStatesArray = frameState.layerStatesArray.sort(function(a, b) {
            return a.zIndex - b.zIndex;
        });
        const declutter = layerStatesArray.some((layerState)=>layerState.layer instanceof (0, $c8d6dc4c09ed9916$export$2e2bcd8739ae039) && layerState.layer.getDeclutter());
        if (declutter) // Some layers need decluttering, turn on deferred rendering hint
        frameState.declutter = {};
        const viewState = frameState.viewState;
        this.children_.length = 0;
        const renderedLayerStates = [];
        let previousElement = null;
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            const layer = layerState.layer;
            const sourceState = layer.getSourceState();
            if (!(0, $534f30fce11effcd$export$acb1e9cb9ce4ca56)(layerState, viewState) || sourceState != "ready" && sourceState != "undefined") {
                layer.unrender();
                continue;
            }
            const element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            renderedLayerStates.push(layerState);
        }
        this.declutter(frameState, renderedLayerStates);
        (0, $075f937d7366f1a2$export$caeacfe04f52533a)(this.element_, this.children_);
        this.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = "";
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */ declutter(frameState, layerStates) {
        if (!frameState.declutter) return;
        for(let i = layerStates.length - 1; i >= 0; --i){
            const layerState = layerStates[i];
            const layer = layerState.layer;
            if (layer.getDeclutter()) layer.renderDeclutter(frameState, layerState);
        }
        layerStates.forEach((layerState)=>layerState.layer.renderDeferred(frameState));
    }
}
var $fa78c97693b12120$export$2e2bcd8739ae039 = $fa78c97693b12120$var$CompositeMapRenderer;




/**
 * @module ol/layer/Group
 */ 










class $0b703156bb914e6f$export$2f5ff21d758d25a7 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */ constructor(type, layer){
        super(type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ this.layer = layer;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $0b703156bb914e6f$var$Property = {
    LAYERS: "layers"
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */ class $0b703156bb914e6f$var$LayerGroup extends (0, $57c5f0299cb9b82f$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Layer options.
   */ constructor(options){
        options = options || {};
        const baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        let layers = options.layers;
        super(baseOptions);
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        this.addChangeListener($0b703156bb914e6f$var$Property.LAYERS, this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(layers.slice(), {
                unique: true
            });
            else (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ layers.getArray === "function", "Expected `layers` to be an array or a `Collection`");
        } else layers = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    /**
   * @private
   */ handleLayerChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.layersListenerKeys_.length = 0;
        const layers = this.getLayers();
        this.layersListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layers, (0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, this.handleLayersAdd_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layers, (0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, this.handleLayersRemove_, this));
        for(const id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.listenerKeys_);
        const layersArray = layers.getArray();
        for(let i = 0, ii = layersArray.length; i < ii; i++){
            const layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("addlayer", layer));
        }
        this.changed();
    }
    /**
   * @param {BaseLayer} layer The layer.
   */ registerLayerListeners_(layer) {
        const listenerKeys = [
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof $0b703156bb914e6f$var$LayerGroup) listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, "addlayer", this.handleLayerGroupAdd_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, "removelayer", this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, $6c5e11070e371322$export$5e82334337e0f204)(layer)] = listenerKeys;
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupAdd_(event) {
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("addlayer", event.layer));
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupRemove_(event) {
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("removelayer", event.layer));
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersAdd_(collectionEvent) {
        const layer = collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("addlayer", layer));
        this.changed();
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersRemove_(collectionEvent) {
        const layer = collectionEvent.element;
        const key = (0, $6c5e11070e371322$export$5e82334337e0f204)(layer);
        this.listenerKeys_[key].forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("removelayer", layer));
        this.changed();
    }
    /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ getLayers() {
        return /** @type {!Collection<import("./Base.js").default>} */ this.get($0b703156bb914e6f$var$Property.LAYERS);
    }
    /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ setLayers(layers) {
        const collection = this.getLayers();
        if (collection) {
            const currentLayers = collection.getArray();
            for(let i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("removelayer", currentLayers[i]));
        }
        this.set($0b703156bb914e6f$var$Property.LAYERS, layers);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        array = array !== undefined ? array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    }
    /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(dest) {
        const states = dest !== undefined ? dest : [];
        const pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        const ownLayerState = this.getLayerState();
        let defaultZIndex = ownLayerState.zIndex;
        if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(let i = pos, ii = states.length; i < ii; i++){
            const layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return "ready";
    }
}
var $0b703156bb914e6f$export$2e2bcd8739ae039 = $0b703156bb914e6f$var$LayerGroup;


/**
 * @module ol/MapBrowserEvent
 */ /**
 * @module ol/MapEvent
 */ 
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ class $3a171922c3a0c5ed$var$MapEvent extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */ constructor(type, map, frameState){
        super(type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ this.frameState = frameState !== undefined ? frameState : null;
    }
}
var $3a171922c3a0c5ed$export$2e2bcd8739ae039 = $3a171922c3a0c5ed$var$MapEvent;


/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {UIEvent} EVENT
 */ class $a1b91f073c6a6c43$var$MapBrowserEvent extends (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */ constructor(type, map, originalEvent, dragging, frameState, activePointers){
        super(type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     */ this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     */ this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ this.activePointers = activePointers;
    }
    /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ get pixel() {
        if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
        return this.pixel_;
    }
    set pixel(pixel) {
        this.pixel_ = pixel;
    }
    /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ get coordinate() {
        if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
        return this.coordinate_;
    }
    set coordinate(coordinate) {
        this.coordinate_ = coordinate;
    }
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   */ preventDefault() {
        super.preventDefault();
        if ("preventDefault" in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    }
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   */ stopPropagation() {
        super.stopPropagation();
        if ("stopPropagation" in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    }
}
var $a1b91f073c6a6c43$export$2e2bcd8739ae039 = $a1b91f073c6a6c43$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ 

/**
 * @module ol/MapBrowserEventType
 */ 
var /**
 * Constants for event names.
 * @enum {string}
 */ $150f412a4a7fa263$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: "singleclick",
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $294047c5e65f31a3$export$2e2bcd8739ae039).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: "pointerdrag",
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: "pointermove",
    POINTERDOWN: "pointerdown",
    POINTERUP: "pointerup",
    POINTEROVER: "pointerover",
    POINTEROUT: "pointerout",
    POINTERENTER: "pointerenter",
    POINTERLEAVE: "pointerleave",
    POINTERCANCEL: "pointercancel"
};


/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $d564567e31203d44$export$2e2bcd8739ae039 = {
    POINTERMOVE: "pointermove",
    POINTERDOWN: "pointerdown",
    POINTERUP: "pointerup",
    POINTEROVER: "pointerover",
    POINTEROUT: "pointerout",
    POINTERENTER: "pointerenter",
    POINTERLEAVE: "pointerleave",
    POINTERCANCEL: "pointercancel"
};





class $6085d006f9d0efe2$var$MapBrowserEventHandler extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */ constructor(map, moveTolerance){
        super(map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ this.down_ = null;
        const element = this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ this.trackedTouches_ = {};
        this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(element, (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {PointerEvent}
     * @private
     */ this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(element, (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERMOVE, this.relayMoveEvent_, this);
        /**
     * @private
     */ this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this);
        this.element_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_, (0, $67c66761d21428d0$export$f751ce96c6c4e4fc) ? {
            passive: false
        } : false);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ emulateClick_(pointerEvent) {
        let newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(()=>{
            this.clickTimeoutId_ = undefined;
            const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }, 250);
    }
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ updateActivePointers_(pointerEvent) {
        const event = pointerEvent;
        const id = event.pointerId;
        if (event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(const pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN || event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = Object.values(this.trackedTouches_);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerDown_(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
        Object.defineProperty(this.down_, "target", {
            writable: false,
            value: pointerEvent.target
        });
        if (this.dragListenerKeys_.length === 0) {
            const doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(doc, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(doc, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.element_, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.element_.getRootNode(), (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this));
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    }
    /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ relayMoveEvent_(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        const dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE, this.map_, pointerEvent, dragging));
    }
    /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ handleTouchMove_(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events,
        // when elm-pep is used as pointer events polyfill.
        const originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== "boolean" || event.cancelable === true)) event.preventDefault();
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    }
    /**
   * Clean up.
   */ disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        super.disposeInternal();
    }
}
var $6085d006f9d0efe2$export$2e2bcd8739ae039 = $6085d006f9d0efe2$var$MapBrowserEventHandler;




/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $e4ad75f913b6f7ff$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: "postrender",
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: "movestart",
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: "moveend",
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: "loadstart",
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: "loadend"
};


/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $07fa325567004bb7$export$2e2bcd8739ae039 = {
    LAYERGROUP: "layergroup",
    SIZE: "size",
    TARGET: "target",
    VIEW: "view"
};





/**
 * @module ol/TileQueue
 */ 
/**
 * @module ol/structs/PriorityQueue
 */ 

const $716c6804ea170b71$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ class $716c6804ea170b71$var$PriorityQueue {
    /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */ constructor(priorityFunction, keyFunction){
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.queuedElements_);
    }
    /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ dequeue() {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = /** @type {T} */ elements.pop();
            priorities[0] = /** @type {number} */ priorities.pop();
            this.siftUp_(0);
        }
        const elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    }
    /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(this.keyFunction_(element) in this.queuedElements_), "Tried to enqueue an `element` that was already added to the queue");
        const priority = this.priorityFunction_(element);
        if (priority != $716c6804ea170b71$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.elements_.length;
    }
    /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ getLeftChildIndex_(index) {
        return index * 2 + 1;
    }
    /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ getRightChildIndex_(index) {
        return index * 2 + 2;
    }
    /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ getParentIndex_(index) {
        return index - 1 >> 1;
    }
    /**
   * Make this a heap. O(N).
   * @private
   */ heapify_() {
        let i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.elements_.length === 0;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ isKeyQueued(key) {
        return key in this.queuedElements_;
    }
    /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ isQueued(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    }
    /**
   * @param {number} index The index of the node to move down.
   * @private
   */ siftUp_(index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const count = elements.length;
        const element = elements[index];
        const priority = priorities[index];
        const startIndex = index;
        while(index < count >> 1){
            const lIndex = this.getLeftChildIndex_(index);
            const rIndex = this.getRightChildIndex_(index);
            const smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    }
    /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ siftDown_(startIndex, index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[index];
        const priority = priorities[index];
        while(index > startIndex){
            const parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    }
    /**
   * FIXME empty description for jsdoc
   */ reprioritize() {
        const priorityFunction = this.priorityFunction_;
        const elements = this.elements_;
        const priorities = this.priorities_;
        let index = 0;
        const n = elements.length;
        let element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $716c6804ea170b71$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    }
}
var $716c6804ea170b71$export$2e2bcd8739ae039 = $716c6804ea170b71$var$PriorityQueue;


/**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $b8291d9739c3c64e$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};


/**
 * @typedef {function(import("./Tile.js").default, string, import("./coordinate.js").Coordinate, number): number} PriorityFunction
 */ class $4c51fd53052a6bbc$var$TileQueue extends (0, $716c6804ea170b71$export$2e2bcd8739ae039) {
    /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */ constructor(tilePriorityFunction, tileChangeCallback){
        super(/**
       * @param {Array} element Element.
       * @return {number} Priority.
       */ function(element) {
            return tilePriorityFunction.apply(null, element);
        }, /**
       * @param {Array} element Element.
       * @return {string} Key.
       */ function(element) {
            return /** @type {import("./Tile.js").default} */ element[0].getKey();
        });
        /** @private */ this.boundHandleTileChange_ = this.handleTileChange.bind(this);
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    /**
   * @param {Array} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        const added = super.enqueue(element);
        if (added) {
            const tile = element[0];
            tile.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    }
    /**
   * @return {number} Number of tiles loading.
   */ getTilesLoading() {
        return this.tilesLoading_;
    }
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("./Tile.js").default} */ event.target;
        const state = tile.getState();
        if (state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR || state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) {
            if (state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) tile.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
            const tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    }
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ loadMoreTiles(maxTotalLoading, maxNewLoads) {
        let newLoads = 0;
        let state, tile, tileKey;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            tile = /** @type {import("./Tile.js").default} */ this.dequeue()[0];
            tileKey = tile.getKey();
            state = tile.getState();
            if (state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    }
}
var $4c51fd53052a6bbc$export$2e2bcd8739ae039 = $4c51fd53052a6bbc$var$TileQueue;
function $4c51fd53052a6bbc$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $716c6804ea170b71$export$b4af72c40fd57063;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $716c6804ea170b71$export$b4af72c40fd57063;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    const center = frameState.viewState.center;
    const deltaX = tileCenter[0] - center[0];
    const deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}









/**
 * @module ol/control/defaults
 */ /**
 * @module ol/control/Attribution
 */ /**
 * @module ol/control/Control
 */ 




/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ class $b978dafe8f7d27ff$var$Control extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Control options.
   */ constructor(options){
        super();
        const element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = "auto";
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        if (options.render) this.render = options.render;
        if (options.target) this.setTarget(options.target);
    }
    /**
   * Clean up.
   */ disposeInternal() {
        (0, $075f937d7366f1a2$export$1d0aa160432dfea5)(this.element);
        super.disposeInternal();
    }
    /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.map_) (0, $075f937d7366f1a2$export$1d0aa160432dfea5)(this.element);
        for(let i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            const target = this.target_ ? this.target_ : map.getOverlayContainerStopEvent();
            target.appendChild(this.element);
            if (this.render !== (0, $013a1733c226ec50$export$1cd1943b3a73bbe8)) this.listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this.render, this));
            map.render();
        }
    }
    /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ render(mapEvent) {}
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ setTarget(target) {
        this.target_ = typeof target === "string" ? document.getElementById(target) : target;
    }
}
var $b978dafe8f7d27ff$export$2e2bcd8739ae039 = $b978dafe8f7d27ff$var$Control;







/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ class $6a26ab11104d2c24$var$Attribution extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Attribution options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement("div"),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement("ul");
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.userCollapsed_ = this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        const className = options.className !== undefined ? options.className : "ol-attribution";
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : "Attributions";
        const expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + "-expand";
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : "\u203A";
        const collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + "-collapse";
        if (typeof collapseLabel === "string") {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement("span");
            this.collapseLabel_.textContent = collapseLabel;
            this.collapseLabel_.className = collapseClassName;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : "i";
        if (typeof label === "string") {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement("span");
            this.label_.textContent = label;
            this.label_.className = expandClassName;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ this.toggleButton_ = document.createElement("button");
        this.toggleButton_.setAttribute("type", "button");
        this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_));
        this.toggleButton_.title = tipLabel;
        this.toggleButton_.appendChild(activeLabel);
        this.toggleButton_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + " " + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + " " + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192) + (this.collapsed_ && this.collapsible_ ? " " + (0, $ce07df6d5d4656f1$export$e16017ac68d14492) : "") + (this.collapsible_ ? "" : " ol-uncollapsible");
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.toggleButton_);
        element.appendChild(this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ collectSourceAttributions_(frameState) {
        const visibleAttributions = Array.from(new Set(this.getMap().getAllLayers().flatMap((layer)=>layer.getAttributions(frameState))));
        const collapsible = !this.getMap().getAllLayers().some((layer)=>layer.getSource() && layer.getSource().getAttributionsCollapsible() === false);
        if (!this.overrideCollapsible_) this.setCollapsible(collapsible);
        return visibleAttributions;
    }
    /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ async updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = "none";
                this.renderedVisible_ = false;
            }
            return;
        }
        const attributions = await Promise.all(this.collectSourceAttributions_(frameState).map((attribution)=>(0, $013a1733c226ec50$export$4dbaaf6c79705e6c)(()=>attribution)));
        const visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? "" : "none";
            this.renderedVisible_ = visible;
        }
        if ((0, $b998d41b678ed5d1$export$e9bab7fafb253603)(attributions, this.renderedAttributions_)) return;
        (0, $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1)(this.ulElement_);
        // append the attributions
        for(let i = 0, ii = attributions.length; i < ii; ++i){
            const element = document.createElement("li");
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, $ce07df6d5d4656f1$export$e16017ac68d14492));
        if (this.collapsed_) (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
        else (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_));
    }
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle("ol-uncollapsible");
        if (this.userCollapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    }
}
var $6a26ab11104d2c24$export$2e2bcd8739ae039 = $6a26ab11104d2c24$var$Attribution;



/**
 * @module ol/control/Rotate
 */ 



/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ class $a305cff1f91b3b86$var$Rotate extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Rotate options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement("div"),
            render: options.render,
            target: options.target
        });
        const className = options.className !== undefined ? options.className : "ol-rotate";
        const label = options.label !== undefined ? options.label : "\u21E7";
        const compassClassName = options.compassClassName !== undefined ? options.compassClassName : "ol-compass";
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === "string") {
            this.label_ = document.createElement("span");
            this.label_.className = compassClassName;
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add(compassClassName);
        }
        const tipLabel = options.tipLabel ? options.tipLabel : "Reset rotation";
        const button = document.createElement("button");
        button.className = className + "-reset";
        button.setAttribute("type", "button");
        button.title = tipLabel;
        button.appendChild(this.label_);
        button.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + " " + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + " " + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, $ce07df6d5d4656f1$export$981241db82723ce2));
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    }
    /**
   * @private
   */ resetNorth_() {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
            });
            else view.setRotation(0);
        }
    }
    /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) return;
        const rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            const transform = "rotate(" + rotation + "rad)";
            if (this.autoHide_) {
                const contains = this.element.classList.contains((0, $ce07df6d5d4656f1$export$981241db82723ce2));
                if (!contains && rotation === 0) this.element.classList.add((0, $ce07df6d5d4656f1$export$981241db82723ce2));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $ce07df6d5d4656f1$export$981241db82723ce2));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    }
}
var $a305cff1f91b3b86$export$2e2bcd8739ae039 = $a305cff1f91b3b86$var$Rotate;


/**
 * @module ol/control/Zoom
 */ 



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ class $4901e3e27e30416a$var$Zoom extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Zoom options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement("div"),
            target: options.target
        });
        const className = options.className !== undefined ? options.className : "ol-zoom";
        const delta = options.delta !== undefined ? options.delta : 1;
        const zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + "-in";
        const zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + "-out";
        const zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : "+";
        const zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : "\u2013";
        const zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : "Zoom in";
        const zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : "Zoom out";
        const inElement = document.createElement("button");
        inElement.className = zoomInClassName;
        inElement.setAttribute("type", "button");
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === "string" ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, delta), false);
        const outElement = document.createElement("button");
        outElement.className = zoomOutClassName;
        outElement.setAttribute("type", "button");
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === "string" ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, -delta), false);
        const cssClasses = className + " " + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + " " + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    }
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ zoomByDelta_(delta) {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
                });
            } else view.setZoom(newZoom);
        }
    }
}
var $4901e3e27e30416a$export$2e2bcd8739ae039 = $4901e3e27e30416a$var$Zoom;


function $af7495b2f822d5e9$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ const controls = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    const zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $4901e3e27e30416a$export$2e2bcd8739ae039)(options.zoomOptions));
    const rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $a305cff1f91b3b86$export$2e2bcd8739ae039)(options.rotateOptions));
    const attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $6a26ab11104d2c24$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}


/**
 * @module ol/interaction/defaults
 */ 
/**
 * @module ol/interaction/DoubleClickZoom
 */ /**
 * @module ol/interaction/Interaction
 */ 
/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $2c9e42723ccf2bfb$export$2e2bcd8739ae039 = {
    ACTIVE: "active"
};



/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} handleEvent
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ class $39210df8527e63e5$var$Interaction extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {InteractionOptions} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ this.un;
        if (options && options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        this.setActive(true);
    }
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ getActive() {
        return /** @type {boolean} */ this.get((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE);
    }
    /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        return true;
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        this.set((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE, active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        this.map_ = map;
    }
}
function $39210df8527e63e5$export$4c486572e961a974(view, delta, duration) {
    const currentCenter = view.getCenterInternal();
    if (currentCenter) {
        const center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, $c7ccf7e681a9b333$export$45db2fc2f15997e7),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $39210df8527e63e5$export$ace321ff2a8016ef(view, delta, anchor, duration) {
    const currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
    });
}
var $39210df8527e63e5$export$2e2bcd8739ae039 = $39210df8527e63e5$var$Interaction;



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ class $b50403621294a654$var$DoubleClickZoom extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK) {
            const browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            const map = mapBrowserEvent.map;
            const anchor = mapBrowserEvent.coordinate;
            const delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            const view = map.getView();
            (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}
var $b50403621294a654$export$2e2bcd8739ae039 = $b50403621294a654$var$DoubleClickZoom;


/**
 * @module ol/interaction/DragPan
 */ /**
 * @module ol/interaction/Pointer
 */ 

/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ class $cf1eb502962d87a8$var$PointerInteraction extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ this.targetPointers = [];
    }
    /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ getPointerCount() {
        return this.targetPointers.length;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleDownEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleDragEvent(mapBrowserEvent) {}
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        let stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP) {
                const handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN) {
                const handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleMoveEvent(mapBrowserEvent) {}
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleUpEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ stopDown(handled) {
        return handled;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ updateTrackedPointers_(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    }
}
function $cf1eb502962d87a8$export$e2a20c553f6c85ce(pointerEvents) {
    const length = pointerEvents.length;
    let clientX = 0;
    let clientY = 0;
    for(let i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
var $cf1eb502962d87a8$export$2e2bcd8739ae039 = $cf1eb502962d87a8$var$PointerInteraction;



/**
 * @module ol/events/condition
 */ 



function $edf87b50170125f7$export$84bf76cd7afc7469(var_args) {
    const conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        let pass = true;
        for(let i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
const $edf87b50170125f7$export$573409992e89967e = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $edf87b50170125f7$export$d7ddd398f22d79ef = function(event) {
    const targetElement = event.map.getTargetElement();
    const activeElement = event.map.getOwnerDocument().activeElement;
    return targetElement.contains(activeElement);
};
const $edf87b50170125f7$export$ae2cdf064e3b0c55 = function(event) {
    return event.map.getTargetElement().hasAttribute("tabindex") ? $edf87b50170125f7$export$d7ddd398f22d79ef(event) : true;
};
const $edf87b50170125f7$export$ba9e5d519bc326ca = (0, $013a1733c226ec50$export$22e23a2304399231);
const $edf87b50170125f7$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).CLICK;
};
const $edf87b50170125f7$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    const originalEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.button == 0 && !((0, $67c66761d21428d0$export$39dfd62a25e0fe93) && (0, $67c66761d21428d0$export$76c0a3b101d93136) && originalEvent.ctrlKey);
};
const $edf87b50170125f7$export$b3e22bcfd64c1022 = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
const $edf87b50170125f7$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == "pointermove";
};
const $edf87b50170125f7$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK;
};
const $edf87b50170125f7$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK;
};
const $edf87b50170125f7$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $67c66761d21428d0$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$32603ad571dd22b5 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return (0, $67c66761d21428d0$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
const $edf87b50170125f7$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $edf87b50170125f7$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    const tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== "INPUT" && tagName !== "SELECT" && tagName !== "TEXTAREA" && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
const $edf87b50170125f7$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    const pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvent !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvent.pointerType == "mouse";
};
const $edf87b50170125f7$export$e74de664a571d084 = function(mapBrowserEvent) {
    const pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvt !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === "touch";
};
const $edf87b50170125f7$export$cd1707283a23f059 = function(mapBrowserEvent) {
    const pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvt !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === "pen";
};
const $edf87b50170125f7$export$189f0d593022b199 = function(mapBrowserEvent) {
    const pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvent !== undefined, "mapBrowserEvent must originate from a pointer event");
    return pointerEvent.isPrimary && pointerEvent.button === 0;
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ class $c11585da26a016db$var$DragPan extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super({
            stopDown: (0, $013a1733c226ec50$export$8f11cee4bdc7e668)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     */ this.panning_ = false;
        const condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$fdc892d0d8fe3bfb), (0, $edf87b50170125f7$export$189f0d593022b199));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        if (!this.panning_) {
            this.panning_ = true;
            map.getView().beginInteraction();
        }
        const targetPointers = this.targetPointers;
        const centroid = map.getEventPixel((0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(targetPointers));
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                const delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                const map = mapBrowserEvent.map;
                const view = map.getView();
                (0, $1bd0a226f9a16141$export$dcdf75081b88279d)(delta, view.getResolution());
                (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                const distance = this.kinetic_.getDistance();
                const angle = this.kinetic_.getAngle();
                const center = view.getCenterInternal();
                const centerpx = map.getPixelFromCoordinateInternal(center);
                const dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
        this.lastCentroid = null;
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        return false;
    }
}
var $c11585da26a016db$export$2e2bcd8739ae039 = $c11585da26a016db$var$DragPan;


/**
 * @module ol/interaction/DragRotate
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ class $197c7092261b2aa0$var$DragRotate extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            stopDown: (0, $013a1733c226ec50$export$8f11cee4bdc7e668)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$4e5f01653f9f1f82);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $d65f0a322291d127$export$e20fbacbb41798b)) return;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            const delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $edf87b50170125f7$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        return false;
    }
}
var $197c7092261b2aa0$export$2e2bcd8739ae039 = $197c7092261b2aa0$var$DragRotate;


/**
 * @module ol/interaction/DragZoom
 */ /**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box


/**
 * @module ol/render/Box
 */ 

class $c47adf75308683a6$var$RenderBox extends (0, $3273ed08087da3da$export$2e2bcd8739ae039) {
    /**
   * @param {string} className CSS class name.
   */ constructor(className){
        super();
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = document.createElement("div");
        this.element_.style.position = "absolute";
        this.element_.style.pointerEvents = "auto";
        this.element_.className = "ol-box " + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    /**
   * Clean up.
   */ disposeInternal() {
        this.setMap(null);
    }
    /**
   * @private
   */ render_() {
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const px = "px";
        const style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            const style = this.element_.style;
            style.left = "inherit";
            style.top = "inherit";
            style.width = "inherit";
            style.height = "inherit";
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    }
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    }
    /**
   * Creates or updates the cached geometry.
   */ createOrUpdateGeometry() {
        if (!this.map_) return;
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        const coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    }
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ getGeometry() {
        return this.geometry_;
    }
}
var $c47adf75308683a6$export$2e2bcd8739ae039 = $c47adf75308683a6$var$RenderBox;



/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ const $e05f414bc3918235$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: "boxstart",
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: "boxdrag",
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: "boxend",
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: "boxcancel"
};
class $e05f414bc3918235$export$7053c33c051365ea extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */ constructor(type, coordinate, mapBrowserEvent){
        super(type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ class $e05f414bc3918235$var$DragBox extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ this.un;
        options = options ? options : {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ this.box_ = new (0, $c47adf75308683a6$export$2e2bcd8739ae039)(options.className || "ol-dragbox");
        /**
     * @type {number}
     * @private
     */ this.minArea_ = options.minArea !== undefined ? options.minArea : 64;
        if (options.onBoxEnd) this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$1238ad6b5e7fff70);
        /**
     * @private
     * @type {EndCondition}
     */ this.boxEndCondition_ = options.boxEndCondition ? options.boxEndCondition : this.defaultBoxEndCondition;
    }
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        const width = endPixel[0] - startPixel[0];
        const height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    }
    /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ getGeometry() {
        return this.box_.getGeometry();
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        if (!this.startPixel_) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        if (!this.startPixel_) return false;
        this.box_.setMap(null);
        const completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea(completeBox ? $e05f414bc3918235$var$DragBoxEventType.BOXEND : $e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        return false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {}
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        if (!active) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setActive(active);
    }
}
var $e05f414bc3918235$export$2e2bcd8739ae039 = $e05f414bc3918235$var$DragBox;




/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ class $afc7f51010a5b660$var$DragZoom extends (0, $e05f414bc3918235$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$5d31fe68a477cfbb);
        super({
            condition: condition,
            className: options.className || "ol-dragzoom",
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {
        const map = this.getMap();
        const view = /** @type {!import("../View.js").default} */ map.getView();
        let geometry = this.getGeometry();
        if (this.out_) {
            const rotatedExtent = view.rotatedExtentForGeometry(geometry);
            const resolution = view.getResolutionForExtentInternal(rotatedExtent);
            const factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
        });
    }
}
var $afc7f51010a5b660$export$2e2bcd8739ae039 = $afc7f51010a5b660$var$DragZoom;


/**
 * @module ol/interaction/KeyboardPan
 */ 

/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var $368e06a3031941b5$export$2e2bcd8739ae039 = {
    LEFT: "ArrowLeft",
    UP: "ArrowUp",
    RIGHT: "ArrowRight",
    DOWN: "ArrowDown"
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ class $178bb1517d626802$var$KeyboardPan extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $edf87b50170125f7$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $edf87b50170125f7$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).DOWN || key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).LEFT || key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).RIGHT || key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).UP)) {
                const map = mapBrowserEvent.map;
                const view = map.getView();
                const mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                let deltaX = 0, deltaY = 0;
                if (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
                else if (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
                else if (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                const delta = [
                    deltaX,
                    deltaY
                ];
                (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(delta, view.getRotation());
                (0, $39210df8527e63e5$export$4c486572e961a974)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $178bb1517d626802$export$2e2bcd8739ae039 = $178bb1517d626802$var$KeyboardPan;


/**
 * @module ol/interaction/KeyboardZoom
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ class $2237fabfa170eefc$var$KeyboardZoom extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, $edf87b50170125f7$export$32603ad571dd22b5)(mapBrowserEvent) && (0, $edf87b50170125f7$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN || mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYPRESS) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key === "+" || key === "-")) {
                const map = mapBrowserEvent.map;
                const delta = key === "+" ? this.delta_ : -this.delta_;
                const view = map.getView();
                (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $2237fabfa170eefc$export$2e2bcd8739ae039 = $2237fabfa170eefc$var$KeyboardZoom;


/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ class $9a54ea8d5f7a49ee$var$Kinetic {
    /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */ constructor(decay, minVelocity, delay){
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    /**
   * FIXME empty description for jsdoc
   */ begin() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   */ update(x, y) {
        this.points_.push(x, y, Date.now());
    }
    /**
   * @return {boolean} Whether we should do kinetic animation.
   */ end() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        const delay = Date.now() - this.delay_;
        const lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        let firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        const duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        const dx = this.points_[lastIndex] - this.points_[firstIndex];
        const dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    }
    /**
   * @return {number} Total distance travelled (pixels).
   */ getDistance() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    }
    /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ getAngle() {
        return this.angle_;
    }
}
var $9a54ea8d5f7a49ee$export$2e2bcd8739ae039 = $9a54ea8d5f7a49ee$var$Kinetic;


/**
 * @module ol/interaction/MouseWheelZoom
 */ 




/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ class $aaa378764710d71e$var$MouseWheelZoom extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        const condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {?import("../coordinate.js").Coordinate}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.deltaPerZoom_ = 300;
    }
    /**
   * @private
   */ endInteraction_() {
        this.trackpadTimeoutId_ = undefined;
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_);
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const type = mapBrowserEvent.type;
        if (type !== (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL) return true;
        const map = mapBrowserEvent.map;
        const wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.coordinate;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        let delta;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL) {
            delta = wheelEvent.deltaY;
            if ((0, $67c66761d21428d0$export$8442bdfd18b7b8a6) && wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) delta /= (0, $67c66761d21428d0$export$6b83a0446fc26f94);
            if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 40;
        }
        if (delta === 0) return false;
        this.lastDelta_ = delta;
        const now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? "trackpad" : "wheel";
        const view = map.getView();
        if (this.mode_ === "trackpad" && !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        const timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    }
    /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ handleWheelZoom_(map) {
        const view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        let delta = -(0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, this.lastAnchor_, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    }
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    }
}
var $aaa378764710d71e$export$2e2bcd8739ae039 = $aaa378764710d71e$var$MouseWheelZoom;


/**
 * @module ol/interaction/PinchRotate
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ class $9727451f2459496c$var$PinchRotate extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        let rotationDelta = 0.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        // angle between touches
        const angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            const delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $d65f0a322291d127$export$e20fbacbb41798b)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(this.targetPointers)));
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $9727451f2459496c$export$2e2bcd8739ae039 = $9727451f2459496c$var$PinchRotate;


/**
 * @module ol/interaction/PinchZoom
 */ 

/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ class $79c946b60b88d4a6$var$PinchZoom extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        let scaleDelta = 1.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        const dx = touch0.clientX - touch1.clientX;
        const dy = touch0.clientY - touch1.clientY;
        // distance between touches
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(this.targetPointers)));
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $79c946b60b88d4a6$export$2e2bcd8739ae039 = $79c946b60b88d4a6$var$PinchZoom;


function $e3fbd36d629ecc04$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ const interactions = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    const kinetic = new (0, $9a54ea8d5f7a49ee$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    const altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $197c7092261b2aa0$export$2e2bcd8739ae039)());
    const doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $b50403621294a654$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    const dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $c11585da26a016db$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    const pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $9727451f2459496c$export$2e2bcd8739ae039)());
    const pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $79c946b60b88d4a6$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    const keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $178bb1517d626802$export$2e2bcd8739ae039)());
        interactions.push(new (0, $2237fabfa170eefc$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    const mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $aaa378764710d71e$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    const shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $afc7f51010a5b660$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}









/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {Object<string, import("rbush").default>|null} declutter Declutter trees by declutter group.
 * When null, no decluttering is needed because no layers have decluttering enabled.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, ?FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $41aa29ae0c4b607a$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $534f30fce11effcd$export$2e2bcd8739ae039)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $0b703156bb914e6f$export$2e2bcd8739ae039)) layer.getLayers().forEach($41aa29ae0c4b607a$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function $41aa29ae0c4b607a$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $534f30fce11effcd$export$2e2bcd8739ae039)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $0b703156bb914e6f$export$2e2bcd8739ae039)) {
        const layers = layer.getLayers().getArray();
        for(let i = 0, ii = layers.length; i < ii; ++i)$41aa29ae0c4b607a$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ class $41aa29ae0c4b607a$var$Map extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {MapOptions} [options] Map options.
   */ constructor(options){
        super();
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {MapEventHandler<void>}
     */ this.un;
        const optionsInternal = $41aa29ae0c4b607a$var$createOptionsInternal(options);
        /**
     * @private
     * @type {boolean|undefined}
     */ this.renderComplete_;
        /**
     * @private
     * @type {boolean}
     */ this.loaded_ = true;
        /** @private */ this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $67c66761d21428d0$export$6b83a0446fc26f94);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = this.animationDelay_.bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ this.viewport_ = document.createElement("div");
        this.viewport_.className = "ol-viewport" + ("ontouchstart" in window ? " ol-touch" : "");
        this.viewport_.style.position = "relative";
        this.viewport_.style.overflow = "hidden";
        this.viewport_.style.width = "100%";
        this.viewport_.style.height = "100%";
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainer_ = document.createElement("div");
        this.overlayContainer_.style.position = "absolute";
        this.overlayContainer_.style.zIndex = "0";
        this.overlayContainer_.style.width = "100%";
        this.overlayContainer_.style.height = "100%";
        this.overlayContainer_.style.pointerEvents = "none";
        this.overlayContainer_.className = "ol-overlaycontainer";
        this.viewport_.appendChild(this.overlayContainer_);
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainerStopEvent_ = document.createElement("div");
        this.overlayContainerStopEvent_.style.position = "absolute";
        this.overlayContainerStopEvent_.style.zIndex = "0";
        this.overlayContainerStopEvent_.style.width = "100%";
        this.overlayContainerStopEvent_.style.height = "100%";
        this.overlayContainerStopEvent_.style.pointerEvents = "none";
        this.overlayContainerStopEvent_.className = "ol-overlaycontainer-stopevent";
        this.viewport_.appendChild(this.overlayContainerStopEvent_);
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.targetElement_ = null;
        /**
     * @type {ResizeObserver}
     */ this.resizeObserver_ = new ResizeObserver(()=>this.updateSize());
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || (0, $af7495b2f822d5e9$export$ebe90cb607ad99e)();
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || (0, $e3fbd36d629ecc04$export$ebe90cb607ad99e)({
            onFocusOnly: true
        });
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, $4c51fd53052a6bbc$export$2e2bcd8739ae039)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP, this.handleLayerGroupChanged_);
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW, this.handleViewChanged_);
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE, this.handleSizeChanged_);
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET, this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        const map = this;
        if (options.view && !(options.view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039))) options.view.then(function(viewOptions) {
            map.setView(new (0, $70364d0195659942$export$2e2bcd8739ae039)(viewOptions));
        });
        this.controls.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ (event)=>{
            event.element.setMap(this);
        });
        this.controls.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.interactions.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(this);
        });
        this.interactions.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.overlays_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            this.addOverlayInternal_(event.element);
        });
        this.overlays_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            const id = event.element.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ (control)=>{
            control.setMap(this);
        });
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ (interaction)=>{
            interaction.setMap(this);
        });
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
    }
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ addControl(control) {
        this.getControls().push(control);
    }
    /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ addInteraction(interaction) {
        this.getInteractions().push(interaction);
    }
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ addLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ handleLayerAdd_(event) {
        $41aa29ae0c4b607a$var$setLayerMapProperty(event.layer, this);
    }
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ addOverlay(overlay) {
        this.getOverlays().push(overlay);
    }
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ addOverlayInternal_(overlay) {
        const id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    }
    /**
   *
   * Clean up.
   */ disposeInternal() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.resizeObserver_.disconnect();
        this.setTarget(null);
        super.disposeInternal();
    }
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ forEachFeatureAtPixel(pixel, callback, options) {
        if (!this.frameState_ || !this.renderer_) return;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $013a1733c226ec50$export$22e23a2304399231);
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    }
    /**
   * Get all features that intersect a pixel on the viewport.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ getFeaturesAtPixel(pixel, options) {
        const features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, options);
        return features;
    }
    /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ getAllLayers() {
        const layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, $0b703156bb914e6f$export$2e2bcd8739ae039)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    }
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ hasFeatureAtPixel(pixel, options) {
        if (!this.frameState_ || !this.renderer_) return false;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $013a1733c226ec50$export$22e23a2304399231);
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    }
    /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    }
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ getEventCoordinateInternal(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    }
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ getEventPixel(event) {
        const viewport = this.viewport_;
        const viewportPosition = viewport.getBoundingClientRect();
        const viewportSize = this.getSize();
        const scaleX = viewportPosition.width / viewportSize[0];
        const scaleY = viewportPosition.height / viewportSize[1];
        const eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        "changedTouches" in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            (eventPosition.clientX - viewportPosition.left) / scaleX,
            (eventPosition.clientY - viewportPosition.top) / scaleY
        ];
    }
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET);
    }
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ getTargetElement() {
        return this.targetElement_;
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ getCoordinateFromPixel(pixel) {
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ getCoordinateFromPixelInternal(pixel) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ getControls() {
        return this.controls;
    }
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ getOverlays() {
        return this.overlays_;
    }
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */ getOverlayById(id) {
        const overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    }
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ getInteractions() {
        return this.interactions;
    }
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP);
    }
    /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ setLayers(layers) {
        const group = this.getLayerGroup();
        if (layers instanceof (0, $931ffc4e747c14db$export$2e2bcd8739ae039)) {
            group.setLayers(layers);
            return;
        }
        const collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    }
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ getLayers() {
        const layers = this.getLayerGroup().getLayers();
        return layers;
    }
    /**
   * @return {boolean} Layers have sources that are still loading.
   */ getLoadingOrNotReady() {
        const layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const state = layerStatesArray[i];
            if (!state.visible) continue;
            const renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            const source = state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ getPixelFromCoordinate(coordinate) {
        const viewCoordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ getPixelFromCoordinateInternal(coordinate) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE);
    }
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ getView() {
        return /** @type {View} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW);
    }
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ getViewport() {
        return this.viewport_;
    }
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ getOverlayContainer() {
        return this.overlayContainer_;
    }
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    }
    /**
   * @return {!Document} The document where the map is displayed.
   */ getOwnerDocument() {
        const targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    }
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $4c51fd53052a6bbc$export$f08ad5eceeff5d45)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    }
    /**
   * @param {UIEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ handleBrowserEvent(browserEvent, type) {
        type = type || browserEvent.type;
        const mapBrowserEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    }
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        const originalEvent = /** @type {PointerEvent} */ mapBrowserEvent.originalEvent;
        const eventType = originalEvent.type;
        if (eventType === (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERDOWN || eventType === (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL || eventType === (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN) {
            const doc = this.getOwnerDocument();
            const rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            const target = /** @type {Node} */ originalEvent.target;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !(rootNode === doc ? doc.documentElement : rootNode).contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            const interactionsArray = this.getInteractions().getArray().slice();
            for(let i = interactionsArray.length - 1; i >= 0; i--){
                const interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                const cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    }
    /**
   * @protected
   */ handlePostRender() {
        const frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        const tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            let maxTotalLoading = this.maxTilesLoading_;
            let maxNewLoads = maxTotalLoading;
            if (frameState) {
                const hints = frameState.viewHints;
                if (hints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING]) {
                    const lowOnFrameBudget = Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_ === true) {
                if (this.hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADSTART, this, frameState));
            }
        }
        const postRenderFunctions = this.postRenderFunctions_;
        for(let i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    }
    /**
   * @private
   */ handleSizeChanged_() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    }
    /**
   * @private
   */ handleTargetChanged_() {
        if (this.mapBrowserEventHandler_) {
            for(let i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            (0, $075f937d7366f1a2$export$1d0aa160432dfea5)(this.viewport_);
        }
        if (this.targetElement_) {
            this.resizeObserver_.unobserve(this.targetElement_);
            const rootNode = this.targetElement_.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
            this.setSize(undefined);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        const target = this.getTarget();
        const targetElement = typeof target === "string" ? document.getElementById(target) : target;
        this.targetElement_ = targetElement;
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = new (0, $fa78c97693b12120$export$2e2bcd8739ae039)(this);
            this.mapBrowserEventHandler_ = new (0, $6085d006f9d0efe2$export$2e2bcd8739ae039)(this, this.moveTolerance_);
            for(const key in 0, $150f412a4a7fa263$export$2e2bcd8739ae039)this.mapBrowserEventHandler_.addEventListener((0, $150f412a4a7fa263$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent.bind(this));
            this.viewport_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
            this.viewport_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_, (0, $67c66761d21428d0$export$f751ce96c6c4e4fc) ? {
                passive: false
            } : false);
            const keyboardEventTarget = !this.keyboardEventTarget_ ? targetElement : this.keyboardEventTarget_;
            this.targetChangeHandlerKeys_ = [
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(keyboardEventTarget, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN, this.handleBrowserEvent, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(keyboardEventTarget, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYPRESS, this.handleBrowserEvent, this)
            ];
            const rootNode = targetElement.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.observe(rootNode.host);
            this.resizeObserver_.observe(targetElement);
        }
        this.updateSize();
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    }
    /**
   * @private
   */ handleTileChange_() {
        this.render();
    }
    /**
   * @private
   */ handleViewPropertyChanged_() {
        this.render();
    }
    /**
   * @private
   */ handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        const view = this.getView();
        if (view) {
            this.updateViewportSize_(this.getSize());
            this.viewPropertyListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(view, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(view, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    }
    /**
   * @private
   */ handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        const layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, $0b703156bb914e6f$export$2f5ff21d758d25a7)("addlayer", layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.render, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.render, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, "addlayer", this.handleLayerAdd_, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, "removelayer", this.handleLayerRemove_, this)
            ];
        }
        this.render();
    }
    /**
   * @return {boolean} Is rendered.
   */ isRendered() {
        return !!this.frameState_;
    }
    /**
   * @private
   */ animationDelay_() {
        this.animationDelayKey_ = undefined;
        this.renderFrame_(Date.now());
    }
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    }
    /**
   * Redraws all text after new fonts have loaded
   */ redrawText() {
        const layerStates = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStates.length; i < ii; ++i){
            const layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    }
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ render() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ removeControl(control) {
        return this.getControls().remove(control);
    }
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    }
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ removeLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ handleLayerRemove_(event) {
        $41aa29ae0c4b607a$var$removeLayerMapProperty(event.layer);
    }
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    }
    /**
   * @param {number} time Time.
   * @private
   */ renderFrame_(time) {
        const size = this.getSize();
        const view = this.getView();
        const previousFrameState = this.frameState_;
        /** @type {?FrameState} */ let frameState = null;
        if (size !== undefined && (0, $cc435a5409103773$export$622c471beb1693c7)(size) && view && view.isDef()) {
            const viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            const viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutter: null,
                extent: (0, $6da4c8ed3074c92b$export$13ba650faf8308)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, $6c5e11070e371322$export$5e82334337e0f204)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                const rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, $6da4c8ed3074c92b$export$13ba650faf8308)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                const moveStart = !this.previousExtent_ || !(0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(this.previousExtent_) && !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(this.previousExtent_);
                }
            }
            const idle = this.previousExtent_ && !frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING] && !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).MOVEEND, this, frameState));
                (0, $6da4c8ed3074c92b$export$9cd59f9826255e47)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this, frameState));
        this.renderComplete_ = this.hasListener((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADSTART) || this.hasListener((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADEND) || this.hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE) ? !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady() : undefined;
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(()=>{
            this.postRenderTimeoutHandle_ = undefined;
            this.handlePostRender();
        }, 0);
    }
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ setLayerGroup(layerGroup) {
        const oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, $0b703156bb914e6f$export$2f5ff21d758d25a7)("removelayer", oldLayerGroup));
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
    }
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ setSize(size) {
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE, size);
    }
    /**
   * Set the target element to render this map into.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ setTarget(target) {
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET, target);
    }
    /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ setView(view) {
        if (!view || view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039)) {
            this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW, view);
            return;
        }
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW, new (0, $70364d0195659942$export$2e2bcd8739ae039)());
        const map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, $70364d0195659942$export$2e2bcd8739ae039)(viewOptions));
        });
    }
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ updateSize() {
        const targetElement = this.getTargetElement();
        let size = undefined;
        if (targetElement) {
            const computedStyle = getComputedStyle(targetElement);
            const width = targetElement.offsetWidth - parseFloat(computedStyle["borderLeftWidth"]) - parseFloat(computedStyle["paddingLeft"]) - parseFloat(computedStyle["paddingRight"]) - parseFloat(computedStyle["borderRightWidth"]);
            const height = targetElement.offsetHeight - parseFloat(computedStyle["borderTopWidth"]) - parseFloat(computedStyle["paddingTop"]) - parseFloat(computedStyle["paddingBottom"]) - parseFloat(computedStyle["borderBottomWidth"]);
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    width,
                    height
                ];
                if (!(0, $cc435a5409103773$export$622c471beb1693c7)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, $8c65b0699f3f3f8e$export$c106dd0671a0fc2d)("No map visible because the map container's width or height are 0.");
            }
        }
        const oldSize = this.getSize();
        if (size && (!oldSize || !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(size, oldSize))) {
            this.setSize(size);
            this.updateViewportSize_(size);
        }
    }
    /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ updateViewportSize_(size) {
        const view = this.getView();
        if (view) view.setViewportSize(size);
    }
}
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $41aa29ae0c4b607a$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ let keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === "string" ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ const values = {};
    const layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === "function" ? /** @type {LayerGroup} */ options.layers : new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW] = options.view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039) ? options.view : new (0, $70364d0195659942$export$2e2bcd8739ae039)();
    /** @type {Collection<import("./control/Control.js").default>} */ let controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.controls.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.controls.getArray === "function", "Expected `controls` to be an array or an `ol/Collection.js`");
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction").default>} */ let interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.interactions.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.interactions.getArray === "function", "Expected `interactions` to be an array or an `ol/Collection.js`");
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ let overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.overlays.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.overlays.getArray === "function", "Expected `overlays` to be an array or an `ol/Collection.js`");
            overlays = options.overlays;
        }
    } else overlays = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $41aa29ae0c4b607a$export$2e2bcd8739ae039 = $41aa29ae0c4b607a$var$Map;


/**
 * @module ol/source/OSM
 */ /**
 * @module ol/source/XYZ
 */ /**
 * @module ol/source/TileImage
 */ 
/**
 * @module ol/ImageTile
 */ /**
 * @module ol/Tile
 */ 




/**
 * A function that takes an {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes an {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ class $0f235d2d04095c6e$var$Tile extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */ constructor(tileCoord, state, options){
        super();
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ this.state = state;
        /**
     * An "interim" tile for this tile. The interim tile may be used while this
     * one is loading, for "smooth" transitions when changing params/dimensions
     * on the source.
     * @type {Tile|null}
     */ this.interimTile = null;
        /**
     * A key assigned to the tile. This is used by the tile source to determine
     * if this tile can effectively be used, or if a new tile should be created
     * and this one be used as an interim tile for this new tile.
     * @type {string}
     */ this.key = "";
        /**
     * The duration for the opacity transition.
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ this.interpolate = !!options.interpolate;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ release() {
        if (this.state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
        this.setState((0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY);
    }
    /**
   * @return {string} Key.
   */ getKey() {
        return this.key + "/" + this.tileCoord;
    }
    /**
   * Get the interim tile most suitable for rendering using the chain of interim
   * tiles. This corresponds to the  most recent tile that has been loaded, if no
   * such tile exists, the original tile is returned.
   * @return {!Tile} Best tile for rendering.
   */ getInterimTile() {
        let tile = this.interimTile;
        if (!tile) //empty chain
        return this;
        // find the first loaded tile and return it. Since the chain is sorted in
        // decreasing order of creation time, there is no need to search the remainder
        // of the list (all those tiles correspond to older requests and will be
        // cleaned up by refreshInterimChain)
        do {
            if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                // Show tile immediately instead of fading it in after loading, because
                // the interim tile is in place already
                this.transition_ = 0;
                return tile;
            }
            tile = tile.interimTile;
        }while (tile);
        // we can not find a better tile
        return this;
    }
    /**
   * Goes through the chain of interim tiles and discards sections of the chain
   * that are no longer relevant.
   */ refreshInterimChain() {
        let tile = this.interimTile;
        if (!tile) return;
        /** @type {Tile} */ let prev = this;
        do {
            if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                //we have a loaded tile, we can discard the rest of the list
                //we would could abort any LOADING tile request
                //older than this tile (i.e. any LOADING tile following this entry in the chain)
                tile.interimTile = null;
                break;
            }
            if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) //keep this LOADING tile any loaded tiles later in the chain are
            //older than this tile, so we're still interested in the request
            prev = tile;
            else if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) //the head of the list is the most current tile, we don't need
            //to start any other requests for this chain
            prev.interimTile = tile.interimTile;
            else prev = tile;
            tile = prev.interimTile;
        }while (tile);
    }
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ getTileCoord() {
        return this.tileCoord;
    }
    /**
   * @return {import("./TileState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ setState(state) {
        if (this.state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR && this.state > state) throw new Error("Tile load sequence violation");
        this.state = state;
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ load() {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ getAlpha(id, time) {
        if (!this.transition_) return 1;
        let start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        const delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $c7ccf7e681a9b333$export$929e5a82286172a6)(delta / this.transition_);
    }
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    }
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    }
}
var $0f235d2d04095c6e$export$2e2bcd8739ae039 = $0f235d2d04095c6e$var$Tile;





class $cd3bc8d185522361$var$ImageTile extends (0, $0f235d2d04095c6e$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, crossOrigin, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ this.image_ = new Image();
        if (crossOrigin !== null) this.image_.crossOrigin = crossOrigin;
        /**
     * @private
     * @type {?function():void}
     */ this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|HTMLImageElement} element Element.
   */ setImage(element) {
        this.image_ = element;
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ handleImageError_() {
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.image_ = $cd3bc8d185522361$var$getBlankImage();
        this.changed();
    }
    /**
   * Tracks successful image load.
   *
   * @private
   */ handleImageLoad_() {
        const image = /** @type {HTMLImageElement} */ this.image_;
        if (image.naturalWidth && image.naturalHeight) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        else this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   *
   * @api
   */ load() {
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        }
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $b54439be79d4619a$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    }
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ unlistenImage_() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    }
}
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */ function $cd3bc8d185522361$var$getBlankImage() {
    const ctx = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1);
    ctx.fillStyle = "rgba(0,0,0,0)";
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $cd3bc8d185522361$export$2e2bcd8739ae039 = $cd3bc8d185522361$var$ImageTile;


/**
 * @module ol/reproj/Tile
 */ /**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ const $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855 = 0.5;





/**
 * @module ol/reproj/Triangulation
 */ 


/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ const $6be53f6edfbf1854$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ const $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ class $6be53f6edfbf1854$var$Triangulation {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   */ constructor(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution){
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ let transformInvCache = {};
        const transformInv = (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            const key = c[0] + "/" + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(maxSourceExtent) >= (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.targetProj_.getExtent()) : null;
        const destinationTopLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(targetExtent);
        const destinationTopRight = (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(targetExtent);
        const destinationBottomRight = (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(targetExtent);
        const destinationBottomLeft = (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(targetExtent);
        const sourceTopLeft = this.transformInv_(destinationTopLeft);
        const sourceTopRight = this.transformInv_(destinationTopRight);
        const sourceBottomRight = this.transformInv_(destinationBottomRight);
        const sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ const maxSubdivision = $6be53f6edfbf1854$var$MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, $6da4c8ed3074c92b$export$520c40045967cb15)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            let leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((triangle)=>{
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                    const newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    const minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    const maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    }
    /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        const sourceQuadExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        const sourceCoverageX = this.sourceWorldWidth_ ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        const sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        const wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        let needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                const targetQuadExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
                    a,
                    b,
                    c,
                    d
                ]);
                const targetCoverageX = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        let isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                const center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                const centerSrc = this.transformInv_(center);
                let dx;
                if (wrapsX) {
                    const centerSrcEstimX = ((0, $6b000a049d919fe5$export$ba467bec01d66def)(aSrc[0], sourceWorldWidth) + (0, $6b000a049d919fe5$export$ba467bec01d66def)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $6b000a049d919fe5$export$ba467bec01d66def)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                const dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                const centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    const bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    const bcSrc = this.transformInv_(bc);
                    const da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    const daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    const ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    const abSrc = this.transformInv_(ab);
                    const cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    const cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    }
    /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ calculateSourceExtent() {
        const extent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        this.triangles_.forEach(function(triangle, i, arr) {
            const src = triangle.source;
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[0]);
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[1]);
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[2]);
        });
        return extent;
    }
    /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ getTriangles() {
        return this.triangles_;
    }
}
var $6be53f6edfbf1854$export$2e2bcd8739ae039 = $6be53f6edfbf1854$var$Triangulation;


/**
 * @module ol/reproj
 */ 



let $2b0a118af78fb031$var$brokenDiagonalRendering_;
const $2b0a118af78fb031$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $2b0a118af78fb031$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $2b0a118af78fb031$var$isBrokenDiagonalRendering() {
    if ($2b0a118af78fb031$var$brokenDiagonalRendering_ === undefined) {
        const ctx = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(6, 6, $2b0a118af78fb031$export$a166f0857c555517);
        ctx.globalCompositeOperation = "lighter";
        ctx.fillStyle = "rgba(210, 0, 0, 0.75)";
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        const data = ctx.getImageData(0, 0, 3, 3).data;
        $2b0a118af78fb031$var$brokenDiagonalRendering_ = $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 0) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 4) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 8);
        (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(ctx);
        $2b0a118af78fb031$export$a166f0857c555517.push(ctx.canvas);
    }
    return $2b0a118af78fb031$var$brokenDiagonalRendering_;
}
function $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    const sourceCenter = (0, $9c4744460e43e41b$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    let sourceResolution = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    const targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    const sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    const sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(sourceExtent, sourceCenter)) {
        const compensationFactor = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $2b0a118af78fb031$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    const targetCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(targetExtent);
    let sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $6da4c8ed3074c92b$export$f9ed8a3d123a08e2)(targetExtent, function(corner) {
        sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $2b0a118af78fb031$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle, clipExtent) {
    const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $2b0a118af78fb031$export$a166f0857c555517);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = "lighter";
    const sourceDataExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
    sources.forEach(function(src, i, arr) {
        (0, $6da4c8ed3074c92b$export$8b58be045bf06082)(sourceDataExtent, src.extent);
    });
    let stitchContext;
    const stitchScale = pixelRatio / sourceResolution;
    // Round up Float32 scale values to prevent interpolation in Firefox.
    const inverseScale = (interpolate ? 1 : 1 + Math.pow(2, -24)) / stitchScale;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        stitchContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(Math.round((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceDataExtent) * stitchScale), Math.round((0, $6da4c8ed3074c92b$export$c08559766941f856)(sourceDataExtent) * stitchScale), $2b0a118af78fb031$export$a166f0857c555517);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        if (sourceExtent && clipExtent) {
            const xPos = (sourceExtent[0] - sourceDataExtent[0]) * stitchScale;
            const yPos = -(sourceExtent[3] - sourceDataExtent[3]) * stitchScale;
            const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceExtent) * stitchScale;
            const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(sourceExtent) * stitchScale;
            stitchContext.rect(xPos, yPos, width, height);
            stitchContext.clip();
        }
        sources.forEach(function(src, i, arr) {
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) {
                if (src.clipExtent) {
                    stitchContext.save();
                    const xPos = (src.clipExtent[0] - sourceDataExtent[0]) * stitchScale;
                    const yPos = -(src.clipExtent[3] - sourceDataExtent[3]) * stitchScale;
                    const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(src.clipExtent) * stitchScale;
                    const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(src.clipExtent) * stitchScale;
                    stitchContext.rect(interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? width : Math.round(xPos + width) - Math.round(xPos), interpolate ? height : Math.round(yPos + height) - Math.round(yPos));
                    stitchContext.clip();
                }
                const xPos = (src.extent[0] - sourceDataExtent[0]) * stitchScale;
                const yPos = -(src.extent[3] - sourceDataExtent[3]) * stitchScale;
                const srcWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(src.extent) * stitchScale;
                const srcHeight = (0, $6da4c8ed3074c92b$export$c08559766941f856)(src.extent) * stitchScale;
                stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? srcWidth : Math.round(xPos + srcWidth) - Math.round(xPos), interpolate ? srcHeight : Math.round(yPos + srcHeight) - Math.round(yPos));
                if (src.clipExtent) stitchContext.restore();
            }
        });
    }
    const targetTopLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ const source = triangle.source;
        const target = triangle.target;
        let x0 = source[0][0], y0 = source[0][1];
        let x1 = source[1][0], y1 = source[1][1];
        let x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        const u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        const v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        const u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        const v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        const u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        const v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        const sourceNumericalShiftX = x0;
        const sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        const augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        const affineCoefs = (0, $6b000a049d919fe5$export$8240f01c446270e6)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($2b0a118af78fb031$var$isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            const steps = 4;
            const ud = u0 - u1;
            const vd = v0 - v1;
            for(let step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        let image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(inverseScale, -inverseScale);
        } else {
            const source = sources[0];
            const extent = source.extent;
            image = source.image;
            context.scale((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / image.width, -(0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(stitchContext);
        $2b0a118af78fb031$export$a166f0857c555517.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = "source-over";
        context.strokeStyle = "black";
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            const target = triangle.target;
            const u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            const v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            const u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            const v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            const u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            const v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}






/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @typedef {Object} TileOffset
 * @property {import("../ImageTile.js").default} tile Tile.
 * @property {number} offset Offset.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ class $398e350e33050c07$var$ReprojTile extends (0, $0f235d2d04095c6e$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */ constructor(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options){
        super(tileCoord, (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceProj.getExtent() : undefined;
        const targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, $6da4c8ed3074c92b$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $6da4c8ed3074c92b$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        const sourceResolution = (0, $2b0a118af78fb031$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $6be53f6edfbf1854$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $6da4c8ed3074c92b$export$520c40045967cb15)(sourceExtent)) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, $6da4c8ed3074c92b$export$9031237f01de0947)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const tile = getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio);
                    if (tile) {
                        const offset = worldsAway * worldWidth;
                        this.sourceTiles_.push({
                            tile: tile,
                            offset: offset
                        });
                    }
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        }
    }
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @private
   */ reproject_() {
        const sources = [];
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (tile && tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
                extent[0] += source.offset;
                extent[2] += source.offset;
                const clipExtent = this.clipExtent_?.slice();
                if (clipExtent) {
                    clipExtent[0] += source.offset;
                    clipExtent[2] += source.offset;
                }
                sources.push({
                    extent: extent,
                    clipExtent: clipExtent,
                    image: tile.getImage()
                });
            }
        });
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
        else {
            const z = this.wrappedTileCoord_[0];
            const size = this.targetTileGrid_.getTileSize(z);
            const width = typeof size === "number" ? size : size[0];
            const height = typeof size === "number" ? size : size[1];
            const targetResolution = this.targetTileGrid_.getResolution(z);
            const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $2b0a118af78fb031$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        }
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
            this.changed();
            let leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(({ tile: tile })=>{
                const state = tile.getState();
                if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) {
                    leftToLoad++;
                    const sourceListenKey = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(tile, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, function(e) {
                        const state = tile.getState();
                        if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) {
                            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    }, this);
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function({ tile: tile }, i, arr) {
                const state = tile.getState();
                if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) tile.load();
            });
        }
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.sourcesListenerKeys_ = null;
    }
    /**
   * Remove from the cache due to expiry
   */ release() {
        if (this.canvas_) {
            (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(this.canvas_.getContext("2d"));
            (0, $2b0a118af78fb031$export$a166f0857c555517).push(this.canvas_);
            this.canvas_ = null;
        }
        super.release();
    }
}
var $398e350e33050c07$export$2e2bcd8739ae039 = $398e350e33050c07$var$ReprojTile;


/**
 * @module ol/TileCache
 */ /**
 * @module ol/structs/LRUCache
 */ 
/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ class $859b1614288c6316$var$LRUCache {
    /**
   * @param {number} [highWaterMark] High water mark.
   */ constructor(highWaterMark){
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    }
    /**
   * Expire the cache.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ expireCache(keep) {
        while(this.canExpireCache())this.pop();
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.count_ = 0;
        this.entries_ = {};
        this.oldest_ = null;
        this.newest_ = null;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    }
    /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ forEach(f) {
        let entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    }
    /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ get(key, options) {
        const entry = this.entries_[key];
        (0, $35d5ec884318008e$export$a7a9523472993e97)(entry !== undefined, "Tried to get a value for a key that does not exist in the cache");
        if (entry === this.newest_) return entry.value_;
        if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    }
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ remove(key) {
        const entry = this.entries_[key];
        (0, $35d5ec884318008e$export$a7a9523472993e97)(entry !== undefined, "Tried to get a value for a key that does not exist in the cache");
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.count_;
    }
    /**
   * @return {Array<string>} Keys.
   */ getKeys() {
        const keys = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    }
    /**
   * @return {Array<T>} Values.
   */ getValues() {
        const values = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    }
    /**
   * @return {T} Last value.
   */ peekLast() {
        return this.oldest_.value_;
    }
    /**
   * @return {string} Last key.
   */ peekLastKey() {
        return this.oldest_.key_;
    }
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ peekFirstKey() {
        return this.newest_.key_;
    }
    /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ peek(key) {
        return this.entries_[key]?.value_;
    }
    /**
   * @return {T} value Value.
   */ pop() {
        const entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ set(key, value) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(key in this.entries_), "Tried to set a value for a key that is used already");
        const entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    }
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ setSize(size) {
        this.highWaterMark = size;
    }
}
var $859b1614288c6316$export$2e2bcd8739ae039 = $859b1614288c6316$var$LRUCache;


/**
 * @module ol/tilecoord
 */ /**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ function $bf2a04496fadabc6$export$958e3e1a02eac4b6(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y) {
    return z + "/" + x + "/" + y;
}
function $bf2a04496fadabc6$export$a47fb462a08de82f(tileCoord) {
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $bf2a04496fadabc6$export$7f760414a8e3d2b5(tileKey) {
    const [z, x, y] = tileKey.substring(tileKey.lastIndexOf("/") + 1, tileKey.length).split(",").map(Number);
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y);
}
function $bf2a04496fadabc6$export$a807b7874eb66454(key) {
    return key.split("/").map(Number);
}
function $bf2a04496fadabc6$export$d6af199866bfb566(tileCoord) {
    return (tileCoord[1] << tileCoord[0]) + tileCoord[2];
}
function $bf2a04496fadabc6$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    const z = tileCoord[0];
    const x = tileCoord[1];
    const y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    const tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}


class $a12e09565a34db59$var$TileCache extends (0, $859b1614288c6316$export$2e2bcd8739ae039) {
    clear() {
        while(this.getCount() > 0)this.pop().release();
        super.clear();
    }
    /**
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */ expireCache(usedTiles) {
        while(this.canExpireCache()){
            const tile = this.peekLast();
            if (tile.getKey() in usedTiles) break;
            else this.pop().release();
        }
    }
    /**
   * Prune all tiles from the cache that don't have the same z as the newest tile.
   */ pruneExceptNewestZ() {
        if (this.getCount() === 0) return;
        const key = this.peekFirstKey();
        const tileCoord = (0, $bf2a04496fadabc6$export$a807b7874eb66454)(key);
        const z = tileCoord[0];
        this.forEach((tile)=>{
            if (tile.tileCoord[0] !== z) {
                this.remove((0, $bf2a04496fadabc6$export$a47fb462a08de82f)(tile.tileCoord));
                tile.release();
            }
        });
    }
}
var $a12e09565a34db59$export$2e2bcd8739ae039 = $a12e09565a34db59$var$TileCache;



/**
 * @module ol/source/UrlTile
 */ /**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $7e3d7a0f8b272861$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: "tileloadstart",
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: "tileloadend",
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: "tileloaderror"
};


/**
 * @module ol/source/Tile
 */ 
/**
 * @module ol/source/Source
 */ 

/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * * a simple string (e.g. `'© Acme Inc.'`)
 * * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ class $ed6dc99f268f3882$var$Source extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Source options.
   */ constructor(options){
        super();
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ this.projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible !== undefined ? options.attributionsCollapsible : true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */ this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ this.state_ = options.state !== undefined ? options.state : "ready";
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ this.viewRejector = null;
        const self = this;
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
    }
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ getAttributions() {
        return this.attributions_;
    }
    /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    }
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ getProjection() {
        return this.projection;
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        return null;
    }
    /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ getView() {
        return this.viewPromise_;
    }
    /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ getState() {
        return this.state_;
    }
    /**
   * @return {boolean|undefined} Wrap X.
   */ getWrapX() {
        return this.wrapX_;
    }
    /**
   * @return {boolean} Use linear interpolation when resampling.
   */ getInterpolate() {
        return this.interpolate_;
    }
    /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ refresh() {
        this.changed();
    }
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ setAttributions(attributions) {
        this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(attributions);
        this.changed();
    }
    /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ setState(state) {
        this.state_ = state;
        this.changed();
    }
}
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $ed6dc99f268f3882$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (Array.isArray(attributionLike)) return function(frameState) {
        return attributionLike;
    };
    if (typeof attributionLike === "function") return attributionLike;
    return function(frameState) {
        return [
            attributionLike
        ];
    };
}
var $ed6dc99f268f3882$export$2e2bcd8739ae039 = $ed6dc99f268f3882$var$Source;








/**
 * @module ol/tilegrid
 */ /**
 * @module ol/tilegrid/TileGrid
 */ /**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ class $550e524b0d1b61d4$var$TileRange {
    /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */ constructor(minX, maxX, minY, maxY){
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ contains(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ containsTileRange(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    }
    /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ containsXY(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ equals(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   */ extend(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    }
    /**
   * @return {number} Height.
   */ getHeight() {
        return this.maxY - this.minY + 1;
    }
    /**
   * @return {import("./size.js").Size} Size.
   */ getSize() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    }
    /**
   * @return {number} Width.
   */ getWidth() {
        return this.maxX - this.minX + 1;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ intersects(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    }
}
function $550e524b0d1b61d4$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new $550e524b0d1b61d4$var$TileRange(minX, maxX, minY, maxY);
}
var $550e524b0d1b61d4$export$2e2bcd8739ae039 = $550e524b0d1b61d4$var$TileRange;










/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ const $bb602a307ef98bb5$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ const $bb602a307ef98bb5$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ class $bb602a307ef98bb5$var$TileGrid {
    /**
   * @param {Options} options Tile grid options.
   */ constructor(options){
        /**
     * @protected
     * @type {number}
     */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = options.resolutions;
        (0, $35d5ec884318008e$export$a7a9523472993e97)((0, $b998d41b678ed5d1$export$efa610630f9e181)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ (a, b)=>b - a, true), "`resolutions` must be sorted in descending order");
        // check if we've got a consistent zoom factor and origin
        let zoomFactor;
        if (!options.origins) for(let i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.origins_.length == this.resolutions_.length, "Number of `origins` and `resolutions` must be equal");
        }
        const extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent);
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, "Either `origin` or `origins` must be configured, never both");
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.tileSizes_.length == this.resolutions_.length, "Number of `tileSizes` and `resolutions` must be equal");
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c) : null;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, "Either `tileSize` or `tileSizes` must be configured, never both");
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map((size, z)=>{
            const tileRange = new (0, $550e524b0d1b61d4$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                const restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ forEachTileCoord(extent, zoom, callback) {
        const tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(let i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(let j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
        let tileRange, x, y;
        let tileCoordExtent = null;
        let z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
        while(z >= this.minZoom){
            if (x !== undefined && y !== undefined) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(x, x, y, y, tempTileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    }
    /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ getMaxZoom() {
        return this.maxZoom;
    }
    /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ getMinZoom() {
        return this.minZoom;
    }
    /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ getOrigin(z) {
        if (this.origin_) return this.origin_;
        return this.origins_[z];
    }
    /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ getResolution(z) {
        return this.resolutions_[z];
    }
    /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                const minX = tileCoord[1] * 2;
                const minY = tileCoord[2] * 2;
                return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, tempTileRange);
            }
            const tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
        }
        return null;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        const tileCoordZ = tileCoord[0];
        const tileCoordX = tileCoord[1];
        const tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
        if (this.zoomFactor_) {
            const factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            const minX = Math.floor(tileCoordX * factor);
            const minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, minX, minY, minY, tempTileRange);
            const maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            const maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
        }
        const tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
    }
    /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ getTileRangeForExtentAndZ(extent, z, tempTileRange) {
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, $bb602a307ef98bb5$var$tmpTileCoord);
        const minX = $bb602a307ef98bb5$var$tmpTileCoord[1];
        const minY = $bb602a307ef98bb5$var$tmpTileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, $bb602a307ef98bb5$var$tmpTileCoord);
        const maxX = $bb602a307ef98bb5$var$tmpTileCoord[1];
        const maxY = $bb602a307ef98bb5$var$tmpTileCoord[2];
        return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ getTileCoordCenter(tileCoord) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    }
    /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getTileCoordExtent(tileCoord, tempExtent) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        const minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        const minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        const maxX = minX + tileSize[0] * resolution;
        const maxY = minY + tileSize[1] * resolution;
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, tempExtent);
    }
    /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    }
    /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        const z = this.getZForResolution(resolution);
        const scale = resolution / this.getResolution(z);
        const origin = this.getOrigin(z);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS) - 1;
            tileCoordY = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS);
            tileCoordY = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS);
        }
        return (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        const origin = this.getOrigin(z);
        const resolution = this.getResolution(z);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS) - 1;
            tileCoordY = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS);
            tileCoordY = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS);
        }
        return (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ getTileCoordResolution(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    }
    /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ getTileSize(z) {
        if (this.tileSize_) return this.tileSize_;
        return this.tileSizes_[z];
    }
    /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ getFullTileRange(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        return this.fullTileRanges_[z];
    }
    /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ getZForResolution(resolution, opt_direction) {
        const z = (0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(z, this.minZoom, this.maxZoom);
    }
    /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ tileCoordIntersectsViewport(tileCoord, viewport) {
        return (0, $acee589e5b390c5c$export$830a0dafbb2ef1c5)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    }
    /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ calculateTileRanges_(extent) {
        const length = this.resolutions_.length;
        const fullTileRanges = new Array(length);
        for(let z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    }
}
var $bb602a307ef98bb5$export$2e2bcd8739ae039 = $bb602a307ef98bb5$var$TileGrid;







function $5779655d81caea04$export$1f4812384df8a9c5(projection) {
    let tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $5779655d81caea04$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $5779655d81caea04$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    const z = tileCoord[0];
    const center = tileGrid.getTileCoordCenter(tileCoord);
    const projectionExtent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(projectionExtent, center)) {
        const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
        const worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function $5779655d81caea04$export$ce88871416242df8(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : "top-left";
    const resolutions = $5779655d81caea04$var$resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $6da4c8ed3074c92b$export$a1cfd206661d0801)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function $5779655d81caea04$export$38500bbeccc864ff(options) {
    const xyzOptions = options || {};
    const extent = xyzOptions.extent || (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("EPSG:3857").getExtent();
    const gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $5779655d81caea04$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $5779655d81caea04$var$resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, $57cd8651d88957a0$export$e98a216cdcc847dc);
    tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileSize !== undefined ? tileSize : (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c));
    const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(extent);
    const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    const length = maxZoom + 1;
    const resolutions = new Array(length);
    for(let z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $5779655d81caea04$export$a251b12f5601c16f(projection, maxZoom, tileSize, corner) {
    const extent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    return $5779655d81caea04$export$ce88871416242df8(extent, maxZoom, tileSize, corner);
}
function $5779655d81caea04$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
    let extent = projection.getExtent();
    if (!extent) {
        const half = 180 * (0, $03edbd434a9e6608$export$1482081eec883108).degrees / projection.getMetersPerUnit();
        extent = (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(-half, -half, half, half);
    }
    return extent;
}



/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] CacheSize.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 * @abstract
 * @api
 */ class $988a11d09320f6a8$var$TileSource extends (0, $ed6dc99f268f3882$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options SourceTile source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {boolean}
     */ this.opaque_ = options.opaque !== undefined ? options.opaque : false;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        const tileSize = [
            256,
            256
        ];
        if (this.tileGrid) (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../TileCache.js").default}
     */ this.tileCache = new (0, $a12e09565a34db59$export$2e2bcd8739ae039)(options.cacheSize || 0);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || "";
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ this.zDirection = options.zDirection ? options.zDirection : 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.tileCache.canExpireCache();
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */ expireCache(projection, usedTiles) {
        const tileCache = this.getTileCacheForProjection(projection);
        if (tileCache) tileCache.expireCache(usedTiles);
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {number} z Zoom level.
   * @param {import("../TileRange.js").default} tileRange Tile range.
   * @param {function(import("../Tile.js").default):(boolean|void)} callback Called with each
   *     loaded tile.  If the callback returns `false`, the tile will not be
   *     considered loaded.
   * @return {boolean} The tile range is fully covered with loaded tiles.
   */ forEachLoadedTile(projection, z, tileRange, callback) {
        const tileCache = this.getTileCacheForProjection(projection);
        if (!tileCache) return false;
        let covered = true;
        let tile, tileCoordKey, loaded;
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            tileCoordKey = (0, $bf2a04496fadabc6$export$92d0df0f1d25c63c)(z, x, y);
            loaded = false;
            if (tileCache.containsKey(tileCoordKey)) {
                tile = /** @type {!import("../Tile.js").default} */ tileCache.get(tileCoordKey);
                loaded = tile.getState() === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
                if (loaded) loaded = callback(tile) !== false;
            }
            if (!loaded) covered = false;
        }
        return covered;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        return this.key_;
    }
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {boolean} Opaque.
   */ getOpaque(projection) {
        return this.opaque_;
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        const tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
        if (!tileGrid) return null;
        return tileGrid.getResolutions();
    }
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../Tile.js").default} Tile.
   */ getTile(z, x, y, pixelRatio, projection) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ getTileGrid() {
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        if (!this.tileGrid) return (0, $5779655d81caea04$export$1f4812384df8a9c5)(projection);
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   * @protected
   */ getTileCacheForProjection(projection) {
        const sourceProjection = this.getProjection();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(sourceProjection === null || (0, $9c4744460e43e41b$export$fe091d73a555748b)(sourceProjection, projection), "A VectorTile source can only be rendered if it has a projection compatible with the view projection.");
        return this.tileCache;
    }
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        return (0, $cc435a5409103773$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
    }
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ getTileCoordForTileUrlFunction(tileCoord, projection) {
        projection = projection !== undefined ? projection : this.getProjection();
        const tileGrid = this.getTileGridForProjection(projection);
        if (this.getWrapX() && projection.isGlobal()) tileCoord = (0, $5779655d81caea04$export$39a9ce3624977b84)(tileGrid, tileCoord, projection);
        return (0, $bf2a04496fadabc6$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
    }
    /**
   * Remove all cached tiles from the source. The next render cycle will fetch new tiles.
   * @api
   */ clear() {
        this.tileCache.clear();
    }
    refresh() {
        this.clear();
        super.refresh();
    }
    /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ updateCacheSize(tileCount, projection) {
        const tileCache = this.getTileCacheForProjection(projection);
        if (tileCount > tileCache.highWaterMark) tileCache.highWaterMark = tileCount;
    }
    /**
   * Marks a tile coord as being used, without triggering a load.
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ useTile(z, x, y, projection) {}
}
class $988a11d09320f6a8$export$c571855c51e6c4b6 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */ constructor(type, tile){
        super(type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
}
var $988a11d09320f6a8$export$2e2bcd8739ae039 = $988a11d09320f6a8$var$TileSource;



/**
 * @module ol/tileurlfunction
 */ 

function $91dd08a0f5859882$export$f0ecb46e90798741(template, tileGrid) {
    const zRegEx = /\{z\}/g;
    const xRegEx = /\{x\}/g;
    const yRegEx = /\{y\}/g;
    const dashYRegEx = /\{-y\}/g;
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        return template.replace(zRegEx, tileCoord[0].toString()).replace(xRegEx, tileCoord[1].toString()).replace(yRegEx, tileCoord[2].toString()).replace(dashYRegEx, function() {
            const z = tileCoord[0];
            const range = tileGrid.getFullTileRange(z);
            if (!range) throw new Error("The {-y} placeholder requires a tile grid with extent");
            const y = range.getHeight() - tileCoord[2] - 1;
            return y.toString();
        });
    });
}
function $91dd08a0f5859882$export$436f44dbcc31fea3(templates, tileGrid) {
    const len = templates.length;
    const tileUrlFunctions = new Array(len);
    for(let i = 0; i < len; ++i)tileUrlFunctions[i] = $91dd08a0f5859882$export$f0ecb46e90798741(templates[i], tileGrid);
    return $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        const h = (0, $bf2a04496fadabc6$export$d6af199866bfb566)(tileCoord);
        const index = (0, $6b000a049d919fe5$export$ba467bec01d66def)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function $91dd08a0f5859882$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}
function $91dd08a0f5859882$export$2a1fa079bfd73dde(url) {
    const urls = [];
    let match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        const startCharCode = match[1].charCodeAt(0);
        const stopCharCode = match[2].charCodeAt(0);
        let charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        const stop = parseInt(match[2], 10);
        for(let i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}




/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Cache size.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] TileUrlFunction.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Base class for sources providing tiles divided into a tile grid over http.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ class $e6408236331c2614$var$UrlTile extends (0, $988a11d09320f6a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = this.tileUrlFunction === $e6408236331c2614$var$UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    /**
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ getTileLoadFunction() {
        return this.tileLoadFunction;
    }
    /**
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ getTileUrlFunction() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    }
    /**
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ getUrls() {
        return this.urls;
    }
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("../Tile.js").default} */ event.target;
        const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(tile);
        const tileState = tile.getState();
        let type;
        if (tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR ? (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED ? (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $988a11d09320f6a8$export$c571855c51e6c4b6)(type, tile));
    }
    /**
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ setTileLoadFunction(tileLoadFunction) {
        this.tileCache.clear();
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    }
    /**
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        this.tileCache.pruneExceptNewestZ();
        if (typeof key !== "undefined") this.setKey(key);
        else this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ setUrl(url) {
        const urls = (0, $91dd08a0f5859882$export$2a1fa079bfd73dde)(url);
        this.urls = urls;
        this.setUrls(urls);
    }
    /**
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join("\n");
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $91dd08a0f5859882$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
        else this.setKey(key);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        return undefined;
    }
    /**
   * Marks a tile coord as being used, without triggering a load.
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   */ useTile(z, x, y) {
        const tileCoordKey = (0, $bf2a04496fadabc6$export$92d0df0f1d25c63c)(z, x, y);
        if (this.tileCache.containsKey(tileCoordKey)) this.tileCache.get(tileCoordKey);
    }
}
var $e6408236331c2614$export$2e2bcd8739ae039 = $e6408236331c2614$var$UrlTile;






/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Base class for sources providing images divided into a tile grid.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ class $51d055913ca55b5e$var$TileImage extends (0, $e6408236331c2614$export$2e2bcd8739ae039) {
    /**
   * @param {!Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $51d055913ca55b5e$var$defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $cd3bc8d185522361$export$2e2bcd8739ae039);
        /**
     * @protected
     * @type {!Object<string, TileCache>}
     */ this.tileCacheForProjection = {};
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        if (this.tileCache.canExpireCache()) return true;
        for(const key in this.tileCacheForProjection){
            if (this.tileCacheForProjection[key].canExpireCache()) return true;
        }
        return false;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */ expireCache(projection, usedTiles) {
        const usedTileCache = this.getTileCacheForProjection(projection);
        this.tileCache.expireCache(this.tileCache == usedTileCache ? usedTiles : {});
        for(const id in this.tileCacheForProjection){
            const tileCache = this.tileCacheForProjection[id];
            tileCache.expireCache(tileCache == usedTileCache ? usedTiles : {});
        }
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        if (this.getProjection() && projection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
        return this.getGutter();
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        let key = super.getKey();
        if (!this.getInterpolate()) key += ":disable-interpolation";
        return key;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {boolean} Opaque.
   */ getOpaque(projection) {
        if (this.getProjection() && projection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(this.getProjection(), projection)) return false;
        return super.getOpaque(projection);
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        const thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $9c4744460e43e41b$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
        const projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(projection);
        if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $5779655d81caea04$export$1f4812384df8a9c5)(projection);
        return this.tileGridForProjection[projKey];
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   */ getTileCacheForProjection(projection) {
        const thisProj = this.getProjection();
        if (!thisProj || (0, $9c4744460e43e41b$export$fe091d73a555748b)(thisProj, projection)) return this.tileCache;
        const projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(projection);
        if (!(projKey in this.tileCacheForProjection)) this.tileCacheForProjection[projKey] = new (0, $a12e09565a34db59$export$2e2bcd8739ae039)(this.tileCache.highWaterMark);
        return this.tileCacheForProjection[projKey];
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ createTile_(z, x, y, pixelRatio, projection, key) {
        const tileCoord = [
            z,
            x,
            y
        ];
        const urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        const tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE : (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : "", this.crossOrigin, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleTileChange.bind(this));
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!(ImageTile|ReprojTile)} Tile.
   */ getTile(z, x, y, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $9c4744460e43e41b$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        const cache = this.getTileCacheForProjection(projection);
        const tileCoord = [
            z,
            x,
            y
        ];
        let tile;
        const tileCoordKey = (0, $bf2a04496fadabc6$export$a47fb462a08de82f)(tileCoord);
        if (cache.containsKey(tileCoordKey)) tile = cache.get(tileCoordKey);
        const key = this.getKey();
        if (tile && tile.key == key) return tile;
        const sourceTileGrid = this.getTileGridForProjection(sourceProjection);
        const targetTileGrid = this.getTileGridForProjection(projection);
        const wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const newTile = new (0, $398e350e33050c07$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (z, x, y, pixelRatio)=>this.getTileInternal(z, x, y, pixelRatio, sourceProjection), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
        newTile.key = key;
        if (tile) {
            newTile.interimTile = tile;
            newTile.refreshInterimChain();
            cache.replace(tileCoordKey, newTile);
        } else cache.set(tileCoordKey, newTile);
        return newTile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @return {!ImageTile} Tile.
   * @protected
   */ getTileInternal(z, x, y, pixelRatio, projection) {
        let tile = null;
        const tileCoordKey = (0, $bf2a04496fadabc6$export$92d0df0f1d25c63c)(z, x, y);
        const key = this.getKey();
        if (!this.tileCache.containsKey(tileCoordKey)) {
            tile = this.createTile_(z, x, y, pixelRatio, projection, key);
            this.tileCache.set(tileCoordKey, tile);
        } else {
            tile = this.tileCache.get(tileCoordKey);
            if (tile.key != key) {
                // The source's params changed. If the tile has an interim tile and if we
                // can use it then we use it. Otherwise we create a new tile.  In both
                // cases we attempt to assign an interim tile to the new tile.
                const interimTile = tile;
                tile = this.createTile_(z, x, y, pixelRatio, projection, key);
                //make the new tile the head of the list,
                if (interimTile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) //the old tile hasn't begun loading yet, and is now outdated, so we can simply discard it
                tile.interimTile = interimTile.interimTile;
                else tile.interimTile = interimTile;
                tile.refreshInterimChain();
                this.tileCache.replace(tileCoordKey, tile);
            }
        }
        return tile;
    }
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ setRenderReprojectionEdges(render) {
        if (this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        for(const id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
        this.changed();
    }
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ setTileGridForProjection(projection, tilegrid) {
        const proj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
        if (proj) {
            const projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(proj);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
        }
    }
    clear() {
        super.clear();
        for(const id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
    }
}
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ function $51d055913ca55b5e$var$defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $51d055913ca55b5e$export$2e2bcd8739ae039 = $51d055913ca55b5e$var$TileImage;



/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {number} [gutter=0] The size in pixels of the gutter around image tiles to ignore.
 * This allows artifacts of rendering at tile edges to be ignored.
 * Supported images should be wider and taller than the tile size by a value of `2 x gutter`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get
 * tile URL given a tile coordinate and the projection.
 * Required if `url` or `urls` are not provided.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ class $963a7ef65488964c$var$XYZ extends (0, $51d055913ca55b5e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] XYZ options.
   */ constructor(options){
        options = options || {};
        const projection = options.projection !== undefined ? options.projection : "EPSG:3857";
        const tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $5779655d81caea04$export$38500bbeccc864ff)({
            extent: (0, $5779655d81caea04$export$7b5b6ef8fd55fac4)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            opaque: options.opaque,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return this.gutter_;
    }
}
var $963a7ef65488964c$export$2e2bcd8739ae039 = $963a7ef65488964c$var$XYZ;


const $6c8498cc816f2362$export$4de8a5e77eb994ad = '&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {boolean} [opaque=true] Whether the layer is opaque.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ class $6c8498cc816f2362$var$OSM extends (0, $963a7ef65488964c$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Open Street Map options.
   */ constructor(options){
        options = options || {};
        let attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            $6c8498cc816f2362$export$4de8a5e77eb994ad
        ];
        const crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : "anonymous";
        const url = options.url !== undefined ? options.url : "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
        super({
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: crossOrigin,
            interpolate: options.interpolate,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            opaque: options.opaque !== undefined ? options.opaque : true,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection
        });
    }
}
var $6c8498cc816f2362$export$2e2bcd8739ae039 = $6c8498cc816f2362$var$OSM;







/**
 * @module ol/source/TileWMS
 */ 
/**
 * @module ol/source/wms
 */ /**
 * @module ol/source/common
 */ /**
 * Default WMS version.
 * @type {string}
 */ const $1dd040dde677fb20$export$8c33e4eedb20eeb5 = "1.3.0";
const $1dd040dde677fb20$export$48fbc15abf52505f = 4;


/**
 * @module ol/uri
 */ /**
 * Appends query parameters to a URI.
 *
 * @param {string} uri The original URI, which may already have query data.
 * @param {!Object} params An object where keys are URI-encoded parameter keys,
 *     and the values are arbitrary types or arrays.
 * @return {string} The new URI.
 */ function $60db182c0252e220$export$c202e3cb8db99a95(uri, params) {
    /** @type {Array<string>} */ const keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function(k) {
        if (params[k] !== null && params[k] !== undefined) keyParams.push(k + "=" + encodeURIComponent(params[k]));
    });
    const qs = keyParams.join("&");
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, "");
    // append ? or & depending on whether uri has existing parameters
    uri += uri.includes("?") ? "&" : "?";
    return uri + qs;
}







/**
 * @module ol/source/Image
 */ 



/**
 * @module ol/reproj/Image
 */ 





/**
 * @module ol/resolution
 */ /**
 * @typedef {number|Array<number>} ResolutionLike
 */ /**
 * @param {ResolutionLike} resolution Resolution.
 * @return {number} Resolution.
 */ function $294095e38e30fd4e$export$bc4231bf34bfa9ad(resolution) {
    if (Array.isArray(resolution)) return Math.min(...resolution);
    return resolution;
}




/**
 * @typedef {function(import("../extent.js").Extent, number, number) : import("../Image.js").default} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected image.
 * See {@link module:ol/source/Image~ImageSource}.
 */ class $22666d8766dd8ace$var$ReprojImage extends (0, $b54439be79d4619a$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection (of the data).
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent.
   * @param {number} targetResolution Target resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {FunctionType} getImageFunction
   *     Function returning source images (extent, resolution, pixelRatio).
   * @param {boolean} interpolate Use linear interpolation when resampling.
   */ constructor(sourceProj, targetProj, targetExtent, targetResolution, pixelRatio, getImageFunction, interpolate){
        let maxSourceExtent = sourceProj.getExtent();
        if (maxSourceExtent && sourceProj.canWrapX()) {
            maxSourceExtent = maxSourceExtent.slice();
            maxSourceExtent[0] = -Infinity;
            maxSourceExtent[2] = Infinity;
        }
        let maxTargetExtent = targetProj.getExtent();
        if (maxTargetExtent && targetProj.canWrapX()) {
            maxTargetExtent = maxTargetExtent.slice();
            maxTargetExtent[0] = -Infinity;
            maxTargetExtent[2] = Infinity;
        }
        const limitedTargetExtent = maxTargetExtent ? (0, $6da4c8ed3074c92b$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        const targetCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(limitedTargetExtent);
        const sourceResolution = (0, $2b0a118af78fb031$export$5fbb958059b7e71f)(sourceProj, targetProj, targetCenter, targetResolution);
        const errorThresholdInPixels = (0, $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855);
        const triangulation = new (0, $6be53f6edfbf1854$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        const sourceExtent = triangulation.calculateSourceExtent();
        const sourceImage = (0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(sourceExtent) ? null : getImageFunction(sourceExtent, sourceResolution, pixelRatio);
        const state = sourceImage ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE : (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).EMPTY;
        const sourcePixelRatio = sourceImage ? sourceImage.getPixelRatio() : 1;
        super(targetExtent, targetResolution, sourcePixelRatio, state);
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.targetProj_ = targetProj;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = triangulation;
        /**
     * @private
     * @type {number}
     */ this.targetResolution_ = targetResolution;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.targetExtent_ = targetExtent;
        /**
     * @private
     * @type {import("../Image.js").default}
     */ this.sourceImage_ = sourceImage;
        /**
     * @private
     * @type {number}
     */ this.sourcePixelRatio_ = sourcePixelRatio;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = interpolate;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceListenerKey_ = null;
    }
    /**
   * Clean up.
   */ disposeInternal() {
        if (this.state == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) this.unlistenSource_();
        super.disposeInternal();
    }
    /**
   * @return {HTMLCanvasElement} Image.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @return {import("../proj/Projection.js").default} Projection.
   */ getProjection() {
        return this.targetProj_;
    }
    /**
   * @private
   */ reproject_() {
        const sourceState = this.sourceImage_.getState();
        if (sourceState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) {
            const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.targetExtent_) / this.targetResolution_;
            const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(this.targetExtent_) / this.targetResolution_;
            this.canvas_ = (0, $2b0a118af78fb031$export$b3890eb0ae9dca99)(width, height, this.sourcePixelRatio_, (0, $294095e38e30fd4e$export$bc4231bf34bfa9ad)(this.sourceImage_.getResolution()), this.maxSourceExtent_, this.targetResolution_, this.targetExtent_, this.triangulation_, [
                {
                    extent: this.sourceImage_.getExtent(),
                    image: this.sourceImage_.getImage()
                }
            ], 0, undefined, this.interpolate_, true);
        }
        this.state = sourceState;
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
            this.changed();
            const sourceState = this.sourceImage_.getState();
            if (sourceState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || sourceState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) this.reproject_();
            else {
                this.sourceListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.sourceImage_, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, function(e) {
                    const sourceState = this.sourceImage_.getState();
                    if (sourceState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || sourceState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) {
                        this.unlistenSource_();
                        this.reproject_();
                    }
                }, this);
                this.sourceImage_.load();
            }
        }
    }
    /**
   * @private
   */ unlistenSource_() {
        (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(/** @type {!import("../events.js").EventsKey} */ this.sourceListenerKey_);
        this.sourceListenerKey_ = null;
    }
}
var $22666d8766dd8ace$export$2e2bcd8739ae039 = $22666d8766dd8ace$var$ReprojImage;









const $ff537d321d4e1584$export$4e0f6da20e5dcc4f = {
    /**
   * Triggered when an image starts loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadstart
   * @api
   */ IMAGELOADSTART: "imageloadstart",
    /**
   * Triggered when an image finishes loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadend
   * @api
   */ IMAGELOADEND: "imageloadend",
    /**
   * Triggered if image loading results in an error.
   * @event module:ol/source/Image.ImageSourceEvent#imageloaderror
   * @api
   */ IMAGELOADERROR: "imageloaderror"
};
class $ff537d321d4e1584$export$58d3276cd83daede extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Image.js").default} image The image.
   */ constructor(type, image){
        super(type);
        /**
     * The image related to the event.
     * @type {import("../Image.js").default}
     * @api
     */ this.image = image;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<ImageSourceEventTypes, ImageSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |ImageSourceEventTypes, Return>} ImageSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../Image.js").Loader} [loader] Loader. Can either be a custom loader, or one of the
 * loaders created with a `createLoader()` function ({@link module:ol/source/wms.createLoader wms},
 * {@link module:ol/source/arcgisRest.createLoader arcgisRest}, {@link module:ol/source/mapguide.createLoader mapguide},
 * {@link module:ol/source/static.createLoader static}).
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {Array<number>} [resolutions] Resolutions.
 * @property {import("./Source.js").State} [state] State.
 */ /**
 * @classdesc
 * Base class for sources providing a single image.
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class $ff537d321d4e1584$var$ImageSource extends (0, $ed6dc99f268f3882$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Single image source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            projection: options.projection,
            state: options.state,
            interpolate: options.interpolate !== undefined ? options.interpolate : true
        });
        /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ImageSourceOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {import("../Image.js").Loader}
     */ this.loader = options.loader || null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.resolutions_ = options.resolutions !== undefined ? options.resolutions : null;
        /**
     * @private
     * @type {import("../reproj/Image.js").default}
     */ this.reprojectedImage_ = null;
        /**
     * @private
     * @type {number}
     */ this.reprojectedRevision_ = 0;
        /**
     * @protected
     * @type {import("../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.wantedExtent_;
        /**
     * @private
     * @type {number}
     */ this.wantedResolution_;
        /**
     * @private
     * @type {boolean}
     */ this.static_ = options.loader ? options.loader.length === 0 : false;
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.wantedProjection_ = null;
    }
    /**
   * @return {Array<number>|null} Resolutions.
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {Array<number>|null} resolutions Resolutions.
   */ setResolutions(resolutions) {
        this.resolutions_ = resolutions;
    }
    /**
   * @protected
   * @param {number} resolution Resolution.
   * @return {number} Resolution.
   */ findNearestResolution(resolution) {
        const resolutions = this.getResolutions();
        if (resolutions) {
            const idx = (0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(resolutions, resolution, 0);
            resolution = resolutions[idx];
        }
        return resolution;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   */ getImage(extent, resolution, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $9c4744460e43e41b$export$fe091d73a555748b)(sourceProjection, projection)) {
            if (sourceProjection) projection = sourceProjection;
            return this.getImageInternal(extent, resolution, pixelRatio, projection);
        }
        if (this.reprojectedImage_) {
            if (this.reprojectedRevision_ == this.getRevision() && (0, $9c4744460e43e41b$export$fe091d73a555748b)(this.reprojectedImage_.getProjection(), projection) && this.reprojectedImage_.getResolution() == resolution && (0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(this.reprojectedImage_.getExtent(), extent)) return this.reprojectedImage_;
            this.reprojectedImage_.dispose();
            this.reprojectedImage_ = null;
        }
        this.reprojectedImage_ = new (0, $22666d8766dd8ace$export$2e2bcd8739ae039)(sourceProjection, projection, extent, resolution, pixelRatio, (extent, resolution, pixelRatio)=>this.getImageInternal(extent, resolution, pixelRatio, sourceProjection), this.getInterpolate());
        this.reprojectedRevision_ = this.getRevision();
        return this.reprojectedImage_;
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   * @protected
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.loader) {
            const requestExtent = $ff537d321d4e1584$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, 1);
            const requestResolution = this.findNearestResolution(resolution);
            if (this.image && (this.static_ || this.wantedProjection_ === projection && (this.wantedExtent_ && (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(this.wantedExtent_, requestExtent) || (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(this.image.getExtent(), requestExtent)) && (this.wantedResolution_ && (0, $294095e38e30fd4e$export$bc4231bf34bfa9ad)(this.wantedResolution_) === requestResolution || (0, $294095e38e30fd4e$export$bc4231bf34bfa9ad)(this.image.getResolution()) === requestResolution))) return this.image;
            this.wantedProjection_ = projection;
            this.wantedExtent_ = requestExtent;
            this.wantedResolution_ = requestResolution;
            this.image = new (0, $b54439be79d4619a$export$2e2bcd8739ae039)(requestExtent, requestResolution, pixelRatio, this.loader);
            this.image.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleImageChange.bind(this));
        }
        return this.image;
    }
    /**
   * Handle image change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleImageChange(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        let type;
        switch(image.getState()){
            case (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING:
                this.loading = true;
                type = $ff537d321d4e1584$export$4e0f6da20e5dcc4f.IMAGELOADSTART;
                break;
            case (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED:
                this.loading = false;
                type = $ff537d321d4e1584$export$4e0f6da20e5dcc4f.IMAGELOADEND;
                break;
            case (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR:
                this.loading = false;
                type = $ff537d321d4e1584$export$4e0f6da20e5dcc4f.IMAGELOADERROR;
                break;
            default:
                return;
        }
        if (this.hasListener(type)) this.dispatchEvent(new $ff537d321d4e1584$export$58d3276cd83daede(type, image));
    }
}
function $ff537d321d4e1584$export$584f102f75ff44b3(image, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ image.getImage().src = src;
}
function $ff537d321d4e1584$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, ratio) {
    const imageResolution = resolution / pixelRatio;
    const center = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(extent);
    const viewWidth = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / imageResolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const viewHeight = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)((0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / imageResolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const marginWidth = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)((ratio - 1) * viewWidth / 2, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const requestWidth = viewWidth + 2 * marginWidth;
    const marginHeight = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)((ratio - 1) * viewHeight / 2, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const requestHeight = viewHeight + 2 * marginHeight;
    return (0, $6da4c8ed3074c92b$export$13ba650faf8308)(center, imageResolution, 0, [
        requestWidth,
        requestHeight
    ]);
}
var $ff537d321d4e1584$export$2e2bcd8739ae039 = $ff537d321d4e1584$var$ImageSource;


const $186e1be7a71804ce$export$363ebe89e6e7aeef = "1.3.0";
/**
 * @const
 * @type {import("../size.js").Size}
 */ const $186e1be7a71804ce$var$GETFEATUREINFO_IMAGE_SIZE = [
    101,
    101
];
function $186e1be7a71804ce$export$14619c0eed01a470(baseUrl, extent, size, projection, params) {
    params["WIDTH"] = size[0];
    params["HEIGHT"] = size[1];
    const axisOrientation = projection.getAxisOrientation();
    let bbox;
    const v13 = (0, $ff7180bdd45ebb19$export$66e1c0999abad646)(params["VERSION"], "1.3") >= 0;
    params[v13 ? "CRS" : "SRS"] = projection.getCode();
    if (v13 && axisOrientation.substr(0, 2) == "ne") bbox = [
        extent[1],
        extent[0],
        extent[3],
        extent[2]
    ];
    else bbox = extent;
    params["BBOX"] = bbox.join(",");
    return (0, $60db182c0252e220$export$c202e3cb8db99a95)(/** @type {string} */ baseUrl, params);
}
function $186e1be7a71804ce$export$ef1c8480e0b65584(extent, resolution, pixelRatio, projection, url, params, serverType) {
    params = Object.assign({
        REQUEST: "GetMap"
    }, params);
    const imageResolution = resolution / pixelRatio;
    const imageSize = [
        (0, $6b000a049d919fe5$export$2077e0241d6afd3c)((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / imageResolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f)),
        (0, $6b000a049d919fe5$export$2077e0241d6afd3c)((0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / imageResolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f))
    ];
    if (pixelRatio != 1) switch(serverType){
        case "geoserver":
            const dpi = 90 * pixelRatio + 0.5 | 0;
            if ("FORMAT_OPTIONS" in params) params["FORMAT_OPTIONS"] += ";dpi:" + dpi;
            else params["FORMAT_OPTIONS"] = "dpi:" + dpi;
            break;
        case "mapserver":
            params["MAP_RESOLUTION"] = 90 * pixelRatio;
            break;
        case "carmentaserver":
        case "qgis":
            params["DPI"] = 90 * pixelRatio;
            break;
        default:
            throw new Error("Unknown `serverType` configured");
    }
    const src = $186e1be7a71804ce$export$14619c0eed01a470(url, extent, imageSize, projection, params);
    return src;
}
function $186e1be7a71804ce$export$a4c60e148c7af082(params, request) {
    return Object.assign({
        "REQUEST": request,
        "SERVICE": "WMS",
        "VERSION": $186e1be7a71804ce$export$363ebe89e6e7aeef,
        "FORMAT": "image/png",
        "STYLES": "",
        "TRANSPARENT": true
    }, params);
}
function $186e1be7a71804ce$export$8e84ca9bef6adc3a(options) {
    const hidpi = options.hidpi === undefined ? true : options.hidpi;
    const projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.projection || "EPSG:3857");
    const ratio = options.ratio || 1.5;
    const load = options.load || (0, $b54439be79d4619a$export$2f872c0f2117be69);
    /**
   * @type {import("../Image.js").Loader}
   */ return (extent, resolution, pixelRatio)=>{
        extent = (0, $ff537d321d4e1584$export$2a9dcc8f63da1787)(extent, resolution, pixelRatio, ratio);
        if (pixelRatio != 1 && (!hidpi || options.serverType === undefined)) pixelRatio = 1;
        const src = $186e1be7a71804ce$export$ef1c8480e0b65584(extent, resolution, pixelRatio, projection, options.url, $186e1be7a71804ce$export$a4c60e148c7af082(options.params, "GetMap"), options.serverType);
        const image = new Image();
        if (options.crossOrigin !== null) image.crossOrigin = options.crossOrigin;
        return load(image, src).then((image)=>({
                image: image,
                extent: extent,
                pixelRatio: pixelRatio
            }));
    };
}
function $186e1be7a71804ce$export$6f3ec358b8c06c5b(options, coordinate, resolution) {
    if (options.url === undefined) return undefined;
    const projectionObj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.projection || "EPSG:3857");
    const extent = (0, $6da4c8ed3074c92b$export$13ba650faf8308)(coordinate, resolution, 0, $186e1be7a71804ce$var$GETFEATUREINFO_IMAGE_SIZE);
    const baseParams = {
        "QUERY_LAYERS": options.params["LAYERS"],
        "INFO_FORMAT": "application/json"
    };
    Object.assign(baseParams, $186e1be7a71804ce$export$a4c60e148c7af082(options.params, "GetFeatureInfo"), options.params);
    const x = (0, $6b000a049d919fe5$export$a3fe094919f356fd)((coordinate[0] - extent[0]) / resolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const y = (0, $6b000a049d919fe5$export$a3fe094919f356fd)((extent[3] - coordinate[1]) / resolution, (0, $1dd040dde677fb20$export$48fbc15abf52505f));
    const v13 = (0, $ff7180bdd45ebb19$export$66e1c0999abad646)(baseParams["VERSION"], "1.3") >= 0;
    baseParams[v13 ? "I" : "X"] = x;
    baseParams[v13 ? "J" : "Y"] = y;
    return $186e1be7a71804ce$export$14619c0eed01a470(options.url, extent, $186e1be7a71804ce$var$GETFEATUREINFO_IMAGE_SIZE, projectionObj, baseParams);
}
function $186e1be7a71804ce$export$9ee42325bd9ccc93(options, resolution) {
    if (options.url === undefined) return undefined;
    const baseParams = {
        "SERVICE": "WMS",
        "VERSION": $186e1be7a71804ce$export$363ebe89e6e7aeef,
        "REQUEST": "GetLegendGraphic",
        "FORMAT": "image/png"
    };
    if (options.params === undefined || options.params["LAYER"] === undefined) {
        const layers = options.params.LAYERS;
        const isSingleLayer = !Array.isArray(layers) || layers.length === 1;
        if (!isSingleLayer) return undefined;
        baseParams["LAYER"] = layers;
    }
    if (resolution !== undefined) {
        const mpu = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.projection || "EPSG:3857").getMetersPerUnit() || 1;
        const pixelSize = 0.00028;
        baseParams["SCALE"] = resolution * mpu / pixelSize;
    }
    Object.assign(baseParams, options.params);
    return (0, $60db182c0252e220$export$c202e3cb8db99a95)(options.url, baseParams);
}









/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {Object<string,*>} params WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
 * @property {number} [gutter=0]
 * The size in pixels of the gutter around image tiles to ignore. By setting
 * this property to a non-zero value, images will be requested that are wider
 * and taller than the tile size by a value of `2 x gutter`.
 * Using a non-zero value allows artifacts of rendering at tile edges to be
 * ignored. If you control the WMS service it is recommended to address
 * "artifacts at tile edges" issues by properly configuring the WMS service. For
 * example, MapServer has a `tile_map_edge_buffer` configuration parameter for
 * this. See https://mapserver.org/output/tile_mode.html.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid. Base this on the resolutions,
 * tilesize and extent supported by the server.
 * If this is not defined, a default grid will be used: if there is a projection
 * extent, the grid will be based on that; if not, a grid based on a global
 * extent with origin at 0,0 will be used.
 * @property {import("./wms.js").ServerType} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver`, `carmentaserver`, or `qgis`.
 * Only needed if `hidpi` is `true`.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {string} [url] WMS service URL.
 * @property {Array<string>} [urls] WMS service urls.
 * Use this instead of `url` when the WMS supports multiple urls for GetMap requests.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * When set to `false`, only one world
 * will be rendered. When `true`, tiles will be requested for one world only,
 * but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data from WMS servers.
 * @api
 */ class $6a269de6fca6e364$var$TileWMS extends (0, $51d055913ca55b5e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Tile WMS options.
   */ constructor(options){
        options = options ? options : /** @type {Options} */ {};
        const params = Object.assign({}, options.params);
        const transparent = "TRANSPARENT" in params ? params["TRANSPARENT"] : true;
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            opaque: !transparent,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileClass: options.tileClass,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
        /**
     * @private
     * @type {!Object}
     */ this.params_ = params;
        /**
     * @private
     * @type {boolean}
     */ this.v13_ = true;
        /**
     * @private
     * @type {import("./wms.js").ServerType}
     */ this.serverType_ = options.serverType;
        /**
     * @private
     * @type {boolean}
     */ this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        this.updateV13_();
        this.setKey(this.getKeyForParams_());
    }
    /**
   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
   * constructed.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
   *     in the `LAYERS` parameter will be used. `VERSION` should not be
   *     specified here.
   * @return {string|undefined} GetFeatureInfo URL.
   * @api
   */ getFeatureInfoUrl(coordinate, resolution, projection, params) {
        const projectionObj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
        const sourceProjectionObj = this.getProjection() || projectionObj;
        let tileGrid = this.getTileGrid();
        if (!tileGrid) tileGrid = this.getTileGridForProjection(sourceProjectionObj);
        const sourceProjCoord = (0, $9c4744460e43e41b$export$51186ad6e864892a)(coordinate, projectionObj, sourceProjectionObj);
        const sourceResolution = (0, $2b0a118af78fb031$export$5fbb958059b7e71f)(sourceProjectionObj, projectionObj, coordinate, resolution);
        const z = tileGrid.getZForResolution(sourceResolution, this.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const tileCoord = tileGrid.getTileCoordForCoordAndZ(sourceProjCoord, z);
        if (tileGrid.getResolutions().length <= tileCoord[0]) return undefined;
        let tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        const gutter = this.gutter_;
        if (gutter !== 0) tileExtent = (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(tileExtent, tileResolution * gutter, tileExtent);
        const baseParams = {
            "QUERY_LAYERS": this.params_["LAYERS"]
        };
        Object.assign(baseParams, (0, $186e1be7a71804ce$export$a4c60e148c7af082)(this.params_, "GetFeatureInfo"), params);
        const x = Math.floor((sourceProjCoord[0] - tileExtent[0]) / tileResolution);
        const y = Math.floor((tileExtent[3] - sourceProjCoord[1]) / tileResolution);
        baseParams[this.v13_ ? "I" : "X"] = x;
        baseParams[this.v13_ ? "J" : "Y"] = y;
        return this.getRequestUrl_(tileCoord, tileExtent, 1, sourceProjectionObj || projectionObj, baseParams);
    }
    /**
   * Return the GetLegendGraphic URL, optionally optimized for the passed
   * resolution and possibly including any passed specific parameters. Returns
   * `undefined` if the GetLegendGraphic URL cannot be constructed.
   *
   * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
   *     will not be calculated and included in URL.
   * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
   *     request is generated for this wms layer, else it will try to use the
   *     configured wms layer. Default `FORMAT` is `image/png`.
   *     `VERSION` should not be specified here.
   * @return {string|undefined} GetLegendGraphic URL.
   * @api
   */ getLegendUrl(resolution, params) {
        if (this.urls[0] === undefined) return undefined;
        const baseParams = {
            "SERVICE": "WMS",
            "VERSION": (0, $186e1be7a71804ce$export$363ebe89e6e7aeef),
            "REQUEST": "GetLegendGraphic",
            "FORMAT": "image/png"
        };
        if (params === undefined || params["LAYER"] === undefined) {
            const layers = this.params_.LAYERS;
            const isSingleLayer = !Array.isArray(layers) || layers.length === 1;
            if (!isSingleLayer) return undefined;
            baseParams["LAYER"] = layers;
        }
        if (resolution !== undefined) {
            const mpu = this.getProjection() ? this.getProjection().getMetersPerUnit() : 1;
            const pixelSize = 0.00028;
            baseParams["SCALE"] = resolution * mpu / pixelSize;
        }
        Object.assign(baseParams, params);
        return (0, $60db182c0252e220$export$c202e3cb8db99a95)(/** @type {string} */ this.urls[0], baseParams);
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return this.gutter_;
    }
    /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */ getParams() {
        return this.params_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} tileExtent Tile extent.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {Object} params Params.
   * @return {string|undefined} Request URL.
   * @private
   */ getRequestUrl_(tileCoord, tileExtent, pixelRatio, projection, params) {
        const urls = this.urls;
        if (!urls) return undefined;
        let url;
        if (urls.length == 1) url = urls[0];
        else {
            const index = (0, $6b000a049d919fe5$export$ba467bec01d66def)((0, $bf2a04496fadabc6$export$d6af199866bfb566)(tileCoord), urls.length);
            url = urls[index];
        }
        return (0, $186e1be7a71804ce$export$ef1c8480e0b65584)(tileExtent, (this.tileGrid || this.getTileGridForProjection(projection)).getResolution(tileCoord[0]), pixelRatio, projection, url, params, this.serverType_);
    }
    /**
   * Get the tile pixel ratio for this source.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return !this.hidpi_ || this.serverType_ === undefined ? 1 : pixelRatio;
    }
    /**
   * @private
   * @return {string} The key for the current params.
   */ getKeyForParams_() {
        let i = 0;
        const res = [];
        for(const key in this.params_)res[i++] = key + "-" + this.params_[key];
        return res.join("/");
    }
    /**
   * Update the user-provided params.
   * @param {Object} params Params.
   * @api
   */ updateParams(params) {
        Object.assign(this.params_, params);
        this.updateV13_();
        this.setKey(this.getKeyForParams_());
    }
    /**
   * @private
   */ updateV13_() {
        const version = this.params_["VERSION"] || (0, $186e1be7a71804ce$export$363ebe89e6e7aeef);
        this.v13_ = (0, $ff7180bdd45ebb19$export$66e1c0999abad646)(version, "1.3") >= 0;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
   * @param {number} pixelRatio The pixel ratio
   * @param {import("../proj/Projection.js").default} projection The projection
   * @return {string|undefined} The tile URL
   * @override
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        let tileGrid = this.getTileGrid();
        if (!tileGrid) tileGrid = this.getTileGridForProjection(projection);
        if (tileGrid.getResolutions().length <= tileCoord[0]) return undefined;
        if (pixelRatio != 1 && (!this.hidpi_ || this.serverType_ === undefined)) pixelRatio = 1;
        const tileResolution = tileGrid.getResolution(tileCoord[0]);
        let tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        const gutter = this.gutter_;
        if (gutter !== 0) tileExtent = (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(tileExtent, tileResolution * gutter, tileExtent);
        const baseParams = Object.assign({}, (0, $186e1be7a71804ce$export$a4c60e148c7af082)(this.params_, "GetMap"));
        return this.getRequestUrl_(tileCoord, tileExtent, pixelRatio, projection, baseParams);
    }
}
var $6a269de6fca6e364$export$2e2bcd8739ae039 = $6a269de6fca6e364$var$TileWMS;



function $95bfc720255032a6$export$2e2bcd8739ae039(defs) {
    defs("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
    defs("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
    defs("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");
    defs.WGS84 = defs["EPSG:4326"];
    defs["EPSG:3785"] = defs["EPSG:3857"]; // maintain backward compat, official code is 3857
    defs.GOOGLE = defs["EPSG:3857"];
    defs["EPSG:900913"] = defs["EPSG:3857"];
    defs["EPSG:102113"] = defs["EPSG:3857"];
}



var $gyVUi = parcelRequire("gyVUi");
var $c0ed0517e336f22b$export$2e2bcd8739ae039 = {};
$c0ed0517e336f22b$export$2e2bcd8739ae039.greenwich = 0.0; //"0dE",
$c0ed0517e336f22b$export$2e2bcd8739ae039.lisbon = -9.131906111111; //"9d07'54.862\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.paris = 2.337229166667; //"2d20'14.025\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.bogota = -74.080916666667; //"74d04'51.3\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.madrid = -3.687938888889; //"3d41'16.58\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.rome = 12.452333333333; //"12d27'8.4\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.bern = 7.439583333333; //"7d26'22.5\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.jakarta = 106.807719444444; //"106d48'27.79\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.ferro = -17.666666666667; //"17d40'W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.brussels = 4.367975; //"4d22'4.71\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.stockholm = 18.058277777778; //"18d3'29.8\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.athens = 23.7163375; //"23d42'58.815\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.oslo = 10.722916666667; //"10d43'22.5\"E"


var $4d34d8675ead8d22$export$2e2bcd8739ae039 = {
    ft: {
        to_meter: 0.3048
    },
    "us-ft": {
        to_meter: 1200 / 3937
    }
};


var $ccc3ecc4732a4173$var$ignoredChar = /[\s_\-\/\(\)]/g;
function $ccc3ecc4732a4173$export$2e2bcd8739ae039(obj, key) {
    if (obj[key]) return obj[key];
    var keys = Object.keys(obj);
    var lkey = key.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, "");
    var i = -1;
    var testkey, processedKey;
    while(++i < keys.length){
        testkey = keys[i];
        processedKey = testkey.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, "");
        if (processedKey === lkey) return obj[testkey];
    }
}


function $583158df16d3522c$export$2e2bcd8739ae039(defData) {
    var self = {};
    var paramObj = defData.split("+").map(function(v) {
        return v.trim();
    }).filter(function(a) {
        return a;
    }).reduce(function(p, a) {
        var split = a.split("=");
        split.push(true);
        p[split[0].toLowerCase()] = split[1];
        return p;
    }, {});
    var paramName, paramVal, paramOutname;
    var params = {
        proj: "projName",
        datum: "datumCode",
        rf: function(v) {
            self.rf = parseFloat(v);
        },
        lat_0: function(v) {
            self.lat0 = v * (0, $gyVUi.D2R);
        },
        lat_1: function(v) {
            self.lat1 = v * (0, $gyVUi.D2R);
        },
        lat_2: function(v) {
            self.lat2 = v * (0, $gyVUi.D2R);
        },
        lat_ts: function(v) {
            self.lat_ts = v * (0, $gyVUi.D2R);
        },
        lon_0: function(v) {
            self.long0 = v * (0, $gyVUi.D2R);
        },
        lon_1: function(v) {
            self.long1 = v * (0, $gyVUi.D2R);
        },
        lon_2: function(v) {
            self.long2 = v * (0, $gyVUi.D2R);
        },
        alpha: function(v) {
            self.alpha = parseFloat(v) * (0, $gyVUi.D2R);
        },
        gamma: function(v) {
            self.rectified_grid_angle = parseFloat(v);
        },
        lonc: function(v) {
            self.longc = v * (0, $gyVUi.D2R);
        },
        x_0: function(v) {
            self.x0 = parseFloat(v);
        },
        y_0: function(v) {
            self.y0 = parseFloat(v);
        },
        k_0: function(v) {
            self.k0 = parseFloat(v);
        },
        k: function(v) {
            self.k0 = parseFloat(v);
        },
        a: function(v) {
            self.a = parseFloat(v);
        },
        b: function(v) {
            self.b = parseFloat(v);
        },
        r_a: function() {
            self.R_A = true;
        },
        zone: function(v) {
            self.zone = parseInt(v, 10);
        },
        south: function() {
            self.utmSouth = true;
        },
        towgs84: function(v) {
            self.datum_params = v.split(",").map(function(a) {
                return parseFloat(a);
            });
        },
        to_meter: function(v) {
            self.to_meter = parseFloat(v);
        },
        units: function(v) {
            self.units = v;
            var unit = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $4d34d8675ead8d22$export$2e2bcd8739ae039), v);
            if (unit) self.to_meter = unit.to_meter;
        },
        from_greenwich: function(v) {
            self.from_greenwich = v * (0, $gyVUi.D2R);
        },
        pm: function(v) {
            var pm = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $c0ed0517e336f22b$export$2e2bcd8739ae039), v);
            self.from_greenwich = (pm ? pm : parseFloat(v)) * (0, $gyVUi.D2R);
        },
        nadgrids: function(v) {
            if (v === "@null") self.datumCode = "none";
            else self.nadgrids = v;
        },
        axis: function(v) {
            var legalAxis = "ewnsud";
            if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) self.axis = v;
        },
        approx: function() {
            self.approx = true;
        }
    };
    for(paramName in paramObj){
        paramVal = paramObj[paramName];
        if (paramName in params) {
            paramOutname = params[paramName];
            if (typeof paramOutname === "function") paramOutname(paramVal);
            else self[paramOutname] = paramVal;
        } else self[paramName] = paramVal;
    }
    if (typeof self.datumCode === "string" && self.datumCode !== "WGS84") self.datumCode = self.datumCode.toLowerCase();
    return self;
}


var $4f92c43f9960a1f4$export$2e2bcd8739ae039 = $4f92c43f9960a1f4$var$parseString;
var $4f92c43f9960a1f4$var$NEUTRAL = 1;
var $4f92c43f9960a1f4$var$KEYWORD = 2;
var $4f92c43f9960a1f4$var$NUMBER = 3;
var $4f92c43f9960a1f4$var$QUOTED = 4;
var $4f92c43f9960a1f4$var$AFTERQUOTE = 5;
var $4f92c43f9960a1f4$var$ENDED = -1;
var $4f92c43f9960a1f4$var$whitespace = /\s/;
var $4f92c43f9960a1f4$var$latin = /[A-Za-z]/;
var $4f92c43f9960a1f4$var$keyword = /[A-Za-z84_]/;
var $4f92c43f9960a1f4$var$endThings = /[,\]]/;
var $4f92c43f9960a1f4$var$digets = /[\d\.E\-\+]/;
// const ignoredChar = /[\s_\-\/\(\)]/g;
function $4f92c43f9960a1f4$var$Parser(text) {
    if (typeof text !== "string") throw new Error("not a string");
    this.text = text.trim();
    this.level = 0;
    this.place = 0;
    this.root = null;
    this.stack = [];
    this.currentObject = null;
    this.state = $4f92c43f9960a1f4$var$NEUTRAL;
}
$4f92c43f9960a1f4$var$Parser.prototype.readCharicter = function() {
    var char = this.text[this.place++];
    if (this.state !== $4f92c43f9960a1f4$var$QUOTED) while($4f92c43f9960a1f4$var$whitespace.test(char)){
        if (this.place >= this.text.length) return;
        char = this.text[this.place++];
    }
    switch(this.state){
        case $4f92c43f9960a1f4$var$NEUTRAL:
            return this.neutral(char);
        case $4f92c43f9960a1f4$var$KEYWORD:
            return this.keyword(char);
        case $4f92c43f9960a1f4$var$QUOTED:
            return this.quoted(char);
        case $4f92c43f9960a1f4$var$AFTERQUOTE:
            return this.afterquote(char);
        case $4f92c43f9960a1f4$var$NUMBER:
            return this.number(char);
        case $4f92c43f9960a1f4$var$ENDED:
            return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.afterquote = function(char) {
    if (char === '"') {
        this.word += '"';
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = this.word.trim();
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in afterquote yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.afterItem = function(char) {
    if (char === ",") {
        if (this.word !== null) this.currentObject.push(this.word);
        this.word = null;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if (char === "]") {
        this.level--;
        if (this.word !== null) {
            this.currentObject.push(this.word);
            this.word = null;
        }
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        this.currentObject = this.stack.pop();
        if (!this.currentObject) this.state = $4f92c43f9960a1f4$var$ENDED;
        return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.number = function(char) {
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word += char;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = parseFloat(this.word);
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in number yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.quoted = function(char) {
    if (char === '"') {
        this.state = $4f92c43f9960a1f4$var$AFTERQUOTE;
        return;
    }
    this.word += char;
    return;
};
$4f92c43f9960a1f4$var$Parser.prototype.keyword = function(char) {
    if ($4f92c43f9960a1f4$var$keyword.test(char)) {
        this.word += char;
        return;
    }
    if (char === "[") {
        var newObjects = [];
        newObjects.push(this.word);
        this.level++;
        if (this.root === null) this.root = newObjects;
        else this.currentObject.push(newObjects);
        this.stack.push(this.currentObject);
        this.currentObject = newObjects;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in keyword yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.neutral = function(char) {
    if ($4f92c43f9960a1f4$var$latin.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$KEYWORD;
        return;
    }
    if (char === '"') {
        this.word = "";
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$NUMBER;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in neutral yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.output = function() {
    while(this.place < this.text.length)this.readCharicter();
    if (this.state === $4f92c43f9960a1f4$var$ENDED) return this.root;
    throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function $4f92c43f9960a1f4$var$parseString(txt) {
    var parser = new $4f92c43f9960a1f4$var$Parser(txt);
    return parser.output();
}


function $5bda1e467f1c2649$var$mapit(obj, key, value) {
    if (Array.isArray(key)) {
        value.unshift(key);
        key = null;
    }
    var thing = key ? {} : obj;
    var out = value.reduce(function(newObj, item) {
        $5bda1e467f1c2649$export$337bc7a3aef1f775(item, newObj);
        return newObj;
    }, thing);
    if (key) obj[key] = out;
}
function $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj) {
    if (!Array.isArray(v)) {
        obj[v] = true;
        return;
    }
    var key = v.shift();
    if (key === "PARAMETER") key = v.shift();
    if (v.length === 1) {
        if (Array.isArray(v[0])) {
            obj[key] = {};
            $5bda1e467f1c2649$export$337bc7a3aef1f775(v[0], obj[key]);
            return;
        }
        obj[key] = v[0];
        return;
    }
    if (!v.length) {
        obj[key] = true;
        return;
    }
    if (key === "TOWGS84") {
        obj[key] = v;
        return;
    }
    if (key === "AXIS") {
        if (!(key in obj)) obj[key] = [];
        obj[key].push(v);
        return;
    }
    if (!Array.isArray(key)) obj[key] = {};
    var i;
    switch(key){
        case "UNIT":
        case "PRIMEM":
        case "VERT_DATUM":
            obj[key] = {
                name: v[0].toLowerCase(),
                convert: v[1]
            };
            if (v.length === 3) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[2], obj[key]);
            return;
        case "SPHEROID":
        case "ELLIPSOID":
            obj[key] = {
                name: v[0],
                a: v[1],
                rf: v[2]
            };
            if (v.length === 4) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[3], obj[key]);
            return;
        case "PROJECTEDCRS":
        case "PROJCRS":
        case "GEOGCS":
        case "GEOCCS":
        case "PROJCS":
        case "LOCAL_CS":
        case "GEODCRS":
        case "GEODETICCRS":
        case "GEODETICDATUM":
        case "EDATUM":
        case "ENGINEERINGDATUM":
        case "VERT_CS":
        case "VERTCRS":
        case "VERTICALCRS":
        case "COMPD_CS":
        case "COMPOUNDCRS":
        case "ENGINEERINGCRS":
        case "ENGCRS":
        case "FITTED_CS":
        case "LOCAL_DATUM":
        case "DATUM":
            v[0] = [
                "name",
                v[0]
            ];
            $5bda1e467f1c2649$var$mapit(obj, key, v);
            return;
        default:
            i = -1;
            while(++i < v.length){
                if (!Array.isArray(v[i])) return $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj[key]);
            }
            return $5bda1e467f1c2649$var$mapit(obj, key, v);
    }
}


var $5c3aabf591259c07$var$D2R = 0.01745329251994329577;
function $5c3aabf591259c07$var$rename(obj, params) {
    var outName = params[0];
    var inName = params[1];
    if (!(outName in obj) && inName in obj) {
        obj[outName] = obj[inName];
        if (params.length === 3) obj[outName] = params[2](obj[outName]);
    }
}
function $5c3aabf591259c07$var$d2r(input) {
    return input * $5c3aabf591259c07$var$D2R;
}
function $5c3aabf591259c07$var$cleanWKT(wkt) {
    if (wkt.type === "GEOGCS") wkt.projName = "longlat";
    else if (wkt.type === "LOCAL_CS") {
        wkt.projName = "identity";
        wkt.local = true;
    } else if (typeof wkt.PROJECTION === "object") wkt.projName = Object.keys(wkt.PROJECTION)[0];
    else wkt.projName = wkt.PROJECTION;
    if (wkt.AXIS) {
        var axisOrder = "";
        for(var i = 0, ii = wkt.AXIS.length; i < ii; ++i){
            var axis = [
                wkt.AXIS[i][0].toLowerCase(),
                wkt.AXIS[i][1].toLowerCase()
            ];
            if (axis[0].indexOf("north") !== -1 || (axis[0] === "y" || axis[0] === "lat") && axis[1] === "north") axisOrder += "n";
            else if (axis[0].indexOf("south") !== -1 || (axis[0] === "y" || axis[0] === "lat") && axis[1] === "south") axisOrder += "s";
            else if (axis[0].indexOf("east") !== -1 || (axis[0] === "x" || axis[0] === "lon") && axis[1] === "east") axisOrder += "e";
            else if (axis[0].indexOf("west") !== -1 || (axis[0] === "x" || axis[0] === "lon") && axis[1] === "west") axisOrder += "w";
        }
        if (axisOrder.length === 2) axisOrder += "u";
        if (axisOrder.length === 3) wkt.axis = axisOrder;
    }
    if (wkt.UNIT) {
        wkt.units = wkt.UNIT.name.toLowerCase();
        if (wkt.units === "metre") wkt.units = "meter";
        if (wkt.UNIT.convert) {
            if (wkt.type === "GEOGCS") {
                if (wkt.DATUM && wkt.DATUM.SPHEROID) wkt.to_meter = wkt.UNIT.convert * wkt.DATUM.SPHEROID.a;
            } else wkt.to_meter = wkt.UNIT.convert;
        }
    }
    var geogcs = wkt.GEOGCS;
    if (wkt.type === "GEOGCS") geogcs = wkt;
    if (geogcs) {
        //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
        //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
        //}
        if (geogcs.DATUM) wkt.datumCode = geogcs.DATUM.name.toLowerCase();
        else wkt.datumCode = geogcs.name.toLowerCase();
        if (wkt.datumCode.slice(0, 2) === "d_") wkt.datumCode = wkt.datumCode.slice(2);
        if (wkt.datumCode === "new_zealand_geodetic_datum_1949" || wkt.datumCode === "new_zealand_1949") wkt.datumCode = "nzgd49";
        if (wkt.datumCode === "wgs_1984" || wkt.datumCode === "world_geodetic_system_1984") {
            if (wkt.PROJECTION === "Mercator_Auxiliary_Sphere") wkt.sphere = true;
            wkt.datumCode = "wgs84";
        }
        if (wkt.datumCode.slice(-6) === "_ferro") wkt.datumCode = wkt.datumCode.slice(0, -6);
        if (wkt.datumCode.slice(-8) === "_jakarta") wkt.datumCode = wkt.datumCode.slice(0, -8);
        if (~wkt.datumCode.indexOf("belge")) wkt.datumCode = "rnb72";
        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
            wkt.ellps = geogcs.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk");
            if (wkt.ellps.toLowerCase().slice(0, 13) === "international") wkt.ellps = "intl";
            wkt.a = geogcs.DATUM.SPHEROID.a;
            wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
        }
        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) wkt.datum_params = geogcs.DATUM.TOWGS84;
        if (~wkt.datumCode.indexOf("osgb_1936")) wkt.datumCode = "osgb36";
        if (~wkt.datumCode.indexOf("osni_1952")) wkt.datumCode = "osni52";
        if (~wkt.datumCode.indexOf("tm65") || ~wkt.datumCode.indexOf("geodetic_datum_of_1965")) wkt.datumCode = "ire65";
        if (wkt.datumCode === "ch1903+") wkt.datumCode = "ch1903";
        if (~wkt.datumCode.indexOf("israel")) wkt.datumCode = "isr93";
    }
    if (wkt.b && !isFinite(wkt.b)) wkt.b = wkt.a;
    function toMeter(input) {
        var ratio = wkt.to_meter || 1;
        return input * ratio;
    }
    var renamer = function(a) {
        return $5c3aabf591259c07$var$rename(wkt, a);
    };
    var list = [
        [
            "standard_parallel_1",
            "Standard_Parallel_1"
        ],
        [
            "standard_parallel_1",
            "Latitude of 1st standard parallel"
        ],
        [
            "standard_parallel_2",
            "Standard_Parallel_2"
        ],
        [
            "standard_parallel_2",
            "Latitude of 2nd standard parallel"
        ],
        [
            "false_easting",
            "False_Easting"
        ],
        [
            "false_easting",
            "False easting"
        ],
        [
            "false-easting",
            "Easting at false origin"
        ],
        [
            "false_northing",
            "False_Northing"
        ],
        [
            "false_northing",
            "False northing"
        ],
        [
            "false_northing",
            "Northing at false origin"
        ],
        [
            "central_meridian",
            "Central_Meridian"
        ],
        [
            "central_meridian",
            "Longitude of natural origin"
        ],
        [
            "central_meridian",
            "Longitude of false origin"
        ],
        [
            "latitude_of_origin",
            "Latitude_Of_Origin"
        ],
        [
            "latitude_of_origin",
            "Central_Parallel"
        ],
        [
            "latitude_of_origin",
            "Latitude of natural origin"
        ],
        [
            "latitude_of_origin",
            "Latitude of false origin"
        ],
        [
            "scale_factor",
            "Scale_Factor"
        ],
        [
            "k0",
            "scale_factor"
        ],
        [
            "latitude_of_center",
            "Latitude_Of_Center"
        ],
        [
            "latitude_of_center",
            "Latitude_of_center"
        ],
        [
            "lat0",
            "latitude_of_center",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "longitude_of_center",
            "Longitude_Of_Center"
        ],
        [
            "longitude_of_center",
            "Longitude_of_center"
        ],
        [
            "longc",
            "longitude_of_center",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "x0",
            "false_easting",
            toMeter
        ],
        [
            "y0",
            "false_northing",
            toMeter
        ],
        [
            "long0",
            "central_meridian",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat0",
            "latitude_of_origin",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat0",
            "standard_parallel_1",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat1",
            "standard_parallel_1",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat2",
            "standard_parallel_2",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "azimuth",
            "Azimuth"
        ],
        [
            "alpha",
            "azimuth",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "srsCode",
            "name"
        ]
    ];
    list.forEach(renamer);
    if (!wkt.long0 && wkt.longc && (wkt.projName === "Albers_Conic_Equal_Area" || wkt.projName === "Lambert_Azimuthal_Equal_Area")) wkt.long0 = wkt.longc;
    if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === "Stereographic_South_Pole" || wkt.projName === "Polar Stereographic (variant B)")) {
        wkt.lat0 = $5c3aabf591259c07$var$d2r(wkt.lat1 > 0 ? 90 : -90);
        wkt.lat_ts = wkt.lat1;
    }
}
function $5c3aabf591259c07$export$2e2bcd8739ae039(wkt) {
    var lisp = (0, $4f92c43f9960a1f4$export$2e2bcd8739ae039)(wkt);
    var type = lisp.shift();
    var name = lisp.shift();
    lisp.unshift([
        "name",
        name
    ]);
    lisp.unshift([
        "type",
        type
    ]);
    var obj = {};
    (0, $5bda1e467f1c2649$export$337bc7a3aef1f775)(lisp, obj);
    $5c3aabf591259c07$var$cleanWKT(obj);
    return obj;
}


function $a9b3183caccb3297$var$defs(name) {
    /*global console*/ var that = this;
    if (arguments.length === 2) {
        var def = arguments[1];
        if (typeof def === "string") {
            if (def.charAt(0) === "+") $a9b3183caccb3297$var$defs[name] = (0, $583158df16d3522c$export$2e2bcd8739ae039)(arguments[1]);
            else $a9b3183caccb3297$var$defs[name] = (0, $5c3aabf591259c07$export$2e2bcd8739ae039)(arguments[1]);
        } else $a9b3183caccb3297$var$defs[name] = def;
    } else if (arguments.length === 1) {
        if (Array.isArray(name)) return name.map(function(v) {
            if (Array.isArray(v)) $a9b3183caccb3297$var$defs.apply(that, v);
            else $a9b3183caccb3297$var$defs(v);
        });
        else if (typeof name === "string") {
            if (name in $a9b3183caccb3297$var$defs) return $a9b3183caccb3297$var$defs[name];
        } else if ("EPSG" in name) $a9b3183caccb3297$var$defs["EPSG:" + name.EPSG] = name;
        else if ("ESRI" in name) $a9b3183caccb3297$var$defs["ESRI:" + name.ESRI] = name;
        else if ("IAU2000" in name) $a9b3183caccb3297$var$defs["IAU2000:" + name.IAU2000] = name;
        else console.log(name);
        return;
    }
}
(0, $95bfc720255032a6$export$2e2bcd8739ae039)($a9b3183caccb3297$var$defs);
var $a9b3183caccb3297$export$2e2bcd8739ae039 = $a9b3183caccb3297$var$defs;





function $bddd3b9c0d2064cd$var$testObj(code) {
    return typeof code === "string";
}
function $bddd3b9c0d2064cd$var$testDef(code) {
    return code in (0, $a9b3183caccb3297$export$2e2bcd8739ae039);
}
var $bddd3b9c0d2064cd$var$codeWords = [
    "PROJECTEDCRS",
    "PROJCRS",
    "GEOGCS",
    "GEOCCS",
    "PROJCS",
    "LOCAL_CS",
    "GEODCRS",
    "GEODETICCRS",
    "GEODETICDATUM",
    "ENGCRS",
    "ENGINEERINGCRS"
];
function $bddd3b9c0d2064cd$var$testWKT(code) {
    return $bddd3b9c0d2064cd$var$codeWords.some(function(word) {
        return code.indexOf(word) > -1;
    });
}
var $bddd3b9c0d2064cd$var$codes = [
    "3857",
    "900913",
    "3785",
    "102113"
];
function $bddd3b9c0d2064cd$var$checkMercator(item) {
    var auth = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(item, "authority");
    if (!auth) return;
    var code = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(auth, "epsg");
    return code && $bddd3b9c0d2064cd$var$codes.indexOf(code) > -1;
}
function $bddd3b9c0d2064cd$var$checkProjStr(item) {
    var ext = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(item, "extension");
    if (!ext) return;
    return (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(ext, "proj4");
}
function $bddd3b9c0d2064cd$var$testProj(code) {
    return code[0] === "+";
}
function $bddd3b9c0d2064cd$var$parse(code) {
    if ($bddd3b9c0d2064cd$var$testObj(code)) {
        //check to see if this is a WKT string
        if ($bddd3b9c0d2064cd$var$testDef(code)) return (0, $a9b3183caccb3297$export$2e2bcd8739ae039)[code];
        if ($bddd3b9c0d2064cd$var$testWKT(code)) {
            var out = (0, $5c3aabf591259c07$export$2e2bcd8739ae039)(code);
            // test of spetial case, due to this being a very common and often malformed
            if ($bddd3b9c0d2064cd$var$checkMercator(out)) return (0, $a9b3183caccb3297$export$2e2bcd8739ae039)["EPSG:3857"];
            var maybeProjStr = $bddd3b9c0d2064cd$var$checkProjStr(out);
            if (maybeProjStr) return (0, $583158df16d3522c$export$2e2bcd8739ae039)(maybeProjStr);
            return out;
        }
        if ($bddd3b9c0d2064cd$var$testProj(code)) return (0, $583158df16d3522c$export$2e2bcd8739ae039)(code);
    } else return code;
}
var $bddd3b9c0d2064cd$export$2e2bcd8739ae039 = $bddd3b9c0d2064cd$var$parse;


function $96b30a4c80088893$export$2e2bcd8739ae039(destination, source) {
    destination = destination || {};
    var value, property;
    if (!source) return destination;
    for(property in source){
        value = source[property];
        if (value !== undefined) destination[property] = value;
    }
    return destination;
}



var $bi5ZC = parcelRequire("bi5ZC");

var $a9oRf = parcelRequire("a9oRf");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d64d5a882433f366$export$2cd8252107eb640b() {
    var con = this.b / this.a;
    this.es = 1 - con * con;
    if (!("x0" in this)) this.x0 = 0;
    if (!("y0" in this)) this.y0 = 0;
    this.e = Math.sqrt(this.es);
    if (this.lat_ts) {
        if (this.sphere) this.k0 = Math.cos(this.lat_ts);
        else this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    } else if (!this.k0) {
        if (this.k) this.k0 = this.k;
        else this.k0 = 1;
    }
}
function $d64d5a882433f366$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * (0, $gyVUi.R2D) > 90 && lat * (0, $gyVUi.R2D) < -90 && lon * (0, $gyVUi.R2D) > 180 && lon * (0, $gyVUi.R2D) < -180) return null;
    var x, y;
    if (Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) return null;
    else {
        if (this.sphere) {
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0);
            y = this.y0 + this.a * this.k0 * Math.log(Math.tan((0, $gyVUi.FORTPI) + 0.5 * lat));
        } else {
            var sinphi = Math.sin(lat);
            var ts = (0, $3xC66.default)(this.e, lat, sinphi);
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0);
            y = this.y0 - this.a * this.k0 * Math.log(ts);
        }
        p.x = x;
        p.y = y;
        return p;
    }
}
function $d64d5a882433f366$export$70ae2c07e401031b(p) {
    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;
    if (this.sphere) lat = (0, $gyVUi.HALF_PI) - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
    else {
        var ts = Math.exp(-y / (this.a * this.k0));
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    }
    lon = (0, $a9oRf.default)(this.long0 + x / (this.a * this.k0));
    p.x = lon;
    p.y = lat;
    return p;
}
var $d64d5a882433f366$export$e4b2ac9215619f8d = [
    "Mercator",
    "Popular Visualisation Pseudo Mercator",
    "Mercator_1SP",
    "Mercator_Auxiliary_Sphere",
    "merc"
];
var $d64d5a882433f366$export$2e2bcd8739ae039 = {
    init: $d64d5a882433f366$export$2cd8252107eb640b,
    forward: $d64d5a882433f366$export$174bb771924e7eb1,
    inverse: $d64d5a882433f366$export$70ae2c07e401031b,
    names: $d64d5a882433f366$export$e4b2ac9215619f8d
};


function $dad2845bfa7291b9$export$2cd8252107eb640b() {
//no-op for longlat
}
function $dad2845bfa7291b9$export$174bb771924e7eb1(pt) {
    return pt;
}
var $dad2845bfa7291b9$export$e4b2ac9215619f8d = [
    "longlat",
    "identity"
];
var $dad2845bfa7291b9$export$2e2bcd8739ae039 = {
    init: $dad2845bfa7291b9$export$2cd8252107eb640b,
    forward: $dad2845bfa7291b9$export$174bb771924e7eb1,
    inverse: $dad2845bfa7291b9$export$174bb771924e7eb1,
    names: $dad2845bfa7291b9$export$e4b2ac9215619f8d
};


var $169de593aeaa174c$var$projs = [
    (0, $d64d5a882433f366$export$2e2bcd8739ae039),
    (0, $dad2845bfa7291b9$export$2e2bcd8739ae039)
];
var $169de593aeaa174c$var$names = {};
var $169de593aeaa174c$var$projStore = [];
function $169de593aeaa174c$export$e16d8520af44a096(proj, i) {
    var len = $169de593aeaa174c$var$projStore.length;
    if (!proj.names) {
        console.log(i);
        return true;
    }
    $169de593aeaa174c$var$projStore[len] = proj;
    proj.names.forEach(function(n) {
        $169de593aeaa174c$var$names[n.toLowerCase()] = len;
    });
    return this;
}
function $169de593aeaa174c$export$3988ae62b71be9a3(name) {
    if (!name) return false;
    var n = name.toLowerCase();
    if (typeof $169de593aeaa174c$var$names[n] !== "undefined" && $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]]) return $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]];
}
function $169de593aeaa174c$export$b3571188c770cc5a() {
    $169de593aeaa174c$var$projs.forEach($169de593aeaa174c$export$e16d8520af44a096);
}
var $169de593aeaa174c$export$2e2bcd8739ae039 = {
    start: $169de593aeaa174c$export$b3571188c770cc5a,
    add: $169de593aeaa174c$export$e16d8520af44a096,
    get: $169de593aeaa174c$export$3988ae62b71be9a3
};



var $gyVUi = parcelRequire("gyVUi");
var $8988c354f092c217$export$2e2bcd8739ae039 = {};
$8988c354f092c217$export$2e2bcd8739ae039.MERIT = {
    a: 6378137.0,
    rf: 298.257,
    ellipseName: "MERIT 1983"
};
$8988c354f092c217$export$2e2bcd8739ae039.SGS85 = {
    a: 6378136.0,
    rf: 298.257,
    ellipseName: "Soviet Geodetic System 85"
};
$8988c354f092c217$export$2e2bcd8739ae039.GRS80 = {
    a: 6378137.0,
    rf: 298.257222101,
    ellipseName: "GRS 1980(IUGG, 1980)"
};
$8988c354f092c217$export$2e2bcd8739ae039.IAU76 = {
    a: 6378140.0,
    rf: 298.257,
    ellipseName: "IAU 1976"
};
$8988c354f092c217$export$2e2bcd8739ae039.airy = {
    a: 6377563.396,
    b: 6356256.910,
    ellipseName: "Airy 1830"
};
$8988c354f092c217$export$2e2bcd8739ae039.APL4 = {
    a: 6378137,
    rf: 298.25,
    ellipseName: "Appl. Physics. 1965"
};
$8988c354f092c217$export$2e2bcd8739ae039.NWL9D = {
    a: 6378145.0,
    rf: 298.25,
    ellipseName: "Naval Weapons Lab., 1965"
};
$8988c354f092c217$export$2e2bcd8739ae039.mod_airy = {
    a: 6377340.189,
    b: 6356034.446,
    ellipseName: "Modified Airy"
};
$8988c354f092c217$export$2e2bcd8739ae039.andrae = {
    a: 6377104.43,
    rf: 300.0,
    ellipseName: "Andrae 1876 (Den., Iclnd.)"
};
$8988c354f092c217$export$2e2bcd8739ae039.aust_SA = {
    a: 6378160.0,
    rf: 298.25,
    ellipseName: "Australian Natl & S. Amer. 1969"
};
$8988c354f092c217$export$2e2bcd8739ae039.GRS67 = {
    a: 6378160.0,
    rf: 298.2471674270,
    ellipseName: "GRS 67(IUGG 1967)"
};
$8988c354f092c217$export$2e2bcd8739ae039.bessel = {
    a: 6377397.155,
    rf: 299.1528128,
    ellipseName: "Bessel 1841"
};
$8988c354f092c217$export$2e2bcd8739ae039.bess_nam = {
    a: 6377483.865,
    rf: 299.1528128,
    ellipseName: "Bessel 1841 (Namibia)"
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk66 = {
    a: 6378206.4,
    b: 6356583.8,
    ellipseName: "Clarke 1866"
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk80 = {
    a: 6378249.145,
    rf: 293.4663,
    ellipseName: "Clarke 1880 mod."
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk58 = {
    a: 6378293.645208759,
    rf: 294.2606763692654,
    ellipseName: "Clarke 1858"
};
$8988c354f092c217$export$2e2bcd8739ae039.CPM = {
    a: 6375738.7,
    rf: 334.29,
    ellipseName: "Comm. des Poids et Mesures 1799"
};
$8988c354f092c217$export$2e2bcd8739ae039.delmbr = {
    a: 6376428.0,
    rf: 311.5,
    ellipseName: "Delambre 1810 (Belgium)"
};
$8988c354f092c217$export$2e2bcd8739ae039.engelis = {
    a: 6378136.05,
    rf: 298.2566,
    ellipseName: "Engelis 1985"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst30 = {
    a: 6377276.345,
    rf: 300.8017,
    ellipseName: "Everest 1830"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst48 = {
    a: 6377304.063,
    rf: 300.8017,
    ellipseName: "Everest 1948"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst56 = {
    a: 6377301.243,
    rf: 300.8017,
    ellipseName: "Everest 1956"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst69 = {
    a: 6377295.664,
    rf: 300.8017,
    ellipseName: "Everest 1969"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrstSS = {
    a: 6377298.556,
    rf: 300.8017,
    ellipseName: "Everest (Sabah & Sarawak)"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr60 = {
    a: 6378166.0,
    rf: 298.3,
    ellipseName: "Fischer (Mercury Datum) 1960"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr60m = {
    a: 6378155.0,
    rf: 298.3,
    ellipseName: "Fischer 1960"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr68 = {
    a: 6378150.0,
    rf: 298.3,
    ellipseName: "Fischer 1968"
};
$8988c354f092c217$export$2e2bcd8739ae039.helmert = {
    a: 6378200.0,
    rf: 298.3,
    ellipseName: "Helmert 1906"
};
$8988c354f092c217$export$2e2bcd8739ae039.hough = {
    a: 6378270.0,
    rf: 297.0,
    ellipseName: "Hough"
};
$8988c354f092c217$export$2e2bcd8739ae039.intl = {
    a: 6378388.0,
    rf: 297.0,
    ellipseName: "International 1909 (Hayford)"
};
$8988c354f092c217$export$2e2bcd8739ae039.kaula = {
    a: 6378163.0,
    rf: 298.24,
    ellipseName: "Kaula 1961"
};
$8988c354f092c217$export$2e2bcd8739ae039.lerch = {
    a: 6378139.0,
    rf: 298.257,
    ellipseName: "Lerch 1979"
};
$8988c354f092c217$export$2e2bcd8739ae039.mprts = {
    a: 6397300.0,
    rf: 191.0,
    ellipseName: "Maupertius 1738"
};
$8988c354f092c217$export$2e2bcd8739ae039.new_intl = {
    a: 6378157.5,
    b: 6356772.2,
    ellipseName: "New International 1967"
};
$8988c354f092c217$export$2e2bcd8739ae039.plessis = {
    a: 6376523.0,
    rf: 6355863.0,
    ellipseName: "Plessis 1817 (France)"
};
$8988c354f092c217$export$2e2bcd8739ae039.krass = {
    a: 6378245.0,
    rf: 298.3,
    ellipseName: "Krassovsky, 1942"
};
$8988c354f092c217$export$2e2bcd8739ae039.SEasia = {
    a: 6378155.0,
    b: 6356773.3205,
    ellipseName: "Southeast Asia"
};
$8988c354f092c217$export$2e2bcd8739ae039.walbeck = {
    a: 6376896.0,
    b: 6355834.8467,
    ellipseName: "Walbeck"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS60 = {
    a: 6378165.0,
    rf: 298.3,
    ellipseName: "WGS 60"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS66 = {
    a: 6378145.0,
    rf: 298.25,
    ellipseName: "WGS 66"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS7 = {
    a: 6378135.0,
    rf: 298.26,
    ellipseName: "WGS 72"
};
var $8988c354f092c217$export$a1db874f6c0f1ba1 = $8988c354f092c217$export$2e2bcd8739ae039.WGS84 = {
    a: 6378137.0,
    rf: 298.257223563,
    ellipseName: "WGS 84"
};
$8988c354f092c217$export$2e2bcd8739ae039.sphere = {
    a: 6370997.0,
    b: 6370997.0,
    ellipseName: "Normal Sphere (r=6370997)"
};



function $98f4ab684186b766$export$e3d7bf2ed2a7479f(a, b, rf, R_A) {
    var a2 = a * a; // used in geocentric
    var b2 = b * b; // used in geocentric
    var es = (a2 - b2) / a2; // e ^ 2
    var e = 0;
    if (R_A) {
        a *= 1 - es * ((0, $gyVUi.SIXTH) + es * ((0, $gyVUi.RA4) + es * (0, $gyVUi.RA6)));
        a2 = a * a;
        es = 0;
    } else e = Math.sqrt(es); // eccentricity
    var ep2 = (a2 - b2) / b2; // used in geocentric
    return {
        es: es,
        e: e,
        ep2: ep2
    };
}
function $98f4ab684186b766$export$b2690196de52b050(a, b, rf, ellps, sphere) {
    if (!a) {
        var ellipse = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $8988c354f092c217$export$2e2bcd8739ae039), ellps);
        if (!ellipse) ellipse = (0, $8988c354f092c217$export$a1db874f6c0f1ba1);
        a = ellipse.a;
        b = ellipse.b;
        rf = ellipse.rf;
    }
    if (rf && !b) b = (1.0 - 1.0 / rf) * a;
    if (rf === 0 || Math.abs(a - b) < (0, $gyVUi.EPSLN)) {
        sphere = true;
        b = a;
    }
    return {
        a: a,
        b: b,
        rf: rf,
        sphere: sphere
    };
}


var $c36bbc8057de3d00$export$2e2bcd8739ae039 = {};
$c36bbc8057de3d00$export$2e2bcd8739ae039.wgs84 = {
    towgs84: "0,0,0",
    ellipse: "WGS84",
    datumName: "WGS84"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.ch1903 = {
    towgs84: "674.374,15.056,405.346",
    ellipse: "bessel",
    datumName: "swiss"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.ggrs87 = {
    towgs84: "-199.87,74.79,246.62",
    ellipse: "GRS80",
    datumName: "Greek_Geodetic_Reference_System_1987"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.nad83 = {
    towgs84: "0,0,0",
    ellipse: "GRS80",
    datumName: "North_American_Datum_1983"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.nad27 = {
    nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
    ellipse: "clrk66",
    datumName: "North_American_Datum_1927"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.potsdam = {
    towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
    ellipse: "bessel",
    datumName: "Potsdam Rauenberg 1950 DHDN"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.carthage = {
    towgs84: "-263.0,6.0,431.0",
    ellipse: "clark80",
    datumName: "Carthage 1934 Tunisia"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.hermannskogel = {
    towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
    ellipse: "bessel",
    datumName: "Hermannskogel"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.osni52 = {
    towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
    ellipse: "airy",
    datumName: "Irish National"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.ire65 = {
    towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
    ellipse: "mod_airy",
    datumName: "Ireland 1965"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.rassadiran = {
    towgs84: "-133.63,-157.5,-158.62",
    ellipse: "intl",
    datumName: "Rassadiran"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.nzgd49 = {
    towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
    ellipse: "intl",
    datumName: "New Zealand Geodetic Datum 1949"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.osgb36 = {
    towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
    ellipse: "airy",
    datumName: "Airy 1830"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.s_jtsk = {
    towgs84: "589,76,480",
    ellipse: "bessel",
    datumName: "S-JTSK (Ferro)"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.beduaram = {
    towgs84: "-106,-87,188",
    ellipse: "clrk80",
    datumName: "Beduaram"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.gunung_segara = {
    towgs84: "-403,684,41",
    ellipse: "bessel",
    datumName: "Gunung Segara Jakarta"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.rnb72 = {
    towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
    ellipse: "intl",
    datumName: "Reseau National Belge 1972"
};



var $gyVUi = parcelRequire("gyVUi");
function $2c13a87cc45f972b$var$datum(datumCode, datum_params, a, b, es, ep2, nadgrids) {
    var out = {};
    if (datumCode === undefined || datumCode === "none") out.datum_type = (0, $gyVUi.PJD_NODATUM);
    else out.datum_type = (0, $gyVUi.PJD_WGS84);
    if (datum_params) {
        out.datum_params = datum_params.map(parseFloat);
        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) out.datum_type = (0, $gyVUi.PJD_3PARAM);
        if (out.datum_params.length > 3) {
            if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
                out.datum_type = (0, $gyVUi.PJD_7PARAM);
                out.datum_params[3] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[4] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[5] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[6] = out.datum_params[6] / 1000000.0 + 1.0;
            }
        }
    }
    if (nadgrids) {
        out.datum_type = (0, $gyVUi.PJD_GRIDSHIFT);
        out.grids = nadgrids;
    }
    out.a = a; //datum object also uses these values
    out.b = b;
    out.es = es;
    out.ep2 = ep2;
    return out;
}
var $2c13a87cc45f972b$export$2e2bcd8739ae039 = $2c13a87cc45f972b$var$datum;



/**
 * Resources for details of NTv2 file formats:
 * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
 * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
 */ var $b2d482da445fbb18$var$loadedNadgrids = {};
function $b2d482da445fbb18$export$2e2bcd8739ae039(key, data) {
    var view = new DataView(data);
    var isLittleEndian = $b2d482da445fbb18$var$detectLittleEndian(view);
    var header = $b2d482da445fbb18$var$readHeader(view, isLittleEndian);
    if (header.nSubgrids > 1) console.log("Only single NTv2 subgrids are currently supported, subsequent sub grids are ignored");
    var subgrids = $b2d482da445fbb18$var$readSubgrids(view, header, isLittleEndian);
    var nadgrid = {
        header: header,
        subgrids: subgrids
    };
    $b2d482da445fbb18$var$loadedNadgrids[key] = nadgrid;
    return nadgrid;
}
function $b2d482da445fbb18$export$31c4d9288d81329a(nadgrids) {
    // Format details: http://proj.maptools.org/gen_parms.html
    if (nadgrids === undefined) return null;
    var grids = nadgrids.split(",");
    return grids.map($b2d482da445fbb18$var$parseNadgridString);
}
function $b2d482da445fbb18$var$parseNadgridString(value) {
    if (value.length === 0) return null;
    var optional = value[0] === "@";
    if (optional) value = value.slice(1);
    if (value === "null") return {
        name: "null",
        mandatory: !optional,
        grid: null,
        isNull: true
    };
    return {
        name: value,
        mandatory: !optional,
        grid: $b2d482da445fbb18$var$loadedNadgrids[value] || null,
        isNull: false
    };
}
function $b2d482da445fbb18$var$secondsToRadians(seconds) {
    return seconds / 3600 * Math.PI / 180;
}
function $b2d482da445fbb18$var$detectLittleEndian(view) {
    var nFields = view.getInt32(8, false);
    if (nFields === 11) return false;
    nFields = view.getInt32(8, true);
    if (nFields !== 11) console.warn("Failed to detect nadgrid endian-ness, defaulting to little-endian");
    return true;
}
function $b2d482da445fbb18$var$readHeader(view, isLittleEndian) {
    return {
        nFields: view.getInt32(8, isLittleEndian),
        nSubgridFields: view.getInt32(24, isLittleEndian),
        nSubgrids: view.getInt32(40, isLittleEndian),
        shiftType: $b2d482da445fbb18$var$decodeString(view, 56, 64).trim(),
        fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
        fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
        toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
        toSemiMinorAxis: view.getFloat64(168, isLittleEndian)
    };
}
function $b2d482da445fbb18$var$decodeString(view, start, end) {
    return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
}
function $b2d482da445fbb18$var$readSubgrids(view, header, isLittleEndian) {
    var gridOffset = 176;
    var grids = [];
    for(var i = 0; i < header.nSubgrids; i++){
        var subHeader = $b2d482da445fbb18$var$readGridHeader(view, gridOffset, isLittleEndian);
        var nodes = $b2d482da445fbb18$var$readGridNodes(view, gridOffset, subHeader, isLittleEndian);
        var lngColumnCount = Math.round(1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
        var latColumnCount = Math.round(1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
        // Proj4 operates on radians whereas the coordinates are in seconds in the grid
        grids.push({
            ll: [
                $b2d482da445fbb18$var$secondsToRadians(subHeader.lowerLongitude),
                $b2d482da445fbb18$var$secondsToRadians(subHeader.lowerLatitude)
            ],
            del: [
                $b2d482da445fbb18$var$secondsToRadians(subHeader.longitudeInterval),
                $b2d482da445fbb18$var$secondsToRadians(subHeader.latitudeInterval)
            ],
            lim: [
                lngColumnCount,
                latColumnCount
            ],
            count: subHeader.gridNodeCount,
            cvs: $b2d482da445fbb18$var$mapNodes(nodes)
        });
    }
    return grids;
}
function $b2d482da445fbb18$var$mapNodes(nodes) {
    return nodes.map(function(r) {
        return [
            $b2d482da445fbb18$var$secondsToRadians(r.longitudeShift),
            $b2d482da445fbb18$var$secondsToRadians(r.latitudeShift)
        ];
    });
}
function $b2d482da445fbb18$var$readGridHeader(view, offset, isLittleEndian) {
    return {
        name: $b2d482da445fbb18$var$decodeString(view, offset + 8, offset + 16).trim(),
        parent: $b2d482da445fbb18$var$decodeString(view, offset + 24, offset + 24 + 8).trim(),
        lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
        upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
        lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
        upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
        latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
        longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
        gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
    };
}
function $b2d482da445fbb18$var$readGridNodes(view, offset, gridHeader, isLittleEndian) {
    var nodesOffset = offset + 176;
    var gridRecordLength = 16;
    var gridShiftRecords = [];
    for(var i = 0; i < gridHeader.gridNodeCount; i++){
        var record = {
            latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
            longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian),
            latitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian),
            longitudeAccuracy: view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian)
        };
        gridShiftRecords.push(record);
    }
    return gridShiftRecords;
}


function $24869d6338533b3b$var$Projection(srsCode, callback) {
    if (!(this instanceof $24869d6338533b3b$var$Projection)) return new $24869d6338533b3b$var$Projection(srsCode);
    callback = callback || function(error) {
        if (error) throw error;
    };
    var json = (0, $bddd3b9c0d2064cd$export$2e2bcd8739ae039)(srsCode);
    if (typeof json !== "object") {
        callback(srsCode);
        return;
    }
    var ourProj = $24869d6338533b3b$var$Projection.projections.get(json.projName);
    if (!ourProj) {
        callback(srsCode);
        return;
    }
    if (json.datumCode && json.datumCode !== "none") {
        var datumDef = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $c36bbc8057de3d00$export$2e2bcd8739ae039), json.datumCode);
        if (datumDef) {
            json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(",") : null);
            json.ellps = datumDef.ellipse;
            json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
        }
    }
    json.k0 = json.k0 || 1.0;
    json.axis = json.axis || "enu";
    json.ellps = json.ellps || "wgs84";
    json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this
    var sphere_ = (0, $98f4ab684186b766$export$b2690196de52b050)(json.a, json.b, json.rf, json.ellps, json.sphere);
    var ecc = (0, $98f4ab684186b766$export$e3d7bf2ed2a7479f)(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
    var nadgrids = (0, $b2d482da445fbb18$export$31c4d9288d81329a)(json.nadgrids);
    var datumObj = json.datum || (0, $2c13a87cc45f972b$export$2e2bcd8739ae039)(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2, nadgrids);
    (0, $96b30a4c80088893$export$2e2bcd8739ae039)(this, json); // transfer everything over from the projection because we don't know what we'll need
    (0, $96b30a4c80088893$export$2e2bcd8739ae039)(this, ourProj); // transfer all the methods from the projection
    // copy the 4 things over we calulated in deriveConstants.sphere
    this.a = sphere_.a;
    this.b = sphere_.b;
    this.rf = sphere_.rf;
    this.sphere = sphere_.sphere;
    // copy the 3 things we calculated in deriveConstants.eccentricity
    this.es = ecc.es;
    this.e = ecc.e;
    this.ep2 = ecc.ep2;
    // add in the datum object
    this.datum = datumObj;
    // init the projection
    this.init();
    // legecy callback from back in the day when it went to spatialreference.org
    callback(null, this);
}
$24869d6338533b3b$var$Projection.projections = (0, $169de593aeaa174c$export$2e2bcd8739ae039);
$24869d6338533b3b$var$Projection.projections.start();
var $24869d6338533b3b$export$2e2bcd8739ae039 = $24869d6338533b3b$var$Projection;



var $gyVUi = parcelRequire("gyVUi");

var $gyVUi = parcelRequire("gyVUi");

var $gyVUi = parcelRequire("gyVUi");
"use strict";
function $3a04bd721826a648$export$68c8d8590fbb24e4(source, dest) {
    if (source.datum_type !== dest.datum_type) return false; // false, datums are not equal
    else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) // the tolerance for es is to ensure that GRS80 and WGS84
    // are considered identical
    return false;
    else if (source.datum_type === (0, $gyVUi.PJD_3PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2];
    else if (source.datum_type === (0, $gyVUi.PJD_7PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6];
    else return true; // datums are equal
} // cs_compare_datums()
function $3a04bd721826a648$export$4a4ae2976f9a808a(p, es, a) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; //Z value not always supplied
    var Rn; /*  Earth radius at location  */ 
    var Sin_Lat; /*  Math.sin(Latitude)  */ 
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */ 
    var Cos_Lat; /*  Math.cos(Latitude)  */ 
    /*
   ** Don't blow up if Latitude is just a little out of the value
   ** range as it may just be a rounding issue.  Also removed longitude
   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
   */ if (Latitude < -(0, $gyVUi.HALF_PI) && Latitude > -1.001 * (0, $gyVUi.HALF_PI)) Latitude = -(0, $gyVUi.HALF_PI);
    else if (Latitude > (0, $gyVUi.HALF_PI) && Latitude < 1.001 * (0, $gyVUi.HALF_PI)) Latitude = (0, $gyVUi.HALF_PI);
    else if (Latitude < -(0, $gyVUi.HALF_PI)) /* Latitude out of range */ //..reportError('geocent:lat out of range:' + Latitude);
    return {
        x: -Infinity,
        y: -Infinity,
        z: p.z
    };
    else if (Latitude > (0, $gyVUi.HALF_PI)) /* Latitude out of range */ return {
        x: Infinity,
        y: Infinity,
        z: p.z
    };
    if (Longitude > Math.PI) Longitude -= 2 * Math.PI;
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = a / Math.sqrt(1.0e0 - es * Sin2_Lat);
    return {
        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
        z: (Rn * (1 - es) + Height) * Sin_Lat
    };
} // cs_geodetic_to_geocentric()
function $3a04bd721826a648$export$26210192c8922750(p, es, a, b) {
    /* local defintions and variables */ /* end-criterium of loop, accuracy of sin(Latitude) */ var genau = 1e-12;
    var genau2 = genau * genau;
    var maxiter = 30;
    var P; /* distance between semi-minor axis and location */ 
    var RR; /* distance between center and location */ 
    var CT; /* sin of geocentric latitude */ 
    var ST; /* cos of geocentric latitude */ 
    var RX;
    var RK;
    var RN; /* Earth radius at location */ 
    var CPHI0; /* cos of start or old geodetic latitude in iterations */ 
    var SPHI0; /* sin of start or old geodetic latitude in iterations */ 
    var CPHI; /* cos of searched geodetic latitude */ 
    var SPHI; /* sin of searched geodetic latitude */ 
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */ 
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */ 
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; //Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);
    /*      special cases for latitude and longitude */ if (P / a < genau) {
        /*  special case, if P=0. (X=0., Y=0.) */ Longitude = 0.0;
        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */ if (RR / a < genau) {
            Latitude = (0, $gyVUi.HALF_PI);
            Height = -b;
            return {
                x: p.x,
                y: p.y,
                z: p.z
            };
        }
    } else /*  ellipsoidal (geodetic) longitude
     *  interval: -PI < Longitude <= +PI */ Longitude = Math.atan2(Y, X);
    /* --------------------------------------------------------------
   * Following iterative algorithm was developped by
   * "Institut for Erdmessung", University of Hannover, July 1988.
   * Internet: www.ife.uni-hannover.de
   * Iterative computation of CPHI,SPHI and Height.
   * Iteration of CPHI and SPHI to 10**-12 radian resp.
   * 2*10**-7 arcsec.
   * --------------------------------------------------------------
   */ CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
    CPHI0 = ST * (1.0 - es) * RX;
    SPHI0 = CT * RX;
    iter = 0;
    /* loop to find sin(Latitude) resp. Latitude
   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */ do {
        iter++;
        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);
        /*  ellipsoidal (geodetic) height */ Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);
        RK = es * RN / (RN + Height);
        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
        CPHI = ST * (1.0 - RK) * RX;
        SPHI = CT * RX;
        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
        CPHI0 = CPHI;
        SPHI0 = SPHI;
    }while (SDPHI * SDPHI > genau2 && iter < maxiter);
    /*      ellipsoidal (geodetic) latitude */ Latitude = Math.atan(SPHI / Math.abs(CPHI));
    return {
        x: Longitude,
        y: Latitude,
        z: Height
    };
} // cs_geocentric_to_geodetic()
function $3a04bd721826a648$export$d18952b9ecb47c8f(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x + datum_params[0],
        y: p.y + datum_params[1],
        z: p.z + datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
            y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
            z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
        };
    }
} // cs_geocentric_to_wgs84
function $3a04bd721826a648$export$2b744ad521e7ac0b(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) //if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x - datum_params[0],
        y: p.y - datum_params[1],
        z: p.z - datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        var x_tmp = (p.x - Dx_BF) / M_BF;
        var y_tmp = (p.y - Dy_BF) / M_BF;
        var z_tmp = (p.z - Dz_BF) / M_BF;
        //if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
            y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
            z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
        };
    } //cs_geocentric_from_wgs84()
}



var $a9oRf = parcelRequire("a9oRf");
function $98d040a88dc0214f$var$checkParams(type) {
    return type === (0, $gyVUi.PJD_3PARAM) || type === (0, $gyVUi.PJD_7PARAM);
}
function $98d040a88dc0214f$export$2e2bcd8739ae039(source, dest, point) {
    // Short cut if the datums are identical.
    if ((0, $3a04bd721826a648$export$68c8d8590fbb24e4)(source, dest)) return point; // in this case, zero is sucess,
    // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
    if (source.datum_type === (0, $gyVUi.PJD_NODATUM) || dest.datum_type === (0, $gyVUi.PJD_NODATUM)) return point;
    // If this datum requires grid shifts, then apply it to geodetic coordinates.
    var source_a = source.a;
    var source_es = source.es;
    if (source.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        var gridShiftCode = $98d040a88dc0214f$export$cfa06df23524576a(source, false, point);
        if (gridShiftCode !== 0) return undefined;
        source_a = (0, $gyVUi.SRS_WGS84_SEMIMAJOR);
        source_es = (0, $gyVUi.SRS_WGS84_ESQUARED);
    }
    var dest_a = dest.a;
    var dest_b = dest.b;
    var dest_es = dest.es;
    if (dest.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        dest_a = (0, $gyVUi.SRS_WGS84_SEMIMAJOR);
        dest_b = (0, $gyVUi.SRS_WGS84_SEMIMINOR);
        dest_es = (0, $gyVUi.SRS_WGS84_ESQUARED);
    }
    // Do we need to go through geocentric coordinates?
    if (source_es === dest_es && source_a === dest_a && !$98d040a88dc0214f$var$checkParams(source.datum_type) && !$98d040a88dc0214f$var$checkParams(dest.datum_type)) return point;
    // Convert to geocentric coordinates.
    point = (0, $3a04bd721826a648$export$4a4ae2976f9a808a)(point, source_es, source_a);
    // Convert between datums
    if ($98d040a88dc0214f$var$checkParams(source.datum_type)) point = (0, $3a04bd721826a648$export$d18952b9ecb47c8f)(point, source.datum_type, source.datum_params);
    if ($98d040a88dc0214f$var$checkParams(dest.datum_type)) point = (0, $3a04bd721826a648$export$2b744ad521e7ac0b)(point, dest.datum_type, dest.datum_params);
    point = (0, $3a04bd721826a648$export$26210192c8922750)(point, dest_es, dest_a, dest_b);
    if (dest.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        var destGridShiftResult = $98d040a88dc0214f$export$cfa06df23524576a(dest, true, point);
        if (destGridShiftResult !== 0) return undefined;
    }
    return point;
}
function $98d040a88dc0214f$export$cfa06df23524576a(source, inverse, point) {
    if (source.grids === null || source.grids.length === 0) {
        console.log("Grid shift grids not found");
        return -1;
    }
    var input = {
        x: -point.x,
        y: point.y
    };
    var output = {
        x: Number.NaN,
        y: Number.NaN
    };
    var onlyMandatoryGrids = false;
    var attemptedGrids = [];
    for(var i = 0; i < source.grids.length; i++){
        var grid = source.grids[i];
        attemptedGrids.push(grid.name);
        if (grid.isNull) {
            output = input;
            break;
        }
        onlyMandatoryGrids = grid.mandatory;
        if (grid.grid === null) {
            if (grid.mandatory) {
                console.log("Unable to find mandatory grid '" + grid.name + "'");
                return -1;
            }
            continue;
        }
        var subgrid = grid.grid.subgrids[0];
        // skip tables that don't match our point at all
        var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
        var minX = subgrid.ll[0] - epsilon;
        var minY = subgrid.ll[1] - epsilon;
        var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
        var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
        if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x) continue;
        output = $98d040a88dc0214f$var$applySubgridShift(input, inverse, subgrid);
        if (!isNaN(output.x)) break;
    }
    if (isNaN(output.x)) {
        console.log("Failed to find a grid shift table for location '" + -input.x * (0, $gyVUi.R2D) + " " + input.y * (0, $gyVUi.R2D) + " tried: '" + attemptedGrids + "'");
        return -1;
    }
    point.x = -output.x;
    point.y = output.y;
    return 0;
}
function $98d040a88dc0214f$var$applySubgridShift(pin, inverse, ct) {
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    if (isNaN(pin.x)) return val;
    var tb = {
        x: pin.x,
        y: pin.y
    };
    tb.x -= ct.ll[0];
    tb.y -= ct.ll[1];
    tb.x = (0, $a9oRf.default)(tb.x - Math.PI) + Math.PI;
    var t = $98d040a88dc0214f$var$nadInterpolate(tb, ct);
    if (inverse) {
        if (isNaN(t.x)) return val;
        t.x = tb.x - t.x;
        t.y = tb.y - t.y;
        var i = 9, tol = 1e-12;
        var dif, del;
        do {
            del = $98d040a88dc0214f$var$nadInterpolate(t, ct);
            if (isNaN(del.x)) {
                console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
                break;
            }
            dif = {
                x: tb.x - (del.x + t.x),
                y: tb.y - (del.y + t.y)
            };
            t.x += dif.x;
            t.y += dif.y;
        }while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
        if (i < 0) {
            console.log("Inverse grid shift iterator failed to converge.");
            return val;
        }
        val.x = (0, $a9oRf.default)(t.x + ct.ll[0]);
        val.y = t.y + ct.ll[1];
    } else if (!isNaN(t.x)) {
        val.x = pin.x + t.x;
        val.y = pin.y + t.y;
    }
    return val;
}
function $98d040a88dc0214f$var$nadInterpolate(pin, ct) {
    var t = {
        x: pin.x / ct.del[0],
        y: pin.y / ct.del[1]
    };
    var indx = {
        x: Math.floor(t.x),
        y: Math.floor(t.y)
    };
    var frct = {
        x: t.x - 1.0 * indx.x,
        y: t.y - 1.0 * indx.y
    };
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    var inx;
    if (indx.x < 0 || indx.x >= ct.lim[0]) return val;
    if (indx.y < 0 || indx.y >= ct.lim[1]) return val;
    inx = indx.y * ct.lim[0] + indx.x;
    var f00 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx++;
    var f10 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx += ct.lim[0];
    var f11 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx--;
    var f01 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y), m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
    val.x = m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x;
    val.y = m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y;
    return val;
}


function $cedb7bb5617791b0$export$2e2bcd8739ae039(crs, denorm, point) {
    var xin = point.x, yin = point.y, zin = point.z || 0.0;
    var v, t, i;
    var out = {};
    for(i = 0; i < 3; i++){
        if (denorm && i === 2 && point.z === undefined) continue;
        if (i === 0) {
            v = xin;
            if ("ew".indexOf(crs.axis[i]) !== -1) t = "x";
            else t = "y";
        } else if (i === 1) {
            v = yin;
            if ("ns".indexOf(crs.axis[i]) !== -1) t = "y";
            else t = "x";
        } else {
            v = zin;
            t = "z";
        }
        switch(crs.axis[i]){
            case "e":
                out[t] = v;
                break;
            case "w":
                out[t] = -v;
                break;
            case "n":
                out[t] = v;
                break;
            case "s":
                out[t] = -v;
                break;
            case "u":
                if (point[t] !== undefined) out.z = v;
                break;
            case "d":
                if (point[t] !== undefined) out.z = -v;
                break;
            default:
                //console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
                return null;
        }
    }
    return out;
}



function $01093474ae9bd8f6$export$2e2bcd8739ae039(array) {
    var out = {
        x: array[0],
        y: array[1]
    };
    if (array.length > 2) out.z = array[2];
    if (array.length > 3) out.m = array[3];
    return out;
}


function $906e8b8bdc80d434$export$2e2bcd8739ae039(point) {
    $906e8b8bdc80d434$var$checkCoord(point.x);
    $906e8b8bdc80d434$var$checkCoord(point.y);
}
function $906e8b8bdc80d434$var$checkCoord(num) {
    if (typeof Number.isFinite === "function") {
        if (Number.isFinite(num)) return;
        throw new TypeError("coordinates must be finite numbers");
    }
    if (typeof num !== "number" || num !== num || !isFinite(num)) throw new TypeError("coordinates must be finite numbers");
}


function $8e8cfb7cbefc2113$var$checkNotWGS(source, dest) {
    return (source.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || source.datum.datum_type === (0, $gyVUi.PJD_7PARAM)) && dest.datumCode !== "WGS84" || (dest.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || dest.datum.datum_type === (0, $gyVUi.PJD_7PARAM)) && source.datumCode !== "WGS84";
}
function $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, dest, point, enforceAxis) {
    var wgs84;
    if (Array.isArray(point)) point = (0, $01093474ae9bd8f6$export$2e2bcd8739ae039)(point);
    (0, $906e8b8bdc80d434$export$2e2bcd8739ae039)(point);
    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && $8e8cfb7cbefc2113$var$checkNotWGS(source, dest)) {
        wgs84 = new (0, $24869d6338533b3b$export$2e2bcd8739ae039)("WGS84");
        point = $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, wgs84, point, enforceAxis);
        source = wgs84;
    }
    // DGR, 2010/11/12
    if (enforceAxis && source.axis !== "enu") point = (0, $cedb7bb5617791b0$export$2e2bcd8739ae039)(source, false, point);
    // Transform source points to long/lat, if they aren't already.
    if (source.projName === "longlat") point = {
        x: point.x * (0, $gyVUi.D2R),
        y: point.y * (0, $gyVUi.D2R),
        z: point.z || 0
    };
    else {
        if (source.to_meter) point = {
            x: point.x * source.to_meter,
            y: point.y * source.to_meter,
            z: point.z || 0
        };
        point = source.inverse(point); // Convert Cartesian to longlat
        if (!point) return;
    }
    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) point.x += source.from_greenwich;
    // Convert datums if needed, and if possible.
    point = (0, $98d040a88dc0214f$export$2e2bcd8739ae039)(source.datum, dest.datum, point);
    if (!point) return;
    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) point = {
        x: point.x - dest.from_greenwich,
        y: point.y,
        z: point.z || 0
    };
    if (dest.projName === "longlat") // convert radians to decimal degrees
    point = {
        x: point.x * (0, $gyVUi.R2D),
        y: point.y * (0, $gyVUi.R2D),
        z: point.z || 0
    };
    else {
        point = dest.forward(point);
        if (dest.to_meter) point = {
            x: point.x / dest.to_meter,
            y: point.y / dest.to_meter,
            z: point.z || 0
        };
    }
    // DGR, 2010/11/12
    if (enforceAxis && dest.axis !== "enu") return (0, $cedb7bb5617791b0$export$2e2bcd8739ae039)(dest, true, point);
    return point;
}


var $471507637a3ff861$var$wgs84 = (0, $24869d6338533b3b$export$2e2bcd8739ae039)("WGS84");
function $471507637a3ff861$var$transformer(from, to, coords, enforceAxis) {
    var transformedArray, out, keys;
    if (Array.isArray(coords)) {
        transformedArray = (0, $8e8cfb7cbefc2113$export$2e2bcd8739ae039)(from, to, coords, enforceAxis) || {
            x: NaN,
            y: NaN
        };
        if (coords.length > 2) {
            if (typeof from.name !== "undefined" && from.name === "geocent" || typeof to.name !== "undefined" && to.name === "geocent") {
                if (typeof transformedArray.z === "number") return [
                    transformedArray.x,
                    transformedArray.y,
                    transformedArray.z
                ].concat(coords.splice(3));
                else return [
                    transformedArray.x,
                    transformedArray.y,
                    coords[2]
                ].concat(coords.splice(3));
            } else return [
                transformedArray.x,
                transformedArray.y
            ].concat(coords.splice(2));
        } else return [
            transformedArray.x,
            transformedArray.y
        ];
    } else {
        out = (0, $8e8cfb7cbefc2113$export$2e2bcd8739ae039)(from, to, coords, enforceAxis);
        keys = Object.keys(coords);
        if (keys.length === 2) return out;
        keys.forEach(function(key) {
            if (typeof from.name !== "undefined" && from.name === "geocent" || typeof to.name !== "undefined" && to.name === "geocent") {
                if (key === "x" || key === "y" || key === "z") return;
            } else {
                if (key === "x" || key === "y") return;
            }
            out[key] = coords[key];
        });
        return out;
    }
}
function $471507637a3ff861$var$checkProj(item) {
    if (item instanceof (0, $24869d6338533b3b$export$2e2bcd8739ae039)) return item;
    if (item.oProj) return item.oProj;
    return (0, $24869d6338533b3b$export$2e2bcd8739ae039)(item);
}
function $471507637a3ff861$var$proj4(fromProj, toProj, coord) {
    fromProj = $471507637a3ff861$var$checkProj(fromProj);
    var single = false;
    var obj;
    if (typeof toProj === "undefined") {
        toProj = fromProj;
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    } else if (typeof toProj.x !== "undefined" || Array.isArray(toProj)) {
        coord = toProj;
        toProj = fromProj;
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    }
    toProj = $471507637a3ff861$var$checkProj(toProj);
    if (coord) return $471507637a3ff861$var$transformer(fromProj, toProj, coord);
    else {
        obj = {
            forward: function(coords, enforceAxis) {
                return $471507637a3ff861$var$transformer(fromProj, toProj, coords, enforceAxis);
            },
            inverse: function(coords, enforceAxis) {
                return $471507637a3ff861$var$transformer(toProj, fromProj, coords, enforceAxis);
            }
        };
        if (single) obj.oProj = toProj;
        return obj;
    }
}
var $471507637a3ff861$export$2e2bcd8739ae039 = $471507637a3ff861$var$proj4;



/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */ var $31ee54b8e1d1cd8f$var$NUM_100K_SETS = 6;
/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS = "AJSAJS";
/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS = "AFAFAF";
var $31ee54b8e1d1cd8f$var$A = 65; // A
var $31ee54b8e1d1cd8f$var$I = 73; // I
var $31ee54b8e1d1cd8f$var$O = 79; // O
var $31ee54b8e1d1cd8f$var$V = 86; // V
var $31ee54b8e1d1cd8f$var$Z = 90; // Z
var $31ee54b8e1d1cd8f$export$2e2bcd8739ae039 = {
    forward: $31ee54b8e1d1cd8f$export$174bb771924e7eb1,
    inverse: $31ee54b8e1d1cd8f$export$70ae2c07e401031b,
    toPoint: $31ee54b8e1d1cd8f$export$b63cca88ddc558a9
};
function $31ee54b8e1d1cd8f$export$174bb771924e7eb1(ll, accuracy) {
    accuracy = accuracy || 5; // default accuracy 1m
    return $31ee54b8e1d1cd8f$var$encode($31ee54b8e1d1cd8f$var$LLtoUTM({
        lat: ll[1],
        lon: ll[0]
    }), accuracy);
}
function $31ee54b8e1d1cd8f$export$70ae2c07e401031b(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat,
        bbox.lon,
        bbox.lat
    ];
    return [
        bbox.left,
        bbox.bottom,
        bbox.right,
        bbox.top
    ];
}
function $31ee54b8e1d1cd8f$export$b63cca88ddc558a9(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat
    ];
    return [
        (bbox.left + bbox.right) / 2,
        (bbox.top + bbox.bottom) / 2
    ];
}
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */ function $31ee54b8e1d1cd8f$var$degToRad(deg) {
    return deg * (Math.PI / 180.0);
}
/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */ function $31ee54b8e1d1cd8f$var$radToDeg(rad) {
    return 180.0 * (rad / Math.PI);
}
/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$LLtoUTM(ll) {
    var Lat = ll.lat;
    var Long = ll.lon;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var k0 = 0.9996;
    var LongOrigin;
    var eccPrimeSquared;
    var N, T, C, A, M;
    var LatRad = $31ee54b8e1d1cd8f$var$degToRad(Lat);
    var LongRad = $31ee54b8e1d1cd8f$var$degToRad(Long);
    var LongOriginRad;
    var ZoneNumber;
    // (int)
    ZoneNumber = Math.floor((Long + 180) / 6) + 1;
    //Make sure the longitude 180.00 is in Zone 60
    if (Long === 180) ZoneNumber = 60;
    // Special zone for Norway
    if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) ZoneNumber = 32;
    // Special zones for Svalbard
    if (Lat >= 72.0 && Lat < 84.0) {
        if (Long >= 0.0 && Long < 9.0) ZoneNumber = 31;
        else if (Long >= 9.0 && Long < 21.0) ZoneNumber = 33;
        else if (Long >= 21.0 && Long < 33.0) ZoneNumber = 35;
        else if (Long >= 33.0 && Long < 42.0) ZoneNumber = 37;
    }
    LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
    // in middle of
    // zone
    LongOriginRad = $31ee54b8e1d1cd8f$var$degToRad(LongOrigin);
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
    T = Math.tan(LatRad) * Math.tan(LatRad);
    C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
    A = Math.cos(LatRad) * (LongRad - LongOriginRad);
    M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - 35 * eccSquared * eccSquared * eccSquared / 3072 * Math.sin(6 * LatRad));
    var UTMEasting = k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0;
    var UTMNorthing = k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0));
    if (Lat < 0.0) UTMNorthing += 10000000.0; //10000000 meter offset for
    return {
        northing: Math.round(UTMNorthing),
        easting: Math.round(UTMEasting),
        zoneNumber: ZoneNumber,
        zoneLetter: $31ee54b8e1d1cd8f$var$getLetterDesignator(Lat)
    };
}
/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$UTMtoLL(utm) {
    var UTMNorthing = utm.northing;
    var UTMEasting = utm.easting;
    var zoneLetter = utm.zoneLetter;
    var zoneNumber = utm.zoneNumber;
    // check the ZoneNummber is valid
    if (zoneNumber < 0 || zoneNumber > 60) return null;
    var k0 = 0.9996;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var eccPrimeSquared;
    var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
    var N1, T1, C1, R1, D, M;
    var LongOrigin;
    var mu, phi1Rad;
    // remove 500,000 meter offset for longitude
    var x = UTMEasting - 500000.0;
    var y = UTMNorthing;
    // We must know somehow if we are in the Northern or Southern
    // hemisphere, this is the only time we use the letter So even
    // if the Zone letter isn't exactly correct it should indicate
    // the hemisphere correctly
    if (zoneLetter < "N") y -= 10000000.0; // remove 10,000,000 meter offset used
    // There are 60 zones with zone 1 being at West -180 to -174
    LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
    // in middle of
    // zone
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    M = y / k0;
    mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
    phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + 151 * e1 * e1 * e1 / 96 * Math.sin(6 * mu);
    // double phi1 = ProjMath.radToDeg(phi1Rad);
    N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
    T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
    C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
    R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
    D = x / (N1 * k0);
    var lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
    lat = $31ee54b8e1d1cd8f$var$radToDeg(lat);
    var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
    lon = LongOrigin + $31ee54b8e1d1cd8f$var$radToDeg(lon);
    var result;
    if (utm.accuracy) {
        var topRight = $31ee54b8e1d1cd8f$var$UTMtoLL({
            northing: utm.northing + utm.accuracy,
            easting: utm.easting + utm.accuracy,
            zoneLetter: utm.zoneLetter,
            zoneNumber: utm.zoneNumber
        });
        result = {
            top: topRight.lat,
            right: topRight.lon,
            bottom: lat,
            left: lon
        };
    } else result = {
        lat: lat,
        lon: lon
    };
    return result;
}
/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */ function $31ee54b8e1d1cd8f$var$getLetterDesignator(lat) {
    //This is here as an error flag to show that the Latitude is
    //outside MGRS limits
    var LetterDesignator = "Z";
    if (84 >= lat && lat >= 72) LetterDesignator = "X";
    else if (72 > lat && lat >= 64) LetterDesignator = "W";
    else if (64 > lat && lat >= 56) LetterDesignator = "V";
    else if (56 > lat && lat >= 48) LetterDesignator = "U";
    else if (48 > lat && lat >= 40) LetterDesignator = "T";
    else if (40 > lat && lat >= 32) LetterDesignator = "S";
    else if (32 > lat && lat >= 24) LetterDesignator = "R";
    else if (24 > lat && lat >= 16) LetterDesignator = "Q";
    else if (16 > lat && lat >= 8) LetterDesignator = "P";
    else if (8 > lat && lat >= 0) LetterDesignator = "N";
    else if (0 > lat && lat >= -8) LetterDesignator = "M";
    else if (-8 > lat && lat >= -16) LetterDesignator = "L";
    else if (-16 > lat && lat >= -24) LetterDesignator = "K";
    else if (-24 > lat && lat >= -32) LetterDesignator = "J";
    else if (-32 > lat && lat >= -40) LetterDesignator = "H";
    else if (-40 > lat && lat >= -48) LetterDesignator = "G";
    else if (-48 > lat && lat >= -56) LetterDesignator = "F";
    else if (-56 > lat && lat >= -64) LetterDesignator = "E";
    else if (-64 > lat && lat >= -72) LetterDesignator = "D";
    else if (-72 > lat && lat >= -80) LetterDesignator = "C";
    return LetterDesignator;
}
/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$encode(utm, accuracy) {
    // prepend with leading zeroes
    var seasting = "00000" + utm.easting, snorthing = "00000" + utm.northing;
    return utm.zoneNumber + utm.zoneLetter + $31ee54b8e1d1cd8f$var$get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}
/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$get100kID(easting, northing, zoneNumber) {
    var setParm = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var setColumn = Math.floor(easting / 100000);
    var setRow = Math.floor(northing / 100000) % 20;
    return $31ee54b8e1d1cd8f$var$getLetter100kID(setColumn, setRow, setParm);
}
/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */ function $31ee54b8e1d1cd8f$var$get100kSetForZone(i) {
    var setParm = i % $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    if (setParm === 0) setParm = $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    return setParm;
}
/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */ function $31ee54b8e1d1cd8f$var$getLetter100kID(column, row, parm) {
    // colOrigin and rowOrigin are the letters at the origin of the set
    var index = parm - 1;
    var colOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
    var rowOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(index);
    // colInt and rowInt are the letters to build to return
    var colInt = colOrigin + column - 1;
    var rowInt = rowOrigin + row;
    var rollover = false;
    if (colInt > $31ee54b8e1d1cd8f$var$Z) {
        colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    }
    if (colInt === $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I && colInt > $31ee54b8e1d1cd8f$var$I || (colInt > $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) colInt++;
    if (colInt === $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O && colInt > $31ee54b8e1d1cd8f$var$O || (colInt > $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        colInt++;
        if (colInt === $31ee54b8e1d1cd8f$var$I) colInt++;
    }
    if (colInt > $31ee54b8e1d1cd8f$var$Z) colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
    if (rowInt > $31ee54b8e1d1cd8f$var$V) {
        rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    } else rollover = false;
    if (rowInt === $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I && rowInt > $31ee54b8e1d1cd8f$var$I || (rowInt > $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) rowInt++;
    if (rowInt === $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O && rowInt > $31ee54b8e1d1cd8f$var$O || (rowInt > $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        rowInt++;
        if (rowInt === $31ee54b8e1d1cd8f$var$I) rowInt++;
    }
    if (rowInt > $31ee54b8e1d1cd8f$var$V) rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
    var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
    return twoLetter;
}
/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */ function $31ee54b8e1d1cd8f$var$decode(mgrsString) {
    if (mgrsString && mgrsString.length === 0) throw "MGRSPoint coverting from nothing";
    var length = mgrsString.length;
    var hunK = null;
    var sb = "";
    var testChar;
    var i = 0;
    // get Zone number
    while(!/[A-Z]/.test(testChar = mgrsString.charAt(i))){
        if (i >= 2) throw "MGRSPoint bad conversion from: " + mgrsString;
        sb += testChar;
        i++;
    }
    var zoneNumber = parseInt(sb, 10);
    if (i === 0 || i + 3 > length) // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw "MGRSPoint bad conversion from: " + mgrsString;
    var zoneLetter = mgrsString.charAt(i++);
    // Should we check the zone letter here? Why not.
    if (zoneLetter <= "A" || zoneLetter === "B" || zoneLetter === "Y" || zoneLetter >= "Z" || zoneLetter === "I" || zoneLetter === "O") throw "MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString;
    hunK = mgrsString.substring(i, i += 2);
    var set = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var east100k = $31ee54b8e1d1cd8f$var$getEastingFromChar(hunK.charAt(0), set);
    var north100k = $31ee54b8e1d1cd8f$var$getNorthingFromChar(hunK.charAt(1), set);
    // We have a bug where the northing may be 2000000 too low.
    // How
    // do we know when to roll over?
    while(north100k < $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter))north100k += 2000000;
    // calculate the char index for easting/northing separator
    var remainder = length - i;
    if (remainder % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString;
    var sep = remainder / 2;
    var sepEasting = 0.0;
    var sepNorthing = 0.0;
    var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
    if (sep > 0) {
        accuracyBonus = 100000.0 / Math.pow(10, sep);
        sepEastingString = mgrsString.substring(i, i + sep);
        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
        sepNorthingString = mgrsString.substring(i + sep);
        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
    }
    easting = sepEasting + east100k;
    northing = sepNorthing + north100k;
    return {
        easting: easting,
        northing: northing,
        zoneLetter: zoneLetter,
        zoneNumber: zoneNumber,
        accuracy: accuracyBonus
    };
}
/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getEastingFromChar(e, set) {
    // colOrigin is the letter at the origin of the set for the
    // column
    var curCol = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
    var eastingValue = 100000.0;
    var rewindMarker = false;
    while(curCol !== e.charCodeAt(0)){
        curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$I) curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$O) curCol++;
        if (curCol > $31ee54b8e1d1cd8f$var$Z) {
            if (rewindMarker) throw "Bad character: " + e;
            curCol = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        eastingValue += 100000.0;
    }
    return eastingValue;
}
/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getNorthingFromChar(n, set) {
    if (n > "V") throw "MGRSPoint given invalid Northing " + n;
    // rowOrigin is the letter at the origin of the set for the
    // column
    var curRow = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
    var northingValue = 0.0;
    var rewindMarker = false;
    while(curRow !== n.charCodeAt(0)){
        curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$I) curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$O) curRow++;
        // fixing a bug making whole application hang in this loop
        // when 'n' is a wrong character
        if (curRow > $31ee54b8e1d1cd8f$var$V) {
            if (rewindMarker) throw "Bad character: " + n;
            curRow = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        northingValue += 100000.0;
    }
    return northingValue;
}
/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */ function $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter) {
    var northing;
    switch(zoneLetter){
        case "C":
            northing = 1100000.0;
            break;
        case "D":
            northing = 2000000.0;
            break;
        case "E":
            northing = 2800000.0;
            break;
        case "F":
            northing = 3700000.0;
            break;
        case "G":
            northing = 4600000.0;
            break;
        case "H":
            northing = 5500000.0;
            break;
        case "J":
            northing = 6400000.0;
            break;
        case "K":
            northing = 7300000.0;
            break;
        case "L":
            northing = 8200000.0;
            break;
        case "M":
            northing = 9100000.0;
            break;
        case "N":
            northing = 0.0;
            break;
        case "P":
            northing = 800000.0;
            break;
        case "Q":
            northing = 1700000.0;
            break;
        case "R":
            northing = 2600000.0;
            break;
        case "S":
            northing = 3500000.0;
            break;
        case "T":
            northing = 4400000.0;
            break;
        case "U":
            northing = 5300000.0;
            break;
        case "V":
            northing = 6200000.0;
            break;
        case "W":
            northing = 7000000.0;
            break;
        case "X":
            northing = 7900000.0;
            break;
        default:
            northing = -1;
    }
    if (northing >= 0.0) return northing;
    else throw "Invalid zone letter: " + zoneLetter;
}


function $d8ec3fc1ff061c76$var$Point(x, y, z) {
    if (!(this instanceof $d8ec3fc1ff061c76$var$Point)) return new $d8ec3fc1ff061c76$var$Point(x, y, z);
    if (Array.isArray(x)) {
        this.x = x[0];
        this.y = x[1];
        this.z = x[2] || 0.0;
    } else if (typeof x === "object") {
        this.x = x.x;
        this.y = x.y;
        this.z = x.z || 0.0;
    } else if (typeof x === "string" && typeof y === "undefined") {
        var coords = x.split(",");
        this.x = parseFloat(coords[0], 10);
        this.y = parseFloat(coords[1], 10);
        this.z = parseFloat(coords[2], 10) || 0.0;
    } else {
        this.x = x;
        this.y = y;
        this.z = z || 0.0;
    }
    console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
}
$d8ec3fc1ff061c76$var$Point.fromMGRS = function(mgrsStr) {
    return new $d8ec3fc1ff061c76$var$Point((0, $31ee54b8e1d1cd8f$export$b63cca88ddc558a9)(mgrsStr));
};
$d8ec3fc1ff061c76$var$Point.prototype.toMGRS = function(accuracy) {
    return (0, $31ee54b8e1d1cd8f$export$174bb771924e7eb1)([
        this.x,
        this.y
    ], accuracy);
};
var $d8ec3fc1ff061c76$export$2e2bcd8739ae039 = $d8ec3fc1ff061c76$var$Point;








var $9t3dO = parcelRequire("9t3dO");

var $9zr9G = parcelRequire("9zr9G");

var $a9oRf = parcelRequire("a9oRf");
function $810f2c2910fd20b1$export$2e2bcd8739ae039(zone, lon) {
    if (zone === undefined) {
        zone = Math.floor(((0, $a9oRf.default)(lon) + Math.PI) * 30 / Math.PI) + 1;
        if (zone < 0) return 0;
        else if (zone > 60) return 60;
    }
    return zone;
}



var $9zr9G = parcelRequire("9zr9G");

var $gyVUi = parcelRequire("gyVUi");
var $efe46ba059d82de2$export$3f91ef0e0d0d8bf8 = "etmerc";
function $efe46ba059d82de2$export$2cd8252107eb640b() {
    var zone = (0, $810f2c2910fd20b1$export$2e2bcd8739ae039)(this.zone, this.long0);
    if (zone === undefined) throw new Error("unknown utm zone");
    this.lat0 = 0;
    this.long0 = (6 * Math.abs(zone) - 183) * (0, $gyVUi.D2R);
    this.x0 = 500000;
    this.y0 = this.utmSouth ? 10000000 : 0;
    this.k0 = 0.9996;
    (0, $9zr9G.default).init.apply(this);
    this.forward = (0, $9zr9G.default).forward;
    this.inverse = (0, $9zr9G.default).inverse;
}
var $efe46ba059d82de2$export$e4b2ac9215619f8d = [
    "Universal Transverse Mercator System",
    "utm"
];
var $efe46ba059d82de2$export$2e2bcd8739ae039 = {
    init: $efe46ba059d82de2$export$2cd8252107eb640b,
    names: $efe46ba059d82de2$export$e4b2ac9215619f8d,
    dependsOn: $efe46ba059d82de2$export$3f91ef0e0d0d8bf8
};


function $5db95ad4da70d3a6$export$2e2bcd8739ae039(esinp, exp) {
    return Math.pow((1 - esinp) / (1 + esinp), exp);
}



var $gyVUi = parcelRequire("gyVUi");
var $06b464b721451620$var$MAX_ITER = 20;
function $06b464b721451620$export$2cd8252107eb640b() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
    this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + (0, $gyVUi.FORTPI)) / (Math.pow(Math.tan(0.5 * this.lat0 + (0, $gyVUi.FORTPI)), this.C) * (0, $5db95ad4da70d3a6$export$2e2bcd8739ae039)(this.e * sphi, this.ratexp));
}
function $06b464b721451620$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)), this.C) * (0, $5db95ad4da70d3a6$export$2e2bcd8739ae039)(this.e * Math.sin(lat), this.ratexp)) - (0, $gyVUi.HALF_PI);
    p.x = this.C * lon;
    return p;
}
function $06b464b721451620$export$70ae2c07e401031b(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)) / this.K, 1 / this.C);
    for(var i = $06b464b721451620$var$MAX_ITER; i > 0; --i){
        lat = 2 * Math.atan(num * (0, $5db95ad4da70d3a6$export$2e2bcd8739ae039)(this.e * Math.sin(p.y), -0.5 * this.e)) - (0, $gyVUi.HALF_PI);
        if (Math.abs(lat - p.y) < DEL_TOL) break;
        p.y = lat;
    }
    /* convergence failed */ if (!i) return null;
    p.x = lon;
    p.y = lat;
    return p;
}
var $06b464b721451620$export$e4b2ac9215619f8d = [
    "gauss"
];
var $06b464b721451620$export$2e2bcd8739ae039 = {
    init: $06b464b721451620$export$2cd8252107eb640b,
    forward: $06b464b721451620$export$174bb771924e7eb1,
    inverse: $06b464b721451620$export$70ae2c07e401031b,
    names: $06b464b721451620$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");
function $4279f8b9d31284e6$export$2cd8252107eb640b() {
    (0, $06b464b721451620$export$2e2bcd8739ae039).init.apply(this);
    if (!this.rc) return;
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2 * this.rc;
    if (!this.title) this.title = "Oblique Stereographic Alternative";
}
function $4279f8b9d31284e6$export$174bb771924e7eb1(p) {
    var sinc, cosc, cosl, k;
    p.x = (0, $a9oRf.default)(p.x - this.long0);
    (0, $06b464b721451620$export$2e2bcd8739ae039).forward.apply(this, [
        p
    ]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $4279f8b9d31284e6$export$70ae2c07e401031b(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rho = Math.sqrt(p.x * p.x + p.y * p.y)) {
        var c = 2 * Math.atan2(rho, this.R2);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    (0, $06b464b721451620$export$2e2bcd8739ae039).inverse.apply(this, [
        p
    ]);
    p.x = (0, $a9oRf.default)(p.x + this.long0);
    return p;
}
var $4279f8b9d31284e6$export$e4b2ac9215619f8d = [
    "Stereographic_North_Pole",
    "Oblique_Stereographic",
    "Polar_Stereographic",
    "sterea",
    "Oblique Stereographic Alternative",
    "Double_Stereographic"
];
var $4279f8b9d31284e6$export$2e2bcd8739ae039 = {
    init: $4279f8b9d31284e6$export$2cd8252107eb640b,
    forward: $4279f8b9d31284e6$export$174bb771924e7eb1,
    inverse: $4279f8b9d31284e6$export$70ae2c07e401031b,
    names: $4279f8b9d31284e6$export$e4b2ac9215619f8d
};



var $llHto = parcelRequire("llHto");
/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */ function $31a8278a941356d4$export$2cd8252107eb640b() {
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
    var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
    var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
    this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
}
function $31a8278a941356d4$export$174bb771924e7eb1(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
    var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;
    // spheric latitude
    var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);
    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);
    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));
    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));
    p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
}
function $31a8278a941356d4$export$70ae2c07e401031b(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;
    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);
    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
    var lambda = this.lambda0 + I / this.alpha;
    var S = 0;
    var phy = b;
    var prevPhy = -1000;
    var iteration = 0;
    while(Math.abs(phy - prevPhy) > 0.0000001){
        if (++iteration > 20) //...reportError("omercFwdInfinity");
        return;
        //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
        prevPhy = phy;
        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
    }
    p.x = lambda;
    p.y = phy;
    return p;
}
var $31a8278a941356d4$export$e4b2ac9215619f8d = [
    "somerc"
];
var $31a8278a941356d4$export$2e2bcd8739ae039 = {
    init: $31a8278a941356d4$export$2cd8252107eb640b,
    forward: $31a8278a941356d4$export$174bb771924e7eb1,
    inverse: $31a8278a941356d4$export$70ae2c07e401031b,
    names: $31a8278a941356d4$export$e4b2ac9215619f8d
};



var $3xC66 = parcelRequire("3xC66");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
var $a6cb33582cb5910b$var$TOL = 1e-7;
function $a6cb33582cb5910b$var$isTypeA(P) {
    var typeAProjections = [
        "Hotine_Oblique_Mercator",
        "Hotine_Oblique_Mercator_Azimuth_Natural_Origin"
    ];
    var projectionName = typeof P.PROJECTION === "object" ? Object.keys(P.PROJECTION)[0] : P.PROJECTION;
    return "no_uoff" in P || "no_off" in P || typeAProjections.indexOf(projectionName) !== -1;
}
function $a6cb33582cb5910b$export$2cd8252107eb640b() {
    var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0, gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0, AB;
    // only Type A uses the no_off or no_uoff property
    // https://github.com/OSGeo/proj.4/issues/104
    this.no_off = $a6cb33582cb5910b$var$isTypeA(this);
    this.no_rot = "no_rot" in this;
    var alp = false;
    if ("alpha" in this) alp = true;
    var gam = false;
    if ("rectified_grid_angle" in this) gam = true;
    if (alp) alpha_c = this.alpha;
    if (gam) gamma = this.rectified_grid_angle * (0, $gyVUi.D2R);
    if (alp || gam) lamc = this.longc;
    else {
        lam1 = this.long1;
        phi1 = this.lat1;
        lam2 = this.long2;
        phi2 = this.lat2;
        if (Math.abs(phi1 - phi2) <= $a6cb33582cb5910b$var$TOL || (con = Math.abs(phi1)) <= $a6cb33582cb5910b$var$TOL || Math.abs(con - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL || Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL || Math.abs(Math.abs(phi2) - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL) throw new Error();
    }
    var one_es = 1.0 - this.es;
    com = Math.sqrt(one_es);
    if (Math.abs(this.lat0) > (0, $gyVUi.EPSLN)) {
        sinph0 = Math.sin(this.lat0);
        cosph0 = Math.cos(this.lat0);
        con = 1 - this.es * sinph0 * sinph0;
        this.B = cosph0 * cosph0;
        this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
        this.A = this.B * this.k0 * com / con;
        D = this.B * com / (cosph0 * Math.sqrt(con));
        F = D * D - 1;
        if (F <= 0) F = 0;
        else {
            F = Math.sqrt(F);
            if (this.lat0 < 0) F = -F;
        }
        this.E = F += D;
        this.E *= Math.pow((0, $3xC66.default)(this.e, this.lat0, sinph0), this.B);
    } else {
        this.B = 1 / com;
        this.A = this.k0;
        this.E = D = F = 1;
    }
    if (alp || gam) {
        if (alp) {
            gamma0 = Math.asin(Math.sin(alpha_c) / D);
            if (!gam) gamma = alpha_c;
        } else {
            gamma0 = gamma;
            alpha_c = Math.asin(D * Math.sin(gamma0));
        }
        this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
    } else {
        H = Math.pow((0, $3xC66.default)(this.e, phi1, Math.sin(phi1)), this.B);
        L = Math.pow((0, $3xC66.default)(this.e, phi2, Math.sin(phi2)), this.B);
        F = this.E / H;
        p = (L - H) / (L + H);
        J = this.E * this.E;
        J = (J - L * H) / (J + L * H);
        con = lam1 - lam2;
        if (con < -Math.pi) lam2 -= (0, $gyVUi.TWO_PI);
        else if (con > Math.pi) lam2 += (0, $gyVUi.TWO_PI);
        this.lam0 = (0, $a9oRf.default)(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B);
        gamma0 = Math.atan(2 * Math.sin(this.B * (0, $a9oRf.default)(lam1 - this.lam0)) / (F - 1 / F));
        gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
    }
    this.singam = Math.sin(gamma0);
    this.cosgam = Math.cos(gamma0);
    this.sinrot = Math.sin(gamma);
    this.cosrot = Math.cos(gamma);
    this.rB = 1 / this.B;
    this.ArB = this.A * this.rB;
    this.BrA = 1 / this.ArB;
    AB = this.A * this.B;
    if (this.no_off) this.u_0 = 0;
    else {
        this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
        if (this.lat0 < 0) this.u_0 = -this.u_0;
    }
    F = 0.5 * gamma0;
    this.v_pole_n = this.ArB * Math.log(Math.tan((0, $gyVUi.FORTPI) - F));
    this.v_pole_s = this.ArB * Math.log(Math.tan((0, $gyVUi.FORTPI) + F));
}
function $a6cb33582cb5910b$export$174bb771924e7eb1(p) {
    var coords = {};
    var S, T, U, V, W, temp, u, v;
    p.x = p.x - this.lam0;
    if (Math.abs(Math.abs(p.y) - (0, $gyVUi.HALF_PI)) > (0, $gyVUi.EPSLN)) {
        W = this.E / Math.pow((0, $3xC66.default)(this.e, p.y, Math.sin(p.y)), this.B);
        temp = 1 / W;
        S = 0.5 * (W - temp);
        T = 0.5 * (W + temp);
        V = Math.sin(this.B * p.x);
        U = (S * this.singam - V * this.cosgam) / T;
        if (Math.abs(Math.abs(U) - 1.0) < (0, $gyVUi.EPSLN)) throw new Error();
        v = 0.5 * this.ArB * Math.log((1 - U) / (1 + U));
        temp = Math.cos(this.B * p.x);
        if (Math.abs(temp) < $a6cb33582cb5910b$var$TOL) u = this.A * p.x;
        else u = this.ArB * Math.atan2(S * this.cosgam + V * this.singam, temp);
    } else {
        v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
        u = this.ArB * p.y;
    }
    if (this.no_rot) {
        coords.x = u;
        coords.y = v;
    } else {
        u -= this.u_0;
        coords.x = v * this.cosrot + u * this.sinrot;
        coords.y = u * this.cosrot - v * this.sinrot;
    }
    coords.x = this.a * coords.x + this.x0;
    coords.y = this.a * coords.y + this.y0;
    return coords;
}
function $a6cb33582cb5910b$export$70ae2c07e401031b(p) {
    var u, v, Qp, Sp, Tp, Vp, Up;
    var coords = {};
    p.x = (p.x - this.x0) * (1.0 / this.a);
    p.y = (p.y - this.y0) * (1.0 / this.a);
    if (this.no_rot) {
        v = p.y;
        u = p.x;
    } else {
        v = p.x * this.cosrot - p.y * this.sinrot;
        u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
    }
    Qp = Math.exp(-this.BrA * v);
    Sp = 0.5 * (Qp - 1 / Qp);
    Tp = 0.5 * (Qp + 1 / Qp);
    Vp = Math.sin(this.BrA * u);
    Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
    if (Math.abs(Math.abs(Up) - 1) < (0, $gyVUi.EPSLN)) {
        coords.x = 0;
        coords.y = Up < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
        coords.y = (0, $2AZR8.default)(this.e, Math.pow(coords.y, 1 / this.B));
        if (coords.y === Infinity) throw new Error();
        coords.x = -this.rB * Math.atan2(Sp * this.cosgam - Vp * this.singam, Math.cos(this.BrA * u));
    }
    coords.x += this.lam0;
    return coords;
}
var $a6cb33582cb5910b$export$e4b2ac9215619f8d = [
    "Hotine_Oblique_Mercator",
    "Hotine Oblique Mercator",
    "Hotine_Oblique_Mercator_Azimuth_Natural_Origin",
    "Hotine_Oblique_Mercator_Two_Point_Natural_Origin",
    "Hotine_Oblique_Mercator_Azimuth_Center",
    "Oblique_Mercator",
    "omerc"
];
var $a6cb33582cb5910b$export$2e2bcd8739ae039 = {
    init: $a6cb33582cb5910b$export$2cd8252107eb640b,
    forward: $a6cb33582cb5910b$export$174bb771924e7eb1,
    inverse: $a6cb33582cb5910b$export$70ae2c07e401031b,
    names: $a6cb33582cb5910b$export$e4b2ac9215619f8d
};



var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $boTd3 = parcelRequire("boTd3");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d753eaf12887a276$export$2cd8252107eb640b() {
    //double lat0;                    /* the reference latitude               */
    //double long0;                   /* the reference longitude              */
    //double lat1;                    /* first standard parallel              */
    //double lat2;                    /* second standard parallel             */
    //double r_maj;                   /* major axis                           */
    //double r_min;                   /* minor axis                           */
    //double false_east;              /* x offset in meters                   */
    //double false_north;             /* y offset in meters                   */
    //the above value can be set with proj4.defs
    //example: proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    if (!this.lat2) this.lat2 = this.lat1;
     //if lat2 is not defined
    if (!this.k0) this.k0 = 1;
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    var temp = this.b / this.a;
    this.e = Math.sqrt(1 - temp * temp);
    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = (0, $bi5ZC.default)(this.e, sin1, cos1);
    var ts1 = (0, $3xC66.default)(this.e, this.lat1, sin1);
    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = (0, $bi5ZC.default)(this.e, sin2, cos2);
    var ts2 = (0, $3xC66.default)(this.e, this.lat2, sin2);
    var ts0 = (0, $3xC66.default)(this.e, this.lat0, Math.sin(this.lat0));
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    else this.ns = sin1;
    if (isNaN(this.ns)) this.ns = sin1;
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) this.title = "Lambert Conformal Conic";
}
function $d753eaf12887a276$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // singular cases :
    if (Math.abs(2 * Math.abs(lat) - Math.PI) <= (0, $gyVUi.EPSLN)) lat = (0, $boTd3.default)(lat) * ((0, $gyVUi.HALF_PI) - 2 * (0, $gyVUi.EPSLN));
    var con = Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI));
    var ts, rh1;
    if (con > (0, $gyVUi.EPSLN)) {
        ts = (0, $3xC66.default)(this.e, lat, Math.sin(lat));
        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    } else {
        con = lat * this.ns;
        if (con <= 0) return null;
        rh1 = 0;
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
    return p;
}
function $d753eaf12887a276$export$70ae2c07e401031b(p) {
    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = this.rh - (p.y - this.y0) / this.k0;
    if (this.ns > 0) {
        rh1 = Math.sqrt(x * x + y * y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(x * x + y * y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * x, con * y);
    if (rh1 !== 0 || this.ns > 0) {
        con = 1 / this.ns;
        ts = Math.pow(rh1 / (this.a * this.f0), con);
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    } else lat = -(0, $gyVUi.HALF_PI);
    lon = (0, $a9oRf.default)(theta / this.ns + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
}
var $d753eaf12887a276$export$e4b2ac9215619f8d = [
    "Lambert Tangential Conformal Conic Projection",
    "Lambert_Conformal_Conic",
    "Lambert_Conformal_Conic_1SP",
    "Lambert_Conformal_Conic_2SP",
    "lcc"
];
var $d753eaf12887a276$export$2e2bcd8739ae039 = {
    init: $d753eaf12887a276$export$2cd8252107eb640b,
    forward: $d753eaf12887a276$export$174bb771924e7eb1,
    inverse: $d753eaf12887a276$export$70ae2c07e401031b,
    names: $d753eaf12887a276$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");
function $c765c705b741a192$export$2cd8252107eb640b() {
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    if (!this.lat0) this.lat0 = 0.863937979737193;
    if (!this.long0) this.long0 = 0.4334234309119251;
    /* if scale not set default to 0.9999 */ if (!this.k0) this.k0 = 0.9999;
    this.s45 = 0.785398163397448; /* 45 */ 
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0;
    this.e2 = this.es;
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2));
    this.uq = 1.04216856380474;
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
    this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555;
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
}
function $c765c705b741a192$export$174bb771924e7eb1(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    /* Transformation */ gfi = Math.pow((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat)), this.alfa * this.e / 2);
    u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
    p.y = ro * Math.cos(eps) / 1;
    p.x = ro * Math.sin(eps) / 1;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    return p;
}
function $c765c705b741a192$export$70ae2c07e401031b(p) {
    var u, deltav, s, d, eps, ro, fi1;
    var ok;
    /* Transformation */ /* revert y, x*/ var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
        p.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
        if (Math.abs(fi1 - p.y) < 0.0000000001) ok = 1;
        fi1 = p.y;
        iter += 1;
    }while (ok === 0 && iter < 15);
    if (iter >= 15) return null;
    return p;
}
var $c765c705b741a192$export$e4b2ac9215619f8d = [
    "Krovak",
    "krovak"
];
var $c765c705b741a192$export$2e2bcd8739ae039 = {
    init: $c765c705b741a192$export$2cd8252107eb640b,
    forward: $c765c705b741a192$export$174bb771924e7eb1,
    inverse: $c765c705b741a192$export$70ae2c07e401031b,
    names: $c765c705b741a192$export$e4b2ac9215619f8d
};


function $af51062589eeb2ce$export$2e2bcd8739ae039(e0, e1, e2, e3, phi) {
    return e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi);
}


function $8b22a51ec249391e$export$2e2bcd8739ae039(x) {
    return 1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x));
}


function $d08e0117e308bb87$export$2e2bcd8739ae039(x) {
    return 0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x));
}


function $d36e2161accfe0ec$export$2e2bcd8739ae039(x) {
    return 0.05859375 * x * x * (1 + 0.75 * x);
}


function $89245c5bc9a5a616$export$2e2bcd8739ae039(x) {
    return x * x * x * (35 / 3072);
}


function $259e1333723cc7cb$export$2e2bcd8739ae039(a, e, sinphi) {
    var temp = e * sinphi;
    return a / Math.sqrt(1 - temp * temp);
}



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $7bf9815baea17aa9$export$2e2bcd8739ae039(x) {
    return Math.abs(x) < (0, $gyVUi.HALF_PI) ? x : x - (0, $boTd3.default)(x) * Math.PI;
}


function $8ebd4771f70de1ee$export$2e2bcd8739ae039(ml, e0, e1, e2, e3) {
    var phi;
    var dphi;
    phi = ml / e0;
    for(var i = 0; i < 15; i++){
        dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
    return NaN;
}



var $gyVUi = parcelRequire("gyVUi");
function $00f791059e8f61f5$export$2cd8252107eb640b() {
    if (!this.sphere) {
        this.e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
        this.e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
        this.e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
        this.e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
        this.ml0 = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    }
}
function $00f791059e8f61f5$export$174bb771924e7eb1(p) {
    /* Forward equations
      -----------------*/ var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0);
    if (this.sphere) {
        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
    } else {
        //ellipsoid
        var sinphi = Math.sin(phi);
        var cosphi = Math.cos(phi);
        var nl = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, sinphi);
        var tl = Math.tan(phi) * Math.tan(phi);
        var al = lam * Math.cos(phi);
        var asq = al * al;
        var cl = this.es * cosphi * cosphi / (1 - this.es);
        var ml = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, phi);
        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $00f791059e8f61f5$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;
    if (this.sphere) {
        var dd = y + this.lat0;
        phi = Math.asin(Math.sin(dd) * Math.cos(x));
        lam = Math.atan2(Math.tan(x), Math.cos(dd));
    } else {
        /* ellipsoid */ var ml1 = this.ml0 / this.a + y;
        var phi1 = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(ml1, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(phi1) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
            p.x = this.long0;
            p.y = (0, $gyVUi.HALF_PI);
            if (y < 0) p.y *= -1;
            return p;
        }
        var nl1 = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, Math.sin(phi1));
        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
        var tl1 = Math.pow(Math.tan(phi1), 2);
        var dl = x * this.a / nl1;
        var dsq = dl * dl;
        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
    }
    p.x = (0, $a9oRf.default)(lam + this.long0);
    p.y = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(phi);
    return p;
}
var $00f791059e8f61f5$export$e4b2ac9215619f8d = [
    "Cassini",
    "Cassini_Soldner",
    "cass"
];
var $00f791059e8f61f5$export$2e2bcd8739ae039 = {
    init: $00f791059e8f61f5$export$2cd8252107eb640b,
    forward: $00f791059e8f61f5$export$174bb771924e7eb1,
    inverse: $00f791059e8f61f5$export$70ae2c07e401031b,
    names: $00f791059e8f61f5$export$e4b2ac9215619f8d
};



var $deudM = parcelRequire("deudM");

var $8mhgZ = parcelRequire("8mhgZ");

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $dbf05e97c9232a2a$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
}
function $dbf05e97c9232a2a$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ dlon = (0, $a9oRf.default)(lon - this.long0);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    } else {
        // Point is in the opposing hemisphere and is unprojectable
        // We still need to return a reasonable point, so we project
        // to infinity, on a bearing
        // equivalent to the northern hemisphere equivalent
        // This is a reasonable approximation for short shapes and lines that
        // straddle the horizon.
        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $dbf05e97c9232a2a$export$70ae2c07e401031b(p) {
    var rh; /* Rho */ 
    var sinc, cosc;
    var c;
    var lon, lat;
    /* Inverse equations
      -----------------*/ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rh = Math.sqrt(p.x * p.x + p.y * p.y)) {
        c = Math.atan2(rh, this.rc);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = (0, $ljPJJ.default)(cosc * this.sin_p14 + p.y * sinc * this.cos_p14 / rh);
        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
        lon = (0, $a9oRf.default)(this.long0 + lon);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $dbf05e97c9232a2a$export$e4b2ac9215619f8d = [
    "gnom"
];
var $dbf05e97c9232a2a$export$2e2bcd8739ae039 = {
    init: $dbf05e97c9232a2a$export$2cd8252107eb640b,
    forward: $dbf05e97c9232a2a$export$174bb771924e7eb1,
    inverse: $dbf05e97c9232a2a$export$70ae2c07e401031b,
    names: $dbf05e97c9232a2a$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $874JP = parcelRequire("874JP");

var $bi5ZC = parcelRequire("bi5ZC");

var $gyVUi = parcelRequire("gyVUi");
function $81070f0f2a61f650$export$2e2bcd8739ae039(eccent, q) {
    var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
    if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
        if (q < 0) return -1 * (0, $gyVUi.HALF_PI);
        else return 0, $gyVUi.HALF_PI;
    }
    //var phi = 0.5* q/(1-eccent*eccent);
    var phi = Math.asin(0.5 * q);
    var dphi;
    var sin_phi;
    var cos_phi;
    var con;
    for(var i = 0; i < 30; i++){
        sin_phi = Math.sin(phi);
        cos_phi = Math.cos(phi);
        con = eccent * sin_phi;
        dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
    return NaN;
}


function $4d31684dfe594c29$export$2cd8252107eb640b() {
    //no-op
    if (!this.sphere) this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
}
function $4d31684dfe594c29$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y;
    /* Forward equations
      -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    if (this.sphere) {
        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    } else {
        var qs = (0, $874JP.default)(this.e, Math.sin(lat));
        x = this.x0 + this.a * this.k0 * dlon;
        y = this.y0 + this.a * qs * 0.5 / this.k0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $4d31684dfe594c29$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat;
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + p.x / this.a / Math.cos(this.lat_ts));
        lat = Math.asin(p.y / this.a * Math.cos(this.lat_ts));
    } else {
        lat = (0, $81070f0f2a61f650$export$2e2bcd8739ae039)(this.e, 2 * p.y * this.k0 / this.a);
        lon = (0, $a9oRf.default)(this.long0 + p.x / (this.a * this.k0));
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $4d31684dfe594c29$export$e4b2ac9215619f8d = [
    "cea"
];
var $4d31684dfe594c29$export$2e2bcd8739ae039 = {
    init: $4d31684dfe594c29$export$2cd8252107eb640b,
    forward: $4d31684dfe594c29$export$174bb771924e7eb1,
    inverse: $4d31684dfe594c29$export$70ae2c07e401031b,
    names: $4d31684dfe594c29$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

function $936a7dd52884a3fc$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Equidistant Cylindrical (Plate Carre)";
    this.rc = Math.cos(this.lat_ts);
}
function $936a7dd52884a3fc$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    var dlat = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(lat - this.lat0);
    p.x = this.x0 + this.a * dlon * this.rc;
    p.y = this.y0 + this.a * dlat;
    return p;
}
function $936a7dd52884a3fc$export$70ae2c07e401031b(p) {
    var x = p.x;
    var y = p.y;
    p.x = (0, $a9oRf.default)(this.long0 + (x - this.x0) / (this.a * this.rc));
    p.y = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(this.lat0 + (y - this.y0) / this.a);
    return p;
}
var $936a7dd52884a3fc$export$e4b2ac9215619f8d = [
    "Equirectangular",
    "Equidistant_Cylindrical",
    "eqc"
];
var $936a7dd52884a3fc$export$2e2bcd8739ae039 = {
    init: $936a7dd52884a3fc$export$2cd8252107eb640b,
    forward: $936a7dd52884a3fc$export$174bb771924e7eb1,
    inverse: $936a7dd52884a3fc$export$70ae2c07e401031b,
    names: $936a7dd52884a3fc$export$e4b2ac9215619f8d
};







var $a9oRf = parcelRequire("a9oRf");



var $gyVUi = parcelRequire("gyVUi");

var $20353e9e716518d0$var$MAX_ITER = 20;
function $20353e9e716518d0$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
    this.e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
    this.e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
    this.e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
    this.ml0 = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
}
function $20353e9e716518d0$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y, el;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    el = dlon * Math.sin(lat);
    if (this.sphere) {
        if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
            x = this.a * dlon;
            y = -1 * this.a * this.lat0;
        } else {
            x = this.a * Math.sin(el) / Math.tan(lat);
            y = this.a * ((0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
        }
    } else if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.a * dlon;
        y = -1 * this.ml0;
    } else {
        var nl = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
        x = nl * Math.sin(el);
        y = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $20353e9e716518d0$export$70ae2c07e401031b(p) {
    var lon, lat, x, y, i;
    var al, bl;
    var phi, dphi;
    x = p.x - this.x0;
    y = p.y - this.y0;
    if (this.sphere) {
        if (Math.abs(y + this.a * this.lat0) <= (0, $gyVUi.EPSLN)) {
            lon = (0, $a9oRf.default)(x / this.a + this.long0);
            lat = 0;
        } else {
            al = this.lat0 + y / this.a;
            bl = x * x / this.a / this.a + al * al;
            phi = al;
            var tanphi;
            for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
                tanphi = Math.tan(phi);
                dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
                phi += dphi;
                if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                    lat = phi;
                    break;
                }
            }
            lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * Math.tan(phi) / this.a) / Math.sin(lat));
        }
    } else if (Math.abs(y + this.ml0) <= (0, $gyVUi.EPSLN)) {
        lat = 0;
        lon = (0, $a9oRf.default)(this.long0 + x / this.a);
    } else {
        al = (this.ml0 + y) / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var cl, mln, mlnp, ma;
        var con;
        for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
            con = this.e * Math.sin(phi);
            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
            mln = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, phi);
            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
            ma = mln / this.a;
            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
            phi -= dphi;
            if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                lat = phi;
                break;
            }
        }
        //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
        cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
        lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $20353e9e716518d0$export$e4b2ac9215619f8d = [
    "Polyconic",
    "poly"
];
var $20353e9e716518d0$export$2e2bcd8739ae039 = {
    init: $20353e9e716518d0$export$2cd8252107eb640b,
    forward: $20353e9e716518d0$export$174bb771924e7eb1,
    inverse: $20353e9e716518d0$export$70ae2c07e401031b,
    names: $20353e9e716518d0$export$e4b2ac9215619f8d
};



var $6Eu1X = parcelRequire("6Eu1X");

var $a9oRf = parcelRequire("a9oRf");
function $b37863f65bf2a2a4$export$2cd8252107eb640b() {
//no-op
}
function $b37863f65bf2a2a4$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + lat / 2.5)) * 1.25;
    p.x = x;
    p.y = y;
    return p;
}
function $b37863f65bf2a2a4$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon = (0, $a9oRf.default)(this.long0 + p.x / this.a);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);
    p.x = lon;
    p.y = lat;
    return p;
}
var $b37863f65bf2a2a4$export$e4b2ac9215619f8d = [
    "Miller_Cylindrical",
    "mill"
];
var $b37863f65bf2a2a4$export$2e2bcd8739ae039 = {
    init: $b37863f65bf2a2a4$export$2cd8252107eb640b,
    forward: $b37863f65bf2a2a4$export$174bb771924e7eb1,
    inverse: $b37863f65bf2a2a4$export$70ae2c07e401031b,
    names: $b37863f65bf2a2a4$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");


var $gqKpL = parcelRequire("gqKpL");

var $hpUQm = parcelRequire("hpUQm");

var $jQUK6 = parcelRequire("jQUK6");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
var $a9d7febe7a8566f2$var$MAX_ITER = 20;
function $a9d7febe7a8566f2$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
    -------------------------------------------------*/ if (!this.sphere) this.en = (0, $gqKpL.default)(this.es);
    else {
        this.n = 1;
        this.m = 0;
        this.es = 0;
        this.C_y = Math.sqrt((this.m + 1) / this.n);
        this.C_x = this.C_y / (this.m + 1);
    }
}
function $a9d7febe7a8566f2$export$174bb771924e7eb1(p) {
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    -----------------*/ lon = (0, $a9oRf.default)(lon - this.long0);
    if (this.sphere) {
        if (!this.m) lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
        else {
            var k = this.n * Math.sin(lat);
            for(var i = $a9d7febe7a8566f2$var$MAX_ITER; i; --i){
                var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
                lat -= V;
                if (Math.abs(V) < (0, $gyVUi.EPSLN)) break;
            }
        }
        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
        y = this.a * this.C_y * lat;
    } else {
        var s = Math.sin(lat);
        var c = Math.cos(lat);
        y = this.a * (0, $hpUQm.default)(lat, s, c, this.en);
        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $a9d7febe7a8566f2$export$70ae2c07e401031b(p) {
    var lat, temp, lon, s;
    p.x -= this.x0;
    lon = p.x / this.a;
    p.y -= this.y0;
    lat = p.y / this.a;
    if (this.sphere) {
        lat /= this.C_y;
        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
        if (this.m) lat = (0, $ljPJJ.default)((this.m * lat + Math.sin(lat)) / this.n);
        else if (this.n !== 1) lat = (0, $ljPJJ.default)(Math.sin(lat) / this.n);
        lon = (0, $a9oRf.default)(lon + this.long0);
        lat = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(lat);
    } else {
        lat = (0, $jQUK6.default)(p.y / this.a, this.es, this.en);
        s = Math.abs(lat);
        if (s < (0, $gyVUi.HALF_PI)) {
            s = Math.sin(lat);
            temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
            //temp = this.long0 + p.x / (this.a * Math.cos(lat));
            lon = (0, $a9oRf.default)(temp);
        } else if (s - (0, $gyVUi.EPSLN) < (0, $gyVUi.HALF_PI)) lon = this.long0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $a9d7febe7a8566f2$export$e4b2ac9215619f8d = [
    "Sinusoidal",
    "sinu"
];
var $a9d7febe7a8566f2$export$2e2bcd8739ae039 = {
    init: $a9d7febe7a8566f2$export$2cd8252107eb640b,
    forward: $a9d7febe7a8566f2$export$174bb771924e7eb1,
    inverse: $a9d7febe7a8566f2$export$70ae2c07e401031b,
    names: $a9d7febe7a8566f2$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");
function $57490138fba0a0b8$export$2cd8252107eb640b() {}
function $57490138fba0a0b8$export$174bb771924e7eb1(p) {
    /* Forward equations
      -----------------*/ var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    var theta = lat;
    var con = Math.PI * Math.sin(lat);
    /* Iterate using the Newton-Raphson method to find theta
      -----------------------------------------------------*/ while(true){
        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
        theta += delta_theta;
        if (Math.abs(delta_theta) < (0, $gyVUi.EPSLN)) break;
    }
    theta /= 2;
    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       --------------------------------------------------------------------------*/ if (Math.PI / 2 - Math.abs(lat) < (0, $gyVUi.EPSLN)) delta_lon = 0;
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function $57490138fba0a0b8$export$70ae2c07e401031b(p) {
    var theta;
    var arg;
    /* Inverse equations
      -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    arg = p.y / (1.4142135623731 * this.a);
    /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       -------------------------------------------------------------------*/ if (Math.abs(arg) > 0.999999999999) arg = 0.999999999999;
    theta = Math.asin(arg);
    var lon = (0, $a9oRf.default)(this.long0 + p.x / (0.900316316158 * this.a * Math.cos(theta)));
    if (lon < -Math.PI) lon = -Math.PI;
    if (lon > Math.PI) lon = Math.PI;
    arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
    if (Math.abs(arg) > 1) arg = 1;
    var lat = Math.asin(arg);
    p.x = lon;
    p.y = lat;
    return p;
}
var $57490138fba0a0b8$export$e4b2ac9215619f8d = [
    "Mollweide",
    "moll"
];
var $57490138fba0a0b8$export$2e2bcd8739ae039 = {
    init: $57490138fba0a0b8$export$2cd8252107eb640b,
    forward: $57490138fba0a0b8$export$174bb771924e7eb1,
    inverse: $57490138fba0a0b8$export$70ae2c07e401031b,
    names: $57490138fba0a0b8$export$e4b2ac9215619f8d
};







var $bi5ZC = parcelRequire("bi5ZC");


var $a9oRf = parcelRequire("a9oRf");



var $gyVUi = parcelRequire("gyVUi");
function $cab513e7d920927e$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.lat2 = this.lat2 || this.lat1;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
    this.e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
    this.e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
    this.e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
    this.sinphi = Math.sin(this.lat1);
    this.cosphi = Math.cos(this.lat1);
    this.ms1 = (0, $bi5ZC.default)(this.e, this.sinphi, this.cosphi);
    this.ml1 = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat1);
    if (Math.abs(this.lat1 - this.lat2) < (0, $gyVUi.EPSLN)) this.ns = this.sinphi;
    else {
        this.sinphi = Math.sin(this.lat2);
        this.cosphi = Math.cos(this.lat2);
        this.ms2 = (0, $bi5ZC.default)(this.e, this.sinphi, this.cosphi);
        this.ml2 = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat2);
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
}
function $cab513e7d920927e$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var rh1;
    /* Forward equations
      -----------------*/ if (this.sphere) rh1 = this.a * (this.g - lat);
    else {
        var ml = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, lat);
        rh1 = this.a * (this.g - ml);
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0);
    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
}
function $cab513e7d920927e$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1, lat, lon;
    if (this.ns >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns);
        lat = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(this.g - rh1 / this.a);
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        var ml = this.g - rh1 / this.a;
        lat = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(ml, this.e0, this.e1, this.e2, this.e3);
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns);
        p.x = lon;
        p.y = lat;
        return p;
    }
}
var $cab513e7d920927e$export$e4b2ac9215619f8d = [
    "Equidistant_Conic",
    "eqdc"
];
var $cab513e7d920927e$export$2e2bcd8739ae039 = {
    init: $cab513e7d920927e$export$2cd8252107eb640b,
    forward: $cab513e7d920927e$export$174bb771924e7eb1,
    inverse: $cab513e7d920927e$export$70ae2c07e401031b,
    names: $cab513e7d920927e$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
function $168e5f6524a6fc5f$export$2cd8252107eb640b() {
    //this.R = 6370997; //Radius of earth
    this.R = this.a;
}
function $168e5f6524a6fc5f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    var x, y;
    if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.R * dlon;
        y = this.y0;
    }
    var theta = (0, $ljPJJ.default)(2 * Math.abs(lat / Math.PI));
    if (Math.abs(dlon) <= (0, $gyVUi.EPSLN) || Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
        x = this.x0;
        if (lat >= 0) y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
        else y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    //  return(OK);
    }
    var al = 0.5 * Math.abs(Math.PI / dlon - dlon / Math.PI);
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);
    var g = costh / (sinth + costh - 1);
    var gsq = g * g;
    var m = g * (2 / sinth - 1);
    var msq = m * m;
    var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) con = -con;
    x = this.x0 + con;
    //con = Math.abs(con / (Math.PI * this.R));
    var q = asq + g;
    con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
    if (lat >= 0) //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
    else //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
    p.x = x;
    p.y = y;
    return p;
}
function $168e5f6524a6fc5f$export$70ae2c07e401031b(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var a1;
    var m1;
    var con;
    var th1;
    var d;
    /* inverse equations
    -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    con = Math.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1 + xys);
    c2 = c1 - 2 * yy * yy + xx * xx;
    c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
    a1 = (c1 - c2 * c2 / 3 / c3) / c3;
    m1 = 2 * Math.sqrt(-a1 / 3);
    con = 3 * d / a1 / m1;
    if (Math.abs(con) > 1) {
        if (con >= 0) con = 1;
        else con = -1;
    }
    th1 = Math.acos(con) / 3;
    if (p.y >= 0) lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    else lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    if (Math.abs(xx) < (0, $gyVUi.EPSLN)) lon = this.long0;
    else lon = (0, $a9oRf.default)(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
    p.x = lon;
    p.y = lat;
    return p;
}
var $168e5f6524a6fc5f$export$e4b2ac9215619f8d = [
    "Van_der_Grinten_I",
    "VanDerGrinten",
    "vandg"
];
var $168e5f6524a6fc5f$export$2e2bcd8739ae039 = {
    init: $168e5f6524a6fc5f$export$2cd8252107eb640b,
    forward: $168e5f6524a6fc5f$export$174bb771924e7eb1,
    inverse: $168e5f6524a6fc5f$export$70ae2c07e401031b,
    names: $168e5f6524a6fc5f$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");







var $ljPJJ = parcelRequire("ljPJJ");

function $d2d34f4dbda3af26$export$2cd8252107eb640b() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
}
function $d2d34f4dbda3af26$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
    if (this.sphere) {
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.sin(dlon);
            p.y = this.y0 - this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.sin(dlon);
            p.y = this.y0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.cos(dlon);
            return p;
        } else {
            //default case
            cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
            c = Math.acos(cos_c);
            kp = c ? c / Math.sin(c) : 1;
            p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
            p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
            return p;
        }
    } else {
        e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
        e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
        e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
        e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North Pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
            p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South Pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
            p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
            return p;
        } else {
            //Default case
            tanphi = sinphi / cosphi;
            Nl1 = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, this.sin_p12);
            Nl = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, sinphi);
            psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
            Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
            if (Az === 0) s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
            else if (Math.abs(Math.abs(Az) - Math.PI) <= (0, $gyVUi.EPSLN)) s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
            else s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
            G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
            H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
            GH = G * H;
            Hs = H * H;
            s2 = s * s;
            s3 = s2 * s;
            s4 = s3 * s;
            s5 = s4 * s;
            c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
            p.x = this.x0 + c * Math.sin(Az);
            p.y = this.y0 + c * Math.cos(Az);
            return p;
        }
    }
}
function $d2d34f4dbda3af26$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F, sinpsi;
    if (this.sphere) {
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        if (rh > 2 * (0, $gyVUi.HALF_PI) * this.a) return;
        z = rh / this.a;
        sinz = Math.sin(z);
        cosz = Math.cos(z);
        lon = this.long0;
        if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) lat = this.lat0;
        else {
            lat = (0, $ljPJJ.default)(cosz * this.sin_p12 + p.y * sinz * this.cos_p12 / rh);
            con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
            if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
                if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y));
                else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y));
            } else /*con = cosz - this.sin_p12 * Math.sin(lat);
        if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
          //no-op, just keep the lon value as is
        } else {
          var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
          lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
        }*/ lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
        }
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
        e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
        e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
        e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = Mlp - rh;
            lat = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y));
            p.x = lon;
            p.y = lat;
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = rh - Mlp;
            lat = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y));
            p.x = lon;
            p.y = lat;
            return p;
        } else {
            //default case
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            Az = Math.atan2(p.x, p.y);
            N1 = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, this.sin_p12);
            cosAz = Math.cos(Az);
            tmp = this.e * this.cos_p12 * cosAz;
            A = -tmp * tmp / (1 - this.es);
            B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
            D = rh / N1;
            Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
            F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
            psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
            lon = (0, $a9oRf.default)(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
            sinpsi = Math.sin(psi);
            lat = Math.atan2((sinpsi - this.es * F * this.sin_p12) * Math.tan(psi), sinpsi * (1 - this.es));
            p.x = lon;
            p.y = lat;
            return p;
        }
    }
}
var $d2d34f4dbda3af26$export$e4b2ac9215619f8d = [
    "Azimuthal_Equidistant",
    "aeqd"
];
var $d2d34f4dbda3af26$export$2e2bcd8739ae039 = {
    init: $d2d34f4dbda3af26$export$2cd8252107eb640b,
    forward: $d2d34f4dbda3af26$export$174bb771924e7eb1,
    inverse: $d2d34f4dbda3af26$export$70ae2c07e401031b,
    names: $d2d34f4dbda3af26$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $24629f153ebf2c1f$export$2cd8252107eb640b() {
    //double temp;      /* temporary variable    */
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
}
function $24629f153ebf2c1f$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g, x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ dlon = (0, $a9oRf.default)(lon - this.long0);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.a * ksp * cosphi * Math.sin(dlon);
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $24629f153ebf2c1f$export$70ae2c07e401031b(p) {
    var rh; /* height above ellipsoid      */ 
    var z; /* angle          */ 
    var sinz, cosz; /* sin of z and cos of z      */ 
    var con;
    var lon, lat;
    /* Inverse equations
      -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    z = (0, $ljPJJ.default)(rh / this.a);
    sinz = Math.sin(z);
    cosz = Math.cos(z);
    lon = this.long0;
    if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) {
        lat = this.lat0;
        p.x = lon;
        p.y = lat;
        return p;
    }
    lat = (0, $ljPJJ.default)(cosz * this.sin_p14 + p.y * sinz * this.cos_p14 / rh);
    con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
    if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
        if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y));
        else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y));
        p.x = lon;
        p.y = lat;
        return p;
    }
    lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
    p.x = lon;
    p.y = lat;
    return p;
}
var $24629f153ebf2c1f$export$e4b2ac9215619f8d = [
    "ortho"
];
var $24629f153ebf2c1f$export$2e2bcd8739ae039 = {
    init: $24629f153ebf2c1f$export$2cd8252107eb640b,
    forward: $24629f153ebf2c1f$export$174bb771924e7eb1,
    inverse: $24629f153ebf2c1f$export$70ae2c07e401031b,
    names: $24629f153ebf2c1f$export$e4b2ac9215619f8d
};


// QSC projection rewritten from the original PROJ4
// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

var $gyVUi = parcelRequire("gyVUi");
/* constants */ var $228cab2632c5bcf7$var$FACE_ENUM = {
    FRONT: 1,
    RIGHT: 2,
    BACK: 3,
    LEFT: 4,
    TOP: 5,
    BOTTOM: 6
};
var $228cab2632c5bcf7$var$AREA_ENUM = {
    AREA_0: 1,
    AREA_1: 2,
    AREA_2: 3,
    AREA_3: 4
};
function $228cab2632c5bcf7$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Quadrilateralized Spherical Cube";
    /* Determine the cube face from the center of projection. */ if (this.lat0 >= (0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0) this.face = $228cab2632c5bcf7$var$FACE_ENUM.TOP;
    else if (this.lat0 <= -((0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM;
    else if (Math.abs(this.long0) <= (0, $gyVUi.FORTPI)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.FRONT;
    else if (Math.abs(this.long0) <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) this.face = this.long0 > 0.0 ? $228cab2632c5bcf7$var$FACE_ENUM.RIGHT : $228cab2632c5bcf7$var$FACE_ENUM.LEFT;
    else this.face = $228cab2632c5bcf7$var$FACE_ENUM.BACK;
    /* Fill in useful values for the ellipsoid <-> sphere shift
   * described in [LK12]. */ if (this.es !== 0) {
        this.one_minus_f = 1 - (this.a - this.b) / this.a;
        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
    }
}
function $228cab2632c5bcf7$export$174bb771924e7eb1(p) {
    var xy = {
        x: 0,
        y: 0
    };
    var lat, lon;
    var theta, phi;
    var t, mu;
    /* nu; */ var area = {
        value: 0
    };
    // move lon according to projection's lon
    p.x -= this.long0;
    /* Convert the geodetic latitude to a geocentric latitude.
   * This corresponds to the shift from the ellipsoid to the sphere
   * described in [LK12]. */ if (this.es !== 0) lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
    else lat = p.y;
    /* Convert the input lat, lon into theta, phi as used by QSC.
   * This depends on the cube face and the area on it.
   * For the top and bottom face, we can compute theta and phi
   * directly from phi, lam. For the other faces, we must use
   * unit sphere cartesian coordinates as an intermediate step. */ lon = p.x; //lon = lp.lam;
    if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = (0, $gyVUi.HALF_PI) - lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = lon - (0, $gyVUi.HALF_PI);
        } else if (lon > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || lon <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = lon > 0.0 ? lon - (0, $gyVUi.SPI) : lon + (0, $gyVUi.SPI);
        } else if (lon > -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) && lon <= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = lon + (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon;
        }
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = (0, $gyVUi.HALF_PI) + lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = -lon + (0, $gyVUi.HALF_PI);
        } else if (lon < (0, $gyVUi.FORTPI) && lon >= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = -lon;
        } else if (lon < -(0, $gyVUi.FORTPI) && lon >= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = -lon - (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon > 0.0 ? -lon + (0, $gyVUi.SPI) : -lon - (0, $gyVUi.SPI);
        }
    } else {
        var q, r, s;
        var sinlat, coslat;
        var sinlon, coslon;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, -(0, $gyVUi.HALF_PI));
        sinlat = Math.sin(lat);
        coslat = Math.cos(lat);
        sinlon = Math.sin(lon);
        coslon = Math.cos(lon);
        q = coslat * coslon;
        r = coslat * sinlon;
        s = sinlat;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.FRONT) {
            phi = Math.acos(q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            phi = Math.acos(r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -q, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            phi = Math.acos(-q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            phi = Math.acos(-r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, q, area);
        } else {
            /* Impossible */ phi = theta = 0;
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        }
    }
    /* Compute mu and nu for the area of definition.
   * For mu, see Eq. (3-21) in [OL76], but note the typos:
   * compare with Eq. (3-14). For nu, see Eq. (3-38). */ mu = Math.atan(12 / (0, $gyVUi.SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos((0, $gyVUi.FORTPI))) - (0, $gyVUi.HALF_PI)));
    t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
    /* Apply the result to the real area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) mu += (0, $gyVUi.HALF_PI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) mu += (0, $gyVUi.SPI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) mu += 1.5 * (0, $gyVUi.SPI);
    /* Now compute x, y from mu and nu */ xy.x = t * Math.cos(mu);
    xy.y = t * Math.sin(mu);
    xy.x = xy.x * this.a + this.x0;
    xy.y = xy.y * this.a + this.y0;
    p.x = xy.x;
    p.y = xy.y;
    return p;
}
function $228cab2632c5bcf7$export$70ae2c07e401031b(p) {
    var lp = {
        lam: 0,
        phi: 0
    };
    var mu, nu, cosmu, tannu;
    var tantheta, theta, cosphi, phi;
    var t;
    var area = {
        value: 0
    };
    /* de-offset */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    /* Convert the input x, y to the mu and nu angles as used by QSC.
   * This depends on the area of the cube face. */ nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
    mu = Math.atan2(p.y, p.x);
    if (p.x >= 0.0 && p.x >= Math.abs(p.y)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
    else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
        mu -= (0, $gyVUi.HALF_PI);
    } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
        mu = mu < 0.0 ? mu + (0, $gyVUi.SPI) : mu - (0, $gyVUi.SPI);
    } else {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
        mu += (0, $gyVUi.HALF_PI);
    }
    /* Compute phi and theta for the area of definition.
   * The inverse projection is not described in the original paper, but some
   * good hints can be found here (as of 2011-12-14):
   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */ t = (0, $gyVUi.SPI) / 12 * Math.tan(mu);
    tantheta = Math.sin(t) / (Math.cos(t) - 1 / Math.sqrt(2));
    theta = Math.atan(tantheta);
    cosmu = Math.cos(mu);
    tannu = Math.tan(nu);
    cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
    if (cosphi < -1) cosphi = -1;
    else if (cosphi > 1) cosphi = 1;
    /* Apply the result to the real area on the cube face.
   * For the top and bottom face, we can compute phi and lam directly.
   * For the other faces, we must use unit sphere cartesian coordinates
   * as an intermediate step. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = Math.acos(cosphi);
        lp.phi = (0, $gyVUi.HALF_PI) - phi;
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = theta < 0.0 ? theta + (0, $gyVUi.SPI) : theta - (0, $gyVUi.SPI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta;
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = Math.acos(cosphi);
        lp.phi = phi - (0, $gyVUi.HALF_PI);
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = -theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = -theta;
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = -theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta < 0.0 ? -theta - (0, $gyVUi.SPI) : -theta + (0, $gyVUi.SPI);
    } else {
        /* Compute phi and lam via cartesian unit sphere coordinates. */ var q, r, s;
        q = cosphi;
        t = q * q;
        if (t >= 1) s = 0;
        else s = Math.sqrt(1 - t) * Math.sin(theta);
        t += s * s;
        if (t >= 1) r = 0;
        else r = Math.sqrt(1 - t);
        /* Rotate q,r,s into the correct area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) {
            t = r;
            r = -s;
            s = t;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) {
            r = -r;
            s = -s;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) {
            t = r;
            r = s;
            s = -t;
        }
        /* Rotate q,r,s into the correct cube face. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            t = q;
            q = -r;
            r = t;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            q = -q;
            r = -r;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            t = q;
            q = r;
            r = -t;
        }
        /* Now compute phi and lam from the unit sphere coordinates. */ lp.phi = Math.acos(-s) - (0, $gyVUi.HALF_PI);
        lp.lam = Math.atan2(r, q);
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, +(0, $gyVUi.HALF_PI));
    }
    /* Apply the shift from the sphere to the ellipsoid as described
   * in [LK12]. */ if (this.es !== 0) {
        var invert_sign;
        var tanphi, xa;
        invert_sign = lp.phi < 0 ? 1 : 0;
        tanphi = Math.tan(lp.phi);
        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
        if (invert_sign) lp.phi = -lp.phi;
    }
    lp.lam += this.long0;
    p.x = lp.lam;
    p.y = lp.phi;
    return p;
}
/* Helper function for forward projection: compute the theta angle
 * and determine the area number. */ function $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, y, x, area) {
    var theta;
    if (phi < (0, $gyVUi.EPSLN)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        theta = 0.0;
    } else {
        theta = Math.atan2(y, x);
        if (Math.abs(theta) <= (0, $gyVUi.FORTPI)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        else if (theta > (0, $gyVUi.FORTPI) && theta <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta -= (0, $gyVUi.HALF_PI);
        } else if (theta > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || theta <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = theta >= 0.0 ? theta - (0, $gyVUi.SPI) : theta + (0, $gyVUi.SPI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta += (0, $gyVUi.HALF_PI);
        }
    }
    return theta;
}
/* Helper function: shift the longitude. */ function $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, offset) {
    var slon = lon + offset;
    if (slon < -(0, $gyVUi.SPI)) slon += (0, $gyVUi.TWO_PI);
    else if (slon > +(0, $gyVUi.SPI)) slon -= (0, $gyVUi.TWO_PI);
    return slon;
}
var $228cab2632c5bcf7$export$e4b2ac9215619f8d = [
    "Quadrilateralized Spherical Cube",
    "Quadrilateralized_Spherical_Cube",
    "qsc"
];
var $228cab2632c5bcf7$export$2e2bcd8739ae039 = {
    init: $228cab2632c5bcf7$export$2cd8252107eb640b,
    forward: $228cab2632c5bcf7$export$174bb771924e7eb1,
    inverse: $228cab2632c5bcf7$export$70ae2c07e401031b,
    names: $228cab2632c5bcf7$export$e4b2ac9215619f8d
};


// Robinson projection
// Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
// Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039

var $gyVUi = parcelRequire("gyVUi");

var $a9oRf = parcelRequire("a9oRf");
var $86b26d30d3579075$var$COEFS_X = [
    [
        1.0000,
        2.2199e-17,
        -0.0000715515,
        3.1103e-06
    ],
    [
        0.9986,
        -0.000482243,
        -0.000024897,
        -0.0000013309
    ],
    [
        0.9954,
        -0.00083103,
        -0.0000448605,
        -0.000000986701
    ],
    [
        0.9900,
        -0.00135364,
        -0.000059661,
        3.6777e-06
    ],
    [
        0.9822,
        -0.00167442,
        -0.00000449547,
        -0.00000572411
    ],
    [
        0.9730,
        -0.00214868,
        -0.0000903571,
        1.8736e-08
    ],
    [
        0.9600,
        -0.00305085,
        -0.0000900761,
        1.64917e-06
    ],
    [
        0.9427,
        -0.00382792,
        -0.0000653386,
        -0.0000026154
    ],
    [
        0.9216,
        -0.00467746,
        -0.00010457,
        4.81243e-06
    ],
    [
        0.8962,
        -0.00536223,
        -0.0000323831,
        -0.00000543432
    ],
    [
        0.8679,
        -0.00609363,
        -0.000113898,
        3.32484e-06
    ],
    [
        0.8350,
        -0.00698325,
        -0.0000640253,
        9.34959e-07
    ],
    [
        0.7986,
        -0.00755338,
        -0.0000500009,
        9.35324e-07
    ],
    [
        0.7597,
        -0.00798324,
        -0.000035971,
        -0.00000227626
    ],
    [
        0.7186,
        -0.00851367,
        -0.0000701149,
        -0.0000086303
    ],
    [
        0.6732,
        -0.00986209,
        -0.000199569,
        1.91974e-05
    ],
    [
        0.6213,
        -0.010418,
        8.83923e-05,
        6.24051e-06
    ],
    [
        0.5722,
        -0.00906601,
        0.000182,
        6.24051e-06
    ],
    [
        0.5322,
        -0.00677797,
        0.000275608,
        6.24051e-06
    ]
];
var $86b26d30d3579075$var$COEFS_Y = [
    [
        -0.00000000000000000520417,
        0.0124,
        1.21431e-18,
        -0.0000000000845284
    ],
    [
        0.0620,
        0.0124,
        -0.00000000126793,
        4.22642e-10
    ],
    [
        0.1240,
        0.0124,
        5.07171e-09,
        -0.00000000160604
    ],
    [
        0.1860,
        0.0123999,
        -0.0000000190189,
        6.00152e-09
    ],
    [
        0.2480,
        0.0124002,
        7.10039e-08,
        -0.0000000224
    ],
    [
        0.3100,
        0.0123992,
        -0.000000264997,
        8.35986e-08
    ],
    [
        0.3720,
        0.0124029,
        9.88983e-07,
        -0.000000311994
    ],
    [
        0.4340,
        0.0123893,
        -0.00000369093,
        -0.000000435621
    ],
    [
        0.4958,
        0.0123198,
        -0.0000102252,
        -0.000000345523
    ],
    [
        0.5571,
        0.0121916,
        -0.0000154081,
        -0.000000582288
    ],
    [
        0.6176,
        0.0119938,
        -0.0000241424,
        -0.000000525327
    ],
    [
        0.6769,
        0.011713,
        -0.0000320223,
        -0.000000516405
    ],
    [
        0.7346,
        0.0113541,
        -0.0000397684,
        -0.000000609052
    ],
    [
        0.7903,
        0.0109107,
        -0.0000489042,
        -0.00000104739
    ],
    [
        0.8435,
        0.0103431,
        -0.000064615,
        -0.00000000140374
    ],
    [
        0.8936,
        0.00969686,
        -0.000064636,
        -0.000008547
    ],
    [
        0.9394,
        0.00840947,
        -0.000192841,
        -0.0000042106
    ],
    [
        0.9761,
        0.00616527,
        -0.000256,
        -0.0000042106
    ],
    [
        1.0000,
        0.00328947,
        -0.000319159,
        -0.0000042106
    ]
];
var $86b26d30d3579075$var$FXC = 0.8487;
var $86b26d30d3579075$var$FYC = 1.3523;
var $86b26d30d3579075$var$C1 = (0, $gyVUi.R2D) / 5; // rad to 5-degree interval
var $86b26d30d3579075$var$RC1 = 1 / $86b26d30d3579075$var$C1;
var $86b26d30d3579075$var$NODES = 18;
var $86b26d30d3579075$var$poly3_val = function(coefs, x) {
    return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
};
var $86b26d30d3579075$var$poly3_der = function(coefs, x) {
    return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
};
function $86b26d30d3579075$var$newton_rapshon(f_df, start, max_err, iters) {
    var x = start;
    for(; iters; --iters){
        var upd = f_df(x);
        x -= upd;
        if (Math.abs(upd) < max_err) break;
    }
    return x;
}
function $86b26d30d3579075$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.es = 0;
    this.title = this.title || "Robinson";
}
function $86b26d30d3579075$export$174bb771924e7eb1(ll) {
    var lon = (0, $a9oRf.default)(ll.x - this.long0);
    var dphi = Math.abs(ll.y);
    var i = Math.floor(dphi * $86b26d30d3579075$var$C1);
    if (i < 0) i = 0;
    else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
    dphi = (0, $gyVUi.R2D) * (dphi - $86b26d30d3579075$var$RC1 * i);
    var xy = {
        x: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], dphi) * lon,
        y: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_Y[i], dphi)
    };
    if (ll.y < 0) xy.y = -xy.y;
    xy.x = xy.x * this.a * $86b26d30d3579075$var$FXC + this.x0;
    xy.y = xy.y * this.a * $86b26d30d3579075$var$FYC + this.y0;
    return xy;
}
function $86b26d30d3579075$export$70ae2c07e401031b(xy) {
    var ll = {
        x: (xy.x - this.x0) / (this.a * $86b26d30d3579075$var$FXC),
        y: Math.abs(xy.y - this.y0) / (this.a * $86b26d30d3579075$var$FYC)
    };
    if (ll.y >= 1) {
        ll.x /= $86b26d30d3579075$var$COEFS_X[$86b26d30d3579075$var$NODES][0];
        ll.y = xy.y < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        // find table interval
        var i = Math.floor(ll.y * $86b26d30d3579075$var$NODES);
        if (i < 0) i = 0;
        else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
        for(;;){
            if ($86b26d30d3579075$var$COEFS_Y[i][0] > ll.y) --i;
            else if ($86b26d30d3579075$var$COEFS_Y[i + 1][0] <= ll.y) ++i;
            else break;
        }
        // linear interpolation in 5 degree interval
        var coefs = $86b26d30d3579075$var$COEFS_Y[i];
        var t = 5 * (ll.y - coefs[0]) / ($86b26d30d3579075$var$COEFS_Y[i + 1][0] - coefs[0]);
        // find t so that poly3_val(coefs, t) = ll.y
        t = $86b26d30d3579075$var$newton_rapshon(function(x) {
            return ($86b26d30d3579075$var$poly3_val(coefs, x) - ll.y) / $86b26d30d3579075$var$poly3_der(coefs, x);
        }, t, (0, $gyVUi.EPSLN), 100);
        ll.x /= $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], t);
        ll.y = (5 * i + t) * (0, $gyVUi.D2R);
        if (xy.y < 0) ll.y = -ll.y;
    }
    ll.x = (0, $a9oRf.default)(ll.x + this.long0);
    return ll;
}
var $86b26d30d3579075$export$e4b2ac9215619f8d = [
    "Robinson",
    "robin"
];
var $86b26d30d3579075$export$2e2bcd8739ae039 = {
    init: $86b26d30d3579075$export$2cd8252107eb640b,
    forward: $86b26d30d3579075$export$174bb771924e7eb1,
    inverse: $86b26d30d3579075$export$70ae2c07e401031b,
    names: $86b26d30d3579075$export$e4b2ac9215619f8d
};



function $07c2abe70612fbc5$export$2cd8252107eb640b() {
    this.name = "geocent";
}
function $07c2abe70612fbc5$export$174bb771924e7eb1(p) {
    var point = (0, $3a04bd721826a648$export$4a4ae2976f9a808a)(p, this.es, this.a);
    return point;
}
function $07c2abe70612fbc5$export$70ae2c07e401031b(p) {
    var point = (0, $3a04bd721826a648$export$26210192c8922750)(p, this.es, this.a, this.b);
    return point;
}
var $07c2abe70612fbc5$export$e4b2ac9215619f8d = [
    "Geocentric",
    "geocentric",
    "geocent",
    "Geocent"
];
var $07c2abe70612fbc5$export$2e2bcd8739ae039 = {
    init: $07c2abe70612fbc5$export$2cd8252107eb640b,
    forward: $07c2abe70612fbc5$export$174bb771924e7eb1,
    inverse: $07c2abe70612fbc5$export$70ae2c07e401031b,
    names: $07c2abe70612fbc5$export$e4b2ac9215619f8d
};



var $gyVUi = parcelRequire("gyVUi");

var $jU5gu = parcelRequire("jU5gu");
var $ab98c67e9f567a4b$var$mode = {
    N_POLE: 0,
    S_POLE: 1,
    EQUIT: 2,
    OBLIQ: 3
};
var $ab98c67e9f567a4b$var$params = {
    h: {
        def: 100000,
        num: true
    },
    azi: {
        def: 0,
        num: true,
        degrees: true
    },
    tilt: {
        def: 0,
        num: true,
        degrees: true
    },
    long0: {
        def: 0,
        num: true
    },
    lat0: {
        def: 0,
        num: true
    } // default is Equator, conversion to rad is automatic
};
function $ab98c67e9f567a4b$export$2cd8252107eb640b() {
    Object.keys($ab98c67e9f567a4b$var$params).forEach((function(p) {
        if (typeof this[p] === "undefined") this[p] = $ab98c67e9f567a4b$var$params[p].def;
        else if ($ab98c67e9f567a4b$var$params[p].num && isNaN(this[p])) throw new Error("Invalid parameter value, must be numeric " + p + " = " + this[p]);
        else if ($ab98c67e9f567a4b$var$params[p].num) this[p] = parseFloat(this[p]);
        if ($ab98c67e9f567a4b$var$params[p].degrees) this[p] = this[p] * (0, $gyVUi.D2R);
    }).bind(this));
    if (Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? $ab98c67e9f567a4b$var$mode.S_POLE : $ab98c67e9f567a4b$var$mode.N_POLE;
    else if (Math.abs(this.lat0) < (0, $gyVUi.EPSLN)) this.mode = $ab98c67e9f567a4b$var$mode.EQUIT;
    else {
        this.mode = $ab98c67e9f567a4b$var$mode.OBLIQ;
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
    this.pn1 = this.h / this.a; // Normalize relative to the Earth's radius
    if (this.pn1 <= 0 || this.pn1 > 1e10) throw new Error("Invalid height");
    this.p = 1 + this.pn1;
    this.rp = 1 / this.p;
    this.h1 = 1 / this.pn1;
    this.pfact = (this.p + 1) * this.h1;
    this.es = 0;
    var omega = this.tilt;
    var gamma = this.azi;
    this.cg = Math.cos(gamma);
    this.sg = Math.sin(gamma);
    this.cw = Math.cos(omega);
    this.sw = Math.sin(omega);
}
function $ab98c67e9f567a4b$export$174bb771924e7eb1(p) {
    p.x -= this.long0;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var coslam = Math.cos(p.x);
    var x, y;
    switch(this.mode){
        case $ab98c67e9f567a4b$var$mode.OBLIQ:
            y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.EQUIT:
            y = cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.S_POLE:
            y = -sinphi;
            break;
        case $ab98c67e9f567a4b$var$mode.N_POLE:
            y = sinphi;
            break;
    }
    y = this.pn1 / (this.p - y);
    x = y * cosphi * Math.sin(p.x);
    switch(this.mode){
        case $ab98c67e9f567a4b$var$mode.OBLIQ:
            y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.EQUIT:
            y *= sinphi;
            break;
        case $ab98c67e9f567a4b$var$mode.N_POLE:
            y *= -(cosphi * coslam);
            break;
        case $ab98c67e9f567a4b$var$mode.S_POLE:
            y *= cosphi * coslam;
            break;
    }
    // Tilt 
    var yt, ba;
    yt = y * this.cg + x * this.sg;
    ba = 1 / (yt * this.sw * this.h1 + this.cw);
    x = (x * this.cg - y * this.sg) * this.cw * ba;
    y = yt * ba;
    p.x = x * this.a;
    p.y = y * this.a;
    return p;
}
function $ab98c67e9f567a4b$export$70ae2c07e401031b(p) {
    p.x /= this.a;
    p.y /= this.a;
    var r = {
        x: p.x,
        y: p.y
    };
    // Un-Tilt
    var bm, bq, yt;
    yt = 1 / (this.pn1 - p.y * this.sw);
    bm = this.pn1 * p.x * yt;
    bq = this.pn1 * p.y * this.cw * yt;
    p.x = bm * this.cg + bq * this.sg;
    p.y = bq * this.cg - bm * this.sg;
    var rh = (0, $jU5gu.default)(p.x, p.y);
    if (Math.abs(rh) < (0, $gyVUi.EPSLN)) {
        r.x = 0;
        r.y = p.y;
    } else {
        var cosz, sinz;
        sinz = 1 - rh * rh * this.pfact;
        sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
        cosz = Math.sqrt(1 - sinz * sinz);
        switch(this.mode){
            case $ab98c67e9f567a4b$var$mode.OBLIQ:
                r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
                p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
                p.x *= sinz * this.cosph0;
                break;
            case $ab98c67e9f567a4b$var$mode.EQUIT:
                r.y = Math.asin(p.y * sinz / rh);
                p.y = cosz * rh;
                p.x *= sinz;
                break;
            case $ab98c67e9f567a4b$var$mode.N_POLE:
                r.y = Math.asin(cosz);
                p.y = -p.y;
                break;
            case $ab98c67e9f567a4b$var$mode.S_POLE:
                r.y = -Math.asin(cosz);
                break;
        }
        r.x = Math.atan2(p.x, p.y);
    }
    p.x = r.x + this.long0;
    p.y = r.y;
    return p;
}
var $ab98c67e9f567a4b$export$e4b2ac9215619f8d = [
    "Tilted_Perspective",
    "tpers"
];
var $ab98c67e9f567a4b$export$2e2bcd8739ae039 = {
    init: $ab98c67e9f567a4b$export$2cd8252107eb640b,
    forward: $ab98c67e9f567a4b$export$174bb771924e7eb1,
    inverse: $ab98c67e9f567a4b$export$70ae2c07e401031b,
    names: $ab98c67e9f567a4b$export$e4b2ac9215619f8d
};


function $de14c0a63cfa0e0d$export$2e2bcd8739ae039(proj4) {
    proj4.Proj.projections.add((0, $9t3dO.default));
    proj4.Proj.projections.add((0, $9zr9G.default));
    proj4.Proj.projections.add((0, $efe46ba059d82de2$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $4279f8b9d31284e6$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $llHto.default));
    proj4.Proj.projections.add((0, $31a8278a941356d4$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $a6cb33582cb5910b$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $d753eaf12887a276$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $c765c705b741a192$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $00f791059e8f61f5$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $deudM.default));
    proj4.Proj.projections.add((0, $8mhgZ.default));
    proj4.Proj.projections.add((0, $dbf05e97c9232a2a$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $4d31684dfe594c29$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $936a7dd52884a3fc$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $20353e9e716518d0$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $6Eu1X.default));
    proj4.Proj.projections.add((0, $b37863f65bf2a2a4$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $a9d7febe7a8566f2$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $57490138fba0a0b8$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $cab513e7d920927e$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $168e5f6524a6fc5f$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $d2d34f4dbda3af26$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $24629f153ebf2c1f$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $228cab2632c5bcf7$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $86b26d30d3579075$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $07c2abe70612fbc5$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $ab98c67e9f567a4b$export$2e2bcd8739ae039));
}


(0, $471507637a3ff861$export$2e2bcd8739ae039).defaultDatum = "WGS84"; //default datum
(0, $471507637a3ff861$export$2e2bcd8739ae039).Proj = (0, $24869d6338533b3b$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).WGS84 = new (0, $471507637a3ff861$export$2e2bcd8739ae039).Proj("WGS84");
(0, $471507637a3ff861$export$2e2bcd8739ae039).Point = (0, $d8ec3fc1ff061c76$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).toPoint = (0, $01093474ae9bd8f6$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).defs = (0, $a9b3183caccb3297$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).nadgrid = (0, $b2d482da445fbb18$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).transform = (0, $8e8cfb7cbefc2113$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).mgrs = (0, $31ee54b8e1d1cd8f$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).version = "__VERSION__";
(0, $de14c0a63cfa0e0d$export$2e2bcd8739ae039)((0, $471507637a3ff861$export$2e2bcd8739ae039));
var $a52c207aab93bf4f$export$2e2bcd8739ae039 = (0, $471507637a3ff861$export$2e2bcd8739ae039);


/**
 * @module ol/layer/Tile
 */ /**
 * @module ol/layer/BaseTile
 */ 
/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $e4c61536de922b84$export$2e2bcd8739ae039 = {
    PRELOAD: "preload",
    USE_INTERIM_TILES_ON_ERROR: "useInterimTilesOnError"
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ class $93be2de6a052f587$var$BaseTileLayer extends (0, $534f30fce11effcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ this.un;
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $e4c61536de922b84$export$2e2bcd8739ae039).PRELOAD);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $e4c61536de922b84$export$2e2bcd8739ae039).PRELOAD, preload);
    }
    /**
   * Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $e4c61536de922b84$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $e4c61536de922b84$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
    /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $93be2de6a052f587$export$2e2bcd8739ae039 = $93be2de6a052f587$var$BaseTileLayer;


/**
 * @module ol/renderer/canvas/TileLayer
 */ /**
 * @module ol/renderer/canvas/Layer
 */ /**
 * @module ol/renderer/Layer
 */ 



/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ class $cb18cdefd702a327$var$LayerRenderer extends (0, $1f093ab5083c8a1f$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super();
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ this.ready = true;
        /** @private */ this.boundHandleImageChange_ = this.handleImageChange_.bind(this);
        /**
     * @protected
     * @type {LayerType}
     */ this.layer_ = layer;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        return null;
    }
    /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   */ renderFrame(frameState, target) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @param {number} zoom Zoom level.
   * @param {import("../Tile.js").default} tile Tile.
   * @return {boolean|void} If `false`, the tile will not be considered loaded.
   */ loadedTileCallback(tiles, zoom, tile) {
        if (!tiles[zoom]) tiles[zoom] = {};
        tiles[zoom][tile.tileCoord.toString()] = tile;
        return undefined;
    }
    /**
   * Create a function that adds loaded tiles to the tile lookup.
   * @param {import("../source/Tile.js").default} source Tile source.
   * @param {import("../proj/Projection.js").default} projection Projection of the tiles.
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @return {function(number, import("../TileRange.js").default):boolean} A function that can be
   *     called with a zoom level and a tile range to add loaded tiles to the lookup.
   * @protected
   */ createLoadedTileFinder(source, projection, tiles) {
        return(/**
       * @param {number} zoom Zoom level.
       * @param {import("../TileRange.js").default} tileRange Tile range.
       * @return {boolean} The tile range is fully loaded.
       */ (zoom, tileRange)=>{
            const callback = this.loadedTileCallback.bind(this, tiles, zoom);
            return source.forEachLoadedTile(projection, zoom, tileRange, callback);
        });
    }
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    }
    /**
   * @return {LayerType} Layer.
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ handleFontsChanged() {}
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ handleImageChange_(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || image.getState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) this.renderIfReadyAndVisible();
    }
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ loadImage(image) {
        let imageState = image.getState();
        if (imageState != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED && imageState != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) image.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
    }
    /**
   * @protected
   */ renderIfReadyAndVisible() {
        const layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === "ready") layer.changed();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ renderDeferred(frameState) {}
    /**
   * Clean up.
   */ disposeInternal() {
        delete this.layer_;
        super.disposeInternal();
    }
}
var $cb18cdefd702a327$export$2e2bcd8739ae039 = $cb18cdefd702a327$var$LayerRenderer;




/**
 * @module ol/render/canvas/ZIndexContext
 */ 
/** @typedef {CanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */ /**
 * @extends {CanvasRenderingContext2D}
 */ class $c1cb593c98d2cbd0$var$ZIndexContext {
    constructor(){
        /**
     * @private
     * @type {Array<Array<*>>}
     */ this.instructions_ = [];
        /**
     * @type {number}
     */ this.zIndex = 0;
        /**
     * @private
     * @type {number}
     */ this.offset_ = 0;
        /**
     * @type {ZIndexContextProxy}
     */ this.context_ = /** @type {ZIndexContextProxy} */ new Proxy((0, $075f937d7366f1a2$export$fcb72ce088a6632c)(), {
            get: (target, property)=>{
                if (typeof /** @type {*} */ (0, $075f937d7366f1a2$export$fcb72ce088a6632c)()[property] !== "function") // we only accept calling functions on the proxy, not accessing properties
                return undefined;
                if (!this.instructions_[this.zIndex + this.offset_]) this.instructions_[this.zIndex + this.offset_] = [];
                this.instructions_[this.zIndex + this.offset_].push(property);
                return this.pushMethodArgs_;
            },
            set: (target, property, value)=>{
                if (!this.instructions_[this.zIndex + this.offset_]) this.instructions_[this.zIndex + this.offset_] = [];
                this.instructions_[this.zIndex + this.offset_].push(property, value);
                return true;
            }
        });
    }
    /**
   * @private
   * @param {...*} args Args.
   * @return {ZIndexContext} This.
   */ pushMethodArgs_ = (...args)=>{
        this.instructions_[this.zIndex + this.offset_].push(args);
        return this;
    };
    /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */ pushFunction(render) {
        this.instructions_[this.zIndex + this.offset_].push(render);
    }
    /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */ getContext() {
        return this.context_;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   */ draw(context) {
        this.instructions_.forEach((instructionsAtIndex)=>{
            for(let i = 0, ii = instructionsAtIndex.length; i < ii; ++i){
                const property = instructionsAtIndex[i];
                if (typeof property === "function") {
                    property(context);
                    continue;
                }
                const instructionAtIndex = instructionsAtIndex[++i];
                if (typeof /** @type {*} */ context[property] === "function") /** @type {*} */ context[property](...instructionAtIndex);
                else {
                    if (typeof instructionAtIndex === "function") {
                        /** @type {*} */ context[property] = instructionAtIndex(context);
                        continue;
                    }
                    /** @type {*} */ context[property] = instructionAtIndex;
                }
            }
        });
    }
    clear() {
        this.instructions_.length = 0;
        this.zIndex = 0;
        this.offset_ = 0;
    }
    /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */ offset() {
        this.offset_ = this.instructions_.length;
        this.zIndex = 0;
    }
}
var $c1cb593c98d2cbd0$export$2e2bcd8739ae039 = $c1cb593c98d2cbd0$var$ZIndexContext;







const $42152f52b26b6ca7$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D}
 */ let $42152f52b26b6ca7$var$pixelContext = null;
function $42152f52b26b6ca7$var$createPixelContext() {
    $42152f52b26b6ca7$var$pixelContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ class $42152f52b26b6ca7$var$CanvasLayerRenderer extends (0, $cb18cdefd702a327$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super(layer);
        /**
     * @protected
     * @type {HTMLElement}
     */ this.container = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.tempTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.pixelTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.inversePixelTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @type {CanvasRenderingContext2D}
     */ this.context = null;
        /**
     * @private
     * @type {ZIndexContext}
     */ this.deferredContext_ = null;
        /**
     * @type {boolean}
     */ this.containerReused = false;
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.pixelContext_ = null;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ this.frameState = null;
    }
    /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ getImageData(image, col, row) {
        if (!$42152f52b26b6ca7$var$pixelContext) $42152f52b26b6ca7$var$createPixelContext();
        $42152f52b26b6ca7$var$pixelContext.clearRect(0, 0, 1, 1);
        let data;
        try {
            $42152f52b26b6ca7$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = $42152f52b26b6ca7$var$pixelContext.getImageData(0, 0, 1, 1).data;
        } catch (err) {
            $42152f52b26b6ca7$var$pixelContext = null;
            return null;
        }
        return data;
    }
    /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ getBackground(frameState) {
        const layer = this.getLayer();
        let background = layer.getBackground();
        if (typeof background === "function") background = background(frameState.viewState.resolution);
        return background || undefined;
    }
    /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS Transform.
   * @param {string} [backgroundColor] Background color.
   */ useContainer(target, transform, backgroundColor) {
        const layerClassName = this.getLayer().getClassName();
        let container, context;
        if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, $b998d41b678ed5d1$export$e9bab7fafb253603)((0, $322346e1ff7894ca$export$75093a47a9fa838d)(target.style.backgroundColor), (0, $322346e1ff7894ca$export$75093a47a9fa838d)(backgroundColor)))) {
            const canvas = target.firstElementChild;
            if (canvas instanceof HTMLCanvasElement) context = canvas.getContext("2d");
        }
        if (context && context.canvas.style.transform === transform) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        } else if (this.container) this.container.style.backgroundColor = null;
        if (!this.container) {
            container = document.createElement("div");
            container.className = layerClassName;
            let style = container.style;
            style.position = "absolute";
            style.width = "100%";
            style.height = "100%";
            context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)();
            const canvas = context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = "absolute";
            style.left = "0";
            style.transformOrigin = "top left";
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ clipUnrotated(context, frameState, extent) {
        const topLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent);
        const topRight = (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(extent);
        const bottomRight = (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(extent);
        const bottomLeft = (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(extent);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        const inverted = this.inversePixelTransform;
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, topLeft);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, topRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, bottomRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */ prepareContainer(frameState, target) {
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const width = Math.round((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / resolution * pixelRatio);
        // set forward and inverse pixel transforms
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        (0, $e22e7611e69f42a9$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        const canvasTransform = (0, $e22e7611e69f42a9$export$f84e8e69fd4488a5)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        if (!this.containerReused) {
            const canvas = this.context.canvas;
            if (canvas.width != width || canvas.height != height) {
                canvas.width = width;
                canvas.height = height;
            } else this.context.clearRect(0, 0, width, height);
            if (canvasTransform !== canvas.style.transform) canvas.style.transform = canvasTransform;
        }
    }
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ dispatchRenderEvent_(type, context, frameState) {
        const layer = this.getLayer();
        if (layer.hasListener(type)) {
            const event = new (0, $b80dddceb0c42ad4$export$2e2bcd8739ae039)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event);
        }
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ preRender(context, frameState) {
        this.frameState = frameState;
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRERENDER, context, frameState);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ postRender(context, frameState) {
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER, context, frameState);
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {}
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */ getRenderContext(frameState) {
        if (frameState.declutter && !this.deferredContext_) this.deferredContext_ = new (0, $c1cb593c98d2cbd0$export$2e2bcd8739ae039)();
        return frameState.declutter ? this.deferredContext_.getContext() : this.context;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferred(frameState) {
        if (!frameState.declutter) return;
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRERENDER, this.context, frameState);
        if (frameState.declutter && this.deferredContext_) {
            this.deferredContext_.draw(this.context);
            this.deferredContext_.clear();
        }
        this.renderDeferredInternal(frameState);
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER, this.context, frameState);
    }
    /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        const dx1 = width / 2;
        const dy1 = height / 2;
        const sx = pixelRatio / resolution;
        const sy = -sx;
        const dx2 = -center[0] + offsetX;
        const dy2 = -center[1];
        return (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    }
    /**
   * Clean up.
   */ disposeInternal() {
        delete this.frameState;
        super.disposeInternal();
    }
}
var $42152f52b26b6ca7$export$2e2bcd8739ae039 = $42152f52b26b6ca7$var$CanvasLayerRenderer;












/**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ class $02fffef185f4339b$var$CanvasTileLayerRenderer extends (0, $42152f52b26b6ca7$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} tileLayer Tile layer.
   */ constructor(tileLayer){
        super(tileLayer);
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ this.extentChanged = true;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default}
     */ this.renderedProjection = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedRevision;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {boolean}
     */ this.newTiles_ = false;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tmpExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tmpTileRange_ = new (0, $550e524b0d1b61d4$export$2e2bcd8739ae039)(0, 0, 0, 0);
    }
    /**
   * @protected
   * @param {import("../../Tile.js").default} tile Tile.
   * @return {boolean} Tile is drawable.
   */ isDrawableTile(tile) {
        const tileLayer = this.getLayer();
        const tileState = tile.getState();
        const useInterimTilesOnError = tileLayer.getUseInterimTilesOnError();
        return tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY || tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR && !useInterimTilesOnError;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {!import("../../Tile.js").default} Tile.
   */ getTile(z, x, y, frameState) {
        const pixelRatio = frameState.pixelRatio;
        const projection = frameState.viewState.projection;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        let tile = tileSource.getTile(z, x, y, pixelRatio, projection);
        if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) {
            if (tileLayer.getUseInterimTilesOnError() && tileLayer.getPreload() > 0) // Preloaded tiles for lower resolutions might have finished loading.
            this.newTiles_ = true;
        }
        if (!this.isDrawableTile(tile)) tile = tile.getInterimTile();
        return tile;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const pixelRatio = frameState.pixelRatio;
        const projection = frameState.viewState.projection;
        const viewState = frameState.viewState;
        const source = layer.getRenderSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(let z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            const tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            const tile = source.getTile(z, tileCoord[1], tileCoord[2], pixelRatio, projection);
            if (!(tile instanceof (0, $cd3bc8d185522361$export$2e2bcd8739ae039) || tile instanceof (0, $398e350e33050c07$export$2e2bcd8739ae039)) || tile instanceof (0, $398e350e33050c07$export$2e2bcd8739ae039) && tile.getState() === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) return null;
            if (tile.getState() !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) continue;
            const tileOrigin = tileGrid.getOrigin(z);
            const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z));
            const tileResolution = tileGrid.getResolution(z);
            const col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            const row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            const gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(tile.getImage(), col + gutter, row + gutter);
        }
        return null;
    }
    /**
   * @param {Object<number, Object<string, import("../../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @param {number} zoom Zoom level.
   * @param {import("../../Tile.js").default} tile Tile.
   * @return {boolean|void} If `false`, the tile will not be considered loaded.
   */ loadedTileCallback(tiles, zoom, tile) {
        if (this.isDrawableTile(tile)) return super.loadedTileCallback(tiles, zoom, tile);
        return false;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return !!this.getLayer().getSource();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const viewResolution = viewState.resolution;
        const viewCenter = viewState.center;
        const rotation = viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const sourceRevision = tileSource.getRevision();
        const tileGrid = tileSource.getTileGridForProjection(projection);
        const z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        let extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const layerExtent = layerState.extent && (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection);
        if (layerExtent) extent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(extent, (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection));
        const dx = tileResolution * width / 2 / tilePixelRatio;
        const dy = tileResolution * height / 2 / tilePixelRatio;
        const canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
        /**
     * @type {Object<number, Object<string, import("../../Tile.js").default>>}
     */ const tilesToDrawByZ = {};
        tilesToDrawByZ[z] = {};
        const findLoadedTiles = this.createLoadedTileFinder(tileSource, projection, tilesToDrawByZ);
        const tmpExtent = this.tmpExtent;
        const tmpTileRange = this.tmpTileRange_;
        this.newTiles_ = false;
        const viewport = rotation ? (0, $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac)(viewState.center, resolution, rotation, frameState.size) : undefined;
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            if (rotation && !tileGrid.tileCoordIntersectsViewport([
                z,
                x,
                y
            ], viewport)) continue;
            const tile = this.getTile(z, x, y, frameState);
            if (this.isDrawableTile(tile)) {
                const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
                if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                    tilesToDrawByZ[z][tile.tileCoord.toString()] = tile;
                    let inTransition = tile.inTransition(uid);
                    if (inTransition && layerState.opacity !== 1) {
                        // Skipping transition when layer is not fully opaque avoids visual artifacts.
                        tile.endTransition(uid);
                        inTransition = false;
                    }
                    if (!this.newTiles_ && (inTransition || !this.renderedTiles.includes(tile))) this.newTiles_ = true;
                }
                if (tile.getAlpha(uid, frameState.time) === 1) continue;
            }
            const childTileRange = tileGrid.getTileCoordChildTileRange(tile.tileCoord, tmpTileRange, tmpExtent);
            let covered = false;
            if (childTileRange) covered = findLoadedTiles(z + 1, childTileRange);
            if (!covered) tileGrid.forEachTileCoordParentTileRange(tile.tileCoord, findLoadedTiles, tmpTileRange, tmpExtent);
        }
        const canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        const context = this.getRenderContext(frameState);
        // set scale transform for calculating tile positions on the canvas
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (layerExtent) this.clipUnrotated(context, frameState, layerExtent);
        if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        this.renderedTiles.length = 0;
        /** @type {Array<number>} */ let zs = Object.keys(tilesToDrawByZ).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        let clips, clipZs, currentClip;
        if (layerState.opacity === 1 && (!this.containerReused || tileSource.getOpaque(frameState.viewState.projection))) zs = zs.reverse();
        else {
            clips = [];
            clipZs = [];
        }
        for(let i = zs.length - 1; i >= 0; --i){
            const currentZ = zs[i];
            const currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            const currentResolution = tileGrid.getResolution(currentZ);
            const currentScale = currentResolution / tileResolution;
            const dx = currentTilePixelSize[0] * currentScale * canvasScale;
            const dy = currentTilePixelSize[1] * currentScale * canvasScale;
            const originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(canvasExtent), currentZ);
            const originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            const origin = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            const tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            const tilesToDraw = tilesToDrawByZ[currentZ];
            for(const tileCoordKey in tilesToDraw){
                const tile = /** @type {import("../../ImageTile.js").default} */ tilesToDraw[tileCoordKey];
                const tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                const xIndex = originTileCoord[1] - tileCoord[1];
                const nextX = Math.round(origin[0] - (xIndex - 1) * dx);
                const yIndex = originTileCoord[2] - tileCoord[2];
                const nextY = Math.round(origin[1] - (yIndex - 1) * dy);
                const x = Math.round(origin[0] - xIndex * dx);
                const y = Math.round(origin[1] - yIndex * dy);
                const w = nextX - x;
                const h = nextY - y;
                const transition = z === currentZ;
                const inTransition = transition && tile.getAlpha((0, $6c5e11070e371322$export$5e82334337e0f204)(this), frameState.time) !== 1;
                let contextSaved = false;
                if (!inTransition) {
                    if (clips) {
                        // Clip mask for regions in this tile that already filled by a higher z tile
                        currentClip = [
                            x,
                            y,
                            x + w,
                            y,
                            x + w,
                            y + h,
                            x,
                            y + h
                        ];
                        for(let i = 0, ii = clips.length; i < ii; ++i)if (z !== currentZ && currentZ < clipZs[i]) {
                            const clip = clips[i];
                            if ((0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)([
                                x,
                                y,
                                x + w,
                                y + h
                            ], [
                                clip[0],
                                clip[3],
                                clip[4],
                                clip[7]
                            ])) {
                                if (!contextSaved) {
                                    context.save();
                                    contextSaved = true;
                                }
                                context.beginPath();
                                // counter-clockwise (outer ring) for current tile
                                context.moveTo(currentClip[0], currentClip[1]);
                                context.lineTo(currentClip[2], currentClip[3]);
                                context.lineTo(currentClip[4], currentClip[5]);
                                context.lineTo(currentClip[6], currentClip[7]);
                                // clockwise (inner ring) for higher z tile
                                context.moveTo(clip[6], clip[7]);
                                context.lineTo(clip[4], clip[5]);
                                context.lineTo(clip[2], clip[3]);
                                context.lineTo(clip[0], clip[1]);
                                context.clip();
                            }
                        }
                        clips.push(currentClip);
                        clipZs.push(currentZ);
                    } else context.clearRect(x, y, w, h);
                }
                this.drawTileImage(tile, frameState, x, y, w, h, tileGutter, transition);
                if (clips && !inTransition) {
                    if (contextSaved) context.restore();
                    this.renderedTiles.unshift(tile);
                } else this.renderedTiles.push(tile);
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedRevision = sourceRevision;
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.renderedProjection = projection;
        this.manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, z, tileLayer.getPreload());
        this.scheduleExpireCache(frameState, tileSource);
        this.postRender(this.context, frameState);
        if (layerState.extent) context.restore();
        context.imageSmoothingEnabled = true;
        return this.container;
    }
    /**
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   */ drawTileImage(tile, frameState, x, y, w, h, gutter, transition) {
        const image = this.getTileImage(tile);
        if (!image) return;
        const context = this.getRenderContext(frameState);
        const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        const alphaChanged = alpha !== context.globalAlpha;
        if (alphaChanged) {
            context.save();
            context.globalAlpha = alpha;
        }
        context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    }
    /**
   * @return {HTMLCanvasElement} Image
   */ getImage() {
        const context = this.context;
        return context ? context.canvas : null;
    }
    /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ getTileImage(tile) {
        return tile.getImage();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @protected
   */ scheduleExpireCache(frameState, tileSource) {
        if (tileSource.canExpireCache()) {
            /**
       * @param {import("../../source/Tile.js").default} tileSource Tile source.
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */ const postRenderFunction = (function(tileSource, map, frameState) {
                const tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
                if (tileSourceKey in frameState.usedTiles) tileSource.expireCache(frameState.viewState.projection, frameState.usedTiles[tileSourceKey]);
            }).bind(null, tileSource);
            frameState.postRenderFunctions.push(/** @type {import("../../Map.js").PostRenderFunction} */ postRenderFunction);
        }
    }
    /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ updateUsedTiles(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        const tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    }
    /**
   * Manage tile pyramid.
   * This function performs a number of functions related to the tiles at the
   * current zoom and lower zoom levels:
   * - registers idle tiles in frameState.wantedTiles so that they are not
   *   discarded by the tile queue
   * - enqueues missing tiles
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid Tile grid.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection.js").default} projection Projection.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {number} currentZ Current Z.
   * @param {number} preload Load low resolution tiles up to `preload` levels.
   * @param {function(import("../../Tile.js").default):void} [tileCallback] Tile callback.
   * @protected
   */ manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, currentZ, preload, tileCallback) {
        const tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        const wantedTiles = frameState.wantedTiles[tileSourceKey];
        const tileQueue = frameState.tileQueue;
        const minZoom = tileGrid.getMinZoom();
        const rotation = frameState.viewState.rotation;
        const viewport = rotation ? (0, $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac)(frameState.viewState.center, frameState.viewState.resolution, rotation, frameState.size) : undefined;
        let tileCount = 0;
        let tile, tileRange, tileResolution, x, y, z;
        for(z = minZoom; z <= currentZ; ++z){
            tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, tileRange);
            tileResolution = tileGrid.getResolution(z);
            for(x = tileRange.minX; x <= tileRange.maxX; ++x)for(y = tileRange.minY; y <= tileRange.maxY; ++y){
                if (rotation && !tileGrid.tileCoordIntersectsViewport([
                    z,
                    x,
                    y
                ], viewport)) continue;
                if (currentZ - z <= preload) {
                    ++tileCount;
                    tile = tileSource.getTile(z, x, y, pixelRatio, projection);
                    if (tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
                        wantedTiles[tile.getKey()] = true;
                        if (!tileQueue.isKeyQueued(tile.getKey())) tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tile.tileCoord),
                            tileResolution
                        ]);
                    }
                    if (tileCallback !== undefined) tileCallback(tile);
                } else tileSource.useTile(z, x, y, projection);
            }
        }
        tileSource.updateCacheSize(tileCount, projection);
    }
}
var $02fffef185f4339b$export$2e2bcd8739ae039 = $02fffef185f4339b$var$CanvasTileLayerRenderer;


/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ class $32e67a4d3559554a$var$TileLayer extends (0, $93be2de6a052f587$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        super(options);
    }
    createRenderer() {
        return new (0, $02fffef185f4339b$export$2e2bcd8739ae039)(this);
    }
}
var $32e67a4d3559554a$export$2e2bcd8739ae039 = $32e67a4d3559554a$var$TileLayer;

/**
 * @module ol/layer/Image
 */ /**
 * @module ol/layer/BaseImage
 */ 
/**
 * @template {import("../source/Image.js").default} ImageSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {ImageSourceType} [source] Source for this layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<ImageSourceType, RendererType>}
 * @api
 */ class $351df830ee0a9d9c$var$BaseImageLayer extends (0, $534f30fce11effcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        options = options ? options : {};
        super(options);
    }
}
var $351df830ee0a9d9c$export$2e2bcd8739ae039 = $351df830ee0a9d9c$var$BaseImageLayer;


/**
 * @module ol/renderer/canvas/ImageLayer
 */ 





/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 */ class $d08a3a38b8c630d8$var$CanvasImageLayerRenderer extends (0, $42152f52b26b6ca7$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/Image.js").default} imageLayer Image layer.
   */ constructor(imageLayer){
        super(imageLayer);
        /**
     * @protected
     * @type {?import("../../Image.js").default}
     */ this.image_ = null;
    }
    /**
   * @return {import('../../DataTile.js').ImageLike} Image.
   */ getImage() {
        return !this.image_ ? null : this.image_.getImage();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewResolution = viewState.resolution;
        const imageSource = this.getLayer().getSource();
        const hints = frameState.viewHints;
        let renderedExtent = frameState.extent;
        if (layerState.extent !== undefined) renderedExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(renderedExtent, (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, viewState.projection));
        if (!hints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] && !hints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING] && !(0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(renderedExtent)) {
            if (imageSource) {
                const projection = viewState.projection;
                const image = imageSource.getImage(renderedExtent, viewResolution, pixelRatio, projection);
                if (image) {
                    if (this.loadImage(image)) this.image_ = image;
                    else if (image.getState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).EMPTY) this.image_ = null;
                }
            } else this.image_ = null;
        }
        return !!this.image_;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const imageExtent = this.image_.getExtent();
        const img = this.image_.getImage();
        const imageMapWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(imageExtent);
        const col = Math.floor(img.width * ((coordinate[0] - imageExtent[0]) / imageMapWidth));
        if (col < 0 || col >= img.width) return null;
        const imageMapHeight = (0, $6da4c8ed3074c92b$export$c08559766941f856)(imageExtent);
        const row = Math.floor(img.height * ((imageExtent[3] - coordinate[1]) / imageMapHeight));
        if (row < 0 || row >= img.height) return null;
        return this.getImageData(img, col, row);
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */ renderFrame(frameState, target) {
        const image = this.image_;
        const imageExtent = image.getExtent();
        const imageResolution = image.getResolution();
        const [imageResolutionX, imageResolutionY] = Array.isArray(imageResolution) ? imageResolution : [
            imageResolution,
            imageResolution
        ];
        const imagePixelRatio = image.getPixelRatio();
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewCenter = viewState.center;
        const viewResolution = viewState.resolution;
        const scaleX = pixelRatio * imageResolutionX / (viewResolution * imagePixelRatio);
        const scaleY = pixelRatio * imageResolutionY / (viewResolution * imagePixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const context = this.getRenderContext(frameState);
        // clipped rendering if layer extent is set
        let clipped = false;
        let render = true;
        if (layerState.extent) {
            const layerExtent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, viewState.projection);
            render = (0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            clipped = render && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (clipped) this.clipUnrotated(context, frameState, layerExtent);
        }
        const img = image.getImage();
        const transform = (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, scaleX, scaleY, 0, imagePixelRatio * (imageExtent[0] - viewCenter[0]) / imageResolutionX, imagePixelRatio * (viewCenter[1] - imageExtent[3]) / imageResolutionY);
        this.renderedResolution = imageResolutionY * pixelRatio / imagePixelRatio;
        const dw = img.width * transform[0];
        const dh = img.height * transform[3];
        if (!this.getLayer().getSource().getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        if (render && dw >= 0.5 && dh >= 0.5) {
            const dx = transform[4];
            const dy = transform[5];
            const opacity = layerState.opacity;
            if (opacity !== 1) {
                context.save();
                context.globalAlpha = opacity;
            }
            context.drawImage(img, 0, 0, +img.width, +img.height, dx, dy, dw, dh);
            if (opacity !== 1) context.restore();
        }
        this.postRender(this.context, frameState);
        if (clipped) context.restore();
        context.imageSmoothingEnabled = true;
        return this.container;
    }
}
var $d08a3a38b8c630d8$export$2e2bcd8739ae039 = $d08a3a38b8c630d8$var$CanvasImageLayerRenderer;


/**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @extends {BaseImageLayer<ImageSourceType, CanvasImageLayerRenderer>}
 * @api
 */ class $14618f63634d34fc$var$ImageLayer extends (0, $351df830ee0a9d9c$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseImage.js").Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        super(options);
    }
    createRenderer() {
        return new (0, $d08a3a38b8c630d8$export$2e2bcd8739ae039)(this);
    }
    /**
   * Get data for a pixel location.  A four element RGBA array will be returned.  For requests outside the
   * layer extent, `null` will be returned.  Data for an image can only be retrieved if the
   * source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $14618f63634d34fc$export$2e2bcd8739ae039 = $14618f63634d34fc$var$ImageLayer;


/**
 * @module ol/Overlay
 */ 





/**
 * @typedef {'bottom-left' | 'bottom-center' | 'bottom-right' | 'center-left' | 'center-center' | 'center-right' | 'top-left' | 'top-center' | 'top-right'} Positioning
 * The overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, or `'top-right'`.
 */ /**
 * @typedef {Object} Options
 * @property {number|string} [id] Set the overlay id. The overlay id can be used
 * with the {@link module:ol/Map~Map#getOverlayById} method.
 * @property {HTMLElement} [element] The overlay element.
 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
 * the overlay. The first element in the
 * array is the horizontal offset. A positive value shifts the overlay right.
 * The second element in the array is the vertical offset. A positive value
 * shifts the overlay down.
 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
 * in map projection.
 * @property {Positioning} [positioning='top-left'] Defines how
 * the overlay is actually positioned with respect to its `position` property.
 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, and `'top-right'`.
 * @property {boolean} [stopEvent=true] Whether event propagation to the map
 * viewport should be stopped. If `true` the overlay is placed in the same
 * container as that of the controls (CSS class name
 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
 * with CSS class name specified by the `className` property.
 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
 * in the overlay container, or appended. If the overlay is placed in the same
 * container as that of the controls (see the `stopEvent` option) you will
 * probably set `insertFirst` to `true` so the overlay is displayed below the
 * controls.
 * @property {PanIntoViewOptions|boolean} [autoPan=false] Pan the map when calling
 * `setPosition`, so that the overlay is entirely visible in the current viewport.
 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
 * name.
 */ /**
 * @typedef {Object} PanOptions
 * @property {number} [duration=1000] The duration of the animation in
 * milliseconds.
 * @property {function(number):number} [easing] The easing function to use. Can
 * be one from {@link module:ol/easing} or a custom function.
 * Default is {@link module:ol/easing.inAndOut}.
 */ /**
 * @typedef {Object} PanIntoViewOptions
 * @property {PanOptions} [animation={}] The animation parameters for the pan
 * @property {number} [margin=20] The margin (in pixels) between the
 * overlay and the borders of the map when panning into view.
 */ /**
 * @enum {string}
 * @protected
 */ const $c80d3ed2a84f41ed$var$Property = {
    ELEMENT: "element",
    MAP: "map",
    OFFSET: "offset",
    POSITION: "position",
    POSITIONING: "positioning"
};
/**
 * @typedef {import("./ObjectEventType").Types|'change:element'|'change:map'|'change:offset'|'change:position'|
 *   'change:positioning'} OverlayObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<OverlayObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|OverlayObjectEventTypes, Return>} OverlayOnSignature
 */ /**
 * @classdesc
 * An element to be displayed over the map and attached to a single map
 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
 * visible widgets. Unlike Controls, they are not in a fixed position on the
 * screen, but are tied to a geographical coordinate, so panning the map will
 * move an Overlay but not a Control.
 *
 * Example:
 *
 *     import Overlay from 'ol/Overlay.js';
 *
 *     // ...
 *     const popup = new Overlay({
 *       element: document.getElementById('popup'),
 *     });
 *     popup.setPosition(coordinate);
 *     map.addOverlay(popup);
 *
 * @api
 */ class $c80d3ed2a84f41ed$var$Overlay extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Overlay options.
   */ constructor(options){
        super();
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {OverlayOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {Options}
     */ this.options = options;
        /**
     * @protected
     * @type {number|string|undefined}
     */ this.id = options.id;
        /**
     * @protected
     * @type {boolean}
     */ this.insertFirst = options.insertFirst !== undefined ? options.insertFirst : true;
        /**
     * @protected
     * @type {boolean}
     */ this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = document.createElement("div");
        this.element.className = options.className !== undefined ? options.className : "ol-overlay-container " + (0, $ce07df6d5d4656f1$export$99b49471b0394319);
        this.element.style.position = "absolute";
        this.element.style.pointerEvents = "auto";
        /**
     * @protected
     * @type {PanIntoViewOptions|undefined}
     */ this.autoPan = options.autoPan === true ? {} : options.autoPan || undefined;
        /**
     * @protected
     * @type {{transform_: string,
     *         visible: boolean}}
     */ this.rendered = {
            transform_: "",
            visible: true
        };
        /**
     * @protected
     * @type {?import("./events.js").EventsKey}
     */ this.mapPostrenderListenerKey = null;
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.ELEMENT, this.handleElementChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.MAP, this.handleMapChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.OFFSET, this.handleOffsetChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.POSITION, this.handlePositionChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.POSITIONING, this.handlePositioningChanged);
        if (options.element !== undefined) this.setElement(options.element);
        this.setOffset(options.offset !== undefined ? options.offset : [
            0,
            0
        ]);
        this.setPositioning(options.positioning || "top-left");
        if (options.position !== undefined) this.setPosition(options.position);
    }
    /**
   * Get the DOM element of this overlay.
   * @return {HTMLElement|undefined} The Element containing the overlay.
   * @observable
   * @api
   */ getElement() {
        return /** @type {HTMLElement|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.ELEMENT);
    }
    /**
   * Get the overlay identifier which is set on constructor.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id;
    }
    /**
   * Get the map associated with this overlay.
   * @return {import("./Map.js").default|null} The map that the
   * overlay is part of.
   * @observable
   * @api
   */ getMap() {
        return /** @type {import("./Map.js").default|null} */ this.get($c80d3ed2a84f41ed$var$Property.MAP) || null;
    }
    /**
   * Get the offset of this overlay.
   * @return {Array<number>} The offset.
   * @observable
   * @api
   */ getOffset() {
        return /** @type {Array<number>} */ this.get($c80d3ed2a84f41ed$var$Property.OFFSET);
    }
    /**
   * Get the current position of this overlay.
   * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
   *     anchored at.
   * @observable
   * @api
   */ getPosition() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.POSITION);
    }
    /**
   * Get the current positioning of this overlay.
   * @return {Positioning} How the overlay is positioned
   *     relative to its point on the map.
   * @observable
   * @api
   */ getPositioning() {
        return /** @type {Positioning} */ this.get($c80d3ed2a84f41ed$var$Property.POSITIONING);
    }
    /**
   * @protected
   */ handleElementChanged() {
        (0, $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1)(this.element);
        const element = this.getElement();
        if (element) this.element.appendChild(element);
    }
    /**
   * @protected
   */ handleMapChanged() {
        if (this.mapPostrenderListenerKey) {
            (0, $075f937d7366f1a2$export$1d0aa160432dfea5)(this.element);
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapPostrenderListenerKey);
            this.mapPostrenderListenerKey = null;
        }
        const map = this.getMap();
        if (map) {
            this.mapPostrenderListenerKey = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this.render, this);
            this.updatePixelPosition();
            const container = this.stopEvent ? map.getOverlayContainerStopEvent() : map.getOverlayContainer();
            if (this.insertFirst) container.insertBefore(this.element, container.childNodes[0] || null);
            else container.appendChild(this.element);
            this.performAutoPan();
        }
    }
    /**
   * @protected
   */ render() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handleOffsetChanged() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handlePositionChanged() {
        this.updatePixelPosition();
        this.performAutoPan();
    }
    /**
   * @protected
   */ handlePositioningChanged() {
        this.updatePixelPosition();
    }
    /**
   * Set the DOM element to be associated with this overlay.
   * @param {HTMLElement|undefined} element The Element containing the overlay.
   * @observable
   * @api
   */ setElement(element) {
        this.set($c80d3ed2a84f41ed$var$Property.ELEMENT, element);
    }
    /**
   * Set the map to be associated with this overlay.
   * @param {import("./Map.js").default|null} map The map that the
   * overlay is part of. Pass `null` to just remove the overlay from the current map.
   * @observable
   * @api
   */ setMap(map) {
        this.set($c80d3ed2a84f41ed$var$Property.MAP, map);
    }
    /**
   * Set the offset for this overlay.
   * @param {Array<number>} offset Offset.
   * @observable
   * @api
   */ setOffset(offset) {
        this.set($c80d3ed2a84f41ed$var$Property.OFFSET, offset);
    }
    /**
   * Set the position for this overlay. If the position is `undefined` the
   * overlay is hidden.
   * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
   *     is anchored at.
   * @observable
   * @api
   */ setPosition(position) {
        this.set($c80d3ed2a84f41ed$var$Property.POSITION, position);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary) using the configured autoPan parameters
   * @protected
   */ performAutoPan() {
        if (this.autoPan) this.panIntoView(this.autoPan);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary).
   * @param {PanIntoViewOptions} [panIntoViewOptions] Options for the pan action
   * @api
   */ panIntoView(panIntoViewOptions) {
        const map = this.getMap();
        if (!map || !map.getTargetElement() || !this.get($c80d3ed2a84f41ed$var$Property.POSITION)) return;
        const mapRect = this.getRect(map.getTargetElement(), map.getSize());
        const element = this.getElement();
        const overlayRect = this.getRect(element, [
            (0, $075f937d7366f1a2$export$e823f88e4111159a)(element),
            (0, $075f937d7366f1a2$export$fc5b8aac72846d1e)(element)
        ]);
        panIntoViewOptions = panIntoViewOptions || {};
        const myMargin = panIntoViewOptions.margin === undefined ? 20 : panIntoViewOptions.margin;
        if (!(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(mapRect, overlayRect)) {
            // the overlay is not completely inside the viewport, so pan the map
            const offsetLeft = overlayRect[0] - mapRect[0];
            const offsetRight = mapRect[2] - overlayRect[2];
            const offsetTop = overlayRect[1] - mapRect[1];
            const offsetBottom = mapRect[3] - overlayRect[3];
            const delta = [
                0,
                0
            ];
            if (offsetLeft < 0) // move map to the left
            delta[0] = offsetLeft - myMargin;
            else if (offsetRight < 0) // move map to the right
            delta[0] = Math.abs(offsetRight) + myMargin;
            if (offsetTop < 0) // move map up
            delta[1] = offsetTop - myMargin;
            else if (offsetBottom < 0) // move map down
            delta[1] = Math.abs(offsetBottom) + myMargin;
            if (delta[0] !== 0 || delta[1] !== 0) {
                const center = /** @type {import("./coordinate.js").Coordinate} */ map.getView().getCenterInternal();
                const centerPx = map.getPixelFromCoordinateInternal(center);
                if (!centerPx) return;
                const newCenterPx = [
                    centerPx[0] + delta[0],
                    centerPx[1] + delta[1]
                ];
                const panOptions = panIntoViewOptions.animation || {};
                map.getView().animateInternal({
                    center: map.getCoordinateFromPixelInternal(newCenterPx),
                    duration: panOptions.duration,
                    easing: panOptions.easing
                });
            }
        }
    }
    /**
   * Get the extent of an element relative to the document
   * @param {HTMLElement} element The element.
   * @param {import("./size.js").Size} size The size of the element.
   * @return {import("./extent.js").Extent} The extent.
   * @protected
   */ getRect(element, size) {
        const box = element.getBoundingClientRect();
        const offsetX = box.left + window.pageXOffset;
        const offsetY = box.top + window.pageYOffset;
        return [
            offsetX,
            offsetY,
            offsetX + size[0],
            offsetY + size[1]
        ];
    }
    /**
   * Set the positioning for this overlay.
   * @param {Positioning} positioning how the overlay is
   *     positioned relative to its point on the map.
   * @observable
   * @api
   */ setPositioning(positioning) {
        this.set($c80d3ed2a84f41ed$var$Property.POSITIONING, positioning);
    }
    /**
   * Modify the visibility of the element.
   * @param {boolean} visible Element visibility.
   * @protected
   */ setVisible(visible) {
        if (this.rendered.visible !== visible) {
            this.element.style.display = visible ? "" : "none";
            this.rendered.visible = visible;
        }
    }
    /**
   * Update pixel position.
   * @protected
   */ updatePixelPosition() {
        const map = this.getMap();
        const position = this.getPosition();
        if (!map || !map.isRendered() || !position) {
            this.setVisible(false);
            return;
        }
        const pixel = map.getPixelFromCoordinate(position);
        const mapSize = map.getSize();
        this.updateRenderedPosition(pixel, mapSize);
    }
    /**
   * @param {import("./pixel.js").Pixel} pixel The pixel location.
   * @param {import("./size.js").Size|undefined} mapSize The map size.
   * @protected
   */ updateRenderedPosition(pixel, mapSize) {
        const style = this.element.style;
        const offset = this.getOffset();
        const positioning = this.getPositioning();
        this.setVisible(true);
        const x = Math.round(pixel[0] + offset[0]) + "px";
        const y = Math.round(pixel[1] + offset[1]) + "px";
        let posX = "0%";
        let posY = "0%";
        if (positioning == "bottom-right" || positioning == "center-right" || positioning == "top-right") posX = "-100%";
        else if (positioning == "bottom-center" || positioning == "center-center" || positioning == "top-center") posX = "-50%";
        if (positioning == "bottom-left" || positioning == "bottom-center" || positioning == "bottom-right") posY = "-100%";
        else if (positioning == "center-left" || positioning == "center-center" || positioning == "center-right") posY = "-50%";
        const transform = `translate(${posX}, ${posY}) translate(${x}, ${y})`;
        if (this.rendered.transform_ != transform) {
            this.rendered.transform_ = transform;
            style.transform = transform;
        }
    }
    /**
   * returns the options this Overlay has been created with
   * @return {Options} overlay options
   */ getOptions() {
        return this.options;
    }
}
var $c80d3ed2a84f41ed$export$2e2bcd8739ae039 = $c80d3ed2a84f41ed$var$Overlay;



/**
 * @module ol/proj/proj4
 */ 


/**
 * @type {import("proj4")|null}
 */ let $2f5e3cce9f26ffcd$var$registered = null;
function $2f5e3cce9f26ffcd$export$bd9a8eae248cc953() {
    return !!$2f5e3cce9f26ffcd$var$registered;
}
function $2f5e3cce9f26ffcd$export$d07f55d4c15c0440() {
    $2f5e3cce9f26ffcd$var$registered = null;
}
function $2f5e3cce9f26ffcd$export$6503ec6e8aabbaf(proj4) {
    $2f5e3cce9f26ffcd$var$registered = proj4;
    const projCodes = Object.keys(proj4.defs);
    const len = projCodes.length;
    let i, j;
    for(i = 0; i < len; ++i){
        const code = projCodes[i];
        if (!(0, $9c4744460e43e41b$export$3988ae62b71be9a3)(code)) {
            const def = proj4.defs(code);
            let units = /** @type {import("./Units.js").Units} */ def.units;
            if (!units && def.projName === "longlat") units = "degrees";
            (0, $9c4744460e43e41b$export$59ae956cd3e343f7)(new (0, $6dc418afeec7068a$export$2e2bcd8739ae039)({
                code: code,
                axisOrientation: def.axis,
                metersPerUnit: def.to_meter,
                units: units
            }));
        }
    }
    for(i = 0; i < len; ++i){
        const code1 = projCodes[i];
        const proj1 = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(code1);
        for(j = 0; j < len; ++j){
            const code2 = projCodes[j];
            const proj2 = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(code2);
            if (!(0, $11b5dd198626e1de$export$3988ae62b71be9a3)(code1, code2)) {
                if (proj4.defs[code1] === proj4.defs[code2]) (0, $9c4744460e43e41b$export$eeb8392580a05a37)([
                    proj1,
                    proj2
                ]);
                else {
                    const transform = proj4(code1, code2);
                    (0, $9c4744460e43e41b$export$6b1c2e6623f4f49d)(proj1, proj2, (0, $9c4744460e43e41b$export$1873f9cfeb8bd1d6)(proj1, proj2, transform.forward), (0, $9c4744460e43e41b$export$1873f9cfeb8bd1d6)(proj2, proj1, transform.inverse));
                }
            }
        }
    }
}
/**
 * @param {number} code The EPSG code.
 * @return {Promise<string>} The proj4 definition.
 */ let $2f5e3cce9f26ffcd$var$epsgLookup = async function(code) {
    const response = await fetch(`https://epsg.io/${code}.proj4`);
    if (!response.ok) throw new Error(`Unexpected response from epsg.io: ${response.status}`);
    return response.text();
};
function $2f5e3cce9f26ffcd$export$a2ab1dacaf978878(func) {
    $2f5e3cce9f26ffcd$var$epsgLookup = func;
}
function $2f5e3cce9f26ffcd$export$740126bd4cc01b24() {
    return $2f5e3cce9f26ffcd$var$epsgLookup;
}
async function $2f5e3cce9f26ffcd$export$8d835cefe312e037(code) {
    if (typeof code === "string") code = parseInt(code.split(":").pop(), 10);
    const proj4 = $2f5e3cce9f26ffcd$var$registered;
    if (!proj4) throw new Error("Proj4 must be registered first with register(proj4)");
    const epsgCode = "EPSG:" + code;
    if (proj4.defs(epsgCode)) return (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(epsgCode);
    proj4.defs(epsgCode, await $2f5e3cce9f26ffcd$var$epsgLookup(code));
    $2f5e3cce9f26ffcd$export$6503ec6e8aabbaf(proj4);
    return (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(epsgCode);
}
function $2f5e3cce9f26ffcd$export$71e713433eeb8730(key) {
    return async function(code) {
        const response = await fetch(`https://api.maptiler.com/coordinates/search/code:${code}.json?transformations=true&exports=true&key=${key}`);
        if (!response.ok) throw new Error(`Unexpected response from maptiler.com: ${response.status}`);
        return response.json().then((json)=>{
            const results = json["results"];
            if (results?.length > 0) {
                const result = results.filter((r)=>r["id"]?.["authority"] === "EPSG" && r["id"]?.["code"] === code)[0];
                if (result) {
                    const transforms = result["transformations"];
                    if (transforms?.length > 0) {
                        // use default transform if it does not require grids
                        const defaultTransform = result["default_transformation"];
                        if (transforms.filter((t)=>t["id"]?.["authority"] === defaultTransform?.["authority"] && t["id"]?.["code"] === defaultTransform?.["code"] && t["grids"]?.length === 0).length > 0) return result["exports"]?.["proj4"];
                        // otherwise use most accurate alternative without grids
                        const transform = transforms.filter((t)=>t["grids"]?.length === 0 && t["target_crs"]?.["authority"] === "EPSG" && t["target_crs"]?.["code"] === 4326 && t["deprecated"] === false && t["usable"] === true).sort((t1, t2)=>t1["accuracy"] - t2["accuracy"])[0]?.["exports"]?.["proj4"];
                        if (transform) return transform;
                    }
                    // fallback to default
                    return result["exports"]?.["proj4"];
                }
            }
        });
    };
}



/**
 * @module ol/layer/Vector
 */ 
/**
 * @module ol/renderer/canvas/VectorLayer
 */ /**
 * @module ol/render/canvas/BuilderGroup
 */ /**
 * @module ol/render/canvas/Builder
 */ /**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ const $cf547866e052f25b$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
const $cf547866e052f25b$export$f21891651e408226 = [
    $cf547866e052f25b$var$Instruction.FILL
];
const $cf547866e052f25b$export$7a98aa5364d62ba8 = [
    $cf547866e052f25b$var$Instruction.STROKE
];
const $cf547866e052f25b$export$9f746cc58a899a00 = [
    $cf547866e052f25b$var$Instruction.BEGIN_PATH
];
const $cf547866e052f25b$export$89b10f327e413e71 = [
    $cf547866e052f25b$var$Instruction.CLOSE_PATH
];
var $cf547866e052f25b$export$2e2bcd8739ae039 = $cf547866e052f25b$var$Instruction;



/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ class $eb0e5c3938110b4c$var$VectorContext {
    /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {}
    /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ drawGeometry(geometry) {}
    /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ setStyle(style) {}
    /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {}
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */ drawFeature(feature, style, index) {}
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawGeometryCollection(geometryCollectionGeometry, feature, index) {}
    /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {}
    /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {}
    /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {}
    /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ setImageStyle(imageStyle, declutterImageWithText) {}
    /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ setTextStyle(textStyle, declutterImageWithText) {}
}
var $eb0e5c3938110b4c$export$2e2bcd8739ae039 = $eb0e5c3938110b4c$var$VectorContext;







class $2bb20f8873deb436$var$CanvasBuilder extends (0, $eb0e5c3938110b4c$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super();
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
    }
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ applyPixelRatio(dashArray) {
        const pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ appendFlatPointCoordinates(flatCoordinates, stride) {
        const extent = this.getBufferedMaxExtent();
        const tmpCoord = this.tmpCoordinate_;
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        const extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        let lastXCoord = flatCoordinates[offset];
        let lastYCoord = flatCoordinates[offset + 1];
        const nextCoord = this.tmpCoordinate_;
        let skipped = true;
        let i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $6da4c8ed3074c92b$export$f97905ead28c61a8)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {
        this.beginGeometry(geometry, feature, index);
        const type = geometry.getType();
        const stride = geometry.getStride();
        const builderBegin = this.coordinates.length;
        let flatCoordinates, builderEnd, builderEnds, builderEndss;
        let offset;
        switch(type){
            case "MultiPolygon":
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(let i = 0, ii = endss.length; i < ii; ++i){
                    const myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, $5454470599558ddd$export$915c7058aeb4dfeb),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $5454470599558ddd$export$915c7058aeb4dfeb),
                    index
                ]);
                break;
            case "Polygon":
            case "MultiLineString":
                builderEnds = [];
                flatCoordinates = type == "Polygon" ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, $5454470599558ddd$export$cbb9596fc0f40db2),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $5454470599558ddd$export$cbb9596fc0f40db2),
                    index
                ]);
                break;
            case "LineString":
            case "Circle":
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                    index
                ]);
                break;
            case "MultiPoint":
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                        index
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                        index
                    ]);
                }
                break;
            case "Point":
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    undefined,
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    undefined,
                    index
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    }
    /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */ beginGeometry(geometry, feature, index) {
        this.beginGeometryInstruction1_ = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    }
    /**
   * Reverse the hit detection instructions.
   */ reverseHitDetectionInstructions() {
        const hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        let i;
        const n = hitDetectionInstructions.length;
        let instruction;
        let type;
        let begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
            else if (type == (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $b998d41b678ed5d1$export$292cfa960964f0e0)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        const state = this.state;
        if (fillStyle) {
            const fillStyleColor = fillStyle.getColor();
            state.fillPatternScale = fillStyleColor && typeof fillStyleColor === "object" && "src" in fillStyleColor ? this.pixelRatio : 1;
            state.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2));
        } else state.fillStyle = undefined;
        if (strokeStyle) {
            const strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            const strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
            const strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76);
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
            const strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e);
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ createFill(state) {
        const fillStyle = state.fillStyle;
        /** @type {Array<*>} */ const fillInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== "string") // Fill is a pattern or gradient - align and scale it!
        fillInstruction.push(state.fillPatternScale);
        return fillInstruction;
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ createStroke(state) {
        return [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            this.applyPixelRatio(state.lineDash),
            state.lineDashOffset * this.pixelRatio
        ];
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ updateFillStyle(state, createFill) {
        const fillStyle = state.fillStyle;
        if (typeof fillStyle !== "string" || state.currentFillStyle != fillStyle) {
            if (fillStyle !== undefined) this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ updateStrokeStyle(state, applyStroke) {
        const strokeStyle = state.strokeStyle;
        const lineCap = state.lineCap;
        const lineDash = state.lineDash;
        const lineDashOffset = state.lineDashOffset;
        const lineJoin = state.lineJoin;
        const lineWidth = state.lineWidth;
        const miterLimit = state.miterLimit;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
            if (strokeStyle !== undefined) applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
        }
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ endGeometry(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        const endGeometryInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    }
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $6da4c8ed3074c92b$export$9cd59f9826255e47)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                const width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    }
}
var $2bb20f8873deb436$export$2e2bcd8739ae039 = $2bb20f8873deb436$var$CanvasBuilder;


/**
 * @module ol/render/canvas/ImageBuilder
 */ 


class $b652f9dd73b29cfe$var$CanvasImageBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {
        if (!this.image_ || this.maxExtent && !(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(this.maxExtent, pointGeometry.getFlatCoordinates())) return;
        this.beginGeometry(pointGeometry, feature, index);
        const flatCoordinates = pointGeometry.getFlatCoordinates();
        const stride = pointGeometry.getStride();
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature, index);
        const flatCoordinates = multiPointGeometry.getFlatCoordinates();
        const filteredFlatCoordinates = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += multiPointGeometry.getStride())if (!this.maxExtent || (0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(this.maxExtent, flatCoordinates.slice(i, i + 2))) filteredFlatCoordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(filteredFlatCoordinates, 2);
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return super.finish();
    }
    /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   */ setImageStyle(imageStyle, sharedData) {
        const anchor = imageStyle.getAnchor();
        const size = imageStyle.getSize();
        const origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $b652f9dd73b29cfe$export$2e2bcd8739ae039 = $b652f9dd73b29cfe$var$CanvasImageBuilder;


/**
 * @module ol/render/canvas/LineStringBuilder
 */ 


class $a207f23baa5aa2c5$var$CanvasLineStringBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */ drawFlatCoordinates_(flatCoordinates, offset, end, stride) {
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        const moveToLineToInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd
        ];
        this.instructions.push(moveToLineToInstruction);
        this.hitDetectionInstructions.push(moveToLineToInstruction);
        return end;
    }
    /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ], (0, $cf547866e052f25b$export$9f746cc58a899a00));
        const flatCoordinates = lineStringGeometry.getFlatCoordinates();
        const stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ], (0, $cf547866e052f25b$export$9f746cc58a899a00));
        const ends = multiLineStringGeometry.getEnds();
        const flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        const stride = multiLineStringGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        const state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return super.finish();
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        super.applyStroke(state);
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
    }
}
var $a207f23baa5aa2c5$export$2e2bcd8739ae039 = $a207f23baa5aa2c5$var$CanvasLineStringBuilder;


/**
 * @module ol/render/canvas/PolygonBuilder
 */ 



class $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawFlatCoordinatess_(flatCoordinates, offset, ends, stride) {
        const state = this.state;
        const fill = state.fillStyle !== undefined;
        const stroke = state.strokeStyle !== undefined;
        const numEnds = ends.length;
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
        for(let i = 0; i < numEnds; ++i){
            const end = ends[i];
            const myBegin = this.coordinates.length;
            const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            const moveToLineToInstruction = [
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd
            ];
            this.instructions.push(moveToLineToInstruction);
            this.hitDetectionInstructions.push(moveToLineToInstruction);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $cf547866e052f25b$export$89b10f327e413e71));
                this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$89b10f327e413e71));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $cf547866e052f25b$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$f21891651e408226));
        }
        if (stroke) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        }
        return offset;
    }
    /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ]);
        const flatCoordinates = circleGeometry.getFlatCoordinates();
        const stride = circleGeometry.getStride();
        const myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        const circleInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).CIRCLE,
            myBegin
        ];
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $cf547866e052f25b$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$f21891651e408226));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        }
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ]);
        const ends = polygonGeometry.getEnds();
        const flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        const stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ]);
        const endss = multiPolygonGeometry.getEndss();
        const flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        const stride = multiPolygonGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        const tolerance = this.tolerance;
        if (tolerance !== 0) {
            const coordinates = this.coordinates;
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $8780aae6970f5f65$export$51a0620f7a28532b)(coordinates[i], tolerance);
        }
        return super.finish();
    }
    /**
   * @private
   */ setFillStrokeStyles_() {
        const state = this.state;
        const fillStyle = state.fillStyle;
        if (fillStyle !== undefined) this.updateFillStyle(state, this.createFill);
        if (state.strokeStyle !== undefined) this.updateStrokeStyle(state, this.applyStroke);
    }
}
var $7d2e8ba11a45ae8a$export$2e2bcd8739ae039 = $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder;


/**
 * @module ol/render/canvas/TextBuilder
 */ 






function $7704cc1df2ddb619$export$f08272c6ff321e57(chunkLength, flatCoordinates, offset, end, stride) {
    const chunks = [];
    let cursor = offset;
    let chunkM = 0;
    let currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        const [x1, y1] = currentChunk.slice(-2);
        const x2 = flatCoordinates[cursor + stride];
        const y2 = flatCoordinates[cursor + stride + 1];
        const segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            const m = (chunkLength - chunkM + segmentLength) / segmentLength;
            const x = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, m);
            const y = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            const missing = segmentLength - chunkM;
            const x = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, missing / segmentLength);
            const y = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, missing / segmentLength);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}


/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $79529ab61b92f869$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    let chunkStart = offset;
    let chunkEnd = offset;
    let chunkM = 0;
    let m = 0;
    let start = offset;
    let acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}


const $8243e906fae47bbe$export$91a016276e4aee96 = {
    "left": 0,
    "center": 0.5,
    "right": 1,
    "top": 0,
    "middle": 0.5,
    "hanging": 0.2,
    "alphabetic": 0.8,
    "ideographic": 0.8,
    "bottom": 1
};
class $8243e906fae47bbe$var$CanvasTextBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ this.text_ = "";
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        this.fillStates[0, $d4aabc5c971073f1$export$c495d52ee3fd74b2] = {
            fillStyle: (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = "";
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = "";
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = "";
        /**
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        const instructions = super.finish();
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {
        const fillState = this.textFillState_;
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        if (this.text_ === "" || !textState || !fillState && !strokeState) return;
        const coordinates = this.coordinates;
        let begin = coordinates.length;
        const geometryType = geometry.getType();
        let flatCoordinates = null;
        let stride = geometry.getStride();
        if (textState.placement === "line" && (geometryType == "LineString" || geometryType == "MultiLineString" || geometryType == "Polygon" || geometryType == "MultiPolygon")) {
            if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.maxExtent, geometry.getExtent())) return;
            let ends;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == "LineString") ends = [
                flatCoordinates.length
            ];
            else if (geometryType == "MultiLineString") ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == "Polygon") ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == "MultiPolygon") {
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(let i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature, index);
            const repeat = textState.repeat;
            const textAlign = repeat ? undefined : textState.textAlign;
            // No `justify` support for line placement.
            let flatOffset = 0;
            for(let o = 0, oo = ends.length; o < oo; ++o){
                let chunks;
                if (repeat) chunks = (0, $7704cc1df2ddb619$export$f08272c6ff321e57)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                else chunks = [
                    flatCoordinates.slice(flatOffset, ends[o])
                ];
                for(let c = 0, cc = chunks.length; c < cc; ++c){
                    const chunk = chunks[c];
                    let chunkBegin = 0;
                    let chunkEnd = chunk.length;
                    if (textAlign == undefined) {
                        const range = (0, $79529ab61b92f869$export$ed6c897eea07a254)(textState.maxAngle, chunk, 0, chunk.length, 2);
                        chunkBegin = range[0];
                        chunkEnd = range[1];
                    }
                    for(let i = chunkBegin; i < chunkEnd; i += stride)coordinates.push(chunk[i], chunk[i + 1]);
                    const end = coordinates.length;
                    flatOffset = ends[o];
                    this.drawChars_(begin, end);
                    begin = end;
                }
            }
            this.endGeometry(feature);
        } else {
            let geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case "Point":
                case "MultiPoint":
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case "LineString":
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case "Circle":
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case "MultiLineString":
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case "Polygon":
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case "MultiPolygon":
                    const interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(let i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            const end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                let beg = begin / 2;
                geometryWidths = geometryWidths.filter((w, i)=>{
                    const keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg;
                    return keep;
                });
            }
            this.saveTextStates_();
            if (textState.backgroundFill || textState.backgroundStroke) {
                this.setFillStrokeStyle(textState.backgroundFill, textState.backgroundStroke);
                if (textState.backgroundFill) this.updateFillStyle(this.state, this.createFill);
                if (textState.backgroundStroke) {
                    this.updateStrokeStyle(this.state, this.applyStroke);
                    this.hitDetectionInstructions.push(this.createStroke(this.state));
                }
            }
            this.beginGeometry(geometry, feature, index);
            // adjust padding for negative scale
            let padding = textState.padding;
            if (padding != (0, $d4aabc5c971073f1$export$40a9eeef55665a40) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                let p0 = textState.padding[0];
                let p1 = textState.padding[1];
                let p2 = textState.padding[2];
                let p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            const pixelRatio = this.pixelRatio;
            this.instructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding == (0, $d4aabc5c971073f1$export$40a9eeef55665a40) ? (0, $d4aabc5c971073f1$export$40a9eeef55665a40) : padding.map(function(p) {
                    return p * pixelRatio;
                }),
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            const scale = 1 / pixelRatio;
            // Set default fill for hit detection background
            const currentFillStyle = this.state.fillStyle;
            if (textState.backgroundFill) {
                this.state.fillStyle = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
                this.hitDetectionInstructions.push(this.createFill(this.state));
            }
            this.hitDetectionInstructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding,
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_ ? (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2) : this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            // Reset previous fill
            if (textState.backgroundFill) {
                this.state.fillStyle = currentFillStyle;
                this.hitDetectionInstructions.push(this.createFill(this.state));
            }
            this.endGeometry(feature);
        }
    }
    /**
   * @private
   */ saveTextStates_() {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const fillState = this.textFillState_;
        const strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        const textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb),
            scale: textState.scale
        };
        const fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    }
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ drawChars_(begin, end) {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const strokeKey = this.strokeKey_;
        const textKey = this.textKey_;
        const fillKey = this.fillKey_;
        this.saveTextStates_();
        const pixelRatio = this.pixelRatio;
        const baseline = $8243e906fae47bbe$export$91a016276e4aee96[textState.textBaseline];
        const offsetY = this.textOffsetY_ * pixelRatio;
        const text = this.text_;
        const strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
            this.declutterMode_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey ? (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2) : fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1 / pixelRatio,
            this.declutterMode_
        ]);
    }
    /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   */ setTextStyle(textStyle, sharedData) {
        let textState, fillState, strokeState;
        if (!textStyle) this.text_ = "";
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2));
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                const lineDash = textStrokeStyle.getLineDash();
                const lineDashOffset = textStrokeStyle.getLineDashOffset();
                const lineWidth = textStrokeStyle.getWidth();
                const miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $d4aabc5c971073f1$export$e06efc2409049f76) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
                strokeState.lineWidth = lineWidth === undefined ? (0, $d4aabc5c971073f1$export$79661f132c62010e) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $d4aabc5c971073f1$export$80c1c01844597b7b) : miterLimit;
                strokeState.strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            }
            textState = this.textState_;
            const font = textStyle.getFont() || (0, $d4aabc5c971073f1$export$3847dfea4f8d4dfa);
            (0, $d4aabc5c971073f1$export$a534074a28fa87ff)(font);
            const textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.repeat = textStyle.getRepeat();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $d4aabc5c971073f1$export$40a9eeef55665a40);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || "";
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == "string" ? strokeState.strokeStyle : (0, $6c5e11070e371322$export$5e82334337e0f204)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + "|" + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + "[" + strokeState.lineDash.join() + "]" : "";
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || "?") + (textState.repeat || "?") + (textState.justify || "?") + (textState.textBaseline || "?");
            this.fillKey_ = fillState && fillState.fillStyle ? typeof fillState.fillStyle == "string" ? fillState.fillStyle : "|" + (0, $6c5e11070e371322$export$5e82334337e0f204)(fillState.fillStyle) : "";
        }
        this.declutterMode_ = textStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $8243e906fae47bbe$export$2e2bcd8739ae039 = $8243e906fae47bbe$var$CanvasTextBuilder;


/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ const $e22658f4b743550b$var$BATCH_CONSTRUCTORS = {
    "Circle": (0, $7d2e8ba11a45ae8a$export$2e2bcd8739ae039),
    "Default": (0, $2bb20f8873deb436$export$2e2bcd8739ae039),
    "Image": (0, $b652f9dd73b29cfe$export$2e2bcd8739ae039),
    "LineString": (0, $a207f23baa5aa2c5$export$2e2bcd8739ae039),
    "Polygon": (0, $7d2e8ba11a45ae8a$export$2e2bcd8739ae039),
    "Text": (0, $8243e906fae47bbe$export$2e2bcd8739ae039)
};
class $e22658f4b743550b$var$BuilderGroup {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ finish() {
        const builderInstructions = {};
        for(const zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            const builders = this.buildersByZIndex_[zKey];
            for(const builderKey in builders){
                const builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    }
    /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ getBuilder(zIndex, builderType) {
        const zIndexKey = zIndex !== undefined ? zIndex.toString() : "0";
        let replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        let replay = replays[builderType];
        if (replay === undefined) {
            const Constructor = $e22658f4b743550b$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    }
}
var $e22658f4b743550b$export$2e2bcd8739ae039 = $e22658f4b743550b$var$BuilderGroup;



/**
 * @module ol/render/canvas/ExecutorGroup
 */ /**
 * @module ol/render/canvas/Executor
 */ 





/**
 * @module ol/geom/flat/textpath
 */ 

function $f6421f31729929e6$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation) {
    let x2 = flatCoordinates[offset];
    let y2 = flatCoordinates[offset + 1];
    let x1 = 0;
    let y1 = 0;
    let segmentLength = 0;
    let segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    let interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    const beginX = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const beginY = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    const startOffset = offset - stride;
    const startLength = segmentM;
    const endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    const endX = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const endY = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    // Keep text upright
    let reverse;
    if (rotation) {
        const flat = [
            beginX,
            beginY,
            endX,
            endY
        ];
        (0, $14c6e714516e527b$export$bb628a54ab399bc9)(flat, 0, 4, 2, rotation, flat, flat);
        reverse = flat[0] > flat[2];
    } else reverse = beginX > endX;
    const PI = Math.PI;
    const result = [];
    const singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    let previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        const x = (endX + beginX) / 2;
        const y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, " "); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(let i = 0, ii = text.length; i < ii;){
        advance();
        let angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            let delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        const iStart = i;
        let charLength = 0;
        for(; i < ii; ++i){
            const index = reverse ? ii - i - 1 : i;
            const len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        const chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        const x = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
        const y = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}



/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    let length = 0;
    for(let i = offset + stride; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $bf04349d827c1d16$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    let perimeter = $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    const dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    const dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}



/**
 * @typedef {Object} BBox
 * @property {number} minX Minimal x.
 * @property {number} minY Minimal y.
 * @property {number} maxX Maximal x.
 * @property {number} maxY Maximal y
 * @property {*} value Value.
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {BBox} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D, 1: import('../../size.js').Size, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, import("../../style/Style.js").DeclutterMode): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ const $6526fa4ee42dc39d$var$tmpExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {BBox} Declutter bbox.
 */ function $6526fa4ee42dc39d$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
const $6526fa4ee42dc39d$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ "[" + String.fromCharCode(0x00591) + "-" + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + "-" + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + "-" + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + "-" + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + "-" + String.fromCharCode(0x1efff) + "]");
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function $6526fa4ee42dc39d$var$horizontalTextAlign(text, align) {
    if (align === "start") align = $6526fa4ee42dc39d$var$rtlRegEx.test(text) ? "right" : "left";
    else if (align === "end") align = $6526fa4ee42dc39d$var$rtlRegEx.test(text) ? "left" : "right";
    return (0, $8243e906fae47bbe$export$91a016276e4aee96)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $6526fa4ee42dc39d$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push("\n", "");
    acc.push(line, "");
    return acc;
}
class $6526fa4ee42dc39d$var$Executor {
    /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */ constructor(resolution, pixelRatio, overlaps, instructions, deferredRendering){
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {number}
     */ this.alignAndScaleFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
        /**
     * @private
     * @type {import("../canvas/ZIndexContext.js").default}
     */ this.zIndexContext_ = deferredRendering ? new (0, $c1cb593c98d2cbd0$export$2e2bcd8739ae039)() : null;
    }
    /**
   * @return {ZIndexContext} ZIndex context.
   */ getZIndexContext() {
        return this.zIndexContext_;
    }
    /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ createLabel(text, textKey, fillKey, strokeKey) {
        const key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        const strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        const fillState = fillKey ? this.fillStates[fillKey] : null;
        const textState = this.textStates[textKey];
        const pixelRatio = this.pixelRatio;
        const scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        const textIsArray = Array.isArray(text);
        const align = textState.justify ? (0, $8243e906fae47bbe$export$91a016276e4aee96)[textState.justify] : $6526fa4ee42dc39d$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766));
        const strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        const chunks = textIsArray ? text : text.split("\n").reduce($6526fa4ee42dc39d$var$createTextChunks, []);
        const { width: width, height: height, widths: widths, heights: heights, lineWidths: lineWidths } = (0, $d4aabc5c971073f1$export$7d7c13020df1e791)(textState, chunks);
        const renderWidth = width + strokeWidth;
        const contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        const w = (renderWidth + 2) * scale[0];
        const h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ const label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push("scale", scale);
        if (strokeKey) {
            contextInstructions.push("strokeStyle", strokeState.strokeStyle);
            contextInstructions.push("lineWidth", strokeWidth);
            contextInstructions.push("lineCap", strokeState.lineCap);
            contextInstructions.push("lineJoin", strokeState.lineJoin);
            contextInstructions.push("miterLimit", strokeState.miterLimit);
            contextInstructions.push("setLineDash", [
                strokeState.lineDash
            ]);
            contextInstructions.push("lineDashOffset", strokeState.lineDashOffset);
        }
        if (fillKey) contextInstructions.push("fillStyle", fillState.fillStyle);
        contextInstructions.push("textBaseline", "middle");
        contextInstructions.push("textAlign", "center");
        const leftRight = 0.5 - align;
        let x = align * renderWidth + leftRight * strokeWidth;
        const strokeInstructions = [];
        const fillInstructions = [];
        let lineHeight = 0;
        let lineOffset = 0;
        let widthHeightIndex = 0;
        let lineWidthIndex = 0;
        let previousFont;
        for(let i = 0, ii = chunks.length; i < ii; i += 2){
            const text = chunks[i];
            if (text === "\n") {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            const font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push("font", font);
                if (fillKey) fillInstructions.push("font", font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            const fillStrokeArgs = [
                text,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push("strokeText", fillStrokeArgs);
            if (fillKey) fillInstructions.push("fillText", fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignAndScaleFill_ = /** @type {number} */ fillInstruction[2];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    }
    /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        let x = centerX - anchorX;
        let y = centerY - anchorY;
        const w = width + originX > sheetWidth ? sheetWidth - originX : width;
        const h = height + originY > sheetHeight ? sheetHeight - originY : height;
        const boxW = padding[3] + w * scale[0] + padding[1];
        const boxH = padding[0] + h * scale[1] + padding[2];
        const boxX = x - padding[3];
        const boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $6526fa4ee42dc39d$var$p1[0] = boxX;
            $6526fa4ee42dc39d$var$p4[0] = boxX;
            $6526fa4ee42dc39d$var$p1[1] = boxY;
            $6526fa4ee42dc39d$var$p2[1] = boxY;
            $6526fa4ee42dc39d$var$p2[0] = boxX + boxW;
            $6526fa4ee42dc39d$var$p3[0] = $6526fa4ee42dc39d$var$p2[0];
            $6526fa4ee42dc39d$var$p3[1] = boxY + boxH;
            $6526fa4ee42dc39d$var$p4[1] = $6526fa4ee42dc39d$var$p3[1];
        }
        let transform;
        if (rotation !== 0) {
            transform = (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)((0, $e22e7611e69f42a9$export$185802fd694ee1f5)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p1);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p2);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p3);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p4);
            (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(Math.min($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.min($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), Math.max($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.max($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), $6526fa4ee42dc39d$var$tmpExtent);
        } else (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $6526fa4ee42dc39d$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $6526fa4ee42dc39d$var$tmpExtent[0],
                minY: $6526fa4ee42dc39d$var$tmpExtent[1],
                maxX: $6526fa4ee42dc39d$var$tmpExtent[2],
                maxY: $6526fa4ee42dc39d$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ replayImageOrLabel_(context, scaledCanvasSize, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        const fillStroke = !!(fillInstruction || strokeInstruction);
        const box = dimensions.declutterBox;
        const strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        const intersects = box.minX - strokePadding <= scaledCanvasSize[0] && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= scaledCanvasSize[1] && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $6526fa4ee42dc39d$var$p1, $6526fa4ee42dc39d$var$p2, $6526fa4ee42dc39d$var$p3, $6526fa4ee42dc39d$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   */ fill_(context) {
        const alignAndScale = this.alignAndScaleFill_;
        if (alignAndScale) {
            const origin = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                0,
                0
            ]);
            const repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            if (alignAndScale !== 1) context.scale(alignAndScale, alignAndScale);
            context.rotate(this.viewRotation_);
        }
        context.fill();
        if (alignAndScale) context.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        context.lineDashOffset = /** @type {number} */ instruction[7];
        context.setLineDash(/** @type {Array<number>} */ instruction[6]);
    }
    /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
        const textState = this.textStates[textKey];
        const label = this.createLabel(text, textKey, fillKey, strokeKey);
        const strokeState = this.strokeStates[strokeKey];
        const pixelRatio = this.pixelRatio;
        const align = $6526fa4ee42dc39d$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766));
        const baseline = (0, $8243e906fae47bbe$export$91a016276e4aee96)[textState.textBaseline || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb)];
        const strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        const width = label.width / pixelRatio - 2 * textState.scale[0];
        const anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        const anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ execute_(context, scaledCanvasSize, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
        const zIndexContext = this.zIndexContext_;
        /** @type {Array<number>} */ let pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $b998d41b678ed5d1$export$e9bab7fafb253603)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $e22e7611e69f42a9$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
        }
        let i = 0; // instruction index
        const ii = instructions.length; // end of instructions
        let d = 0; // data index
        let dd; // end of per-instruction data
        let anchorX, anchorY, /** @type {import('../../style/Style.js').DeclutterMode} */ declutterMode, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        let pendingFill = 0;
        let pendingStroke = 0;
        let lastFillInstruction = null;
        let lastStrokeInstruction = null;
        const coordinateCache = this.coordinateCache_;
        const viewRotation = this.viewRotation_;
        const viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        const state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        const batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        let /** @type {import("../../Feature.js").FeatureLike} */ feature;
        let x, y, currentGeometry;
        while(i < ii){
            const instruction = instructions[i];
            const type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (hitExtent !== undefined && !(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    if (zIndexContext) zIndexContext.zIndex = instruction[4];
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    const x1 = pixelCoordinates[d];
                    const y1 = pixelCoordinates[d + 1];
                    const x2 = pixelCoordinates[d + 2];
                    const y2 = pixelCoordinates[d + 3];
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    const geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    const renderer = instruction[4];
                    const fn = instruction[5];
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    const coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    if (zIndexContext) zIndexContext.zIndex = instruction[6];
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    let height = /** @type {number} */ instruction[6];
                    const opacity = /** @type {number} */ instruction[7];
                    const originX = /** @type {number} */ instruction[8];
                    const originY = /** @type {number} */ instruction[9];
                    const rotateWithView = /** @type {boolean} */ instruction[10];
                    let rotation = /** @type {number} */ instruction[11];
                    const scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    let width = /** @type {number} */ instruction[13];
                    declutterMode = instruction[14] || "declutter";
                    const declutterImageWithText = /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        const labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        const textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        const textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    let geometryWidths;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    let padding, backgroundFill, backgroundStroke;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFill = /** @type {boolean} */ instruction[17];
                        backgroundStroke = /** @type {boolean} */ instruction[18];
                    } else {
                        padding = (0, $d4aabc5c971073f1$export$40a9eeef55665a40);
                        backgroundFill = false;
                        backgroundStroke = false;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    let widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        const dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, backgroundFill || backgroundStroke, feature);
                        /** @type {ReplayImageOrLabelArgs} */ const args = [
                            context,
                            scaledCanvasSize,
                            image,
                            dimensions,
                            opacity,
                            backgroundFill ? /** @type {Array<*>} */ lastFillInstruction : null,
                            backgroundStroke ? /** @type {Array<*>} */ lastStrokeInstruction : null
                        ];
                        if (declutterTree) {
                            let imageArgs, imageDeclutterMode, imageDeclutterBox;
                            if (declutterImageWithText) {
                                const index = dd - d;
                                if (!declutterImageWithText[index]) {
                                    // We now have the image for an image+text combination.
                                    declutterImageWithText[index] = {
                                        args: args,
                                        declutterMode: declutterMode
                                    };
                                    continue;
                                }
                                const imageDeclutter = declutterImageWithText[index];
                                imageArgs = imageDeclutter.args;
                                imageDeclutterMode = imageDeclutter.declutterMode;
                                delete declutterImageWithText[index];
                                imageDeclutterBox = $6526fa4ee42dc39d$var$getDeclutterBox(imageArgs);
                            }
                            // We now have image and text for an image+text combination.
                            let renderImage, renderText;
                            if (imageArgs && (imageDeclutterMode !== "declutter" || !declutterTree.collides(imageDeclutterBox))) renderImage = true;
                            if (declutterMode !== "declutter" || !declutterTree.collides(dimensions.declutterBox)) renderText = true;
                            if (imageDeclutterMode === "declutter" && declutterMode === "declutter") {
                                const render = renderImage && renderText;
                                renderImage = render;
                                renderText = render;
                            }
                            if (renderImage) {
                                if (imageDeclutterMode !== "none") declutterTree.insert(imageDeclutterBox);
                                this.replayImageOrLabel_.apply(this, imageArgs);
                            }
                            if (renderText) {
                                if (declutterMode !== "none") declutterTree.insert(dimensions.declutterBox);
                                this.replayImageOrLabel_.apply(this, args);
                            }
                        } else this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS:
                    const begin = /** @type {number} */ instruction[1];
                    const end = /** @type {number} */ instruction[2];
                    const baseline = /** @type {number} */ instruction[3];
                    const overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    const maxAngle = /** @type {number} */ instruction[6];
                    const measurePixelRatio = /** @type {number} */ instruction[7];
                    const offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    const strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string} */ instruction[11];
                    textKey = /** @type {string} */ instruction[12];
                    const pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    declutterMode = instruction[14] || "declutter";
                    const textState = this.textStates[textKey];
                    const font = textState.font;
                    const textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    let cachedWidths;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    const pathLength = (0, $bf04349d827c1d16$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                    const textLength = Math.abs(textScale[0]) * (0, $d4aabc5c971073f1$export$915c7ba51467308f)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        const textAlign = this.textStates[textKey].textAlign;
                        const startM = (pathLength - textLength) * $6526fa4ee42dc39d$var$horizontalTextAlign(text, textAlign);
                        const parts = (0, $f6421f31729929e6$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $d4aabc5c971073f1$export$915c7ba51467308f), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ const replayImageOrLabelArgs = [];
                            let c, cc, chars, label, part;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, "", strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $d4aabc5c971073f1$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === "declutter" && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, "");
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $d4aabc5c971073f1$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === "declutter" && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (declutterTree && declutterMode !== "none") declutterTree.load(replayImageOrLabelArgs.map($6526fa4ee42dc39d$var$getDeclutterBox));
                            for(let i = 0, ii = replayImageOrLabelArgs.length; i < ii; ++i)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i]);
                        }
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        const result = featureCallback(feature, currentGeometry, declutterMode);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    context.moveTo(x, y);
                    prevX = x + 0.5 | 0;
                    prevY = y + 0.5 | 0;
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE:
                    lastFillInstruction = instruction;
                    this.alignAndScaleFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    /** @type {import("../../colorlike.js").ColorLike} */ context.fillStyle = instruction[1];
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                    lastStrokeInstruction = instruction;
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   */ execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, scaledCanvasSize, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, [
            context.canvas.width,
            context.canvas.height
        ], transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
    }
}
var $6526fa4ee42dc39d$export$2e2bcd8739ae039 = $6526fa4ee42dc39d$var$Executor;








const $a34a824d875e4ea1$export$61b49a5ae59d663 = [
    "Polygon",
    "Circle",
    "LineString",
    "Image",
    "Text",
    "Default"
];
const $a34a824d875e4ea1$export$6195a93a6c97ce02 = [
    "Image",
    "Text"
];
const $a34a824d875e4ea1$export$d0fe61ccfaa1ca87 = $a34a824d875e4ea1$export$61b49a5ae59d663.filter((builderType)=>!$a34a824d875e4ea1$export$6195a93a6c97ce02.includes(builderType));
class $a34a824d875e4ea1$var$ExecutorGroup {
    /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */ constructor(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer, deferredRendering){
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<string, import("./Executor").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.renderedContext_ = null;
        /**
     * @type {Object<number, Array<import("./ZIndexContext.js").default>>}
     */ this.deferredZIndexContexts_ = {};
        this.createExecutors_(allInstructions, deferredRendering);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ clip(context, transform) {
        const flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    }
    /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */ createExecutors_(allInstructions, deferredRendering) {
        for(const zIndex in allInstructions){
            let executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            const instructionByZindex = allInstructions[zIndex];
            for(const builderType in instructionByZindex){
                const instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $6526fa4ee42dc39d$export$2e2bcd8739ae039)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, deferredRendering);
            }
        }
    }
    /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ hasExecutors(executors) {
        for(const zIndex in this.executorsByZIndex_){
            const candidates = this.executorsByZIndex_[zIndex];
            for(let i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        hitTolerance = Math.round(hitTolerance);
        const contextSize = hitTolerance * 2 + 1;
        const transform = (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        const newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(contextSize, contextSize, undefined, {
            willReadFrequently: true
        });
        const context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /**
     * @type {import("../../extent.js").Extent}
     */ let hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(hitExtent, coordinate);
            (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        const indexes = $a34a824d875e4ea1$export$96fc84ea21b8269f(hitTolerance);
        let builderType;
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import('../../style/Style.js').DeclutterMode} declutterMode Declutter mode.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry, declutterMode) {
            const imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(let i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                if (!declutteredFeatures || declutterMode === "none" || builderType !== "Image" && builderType !== "Text" || declutteredFeatures.includes(feature)) {
                    const idx = (indexes[i] - 3) / 4;
                    const x = hitTolerance - idx % contextSize;
                    const y = hitTolerance - (idx / contextSize | 0);
                    const result = callback(feature, geometry, x * x + y * y);
                    if (result) return result;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        let i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            const zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $a34a824d875e4ea1$export$61b49a5ae59d663.length - 1; j >= 0; --j){
                builderType = $a34a824d875e4ea1$export$61b49a5ae59d663[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ getClipCoords(transform) {
        const maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        const minX = maxExtent[0];
        const minY = maxExtent[1];
        const maxX = maxExtent[2];
        const maxY = maxExtent[3];
        const flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.executorsByZIndex_);
    }
    /**
   * @param {CanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */ execute(targetContext, scaledCanvasSize, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        builderTypes = builderTypes ? builderTypes : $a34a824d875e4ea1$export$61b49a5ae59d663;
        const maxBuilderTypes = $a34a824d875e4ea1$export$61b49a5ae59d663.length;
        let i, ii, j, jj, replays;
        if (declutterTree) zs.reverse();
        for(i = 0, ii = zs.length; i < ii; ++i){
            const zIndexKey = zs[i].toString();
            replays = this.executorsByZIndex_[zIndexKey];
            for(j = 0, jj = builderTypes.length; j < jj; ++j){
                const builderType = builderTypes[j];
                const replay = replays[builderType];
                if (replay !== undefined) {
                    const zIndexContext = declutterTree === null ? undefined : replay.getZIndexContext();
                    const context = zIndexContext ? zIndexContext.getContext() : targetContext;
                    const requireClip = this.maxExtent_ && builderType !== "Image" && builderType !== "Text";
                    if (requireClip) {
                        context.save();
                        // setup clipping so that the parts of over-simplified geometries are not
                        // visible outside the current extent when panning
                        this.clip(context, transform);
                    }
                    if (!zIndexContext || builderType === "Text" || builderType === "Image") replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree);
                    else zIndexContext.pushFunction((context)=>replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree));
                    if (requireClip) context.restore();
                    if (zIndexContext) {
                        zIndexContext.offset();
                        const index = zs[i] * maxBuilderTypes + j;
                        if (!this.deferredZIndexContexts_[index]) this.deferredZIndexContexts_[index] = [];
                        this.deferredZIndexContexts_[index].push(zIndexContext);
                    }
                }
            }
        }
        this.renderedContext_ = targetContext;
    }
    getDeferredZIndexContexts() {
        return this.deferredZIndexContexts_;
    }
    getRenderedContext() {
        return this.renderedContext_;
    }
    renderDeferred() {
        const deferredZIndexContexts = this.deferredZIndexContexts_;
        const zs = Object.keys(deferredZIndexContexts).map(Number).sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        for(let i = 0, ii = zs.length; i < ii; ++i){
            deferredZIndexContexts[zs[i]].forEach((zIndexContext)=>{
                zIndexContext.draw(this.renderedContext_); // FIXME Pass clip to replay for temporarily enabling clip
                zIndexContext.clear();
            });
            deferredZIndexContexts[zs[i]].length = 0;
        }
    }
}
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ const $a34a824d875e4ea1$var$circlePixelIndexArrayCache = {};
function $a34a824d875e4ea1$export$96fc84ea21b8269f(radius) {
    if ($a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] !== undefined) return $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius];
    const size = radius * 2 + 1;
    const maxDistanceSq = radius * radius;
    const distances = new Array(maxDistanceSq + 1);
    for(let i = 0; i <= radius; ++i)for(let j = 0; j <= radius; ++j){
        const distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        let distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    const pixelIndex = [];
    for(let i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push(...distances[i]);
    $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $a34a824d875e4ea1$export$2e2bcd8739ae039 = $a34a824d875e4ea1$var$ExecutorGroup;




/**
 * @module ol/render/canvas/hitdetect
 */ /**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?









/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ class $7b0c2128a27f5020$var$CanvasImmediateRenderer extends (0, $eb0e5c3938110b4c$export$2e2bcd8739ae039) {
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */ constructor(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform){
        super();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.transformRotation_ = transform ? (0, $6b000a049d919fe5$export$a81f732198733497)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = "";
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        const pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        const localTransform = this.tmpLocalTransform_;
        const alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        let rotation = this.imageRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(let i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            const x = pixelCoordinates[i] - this.imageAnchorX_;
            const y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                const centerX = x + this.imageAnchorX_;
                const centerY = y + this.imageAnchorY_;
                (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.save();
                context.transform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.restore();
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === "") return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        const pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        let rotation = this.textRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            const x = pixelCoordinates[offset] + this.textOffsetX_;
            const y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                context.save();
                context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                context.rotate(rotation);
                context.translate(this.textOffsetX_, this.textOffsetY_);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.restore();
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */ moveToLineTo_(flatCoordinates, offset, end, stride, close) {
        const context = this.context_;
        const pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        let length = pixelCoordinates.length;
        if (close) length -= 2;
        for(let i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawRings_(flatCoordinates, offset, ends, stride) {
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
        return offset;
    }
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   */ drawCircle(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const pixelCoordinates = (0, $c76e993e57efc8c4$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
            const dx = pixelCoordinates[2] - pixelCoordinates[0];
            const dy = pixelCoordinates[3] - pixelCoordinates[1];
            const radius = Math.sqrt(dx * dx + dy * dy);
            const context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   */ setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ setTransform(transform) {
        this.transform_ = transform;
    }
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   */ drawGeometry(geometry) {
        const type = geometry.getType();
        switch(type){
            case "Point":
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case "LineString":
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case "Polygon":
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case "MultiPoint":
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case "MultiLineString":
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case "MultiPolygon":
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case "GeometryCollection":
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case "Circle":
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    }
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   */ drawFeature(feature, style) {
        const geometry = style.getGeometryFunction()(feature);
        if (!geometry) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    }
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   */ drawGeometryCollection(geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    }
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   */ drawPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== "") this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   */ drawMultiPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== "") this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   */ drawLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
            context.stroke();
        }
        if (this.text_ !== "") {
            const flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    }
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   */ drawMultiLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const geometryExtent = geometry.getExtent();
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            let offset = 0;
            const ends = /** @type {Array<number>} */ geometry.getEnds();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
            context.stroke();
        }
        if (this.text_ !== "") {
            const flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    }
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   */ drawPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride());
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") {
            const flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    }
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   */ drawMultiPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getOrientedFlatCoordinates();
            let offset = 0;
            const endss = geometry.getEndss();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = endss.length; i < ii; ++i){
                const ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") {
            const flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    }
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ setContextFillState_(fillState) {
        const context = this.context_;
        const contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ setContextStrokeState_(strokeState) {
        const context = this.context_;
        const contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            context.setLineDash(strokeState.lineDash);
            context.lineDashOffset = strokeState.lineDashOffset;
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (!(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
            if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    }
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ setContextTextState_(textState) {
        const context = this.context_;
        const contextTextState = this.contextTextState_;
        const textAlign = textState.textAlign ? textState.textAlign : (0, $d4aabc5c971073f1$export$94d53b95641b5766);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = textAlign;
            context.textBaseline = textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = textAlign;
                context.textAlign = textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = textState.textBaseline;
                context.textBaseline = textState.textBaseline;
            }
        }
    }
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            const fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            const strokeStyleColor = strokeStyle.getColor();
            const strokeStyleLineCap = strokeStyle.getLineCap();
            const strokeStyleLineDash = strokeStyle.getLineDash();
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            const strokeStyleWidth = strokeStyle.getWidth();
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            const lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map((n)=>n * this.pixelRatio_),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b),
                strokeStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e))
            };
        }
    }
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   */ setImageStyle(imageStyle) {
        let imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        const imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
        const imageAnchor = imageStyle.getAnchor();
        const imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
        this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
        this.imageHeight_ = imageSize[1] * imagePixelRatio;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        const imageScale = imageStyle.getScaleArray();
        this.imageScale_ = [
            imageScale[0] * this.pixelRatio_ / imagePixelRatio,
            imageScale[1] * this.pixelRatio_ / imagePixelRatio
        ];
        this.imageWidth_ = imageSize[0] * imagePixelRatio;
    }
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   */ setTextStyle(textStyle) {
        if (!textStyle) this.text_ = "";
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                const textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2))
                };
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                const textStrokeStyleColor = textStrokeStyle.getColor();
                const textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                const textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                const textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                const textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                const textStrokeStyleWidth = textStrokeStyle.getWidth();
                const textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b),
                    strokeStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e))
                };
            }
            const textFont = textStyle.getFont();
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            const textScale = textStyle.getScaleArray();
            const textText = textStyle.getText();
            const textTextAlign = textStyle.getTextAlign();
            const textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $d4aabc5c971073f1$export$3847dfea4f8d4dfa),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $d4aabc5c971073f1$export$94d53b95641b5766),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $d4aabc5c971073f1$export$cf2279a1bff62eb)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce((acc, t, i)=>acc += i % 2 ? " " : t, "") : textText : "";
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    }
}
var $7b0c2128a27f5020$export$2e2bcd8739ae039 = $7b0c2128a27f5020$var$CanvasImmediateRenderer;








const $13dfa0283bf5c35f$export$ab51038298418f25 = 0.5;
function $13dfa0283bf5c35f$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation, squaredTolerance, projection) {
    const userExtent = projection ? (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, projection) : extent;
    const width = size[0] * $13dfa0283bf5c35f$export$ab51038298418f25;
    const height = size[1] * $13dfa0283bf5c35f$export$ab51038298418f25;
    const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(width, height);
    context.imageSmoothingEnabled = false;
    const canvas = context.canvas;
    const renderer = new (0, $7b0c2128a27f5020$export$2e2bcd8739ae039)(context, $13dfa0283bf5c35f$export$ab51038298418f25, extent, null, rotation, squaredTolerance, projection ? (0, $9c4744460e43e41b$export$e3c4995a701c26a3)((0, $9c4744460e43e41b$export$3973b77d5f6f2790)(), projection) : null);
    const featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    const indexFactor = Math.floor(16777215 / featureCount);
    const featuresByZIndex = {};
    for(let i = 1; i <= featureCount; ++i){
        const feature = features[i - 1];
        const featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        let styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        const index = i * indexFactor;
        const color = index.toString(16).padStart(7, "#00000");
        for(let j = 0, jj = styles.length; j < jj; ++j){
            const originalStyle = styles[j];
            const geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(userExtent, geometry.getExtent())) continue;
            const style = originalStyle.clone();
            const fill = style.getFill();
            if (fill) fill.setColor(color);
            const stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            const image = originalStyle.getImage();
            if (image) {
                const imgSize = image.getImageSize();
                if (!imgSize) continue;
                const imgContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                const img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: "pixels",
                    anchorYUnits: "pixels",
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            const zIndex = style.getZIndex() || 0;
            let byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType["Polygon"] = [];
                byGeometryType["Circle"] = [];
                byGeometryType["LineString"] = [];
                byGeometryType["Point"] = [];
            }
            const type = geometry.getType();
            if (type === "GeometryCollection") {
                const geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(let i = 0, ii = geometries.length; i < ii; ++i){
                    const geometry = geometries[i];
                    byGeometryType[geometry.getType().replace("Multi", "")].push(geometry, style);
                }
            } else byGeometryType[type.replace("Multi", "")].push(geometry, style);
        }
    }
    const zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
    for(let i = 0, ii = zIndexKeys.length; i < ii; ++i){
        const byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(const type in byGeometryType){
            const geomAndStyle = byGeometryType[type];
            for(let j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(let k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $13dfa0283bf5c35f$export$6d4d555ddbfffa32(pixel, features, imageData) {
    /** @type {Array<F>} */ const resultFeatures = [];
    if (imageData) {
        const x = Math.floor(Math.round(pixel[0]) * $13dfa0283bf5c35f$export$ab51038298418f25);
        const y = Math.floor(Math.round(pixel[1]) * $13dfa0283bf5c35f$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        const index = ((0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(x, 0, imageData.width - 1) + (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(y, 0, imageData.height - 1) * imageData.width) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];
        const i = b + 256 * (g + 256 * r);
        const indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}




/**
 * @module ol/renderer/vector
 */ 

/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ const $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ const $4b9ac454600c05d2$var$GEOMETRY_RENDERERS = {
    "Point": $4b9ac454600c05d2$var$renderPointGeometry,
    "LineString": $4b9ac454600c05d2$var$renderLineStringGeometry,
    "Polygon": $4b9ac454600c05d2$var$renderPolygonGeometry,
    "MultiPoint": $4b9ac454600c05d2$var$renderMultiPointGeometry,
    "MultiLineString": $4b9ac454600c05d2$var$renderMultiLineStringGeometry,
    "MultiPolygon": $4b9ac454600c05d2$var$renderMultiPolygonGeometry,
    "GeometryCollection": $4b9ac454600c05d2$var$renderGeometryCollectionGeometry,
    "Circle": $4b9ac454600c05d2$var$renderCircleGeometry
};
function $4b9ac454600c05d2$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $6c5e11070e371322$export$5e82334337e0f204)(feature1), 10) - parseInt((0, $6c5e11070e371322$export$5e82334337e0f204)(feature2), 10);
}
function $4b9ac454600c05d2$export$75084a70d324c1e6(resolution, pixelRatio) {
    const tolerance = $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderCircleGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const circleReplay = builderGroup.getBuilder(style.getZIndex(), "Circle");
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $4b9ac454600c05d2$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, transform, declutter, index) {
    const loadingPromises = [];
    const imageStyle = style.getImage();
    if (imageStyle) {
        let loading = true;
        const imageState = imageStyle.getImageState();
        if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) loading = false;
        else if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) imageStyle.load();
        if (loading) loadingPromises.push(imageStyle.ready());
    }
    const fillStyle = style.getFill();
    if (fillStyle && fillStyle.loading()) loadingPromises.push(fillStyle.ready());
    const loading = loadingPromises.length > 0;
    if (loading) Promise.all(loadingPromises).then(()=>listener(null));
    $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 */ function $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index) {
    const geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    const simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    const renderer = style.getRenderer();
    if (renderer) $4b9ac454600c05d2$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature, index);
    else {
        const geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, index, declutter);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderGeometry(replayGroup, geometry, style, feature, index) {
    if (geometry.getType() == "GeometryCollection") {
        const geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(let i = 0, ii = geometries.length; i < ii; ++i)$4b9ac454600c05d2$var$renderGeometry(replayGroup, geometries[i], style, feature, index);
        return;
    }
    const replay = replayGroup.getBuilder(style.getZIndex(), "Default");
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer(), index);
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup, index) {
    const geometries = geometry.getGeometriesArray();
    let i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        const geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), "LineString");
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), "LineString");
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), "Polygon");
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4b9ac454600c05d2$var$renderPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && imageStyle && hasText ? {} : undefined;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), "Image");
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4b9ac454600c05d2$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const hasImage = imageStyle && imageStyle.getOpacity() !== 0;
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && hasImage && hasText ? {} : undefined;
    if (hasImage) {
        if (imageStyle.getImageState() != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), "Image");
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), "Polygon");
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}






/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ class $659e0e97392a5f5e$var$CanvasVectorLayerRenderer extends (0, $42152f52b26b6ca7$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */ constructor(vectorLayer){
        super(vectorLayer);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @type {boolean}
     */ this.animatingOrInteracting_;
        /**
     * @type {ImageData|null}
     */ this.hitDetectionImageData_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.clipped_ = false;
        /**
     * @private
     * @type {Array<import("../../Feature.js").default>}
     */ this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.wrappedRenderedExtent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate").Coordinate}
     */ this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection").default}
     */ this.renderedProjection_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedPixelRatio_ = 1;
        /**
     * @private
     * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.renderedFrameDeclutter_;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.targetContext_ = null;
        /**
     * @private
     * @type {number}
     */ this.opacity_ = 1;
    }
    /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */ renderWorlds(executorGroup, frameState, declutterable) {
        const extent = frameState.extent;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const projection = viewState.projection;
        const rotation = viewState.rotation;
        const projectionExtent = projection.getExtent();
        const vectorSource = this.getLayer().getSource();
        const declutter = this.getLayer().getDeclutter();
        const pixelRatio = frameState.pixelRatio;
        const viewHints = frameState.viewHints;
        const snapToPixel = !(viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING]);
        const context = this.context;
        const width = Math.round((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / resolution * pixelRatio);
        const multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        const worldWidth = multiWorld ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent) : null;
        const endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1 : 1;
        let world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) : 0;
        do {
            let transform = this.getRenderTransform(center, resolution, 0, pixelRatio, width, height, world * worldWidth);
            if (frameState.declutter) transform = transform.slice(0);
            executorGroup.execute(context, [
                context.canvas.width,
                context.canvas.height
            ], transform, rotation, snapToPixel, declutterable === undefined ? (0, $a34a824d875e4ea1$export$61b49a5ae59d663) : declutterable ? (0, $a34a824d875e4ea1$export$6195a93a6c97ce02) : (0, $a34a824d875e4ea1$export$d0fe61ccfaa1ca87), declutterable ? declutter && frameState.declutter[declutter] : undefined);
        }while (++world < endWorld);
    }
    /**
   * @private
   */ setDrawContext_() {
        if (this.opacity_ !== 1) {
            this.targetContext_ = this.context;
            this.context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(this.context.canvas.width, this.context.canvas.height, (0, $42152f52b26b6ca7$export$a166f0857c555517));
        }
    }
    /**
   * @private
   */ resetDrawContext_() {
        if (this.opacity_ !== 1) {
            const alpha = this.targetContext_.globalAlpha;
            this.targetContext_.globalAlpha = this.opacity_;
            this.targetContext_.drawImage(this.context.canvas, 0, 0);
            this.targetContext_.globalAlpha = alpha;
            (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(this.context);
            (0, $42152f52b26b6ca7$export$a166f0857c555517).push(this.context.canvas);
            this.context = this.targetContext_;
            this.targetContext_ = null;
        }
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeclutter(frameState) {
        if (!this.replayGroup_ || !this.getLayer().getDeclutter()) return;
        this.renderWorlds(this.replayGroup_, frameState, true);
    }
    /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {
        if (!this.replayGroup_) return;
        this.replayGroup_.renderDeferred();
        if (this.clipped_) this.context.restore();
        this.resetDrawContext_();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        this.opacity_ = layerState.opacity;
        const viewState = frameState.viewState;
        this.prepareContainer(frameState, target);
        const context = this.context;
        const replayGroup = this.replayGroup_;
        let render = replayGroup && !replayGroup.isEmpty();
        if (!render) {
            const hasRenderListeners = this.getLayer().hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRERENDER) || this.getLayer().hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER);
            if (!hasRenderListeners) return null;
        }
        this.setDrawContext_();
        this.preRender(context, frameState);
        const projection = viewState.projection;
        // clipped rendering if layer extent is set
        this.clipped_ = false;
        if (render && layerState.extent && this.clipping) {
            const layerExtent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection);
            render = (0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            this.clipped_ = render && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (this.clipped_) this.clipUnrotated(context, frameState, layerExtent);
        }
        if (render) this.renderWorlds(replayGroup, frameState, this.getLayer().getDeclutter() ? false : undefined);
        if (!frameState.declutter && this.clipped_) context.restore();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        if (!frameState.declutter) this.resetDrawContext_();
        return this.container;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise
   * that resolves with an array of features.
   */ getFeatures(pixel) {
        return new Promise((resolve)=>{
            if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                const size = this.frameState.size.slice();
                const center = this.renderedCenter_;
                const resolution = this.renderedResolution_;
                const rotation = this.renderedRotation_;
                const projection = this.renderedProjection_;
                const extent = this.wrappedRenderedExtent_;
                const layer = this.getLayer();
                const transforms = [];
                const width = size[0] * (0, $13dfa0283bf5c35f$export$ab51038298418f25);
                const height = size[1] * (0, $13dfa0283bf5c35f$export$ab51038298418f25);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $13dfa0283bf5c35f$export$ab51038298418f25), width, height, 0).slice());
                const source = layer.getSource();
                const projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(projectionExtent, extent)) {
                    let startX = extent[0];
                    const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
                    let world = 0;
                    let offsetX;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $13dfa0283bf5c35f$export$ab51038298418f25), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $13dfa0283bf5c35f$export$ab51038298418f25), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                this.hitDetectionImageData_ = (0, $13dfa0283bf5c35f$export$bd05e394339d469)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation, (0, $4b9ac454600c05d2$export$75084a70d324c1e6)(resolution, this.renderedPixelRatio_), userProjection ? projection : null);
            }
            resolve((0, $13dfa0283bf5c35f$export$6d4d555ddbfffa32)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        });
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        if (!this.replayGroup_) return undefined;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            const key = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        let result;
        const executorGroups = [
            this.replayGroup_
        ];
        const declutter = this.getLayer().getDeclutter();
        executorGroups.some((executorGroup)=>{
            return result = executorGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutter && frameState.declutter[declutter] ? frameState.declutter[declutter].all().map((item)=>item.value) : null);
        });
        return result;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        const vectorLayer = this.getLayer();
        const vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        const animating = frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING];
        const interacting = frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING];
        const updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        const updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        const frameStateExtent = frameState.extent;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const resolution = viewState.resolution;
        const pixelRatio = frameState.pixelRatio;
        const vectorLayerRevision = vectorLayer.getRevision();
        const vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        let vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $4b9ac454600c05d2$export$531ddd8416d52dfc);
        const center = viewState.center.slice();
        const extent = (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        const renderedExtent = extent.slice();
        const loadExtents = [
            extent.slice()
        ];
        const projectionExtent = projection.getExtent();
        if (vectorSource.getWrapX() && projection.canWrapX() && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(projectionExtent, frameState.extent)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
            const gutter = Math.max((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / 2, worldWidth);
            extent[0] = projectionExtent[0] - gutter;
            extent[2] = projectionExtent[2] + gutter;
            (0, $1bd0a226f9a16141$export$39a9ce3624977b84)(center, projection);
            const loadExtent = (0, $6da4c8ed3074c92b$export$39a9ce3624977b84)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && this.renderedFrameDeclutter_ === !!frameState.declutter && (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        const replayGroup = new (0, $e22658f4b743550b$export$2e2bcd8739ae039)((0, $4b9ac454600c05d2$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        let userTransform;
        if (userProjection) {
            for(let i = 0, ii = loadExtents.length; i < ii; ++i){
                const extent = loadExtents[i];
                const userExtent = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, projection);
                vectorSource.loadFeatures(userExtent, (0, $9c4744460e43e41b$export$b56bb8ad8b3a00e9)(resolution, projection), userProjection);
            }
            userTransform = (0, $9c4744460e43e41b$export$e3c4995a701c26a3)(userProjection, projection);
        } else for(let i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        const squaredTolerance = (0, $4b9ac454600c05d2$export$75084a70d324c1e6)(resolution, pixelRatio);
        let ready = true;
        const render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */ (feature, index)=>{
            let styles;
            const styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                const dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, this.getLayer().getDeclutter(), index);
                ready = ready && !dirty;
            }
        };
        const userExtent = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ const features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(let i = 0, ii = features.length; i < ii; ++i)render(features[i], i);
        this.renderedFeatures_ = features;
        this.ready = ready;
        const replayGroupInstructions = replayGroup.finish();
        const executorGroup = new (0, $a34a824d875e4ea1$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer(), !!frameState.declutter);
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedFrameDeclutter_ = !!frameState.declutter;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.renderedPixelRatio_ = pixelRatio;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    }
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, transform, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $4b9ac454600c05d2$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index) || loading;
        else loading = (0, $4b9ac454600c05d2$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index);
        return loading;
    }
}
var $659e0e97392a5f5e$export$2e2bcd8739ae039 = $659e0e97392a5f5e$var$CanvasVectorLayerRenderer;


/**
 * @template {import('../Feature.js').FeatureLike} FeatureType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {import("../source/Vector.js").default<FeatureType>} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import('../Feature.js').FeatureLike} FeatureType
 * @extends {BaseVectorLayer<import("../source/Vector.js").default<FeatureType>, CanvasVectorLayerRenderer>}
 * @api
 */ class $82a68515bd6ef378$var$VectorLayer extends (0, $c8d6dc4c09ed9916$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        super(options);
    }
    createRenderer() {
        return new (0, $659e0e97392a5f5e$export$2e2bcd8739ae039)(this);
    }
}
var $82a68515bd6ef378$export$2e2bcd8739ae039 = $82a68515bd6ef378$var$VectorLayer;


/**
 * @module ol/source/Vector
 */ 




/**
 * @module ol/structs/RBush
 */ 



/**
 * @typedef {Object} Entry
 * @property {number} minX MinX.
 * @property {number} minY MinY.
 * @property {number} maxX MaxX.
 * @property {number} maxY MaxY.
 * @property {Object} [value] Value.
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template T
 */ class $34c742891733e7a4$var$RBush {
    /**
   * @param {number} [maxEntries] Max entries.
   */ constructor(maxEntries){
        /**
     * @private
     */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($176ca75ee9f69668$exports)))(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry>}
     */ this.items_ = {};
    }
    /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ insert(extent, value) {
        /** @type {Entry} */ const item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)] = item;
    }
    /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ load(extents, values) {
        const items = new Array(values.length);
        for(let i = 0, l = values.length; i < l; i++){
            const extent = extents[i];
            const value = values[i];
            /** @type {Entry} */ const item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)] = item;
        }
        this.rbush_.load(items);
    }
    /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ remove(value) {
        const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        const item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    }
    /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ update(extent, value) {
        const item = this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)];
        const bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    }
    /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ getAll() {
        const items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ getInExtent(extent) {
        /** @type {Entry} */ const bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        const items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): *} callback Callback.
   * @return {*} Callback return value.
   */ forEach(callback) {
        return this.forEach_(this.getAll(), callback);
    }
    /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): *} callback Callback.
   * @return {*} Callback return value.
   */ forEachInExtent(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    }
    /**
   * @param {Array<T>} values Values.
   * @param {function(T): *} callback Callback.
   * @private
   * @return {*} Callback return value.
   */ forEach_(values, callback) {
        let result;
        for(let i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.items_);
    }
    /**
   * Remove all values from the RBush.
   */ clear() {
        this.rbush_.clear();
        this.items_ = {};
    }
    /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ getExtent(extent) {
        const data = this.rbush_.toJSON();
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(data.minX, data.minY, data.maxX, data.maxY, extent);
    }
    /**
   * @param {RBush} rbush R-Tree.
   */ concat(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(const i in rbush.items_)this.items_[i] = rbush.items_[i];
    }
}
var $34c742891733e7a4$export$2e2bcd8739ae039 = $34c742891733e7a4$var$RBush;


/**
 * @module ol/render/Feature
 */ /**
 * @module ol/Feature
 */ 



/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @typedef {Object<string, *> & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 */ class $9fd014ab6df63665$var$Feature extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Geometry|ObjectWithGeometry<Geometry>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */ constructor(geometryOrProperties){
        super();
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = "geometry";
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === "function") {
                const geometry = /** @type {Geometry} */ geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {Object<string, *>} */ const properties = geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ clone() {
        const clone = /** @type {Feature<Geometry>} */ new $9fd014ab6df63665$var$Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        const geometry = this.getGeometry();
        if (geometry) clone.setGeometry(/** @type {Geometry} */ geometry.clone());
        const style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    }
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ getGeometry() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ getGeometryName() {
        return this.geometryName_;
    }
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @private
   */ handleGeometryChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        const geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(geometry, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    }
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    }
    /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : $9fd014ab6df63665$export$bb06ddfd5d66e02e(style);
        this.changed();
    }
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setId(id) {
        this.id_ = id;
        this.changed();
    }
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ setGeometryName(name) {
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    }
}
function $9fd014ab6df63665$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === "function") return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ let styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === "function", "Expected an `ol/style/Style` or an array of `ol/style/Style.js`");
        const style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
var $9fd014ab6df63665$export$2e2bcd8739ae039 = $9fd014ab6df63665$var$Feature;


/**
 * @module ol/geom/MultiPoint
 */ 






/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ class $e6080c63a9451eda$var$MultiPoint extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        if (layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ appendPoint(point) {
        (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   */ clone() {
        const multiPoint = new $e6080c63a9451eda$var$MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(let j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ getPoint(index) {
        const n = this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    }
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ getPoints() {
        const flatCoordinates = this.flatCoordinates;
        const layout = this.layout;
        const stride = this.stride;
        /** @type {Array<Point>} */ const points = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const point = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "MultiPoint";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            if ((0, $6da4c8ed3074c92b$export$805bdfd6d6690e97)(extent, x, y)) return true;
        }
        return false;
    }
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $e6080c63a9451eda$export$2e2bcd8739ae039 = $e6080c63a9451eda$var$MultiPoint;

/**
 * @module ol/geom/LineString
 */ 







/**
 * @module ol/geom/flat/interpolate
 */ 

function $43ed5485a1d0c509$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    let o, t;
    const n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        let x1 = flatCoordinates[offset];
        let y1 = flatCoordinates[offset + 1];
        let length = 0;
        const cumulativeLengths = [
            0
        ];
        for(let i = offset + stride; i < end; i += stride){
            const x2 = flatCoordinates[i];
            const y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        const target = fraction * length;
        const index = (0, $b998d41b678ed5d1$export$2e0ae67339d5f1ac)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(let i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    let coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    let lo = offset / stride;
    let hi = end / stride;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    const m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    const m1 = flatCoordinates[(lo + 1) * stride - 1];
    const t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(let i = 0; i < stride - 1; ++i)coordinate.push((0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $43ed5485a1d0c509$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    let coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}




/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ class $292e4002746c8223$var$LineString extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ appendCoordinate(coordinate) {
        (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, coordinate);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   */ clone() {
        const lineString = new $292e4002746c8223$var$LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ forEachSegment(callback) {
        return (0, $3e64078bffae1cbd$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate) {
        if (this.layout != "XYM" && this.layout != "XYZM") return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        return (0, $43ed5485a1d0c509$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    }
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ getCoordinateAt(fraction, dest) {
        return (0, $43ed5485a1d0c509$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
    }
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        return (0, $bf04349d827c1d16$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_ ?? undefined);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatMidpoint_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $292e4002746c8223$var$LineString(simplifiedFlatCoordinates, "XY");
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "LineString";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $292e4002746c8223$export$2e2bcd8739ae039 = $292e4002746c8223$var$LineString;

/**
 * @module ol/geom/MultiLineString
 */ 









/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ class $b4c0e2e13beea46e$var$MultiLineString extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else {
            const lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const ends = [];
            for(let i = 0, ii = lineStrings.length; i < ii; ++i){
                const lineString = lineStrings[i];
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            const layout = lineStrings.length === 0 ? this.getLayout() : lineStrings[0].getLayout();
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ appendLineString(lineString) {
        (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   */ clone() {
        const multiLineString = new $b4c0e2e13beea46e$var$MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate, interpolate) {
        if (this.layout != "XYM" && this.layout != "XYZM" || this.flatCoordinates.length === 0) return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        interpolate = interpolate !== undefined ? interpolate : false;
        return (0, $43ed5485a1d0c509$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    }
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $292e4002746c8223$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ getLineStrings() {
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const layout = this.layout;
        /** @type {Array<LineString>} */ const lineStrings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const lineString = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        /** @type {Array<number>} */ const midpoints = [];
        const flatCoordinates = this.flatCoordinates;
        let offset = 0;
        const ends = this.ends_;
        const stride = this.stride;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const midpoint = (0, $43ed5485a1d0c509$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $b4c0e2e13beea46e$var$MultiLineString(simplifiedFlatCoordinates, "XY", simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "MultiLineString";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $b4c0e2e13beea46e$export$2e2bcd8739ae039 = $b4c0e2e13beea46e$var$MultiLineString;

/**
 * @module ol/geom/MultiPolygon
 */ 











/**
 * @module ol/geom/flat/center
 */ 
function $9825fadaf3b68c4e$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    const flatCenters = [];
    let extent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        extent = (0, $6da4c8ed3074c92b$export$be0ab0bf96ca59ca)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}




/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ class $f73f35eb6af8b987$var$MultiPolygon extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */ constructor(coordinates, layout, endss){
        super();
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            const polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const thisEndss = [];
            for(let i = 0, ii = polygons.length; i < ii; ++i){
                const polygon = polygons[i];
                const offset = flatCoordinates.length;
                const ends = polygon.getEnds();
                for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
    }
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ appendPolygon(polygon) {
        /** @type {Array<number>} */ let ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            const offset = this.flatCoordinates.length;
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   */ clone() {
        const len = this.endss_.length;
        const newEndss = new Array(len);
        for(let i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        const multiPolygon = new $f73f35eb6af8b987$var$MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$37c18e6e7d50501a)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$60e067685eb8f9c4)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return (0, $239aa88e7a573859$export$c760d9d16cf92043)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    }
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $01ff26a2f986a1d0$export$78e139679ca7205)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $7892dc06ffd23218$export$ea9ed55fc2a85010)(flatCoordinates, 0, this.endss_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $5454470599558ddd$export$915c7058aeb4dfeb)(flatCoordinates, 0, this.endss_, this.stride);
    }
    /**
   * @return {Array<Array<number>>} Endss.
   */ getEndss() {
        return this.endss_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            const flatCenters = (0, $9825fadaf3b68c4e$export$78e139679ca7205)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $2166f19777f69377$export$11463803eda8a372)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatInteriorPoints_;
    }
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoints() {
        return new (0, $e6080c63a9451eda$export$2e2bcd8739ae039)(this.getFlatInteriorPoints().slice(), "XYM");
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $7892dc06ffd23218$export$a1d138f4bd85f4b4)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $7892dc06ffd23218$export$ea9ed55fc2a85010)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<Array<number>>} */ const simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$b9acf67ef05cd17c)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new $f73f35eb6af8b987$var$MultiPolygon(simplifiedFlatCoordinates, "XY", simplifiedEndss);
    }
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        let offset;
        if (index === 0) offset = 0;
        else {
            const prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        const ends = this.endss_[index].slice();
        const end = ends[ends.length - 1];
        if (offset !== 0) for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    }
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ getPolygons() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const endss = this.endss_;
        const polygons = [];
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i].slice();
            const end = ends[ends.length - 1];
            if (offset !== 0) for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            const polygon = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "MultiPolygon";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$77b72fa3792f5bf0)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const endss = (0, $6b086aa46281540d$export$f9f2bb59da4accd3)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            const lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    }
}
var $f73f35eb6af8b987$export$2e2bcd8739ae039 = $f73f35eb6af8b987$var$MultiPolygon;













/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $36d6c36c1f9ad5d9$var$tmpTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ class $36d6c36c1f9ad5d9$var$RenderFeature {
    /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */ constructor(type, flatCoordinates, ends, stride, properties, id){
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.ends_ = ends || null;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ get(key) {
        return this.properties_[key];
    }
    /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        if (!this.extent_) this.extent_ = this.type_ === "Point" ? (0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(this.flatCoordinates_) : (0, $6da4c8ed3074c92b$export$be0ab0bf96ca59ca)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
        return this.extent_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoint() {
        if (!this.flatInteriorPoints_) {
            const flatCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoints_ = (0, $2166f19777f69377$export$50e3b25928a5e892)(this.flatCoordinates_, 0, this.ends_, 2, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (!this.flatInteriorPoints_) {
            const ends = (0, $7892dc06ffd23218$export$cb72ae403d6e78e6)(this.flatCoordinates_, this.ends_);
            const flatCenters = (0, $9825fadaf3b68c4e$export$78e139679ca7205)(this.flatCoordinates_, 0, ends, 2);
            this.flatInteriorPoints_ = (0, $2166f19777f69377$export$11463803eda8a372)(this.flatCoordinates_, 0, ends, 2, flatCenters);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (!this.flatMidpoints_) this.flatMidpoints_ = (0, $43ed5485a1d0c509$export$687ff82efd78795b)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
        return this.flatMidpoints_;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            const flatCoordinates = this.flatCoordinates_;
            let offset = 0;
            const ends = /** @type {Array<number>} */ this.ends_;
            for(let i = 0, ii = ends.length; i < ii; ++i){
                const end = ends[i];
                const midpoint = (0, $43ed5485a1d0c509$export$687ff82efd78795b)(flatCoordinates, offset, end, 2, 0.5);
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getOrientedFlatCoordinates() {
        return this.flatCoordinates_;
    }
    /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ getGeometry() {
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return this;
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this;
    }
    /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ getProperties() {
        return this.properties_;
    }
    /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.properties_;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride_;
    }
    /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ getStyleFunction() {
        return this.styleFunction;
    }
    /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ getType() {
        return this.type_;
    }
    /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ transform(projection) {
        projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
        const pixelExtent = projection.getExtent();
        const projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            const scale = (0, $6da4c8ed3074c92b$export$c08559766941f856)(projectedExtent) / (0, $6da4c8ed3074c92b$export$c08559766941f856)(pixelExtent);
            (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)($36d6c36c1f9ad5d9$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $14c6e714516e527b$export$b92b2dedcfff79de)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, $36d6c36c1f9ad5d9$var$tmpTransform, this.flatCoordinates_);
        }
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ applyTransform(transformFn) {
        transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
    }
    /**
   * @return {RenderFeature} A cloned render feature.
   */ clone() {
        return new $36d6c36c1f9ad5d9$var$RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_?.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
    }
    /**
   * @return {Array<number>|null} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ enableSimplifyTransformed() {
        this.simplifyTransformed = (0, $013a1733c226ec50$export$ff83df6f9971435f)((squaredTolerance, transform)=>{
            if (squaredTolerance === this.squaredTolerance_) return this.simplifiedGeometry_;
            this.simplifiedGeometry_ = this.clone();
            if (transform) this.simplifiedGeometry_.applyTransform(transform);
            const simplifiedFlatCoordinates = this.simplifiedGeometry_.getFlatCoordinates();
            let simplifiedEnds;
            switch(this.type_){
                case "LineString":
                    simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.flatCoordinates_.length, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                    simplifiedEnds = [
                        simplifiedFlatCoordinates.length
                    ];
                    break;
                case "MultiLineString":
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$cedb9900c0b225c2)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                case "Polygon":
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$60a9904b67f8d51b)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                default:
            }
            if (simplifiedEnds) this.simplifiedGeometry_ = new $36d6c36c1f9ad5d9$var$RenderFeature(this.type_, simplifiedFlatCoordinates, simplifiedEnds, 2, this.properties_, this.id_);
            this.squaredTolerance_ = squaredTolerance;
            return this.simplifiedGeometry_;
        });
        return this;
    }
}
/**
 * @return {Array<number>} Flat coordinates.
 */ $36d6c36c1f9ad5d9$var$RenderFeature.prototype.getFlatCoordinates = $36d6c36c1f9ad5d9$var$RenderFeature.prototype.getOrientedFlatCoordinates;
function $36d6c36c1f9ad5d9$export$b89ab3d1d30dec84(renderFeature) {
    const geometryType = renderFeature.getType();
    switch(geometryType){
        case "Point":
            return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates());
        case "MultiPoint":
            return new (0, $e6080c63a9451eda$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), "XY");
        case "LineString":
            return new (0, $292e4002746c8223$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), "XY");
        case "MultiLineString":
            return new (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), "XY", /** @type {Array<number>} */ renderFeature.getEnds());
        case "Polygon":
            const flatCoordinates = renderFeature.getFlatCoordinates();
            const ends = renderFeature.getEnds();
            const endss = (0, $7892dc06ffd23218$export$cb72ae403d6e78e6)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)(flatCoordinates, "XY", endss) : new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(flatCoordinates, "XY", ends);
        default:
            throw new Error("Invalid geometry type:" + geometryType);
    }
}
function $36d6c36c1f9ad5d9$export$ab19ba60efd1c4b5(renderFeature, geometryName) {
    const id = renderFeature.getId();
    const geometry = $36d6c36c1f9ad5d9$export$b89ab3d1d30dec84(renderFeature);
    const properties = renderFeature.getProperties();
    const feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
var $36d6c36c1f9ad5d9$export$2e2bcd8739ae039 = $36d6c36c1f9ad5d9$var$RenderFeature;



/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $ccc4e6f11f11978f$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: "addfeature",
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: "changefeature",
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: "clear",
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: "removefeature",
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: "featuresloadstart",
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: "featuresloadend",
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: "featuresloaderror"
};



/**
 * @module ol/loadingstrategy
 */ 
function $eb51d0a16123ee90$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $eb51d0a16123ee90$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $eb51d0a16123ee90$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        const z = tileGrid.getZForResolution((0, $9c4744460e43e41b$export$bd1cd3b88140b906)(resolution, projection));
        const tileRange = tileGrid.getTileRangeForExtentAndZ((0, $9c4744460e43e41b$export$494be3a3a25689ca)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ const extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ const tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $9c4744460e43e41b$export$96bfd09e2cffb006)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}








/**
 * @module ol/featureloader
 */ 
/**
 *
 * @type {boolean}
 * @private
 */ let $588823c001569193$var$withCredentials = false;
function $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", typeof url === "function" ? url(extent, resolution, projection) : url, true);
    if (format.getType() == "arraybuffer") xhr.responseType = "arraybuffer";
    xhr.withCredentials = $588823c001569193$var$withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            try {
                /** @type {Document|Node|Object|string|undefined} */ let source;
                if (type == "text" || type == "json") source = xhr.responseText;
                else if (type == "xml") source = xhr.responseXML || xhr.responseText;
                else if (type == "arraybuffer") source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success(/** @type {Array<FeatureType>} */ format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection
                }), format.readProjection(source));
                else failure();
            } catch  {
                failure();
            }
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function $588823c001569193$export$14cc81df70b6707e(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<FeatureType>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   */ return function(extent, resolution, projection, success, failure) {
        const source = /** @type {import("./source/Vector").default<FeatureType>} */ this;
        $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ function(features, dataProjection) {
            source.addFeatures(features);
            if (success !== undefined) success(features);
        }, /* FIXME handle error */ failure ? failure : (0, $013a1733c226ec50$export$1cd1943b3a73bbe8));
    };
}
function $588823c001569193$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $588823c001569193$var$withCredentials = xhrWithCredentials;
}


class $84888e4daf3fdf44$export$d402fd02dc2b661c extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {FeatureClass} [feature] Feature.
   * @param {Array<FeatureClass>} [features] Features.
   */ constructor(type, feature, features){
        super(type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureClass|undefined}
     * @api
     */ this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureClass>|undefined}
     * @api
     */ this.features = features;
    }
}
/***
 * @template {import("../Feature.js").FeatureLike} [T=import("../Feature.js").default]
 * @typedef {T extends RenderFeature ? T|Array<T> : T} FeatureClassOrArrayOfRenderFeatures
 */ /***
 * @template Return
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent<FeatureType>, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} FeatureType
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureType>|Collection<FeatureType>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default<import("../format/Feature.js").FeatureToFeatureClass<FeatureType>>} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader<FeatureType>} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      const proj = projection.getCode();
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      const xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      const onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          const features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox,
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ class $84888e4daf3fdf44$var$VectorSource extends (0, $ed6dc99f268f3882$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: "ready",
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader<FeatureType>}
     */ this.loader_ = (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
        /**
     * @private
     * @type {import("../format/Feature.js").default<import('../format/Feature.js').FeatureToFeatureClass<FeatureType>>|undefined}
     */ this.format_ = options.format;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.format_, "`format` must be set when `url` is set");
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, $588823c001569193$export$14cc81df70b6707e)(this.url_, this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $eb51d0a16123ee90$export$84bf76cd7afc7469);
        const useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureType>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, $34c742891733e7a4$export$2e2bcd8739ae039)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, $34c742891733e7a4$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ this.loadingExtentsCount_ = 0;
        /**
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import('../Feature.js').FeatureLike|Array<import('../Feature.js').FeatureLike>>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureType>|null}
     */ this.featuresCollection_ = null;
        /** @type {Collection<FeatureType>} */ let collection;
        /** @type {Array<FeatureType>} */ let features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if an {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */ addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    }
    /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */ addFeatureInternal(feature) {
        const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, feature));
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */ setupChangeEvents_(featureKey, feature) {
        if (feature instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)) return;
        this.featureChangeKeys_[featureKey] = [
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(feature, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this),
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(feature, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ addToIndex_(featureKey, feature) {
        let valid = true;
        if (feature.getId() !== undefined) {
            const id = String(feature.getId());
            if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
            else if (feature instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)) {
                const indexedFeature = this.idIndex_[id];
                if (!(indexedFeature instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039))) valid = false;
                else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                    indexedFeature,
                    feature
                ];
                else indexedFeature.push(feature);
            } else valid = false;
        }
        if (valid) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(!(featureKey in this.uidIndex_), "The passed `feature` was already added to the source");
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    }
    /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */ addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    }
    /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */ addFeaturesInternal(features) {
        const extents = [];
        /** @type {Array<FeatureType>} */ const newFeatures = [];
        /** @type Array<FeatureType> */ const geometryFeatures = [];
        for(let i = 0, length = features.length; i < length; i++){
            const feature = features[i];
            const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(let i = 0, length = newFeatures.length; i < length; i++){
            const feature = newFeatures[i];
            const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            this.setupChangeEvents_(featureKey, feature);
            const geometry = feature.getGeometry();
            if (geometry) {
                const extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE)) for(let i = 0, length = newFeatures.length; i < length; i++)this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i]));
    }
    /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */ bindFeaturesCollection_(collection) {
        let modifyingCollection = false;
        this.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(evt.element);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(evt.element);
                modifyingCollection = false;
            }
        });
        this.featuresCollection_ = collection;
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ clear(fast) {
        if (fast) {
            for(const featureId in this.featureChangeKeys_){
                const keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            const removeAndIgnoreReturn = (feature)=>{
                this.removeFeatureInternal(feature);
            };
            this.featuresRtree_.forEach(removeAndIgnoreReturn);
            for(const id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        const clearEvent = new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    }
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ forEachFeatureAtCoordinateDirect(coordinate, callback) {
        const extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
            return undefined;
        });
    }
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039) || geometry.intersectsExtent(extent)) {
                const result = callback(feature);
                if (result) return result;
            }
        });
    }
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with an {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */ getFeaturesCollection() {
        return this.featuresCollection_;
    }
    /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        let features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_)) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(features, Object.values(this.nullGeometryFeatures_));
        }
        return features;
    }
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */ getFeaturesAtCoordinate(coordinate) {
        const features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    }
    /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent, projection) {
        if (this.featuresRtree_) {
            const multiWorld = projection && projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            const extents = (0, $6da4c8ed3074c92b$export$9031237f01de0947)(extent, projection);
            return [].concat(...extents.map((anExtent)=>this.featuresRtree_.getInExtent(anExtent)));
        }
        if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        return [];
    }
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType} Closest feature.
   * @api
   */ getClosestFeatureToCoordinate(coordinate, filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        const x = coordinate[0];
        const y = coordinate[1];
        let closestFeature = null;
        const closestPoint = [
            NaN,
            NaN
        ];
        let minSquaredDistance = Infinity;
        const extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        filter = filter ? filter : (0, $013a1733c226ec50$export$22e23a2304399231);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                const geometry = feature.getGeometry();
                const previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    const minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    }
    /**
   * Get the extent of the features currently in the source.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent(extent) {
        return this.featuresRtree_.getExtent(extent);
    }
    /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */ getFeatureById(id) {
        const feature = this.idIndex_[id.toString()];
        return feature !== undefined ? /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */ feature : null;
    }
    /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */ getFeatureByUid(uid) {
        const feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    }
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<import('../format/Feature.js').FeatureToFeatureClass<FeatureType>>|undefined} The feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * @param {Event} event Event.
   * @private
   */ handleFeatureChange_(event) {
        const feature = /** @type {FeatureType} */ event.target;
        const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        const geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            const extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        const id = feature.getId();
        if (id !== undefined) {
            const sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
    }
    /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ hasFeature(feature) {
        const id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        return (0, $6c5e11070e371322$export$5e82334337e0f204)(feature) in this.uidIndex_;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ loadFeatures(extent, resolution, projection) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const extentsToLoad = this.strategy_(extent, resolution, projection);
        for(let i = 0, ii = extentsToLoad.length; i < ii; ++i){
            const extentToLoad = extentsToLoad[i];
            const alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                ++this.loadingExtentsCount_;
                this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADSTART));
                this.loader_.call(this, extentToLoad, resolution, projection, (features)=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADEND, undefined, features));
                }, ()=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADERROR));
                });
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        }
        this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
    }
    refresh() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        super.refresh();
    }
    /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ removeLoadedExtent(extent) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        let obj;
        loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(object.extent, extent)) {
                obj = object;
                return true;
            }
        });
        if (obj) loadedExtentsRtree.remove(obj);
    }
    /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */ removeFeatures(features) {
        const removedFeatures = [];
        for(let i = 0, ii = features.length; i < ii; ++i){
            const feature = features[i];
            const removedFeature = this.removeFeatureInternal(feature);
            if (removedFeature) removedFeatures.push(removedFeature);
        }
        if (removedFeatures.length > 0) this.changed();
    }
    /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */ removeFeature(feature) {
        if (!feature) return;
        const result = this.removeFeatureInternal(feature);
        if (result) this.changed();
    }
    /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {FeatureType|undefined} The removed feature
   *     (or undefined if the feature was not found).
   * @protected
   */ removeFeatureInternal(feature) {
        const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        if (!(featureKey in this.uidIndex_)) return;
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        const featureChangeKeys = this.featureChangeKeys_[featureKey];
        featureChangeKeys?.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        delete this.featureChangeKeys_[featureKey];
        const id = feature.getId();
        if (id !== undefined) {
            const idString = id.toString();
            const indexedFeature = this.idIndex_[idString];
            if (indexedFeature === feature) delete this.idIndex_[idString];
            else if (Array.isArray(indexedFeature)) {
                indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                if (indexedFeature.length === 1) this.idIndex_[idString] = indexedFeature[0];
            }
        }
        delete this.uidIndex_[featureKey];
        if (this.hasListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE)) this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
        return feature;
    }
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @return {boolean} Removed the feature from the index.
   * @private
   */ removeFromIdIndex_(feature) {
        let removed = false;
        for(const id in this.idIndex_){
            const indexedFeature = this.idIndex_[id];
            if (feature instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039) && Array.isArray(indexedFeature) && indexedFeature.includes(feature)) indexedFeature.splice(indexedFeature.indexOf(feature), 1);
            else if (this.idIndex_[id] === feature) {
                delete this.idIndex_[id];
                removed = true;
                break;
            }
        }
        return removed;
    }
    /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader<FeatureType>} loader The loader to set.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
    /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ setUrl(url) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(this.format_, "`format` must be set when `url` is set");
        this.url_ = url;
        this.setLoader((0, $588823c001569193$export$14cc81df70b6707e)(url, this.format_));
    }
}
var $84888e4daf3fdf44$export$2e2bcd8739ae039 = $84888e4daf3fdf44$var$VectorSource;


/**
 * @module ol/format/GeoJSON
 */ 
/**
 * @module ol/format/JSONFeature
 */ /**
 * @module ol/format/Feature
 */ 

/**
 * @module ol/geom/GeometryCollection
 */ 



/**
 * @classdesc
 * An array of {@link module:ol/geom/Geometry~Geometry} objects.
 *
 * @api
 */ class $0e4f3959219eede5$var$GeometryCollection extends (0, $50db89a00eb954f6$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ constructor(geometries){
        super();
        /**
     * @private
     * @type {Array<Geometry>}
     */ this.geometries_ = geometries;
        /**
     * @type {Array<import("../events.js").EventsKey>}
     */ this.changeEventsKeys_ = [];
        this.listenGeometriesChange_();
    }
    /**
   * @private
   */ unlistenGeometriesChange_() {
        this.changeEventsKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.changeEventsKeys_.length = 0;
    }
    /**
   * @private
   */ listenGeometriesChange_() {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.changeEventsKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(geometries[i], (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.changed, this));
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!GeometryCollection} Clone.
   * @api
   */ clone() {
        const geometryCollection = new $0e4f3959219eede5$var$GeometryCollection($0e4f3959219eede5$var$cloneGeometries(this.geometries_));
        geometryCollection.applyProperties(this);
        return geometryCollection;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)minSquaredDistance = geometries[i].closestPointXY(x, y, closestPoint, minSquaredDistance);
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].containsXY(x, y)) return true;
        }
        return false;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(extent);
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)(0, $6da4c8ed3074c92b$export$8b58be045bf06082)(extent, geometries[i].getExtent());
        return extent;
    }
    /**
   * Return the geometries that make up this geometry collection.
   * @return {Array<Geometry>} Geometries.
   * @api
   */ getGeometries() {
        return $0e4f3959219eede5$var$cloneGeometries(this.geometries_);
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArray() {
        return this.geometries_;
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArrayRecursive() {
        /** @type {Array<Geometry>} */ let geometriesArray = [];
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)if (geometries[i].getType() === this.getType()) geometriesArray = geometriesArray.concat(/** @type {GeometryCollection} */ geometries[i].getGeometriesArrayRecursive());
        else geometriesArray.push(geometries[i]);
        return geometriesArray;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {GeometryCollection} Simplified GeometryCollection.
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometries = [];
        const geometries = this.geometries_;
        let simplified = false;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            const geometry = geometries[i];
            const simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
            simplifiedGeometries.push(simplifiedGeometry);
            if (simplifiedGeometry !== geometry) simplified = true;
        }
        if (simplified) {
            const simplifiedGeometryCollection = new $0e4f3959219eede5$var$GeometryCollection(simplifiedGeometries);
            return simplifiedGeometryCollection;
        }
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "GeometryCollection";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].intersectsExtent(extent)) return true;
        }
        return false;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.geometries_.length === 0;
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].rotate(angle, anchor);
        this.changed();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        if (!anchor) anchor = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].scale(sx, sy, anchor);
        this.changed();
    }
    /**
   * Set the geometries that make up this geometry collection.
   * @param {Array<Geometry>} geometries Geometries.
   * @api
   */ setGeometries(geometries) {
        this.setGeometriesArray($0e4f3959219eede5$var$cloneGeometries(geometries));
    }
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ setGeometriesArray(geometries) {
        this.unlistenGeometriesChange_();
        this.geometries_ = geometries;
        this.listenGeometriesChange_();
        this.changed();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   */ applyTransform(transformFn) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].applyTransform(transformFn);
        this.changed();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].translate(deltaX, deltaY);
        this.changed();
    }
    /**
   * Clean up.
   */ disposeInternal() {
        this.unlistenGeometriesChange_();
        super.disposeInternal();
    }
}
/**
 * @param {Array<Geometry>} geometries Geometries.
 * @return {Array<Geometry>} Cloned geometries.
 */ function $0e4f3959219eede5$var$cloneGeometries(geometries) {
    return geometries.map((geometry)=>geometry.clone());
}
var $0e4f3959219eede5$export$2e2bcd8739ae039 = $0e4f3959219eede5$var$GeometryCollection;





/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @typedef {'arraybuffer' | 'json' | 'text' | 'xml'} Type
 */ /**
 * @typedef {Object} SimpleGeometryObject
 * @property {import('../geom/Geometry.js').Type} type Type.
 * @property {Array<number>} flatCoordinates Flat coordinates.
 * @property {Array<number>|Array<Array<number>>} [ends] Ends or endss.
 * @property {import('../geom/Geometry.js').GeometryLayout} [layout] Layout.
 */ /**
 * @typedef {Array<GeometryObject>} GeometryCollectionObject
 */ /**
 * @typedef {SimpleGeometryObject|GeometryCollectionObject} GeometryObject
 */ /**
 * @typedef {Object} FeatureObject
 * @property {string|number} [id] Id.
 * @property {GeometryObject} [geometry] Geometry.
 * @property {Object<string, *>} [properties] Properties.
 */ /***
 * @template {Feature|RenderFeature} T
 * @typedef {T extends RenderFeature ? typeof RenderFeature : typeof Feature} FeatureToFeatureClass
 */ /***
 * @template {import("../Feature.js").FeatureClass} T
 * @typedef {T[keyof T] extends RenderFeature ? RenderFeature : Feature} FeatureClassToFeature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @template {import('../Feature.js').FeatureClass} [T=typeof import('../Feature.js').default]
 * @abstract
 * @api
 */ class $ec084d0ff9c13a22$var$FeatureFormat {
    constructor(){
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.dataProjection = undefined;
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.defaultFeatureProjection = undefined;
        /**
     * @protected
     * @type {T}
     */ this.featureClass = /** @type {T} */ (0, $9fd014ab6df63665$export$2e2bcd8739ae039);
        /**
     * A list media types supported by the format in descending order of preference.
     * @type {Array<string>}
     */ this.supportedMediaTypes = null;
    }
    /**
   * Adds the data projection to the read options.
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Options.
   * @return {ReadOptions|undefined} Options.
   * @protected
   */ getReadOptions(source, options) {
        if (options) {
            let dataProjection = options.dataProjection ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection) : this.readProjection(source);
            if (options.extent && dataProjection && dataProjection.getUnits() === "tile-pixels") {
                dataProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(dataProjection);
                dataProjection.setWorldExtent(options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: options.featureProjection
            };
        }
        return this.adaptOptions(options);
    }
    /**
   * Sets the `dataProjection` on the options, if no `dataProjection`
   * is set.
   * @param {WriteOptions|ReadOptions|undefined} options
   *     Options.
   * @protected
   * @return {WriteOptions|ReadOptions|undefined}
   *     Updated options.
   */ adaptOptions(options) {
        return Object.assign({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection,
            featureClass: this.featureClass
        }, options);
    }
    /**
   * @abstract
   * @return {Type} The format type.
   */ getType() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read a single feature from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../Feature.js").FeatureLike|Array<import("../render/Feature.js").default>} Feature.
   */ readFeature(source, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read all features from a source.
   *
   * @abstract
   * @param {Document|Element|ArrayBuffer|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {Array<import('../Feature.js').FeatureLike|FeatureClassToFeature<T>>} Features.
   */ readFeatures(source, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read a single geometry from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometry(source, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjection(source) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature in this format.
   *
   * @abstract
   * @param {Feature} feature Feature.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeature(feature, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features in this format.
   *
   * @abstract
   * @param {Array<Feature>} features Features.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeatures(features, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Write a single geometry in this format.
   *
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeGeometry(geometry, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
}
var $ec084d0ff9c13a22$export$2e2bcd8739ae039 = $ec084d0ff9c13a22$var$FeatureFormat;
function $ec084d0ff9c13a22$export$7beeea566b560d4(geometry, write, options) {
    const featureProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection) : null;
    let transformed = geometry;
    if (featureProjection && dataProjection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(featureProjection, dataProjection)) {
        if (write) transformed = /** @type {T} */ geometry.clone();
        const fromProjection = write ? featureProjection : dataProjection;
        const toProjection = write ? dataProjection : featureProjection;
        if (fromProjection.getUnits() === "tile-pixels") transformed.transform(fromProjection, toProjection);
        else transformed.applyTransform((0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(fromProjection, toProjection));
    }
    if (write && options && /** @type {WriteOptions} */ options.decimals !== undefined) {
        const power = Math.pow(10, /** @type {WriteOptions} */ options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
     * @param {Array<number>} coordinates Coordinates.
     * @return {Array<number>} Transformed coordinates.
     */ const transform = function(coordinates) {
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power) / power;
            return coordinates;
        };
        if (transformed === geometry) transformed = /** @type {T} */ geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}
function $ec084d0ff9c13a22$export$d3e9e4b1c7f2405c(extent, options) {
    const featureProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection) : null;
    if (featureProjection && dataProjection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(featureProjection, dataProjection)) return (0, $9c4744460e43e41b$export$751c68e0e0efff79)(extent, dataProjection, featureProjection);
    return extent;
}
const $ec084d0ff9c13a22$var$GeometryConstructor = {
    Point: (0, $6eced4c969949f6b$export$2e2bcd8739ae039),
    LineString: (0, $292e4002746c8223$export$2e2bcd8739ae039),
    Polygon: (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039),
    MultiPoint: (0, $e6080c63a9451eda$export$2e2bcd8739ae039),
    MultiLineString: (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039),
    MultiPolygon: (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)
};
function $ec084d0ff9c13a22$var$orientFlatCoordinates(flatCoordinates, ends, stride) {
    if (Array.isArray(ends[0])) {
        // MultiPolagon
        if (!(0, $7892dc06ffd23218$export$a1d138f4bd85f4b4)(flatCoordinates, 0, ends, stride)) {
            flatCoordinates = flatCoordinates.slice();
            (0, $7892dc06ffd23218$export$ea9ed55fc2a85010)(flatCoordinates, 0, ends, stride);
        }
        return flatCoordinates;
    }
    if (!(0, $7892dc06ffd23218$export$f27cd06e85f4ba28)(flatCoordinates, 0, ends, stride)) {
        flatCoordinates = flatCoordinates.slice();
        (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(flatCoordinates, 0, ends, stride);
    }
    return flatCoordinates;
}
function $ec084d0ff9c13a22$export$f935e77582b330a(object, options) {
    const geometry = object.geometry;
    if (!geometry) return [];
    if (Array.isArray(geometry)) return geometry.map((geometry)=>$ec084d0ff9c13a22$export$f935e77582b330a({
            ...object,
            geometry: geometry
        })).flat();
    const geometryType = geometry.type === "MultiPolygon" ? "Polygon" : geometry.type;
    if (geometryType === "GeometryCollection" || geometryType === "Circle") throw new Error("Unsupported geometry type: " + geometryType);
    const stride = geometry.layout.length;
    return $ec084d0ff9c13a22$export$7beeea566b560d4(new (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)(geometryType, geometryType === "Polygon" ? $ec084d0ff9c13a22$var$orientFlatCoordinates(geometry.flatCoordinates, geometry.ends, stride) : geometry.flatCoordinates, geometry.ends?.flat(), stride, object.properties || {}, object.id).enableSimplifyTransformed(), false, options);
}
function $ec084d0ff9c13a22$export$322c9678d8c47bf(object, options) {
    if (!object) return null;
    if (Array.isArray(object)) {
        const geometries = object.map((geometry)=>$ec084d0ff9c13a22$export$322c9678d8c47bf(geometry, options));
        return new (0, $0e4f3959219eede5$export$2e2bcd8739ae039)(geometries);
    }
    const Geometry = $ec084d0ff9c13a22$var$GeometryConstructor[object.type];
    return $ec084d0ff9c13a22$export$7beeea566b560d4(new Geometry(object.flatCoordinates, object.layout, object.ends), false, options);
}



/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @template {import('../Feature.js').FeatureClass} [T=typeof import('../Feature.js').default]
 * @extends {FeatureFormat<T>}
 * @abstract
 */ class $2f9f6f6b6e1ba437$var$JSONFeature extends (0, $ec084d0ff9c13a22$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   */ getType() {
        return "json";
    }
    /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import('./Feature.js').FeatureClassToFeature<T>} Feature.
   * @api
   */ readFeature(source, options) {
        return /** @type {import('./Feature.js').FeatureClassToFeature<T>} */ this.readFeatureFromObject($2f9f6f6b6e1ba437$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<import('./Feature.js').FeatureClassToFeature<T>>} Features.
   * @api
   */ readFeatures(source, options) {
        return /** @type {Array<import('./Feature.js').FeatureClassToFeature<T>>} */ this.readFeaturesFromObject($2f9f6f6b6e1ba437$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../Feature.js").default|import("../render/Feature.js").default|Array<import("../render/Feature.js").default>} Feature.
   */ readFeatureFromObject(object, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<import("../Feature.js").default|import("../render/Feature.js").default>} Features.
   */ readFeaturesFromObject(object, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   */ readGeometry(source, options) {
        return this.readGeometryFromObject($2f9f6f6b6e1ba437$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromObject(object, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   */ readProjection(source) {
        return this.readProjectionFromObject($2f9f6f6b6e1ba437$var$getObject(source));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromObject(object) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   */ writeFeature(feature, options) {
        return JSON.stringify(this.writeFeatureObject(feature, options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeatureObject(feature, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   */ writeFeatures(features, options) {
        return JSON.stringify(this.writeFeaturesObject(features, options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeaturesObject(features, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @api
   */ writeGeometry(geometry, options) {
        return JSON.stringify(this.writeGeometryObject(geometry, options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeGeometryObject(geometry, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */ function $2f9f6f6b6e1ba437$var$getObject(source) {
    if (typeof source === "string") {
        const object = JSON.parse(source);
        return object ? /** @type {Object} */ object : null;
    }
    if (source !== null) return source;
    return null;
}
var $2f9f6f6b6e1ba437$export$2e2bcd8739ae039 = $2f9f6f6b6e1ba437$var$JSONFeature;








/**
 * @typedef {import("geojson").GeoJSON} GeoJSONObject
 * @typedef {import("geojson").Feature} GeoJSONFeature
 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
 * @typedef {import("geojson").Geometry} GeoJSONGeometry
 * @typedef {import("geojson").Point} GeoJSONPoint
 * @typedef {import("geojson").LineString} GeoJSONLineString
 * @typedef {import("geojson").Polygon} GeoJSONPolygon
 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
 */ /**
 * @template {import("../Feature.js").FeatureClass} FeatureClassToFeature
 * @typedef {Object} Options
 *
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
 * written by the format.  Options passed to read or write methods will take precedence.
 * @property {string} [geometryName] Geometry name to use when creating features.
 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
 * will look for that field to set the geometry name. If both this field is set to `true`
 * and a `geometryName` is provided, the `geometryName` will take precedence.
 * @property {FeatureClassToFeature} [featureClass] Feature class
 * to be used when reading features. The default is {@link module:ol/Feature~Feature}. If performance is
 * the primary concern, and features are not going to be modified or round-tripped through the format,
 * consider using {@link module:ol/render/Feature~RenderFeature}
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GeoJSON format.
 *
 * @template {import('../Feature.js').FeatureClass} [T=typeof Feature]
 * @extends {JSONFeature<T>}
 * @api
 */ class $f602cef51a2e6950$var$GeoJSON extends (0, $2f9f6f6b6e1ba437$export$2e2bcd8739ae039) {
    /**
   * @param {Options<T>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super();
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection ? options.dataProjection : "EPSG:4326");
        if (options.featureProjection) /**
       * @type {import("../proj/Projection.js").default}
       */ this.defaultFeatureProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.featureProjection);
        if (options.featureClass) this.featureClass = options.featureClass;
        /**
     * Name of the geometry attribute for features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * Look for the `geometry_name` in the feature GeoJSON
     * @type {boolean|undefined}
     * @private
     */ this.extractGeometryName_ = options.extractGeometryName;
        this.supportedMediaTypes = [
            "application/geo+json",
            "application/vnd.geo+json"
        ];
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Feature|RenderFeature|Array<RenderFeature>}.default} Feature.
   */ readFeatureFromObject(object, options) {
        /**
     * @type {GeoJSONFeature}
     */ let geoJSONFeature = null;
        if (object["type"] === "Feature") geoJSONFeature = /** @type {GeoJSONFeature} */ object;
        else geoJSONFeature = {
            "type": "Feature",
            "geometry": /** @type {GeoJSONGeometry} */ object,
            "properties": null
        };
        const geometry = $f602cef51a2e6950$var$readGeometryInternal(geoJSONFeature["geometry"], options);
        if (this.featureClass === (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)) return (0, $ec084d0ff9c13a22$export$f935e77582b330a)({
            geometry: geometry,
            id: geoJSONFeature["id"],
            properties: geoJSONFeature["properties"]
        }, options);
        const feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
        if (this.geometryName_) feature.setGeometryName(this.geometryName_);
        else if (this.extractGeometryName_ && geoJSONFeature["geometry_name"]) feature.setGeometryName(geoJSONFeature["geometry_name"]);
        feature.setGeometry((0, $ec084d0ff9c13a22$export$322c9678d8c47bf)(geometry, options));
        if ("id" in geoJSONFeature) feature.setId(geoJSONFeature["id"]);
        if (geoJSONFeature["properties"]) feature.setProperties(geoJSONFeature["properties"], true);
        return feature;
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<Feature|RenderFeature>} Features.
   */ readFeaturesFromObject(object, options) {
        const geoJSONObject = /** @type {GeoJSONObject} */ object;
        /** @type {Array<Feature|RenderFeature|Array<RenderFeature>>} */ let features = null;
        if (geoJSONObject["type"] === "FeatureCollection") {
            const geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ object;
            features = [];
            const geoJSONFeatures = geoJSONFeatureCollection["features"];
            for(let i = 0, ii = geoJSONFeatures.length; i < ii; ++i){
                const featureObject = this.readFeatureFromObject(geoJSONFeatures[i], options);
                if (!featureObject) continue;
                features.push(featureObject);
            }
        } else features = [
            this.readFeatureFromObject(object, options)
        ];
        return features.flat();
    }
    /**
   * @param {GeoJSONGeometry} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromObject(object, options) {
        return $f602cef51a2e6950$var$readGeometry(object, options);
    }
    /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromObject(object) {
        const crs = object["crs"];
        let projection;
        if (crs) {
            if (crs["type"] == "name") projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(crs["properties"]["name"]);
            else if (crs["type"] === "EPSG") projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("EPSG:" + crs["properties"]["code"]);
            else throw new Error("Unknown SRS type");
        } else projection = this.dataProjection;
        return /** @type {import("../proj/Projection.js").default} */ projection;
    }
    /**
   * Encode a feature as a GeoJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeature} Object.
   * @api
   */ writeFeatureObject(feature, options) {
        options = this.adaptOptions(options);
        /** @type {GeoJSONFeature} */ const object = {
            "type": "Feature",
            geometry: null,
            properties: null
        };
        const id = feature.getId();
        if (id !== undefined) object.id = id;
        if (!feature.hasProperties()) return object;
        const properties = feature.getProperties();
        const geometry = feature.getGeometry();
        if (geometry) {
            object.geometry = $f602cef51a2e6950$var$writeGeometry(geometry, options);
            delete properties[feature.getGeometryName()];
        }
        if (!(0, $beaefe87199bb537$export$dd1bc94b04021eeb)(properties)) object.properties = properties;
        return object;
    }
    /**
   * Encode an array of features as a GeoJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeatureCollection} GeoJSON Object.
   * @api
   */ writeFeaturesObject(features, options) {
        options = this.adaptOptions(options);
        const objects = [];
        for(let i = 0, ii = features.length; i < ii; ++i)objects.push(this.writeFeatureObject(features[i], options));
        return {
            type: "FeatureCollection",
            features: objects
        };
    }
    /**
   * Encode a geometry as a GeoJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
   * @api
   */ writeGeometryObject(geometry, options) {
        return $f602cef51a2e6950$var$writeGeometry(geometry, this.adaptOptions(options));
    }
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryObject} Geometry.
 */ function $f602cef51a2e6950$var$readGeometryInternal(object, options) {
    if (!object) return null;
    /** @type {import("./Feature.js").GeometryObject} */ let geometry;
    switch(object["type"]){
        case "Point":
            geometry = $f602cef51a2e6950$var$readPointGeometry(/** @type {GeoJSONPoint} */ object);
            break;
        case "LineString":
            geometry = $f602cef51a2e6950$var$readLineStringGeometry(/** @type {GeoJSONLineString} */ object);
            break;
        case "Polygon":
            geometry = $f602cef51a2e6950$var$readPolygonGeometry(/** @type {GeoJSONPolygon} */ object);
            break;
        case "MultiPoint":
            geometry = $f602cef51a2e6950$var$readMultiPointGeometry(/** @type {GeoJSONMultiPoint} */ object);
            break;
        case "MultiLineString":
            geometry = $f602cef51a2e6950$var$readMultiLineStringGeometry(/** @type {GeoJSONMultiLineString} */ object);
            break;
        case "MultiPolygon":
            geometry = $f602cef51a2e6950$var$readMultiPolygonGeometry(/** @type {GeoJSONMultiPolygon} */ object);
            break;
        case "GeometryCollection":
            geometry = $f602cef51a2e6950$var$readGeometryCollectionGeometry(/** @type {GeoJSONGeometryCollection} */ object);
            break;
        default:
            throw new Error("Unsupported GeoJSON type: " + object["type"]);
    }
    return geometry;
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $f602cef51a2e6950$var$readGeometry(object, options) {
    const geometryObject = $f602cef51a2e6950$var$readGeometryInternal(object, options);
    return (0, $ec084d0ff9c13a22$export$322c9678d8c47bf)(geometryObject, options);
}
/**
 * @param {GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryCollectionObject} Geometry collection.
 */ function $f602cef51a2e6950$var$readGeometryCollectionGeometry(object, options) {
    const geometries = object["geometries"].map(/**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("./Feature.js").GeometryObject} geometry Geometry.
     */ function(geometry) {
        return $f602cef51a2e6950$var$readGeometryInternal(geometry, options);
    });
    return geometries;
}
/**
 * @param {GeoJSONPoint} object Input object.
 * @return {import("./Feature.js").GeometryObject} Point geometry.
 */ function $f602cef51a2e6950$var$readPointGeometry(object) {
    const flatCoordinates = object["coordinates"];
    return {
        type: "Point",
        flatCoordinates: flatCoordinates,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(flatCoordinates.length)
    };
}
/**
 * @param {GeoJSONLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} LineString geometry.
 */ function $f602cef51a2e6950$var$readLineStringGeometry(object) {
    const coordinates = object["coordinates"];
    const flatCoordinates = coordinates.flat();
    return {
        type: "LineString",
        flatCoordinates: flatCoordinates,
        ends: [
            flatCoordinates.length
        ],
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiLineString geometry.
 */ function $f602cef51a2e6950$var$readMultiLineStringGeometry(object) {
    const coordinates = object["coordinates"];
    const stride = coordinates[0]?.[0]?.length || 2;
    const flatCoordinates = [];
    const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: "MultiLineString",
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONMultiPoint} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPoint geometry.
 */ function $f602cef51a2e6950$var$readMultiPointGeometry(object) {
    const coordinates = object["coordinates"];
    return {
        type: "MultiPoint",
        flatCoordinates: coordinates.flat(),
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPolygon geometry.
 */ function $f602cef51a2e6950$var$readMultiPolygonGeometry(object) {
    const coordinates = object["coordinates"];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.[0].length || 2;
    const endss = (0, $6b086aa46281540d$export$f9f2bb59da4accd3)(flatCoordinates, 0, coordinates, stride);
    return {
        type: "MultiPolygon",
        flatCoordinates: flatCoordinates,
        ends: endss,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} Polygon.
 */ function $f602cef51a2e6950$var$readPolygonGeometry(object) {
    const coordinates = object["coordinates"];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.length;
    const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: "Polygon",
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeGeometry(geometry, options) {
    geometry = (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, true, options);
    const type = geometry.getType();
    /** @type {GeoJSONGeometry} */ let geoJSON;
    switch(type){
        case "Point":
            geoJSON = $f602cef51a2e6950$var$writePointGeometry(/** @type {import("../geom/Point.js").default} */ geometry, options);
            break;
        case "LineString":
            geoJSON = $f602cef51a2e6950$var$writeLineStringGeometry(/** @type {import("../geom/LineString.js").default} */ geometry, options);
            break;
        case "Polygon":
            geoJSON = $f602cef51a2e6950$var$writePolygonGeometry(/** @type {import("../geom/Polygon.js").default} */ geometry, options);
            break;
        case "MultiPoint":
            geoJSON = $f602cef51a2e6950$var$writeMultiPointGeometry(/** @type {import("../geom/MultiPoint.js").default} */ geometry, options);
            break;
        case "MultiLineString":
            geoJSON = $f602cef51a2e6950$var$writeMultiLineStringGeometry(/** @type {import("../geom/MultiLineString.js").default} */ geometry, options);
            break;
        case "MultiPolygon":
            geoJSON = $f602cef51a2e6950$var$writeMultiPolygonGeometry(/** @type {import("../geom/MultiPolygon.js").default} */ geometry, options);
            break;
        case "GeometryCollection":
            geoJSON = $f602cef51a2e6950$var$writeGeometryCollectionGeometry(/** @type {import("../geom/GeometryCollection.js").default} */ geometry, options);
            break;
        case "Circle":
            geoJSON = {
                type: "GeometryCollection",
                geometries: []
            };
            break;
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return geoJSON;
}
/**
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
 */ function $f602cef51a2e6950$var$writeGeometryCollectionGeometry(geometry, options) {
    options = Object.assign({}, options);
    delete options.featureProjection;
    const geometries = geometry.getGeometriesArray().map(function(geometry) {
        return $f602cef51a2e6950$var$writeGeometry(geometry, options);
    });
    return {
        type: "GeometryCollection",
        geometries: geometries
    };
}
/**
 * @param {import("../geom/LineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeLineStringGeometry(geometry, options) {
    return {
        type: "LineString",
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeMultiLineStringGeometry(geometry, options) {
    return {
        type: "MultiLineString",
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeMultiPointGeometry(geometry, options) {
    return {
        type: "MultiPoint",
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeMultiPolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: "MultiPolygon",
        coordinates: geometry.getCoordinates(right)
    };
}
/**
 * @param {import("../geom/Point.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writePointGeometry(geometry, options) {
    return {
        type: "Point",
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/Polygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writePolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: "Polygon",
        coordinates: geometry.getCoordinates(right)
    };
}
var $f602cef51a2e6950$export$2e2bcd8739ae039 = $f602cef51a2e6950$var$GeoJSON;





/**
 * @module ol/interaction/Modify
 */ 



















/**
 * The segment index assigned to a circle's center when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */ const $8c24f34a0807f744$var$CIRCLE_CENTER_INDEX = 0;
/**
 * The segment index assigned to a circle's circumference when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */ const $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX = 1;
const $8c24f34a0807f744$var$tempExtent = [
    0,
    0,
    0,
    0
];
const $8c24f34a0807f744$var$tempSegment = [];
/**
 * @enum {string}
 */ const $8c24f34a0807f744$var$ModifyEventType = {
    /**
   * Triggered upon feature modification start
   * @event ModifyEvent#modifystart
   * @api
   */ MODIFYSTART: "modifystart",
    /**
   * Triggered upon feature modification end
   * @event ModifyEvent#modifyend
   * @api
   */ MODIFYEND: "modifyend"
};
class $8c24f34a0807f744$export$eb2af8bb6aa1fb54 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {ModifyEventType} type Type.
   * @param {Collection<Feature>} features
   * The features modified.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent
   * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */ constructor(type, features, mapBrowserEvent){
        super(type);
        /**
     * The features being modified.
     * @type {Collection<Feature>}
     * @api
     */ this.features = features;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'modifyend'|'modifystart', ModifyEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'modifyend'|'modifystart', Return>} ModifyOnSignature
 */ /**
 * @classdesc
 * Interaction for modifying feature geometries.  To modify features that have
 * been added to an existing source, construct the modify interaction with the
 * `source` option.  If you want to modify features in a collection (for example,
 * the collection used by a select interaction), construct the interaction with
 * the `features` option.  The interaction must be constructed with either a
 * `source` or `features` option.
 *
 * Cartesian distance from the pointer is used to determine the features that
 * will be modified. This means that geometries will only be considered for
 * modification when they are within the configured `pixelTolerance`. For point
 * geometries, the `hitDetection` option can be used to match their visual
 * appearance.
 *
 * By default, the interaction will allow deletion of vertices when the `alt`
 * key is pressed.  To configure the interaction with a different condition
 * for deletion, use the `deleteCondition` option.
 * @fires ModifyEvent
 * @api
 */ class $8c24f34a0807f744$var$Modify extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super(/** @type {import("./Pointer.js").Options} */ options);
        /***
     * @type {ModifyOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ModifyOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ModifyOnSignature<void>}
     */ this.un;
        /** @private */ this.boundHandleFeatureChange_ = this.handleFeatureChange_.bind(this);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$189f0d593022b199);
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultDeleteCondition_ = function(mapBrowserEvent) {
            return (0, $edf87b50170125f7$export$573409992e89967e)(mapBrowserEvent) && (0, $edf87b50170125f7$export$194df8bad091b401)(mapBrowserEvent);
        };
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.deleteCondition_ = options.deleteCondition ? options.deleteCondition : this.defaultDeleteCondition_;
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.insertVertexCondition_ = options.insertVertexCondition ? options.insertVertexCondition : (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        /**
     * Editing vertex.
     * @type {Feature<Point>}
     * @private
     */ this.vertexFeature_ = null;
        /**
     * Segments intersecting {@link this.vertexFeature_} by segment uid.
     * @type {Object<string, boolean>}
     * @private
     */ this.vertexSegments_ = null;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.lastPixel_ = [
            0,
            0
        ];
        /**
     * Tracks if the next `singleclick` event should be ignored to prevent
     * accidental deletion right after vertex creation.
     * @type {boolean}
     * @private
     */ this.ignoreNextSingleClick_ = false;
        /**
     * @type {Collection<Feature>}
     * @private
     */ this.featuresBeingModified_ = null;
        /**
     * Segment RTree for each layer
     * @type {RBush<SegmentData>}
     * @private
     */ this.rBush_ = new (0, $34c742891733e7a4$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ this.pixelTolerance_ = options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
        /**
     * @type {boolean}
     * @private
     */ this.snappedToVertex_ = false;
        /**
     * Indicate whether the interaction is currently changing a feature's
     * coordinates.
     * @type {boolean}
     * @private
     */ this.changingFeature_ = false;
        /**
     * @type {Array}
     * @private
     */ this.dragSegments_ = [];
        /**
     * Draw overlay where sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */ this.overlay_ = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
                useSpatialIndex: false,
                wrapX: !!options.wrapX
            }),
            style: options.style ? options.style : $8c24f34a0807f744$var$getDefaultStyleFunction(),
            updateWhileAnimating: true,
            updateWhileInteracting: true
        });
        /**
     * @const
     * @private
     * @type {!Object<string, function(Feature, import("../geom/Geometry.js").default): void>}
     */ this.SEGMENT_WRITERS_ = {
            "Point": this.writePointGeometry_.bind(this),
            "LineString": this.writeLineStringGeometry_.bind(this),
            "LinearRing": this.writeLineStringGeometry_.bind(this),
            "Polygon": this.writePolygonGeometry_.bind(this),
            "MultiPoint": this.writeMultiPointGeometry_.bind(this),
            "MultiLineString": this.writeMultiLineStringGeometry_.bind(this),
            "MultiPolygon": this.writeMultiPolygonGeometry_.bind(this),
            "Circle": this.writeCircleGeometry_.bind(this),
            "GeometryCollection": this.writeGeometryCollectionGeometry_.bind(this)
        };
        /**
     * @type {VectorSource}
     * @private
     */ this.source_ = null;
        /**
     * @type {boolean|import("../layer/BaseVector").default}
     */ this.hitDetection_ = null;
        /** @type {Collection<Feature>} */ let features;
        if (options.features) features = options.features;
        else if (options.source) {
            this.source_ = options.source;
            features = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(this.source_.getFeatures());
            this.source_.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, this.handleSourceAdd_.bind(this));
            this.source_.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, this.handleSourceRemove_.bind(this));
        }
        if (!features) throw new Error("The modify interaction requires features, a source or a layer");
        if (options.hitDetection) this.hitDetection_ = options.hitDetection;
        /**
     * @type {Collection<Feature>}
     * @private
     */ this.features_ = features;
        this.features_.forEach(this.addFeature_.bind(this));
        this.features_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, this.handleFeatureAdd_.bind(this));
        this.features_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, this.handleFeatureRemove_.bind(this));
        /**
     * @type {import("../MapBrowserEvent.js").default}
     * @private
     */ this.lastPointerEvent_ = null;
        /**
     * Delta (x, y in map units) between matched rtree vertex and pointer vertex.
     * @type {Array<number>}
     */ this.delta_ = [
            0,
            0
        ];
        /**
     * @private
     */ this.snapToPointer_ = options.snapToPointer === undefined ? !this.hitDetection_ : options.snapToPointer;
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ addFeature_(feature) {
        const geometry = feature.getGeometry();
        if (geometry) {
            const writer = this.SEGMENT_WRITERS_[geometry.getType()];
            if (writer) writer(feature, geometry);
        }
        const map = this.getMap();
        if (map && map.isRendered() && this.getActive()) this.handlePointerAtPixel_(this.lastPixel_, map);
        feature.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleFeatureChange_);
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} evt Map browser event.
   * @param {Array<Array<SegmentData>>} segments The segments subject to modification.
   * @private
   */ willModifyFeatures_(evt, segments) {
        if (!this.featuresBeingModified_) {
            this.featuresBeingModified_ = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
            const features = this.featuresBeingModified_.getArray();
            for(let i = 0, ii = segments.length; i < ii; ++i){
                const segment = segments[i];
                for(let s = 0, ss = segment.length; s < ss; ++s){
                    const feature = segment[s].feature;
                    if (feature && !features.includes(feature)) this.featuresBeingModified_.push(feature);
                }
            }
            if (this.featuresBeingModified_.getLength() === 0) this.featuresBeingModified_ = null;
            else this.dispatchEvent(new $8c24f34a0807f744$export$eb2af8bb6aa1fb54($8c24f34a0807f744$var$ModifyEventType.MODIFYSTART, this.featuresBeingModified_, evt));
        }
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeature_(feature) {
        this.removeFeatureSegmentData_(feature);
        // Remove the vertex feature if the collection of candidate features is empty.
        if (this.vertexFeature_ && this.features_.getLength() === 0) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
        feature.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleFeatureChange_);
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeatureSegmentData_(feature) {
        const rBush = this.rBush_;
        /** @type {Array<SegmentData>} */ const nodesToRemove = [];
        rBush.forEach(/**
       * @param {SegmentData} node RTree node.
       */ function(node) {
            if (feature === node.feature) nodesToRemove.push(node);
        });
        for(let i = nodesToRemove.length - 1; i >= 0; --i){
            const nodeToRemove = nodesToRemove[i];
            for(let j = this.dragSegments_.length - 1; j >= 0; --j)if (this.dragSegments_[j][0] === nodeToRemove) this.dragSegments_.splice(j, 1);
            rBush.remove(nodeToRemove);
        }
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        if (this.vertexFeature_ && !active) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
        super.setActive(active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   */ setMap(map) {
        this.overlay_.setMap(map);
        super.setMap(map);
    }
    /**
   * Get the overlay layer that this interaction renders the modification point or vertex to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */ getOverlay() {
        return this.overlay_;
    }
    /**
   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
   * @private
   */ handleSourceAdd_(event) {
        if (event.feature) this.features_.push(event.feature);
    }
    /**
   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
   * @private
   */ handleSourceRemove_(event) {
        if (event.feature) this.features_.remove(event.feature);
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ handleFeatureAdd_(evt) {
        this.addFeature_(evt.element);
    }
    /**
   * @param {import("../events/Event.js").default} evt Event.
   * @private
   */ handleFeatureChange_(evt) {
        if (!this.changingFeature_) {
            const feature = /** @type {Feature} */ evt.target;
            this.removeFeature_(feature);
            this.addFeature_(feature);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ handleFeatureRemove_(evt) {
        this.removeFeature_(evt.element);
    }
    /**
   * @param {Feature} feature Feature
   * @param {Point} geometry Geometry.
   * @private
   */ writePointGeometry_(feature, geometry) {
        const coordinates = geometry.getCoordinates();
        /** @type {SegmentData} */ const segmentData = {
            feature: feature,
            geometry: geometry,
            segment: [
                coordinates,
                coordinates
            ]
        };
        this.rBush_.insert(geometry.getExtent(), segmentData);
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
   * @private
   */ writeMultiPointGeometry_(feature, geometry) {
        const points = geometry.getCoordinates();
        for(let i = 0, ii = points.length; i < ii; ++i){
            const coordinates = points[i];
            /** @type {SegmentData} */ const segmentData = {
                feature: feature,
                geometry: geometry,
                depth: [
                    i
                ],
                index: i,
                segment: [
                    coordinates,
                    coordinates
                ]
            };
            this.rBush_.insert(geometry.getExtent(), segmentData);
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/LineString.js").default} geometry Geometry.
   * @private
   */ writeLineStringGeometry_(feature, geometry) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
            const segment = coordinates.slice(i, i + 2);
            /** @type {SegmentData} */ const segmentData = {
                feature: feature,
                geometry: geometry,
                index: i,
                segment: segment
            };
            this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
   * @private
   */ writeMultiLineStringGeometry_(feature, geometry) {
        const lines = geometry.getCoordinates();
        for(let j = 0, jj = lines.length; j < jj; ++j){
            const coordinates = lines[j];
            for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                const segment = coordinates.slice(i, i + 2);
                /** @type {SegmentData} */ const segmentData = {
                    feature: feature,
                    geometry: geometry,
                    depth: [
                        j
                    ],
                    index: i,
                    segment: segment
                };
                this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
            }
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/Polygon.js").default} geometry Geometry.
   * @private
   */ writePolygonGeometry_(feature, geometry) {
        const rings = geometry.getCoordinates();
        for(let j = 0, jj = rings.length; j < jj; ++j){
            const coordinates = rings[j];
            for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                const segment = coordinates.slice(i, i + 2);
                /** @type {SegmentData} */ const segmentData = {
                    feature: feature,
                    geometry: geometry,
                    depth: [
                        j
                    ],
                    index: i,
                    segment: segment
                };
                this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
            }
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
   * @private
   */ writeMultiPolygonGeometry_(feature, geometry) {
        const polygons = geometry.getCoordinates();
        for(let k = 0, kk = polygons.length; k < kk; ++k){
            const rings = polygons[k];
            for(let j = 0, jj = rings.length; j < jj; ++j){
                const coordinates = rings[j];
                for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                    const segment = coordinates.slice(i, i + 2);
                    /** @type {SegmentData} */ const segmentData = {
                        feature: feature,
                        geometry: geometry,
                        depth: [
                            j,
                            k
                        ],
                        index: i,
                        segment: segment
                    };
                    this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
                }
            }
        }
    }
    /**
   * We convert a circle into two segments.  The segment at index
   * {@link CIRCLE_CENTER_INDEX} is the
   * circle's center (a point).  The segment at index
   * {@link CIRCLE_CIRCUMFERENCE_INDEX} is
   * the circumference, and is not a line segment.
   *
   * @param {Feature} feature Feature.
   * @param {import("../geom/Circle.js").default} geometry Geometry.
   * @private
   */ writeCircleGeometry_(feature, geometry) {
        const coordinates = geometry.getCenter();
        /** @type {SegmentData} */ const centerSegmentData = {
            feature: feature,
            geometry: geometry,
            index: $8c24f34a0807f744$var$CIRCLE_CENTER_INDEX,
            segment: [
                coordinates,
                coordinates
            ]
        };
        /** @type {SegmentData} */ const circumferenceSegmentData = {
            feature: feature,
            geometry: geometry,
            index: $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX,
            segment: [
                coordinates,
                coordinates
            ]
        };
        const featureSegments = [
            centerSegmentData,
            circumferenceSegmentData
        ];
        centerSegmentData.featureSegments = featureSegments;
        circumferenceSegmentData.featureSegments = featureSegments;
        this.rBush_.insert((0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(coordinates), centerSegmentData);
        let circleGeometry = /** @type {import("../geom/Geometry.js").default} */ geometry;
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection && this.getMap()) {
            const projection = this.getMap().getView().getProjection();
            circleGeometry = circleGeometry.clone().transform(userProjection, projection);
            circleGeometry = (0, $40aa8d43bbe572bf$export$2451009d645fb8c2)(/** @type {import("../geom/Circle.js").default} */ circleGeometry).transform(projection, userProjection);
        }
        this.rBush_.insert(circleGeometry.getExtent(), circumferenceSegmentData);
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
   * @private
   */ writeGeometryCollectionGeometry_(feature, geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0; i < geometries.length; ++i){
            const geometry = geometries[i];
            const writer = this.SEGMENT_WRITERS_[geometry.getType()];
            writer(feature, geometry);
        }
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {Array<Feature>} features The features being modified.
   * @param {Array<import("../geom/SimpleGeometry.js").default>} geometries The geometries being modified.
   * @return {Feature} Vertex feature.
   * @private
   */ createOrUpdateVertexFeature_(coordinates, features, geometries) {
        let vertexFeature = this.vertexFeature_;
        if (!vertexFeature) {
            vertexFeature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(coordinates));
            this.vertexFeature_ = vertexFeature;
            this.overlay_.getSource().addFeature(vertexFeature);
        } else {
            const geometry = vertexFeature.getGeometry();
            geometry.setCoordinates(coordinates);
        }
        vertexFeature.set("features", features);
        vertexFeature.set("geometries", geometries);
        return vertexFeature;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may modify the geometry.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        this.lastPointerEvent_ = mapBrowserEvent;
        let handled;
        if (!mapBrowserEvent.map.getView().getInteracting() && mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE && !this.handlingDownUpSequence) this.handlePointerMove_(mapBrowserEvent);
        if (this.vertexFeature_ && this.deleteCondition_(mapBrowserEvent)) {
            if (mapBrowserEvent.type != (0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK || !this.ignoreNextSingleClick_) handled = this.removePoint();
            else handled = true;
        }
        if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK) this.ignoreNextSingleClick_ = false;
        return super.handleEvent(mapBrowserEvent) && !handled;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   */ handleDragEvent(evt) {
        this.ignoreNextSingleClick_ = false;
        this.willModifyFeatures_(evt, this.dragSegments_);
        const vertex = [
            evt.coordinate[0] + this.delta_[0],
            evt.coordinate[1] + this.delta_[1]
        ];
        const features = [];
        const geometries = [];
        for(let i = 0, ii = this.dragSegments_.length; i < ii; ++i){
            const dragSegment = this.dragSegments_[i];
            const segmentData = dragSegment[0];
            const feature = segmentData.feature;
            if (!features.includes(feature)) features.push(feature);
            const geometry = segmentData.geometry;
            if (!geometries.includes(geometry)) geometries.push(geometry);
            const depth = segmentData.depth;
            let coordinates;
            const segment = segmentData.segment;
            const index = dragSegment[1];
            while(vertex.length < geometry.getStride())vertex.push(segment[index][vertex.length]);
            switch(geometry.getType()){
                case "Point":
                    coordinates = vertex;
                    segment[0] = vertex;
                    segment[1] = vertex;
                    break;
                case "MultiPoint":
                    coordinates = geometry.getCoordinates();
                    coordinates[segmentData.index] = vertex;
                    segment[0] = vertex;
                    segment[1] = vertex;
                    break;
                case "LineString":
                    coordinates = geometry.getCoordinates();
                    coordinates[segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case "MultiLineString":
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case "Polygon":
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case "MultiPolygon":
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[1]][depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case "Circle":
                    segment[0] = vertex;
                    segment[1] = vertex;
                    if (segmentData.index === $8c24f34a0807f744$var$CIRCLE_CENTER_INDEX) {
                        this.changingFeature_ = true;
                        geometry.setCenter(vertex);
                        this.changingFeature_ = false;
                    } else {
                        // We're dragging the circle's circumference:
                        this.changingFeature_ = true;
                        const projection = evt.map.getView().getProjection();
                        let radius = (0, $1bd0a226f9a16141$export$9f17032d917177de)((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(geometry.getCenter(), projection), (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(vertex, projection));
                        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                        if (userProjection) {
                            const circleGeometry = geometry.clone().transform(userProjection, projection);
                            circleGeometry.setRadius(radius);
                            radius = circleGeometry.transform(projection, userProjection).getRadius();
                        }
                        geometry.setRadius(radius);
                        this.changingFeature_ = false;
                    }
                    break;
                default:
            }
            if (coordinates) this.setGeometryCoordinates_(geometry, coordinates);
        }
        this.createOrUpdateVertexFeature_(vertex, features, geometries);
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(evt) {
        if (!this.condition_(evt)) return false;
        const pixelCoordinate = evt.coordinate;
        this.handlePointerAtPixel_(evt.pixel, evt.map, pixelCoordinate);
        this.dragSegments_.length = 0;
        this.featuresBeingModified_ = null;
        const vertexFeature = this.vertexFeature_;
        if (vertexFeature) {
            const projection = evt.map.getView().getProjection();
            const insertVertices = [];
            const vertex = vertexFeature.getGeometry().getCoordinates();
            const vertexExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
                vertex
            ]);
            const segmentDataMatches = this.rBush_.getInExtent(vertexExtent);
            const componentSegments = {};
            segmentDataMatches.sort($8c24f34a0807f744$var$compareIndexes);
            for(let i = 0, ii = segmentDataMatches.length; i < ii; ++i){
                const segmentDataMatch = segmentDataMatches[i];
                const segment = segmentDataMatch.segment;
                let uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(segmentDataMatch.geometry);
                const depth = segmentDataMatch.depth;
                if (depth) uid += "-" + depth.join("-"); // separate feature components
                if (!componentSegments[uid]) componentSegments[uid] = new Array(2);
                if (segmentDataMatch.geometry.getType() === "Circle" && segmentDataMatch.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
                    const closestVertex = $8c24f34a0807f744$var$closestOnSegmentData(pixelCoordinate, segmentDataMatch, projection);
                    if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestVertex, vertex) && !componentSegments[uid][0]) {
                        this.dragSegments_.push([
                            segmentDataMatch,
                            0
                        ]);
                        componentSegments[uid][0] = segmentDataMatch;
                    }
                    continue;
                }
                if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(segment[0], vertex) && !componentSegments[uid][0]) {
                    this.dragSegments_.push([
                        segmentDataMatch,
                        0
                    ]);
                    componentSegments[uid][0] = segmentDataMatch;
                    continue;
                }
                if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(segment[1], vertex) && !componentSegments[uid][1]) {
                    if (componentSegments[uid][0] && componentSegments[uid][0].index === 0) {
                        let coordinates = segmentDataMatch.geometry.getCoordinates();
                        switch(segmentDataMatch.geometry.getType()){
                            // prevent dragging closed linestrings by the connecting node
                            case "LineString":
                            case "MultiLineString":
                                continue;
                            // if dragging the first vertex of a polygon, ensure the other segment
                            // belongs to the closing vertex of the linear ring
                            case "MultiPolygon":
                                coordinates = coordinates[depth[1]];
                            /* falls through */ case "Polygon":
                                if (segmentDataMatch.index !== coordinates[depth[0]].length - 2) continue;
                                break;
                            default:
                        }
                    }
                    this.dragSegments_.push([
                        segmentDataMatch,
                        1
                    ]);
                    componentSegments[uid][1] = segmentDataMatch;
                    continue;
                }
                if ((0, $6c5e11070e371322$export$5e82334337e0f204)(segment) in this.vertexSegments_ && !componentSegments[uid][0] && !componentSegments[uid][1] && this.insertVertexCondition_(evt)) insertVertices.push(segmentDataMatch);
            }
            if (insertVertices.length) this.willModifyFeatures_(evt, [
                insertVertices
            ]);
            for(let j = insertVertices.length - 1; j >= 0; --j)this.insertVertex_(insertVertices[j], vertex);
        }
        return !!this.vertexFeature_;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(evt) {
        for(let i = this.dragSegments_.length - 1; i >= 0; --i){
            const segmentData = this.dragSegments_[i][0];
            const geometry = segmentData.geometry;
            if (geometry.getType() === "Circle") {
                // Update a circle object in the R* bush:
                const coordinates = geometry.getCenter();
                const centerSegmentData = segmentData.featureSegments[0];
                const circumferenceSegmentData = segmentData.featureSegments[1];
                centerSegmentData.segment[0] = coordinates;
                centerSegmentData.segment[1] = coordinates;
                circumferenceSegmentData.segment[0] = coordinates;
                circumferenceSegmentData.segment[1] = coordinates;
                this.rBush_.update((0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(coordinates), centerSegmentData);
                let circleGeometry = geometry;
                const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                if (userProjection) {
                    const projection = evt.map.getView().getProjection();
                    circleGeometry = circleGeometry.clone().transform(userProjection, projection);
                    circleGeometry = (0, $40aa8d43bbe572bf$export$2451009d645fb8c2)(circleGeometry).transform(projection, userProjection);
                }
                this.rBush_.update(circleGeometry.getExtent(), circumferenceSegmentData);
            } else this.rBush_.update((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segmentData.segment), segmentData);
        }
        if (this.featuresBeingModified_) {
            this.dispatchEvent(new $8c24f34a0807f744$export$eb2af8bb6aa1fb54($8c24f34a0807f744$var$ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
            this.featuresBeingModified_ = null;
        }
        return false;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @private
   */ handlePointerMove_(evt) {
        this.lastPixel_ = evt.pixel;
        this.handlePointerAtPixel_(evt.pixel, evt.map, evt.coordinate);
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel
   * @param {import("../Map.js").default} map Map.
   * @param {import("../coordinate.js").Coordinate} [coordinate] The pixel Coordinate.
   * @private
   */ handlePointerAtPixel_(pixel, map, coordinate) {
        const pixelCoordinate = coordinate || map.getCoordinateFromPixel(pixel);
        const projection = map.getView().getProjection();
        const sortByDistance = function(a, b) {
            return $8c24f34a0807f744$var$projectedDistanceToSegmentDataSquared(pixelCoordinate, a, projection) - $8c24f34a0807f744$var$projectedDistanceToSegmentDataSquared(pixelCoordinate, b, projection);
        };
        /** @type {Array<SegmentData>|undefined} */ let nodes;
        /** @type {Point|undefined} */ let hitPointGeometry;
        if (this.hitDetection_) {
            const layerFilter = typeof this.hitDetection_ === "object" ? (layer)=>layer === this.hitDetection_ : undefined;
            map.forEachFeatureAtPixel(pixel, (feature, layer, geometry)=>{
                if (geometry && geometry.getType() === "Point") geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)((0, $9c4744460e43e41b$export$698f563af1ba02a5)(geometry.getCoordinates(), projection));
                const geom = geometry || feature.getGeometry();
                if (feature instanceof (0, $9fd014ab6df63665$export$2e2bcd8739ae039) && this.features_.getArray().includes(feature)) {
                    hitPointGeometry = /** @type {Point} */ geom;
                    const coordinate = /** @type {Point} */ feature.getGeometry().getFlatCoordinates().slice(0, 2);
                    nodes = [
                        {
                            feature: feature,
                            geometry: hitPointGeometry,
                            segment: [
                                coordinate,
                                coordinate
                            ]
                        }
                    ];
                }
                return true;
            }, {
                layerFilter: layerFilter
            });
        }
        if (!nodes) {
            const viewExtent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)((0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(pixelCoordinate, $8c24f34a0807f744$var$tempExtent), projection);
            const buffer = map.getView().getResolution() * this.pixelTolerance_;
            const box = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)((0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(viewExtent, buffer, $8c24f34a0807f744$var$tempExtent), projection);
            nodes = this.rBush_.getInExtent(box);
        }
        if (nodes && nodes.length > 0) {
            const node = nodes.sort(sortByDistance)[0];
            const closestSegment = node.segment;
            let vertex = $8c24f34a0807f744$var$closestOnSegmentData(pixelCoordinate, node, projection);
            const vertexPixel = map.getPixelFromCoordinate(vertex);
            let dist = (0, $1bd0a226f9a16141$export$9f17032d917177de)(pixel, vertexPixel);
            if (hitPointGeometry || dist <= this.pixelTolerance_) {
                /** @type {Object<string, boolean>} */ const vertexSegments = {};
                vertexSegments[(0, $6c5e11070e371322$export$5e82334337e0f204)(closestSegment)] = true;
                if (!this.snapToPointer_) {
                    this.delta_[0] = vertex[0] - pixelCoordinate[0];
                    this.delta_[1] = vertex[1] - pixelCoordinate[1];
                }
                if (node.geometry.getType() === "Circle" && node.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
                    this.snappedToVertex_ = true;
                    this.createOrUpdateVertexFeature_(vertex, [
                        node.feature
                    ], [
                        node.geometry
                    ]);
                } else {
                    const pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
                    const pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
                    const squaredDist1 = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(vertexPixel, pixel1);
                    const squaredDist2 = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(vertexPixel, pixel2);
                    dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
                    this.snappedToVertex_ = dist <= this.pixelTolerance_;
                    if (this.snappedToVertex_) vertex = squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
                    this.createOrUpdateVertexFeature_(vertex, [
                        node.feature
                    ], [
                        node.geometry
                    ]);
                    const geometries = {};
                    geometries[(0, $6c5e11070e371322$export$5e82334337e0f204)(node.geometry)] = true;
                    for(let i = 1, ii = nodes.length; i < ii; ++i){
                        const segment = nodes[i].segment;
                        if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[0], segment[0]) && (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[1], segment[1]) || (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[0], segment[1]) && (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[1], segment[0])) {
                            const geometryUid = (0, $6c5e11070e371322$export$5e82334337e0f204)(nodes[i].geometry);
                            if (!(geometryUid in geometries)) {
                                geometries[geometryUid] = true;
                                vertexSegments[(0, $6c5e11070e371322$export$5e82334337e0f204)(segment)] = true;
                            }
                        } else break;
                    }
                }
                this.vertexSegments_ = vertexSegments;
                return;
            }
        }
        if (this.vertexFeature_) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
    }
    /**
   * @param {SegmentData} segmentData Segment data.
   * @param {import("../coordinate.js").Coordinate} vertex Vertex.
   * @private
   */ insertVertex_(segmentData, vertex) {
        const segment = segmentData.segment;
        const feature = segmentData.feature;
        const geometry = segmentData.geometry;
        const depth = segmentData.depth;
        const index = segmentData.index;
        let coordinates;
        while(vertex.length < geometry.getStride())vertex.push(0);
        switch(geometry.getType()){
            case "MultiLineString":
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]].splice(index + 1, 0, vertex);
                break;
            case "Polygon":
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]].splice(index + 1, 0, vertex);
                break;
            case "MultiPolygon":
                coordinates = geometry.getCoordinates();
                coordinates[depth[1]][depth[0]].splice(index + 1, 0, vertex);
                break;
            case "LineString":
                coordinates = geometry.getCoordinates();
                coordinates.splice(index + 1, 0, vertex);
                break;
            default:
                return;
        }
        this.setGeometryCoordinates_(geometry, coordinates);
        const rTree = this.rBush_;
        rTree.remove(segmentData);
        this.updateSegmentIndices_(geometry, index, depth, 1);
        /** @type {SegmentData} */ const newSegmentData = {
            segment: [
                segment[0],
                vertex
            ],
            feature: feature,
            geometry: geometry,
            depth: depth,
            index: index
        };
        rTree.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(newSegmentData.segment), newSegmentData);
        this.dragSegments_.push([
            newSegmentData,
            1
        ]);
        /** @type {SegmentData} */ const newSegmentData2 = {
            segment: [
                vertex,
                segment[1]
            ],
            feature: feature,
            geometry: geometry,
            depth: depth,
            index: index + 1
        };
        rTree.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(newSegmentData2.segment), newSegmentData2);
        this.dragSegments_.push([
            newSegmentData2,
            0
        ]);
        this.ignoreNextSingleClick_ = true;
    }
    /**
   * Removes the vertex currently being pointed.
   * @return {boolean} True when a vertex was removed.
   * @api
   */ removePoint() {
        if (this.lastPointerEvent_ && this.lastPointerEvent_.type != (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG) {
            const evt = this.lastPointerEvent_;
            this.willModifyFeatures_(evt, this.dragSegments_);
            const removed = this.removeVertex_();
            if (this.featuresBeingModified_) this.dispatchEvent(new $8c24f34a0807f744$export$eb2af8bb6aa1fb54($8c24f34a0807f744$var$ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
            this.featuresBeingModified_ = null;
            return removed;
        }
        return false;
    }
    /**
   * Removes a vertex from all matching features.
   * @return {boolean} True when a vertex was removed.
   * @private
   */ removeVertex_() {
        const dragSegments = this.dragSegments_;
        const segmentsByFeature = {};
        let deleted = false;
        let component, coordinates, dragSegment, geometry, i, index, left;
        let newIndex, right, segmentData, uid;
        for(i = dragSegments.length - 1; i >= 0; --i){
            dragSegment = dragSegments[i];
            segmentData = dragSegment[0];
            uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(segmentData.feature);
            if (segmentData.depth) // separate feature components
            uid += "-" + segmentData.depth.join("-");
            if (!(uid in segmentsByFeature)) segmentsByFeature[uid] = {};
            if (dragSegment[1] === 0) {
                segmentsByFeature[uid].right = segmentData;
                segmentsByFeature[uid].index = segmentData.index;
            } else if (dragSegment[1] == 1) {
                segmentsByFeature[uid].left = segmentData;
                segmentsByFeature[uid].index = segmentData.index + 1;
            }
        }
        for(uid in segmentsByFeature){
            right = segmentsByFeature[uid].right;
            left = segmentsByFeature[uid].left;
            index = segmentsByFeature[uid].index;
            newIndex = index - 1;
            if (left !== undefined) segmentData = left;
            else segmentData = right;
            if (newIndex < 0) newIndex = 0;
            geometry = segmentData.geometry;
            coordinates = geometry.getCoordinates();
            component = coordinates;
            deleted = false;
            switch(geometry.getType()){
                case "MultiLineString":
                    if (coordinates[segmentData.depth[0]].length > 2) {
                        coordinates[segmentData.depth[0]].splice(index, 1);
                        deleted = true;
                    }
                    break;
                case "LineString":
                    if (coordinates.length > 2) {
                        coordinates.splice(index, 1);
                        deleted = true;
                    }
                    break;
                case "MultiPolygon":
                    component = component[segmentData.depth[1]];
                /* falls through */ case "Polygon":
                    component = component[segmentData.depth[0]];
                    if (component.length > 4) {
                        if (index == component.length - 1) index = 0;
                        component.splice(index, 1);
                        deleted = true;
                        if (index === 0) {
                            // close the ring again
                            component.pop();
                            component.push(component[0]);
                            newIndex = component.length - 1;
                        }
                    }
                    break;
                default:
            }
            if (deleted) {
                this.setGeometryCoordinates_(geometry, coordinates);
                const segments = [];
                if (left !== undefined) {
                    this.rBush_.remove(left);
                    segments.push(left.segment[0]);
                }
                if (right !== undefined) {
                    this.rBush_.remove(right);
                    segments.push(right.segment[1]);
                }
                if (left !== undefined && right !== undefined) {
                    /** @type {SegmentData} */ const newSegmentData = {
                        depth: segmentData.depth,
                        feature: segmentData.feature,
                        geometry: segmentData.geometry,
                        index: newIndex,
                        segment: segments
                    };
                    this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(newSegmentData.segment), newSegmentData);
                }
                this.updateSegmentIndices_(geometry, index, segmentData.depth, -1);
                if (this.vertexFeature_) {
                    this.overlay_.getSource().removeFeature(this.vertexFeature_);
                    this.vertexFeature_ = null;
                }
                dragSegments.length = 0;
            }
        }
        return deleted;
    }
    /**
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {Array} coordinates Coordinates.
   * @private
   */ setGeometryCoordinates_(geometry, coordinates) {
        this.changingFeature_ = true;
        geometry.setCoordinates(coordinates);
        this.changingFeature_ = false;
    }
    /**
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {number} index Index.
   * @param {Array<number>|undefined} depth Depth.
   * @param {number} delta Delta (1 or -1).
   * @private
   */ updateSegmentIndices_(geometry, index, depth, delta) {
        this.rBush_.forEachInExtent(geometry.getExtent(), function(segmentDataMatch) {
            if (segmentDataMatch.geometry === geometry && (depth === undefined || segmentDataMatch.depth === undefined || (0, $b998d41b678ed5d1$export$e9bab7fafb253603)(segmentDataMatch.depth, depth)) && segmentDataMatch.index > index) segmentDataMatch.index += delta;
        });
    }
}
/**
 * @param {SegmentData} a The first segment data.
 * @param {SegmentData} b The second segment data.
 * @return {number} The difference in indexes.
 */ function $8c24f34a0807f744$var$compareIndexes(a, b) {
    return a.index - b.index;
}
/**
 * Returns the distance from a point to a line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The coordinates of the point from
 *        which to calculate the distance.
 * @param {SegmentData} segmentData The object describing the line
 *        segment we are calculating the distance to.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {number} The square of the distance between a point and a line segment.
 */ function $8c24f34a0807f744$var$projectedDistanceToSegmentDataSquared(pointCoordinates, segmentData, projection) {
    const geometry = segmentData.geometry;
    if (geometry.getType() === "Circle") {
        let circleGeometry = /** @type {import("../geom/Circle.js").default} */ geometry;
        if (segmentData.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
            const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
            if (userProjection) circleGeometry = circleGeometry.clone().transform(userProjection, projection);
            const distanceToCenterSquared = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(circleGeometry.getCenter(), (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection));
            const distanceToCircumference = Math.sqrt(distanceToCenterSquared) - circleGeometry.getRadius();
            return distanceToCircumference * distanceToCircumference;
        }
    }
    const coordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection);
    $8c24f34a0807f744$var$tempSegment[0] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[0], projection);
    $8c24f34a0807f744$var$tempSegment[1] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[1], projection);
    return (0, $1bd0a226f9a16141$export$6985570514055196)(coordinate, $8c24f34a0807f744$var$tempSegment);
}
/**
 * Returns the point closest to a given line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The point to which a closest point
 *        should be found.
 * @param {SegmentData} segmentData The object describing the line
 *        segment which should contain the closest point.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {import("../coordinate.js").Coordinate} The point closest to the specified line segment.
 */ function $8c24f34a0807f744$var$closestOnSegmentData(pointCoordinates, segmentData, projection) {
    const geometry = segmentData.geometry;
    if (geometry.getType() === "Circle" && segmentData.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
        let circleGeometry = /** @type {import("../geom/Circle.js").default} */ geometry;
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection) circleGeometry = circleGeometry.clone().transform(userProjection, projection);
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(circleGeometry.getClosestPoint((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection)), projection);
    }
    const coordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection);
    $8c24f34a0807f744$var$tempSegment[0] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[0], projection);
    $8c24f34a0807f744$var$tempSegment[1] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[1], projection);
    return (0, $9c4744460e43e41b$export$698f563af1ba02a5)((0, $1bd0a226f9a16141$export$18cdd31d17f97131)(coordinate, $8c24f34a0807f744$var$tempSegment), projection);
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $8c24f34a0807f744$var$getDefaultStyleFunction() {
    const style = (0, $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac)();
    return function(feature, resolution) {
        return style["Point"];
    };
}
var $8c24f34a0807f744$export$2e2bcd8739ae039 = $8c24f34a0807f744$var$Modify;


/**
 * @module ol/interaction/DragRotateAndZoom
 */ 

/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom and rotate the map by clicking and dragging
 * on the map.  By default, this interaction is limited to when the shift
 * key is held down.
 *
 * This interaction is only supported for mouse devices.
 *
 * And this interaction is not included in the default interactions.
 * @api
 */ class $0ebfa315e165e798$var$DragRotateAndZoom extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Pointer.js").Options} */ options);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$5d31fe68a477cfbb);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastMagnitude_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const deltaX = offset[0] - size[0] / 2;
        const deltaY = size[1] / 2 - offset[1];
        const theta = Math.atan2(deltaY, deltaX);
        const magnitude = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const view = map.getView();
        if (this.lastAngle_ !== undefined) {
            const angleDelta = this.lastAngle_ - theta;
            view.adjustRotationInternal(angleDelta);
        }
        this.lastAngle_ = theta;
        if (this.lastMagnitude_ !== undefined) view.adjustResolutionInternal(this.lastMagnitude_ / magnitude);
        if (this.lastMagnitude_ !== undefined) this.lastScaleDelta_ = this.lastMagnitude_ / magnitude;
        this.lastMagnitude_ = magnitude;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
        view.endInteraction(this.duration_, direction);
        this.lastScaleDelta_ = 0;
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if (this.condition_(mapBrowserEvent)) {
            mapBrowserEvent.map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            this.lastMagnitude_ = undefined;
            return true;
        }
        return false;
    }
}
var $0ebfa315e165e798$export$2e2bcd8739ae039 = $0ebfa315e165e798$var$DragRotateAndZoom;



/**
 * @module ol/control/FullScreen
 */ 





const $213858285507f9af$var$events = [
    "fullscreenchange",
    "webkitfullscreenchange",
    "MSFullscreenChange"
];
/**
 * @enum {string}
 */ const $213858285507f9af$var$FullScreenEventType = {
    /**
   * Triggered after the map entered fullscreen.
   * @event FullScreenEventType#enterfullscreen
   * @api
   */ ENTERFULLSCREEN: "enterfullscreen",
    /**
   * Triggered after the map leave fullscreen.
   * @event FullScreenEventType#leavefullscreen
   * @api
   */ LEAVEFULLSCREEN: "leavefullscreen"
};
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes|
 *     'enterfullscreen'|'leavefullscreen', import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|
 *     'enterfullscreen'|'leavefullscreen'|import("../ObjectEventType").Types, Return>} FullScreenOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-full-screen'] CSS class name.
 * @property {string|Text|HTMLElement} [label='\u2922'] Text label to use for the button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|Text|HTMLElement} [labelActive='\u00d7'] Text label to use for the
 * button when full-screen is active.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [activeClassName=className + '-true'] CSS class name for the button
 * when full-screen is active.
 * @property {string} [inactiveClassName=className + '-false'] CSS class name for the button
 * when full-screen is inactive.
 * @property {string} [tipLabel='Toggle full-screen'] Text label to use for the button tip.
 * @property {boolean} [keys=false] Full keyboard access.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {HTMLElement|string} [source] The element to be displayed
 * fullscreen. When not provided, the element containing the map viewport will
 * be displayed fullscreen.
 */ /**
 * @classdesc
 * Provides a button that when clicked fills up the full screen with the map.
 * The full screen source element is by default the element containing the map viewport unless
 * overridden by providing the `source` option. In which case, the dom
 * element introduced using this parameter will be displayed in full screen.
 *
 * When in full screen mode, a close button is shown to exit full screen mode.
 * The [Fullscreen API](https://www.w3.org/TR/fullscreen/) is used to
 * toggle the map in full screen mode.
 *
 * @fires FullScreenEventType#enterfullscreen
 * @fires FullScreenEventType#leavefullscreen
 * @api
 */ class $213858285507f9af$var$FullScreen extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement("div"),
            target: options.target
        });
        /***
     * @type {FullScreenOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {FullScreenOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {FullScreenOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {boolean}
     */ this.keys_ = options.keys !== undefined ? options.keys : false;
        /**
     * @private
     * @type {HTMLElement|string|undefined}
     */ this.source_ = options.source;
        /**
     * @type {boolean}
     * @private
     */ this.isInFullscreen_ = false;
        /**
     * @private
     */ this.boundHandleMapTargetChange_ = this.handleMapTargetChange_.bind(this);
        /**
     * @private
     * @type {string}
     */ this.cssClassName_ = options.className !== undefined ? options.className : "ol-full-screen";
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.documentListeners_ = [];
        /**
     * @private
     * @type {Array<string>}
     */ this.activeClassName_ = options.activeClassName !== undefined ? options.activeClassName.split(" ") : [
            this.cssClassName_ + "-true"
        ];
        /**
     * @private
     * @type {Array<string>}
     */ this.inactiveClassName_ = options.inactiveClassName !== undefined ? options.inactiveClassName.split(" ") : [
            this.cssClassName_ + "-false"
        ];
        const label = options.label !== undefined ? options.label : "\u2922";
        /**
     * @private
     * @type {Text|HTMLElement}
     */ this.labelNode_ = typeof label === "string" ? document.createTextNode(label) : label;
        const labelActive = options.labelActive !== undefined ? options.labelActive : "\xd7";
        /**
     * @private
     * @type {Text|HTMLElement}
     */ this.labelActiveNode_ = typeof labelActive === "string" ? document.createTextNode(labelActive) : labelActive;
        const tipLabel = options.tipLabel ? options.tipLabel : "Toggle full-screen";
        /**
     * @private
     * @type {HTMLElement}
     */ this.button_ = document.createElement("button");
        this.button_.title = tipLabel;
        this.button_.setAttribute("type", "button");
        this.button_.appendChild(this.labelNode_);
        this.button_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        this.setClassName_(this.button_, this.isInFullscreen_);
        this.element.className = `${this.cssClassName_} ${0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29} ${0, $ce07df6d5d4656f1$export$4d4f8be70b656192}`;
        this.element.appendChild(this.button_);
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleFullScreen_();
    }
    /**
   * @private
   */ handleFullScreen_() {
        const map = this.getMap();
        if (!map) return;
        const doc = map.getOwnerDocument();
        if (!$213858285507f9af$var$isFullScreenSupported(doc)) return;
        if ($213858285507f9af$var$isFullScreen(doc)) $213858285507f9af$var$exitFullScreen(doc);
        else {
            let element;
            if (this.source_) element = typeof this.source_ === "string" ? doc.getElementById(this.source_) : this.source_;
            else element = map.getTargetElement();
            if (this.keys_) $213858285507f9af$var$requestFullScreenWithKeys(element);
            else $213858285507f9af$var$requestFullScreen(element);
        }
    }
    /**
   * @private
   */ handleFullScreenChange_() {
        const map = this.getMap();
        if (!map) return;
        const wasInFullscreen = this.isInFullscreen_;
        this.isInFullscreen_ = $213858285507f9af$var$isFullScreen(map.getOwnerDocument());
        if (wasInFullscreen !== this.isInFullscreen_) {
            this.setClassName_(this.button_, this.isInFullscreen_);
            if (this.isInFullscreen_) {
                (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.labelActiveNode_, this.labelNode_);
                this.dispatchEvent($213858285507f9af$var$FullScreenEventType.ENTERFULLSCREEN);
            } else {
                (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.labelNode_, this.labelActiveNode_);
                this.dispatchEvent($213858285507f9af$var$FullScreenEventType.LEAVEFULLSCREEN);
            }
            map.updateSize();
        }
    }
    /**
   * @param {HTMLElement} element Target element
   * @param {boolean} fullscreen True if fullscreen class name should be active
   * @private
   */ setClassName_(element, fullscreen) {
        if (fullscreen) {
            element.classList.remove(...this.inactiveClassName_);
            element.classList.add(...this.activeClassName_);
        } else {
            element.classList.remove(...this.activeClassName_);
            element.classList.add(...this.inactiveClassName_);
        }
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        const oldMap = this.getMap();
        if (oldMap) oldMap.removeChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET, this.boundHandleMapTargetChange_);
        super.setMap(map);
        this.handleMapTargetChange_();
        if (map) map.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET, this.boundHandleMapTargetChange_);
    }
    /**
   * @private
   */ handleMapTargetChange_() {
        const listeners = this.documentListeners_;
        for(let i = 0, ii = listeners.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(listeners[i]);
        listeners.length = 0;
        const map = this.getMap();
        if (map) {
            const doc = map.getOwnerDocument();
            if ($213858285507f9af$var$isFullScreenSupported(doc)) this.element.classList.remove((0, $ce07df6d5d4656f1$export$68eede0dd8c6c1da));
            else this.element.classList.add((0, $ce07df6d5d4656f1$export$68eede0dd8c6c1da));
            for(let i = 0, ii = $213858285507f9af$var$events.length; i < ii; ++i)listeners.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(doc, $213858285507f9af$var$events[i], this.handleFullScreenChange_, this));
            this.handleFullScreenChange_();
        }
    }
}
/**
 * @param {Document} doc The root document to check.
 * @return {boolean} Fullscreen is supported by the current platform.
 */ function $213858285507f9af$var$isFullScreenSupported(doc) {
    const body = doc.body;
    return !!(body["webkitRequestFullscreen"] || body.requestFullscreen && doc.fullscreenEnabled);
}
/**
 * @param {Document} doc The root document to check.
 * @return {boolean} Element is currently in fullscreen.
 */ function $213858285507f9af$var$isFullScreen(doc) {
    return !!(doc["webkitIsFullScreen"] || doc.fullscreenElement);
}
/**
 * Request to fullscreen an element.
 * @param {HTMLElement} element Element to request fullscreen
 */ function $213858285507f9af$var$requestFullScreen(element) {
    if (element.requestFullscreen) element.requestFullscreen();
    else if (element["webkitRequestFullscreen"]) element["webkitRequestFullscreen"]();
}
/**
 * Request to fullscreen an element with keyboard input.
 * @param {HTMLElement} element Element to request fullscreen
 */ function $213858285507f9af$var$requestFullScreenWithKeys(element) {
    if (element["webkitRequestFullscreen"]) element["webkitRequestFullscreen"]();
    else $213858285507f9af$var$requestFullScreen(element);
}
/**
 * Exit fullscreen.
 * @param {Document} doc The document to exit fullscren from
 */ function $213858285507f9af$var$exitFullScreen(doc) {
    if (doc.exitFullscreen) doc.exitFullscreen();
    else if (doc["webkitExitFullscreen"]) doc["webkitExitFullscreen"]();
}
var $213858285507f9af$export$2e2bcd8739ae039 = $213858285507f9af$var$FullScreen;



var $efd3ba4ec2608b1d$var$Version = "3.22";
var $efd3ba4ec2608b1d$var$ModelMode = false;
var $efd3ba4ec2608b1d$var$Nowcast = false;
var $efd3ba4ec2608b1d$var$WindMaps = false;
var $efd3ba4ec2608b1d$var$L_GDPSE = false;
var $efd3ba4ec2608b1d$var$L_SHOP = true;
var $efd3ba4ec2608b1d$var$ChoixDuoEnCour = false;
const $efd3ba4ec2608b1d$var$queryString = window.location.search;
console.log("QueryString: ", $efd3ba4ec2608b1d$var$queryString);
const $efd3ba4ec2608b1d$var$imeteoMapsParams = new URLSearchParams($efd3ba4ec2608b1d$var$queryString);
console.log("URLSearchParams: ", $efd3ba4ec2608b1d$var$imeteoMapsParams);
const $efd3ba4ec2608b1d$var$ParamWindMaps = $efd3ba4ec2608b1d$var$imeteoMapsParams.get("windmaps");
const $efd3ba4ec2608b1d$var$ParamFlot = $efd3ba4ec2608b1d$var$imeteoMapsParams.get("flot");
const $efd3ba4ec2608b1d$var$ParamFlots = $efd3ba4ec2608b1d$var$imeteoMapsParams.get("flots");
if ($efd3ba4ec2608b1d$var$imeteoMapsParams.has("windmaps")) {
    console.log("windmaps: ", $efd3ba4ec2608b1d$var$ParamWindMaps);
    console.log(" query string has windmaps");
    let chaineParamWindMaps = $efd3ba4ec2608b1d$var$ParamWindMaps.toString();
    console.log("windmaps was given as: ", chaineParamWindMaps);
    if (chaineParamWindMaps != "F" || chaineParamWindMaps != "FALSE") {
        console.log(" WinMaps is activated as requested in URL");
        $efd3ba4ec2608b1d$var$WindMaps = true;
        console.log(" shop is activated as requested in windmaps");
        $efd3ba4ec2608b1d$var$L_SHOP = true;
    } else console.log(" windmaps is not activated since F or FALSE was flaged");
} else if ($efd3ba4ec2608b1d$var$imeteoMapsParams.has("flots")) {
    console.log("flots: ", $efd3ba4ec2608b1d$var$ParamFlots);
    console.log(" query string has flots");
    let chaineParamFlots = $efd3ba4ec2608b1d$var$ParamFlots.toString();
    console.log("windmaps was given as: ", chaineParamFlots);
    if (chaineParamFlots != "F" || chaineParamFlots != "FALSE") {
        console.log(" WinMaps is activated as requested in URL via parameter: flots");
        $efd3ba4ec2608b1d$var$WindMaps = true;
        console.log(" shop is activated as requested in windmaps");
        $efd3ba4ec2608b1d$var$L_SHOP = true;
    } else console.log(" windmaps is not activated since F or FALSE was flaged via parameter: flots");
} else if ($efd3ba4ec2608b1d$var$imeteoMapsParams.has("flot")) {
    console.log("flot: ", $efd3ba4ec2608b1d$var$ParamFlot);
    console.log(" query string has flot");
    let chaineParamFlot = $efd3ba4ec2608b1d$var$ParamFlot.toString();
    console.log("windmaps was given as: ", chaineParamFlot);
    if (chaineParamFlot != "F" || chaineParamFlot != "FALSE") {
        console.log(" WinMaps is activated as requested in URL via parameter: flot");
        $efd3ba4ec2608b1d$var$WindMaps = true;
        console.log(" shop is activated as requested in windmaps");
        $efd3ba4ec2608b1d$var$L_SHOP = true;
    } else console.log(" windmaps is not activated since F or FALSE was flaged via parameter: flot");
}
const $efd3ba4ec2608b1d$var$ParamNowcast = $efd3ba4ec2608b1d$var$imeteoMapsParams.get("nowcast");
if ($efd3ba4ec2608b1d$var$imeteoMapsParams.has("nowcast") && !$efd3ba4ec2608b1d$var$WindMaps) {
    console.log("nowcast: ", $efd3ba4ec2608b1d$var$ParamNowcast);
    console.log(" query string has nowcast");
    let chaineParamNowcast = $efd3ba4ec2608b1d$var$ParamNowcast.toString();
    console.log("nowcast was given as: ", chaineParamNowcast);
    if (chaineParamNowcast != "F" || chaineParamNowcast != "FALSE") {
        console.log(" Nowcast is activated as requested in URL");
        $efd3ba4ec2608b1d$var$Nowcast = true;
    } else console.log(" Nowcast is not activated since F or FALSE was flaged");
}
if (!$efd3ba4ec2608b1d$var$Nowcast && !$efd3ba4ec2608b1d$var$WindMaps) $efd3ba4ec2608b1d$var$ModelMode = true;
const $efd3ba4ec2608b1d$var$ParamGDPSE = $efd3ba4ec2608b1d$var$imeteoMapsParams.get("europe");
if ($efd3ba4ec2608b1d$var$imeteoMapsParams.has("europe") && !$efd3ba4ec2608b1d$var$WindMaps) {
    console.log("europe: ", $efd3ba4ec2608b1d$var$ParamGDPSE);
    console.log(" query string has europe");
    let chaineParamGDPSE = $efd3ba4ec2608b1d$var$ParamGDPSE.toString();
    console.log("europe was given as: ", chaineParamGDPSE);
    if (chaineParamGDPSE != "F" || chaineParamGDPSE != "FALSE") {
        console.log(" europe is activated as requested in URL");
        $efd3ba4ec2608b1d$var$L_GDPSE = true;
    } else console.log(" GDPSE is not activated since F or FALSE was flaged");
}
const $efd3ba4ec2608b1d$var$ParamSHOP = $efd3ba4ec2608b1d$var$imeteoMapsParams.get("shop");
if ($efd3ba4ec2608b1d$var$imeteoMapsParams.has("shop")) {
    console.log("shop: ", $efd3ba4ec2608b1d$var$ParamSHOP);
    console.log(" query string has shop");
    let chaineParamSHOP = $efd3ba4ec2608b1d$var$ParamSHOP.toString();
    console.log("shop was given as: ", chaineParamSHOP);
    if (chaineParamSHOP != "F" || chaineParamSHOP != "FALSE") {
        console.log(" shop is activated as requested in URL");
        $efd3ba4ec2608b1d$var$L_SHOP = true;
    } else console.log(" SHOP is not activated since F or FALSE was flaged");
}
// ---  Preparing viewing projections ------------------------
//
(0, $a52c207aab93bf4f$export$2e2bcd8739ae039).defs("EPSG:2163", "+proj=laea +lat_0=45 +lon_0=-100 +x_0=0 +y_0=0 +a=6370997 +b=6370997 +units=m +no_defs");
(0, $a52c207aab93bf4f$export$2e2bcd8739ae039).defs("SR-ORG:8237", "+proj=stere +lat_0=90 +lat_ts=60 +lon_0=-111  +x_0=0 +y_0=0 +a=6371229 +b=6371229 +units=m +no_defs");
//  RDPS:
//  cellcentre.offset: Named num [1:2] -4551441 -7314318
//  bbox       : num [1:2, 1:2] -4556441 -7319318 4793559 920682
//
//  Origin = (-4556441.403315242379904,920682.141165949404240)
//Corner Coordinates:
//Upper Left  (-4556441.403,  920682.141) (147d34'35.51"E, 47d17'21.08"N)
//Lower Left  (-4556441.403,-7319317.859) (142d54'11.52"W, 18d 6' 5.46"N)
//Upper Right ( 4793558.597,  920682.141) ( 10d 7'40.08"W, 45d21'25.84"N)
//Lower Right ( 4793558.597,-7319317.859) ( 77d46'42.45"W, 17d17'57.97"N)
//Center      (  118558.597,-3199317.859) (108d52'39.85"W, 59d51'25.44"N)
//
//  projargs: chr +proj=stere +lat_0=90 +lat_ts=60 +lon_0=249 +k=90 +x_0=0 +y_0=0 +a=6371229 +b=6371229 +units=m +no_defs"
//
(0, $a52c207aab93bf4f$export$2e2bcd8739ae039).defs("SR-ORG:9237", "+proj=stere +lat_0=90 +lat_ts=60 +lon_0=252  +x_0=0 +y_0=0 +a=6371229 +b=6371229 +units=m +no_defs");
(0, $a52c207aab93bf4f$export$2e2bcd8739ae039).defs("SR-ORG:9238", "+proj=longlat +a=6371229 +b=6371229 +no_defs");
(0, $a52c207aab93bf4f$export$2e2bcd8739ae039).defs("EPSG:3413", "+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs");
//proj4.defs(
//  'EPSG:9001',
//  '+proj=ob_tran +o_proj=longlat +o_lon_p=0 +o_lat_p=36.08852 ' +
//        ' +lon_0=-114.694858 +R=6371229 +no_defs'
//);
///operation@kraken:~/grib/data/HRDPS_LL$ gdalsrsinfo 20230316T12Z_MSC_HRDPS_TMP_ISBL_0850_RLatLon0.0225_PT048H.grib2
///PROJ.4 : +proj=ob_tran +o_proj=longlat +o_lon_p=0 +o_lat_p=36.08852 +lon_0=-114.694858 +R=6371229 +no_defs
////   Regional OPS PS
//  RDPS
//
//
//
/*
    Images continentales:   1691 x 1235  = 2 088 385
                935 x 824=   770 440

Driver: GRIB/GRIdded Binary (.grb)
Files: CMC_reg_HGT_ISBL_700_ps10km_2021122406_P084.grib2
Size is 935, 824
Coordinate System is:
PROJCS["unnamed",
    GEOGCS["Coordinate System imported from GRIB file",
        DATUM["unknown",
            SPHEROID["Sphere",6371229,0]],
        PRIMEM["Greenwich",0],
        UNIT["degree",0.0174532925199433]],
    PROJECTION["Polar_Stereographic"],
    PARAMETER["latitude_of_origin",60],
    PARAMETER["central_meridian",249],
   PARAMETER["scale_factor",90],
    PARAMETER["false_easting",0],
    PARAMETER["false_northing",0]]
Origin = (-4556441.403315242379904,920682.141165949404240)
Pixel Size = (10000.000000000000000,-10000.000000000000000)
Corner Coordinates:
Upper Left  (-4556441.403,  920682.141) (147d34'35.51"E, 47d17'21.08"N)
Lower Left  (-4556441.403,-7319317.859) (142d54'11.52"W, 18d 6' 5.46"N)
Upper Right ( 4793558.597,  920682.141) ( 10d 7'40.08"W, 45d21'25.84"N)
Lower Right ( 4793558.597,-7319317.859) ( 77d46'42.45"W, 17d17'57.97"N)
Center      (  118558.597,-3199317.859) (108d52'39.85"W, 59d51'25.44"N)
Band 1 Block=935x1 Type=Float64, ColorInterp=Undefined
  Description = 69999999999999992861909247110435160666542483456969070400199778929114697432472734636454224471710480991647905381140924834250752[Pa] ISBL="Isobaric surface"
  NoData Value=9999
  Metadata:
    oRIB_COMMENT=Geopotential height [gpm]
    GRIB_ELEMENT=HGT
    GRIB_FORECAST_SECONDS=302400 sec
    GRIB_PDS_PDTN=0
    GRIB_PDS_TEMPLATE_NUMBERS=3 5 2 36 36 0 0 0 1 0 0 0 84 100 132 0 0 0 7 255 255 255 255 255 255
    GRIB_REF_TIME=  1640325600 sec UTC
    GRIB_SHORT_NAME=69999999999999992861909247110435160666542483456969070400199778929114697432472734636454224471710480991647905381140924834250752-ISBL
    GRIB_UNIT=[gpm]
    GRIB_VALID_TIME=  1640628000 sec UTC
*/ /*
//  HRDPS:
    //     Images EAST   1870 x 1188    = 2 221 560
    //     Images WEST   1870 x 1231    = 2 301 970
    //     2576 x 1456          = 3 750 656

    //  Driver: GRIB/GRIdded Binary (.grb)
Files: CMC_hrdps_continental_WEARN_SFC_0_ps2.5km_2021122406_P048-00.grib2
Size is 2576, 1456
Coordinate System is:
PROJCS["unnamed",
    GEOGCS["Coordinate System imported from GRIB file",
        DATUM["unknown",
            SPHEROID["Sphere",6371229,0]],
        PRIMEM["Greenwich",0],
        UNIT["degree",0.0174532925199433]],
    PROJECTION["Polar_Stereographic"],
    PARAMETER["latitude_of_origin",60],
    PARAMETER["central_meridian",252],
    PARAMETER["scale_factor",90],
    PARAMETER["false_easting",0],
    PARAMETER["false_northing",0]]
Origin = (-2099127.494496937375516,-2099388.521499627269804)
Pixel Size = (2500.000000000000000,-2500.000000000000000)
Corner Coordinates:
Upper Left  (-2099127.494,-2099388.521) (152d59'47.18"W, 61d57'30.73"N)
Lower Left  (-2099127.494,-5739388.521) (128d 5'22.27"W, 35d35'28.15"N)
Upper Right ( 4340872.506,-2099388.521) ( 43d48'35.77"W, 45d50'49.32"N)
Lower Right ( 4340872.506,-5739388.521) ( 70d53'55.27"W, 27d37'43.23"N)
Center      ( 1120872.506,-3919388.521) ( 92d 2'25.63"W, 52d 8'52.39"N)
Band 1 Block=2576x1 Type=Float64, ColorInterp=Undefined
  Description = 0[-] SFC="Ground or water surface"
  NoData Value=9999
  Metadata:
    GRIB_COMMENT=Rain precipitation rate [kg/(m^2*s)]
    GRIB_ELEMENT=RPRATE
    GRIB_FORECAST_SECONDS=0 sec
    GRIB_PDS_PDTN=8
    GRIB_PDS_TEMPLATE_NUMBERS=1 65 2 50 50 0 0 0 1 0 0 0 0 1 0 0 0 0 0 255 255 255 255 255 255 7 229 12 26 6 0 0 1 0 0 0 0 1 2 1 0 0 0 48 1 0 0 0 0
    GRIB_REF_TIME=  1640325600 sec UTC
    GRIB_SHORT_NAME=0-SFC
    GRIB_UNIT=[kg/(m^2*s)]
    GRIB_VALID_TIME=  1640498400 sec UTC
*/ //
//  GDPS:
//
//  Images NOAM:     1573 x 1238 = 1 947 374
//                   2400 x 1201 = 2 882 400
//
//  cellcentre.offset: Named num [1:2] -180 -90
//  bbox       : num [1:2, 1:2] -180 -90.1 180 90.1
//  projargs: chr "+proj=longlat +a=6371229 +b=6371229 +no_defs"
//
/*
Files: CMC_glb_HGT_ISBY_1000-500_latlon.15x.15_2021122400_P240.grib2
Size is 2400, 1201
Coordinate System is:
GEOGCS["Coordinate System imported from GRIB file",
    DATUM["unknown",
        SPHEROID["Sphere",6371229,0]],
    PRIMEM["Greenwich",0],
    UNIT["degree",0.0174532925199433]]
Origin = (179.925000000000011,90.075000000000003)
Pixel Size = (0.150000000000000,-0.150000000000000)
Corner Coordinates:
Upper Left  ( 179.9250000,  90.0750000) (179d55'30.00"E, 90d 4'30.00"N)
Lower Left  ( 179.9250000, -90.0750000) (179d55'30.00"E, 90d 4'30.00"S)
Upper Right (     539.925,      90.075) (Invalid angle, 90d 4'30.00"N)
Lower Right (     539.925,     -90.075) (Invalid angle, 90d 4'30.00"S)
Center      (     359.925,       0.000) (359d55'30.00"E,  0d 0' 0.01"N)
Band 1 Block=2400x1 Type=Float64, ColorInterp=Undefined
  Description = 999999999999999977709969731404129670057984297594921577392083322662491290889839886077866558841507631684757522070951350501376-49999999999999996243388080949644102127233543491741923071961298611264709998789651330158174688140882687576502920682776614141952[Pa] ISBL="Isobaric surface"
  Metadata:
    GRIB_COMMENT=Thickness [m]
    GRIB_ELEMENT=THICK
    GRIB_FORECAST_SECONDS=864000 sec
    GRIB_PDS_PDTN=0
    GRIB_PDS_TEMPLATE_NUMBERS=3 12 2 47 47 0 0 0 1 0 0 0 240 100 133 0 0 0 1 100 132 0 0 0 5
    GRIB_REF_TIME=  1640304000 sec UTC
    GRIB_SHORT_NAME=999999999999999977709969731404129670057984297594921577392083322662491290889839886077866558841507631684757522070951350501376-49999999999999996243388080949644102127233543491741923071961298611264709998789651330158174688140882687576502920682776614141952-ISBL
    GRIB_UNIT=[m]
    GRIB_VALID_TIME=  1641168000 sec UTC
*/ /*
//                GFS
    //                GFS NOAM:   980 x 795 = 779 100
    //                  1440 x 721      = 1 038 240
Driver: GRIB/GRIdded Binary (.grb)
Files: NWS_glb_WEASN_SFC_0_latlon.25x.25_2021122400_P120.grib2
Size is 1440, 721
Coordinate System is:
GEOGCS["Coordinate System imported from GRIB file",
    DATUM["unknown",
        SPHEROID["Sphere",6371229,0]],
    PRIMEM["Greenwich",0],
    UNIT["degree",0.0174532925199433]]
Origin = (-0.125000000000000,90.125000000000000)
Pixel Size = (0.250000000000000,-0.250000000000000)
Corner Coordinates:
Upper Left  (  -0.1250000,  90.1250000) (  0d 7'30.00"W, 90d 7'30.00"N)
Lower Left  (  -0.1250000, -90.1250000) (  0d 7'30.00"W, 90d 7'30.00"S)
Upper Right (     359.875,      90.125) (359d52'30.00"E, 90d 7'30.00"N)
Lower Right (     359.875,     -90.125) (359d52'30.00"E, 90d 7'30.00"S)
Center      ( 179.8750000,   0.0000000) (179d52'30.00"E,  0d 0' 0.01"N)
Band 1 Block=1440x1 Type=Float64, ColorInterp=Undefined
  Description = 0[-] SFC="Ground or water surface"
  Metadata:
    GRIB_COMMENT=Categorical Snow [0=no; 1=yes]
    GRIB_ELEMENT=CSNOW
    GRIB_FORECAST_SECONDS=432000 sec
    GRIB_PDS_PDTN=0
    GRIB_PDS_TEMPLATE_NUMBERS=1 195 2 0 96 0 0 0 1 0 0 0 120 1 0 0 0 0 0 255 0 0 0 0 0
    GRIB_REF_TIME=  1640304000 sec UTC
    GRIB_SHORT_NAME=0-SFC
    GRIB_UNIT=[0=no; 1=yes]
    GRIB_VALID_TIME=  1640736000 sec UTC
Band 2 Block=1440x1 Type=Float64, ColorInterp=Undefined
  Description = 0[-] SFC="Ground or water surface"
  Metadata:
    GRIB_COMMENT=Categorical Snow [0=no; 1=yes]
    GRIB_ELEMENT=CSNOW
    GRIB_FORECAST_SECONDS=410400 sec
    GRIB_PDS_PDTN=8
    GRIB_PDS_TEMPLATE_NUMBERS=1 195 2 0 96 0 0 0 1 0 0 0 114 1 0 0 0 0 0 255 0 0 0 0 0 7 229 12 29 0 0 0 1 0 0 0 0 0 2 1 0 0 0 6 255 0 0 0 0
    GRIB_REF_TIME=  1640304000 sec UTC
    GRIB_SHORT_NAME=0-SFC
    GRIB_UNIT=[0=no; 1=yes]
    GRIB_VALID_TIME=  1640736000 sec UTC
*/ //proj4.defs(
//  'SR-ORG:100999',
//  '+proj=nsper +lat_0=45 +lon_0=-100 +units=m +h=3000000 +ellps=WGS84 +datum=WGS84 ' 
//);
(0, $2f5e3cce9f26ffcd$export$6503ec6e8aabbaf)((0, $a52c207aab93bf4f$export$2e2bcd8739ae039));
const $efd3ba4ec2608b1d$var$proj2163 = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("EPSG:2163");
$efd3ba4ec2608b1d$var$proj2163.setExtent((0, $9c4744460e43e41b$export$751c68e0e0efff79)([
    -145,
    5,
    -35,
    75
], "EPSG:4326", "EPSG:2163"));
const $efd3ba4ec2608b1d$var$proj8237 = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("SR-ORG:8237");
//proj8237.setExtent( transformExtent( [-180, -50, 0, 0  ], 'EPSG:4326', 'SR-ORG:8237' ) );
//proj8237.setExtent( [-4556441.403, -7319317.859, 4793558.597 , 920682.141 ] );
$efd3ba4ec2608b1d$var$proj8237.setExtent((0, $9c4744460e43e41b$export$751c68e0e0efff79)([
    -155,
    -5,
    0,
    55
], "EPSG:4326", "SR-ORG:8237"));
const $efd3ba4ec2608b1d$var$proj9237 = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("SR-ORG:9237");
//proj9237.setExtent( [ -2099127.494, -5739388.521,  4340872.506,-2099388.521 ] );
$efd3ba4ec2608b1d$var$proj9237.setExtent((0, $9c4744460e43e41b$export$751c68e0e0efff79)([
    -155,
    -5,
    0,
    55
], "EPSG:4326", "SR-ORG:9237"));
const $efd3ba4ec2608b1d$var$proj9238 = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("SR-ORG:9238");
$efd3ba4ec2608b1d$var$proj9238.setExtent([
    -180,
    -90,
    180,
    90
]);
//Upper Left  (-4556441.403,  920682.141) (147d34'35.51"E, 47d17'21.08"N)
//Lower Left  (-4556441.403,-7319317.859) (142d54'11.52"W, 18d 6' 5.46"N)
//Upper Right ( 4793558.597,  920682.141) ( 10d 7'40.08"W, 45d21'25.84"N)
//Lower Right ( 4793558.597,-7319317.859) ( 77d46'42.45"W, 17d17'57.97"N)
//Center      (  118558.597,-3199317.859) (108d52'39.85"W, 59d51'25.44"N)
//projargs: chr +proj=stere +lat_0=90 +lat_ts=60 +lon_0=249 +k=90 +x_0=0 +y_0=0 +a=6371229 +b=6371229 +units=m +no_defs"
/*function LonLatToXY(lon, lat, rayon, ecc, lat0, lon0) {

    //%convert to radians
    var degtorad = Math.PI/180.;

        var lonR= lon * degtorad;
    var latR = lat * degtorad;
    var lat0R = lat0 * degtorad;
    var lon0R = lon0 * degtorad;

        var k = 2/( 1 + Math.sin( lat0R )*Math.sin( latR ) + Math.cos( lat0R )*Math.cos( latR )*Math.cos( lonR-lon0R  ) ) ;

    var x = rayon * k * Math.cos( latR ) * Math.sin( lonR-lon0R  );
    var y = rayon * k * ( Math.cos( lat0R )*Math.sin( latR ) - Math.sin( lat0R )*Math.cos( latR )*Math.cos( lonR-lon0R  )  );

    var point = [];
    point[0] = x;
    point[1] = y;

    return point;
 }

var point = LonLatToXY( -142.8968 , 18.1429, 6371229, 1, 60, -111);
*/ const $efd3ba4ec2608b1d$var$proj3413 = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("EPSG:3413");
//proj3413.setExtent( [-5194304, -5194304, 4194304, 4194304] );
$efd3ba4ec2608b1d$var$proj3413.setExtent([
    -5693528,
    -6627744,
    603750,
    751207
]);
//const proj9001 = getProjection('EPSG:9001');
//proj9001.setExtent( transformExtent( [-180, 89, 0, 0], 'EPSG:4326', 'EPSG:9001' ) );
//const proj100999 = getProjection('SR-ORG:100999');
//proj100999.setExtent( transformExtent( [-145, 05, -40, 75 ], 'EPSG:4326', 'SR-ORG:100999' ) );
const $efd3ba4ec2608b1d$var$projView = "EPSG:3857";
const $efd3ba4ec2608b1d$var$attribution1 = new (0, $6a26ab11104d2c24$export$2e2bcd8739ae039)({
    collapsible: true,
    collapsed: true
});
const $efd3ba4ec2608b1d$var$attribution2 = new (0, $6a26ab11104d2c24$export$2e2bcd8739ae039)({
    collapsible: true,
    collapsed: true
});
// var WrapperFull = "fullscreen-wrapper";
var $efd3ba4ec2608b1d$var$WrapperFull = "total-wrapper";
const $efd3ba4ec2608b1d$var$map = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)({
    controls: (0, $af7495b2f822d5e9$export$ebe90cb607ad99e)({
        attribution: false
    }).extend([
        new (0, $213858285507f9af$export$2e2bcd8739ae039)({
            source: $efd3ba4ec2608b1d$var$WrapperFull
        })
    ], [
        $efd3ba4ec2608b1d$var$attribution1
    ]),
    interactions: (0, $e3fbd36d629ecc04$export$ebe90cb607ad99e)().extend([
        new (0, $0ebfa315e165e798$export$2e2bcd8739ae039)()
    ]),
    moveTolerance: 10,
    maxTilesLoading: 256,
    target: "map",
    view: new (0, $70364d0195659942$export$2e2bcd8739ae039)({
        center: (0, $9c4744460e43e41b$export$b15d9668511529b9)([
            -88,
            45
        ], $efd3ba4ec2608b1d$var$projView),
        zoom: 5,
        projection: $efd3ba4ec2608b1d$var$projView,
        constrainResolution: false
    })
});
$efd3ba4ec2608b1d$var$map.addControl($efd3ba4ec2608b1d$var$attribution1);
const $efd3ba4ec2608b1d$var$map2 = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)({
    controls: (0, $af7495b2f822d5e9$export$ebe90cb607ad99e)({
        attribution: false
    }).extend([
        new (0, $213858285507f9af$export$2e2bcd8739ae039)({
            source: $efd3ba4ec2608b1d$var$WrapperFull
        })
    ], [
        $efd3ba4ec2608b1d$var$attribution2
    ]),
    interactions: (0, $e3fbd36d629ecc04$export$ebe90cb607ad99e)().extend([
        new (0, $0ebfa315e165e798$export$2e2bcd8739ae039)()
    ]),
    moveTolerance: 10,
    maxTilesLoading: 256,
    target: "map2",
    view: new (0, $70364d0195659942$export$2e2bcd8739ae039)({
        center: (0, $9c4744460e43e41b$export$b15d9668511529b9)([
            -88,
            45
        ], $efd3ba4ec2608b1d$var$projView),
        zoom: 5,
        projection: $efd3ba4ec2608b1d$var$projView,
        constrainResolution: false
    })
});
$efd3ba4ec2608b1d$var$map2.addControl($efd3ba4ec2608b1d$var$attribution2);
const $efd3ba4ec2608b1d$var$LightBasemap = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    title: "LightBasemap",
    zIndex: 0,
    visible: true,
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>'
    })
});
const $efd3ba4ec2608b1d$var$LightBasemap2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    title: "LightBasemap",
    zIndex: 0,
    visible: true,
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>'
    })
});
const $efd3ba4ec2608b1d$var$DarkBasemap = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    title: "DarkBasemap",
    zIndex: 0,
    visible: false,
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>'
    })
});
const $efd3ba4ec2608b1d$var$DarkBasemap2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    title: "DarkBasemap",
    zIndex: 0,
    visible: false,
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>'
    })
});
const $efd3ba4ec2608b1d$var$OSMStandard = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: new (0, $6c8498cc816f2362$export$2e2bcd8739ae039)({
        attributions: ' Basemap &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>'
    }),
    projection: $efd3ba4ec2608b1d$var$projView || "EPSG:4326",
    zIndex: 0,
    visible: false,
    title: "OSMStandard"
});
const $efd3ba4ec2608b1d$var$OSMStandard2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: new (0, $6c8498cc816f2362$export$2e2bcd8739ae039)({
        attributions: ' Basemap &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>'
    }),
    projection: $efd3ba4ec2608b1d$var$projView || "EPSG:4326",
    zIndex: 0,
    visible: false,
    title: "OSMStandard",
    attributions: ' Basemap &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>'
});
//_______________________________________________________________
const $efd3ba4ec2608b1d$var$sourceAhocevar = new (0, $6a269de6fca6e364$export$2e2bcd8739ae039)({
    url: "https://ahocevar.com/geoserver/wms",
    projection: $efd3ba4ec2608b1d$var$projView || "EPSG:4326",
    params: {
        "LAYERS": "ne:NE1_HR_LC_SR_W_DR",
        "TILED": true,
        attributions: 'Basemap &copy; <a href="https://ahocevar.com"> Ahocevar</a> &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>'
    }
});
const $efd3ba4ec2608b1d$var$Ahocevar = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceAhocevar,
    zIndex: 0,
    visible: false,
    title: "Ahocevar"
});
const $efd3ba4ec2608b1d$var$Ahocevar2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceAhocevar,
    zIndex: 0,
    visible: false,
    title: "Ahocevar"
});
var $efd3ba4ec2608b1d$var$Visible = true;
if ($efd3ba4ec2608b1d$var$WindMaps) $efd3ba4ec2608b1d$var$Visible = false;
//_______________________________________________________________
///   Hydro :   contour et filled...   lacs et rivières...
const $efd3ba4ec2608b1d$var$sourceCanvecHydro = new (0, $6a269de6fca6e364$export$2e2bcd8739ae039)({
    url: "https://maps.geogratis.gc.ca/wms/canvec_en",
    params: {
        "LAYERS": "hydro",
        "TILED": true
    },
    projection: "EPSG:4326",
    serverType: "geoserver",
    transition: 0
});
const $efd3ba4ec2608b1d$var$CanvecHydro = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceCanvecHydro,
    minZoom: 29,
    zIndex: 10,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "CanvecHydro"
});
const $efd3ba4ec2608b1d$var$CanvecHydro2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceCanvecHydro,
    minZoom: 29,
    zIndex: 10,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "CanvecHydro"
});
//_______________________________________________________________
///   Elevation :   contour topographiques 
const $efd3ba4ec2608b1d$var$sourceCanvecElevation = new (0, $6a269de6fca6e364$export$2e2bcd8739ae039)({
    url: "https://maps.geogratis.gc.ca/wms/canvec_en",
    params: {
        "LAYERS": "elevation",
        "TILED": true
    },
    projection: $efd3ba4ec2608b1d$var$projView || "EPSG:4326",
    minZoom: 6,
    serverType: "geoserver",
    transition: 0
});
const $efd3ba4ec2608b1d$var$CanvecElevation = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceCanvecElevation,
    zIndex: 10,
    visible: false,
    title: "CanvecElevation"
});
const $efd3ba4ec2608b1d$var$CanvecElevation2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceCanvecElevation,
    zIndex: 10,
    visible: false,
    title: "CanvecElevation"
});
//_______________________________________________________________
const $efd3ba4ec2608b1d$var$sourceCanvecAdmin = new (0, $6a269de6fca6e364$export$2e2bcd8739ae039)({
    url: "https://maps.geogratis.gc.ca/wms/canvec_en",
    params: {
        "LAYERS": "('boundary_small', 'boundary_mid', 'boundary_large_01', 'boundary_large_02', 'boundary_large_03')",
        "TILED": true
    },
    projection: "EPSG:4326",
    minZoom: 6,
    serverType: "geoserver",
    transition: 0,
    zDirection: 0,
    zIndex: 98
});
const $efd3ba4ec2608b1d$var$CanvecAdmin = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceCanvecAdmin,
    zIndex: 98,
    visible: false,
    title: "CanvecAdmin"
});
const $efd3ba4ec2608b1d$var$CanvecAdmin2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceCanvecAdmin,
    zIndex: 98,
    visible: false,
    title: "CanvecAdmin"
});
//_______________________________________________________________
//   Toponymie:  bon pour les noms de lacs et Montagnes...
const $efd3ba4ec2608b1d$var$sourceCanvecToponymy = new (0, $6a269de6fca6e364$export$2e2bcd8739ae039)({
    url: "https://maps.geogratis.gc.ca/wms/canvec_en",
    params: {
        "LAYERS": "toponymy",
        "TILED": true
    },
    projection: "EPSG:4326",
    minZoom: 6,
    serverType: "geoserver",
    transition: 0,
    zDirection: 0,
    zIndex: 98
});
const $efd3ba4ec2608b1d$var$CanvecToponymy = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceCanvecToponymy,
    zIndex: 98,
    visible: false,
    title: "CanvecToponymy"
});
const $efd3ba4ec2608b1d$var$CanvecToponymy2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceCanvecToponymy,
    zIndex: 98,
    visible: false,
    title: "CanvecToponymy"
});
$efd3ba4ec2608b1d$var$Visible = true;
if ($efd3ba4ec2608b1d$var$WindMaps) $efd3ba4ec2608b1d$var$Visible = true;
//_______________________________________________________________
//  Transport
const $efd3ba4ec2608b1d$var$sourceCanvecTransport = new (0, $6a269de6fca6e364$export$2e2bcd8739ae039)({
    url: "https://maps.geogratis.gc.ca/wms/canvec_en",
    params: {
        "LAYERS": "transport",
        "TILED": true
    },
    projection: "EPSG:4326",
    serverType: "geoserver",
    transition: 0,
    zDirection: 0,
    zIndex: 98
});
const $efd3ba4ec2608b1d$var$CanvecTransport = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceCanvecTransport,
    minZoom: 30,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "CanvecTransport"
});
const $efd3ba4ec2608b1d$var$CanvecTransport2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$sourceCanvecTransport,
    minZoom: 30,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "CanvecTransport"
});
//
//  stand alone Top map layers :  geographical references to render on top of the weather information
//  in order to provide geographical reference even when the weather information is colored and opaque
//
//  Those are selctable on the layer switcher
//
$efd3ba4ec2608b1d$var$Visible = true;
// Style pour les frontières des pays,  rivièeres,  coastlines,  etc
const $efd3ba4ec2608b1d$var$lineStyleDarkGrey = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: [
            100,
            100,
            100,
            1.0
        ],
        width: 1
    })
});
const $efd3ba4ec2608b1d$var$lineStyleLightGrey = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: [
            160,
            160,
            160,
            1.0
        ],
        width: 1
    })
});
const $efd3ba4ec2608b1d$var$lineStyleBlue = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: [
            100,
            150,
            255,
            1.0
        ],
        width: 1
    })
});
const $efd3ba4ec2608b1d$var$lineStyleGreen = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: [
            100,
            255,
            150,
            1.0
        ],
        width: 1
    })
});
const $efd3ba4ec2608b1d$var$lineStyleCyan = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: [
            100,
            255,
            255,
            1.0
        ],
        width: 1
    })
});
const $efd3ba4ec2608b1d$var$countryStyleWhite = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: [
            255,
            255,
            255,
            1.0
        ],
        width: 2
    })
});
const $efd3ba4ec2608b1d$var$countryStyleColor = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: [
            153,
            153,
            102,
            1.0
        ],
        width: 1
    })
});
// 153,153,102 is #999966
const $efd3ba4ec2608b1d$var$countryStyleRiverColor = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: [
            136,
            136,
            170,
            1.0
        ],
        width: 1
    })
});
//  136 136 170  is #8888AA
//   vectorSource json are obtained from ogr2ogr procedure applied to shapefiles 
//   vectorSource names tagged as NE  were derived from shapefiles at source:
//                https://www.naturalearthdata.com/downloads/
const $efd3ba4ec2608b1d$var$vectorSourceNE_stateProv = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
    format: new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)(),
    projection: "EPSG:4326",
    url: "../maps/geoJSON/states_prov.json",
    attributions: '<a href="https://www.naturalearthdata.com"> NaturelEarth</a>'
});
// style: [countryStyleWhite, lineStyleDarkGrey],
const $efd3ba4ec2608b1d$var$vectorLayerNE_stateProv = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceNE_stateProv,
    style: $efd3ba4ec2608b1d$var$countryStyleColor,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "vectorLayerNE_stateProv"
});
const $efd3ba4ec2608b1d$var$vectorLayerNE_stateProv2 = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceNE_stateProv,
    style: $efd3ba4ec2608b1d$var$countryStyleColor,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "vectorLayerNE_stateProv"
});
//   ---------------------------------------------------------
//   Rivers and Lakes   2 sources,  considering the North america extention
//   ---------------------------------------------------------
const $efd3ba4ec2608b1d$var$vectorSourceNE_rivers_lake = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
    format: new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)(),
    projection: "EPSG:4326",
    url: "../maps/geoJSON/rivers_lake.json",
    attributions: '<a href="https://www.naturalearthdata.com"> NaturelEarth</a>'
});
const $efd3ba4ec2608b1d$var$vectorLayerNE_rivers_lake = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceNE_rivers_lake,
    style: $efd3ba4ec2608b1d$var$countryStyleRiverColor,
    minZoom: 23,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "vectorLayerNE_rivers_lake"
});
const $efd3ba4ec2608b1d$var$vectorLayerNE_rivers_lake2 = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceNE_rivers_lake,
    style: $efd3ba4ec2608b1d$var$countryStyleRiverColor,
    minZoom: 23,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "vectorLayerNE_rivers_lake"
});
//   North america extention
const $efd3ba4ec2608b1d$var$vectorSourceNE_rivers = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
    format: new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)(),
    projection: "EPSG:4326",
    url: "../maps/geoJSON/rivers_NA.json"
});
const $efd3ba4ec2608b1d$var$vectorLayerNE_rivers = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceNE_rivers,
    style: $efd3ba4ec2608b1d$var$countryStyleRiverColor,
    minZoom: 23,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "vectorLayerNE_rivers"
});
const $efd3ba4ec2608b1d$var$vectorLayerNE_rivers2 = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceNE_rivers,
    style: $efd3ba4ec2608b1d$var$countryStyleRiverColor,
    minZoom: 23,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "vectorLayerNE_rivers"
});
//   vectorSource json are obtained from ogr2ogr procedure applied to shapefiles 
//   example:  ogr2ogr -f GeoJSON river_NA.json ne_10m_rivers_north_america_unzip/rivers_NA.shp
//   vectorSource names tagged as CAN?  or USA?  were derived fromi shapefile at source:
//               https://www.geoboundaries.org/api.html#api   
//   attribution:   "geoBoundaries" 'https://www.geoboundaries.org/api.html#api'
//  Canada admin level zero:   better source found  for detailed islands and coastlines 
//                              including st-Laurent river downstream Sorel
const $efd3ba4ec2608b1d$var$vectorSourceCAN0 = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
    format: new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)(),
    projection: "EPSG:4326",
    url: "../maps/geoJSON/CAN_ADM0.json",
    attributions: '<a href="https://www.geoboundaries.org/api.html#api"> geoBoudaries</a>'
});
const $efd3ba4ec2608b1d$var$vectorLayerCAN0 = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceCAN0,
    style: $efd3ba4ec2608b1d$var$countryStyleColor,
    minZoom: 24,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "vectorLayerCAN0"
});
const $efd3ba4ec2608b1d$var$vectorLayerCAN02 = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceCAN0,
    style: $efd3ba4ec2608b1d$var$countryStyleColor,
    minZoom: 24,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "vectorLayerCAN0"
});
//  USA admin level zero: 
//                       better source found  for detailed islands and coastlines 
//                       including Great lakes                       
const $efd3ba4ec2608b1d$var$vectorSourceUSA0 = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
    format: new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)(),
    projection: "EPSG:4326",
    url: "../maps/geoJSON/USA_ADM0.json",
    attributions: '<a href="https://www.geoboundaries.org/api.html#api"> geoBoudaries</a>'
});
const $efd3ba4ec2608b1d$var$vectorLayerUSA0 = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceUSA0,
    style: $efd3ba4ec2608b1d$var$countryStyleColor,
    minZoom: 24,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "vectorLayerUSA0"
});
const $efd3ba4ec2608b1d$var$vectorLayerUSA02 = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceUSA0,
    style: $efd3ba4ec2608b1d$var$countryStyleColor,
    minZoom: 24,
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "vectorLayerUSA0"
});
$efd3ba4ec2608b1d$var$Visible = false;
const $efd3ba4ec2608b1d$var$StandFordContour = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: new (0, $6a269de6fca6e364$export$2e2bcd8739ae039)({
        url: "https://geowebservices.stanford.edu/geoserver/wms",
        params: {
            "LAYERS": "druid:hz772ng0160",
            "TILED": true
        },
        //projection: 'EPSG:3857',
        projection: $efd3ba4ec2608b1d$var$projView || "EPSG:4326",
        maxZoom: 10,
        serverType: "geoserver",
        //  so do not fade tiles:
        transition: 0,
        zIndex: 98,
        attributions: '<a href="https://geowebservices.stanford.edu/geoserver/web/"> Stanford U.</a>'
    }),
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "StandFordContour"
});
const $efd3ba4ec2608b1d$var$StandFordContour2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: new (0, $6a269de6fca6e364$export$2e2bcd8739ae039)({
        url: "https://geowebservices.stanford.edu/geoserver/wms",
        params: {
            "LAYERS": "druid:hz772ng0160",
            "TILED": true
        },
        projection: $efd3ba4ec2608b1d$var$projView || "EPSG:4326",
        maxZoom: 10,
        serverType: "geoserver",
        //  so do not fade tiles:
        transition: 0,
        zIndex: 98,
        attributions: '<a href="https://geowebservices.stanford.edu/geoserver/web/"> Stanford U.</a>'
    }),
    zIndex: 98,
    visible: $efd3ba4ec2608b1d$var$Visible,
    title: "StandFordContour"
});
//
//  Top map layers Labels:  geographical references Label to render on top of the weather information
//  in order to provide geographical reference even when the weather information is colored and opaque
//
//   These Labels are paired with Basemaps:  they are not offered in the layer swithcher
//   They are set to visible when their associated basemap is selcted
//   For this to work,   it is important that their titles match with the basemap with the addition of "Labels"
//   comme pour Basemap   remplacer l'URL par Reference  au lieu de Base pour ESRi:
const $efd3ba4ec2608b1d$var$LightLabels = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    title: "LightBasemapLabels",
    zIndex: 100,
    visible: true,
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        zDirection: 1
    })
});
const $efd3ba4ec2608b1d$var$LightLabels2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    title: "LightBasemapLabels",
    zIndex: 100,
    visible: true,
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        zDirection: 1
    })
});
//const LightLabels = new TileLayer({
//      source: new XYZ({
//        url: 'https://{1-4}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png',
//        projection: 'EPSG:3857',
//    zDirection: 1,
//     }),
//     zIndex: 100,
//     visible: true,
//     title: 'LightBasemapLabels',
//  });
const $efd3ba4ec2608b1d$var$DarkLabels = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    title: "DarkBasemapLabels",
    zIndex: 100,
    visible: true,
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        zDirection: 1
    })
});
const $efd3ba4ec2608b1d$var$DarkLabels2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    title: "DarkBasemapLabels",
    zIndex: 100,
    visible: true,
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        zDirection: 1
    })
});
const $efd3ba4ec2608b1d$var$OSMStandardLabels = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        projection: "EPSG:3857",
        zDirection: 1
    }),
    zIndex: 100,
    visible: false,
    title: "OSMStandardLabels"
});
const $efd3ba4ec2608b1d$var$OSMStandardLabels2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        projection: "EPSG:3857",
        zDirection: 1
    }),
    zIndex: 100,
    visible: false,
    title: "OSMStandardLabels"
});
const $efd3ba4ec2608b1d$var$AhocevarLabels = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        projection: "EPSG:3857",
        zDirection: 1
    }),
    zIndex: 100,
    visible: false,
    title: "AhocevarLabels"
});
const $efd3ba4ec2608b1d$var$AhocevarLabels2 = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
    source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}",
        attributions: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
        projection: "EPSG:3857",
        zDirection: 1
    }),
    zIndex: 100,
    visible: false,
    title: "AhocevarLabels"
});
// Basemaps layer group
const $efd3ba4ec2608b1d$var$BaseLayerGroup1 = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$LightBasemap,
        $efd3ba4ec2608b1d$var$DarkBasemap,
        $efd3ba4ec2608b1d$var$OSMStandard,
        $efd3ba4ec2608b1d$var$Ahocevar
    ]
});
const $efd3ba4ec2608b1d$var$BaseLayerGroup2 = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$LightBasemap2,
        $efd3ba4ec2608b1d$var$DarkBasemap2,
        $efd3ba4ec2608b1d$var$OSMStandard2,
        $efd3ba4ec2608b1d$var$Ahocevar2
    ]
});
// Basemaps overlay layer group 
const $efd3ba4ec2608b1d$var$BaseOverlayLayerGroup1 = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$CanvecHydro,
        $efd3ba4ec2608b1d$var$CanvecElevation
    ]
});
const $efd3ba4ec2608b1d$var$BaseOverlayLayerGroup2 = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$CanvecHydro2,
        $efd3ba4ec2608b1d$var$CanvecElevation2
    ]
});
//
//  stand alone Top maps layers group
//
const $efd3ba4ec2608b1d$var$TopLayerGroup1 = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$CanvecAdmin,
        $efd3ba4ec2608b1d$var$CanvecToponymy,
        $efd3ba4ec2608b1d$var$CanvecTransport,
        $efd3ba4ec2608b1d$var$vectorLayerNE_stateProv,
        $efd3ba4ec2608b1d$var$vectorLayerNE_rivers,
        $efd3ba4ec2608b1d$var$vectorLayerNE_rivers_lake,
        $efd3ba4ec2608b1d$var$vectorLayerCAN0,
        $efd3ba4ec2608b1d$var$vectorLayerUSA0,
        $efd3ba4ec2608b1d$var$StandFordContour
    ]
});
const $efd3ba4ec2608b1d$var$TopLayerGroup2 = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$CanvecAdmin2,
        $efd3ba4ec2608b1d$var$CanvecToponymy2,
        $efd3ba4ec2608b1d$var$CanvecTransport2,
        $efd3ba4ec2608b1d$var$vectorLayerNE_stateProv2,
        $efd3ba4ec2608b1d$var$vectorLayerNE_rivers2,
        $efd3ba4ec2608b1d$var$vectorLayerNE_rivers_lake2,
        $efd3ba4ec2608b1d$var$vectorLayerCAN02,
        $efd3ba4ec2608b1d$var$vectorLayerUSA02,
        $efd3ba4ec2608b1d$var$StandFordContour2
    ]
});
//
//    Top Layer Label group
//
const $efd3ba4ec2608b1d$var$TopLayerLabelGroup1 = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$LightLabels,
        $efd3ba4ec2608b1d$var$DarkLabels,
        $efd3ba4ec2608b1d$var$OSMStandardLabels,
        $efd3ba4ec2608b1d$var$AhocevarLabels
    ]
});
const $efd3ba4ec2608b1d$var$TopLayerLabelGroup2 = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$LightLabels2,
        $efd3ba4ec2608b1d$var$DarkLabels2,
        $efd3ba4ec2608b1d$var$OSMStandardLabels2,
        $efd3ba4ec2608b1d$var$AhocevarLabels2
    ]
});
var $efd3ba4ec2608b1d$var$ActiveLoadLayers = true;
var $efd3ba4ec2608b1d$var$LoadExtra = false;
const $efd3ba4ec2608b1d$var$imageLayers1 = [];
const $efd3ba4ec2608b1d$var$imageLayers2 = [];
const $efd3ba4ec2608b1d$var$tileLayers1 = [];
const $efd3ba4ec2608b1d$var$tileLayers2 = [];
const $efd3ba4ec2608b1d$var$tileLayersCo1 = [];
const $efd3ba4ec2608b1d$var$tileLayersCo2 = [];
var $efd3ba4ec2608b1d$var$NoLimitOfLayers = 2;
var $efd3ba4ec2608b1d$var$NoOfLayers = 2;
var $efd3ba4ec2608b1d$var$ii = 0;
//var iimin = imageLayers1.length ;
for($efd3ba4ec2608b1d$var$ii = 0; $efd3ba4ec2608b1d$var$ii <= $efd3ba4ec2608b1d$var$NoLimitOfLayers - 1; $efd3ba4ec2608b1d$var$ii++){
    $efd3ba4ec2608b1d$var$imageLayers2[$efd3ba4ec2608b1d$var$ii] = new (0, $14618f63634d34fc$export$2e2bcd8739ae039)({
        zIndex: 11
    });
    $efd3ba4ec2608b1d$var$imageLayers1[$efd3ba4ec2608b1d$var$ii] = new (0, $14618f63634d34fc$export$2e2bcd8739ae039)({
        zIndex: 12
    });
    $efd3ba4ec2608b1d$var$tileLayers2[$efd3ba4ec2608b1d$var$ii] = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
        zIndex: 11
    });
    $efd3ba4ec2608b1d$var$tileLayers1[$efd3ba4ec2608b1d$var$ii] = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
        zIndex: 12
    });
    $efd3ba4ec2608b1d$var$tileLayersCo2[$efd3ba4ec2608b1d$var$ii] = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
        zIndex: 13
    });
    $efd3ba4ec2608b1d$var$tileLayersCo1[$efd3ba4ec2608b1d$var$ii] = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
        zIndex: 14
    });
}
const $efd3ba4ec2608b1d$var$imageLayers2Group = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$imageLayers2[0],
        $efd3ba4ec2608b1d$var$imageLayers2[1]
    ]
});
const $efd3ba4ec2608b1d$var$imageLayers1Group = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$imageLayers1[0],
        $efd3ba4ec2608b1d$var$imageLayers1[1]
    ]
});
const $efd3ba4ec2608b1d$var$tileLayers2Group = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$tileLayers2[0],
        $efd3ba4ec2608b1d$var$tileLayers2[1],
        $efd3ba4ec2608b1d$var$tileLayersCo2[0],
        $efd3ba4ec2608b1d$var$tileLayersCo2[1]
    ]
});
const $efd3ba4ec2608b1d$var$tileLayers1Group = new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
    layers: [
        $efd3ba4ec2608b1d$var$tileLayers1[0],
        $efd3ba4ec2608b1d$var$tileLayers1[1],
        $efd3ba4ec2608b1d$var$tileLayersCo1[0],
        $efd3ba4ec2608b1d$var$tileLayersCo1[1]
    ]
});
$efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$BaseLayerGroup1);
$efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$BaseOverlayLayerGroup1);
$efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$imageLayers2Group);
$efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$imageLayers1Group);
$efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$tileLayers2Group);
$efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$tileLayers1Group);
$efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$TopLayerGroup1);
$efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$TopLayerLabelGroup1);
$efd3ba4ec2608b1d$var$map2.addLayer($efd3ba4ec2608b1d$var$BaseLayerGroup2);
$efd3ba4ec2608b1d$var$map2.addLayer($efd3ba4ec2608b1d$var$BaseOverlayLayerGroup2);
//map2.addLayer(imageLayers2Group);
$efd3ba4ec2608b1d$var$map2.addLayer($efd3ba4ec2608b1d$var$TopLayerGroup2);
$efd3ba4ec2608b1d$var$map2.addLayer($efd3ba4ec2608b1d$var$TopLayerLabelGroup2);
//   Layer switcher Logic for basemaps  and their associated Top Layers Labels
//
const $efd3ba4ec2608b1d$var$BaseLayerElements = document.getElementsByName("baseLayerRadioButton");
for (let BaseLayerElement of $efd3ba4ec2608b1d$var$BaseLayerElements)BaseLayerElement.addEventListener("change", function() {
    let BaseLayerElementValue = this.value;
    $efd3ba4ec2608b1d$var$BaseLayerGroup1.getLayers().forEach(function(element, index, array) {
        let BaseLayerTitle = element.get("title");
        console.log(" Base Layer Title: " + BaseLayerTitle + " Base selected radio: " + BaseLayerElementValue);
        element.setVisible(BaseLayerTitle === BaseLayerElementValue);
    });
    $efd3ba4ec2608b1d$var$BaseLayerGroup2.getLayers().forEach(function(element, index, array) {
        let BaseLayerTitle2 = element.get("title");
        console.log(" map2 Base Layer Title: " + BaseLayerTitle2 + " Base selected radio: " + BaseLayerElementValue);
        element.setVisible(BaseLayerTitle2 === BaseLayerElementValue);
    });
    //   the Labels associated to a basemap are added-replicated on top of weatherlayers 
    //    A change in the base layer will also trigger a change to the top label layer. Here is why the values and titles are matched 
    //    The titles of the top label layers are constructed with the same name with the addition of the strind 'Labels'
    let TopLayerElementLabel = BaseLayerElementValue + "Labels";
    $efd3ba4ec2608b1d$var$TopLayerLabelGroup1.getLayers().forEach(function(element, index, array) {
        let TopLayerLabelTitle = element.get("title");
        console.log(" Label layer Title: " + TopLayerLabelTitle + " Label associated with base selected: " + TopLayerElementLabel);
        element.setVisible(TopLayerLabelTitle === TopLayerElementLabel);
    });
    $efd3ba4ec2608b1d$var$TopLayerLabelGroup2.getLayers().forEach(function(element, index, array) {
        let TopLayerLabelTitle2 = element.get("title");
        console.log(" map2 Label layer Title: " + TopLayerLabelTitle2 + " Label associated with base selected: " + TopLayerElementLabel);
        element.setVisible(TopLayerLabelTitle2 === TopLayerElementLabel);
    });
});
//   Layer et Logic for basemaps overlays   and Top Layers overlays having checkbox in the HTML
//
//const LayerElements = document.querySelectorAll('.sidenav > input[type=checkbox]');
const $efd3ba4ec2608b1d$var$LayerElements = document.getElementsByName("topLayerCheckBox");
for (let LayerElement of $efd3ba4ec2608b1d$var$LayerElements)LayerElement.addEventListener("change", function() {
    let LayerElementValue = this.value;
    $efd3ba4ec2608b1d$var$BaseOverlayLayerGroup1.getLayers().forEach(function(element, index, array) {
        let BaseOverlayLayerTitle = element.get("title");
        console.log(" BaseOverlay Layer Title: " + BaseOverlayLayerTitle + " Overlay selected radio: " + LayerElementValue);
        if (BaseOverlayLayerTitle === LayerElementValue) element.setVisible(LayerElement.checked);
    });
    $efd3ba4ec2608b1d$var$BaseOverlayLayerGroup2.getLayers().forEach(function(element, index, array) {
        let BaseOverlayLayerTitle2 = element.get("title");
        console.log(" map2 BaseOverlay Layer Title: " + BaseOverlayLayerTitle2 + " Overlay selected radio: " + LayerElementValue);
        if (BaseOverlayLayerTitle2 === LayerElementValue) element.setVisible(LayerElement.checked);
    });
    $efd3ba4ec2608b1d$var$TopLayerGroup1.getLayers().forEach(function(element, index, array) {
        let TopLayerTitle = element.get("title");
        console.log(" Top Layer Title: " + TopLayerTitle + " Top Layer selected radio: " + LayerElementValue);
        if (TopLayerTitle === LayerElementValue) element.setVisible(LayerElement.checked);
    });
    $efd3ba4ec2608b1d$var$TopLayerGroup2.getLayers().forEach(function(element, index, array) {
        let TopLayerTitle2 = element.get("title");
        console.log(" map2 Top Layer Title: " + TopLayerTitle2 + " Top Layer selected radio: " + LayerElementValue);
        if (TopLayerTitle2 === LayerElementValue) element.setVisible(LayerElement.checked);
    });
});
//   For markers --------------------------------
////modify.on('drag', function(evt) {
////const modifiedFeature = evt.features.getArray()[0]; // Get the modified feature
////const newCoords = modifiedFeature.getGeometry().getCoordinates(); // Get new coordinates
////// Update your logic here to handle the new marker position (e.g., display coordinates, store in database)
////console.log('New Marker Position:', newCoords); // Example: log new coordinates to console
//});
let $efd3ba4ec2608b1d$var$tempoLaLoA = (0, $9c4744460e43e41b$export$b15d9668511529b9)([
    -73.562,
    45.499
], $efd3ba4ec2608b1d$var$projView);
let $efd3ba4ec2608b1d$var$tempoLaLoB = (0, $9c4744460e43e41b$export$b15d9668511529b9)([
    -71.208,
    46.813
], $efd3ba4ec2608b1d$var$projView);
var $efd3ba4ec2608b1d$var$StorageLoAId = "longitudeA";
var $efd3ba4ec2608b1d$var$StorageLaAId = "latitudeA";
var $efd3ba4ec2608b1d$var$StorageLoBId = "longitudeB";
var $efd3ba4ec2608b1d$var$StorageLaBId = "latitudeB";
var $efd3ba4ec2608b1d$var$storageLoA = localStorage.getItem($efd3ba4ec2608b1d$var$StorageLoAId);
var $efd3ba4ec2608b1d$var$storageLaA = localStorage.getItem($efd3ba4ec2608b1d$var$StorageLaAId);
var $efd3ba4ec2608b1d$var$storageLoB = localStorage.getItem($efd3ba4ec2608b1d$var$StorageLoBId);
var $efd3ba4ec2608b1d$var$storageLaB = localStorage.getItem($efd3ba4ec2608b1d$var$StorageLaBId);
if ($efd3ba4ec2608b1d$var$storageLoA !== null && $efd3ba4ec2608b1d$var$storageLaA !== null) {
    console.log(" valeur de long et lat  en storage du marqueur A sont:", $efd3ba4ec2608b1d$var$storageLoA, " ", $efd3ba4ec2608b1d$var$storageLaA);
    $efd3ba4ec2608b1d$var$tempoLaLoA = (0, $9c4744460e43e41b$export$b15d9668511529b9)([
        $efd3ba4ec2608b1d$var$storageLoA,
        $efd3ba4ec2608b1d$var$storageLaA
    ], $efd3ba4ec2608b1d$var$projView);
}
if ($efd3ba4ec2608b1d$var$storageLoB !== null && $efd3ba4ec2608b1d$var$storageLaB !== null) {
    console.log(" valeur de long et lat  en storage du marqueur B sont:", $efd3ba4ec2608b1d$var$storageLoB, " ", $efd3ba4ec2608b1d$var$storageLaB);
    $efd3ba4ec2608b1d$var$tempoLaLoB = (0, $9c4744460e43e41b$export$b15d9668511529b9)([
        $efd3ba4ec2608b1d$var$storageLoB,
        $efd3ba4ec2608b1d$var$storageLaB
    ], $efd3ba4ec2608b1d$var$projView);
}
const $efd3ba4ec2608b1d$var$longitudeInputA = document.getElementById("longitudeA");
const $efd3ba4ec2608b1d$var$latitudeInputA = document.getElementById("latitudeA");
const $efd3ba4ec2608b1d$var$longitudeInputB = document.getElementById("longitudeB");
const $efd3ba4ec2608b1d$var$latitudeInputB = document.getElementById("latitudeB");
const $efd3ba4ec2608b1d$var$iconFeatureA = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
    geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)($efd3ba4ec2608b1d$var$tempoLaLoA, $efd3ba4ec2608b1d$var$projView),
    name: "Mark A"
});
const $efd3ba4ec2608b1d$var$iconFeatureB = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
    geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)($efd3ba4ec2608b1d$var$tempoLaLoB, $efd3ba4ec2608b1d$var$projView),
    name: "Mark B"
});
function $efd3ba4ec2608b1d$var$MiseAJourCoordFromFeature(feature, lonInput, latInput, storageLoId, storageLaId) {
    const geometry = feature.getGeometry();
    const coordinates = geometry.getCoordinates();
    const lonLat = (0, $9c4744460e43e41b$export$3fb495868742d370)(coordinates, $efd3ba4ec2608b1d$var$projView);
    lonInput.value = lonLat[0].toFixed(3);
    latInput.value = lonLat[1].toFixed(3);
    localStorage.setItem(storageLoId, lonLat[0]);
    localStorage.setItem(storageLaId, lonLat[1]);
}
// Afficher les coordonnées initiales des marqueurs  
$efd3ba4ec2608b1d$var$MiseAJourCoordFromFeature($efd3ba4ec2608b1d$var$iconFeatureA, $efd3ba4ec2608b1d$var$longitudeInputA, $efd3ba4ec2608b1d$var$latitudeInputA, $efd3ba4ec2608b1d$var$StorageLoAId, $efd3ba4ec2608b1d$var$StorageLaAId);
$efd3ba4ec2608b1d$var$MiseAJourCoordFromFeature($efd3ba4ec2608b1d$var$iconFeatureB, $efd3ba4ec2608b1d$var$longitudeInputB, $efd3ba4ec2608b1d$var$latitudeInputB, $efd3ba4ec2608b1d$var$StorageLoBId, $efd3ba4ec2608b1d$var$StorageLaBId);
function $efd3ba4ec2608b1d$var$MiseAJourFeaturesFromInputs() {
    const longitudeA = parseFloat($efd3ba4ec2608b1d$var$longitudeInputA.value);
    const latitudeA = parseFloat($efd3ba4ec2608b1d$var$latitudeInputA.value);
    const coordonneesA = (0, $9c4744460e43e41b$export$b15d9668511529b9)([
        longitudeA,
        latitudeA
    ], $efd3ba4ec2608b1d$var$projView);
    $efd3ba4ec2608b1d$var$iconFeatureA.getGeometry().setCoordinates(coordonneesA);
    $efd3ba4ec2608b1d$var$iconFeatureA2.getGeometry().setCoordinates(coordonneesA);
    localStorage.setItem($efd3ba4ec2608b1d$var$StorageLoAId, longitudeA);
    localStorage.setItem($efd3ba4ec2608b1d$var$StorageLaAId, latitudeA);
    const longitudeB = parseFloat($efd3ba4ec2608b1d$var$longitudeInputB.value);
    const latitudeB = parseFloat($efd3ba4ec2608b1d$var$latitudeInputB.value);
    const coordonneesB = (0, $9c4744460e43e41b$export$b15d9668511529b9)([
        longitudeB,
        latitudeB
    ], $efd3ba4ec2608b1d$var$projView);
    $efd3ba4ec2608b1d$var$iconFeatureB.getGeometry().setCoordinates(coordonneesB);
    $efd3ba4ec2608b1d$var$iconFeatureB2.getGeometry().setCoordinates(coordonneesB);
    localStorage.setItem($efd3ba4ec2608b1d$var$StorageLoBId, longitudeB);
    localStorage.setItem($efd3ba4ec2608b1d$var$StorageLaBId, latitudeB);
}
//   MIse en pause des marqueurs:
//   Les marqueurs pourraient etre rendu invisibles mais alors leurs intéractions seraient encore actives
//   et cela pourrait entrainer des confusions, puisque on pourrait les déplacer sans s'en rendre compte. 
//   Les marqueurs pourraient etre retirer et ajouter sur les cartes  au besoin mais
//   il faudrait alors réactiver toutes les intéractions, et synchronisations, ce qui pourrait etre lourd.
//   Par simplicfication: ien mode pause....  on déplace l'icone loin dans l'hémisphère sud  
//   ce qui le fait litérallement disparaitre et empèche les intéractions
//   Les marqueurs sont en mode pause par l'appel suivant,  et ils sont réactivés par l'appel qui précéde...
function $efd3ba4ec2608b1d$var$MiseEnPauseFeatures() {
    const coordonnees = (0, $9c4744460e43e41b$export$b15d9668511529b9)([
        0,
        -84
    ], $efd3ba4ec2608b1d$var$projView);
    $efd3ba4ec2608b1d$var$iconFeatureA.getGeometry().setCoordinates(coordonnees);
    $efd3ba4ec2608b1d$var$iconFeatureB.getGeometry().setCoordinates(coordonnees);
    $efd3ba4ec2608b1d$var$iconFeatureA2.getGeometry().setCoordinates(coordonnees);
    $efd3ba4ec2608b1d$var$iconFeatureB2.getGeometry().setCoordinates(coordonnees);
}
function $efd3ba4ec2608b1d$var$mettreAJourMarqueurA(longitude, latitude) {
    const coordonnees = (0, $9c4744460e43e41b$export$b15d9668511529b9)([
        longitude,
        latitude
    ], $efd3ba4ec2608b1d$var$projView);
    $efd3ba4ec2608b1d$var$iconFeatureA.getGeometry().setCoordinates(coordonnees);
    localStorage.setItem($efd3ba4ec2608b1d$var$StorageLoAId, longitude);
    localStorage.setItem($efd3ba4ec2608b1d$var$StorageLaAId, latitude);
}
function $efd3ba4ec2608b1d$var$mettreAJourMarqueurB(longitude, latitude) {
    const coordonnees = (0, $9c4744460e43e41b$export$b15d9668511529b9)([
        longitude,
        latitude
    ], $efd3ba4ec2608b1d$var$projView);
    $efd3ba4ec2608b1d$var$iconFeatureB.getGeometry().setCoordinates(coordonnees);
    localStorage.setItem($efd3ba4ec2608b1d$var$StorageLoBId, longitude);
    localStorage.setItem($efd3ba4ec2608b1d$var$StorageLaBId, latitude);
}
// Mettre à jour les marqueur lorsque les champs de saisie changent
$efd3ba4ec2608b1d$var$longitudeInputA.addEventListener("change", function() {
    const longitude = parseFloat($efd3ba4ec2608b1d$var$longitudeInputA.value);
    const latitude = parseFloat($efd3ba4ec2608b1d$var$latitudeInputA.value);
    $efd3ba4ec2608b1d$var$mettreAJourMarqueurA(longitude, latitude);
});
$efd3ba4ec2608b1d$var$latitudeInputA.addEventListener("change", function() {
    const longitude = parseFloat($efd3ba4ec2608b1d$var$longitudeInputA.value);
    const latitude = parseFloat($efd3ba4ec2608b1d$var$latitudeInputA.value);
    $efd3ba4ec2608b1d$var$mettreAJourMarqueurA(longitude, latitude);
});
$efd3ba4ec2608b1d$var$longitudeInputB.addEventListener("change", function() {
    const longitude = parseFloat($efd3ba4ec2608b1d$var$longitudeInputB.value);
    const latitude = parseFloat($efd3ba4ec2608b1d$var$latitudeInputB.value);
    $efd3ba4ec2608b1d$var$mettreAJourMarqueurB(longitude, latitude);
});
$efd3ba4ec2608b1d$var$latitudeInputB.addEventListener("change", function() {
    const longitude = parseFloat($efd3ba4ec2608b1d$var$longitudeInputB.value);
    const latitude = parseFloat($efd3ba4ec2608b1d$var$latitudeInputB.value);
    $efd3ba4ec2608b1d$var$mettreAJourMarqueurB(longitude, latitude);
});
const $efd3ba4ec2608b1d$var$iconStyleA = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
        anchor: [
            0.5,
            1
        ],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        src: "../image_res/location-noir.png",
        width: 20,
        height: 32
    }),
    zIndex: 102
});
const $efd3ba4ec2608b1d$var$iconStyleB = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
        anchor: [
            0.5,
            1
        ],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        src: "../image_res/location-rouge.png",
        width: 20,
        height: 32
    }),
    zIndex: 102
});
$efd3ba4ec2608b1d$var$iconFeatureA.setStyle($efd3ba4ec2608b1d$var$iconStyleA);
$efd3ba4ec2608b1d$var$iconFeatureB.setStyle($efd3ba4ec2608b1d$var$iconStyleB);
const $efd3ba4ec2608b1d$var$vectorSourceMarkA = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
    features: [
        $efd3ba4ec2608b1d$var$iconFeatureA
    ]
});
const $efd3ba4ec2608b1d$var$vectorSourceMarkB = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
    features: [
        $efd3ba4ec2608b1d$var$iconFeatureB
    ]
});
const $efd3ba4ec2608b1d$var$vectorLayerMarkA = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceMarkA,
    zIndex: 102
});
const $efd3ba4ec2608b1d$var$vectorLayerMarkB = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceMarkB,
    zIndex: 102
});
$efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$vectorLayerMarkA);
$efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$vectorLayerMarkB);
const $efd3ba4ec2608b1d$var$modifyA = new (0, $8c24f34a0807f744$export$2e2bcd8739ae039)({
    hitDetection: $efd3ba4ec2608b1d$var$vectorLayerMarkA,
    source: $efd3ba4ec2608b1d$var$vectorSourceMarkA
});
const $efd3ba4ec2608b1d$var$modifyB = new (0, $8c24f34a0807f744$export$2e2bcd8739ae039)({
    hitDetection: $efd3ba4ec2608b1d$var$vectorLayerMarkB,
    source: $efd3ba4ec2608b1d$var$vectorSourceMarkB
});
const $efd3ba4ec2608b1d$var$target = document.getElementById("map");
$efd3ba4ec2608b1d$var$modifyA.on([
    "modifystart",
    "modifyend"
], function(evt) {
    $efd3ba4ec2608b1d$var$target.style.cursor = evt.type === "modifystart" ? "grabbing" : "pointer";
});
$efd3ba4ec2608b1d$var$modifyB.on([
    "modifystart",
    "modifyend"
], function(evt) {
    $efd3ba4ec2608b1d$var$target.style.cursor = evt.type === "modifystart" ? "grabbing" : "pointer";
});
const $efd3ba4ec2608b1d$var$overlaySourceMarkA = $efd3ba4ec2608b1d$var$modifyA.getOverlay().getSource();
const $efd3ba4ec2608b1d$var$overlaySourceMarkB = $efd3ba4ec2608b1d$var$modifyB.getOverlay().getSource();
$efd3ba4ec2608b1d$var$overlaySourceMarkA.on([
    "addfeature",
    "removefeature"
], function(evt) {
    $efd3ba4ec2608b1d$var$target.style.cursor = evt.type === "addfeature" ? "pointer" : "";
});
$efd3ba4ec2608b1d$var$overlaySourceMarkB.on([
    "addfeature",
    "removefeature"
], function(evt) {
    $efd3ba4ec2608b1d$var$target.style.cursor = evt.type === "addfeature" ? "pointer" : "";
});
const $efd3ba4ec2608b1d$var$iconFeatureA2 = $efd3ba4ec2608b1d$var$iconFeatureA.clone();
const $efd3ba4ec2608b1d$var$iconFeatureB2 = $efd3ba4ec2608b1d$var$iconFeatureB.clone();
const $efd3ba4ec2608b1d$var$vectorSourceMarkA2 = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
    features: [
        $efd3ba4ec2608b1d$var$iconFeatureA2
    ]
});
const $efd3ba4ec2608b1d$var$vectorSourceMarkB2 = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
    features: [
        $efd3ba4ec2608b1d$var$iconFeatureB2
    ]
});
const $efd3ba4ec2608b1d$var$vectorLayerMarkA2 = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceMarkA2,
    zIndex: 102
});
const $efd3ba4ec2608b1d$var$vectorLayerMarkB2 = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
    source: $efd3ba4ec2608b1d$var$vectorSourceMarkB2,
    zIndex: 102
});
$efd3ba4ec2608b1d$var$map2.addLayer($efd3ba4ec2608b1d$var$vectorLayerMarkA2);
$efd3ba4ec2608b1d$var$map2.addLayer($efd3ba4ec2608b1d$var$vectorLayerMarkB2);
const $efd3ba4ec2608b1d$var$modifyA2 = new (0, $8c24f34a0807f744$export$2e2bcd8739ae039)({
    hitDetection: $efd3ba4ec2608b1d$var$vectorLayerMarkA2,
    source: $efd3ba4ec2608b1d$var$vectorSourceMarkA2
});
const $efd3ba4ec2608b1d$var$modifyB2 = new (0, $8c24f34a0807f744$export$2e2bcd8739ae039)({
    hitDetection: $efd3ba4ec2608b1d$var$vectorLayerMarkB2,
    source: $efd3ba4ec2608b1d$var$vectorSourceMarkB2
});
function $efd3ba4ec2608b1d$var$syncModifA(evt) {
    $efd3ba4ec2608b1d$var$iconFeatureA2.setGeometry($efd3ba4ec2608b1d$var$iconFeatureA.getGeometry());
    $efd3ba4ec2608b1d$var$MiseAJourCoordFromFeature($efd3ba4ec2608b1d$var$iconFeatureA, $efd3ba4ec2608b1d$var$longitudeInputA, $efd3ba4ec2608b1d$var$latitudeInputA, $efd3ba4ec2608b1d$var$StorageLoAId, $efd3ba4ec2608b1d$var$StorageLaAId);
}
function $efd3ba4ec2608b1d$var$syncModifA2(evt) {
    $efd3ba4ec2608b1d$var$iconFeatureA.setGeometry($efd3ba4ec2608b1d$var$iconFeatureA2.getGeometry());
    $efd3ba4ec2608b1d$var$MiseAJourCoordFromFeature($efd3ba4ec2608b1d$var$iconFeatureA2, $efd3ba4ec2608b1d$var$longitudeInputA, $efd3ba4ec2608b1d$var$latitudeInputA, $efd3ba4ec2608b1d$var$StorageLoAId, $efd3ba4ec2608b1d$var$StorageLaAId);
}
function $efd3ba4ec2608b1d$var$syncModifB(evt) {
    $efd3ba4ec2608b1d$var$iconFeatureB2.setGeometry($efd3ba4ec2608b1d$var$iconFeatureB.getGeometry());
    $efd3ba4ec2608b1d$var$MiseAJourCoordFromFeature($efd3ba4ec2608b1d$var$iconFeatureB, $efd3ba4ec2608b1d$var$longitudeInputB, $efd3ba4ec2608b1d$var$latitudeInputB, $efd3ba4ec2608b1d$var$StorageLoBId, $efd3ba4ec2608b1d$var$StorageLaBId);
}
function $efd3ba4ec2608b1d$var$syncModifB2(evt) {
    $efd3ba4ec2608b1d$var$iconFeatureB.setGeometry($efd3ba4ec2608b1d$var$iconFeatureB2.getGeometry());
    $efd3ba4ec2608b1d$var$MiseAJourCoordFromFeature($efd3ba4ec2608b1d$var$iconFeatureB2, $efd3ba4ec2608b1d$var$longitudeInputB, $efd3ba4ec2608b1d$var$latitudeInputB, $efd3ba4ec2608b1d$var$StorageLoBId, $efd3ba4ec2608b1d$var$StorageLaBId);
}
$efd3ba4ec2608b1d$var$modifyA.on("modifyend", $efd3ba4ec2608b1d$var$syncModifA);
$efd3ba4ec2608b1d$var$modifyB.on("modifyend", $efd3ba4ec2608b1d$var$syncModifB);
$efd3ba4ec2608b1d$var$modifyA2.on("modifyend", $efd3ba4ec2608b1d$var$syncModifA2);
$efd3ba4ec2608b1d$var$modifyB2.on("modifyend", $efd3ba4ec2608b1d$var$syncModifB2);
$efd3ba4ec2608b1d$var$map.addInteraction($efd3ba4ec2608b1d$var$modifyA);
$efd3ba4ec2608b1d$var$map.addInteraction($efd3ba4ec2608b1d$var$modifyB);
$efd3ba4ec2608b1d$var$map2.addInteraction($efd3ba4ec2608b1d$var$modifyA2);
$efd3ba4ec2608b1d$var$map2.addInteraction($efd3ba4ec2608b1d$var$modifyB2);
// pour que les coordonnées soient mises à jour sur l'affichage lors du déplacement   FONCTIONNE PAS
///let dernierTemps = Date.now();
///const intervalleCoor = 100; // Intervalle de mise à jour en millisecondes
///function afficherCoordonneesDebounce(evt) {
///  const tempsActuel = Date.now();
///  if (tempsActuel - dernierTemps >= intervalleCoor) {
///    console.log(' déplacement marqueur1 ', tempsActuel, ' ', dernierTemps);
///    if (evt.features.getArray()[0].get('name') === 'Mark A') {
///      afficherCoordonnees(iconFeatureA);
///    } else if (evt.features.getArray()[0].get('name') === 'Mark B') {
///      afficherCoordonnees(iconFeatureB);
///    }
///    dernierTemps = tempsActuel;
///  }
///}
///modifyA.on('modify', afficherCoordonneesDebounce); // Affichage des coordonnées en temps réel
///modifyB.on('modify', afficherCoordonneesDebounce);
///modifyA2.on('modify', afficherCoordonneesDebounce);
///modifyB2.on('modify', afficherCoordonneesDebounce);
// -----------------------------------------------------------------------------------
//   Selector  for view projection
//
const $efd3ba4ec2608b1d$var$ViewProjSelect = document.getElementById("view-projection");
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateViewProjection() {
    if ($efd3ba4ec2608b1d$var$ViewProjSelect.value == "Syst.Prev") {
        console.log(" Syst.Prev ");
        $efd3ba4ec2608b1d$var$SetVu($efd3ba4ec2608b1d$var$Couche1.getProjection(), $efd3ba4ec2608b1d$var$ZoomToViewExtent.get($efd3ba4ec2608b1d$var$Couche1.zoomId), false);
    } else if ($efd3ba4ec2608b1d$var$ViewProjSelect.value == "EPSG:3857") {
        console.log(" EPSG:3857 ");
        $efd3ba4ec2608b1d$var$SetVu((0, $9c4744460e43e41b$export$3988ae62b71be9a3)($efd3ba4ec2608b1d$var$ViewProjSelect.value), (0, $9c4744460e43e41b$export$751c68e0e0efff79)([
            -180,
            -80,
            180,
            80
        ], "EPSG:4326", "EPSG:3857"), false);
    } else if ($efd3ba4ec2608b1d$var$ViewProjSelect.value == "EPSG:4326") {
        console.log(" EPSG:4326 ");
        $efd3ba4ec2608b1d$var$SetVu((0, $9c4744460e43e41b$export$3988ae62b71be9a3)($efd3ba4ec2608b1d$var$ViewProjSelect.value), [
            -180,
            -80,
            180,
            80
        ], false);
    } else {
        console.log(" Selct proj: ", $efd3ba4ec2608b1d$var$ViewProjSelect.value);
        $efd3ba4ec2608b1d$var$SetVu((0, $9c4744460e43e41b$export$3988ae62b71be9a3)($efd3ba4ec2608b1d$var$ViewProjSelect.value), (0, $9c4744460e43e41b$export$3988ae62b71be9a3)($efd3ba4ec2608b1d$var$ViewProjSelect.value).getExtent(), false);
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$SetVu(proj_, extent_, init) {
    var couche1Centre_ = $efd3ba4ec2608b1d$var$GetCentre($efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$Couche1.zoomId));
    var couche1Extent_ = $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$Couche1.zoomId);
    var couche1Proj_ = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$Couche1.zoomId);
    if (couche1Proj_ != "EPSG:4326") {
        couche1Extent_ = (0, $9c4744460e43e41b$export$751c68e0e0efff79)(couche1Extent_, couche1Proj_, "EPSG:4326");
        couche1Centre_ = (0, $9c4744460e43e41b$export$51186ad6e864892a)(couche1Centre_, couche1Proj_, "EPSG:4326");
    }
    if ($efd3ba4ec2608b1d$var$Couche2.modeleZoom != "void" && $efd3ba4ec2608b1d$var$Couche2.modeleZoom != $efd3ba4ec2608b1d$var$Couche1.modeleZoom) {
        var couche2Centre_ = $efd3ba4ec2608b1d$var$GetCentre($efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$Couche2.zoomId));
        var couche2Extent_ = $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$Couche2.zoomId);
        var couche2Proj_ = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$Couche2.zoomId);
        if (couche2Proj_ != "EPSG:4326") {
            couche2Extent_ = (0, $9c4744460e43e41b$export$751c68e0e0efff79)(couche2Extent_, couche2Proj_, "EPSG:4326");
            couche2Centre_ = (0, $9c4744460e43e41b$export$51186ad6e864892a)(couche1Centre_, couche2Proj_, "EPSG:4326");
        }
    }
    var centerView_isInside1 = false;
    var centerView_isInside2 = false;
    var coucheIsInsideView = false;
    var zoomInit = 15;
    var zoom_ = zoomInit;
    var centre_ = couche1Centre_;
    if ($efd3ba4ec2608b1d$var$WindMaps) {
        zoomInit = 24;
        zoom_ = zoomInit;
    }
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast($efd3ba4ec2608b1d$var$Couche1.modeleZoom);
    if (nowcast1) {
        zoomInit = 15;
        zoom_ = zoomInit;
    }
    if (init) {
        var storageZoom = localStorage.getItem($efd3ba4ec2608b1d$var$StorageZoomId);
        var storageProj = localStorage.getItem($efd3ba4ec2608b1d$var$StorageProjId);
        const storageCenter = [
            0,
            0
        ];
        storageCenter[0] = localStorage.getItem($efd3ba4ec2608b1d$var$StorageCenterIdX);
        storageCenter[1] = localStorage.getItem($efd3ba4ec2608b1d$var$StorageCenterIdY);
        if (storageCenter[0] != null && storageCenter[1] != null && storageProj != null && storageZoom != null) {
            console.log("Proj,  Zoom, Center from storage :", storageProj, storageZoom, storageCenter);
            centre_ = storageCenter;
            if (storageProj != "EPSG:4326") centre_ = (0, $9c4744460e43e41b$export$51186ad6e864892a)(storageCenter, storageProj, "EPSG:4326");
            zoom_ = storageZoom;
        }
    } else {
        let viewZoom_ = $efd3ba4ec2608b1d$var$map.getView().getZoom();
        let viewCentre_ = $efd3ba4ec2608b1d$var$map.getView().getCenter();
        let viewExtent_ = $efd3ba4ec2608b1d$var$map.getView().calculateExtent($efd3ba4ec2608b1d$var$map.getSize());
        let viewProj_ = $efd3ba4ec2608b1d$var$map.getView().getProjection();
        if (viewProj_ != "EPSG:4326") {
            viewExtent_ = (0, $9c4744460e43e41b$export$751c68e0e0efff79)(viewExtent_, viewProj_, "EPSG:4326");
            viewCentre_ = (0, $9c4744460e43e41b$export$51186ad6e864892a)(viewCentre_, viewProj_, "EPSG:4326");
        }
        centre_ = viewCentre_;
        zoom_ = viewZoom_;
        centerView_isInside1 = $efd3ba4ec2608b1d$var$IsLonLatInExtent(centre_[0], centre_[1], couche1Extent_);
        console.log("    ExtentCouche 1: ", couche1Extent_, "centre_: ", centre_);
        console.log(" center_isInside 1: ", centerView_isInside1);
        if ($efd3ba4ec2608b1d$var$Couche2.modeleZoom == "void" || $efd3ba4ec2608b1d$var$Couche2.modeleZoom == $efd3ba4ec2608b1d$var$Couche1.modeleZoom) {
            if (!centerView_isInside1) {
                centre_ = couche1Centre_;
                zoom_ = zoomInit;
                console.log(" SetVu 1 couche  Outside couche1 ", proj_, " Extent: ", extent_, " Zoom: ", zoom_, " Center: ", centre_);
            }
        } else {
            centerView_isInside2 = $efd3ba4ec2608b1d$var$IsLonLatInExtent(centre_[0], centre_[1], couche2Extent_);
            console.log("    ExtentCouche2: ", couche2Extent_, "viewCentre_: ", viewCentre_);
            console.log(" centerView_isInside 2: ", centerView_isInside2);
            if (!centerView_isInside1 && !centerView_isInside2) {
                centre_ = $efd3ba4ec2608b1d$var$GetCentreDes2(couche1Extent_, couche2Extent_);
                zoom_ = zoomInit;
                console.log(" SetVu centre view  Outside  couche 1 et 2  reset centre to Center: ", centre_);
            }
            coucheIsInsideView = $efd3ba4ec2608b1d$var$IsCoucheExtentInExtent(viewExtent_, couche1Extent_);
            console.log("    ExtentCouche 1: ", couche1Extent_, "view extent", viewExtent_);
            console.log(" couche 1 IsInsideView: ", coucheIsInsideView);
            if (coucheIsInsideView) {
                coucheIsInsideView = $efd3ba4ec2608b1d$var$IsCoucheExtentInExtent(viewExtent_, couche2Extent_);
                console.log("    ExtentCouche 2: ", couche2Extent_, "view extent", viewExtent_);
                console.log(" couche 2 IsInsideView: ", coucheIsInsideView);
            }
            if (!coucheIsInsideView) {
                centre_ = $efd3ba4ec2608b1d$var$GetCentreDes2(couche1Extent_, couche2Extent_);
                zoom_ = zoomInit;
                console.log(" SetVu centre view  Outside  couche 1 et 2  seset centre to Center: ", centre_);
            }
        }
    }
    var center_ = centre_;
    if (proj_ != "EPSG:4326") {
        console.log(" Ici le centre n est pas dans les bonnes  coordonn\xe9es ", centre_);
        center_ = (0, $9c4744460e43e41b$export$51186ad6e864892a)(centre_, "EPSG:4326", proj_);
        console.log(" Ici le centre est converti dans ls bonnes coordonn\xe9es ", center_);
    }
    console.log(" SetVu proj_ ", proj_, " Extent: ", extent_, " Zoom: ", zoom_, " Center: ", center_);
    const newView = new (0, $70364d0195659942$export$2e2bcd8739ae039)({
        projection: proj_,
        zoom: zoom_,
        zoomFactor: 1.26,
        extent: extent_,
        center: center_,
        constrainResolution: false,
        showFullExtent: true,
        multiWorld: false
    });
    if (!init) $efd3ba4ec2608b1d$var$UnsetValeurs("0");
    $efd3ba4ec2608b1d$var$map.setView(newView);
    if ($efd3ba4ec2608b1d$var$L_Juxtapo) $efd3ba4ec2608b1d$var$map2.setView(newView);
    if (!init) $efd3ba4ec2608b1d$var$ResetValeurs();
}
// ________________________________________________________________________________
// ________________________________________________________________________________
// Handle change event.
//
$efd3ba4ec2608b1d$var$ViewProjSelect.onchange = function() {
    $efd3ba4ec2608b1d$var$StopAnimate();
    $efd3ba4ec2608b1d$var$updateViewProjection();
    if ($efd3ba4ec2608b1d$var$ActiveLoop) $efd3ba4ec2608b1d$var$StartAnimate();
};
if ($efd3ba4ec2608b1d$var$WindMaps) {
    document.getElementById("view-projection").style.display = "none";
    document.getElementById("labelViewProjection").style.display = "none";
}
// ------------------------------------------------------------------------------
//ViewProjSelect.value ="EPSG:3857";
//ViewProjSelect.value ="EPSG:2163";
//updateViewProjection();
//
//---------------------------------------------------------------------------------
//   Weather layers properties  set up and initialisation
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$Couche(s_modele, s_modele_zoom, s_zoomid, s_extent, s_projection, s_mapid_h, s_mapidCo, s_houroid, i_debut, i_fin, i_interval) {
    this.modele = s_modele;
    this.getModele = function() {
        return this.modele;
    };
    this.modeleZoom = s_modele_zoom;
    this.getModeleZoom = function() {
        return this.modeleZoom;
    };
    this.zoomId = s_zoomid;
    this.getZoomId = function() {
        return this.zoomId;
    };
    this.extent = s_extent;
    this.getExtent = function() {
        return this.extent;
    };
    this.projection = s_projection;
    this.getProjection = function() {
        return this.projection;
    };
    this.mapIdH = s_mapid_h;
    this.getMapIdH = function() {
        return this.mapIdH;
    };
    this.mapIdCo = s_mapidCo;
    this.getMapIdCo = function() {
        return this.mapIdCo;
    };
    this.hourOId = s_houroid;
    this.getHourOId = function() {
        return this.hourOId;
    };
    this.debut = i_debut;
    this.getDebut = function() {
        return this.debut;
    };
    this.fin = i_fin;
    this.getFin = function() {
        return this.fin;
    };
    this.interval = i_interval;
    this.getInterval = function() {
        return this.interval;
    };
    this.getMapId = function() {
        if (this.mapIdH.indexOf("_h") != -1) return this.mapIdH.replace("_h", "_") + Math.round(this.interval / 60.) + "h";
        else return this.mapIdH;
    };
}
var $efd3ba4ec2608b1d$var$Tronc = "maps";
var $efd3ba4ec2608b1d$var$ArchivesVerif = false;
const $efd3ba4ec2608b1d$var$ModADebut = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
$efd3ba4ec2608b1d$var$ModADebut.set("RDPS", 180);
$efd3ba4ec2608b1d$var$ModADebut.set("GDPS", 360);
$efd3ba4ec2608b1d$var$ModADebut.set("GDPSIA", 360);
$efd3ba4ec2608b1d$var$ModADebut.set("GDPSE", 360);
$efd3ba4ec2608b1d$var$ModADebut.set("GDPSIAE", 360);
$efd3ba4ec2608b1d$var$ModADebut.set("GFS", 360);
$efd3ba4ec2608b1d$var$ModADebut.set("AIFS", 360);
$efd3ba4ec2608b1d$var$ModADebut.set("AIFSE", 360);
$efd3ba4ec2608b1d$var$ModADebut.set("ECMWF", 360);
$efd3ba4ec2608b1d$var$ModADebut.set("ECMWFE", 360);
$efd3ba4ec2608b1d$var$ModADebut.set("ECMWF3", 180);
$efd3ba4ec2608b1d$var$ModADebut.set("HRDPS E", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("HRDPS W", 180);
$efd3ba4ec2608b1d$var$ModADebut.set("HRDPS S", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("HRDPS S0", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("HRDPS S1", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("HRDPS S2", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("HRDPS S3", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("RAQDPS", 180);
$efd3ba4ec2608b1d$var$ModADebut.set("WCPS", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("SHOP", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("RDWPS", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("DIAGW", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("CIOPS", 60);
$efd3ba4ec2608b1d$var$ModADebut.set("GOESR CO", -1440);
$efd3ba4ec2608b1d$var$ModADebut.set("GOESR GLM", -1440);
$efd3ba4ec2608b1d$var$ModADebut.set("GOESR_PLUS", -1440);
$efd3ba4ec2608b1d$var$ModADebut.set("RADAR CO", -1440);
$efd3ba4ec2608b1d$var$ModADebut.set("RADART CO", -1440);
$efd3ba4ec2608b1d$var$ModADebut.set("FOUDRE CO", -1440);
const $efd3ba4ec2608b1d$var$ModAFin = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
$efd3ba4ec2608b1d$var$ModAFin.set("RDPS", 5040);
$efd3ba4ec2608b1d$var$ModAFin.set("GDPS", 14400);
$efd3ba4ec2608b1d$var$ModAFin.set("GDPSIA", 14400);
$efd3ba4ec2608b1d$var$ModAFin.set("GDPSE", 14400);
$efd3ba4ec2608b1d$var$ModAFin.set("GDPSIAE", 14400);
$efd3ba4ec2608b1d$var$ModAFin.set("GFS", 14400);
$efd3ba4ec2608b1d$var$ModAFin.set("AIFS", 14400);
$efd3ba4ec2608b1d$var$ModAFin.set("AIFSE", 14400);
$efd3ba4ec2608b1d$var$ModAFin.set("ECMWF", 14400);
$efd3ba4ec2608b1d$var$ModAFin.set("ECMWFE", 14400);
$efd3ba4ec2608b1d$var$ModAFin.set("ECMWF3", 5400);
$efd3ba4ec2608b1d$var$ModAFin.set("HRDPS E", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("HRDPS W", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("HRDPS S", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("HRDPS S0", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("HRDPS S1", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("HRDPS S2", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("HRDPS S3", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("RAQDPS", 4320);
$efd3ba4ec2608b1d$var$ModAFin.set("CIOPS", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("WCPS", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("SHOP", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("RDWPS", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("DIAGW", 2880);
$efd3ba4ec2608b1d$var$ModAFin.set("GOESR CO", 0);
$efd3ba4ec2608b1d$var$ModAFin.set("GOESR GLM", 0);
$efd3ba4ec2608b1d$var$ModAFin.set("GOESR_PLUS", 0);
$efd3ba4ec2608b1d$var$ModAFin.set("RADAR CO", 0);
$efd3ba4ec2608b1d$var$ModAFin.set("RADART CO", 0);
$efd3ba4ec2608b1d$var$ModAFin.set("FOUDRE CO", 0);
const $efd3ba4ec2608b1d$var$ModAInterv = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
$efd3ba4ec2608b1d$var$ModAInterv.set("RDPS", 180);
$efd3ba4ec2608b1d$var$ModAInterv.set("GDPS", 360);
$efd3ba4ec2608b1d$var$ModAInterv.set("GDPSIA", 360);
$efd3ba4ec2608b1d$var$ModAInterv.set("GDPSE", 360);
$efd3ba4ec2608b1d$var$ModAInterv.set("GDPSIAE", 360);
$efd3ba4ec2608b1d$var$ModAInterv.set("GFS", 360);
$efd3ba4ec2608b1d$var$ModAInterv.set("AIFS", 360);
$efd3ba4ec2608b1d$var$ModAInterv.set("AIFSE", 360);
$efd3ba4ec2608b1d$var$ModAInterv.set("ECMWF", 360);
$efd3ba4ec2608b1d$var$ModAInterv.set("ECMWFE", 360);
$efd3ba4ec2608b1d$var$ModAInterv.set("ECMWF3", 180);
$efd3ba4ec2608b1d$var$ModAInterv.set("HRDPS E", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("HRDPS W", 180);
$efd3ba4ec2608b1d$var$ModAInterv.set("HRDPS S", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("HRDPS S0", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("HRDPS S1", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("HRDPS S2", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("HRDPS S3", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("RAQDPS", 180);
$efd3ba4ec2608b1d$var$ModAInterv.set("CIOPS", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("WCPS", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("SHOP", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("RDWPS", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("DIAGW", 60);
$efd3ba4ec2608b1d$var$ModAInterv.set("GOESR CO", 5);
$efd3ba4ec2608b1d$var$ModAInterv.set("GOESR GLM", 5);
$efd3ba4ec2608b1d$var$ModAInterv.set("GOESR_PLUS", 5);
$efd3ba4ec2608b1d$var$ModAInterv.set("RADAR CO", 6);
$efd3ba4ec2608b1d$var$ModAInterv.set("RADART CO", 6);
$efd3ba4ec2608b1d$var$ModAInterv.set("FOUDRE CO", 5);
const $efd3ba4ec2608b1d$var$ModAHourOId = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
$efd3ba4ec2608b1d$var$ModAHourOId.set("RDPS", $efd3ba4ec2608b1d$var$GuessHourOId("RDPS", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("GDPS", $efd3ba4ec2608b1d$var$GuessHourOId("GDPS", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("GDPSIA", $efd3ba4ec2608b1d$var$GuessHourOId("GDPSIA", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("GDPSE", $efd3ba4ec2608b1d$var$GuessHourOId("GDPSE", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("GDPSIAE", $efd3ba4ec2608b1d$var$GuessHourOId("GDPSIAE", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("GFS", $efd3ba4ec2608b1d$var$GuessHourOId("GFS", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("AIFS", $efd3ba4ec2608b1d$var$GuessHourOId("AIFS", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("AIFSE", $efd3ba4ec2608b1d$var$GuessHourOId("AIFSE", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("ECMWF", $efd3ba4ec2608b1d$var$GuessHourOId("ECMWF", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("ECMWFE", $efd3ba4ec2608b1d$var$GuessHourOId("ECMWFE", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("ECMWF3", $efd3ba4ec2608b1d$var$GuessHourOId("ECMWF3", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("HRDPS E", $efd3ba4ec2608b1d$var$GuessHourOId("HRDPS E", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("HRDPS W", $efd3ba4ec2608b1d$var$GuessHourOId("HRDPS W", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("HRDPS S", $efd3ba4ec2608b1d$var$GuessHourOId("HRDPS S", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("HRDPS S0", $efd3ba4ec2608b1d$var$GuessHourOId("HRDPS S0", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("HRDPS S1", $efd3ba4ec2608b1d$var$GuessHourOId("HRDPS S1", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("HRDPS S2", $efd3ba4ec2608b1d$var$GuessHourOId("HRDPS S2", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("HRDPS S3", $efd3ba4ec2608b1d$var$GuessHourOId("HRDPS S3", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("RAQDPS", $efd3ba4ec2608b1d$var$GuessHourOId("RAQDPS", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("WCPS", $efd3ba4ec2608b1d$var$GuessHourOId("WCPS", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("SHOP", $efd3ba4ec2608b1d$var$GuessHourOId("SHOP", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("RDWPS", $efd3ba4ec2608b1d$var$GuessHourOId("RDWPS", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("DIAGW", $efd3ba4ec2608b1d$var$GuessHourOId("DIAGW", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("CIOPS", $efd3ba4ec2608b1d$var$GuessHourOId("CIOPS", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("GOESR CO", $efd3ba4ec2608b1d$var$GuessHourOId("GOESR CO", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("GOESR GLM", $efd3ba4ec2608b1d$var$GuessHourOId("GOESR GLM", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("GOESR_PLUS", $efd3ba4ec2608b1d$var$GuessHourOId("GOESR_PLUS", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("FOUDRE CO", $efd3ba4ec2608b1d$var$GuessHourOId("FOUDRE CO", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("RADAR CO", $efd3ba4ec2608b1d$var$GuessHourOId("RADAR CO", -1));
$efd3ba4ec2608b1d$var$ModAHourOId.set("RADART CO", $efd3ba4ec2608b1d$var$GuessHourOId("RADART CO", -1));
const $efd3ba4ec2608b1d$var$ModToId = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
$efd3ba4ec2608b1d$var$ModToId.set("RDPS", "RDPS");
$efd3ba4ec2608b1d$var$ModToId.set("GDPS", "GDPS");
$efd3ba4ec2608b1d$var$ModToId.set("GDPSIA", "GDPSIA");
$efd3ba4ec2608b1d$var$ModToId.set("GDPSE", "GDPS");
$efd3ba4ec2608b1d$var$ModToId.set("GDPSIAE", "GDPSIA");
$efd3ba4ec2608b1d$var$ModToId.set("GFS", "GFS");
$efd3ba4ec2608b1d$var$ModToId.set("AIFS", "AIFS");
$efd3ba4ec2608b1d$var$ModToId.set("AIFSE", "AIFS");
$efd3ba4ec2608b1d$var$ModToId.set("ECMWF", "ECMWF");
$efd3ba4ec2608b1d$var$ModToId.set("ECMWFE", "ECMWF");
$efd3ba4ec2608b1d$var$ModToId.set("ECMWF3", "ECMWF3");
$efd3ba4ec2608b1d$var$ModToId.set("HRDPS E", "HRDPS");
$efd3ba4ec2608b1d$var$ModToId.set("HRDPS W", "HRDPS");
$efd3ba4ec2608b1d$var$ModToId.set("HRDPS S", "HRDPS");
$efd3ba4ec2608b1d$var$ModToId.set("HRDPS S0", "HRDPS");
$efd3ba4ec2608b1d$var$ModToId.set("HRDPS S1", "HRDPS");
$efd3ba4ec2608b1d$var$ModToId.set("HRDPS S2", "HRDPS");
$efd3ba4ec2608b1d$var$ModToId.set("HRDPS S3", "HRDPS");
$efd3ba4ec2608b1d$var$ModToId.set("RAQDPS", "RAQDPS");
$efd3ba4ec2608b1d$var$ModToId.set("WCPS", "WCPS");
$efd3ba4ec2608b1d$var$ModToId.set("SHOP", "SHOP");
$efd3ba4ec2608b1d$var$ModToId.set("RDWPS", "RDWPS");
$efd3ba4ec2608b1d$var$ModToId.set("DIAGW", "DIAGW");
$efd3ba4ec2608b1d$var$ModToId.set("CIOPS", "CIOPS");
$efd3ba4ec2608b1d$var$ModToId.set("GOESR CO", "GOESR");
$efd3ba4ec2608b1d$var$ModToId.set("GOESR GLM", "GLM");
$efd3ba4ec2608b1d$var$ModToId.set("GOESR_PLUS", "GOESR_PLUS");
$efd3ba4ec2608b1d$var$ModToId.set("FOUDRE CO", "FOUDRE");
$efd3ba4ec2608b1d$var$ModToId.set("RADAR CO", "RADAR");
$efd3ba4ec2608b1d$var$ModToId.set("RADART CO", "RADART");
const $efd3ba4ec2608b1d$var$ModToLyrTyp = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("RDPS", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("GDPS", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("GDPSIA", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("GDPSE", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("GDPSIAE", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("GFS", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("AIFS", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("AIFSE", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("ECMWF", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("ECMWFE", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("ECMWF3", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("HRDPS E", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("HRDPS W", "Image");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("HRDPS S", "Image");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("HRDPS S0", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("HRDPS S1", "Image");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("HRDPS S2", "Image");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("HRDPS S3", "Image");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("RAQDPS", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("WCPS", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("SHOP", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("RDWPS", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("DIAGW", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("CIOPS", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("GOESR CO", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("GOESR GLM", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("GOESR_PLUS", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("FOUDRE CO", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("RADAR CO", "Tuile");
$efd3ba4ec2608b1d$var$ModToLyrTyp.set("RADART CO", "Tuile");
var $efd3ba4ec2608b1d$var$Resolutions1 = [];
var $efd3ba4ec2608b1d$var$Resolutions2 = [];
var $efd3ba4ec2608b1d$var$ResolutionsCo1 = [];
var $efd3ba4ec2608b1d$var$ResolutionsCo2 = [];
const $efd3ba4ec2608b1d$var$ModToDimX = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
const $efd3ba4ec2608b1d$var$ModToDimY = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
//if ( ModToLyrTyp.get("RDPS") != "Image" ) { ModToDimX.set("RDPS", 530); }
//if ( ModToLyrTyp.get("RDPS") != "Image" ) { ModToDimY.set("RDPS", 265); }
//if ( ModToLyrTyp.get("RDPS") != "Image" ) { ModToDimX.set("RDPS", 371); }
//if ( ModToLyrTyp.get("RDPS") != "Image" ) { ModToDimY.set("RDPS", 336); }
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("RDPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("RDPS", 279);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("RDPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("RDPS", 252);
//if ( ModToLyrTyp.get("GDPS") != "Image" ) { ModToDimX.set("GDPS", 432); }
//if ( ModToLyrTyp.get("GDPS") != "Image" ) { ModToDimY.set("GDPS", 216); }
//if ( ModToLyrTyp.get("GDPS") != "Image" ) { ModToDimX.set("GDPS", 354); }
//if ( ModToLyrTyp.get("GDPS") != "Image" ) { ModToDimY.set("GDPS", 264); }
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GDPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("GDPS", 223);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GDPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("GDPS", 167);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GDPSIA") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("GDPSIA", 223);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GDPSIA") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("GDPSIA", 167);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GDPSE") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("GDPSE", 223);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GDPSE") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("GDPSE", 167);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GDPSIAE") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("GDPSIAE", 223);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GDPSIAE") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("GDPSIAE", 167);
//if ( ModToLyrTyp.get("GFS") != "Image" ) { ModToDimX.set("GFS", 354); }
//if ( ModToLyrTyp.get("GFS") != "Image" ) { ModToDimY.set("GFS", 264); }
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GFS") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("GFS", 166);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GFS") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("GFS", 124);
//if ( ModToLyrTyp.get("ECMWF") != "Image" ) { ModToDimX.set("ECMWF", 354); }
//if ( ModToLyrTyp.get("ECMWF") != "Image" ) { ModToDimY.set("ECMWF", 264); }
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("ECMWF") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("ECMWF", 168);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("ECMWF") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("ECMWF", 125);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("ECMWFE") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("ECMWFE", 168);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("ECMWFE") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("ECMWFE", 125);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("ECMWF3") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("ECMWF3", 168);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("ECMWF3") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("ECMWF3", 125);
//if ( ModToLyrTyp.get("AIFS") != "Image" ) { ModToDimX.set("AIFS", 354); }
//if ( ModToLyrTyp.get("AIFS") != "Image" ) { ModToDimY.set("AIFS", 264); }
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("AIFS") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("AIFS", 168);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("AIFS") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("AIFS", 125);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("AIFSE") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("AIFSE", 168);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("AIFSE") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("AIFSE", 125);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("RAQDPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("RAQDPS", 280);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("RAQDPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("RAQDPS", 255);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("CIOPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("CIOPS", 472);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("CIOPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("CIOPS", 276);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("HRDPS E") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("HRDPS E", 446);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("HRDPS E") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("HRDPS E", 265);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("HRDPS S0") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("HRDPS S0", 454);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("HRDPS S0") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("HRDPS S0", 259);
//if ( ModToLyrTyp.get("WCPS") != "Image" ) { ModToDimX.set("WCPS", 474); }
//if ( ModToLyrTyp.get("WCPS") != "Image" ) { ModToDimY.set("WCPS", 277); }
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("WCPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("WCPS", 454);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("WCPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("WCPS", 259);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("RDWPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("RDWPS", 454);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("RDWPS") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("RDWPS", 259);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("DIAGW") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("DIAGW", 454);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("DIAGW") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("DIAGW", 259);
//200m sur 3857 => 140m
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("SHOP") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("SHOP", 627);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("SHOP") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("SHOP", 444);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GOESR CO") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("GOESR CO", 720);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GOESR CO") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("GOESR CO", 516);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GOESR GLM") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("GOESR GLM", 720);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GOESR GLM") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("GOESR GLM", 516);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GOESR_PLUS") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("GOESR_PLUS", 720);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("GOESR_PLUS") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("GOESR_PLUS", 516);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("FOUDRE CO") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("FOUDRE CO", 960);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("FOUDRE CO") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("FOUDRE CO", 687);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("RADAR CO") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("RADAR CO", 960);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("RADAR CO") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("RADAR CO", 687);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("RADART CO") != "Image") $efd3ba4ec2608b1d$var$ModToDimX.set("RADART CO", 960);
if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get("RADART CO") != "Image") $efd3ba4ec2608b1d$var$ModToDimY.set("RADART CO", 687);
const $efd3ba4ec2608b1d$var$ModToZoom = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
$efd3ba4ec2608b1d$var$ModToZoom.set("RDPS", "NOAMR");
$efd3ba4ec2608b1d$var$ModToZoom.set("GDPS", "NOAM");
$efd3ba4ec2608b1d$var$ModToZoom.set("GDPSIA", "NOAM");
$efd3ba4ec2608b1d$var$ModToZoom.set("GDPSE", "EURO");
$efd3ba4ec2608b1d$var$ModToZoom.set("GDPSIAE", "EURO");
$efd3ba4ec2608b1d$var$ModToZoom.set("HRDPS E", "EAST");
$efd3ba4ec2608b1d$var$ModToZoom.set("HRDPS S0", "SUDQC");
$efd3ba4ec2608b1d$var$ModToZoom.set("CIOPS", "SUDQC");
$efd3ba4ec2608b1d$var$ModToZoom.set("GFS", "NOAM20");
$efd3ba4ec2608b1d$var$ModToZoom.set("AIFS", "NOAM20");
$efd3ba4ec2608b1d$var$ModToZoom.set("AIFSE", "EURO20");
$efd3ba4ec2608b1d$var$ModToZoom.set("ECMWF", "NOAM20");
$efd3ba4ec2608b1d$var$ModToZoom.set("ECMWFE", "EURO20");
$efd3ba4ec2608b1d$var$ModToZoom.set("ECMWF3", "NOAM20");
$efd3ba4ec2608b1d$var$ModToZoom.set("HRDPS W", "HRDPSW_PS");
$efd3ba4ec2608b1d$var$ModToZoom.set("HRDPS S", "HRDPSS_PS");
$efd3ba4ec2608b1d$var$ModToZoom.set("HRDPS S1", "SUDQC1");
$efd3ba4ec2608b1d$var$ModToZoom.set("HRDPS S2", "SUDQC2");
$efd3ba4ec2608b1d$var$ModToZoom.set("HRDPS S3", "SUDQC3");
$efd3ba4ec2608b1d$var$ModToZoom.set("RAQDPS", "NOAMAQ");
//ModToZoom.set("WCPS", "WCPS3857");
$efd3ba4ec2608b1d$var$ModToZoom.set("WCPS", "SUDQC");
$efd3ba4ec2608b1d$var$ModToZoom.set("RDWPS", "SUDQC");
$efd3ba4ec2608b1d$var$ModToZoom.set("DIAGW", "SUDQC");
$efd3ba4ec2608b1d$var$ModToZoom.set("SHOP", "SLFE3857");
$efd3ba4ec2608b1d$var$ModToZoom.set("GOESR CO", "GOESR_LLCO");
$efd3ba4ec2608b1d$var$ModToZoom.set("GOESR GLM", "GOESR_LLCO");
$efd3ba4ec2608b1d$var$ModToZoom.set("GOESR_PLUS", "GOESR3857");
$efd3ba4ec2608b1d$var$ModToZoom.set("FOUDRE CO", "FOUDRE_CO3857");
$efd3ba4ec2608b1d$var$ModToZoom.set("RADAR CO", "RADAR_LL");
$efd3ba4ec2608b1d$var$ModToZoom.set("RADART CO", "RADAR_LL");
const $efd3ba4ec2608b1d$var$ZoomToProjec = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
$efd3ba4ec2608b1d$var$ZoomToProjec.set("NOAM", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("NOAM20", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("EURO", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("EURO20", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("GDPS_LLW", "EPSG:4326");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("GFS_LLW", "EPSG:4326");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("NOAMR", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("NOAMAQ", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("RDPS_PS", "SR-ORG:8237");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("RDPSS_PS", "SR-ORG:8237");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("HRDPS_PS", "SR-ORG:9237");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("HRDPSE_PS", "SR-ORG:9237");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("HRDPSW_PS", "SR-ORG:9237");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("HRDPSS_PS", "SR-ORG:9237");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("EAST", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("WEST", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("SUDQC", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("SLFE", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("SLFE3857", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("SUDQC1", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("SUDQC2", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("SUDQC3", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("WCPS_LL", "EPSG:4326");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("WCPS3857", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("GOESR_LLCO", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("GOESR3857", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("FOUDRE_CO3857", "EPSG:3857");
$efd3ba4ec2608b1d$var$ZoomToProjec.set("RADAR_LL", "EPSG:3857");
function $efd3ba4ec2608b1d$var$transforme(extent_, zoom_) {
    return (0, $9c4744460e43e41b$export$751c68e0e0efff79)(extent_, "EPSG:4326", $efd3ba4ec2608b1d$var$ZoomToProjec.get(zoom_));
}
const $efd3ba4ec2608b1d$var$ZoomToExtent = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
//ZoomToExtent.set("NOAM", transforme( [-160.075, 9.925, -39.125, 70.075 ], "NOAM") );
$efd3ba4ec2608b1d$var$ZoomToExtent.set("NOAM", [
    -17824430.6699214,
    1133170.3990476,
    -4444430.66992145,
    11093170.3990476
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("NOAM20", [
    -17884430.6699214,
    1093170.3990476,
    -4444430.66992145,
    11093170.3990476
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("EURO", [
    -4466091.77472862,
    1133170.3990476,
    8913908.22527138,
    11093170.3990476
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("EURO20", [
    -4526091.77472862,
    1093170.3990476,
    8913908.22527138,
    11093170.3990476
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("GDPS_LLW", [
    -160.075,
    10.075,
    -40.075,
    70.075
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("GFS_LLW", [
    -160.125,
    10.125,
    -40.125,
    70.125
]);
//ZoomToExtent.set("NOAMR", transforme( [-145, 25, -45, 75 ], "NOAMR") );
$efd3ba4ec2608b1d$var$ZoomToExtent.set("NOAMR", [
    -16169377.0856973,
    2852243.11199203,
    -5009377.08569731,
    12932243.111992
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("NOAMAQ", [
    -16200000,
    2800000.0,
    -5000000,
    13000000.0
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("RDPS_PS", [
    -4556441.403,
    -7319317.859,
    4793558.597,
    920682.141
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("RDPSS_PS", [
    -4556441.403,
    -7319317.859,
    4793558.597,
    500682.141
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("HRDPS_PS", [
    -2099127.494,
    -5739388.521,
    4340872.506,
    -2099388.521
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("HRDPSE_PS", [
    1120872.506,
    -5439388.521,
    4340872.506,
    -2099388.521
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("HRDPSW_PS", [
    -2099127.494,
    -5439388.521,
    1120872.506,
    -2099388.521
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("HRDPSS_PS", [
    2086872.506,
    -4839388.521,
    3696872.506,
    -2949388.521
]);
//ZoomToExtent.set("EAST", transforme( [ -92, 39, -52, 55 ], "EAST") );
$efd3ba4ec2608b1d$var$ZoomToExtent.set("EAST", [
    -10248613.5212502,
    4711866.11305119,
    -5788613.52125023,
    7361866.11305119
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("WEST", $efd3ba4ec2608b1d$var$transforme([
    -132,
    41,
    -92,
    57
], "WEST"));
//ZoomToExtent.set("SUDQC", transforme( [-78, 43.75, -61, 50.5 ], "SUDQC" ) );
//ZoomToExtent.set("SUDQC",  [-8686488.93838969, 5425321.56783793, -6790488.93838969, 6533321.56783793 ] );
$efd3ba4ec2608b1d$var$ZoomToExtent.set("SUDQC", [
    -8687235.8917887,
    5349725.45439731,
    -6144835.89178879,
    6800125.45439731
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("SLFE", [
    -8254764.35552915,
    5668637.35442844,
    -7792364.35552915,
    6015837.35442844
]);
//ZoomToExtent.set("SLFE3857",  transforme( [ -74.5, 45.3, -70, 47.5 ], "SLFE3857" ) );
$efd3ba4ec2608b1d$var$ZoomToExtent.set("SLFE3857", [
    -8293964.355,
    5668872.119,
    -7792364.356,
    6024072.119
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("SUDQC1", $efd3ba4ec2608b1d$var$transforme([
    -79,
    43.5,
    -72,
    47
], "SUDQC1"));
$efd3ba4ec2608b1d$var$ZoomToExtent.set("SUDQC2", $efd3ba4ec2608b1d$var$transforme([
    -73,
    44.75,
    -67,
    49.5
], "SUDQC2"));
$efd3ba4ec2608b1d$var$ZoomToExtent.set("SUDQC3", $efd3ba4ec2608b1d$var$transforme([
    -68,
    44,
    -61,
    50.5
], "SUDQC3"));
$efd3ba4ec2608b1d$var$ZoomToExtent.set("WCPS_LL", [
    -94.5042,
    38.99583,
    -67.9958,
    53.00417
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("WCPS3857", $efd3ba4ec2608b1d$var$transforme([
    -94.5042,
    38.99583,
    -67.9958,
    53.00417
], "WCPS3857"));
$efd3ba4ec2608b1d$var$ZoomToExtent.set("GOESR_LLCO", $efd3ba4ec2608b1d$var$transforme([
    -110.0555,
    22.0215,
    -58.5,
    51.00
], "GOESR_LLCO"));
$efd3ba4ec2608b1d$var$ZoomToExtent.set("GOESR3857", $efd3ba4ec2608b1d$var$transforme([
    -110.055,
    22.0215,
    -58.5,
    51.00
], "GOESR3857"));
//ZoomToExtent.set("FOUDRE_CO3857", transforme( [ -110.0555, 22.00, -58.50, 51.00], "FOUDRE_CO3857") );
//ZoomToExtent.set("FOUDRE_CO3857", [ -12251266.5592537, 2511525.23484571, -6512190.2114065, 6621293.72274017] );
//ZoomToExtent.set("FOUDRE_CO3857", [ -12251266.5592537, 2550092.56646875, -6512190.2114065, 6621293.72274017] );
//ZoomToExtent.set("FOUDRE_CO3857", transforme( [ -110.0555, 22.0228361765039, -58.50, 51.00], "FOUDRE_CO3857") );
//ZoomToExtent.set("FOUDRE_CO3857", transforme( [ -110.0555, 22.0228361765039, -58.50, 51.00], "FOUDRE_CO3857") );
$efd3ba4ec2608b1d$var$ZoomToExtent.set("FOUDRE_CO3857", [
    -12251266.5592537,
    2514267.211312,
    -6512190.2114065,
    6621293.72274017
]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("RADAR_LLNE", [
    -81.28,
    41.00,
    -64,
    50.72
]);
//ZoomToExtent.set("RADAR_LLCO", transforme( [ -110.0555, 22.00, -58.50, 51.00], "RADAR_LLCO") );
//ZoomToExtent.set("RADAR_LLCO",  [ -12251328.40, 2511525.23, -6512190.21, 6621293.72]);
//ZoomToExtent.set("RADAR_LLCO",  [ -12251328.40, 2550092.56646875, -6512190.21, 6621293.72]);
$efd3ba4ec2608b1d$var$ZoomToExtent.set("RADAR_LL", [
    -12251266.5592537,
    2514267.211312,
    -6512190.2114065,
    6621293.72274017
]);
function $efd3ba4ec2608b1d$var$GetCentre(extent_) {
    let centre_ = [
        (extent_[0] + extent_[2]) / 2.,
        (extent_[1] + extent_[3]) / 2.
    ];
    return centre_;
}
function $efd3ba4ec2608b1d$var$GetCentreDes2(extent_1, extent_2) {
    let centre_ = [
        (extent_1[0] + extent_1[2] + extent_2[0] + extent_2[2]) / 4.,
        (extent_1[1] + extent_1[3] + extent_2[1] + extent_2[3]) / 4.
    ];
    return centre_;
}
function $efd3ba4ec2608b1d$var$IsLonLatInExtent(lon_, lat_, extent_) {
    let lonLatIsIn = false;
    if (lon_ > extent_[0] && lon_ < extent_[2]) {
        if (lat_ > extent_[1] && lat_ < extent_[3]) lonLatIsIn = true;
    }
    return lonLatIsIn;
}
function $efd3ba4ec2608b1d$var$IsCoucheExtentInExtent(extent_, coucheExtent_) {
    ///var minlon = extent_[0];
    ///var minlat = extent_[1];
    ///var maxlon = extent_[2]; 
    ///var maxlat = extent_[3]; 
    var coucheExtentIsInExtent_ = false;
    if (extent_[0] < coucheExtent_[2] && extent_[2] > coucheExtent_[0]) // longitude is ok
    {
        if (extent_[1] < coucheExtent_[3] && extent_[3] > coucheExtent_[1]) // latitude is ok
        coucheExtentIsInExtent_ = true;
    }
    return coucheExtentIsInExtent_;
}
const $efd3ba4ec2608b1d$var$ZoomToViewExtent = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("NOAM", $efd3ba4ec2608b1d$var$transforme([
    -180,
    -10,
    180,
    80
], "NOAM"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("NOAM20", $efd3ba4ec2608b1d$var$transforme([
    -180,
    -10,
    180,
    80
], "NOAM20"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("EURO", $efd3ba4ec2608b1d$var$transforme([
    -180,
    -10,
    180,
    80
], "EURO"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("GDPS_LLW", [
    -165,
    5,
    -35,
    75
]);
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("GFS_LLW", [
    -165,
    5,
    -35,
    75
]);
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("NOAMR", $efd3ba4ec2608b1d$var$transforme([
    -180,
    10,
    -20,
    80
], "NOAMR"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("NOAMAQ", $efd3ba4ec2608b1d$var$transforme([
    -180,
    10,
    -20,
    80
], "NOAMAQ"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("RDPS_PS", $efd3ba4ec2608b1d$var$transforme([
    -145,
    15,
    -13,
    45
], "RDPS_PS"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("RDPSS_PS", $efd3ba4ec2608b1d$var$transforme([
    -145,
    15,
    -13,
    45
], "RDPSS_PS"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("HRDPS_PS", $efd3ba4ec2608b1d$var$transforme([
    -150,
    20,
    -40,
    70
], "HRDPS_PS"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("HRDPSE_PS", $efd3ba4ec2608b1d$var$transforme([
    -150,
    20,
    -40,
    70
], "HRDPSE_PS"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("HRDPSS_PS", $efd3ba4ec2608b1d$var$transforme([
    -150,
    20,
    -40,
    70
], "HRDPSS_PS"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("HRDPSW_PS", $efd3ba4ec2608b1d$var$transforme([
    -150,
    20,
    -40,
    70
], "HRDPSW_PS"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("EAST", $efd3ba4ec2608b1d$var$transforme([
    -95,
    36,
    -49,
    58
], "EAST"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("WEST", $efd3ba4ec2608b1d$var$transforme([
    -135,
    39,
    -89,
    60
], "WEST"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("SUDQC", $efd3ba4ec2608b1d$var$transforme([
    -150,
    20,
    -40,
    70
], "SUDQC"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("SUDQC1", $efd3ba4ec2608b1d$var$transforme([
    -80,
    41,
    -58,
    53
], "SUDQC1"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("SUDQC2", $efd3ba4ec2608b1d$var$transforme([
    -80,
    41,
    -58,
    53
], "SUDQC2"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("SUDQC3", $efd3ba4ec2608b1d$var$transforme([
    -80,
    41,
    -58,
    53
], "SUDQC3"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("SLFE", $efd3ba4ec2608b1d$var$transforme([
    -100,
    35,
    -50,
    60
], "SLFE"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("SLFE3857", $efd3ba4ec2608b1d$var$transforme([
    -100,
    35,
    -50,
    60
], "SLFE3857"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("WCPS_LL", [
    -96,
    38,
    -65,
    54
]);
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("WCPS3857", $efd3ba4ec2608b1d$var$transforme([
    -96,
    38,
    -65,
    54
], "WCPS3857"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("GOESR_LLCO", $efd3ba4ec2608b1d$var$transforme([
    -185,
    10,
    -30,
    70
], "GOESR_LLCO"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("GOESR3857", $efd3ba4ec2608b1d$var$transforme([
    -185,
    10,
    -30,
    70
], "GOESR3857"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("FOUDRE_CO3857", $efd3ba4ec2608b1d$var$transforme([
    -185,
    10,
    -30,
    70
], "FOUDRE_CO3857"));
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("RADAR_LLNE", [
    -95,
    30,
    -45,
    60
]);
$efd3ba4ec2608b1d$var$ZoomToViewExtent.set("RADAR_LL", $efd3ba4ec2608b1d$var$transforme([
    -165,
    15,
    -35,
    60
], "RADAR_LL"));
const $efd3ba4ec2608b1d$var$ModToMapId = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)();
$efd3ba4ec2608b1d$var$ModToMapId.set("RDPS", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("GDPS", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("GDPSIA", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("GDPSE", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("GDPSIAE", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("GFS", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("AIFS", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("AIFSE", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("ECMWF", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("ECMWFE", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("ECMWF3", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("HRDPS E", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("HRDPS W", "PRMSL");
$efd3ba4ec2608b1d$var$ModToMapId.set("HRDPS S", "PRMSL_");
$efd3ba4ec2608b1d$var$ModToMapId.set("HRDPS S0", "WDIR_10");
$efd3ba4ec2608b1d$var$ModToMapId.set("HRDPS S1", "WDIR_10");
$efd3ba4ec2608b1d$var$ModToMapId.set("HRDPS S2", "WDIR_10");
$efd3ba4ec2608b1d$var$ModToMapId.set("HRDPS S3", "WDIR_10");
$efd3ba4ec2608b1d$var$ModToMapId.set("RAQDPS", "PM10_SFC");
$efd3ba4ec2608b1d$var$ModToMapId.set("WCPS", "IICECONC_");
$efd3ba4ec2608b1d$var$ModToMapId.set("RDWPS", "HTSGW_Sfc");
$efd3ba4ec2608b1d$var$ModToMapId.set("DIAGW", "IaG_Sfc");
$efd3ba4ec2608b1d$var$ModToMapId.set("SHOP", "SOSSHEIG");
$efd3ba4ec2608b1d$var$ModToMapId.set("CIOPS", "IICECONC_");
$efd3ba4ec2608b1d$var$ModToMapId.set("GOESR CO", "C13_CO");
$efd3ba4ec2608b1d$var$ModToMapId.set("GOESR GLM", "GLM_G19");
$efd3ba4ec2608b1d$var$ModToMapId.set("GOESR_PLUS", "C13_CO");
$efd3ba4ec2608b1d$var$ModToMapId.set("FOUDRE CO", "FOUDRE_PTS_CO");
$efd3ba4ec2608b1d$var$ModToMapId.set("RADART CO", "RTYP");
$efd3ba4ec2608b1d$var$ModToMapId.set("RADAR CO", "RRAI");
const $efd3ba4ec2608b1d$var$ListModeleId = [];
if ($efd3ba4ec2608b1d$var$WindMaps) {
    $efd3ba4ec2608b1d$var$ListModeleId[0] = "HRDPS S0";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "WCPS";
} else {
    $efd3ba4ec2608b1d$var$ListModeleId[0] = "RDPS";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "RAQDPS";
    //  retrait RAQDPS ici
    //      ListModeleId[0] = "RDPS"; 
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "GDPS";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "GFS";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "HRDPS E";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "HRDPS S0";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "WCPS";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "ECMWF";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "ECMWF3";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "AIFS";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "GOESR CO";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "RADAR CO";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "RADART CO";
    ////ListModeleId[ListModeleId.length] = "GOESR GLM"; 
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "FOUDRE CO";
    $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "GOESR_PLUS";
    if ($efd3ba4ec2608b1d$var$L_GDPSE) {
        $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "GDPSE";
        $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "ECMWFE";
        $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "AIFSE";
    }
}
$efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "RDWPS";
$efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "DIAGW";
if ($efd3ba4ec2608b1d$var$L_SHOP) $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "SHOP";
$efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$ListModeleId.length] = "void";
const $efd3ba4ec2608b1d$var$ListCartePix = [
    "WIND"
];
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "WIN-_10";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "GUST";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "1000-500";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "D-HGT_500";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "TCDC";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "WEARN";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "WEASN";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "WEAFR";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "WEAPE";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "COMPO";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "APCP_";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "APCP-_";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "TMP";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "DPT";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "HUDX";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "CAPE";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "MU-VT-LI_500";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "ABSV";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "C13_CO";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "C02_CO";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "RSNO";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "RSNO NET";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "RRAI";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "RRAI NET";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "SNOD_sfc";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "ICECONC";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "VOTEMPER";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "CSPEED_0.5";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "SOSSHEIG";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "PM10_SFC";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "PM10_ATM";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "PM2.5_SFC";
$efd3ba4ec2608b1d$var$ListCartePix[$efd3ba4ec2608b1d$var$ListCartePix.length] = "PM2.5_ATM";
const $efd3ba4ec2608b1d$var$ListCarteCon = [
    "WDIR_10"
];
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "PRMSL__WDIR_10";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "WDIR_850";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "WDIR_250";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "PRMSL_";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "HGT_1000";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "HGT_850";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "HGT_700";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "HGT_500";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "HGT_250";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "FOUDRE_PTS_CO";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "CDIR_0.5";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "CDIR_Avg";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "PWAVEDIR_Sfc";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "WVDIR_Sfc";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "H1DIR_Sfc";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "H2DIR_Sfc";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "MWDFSWEL_Sfc";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "MWDSSWEL_Sfc";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "IaDir_Sfc";
$efd3ba4ec2608b1d$var$ListCarteCon[$efd3ba4ec2608b1d$var$ListCarteCon.length] = "Ia2Dir_Sfc";
var $efd3ba4ec2608b1d$var$Warning_ECMWF_TYPES = "";
var $efd3ba4ec2608b1d$var$INFO_version = "";
var $efd3ba4ec2608b1d$var$Model1_Def = "";
var $efd3ba4ec2608b1d$var$Model2_Def = "";
var $efd3ba4ec2608b1d$var$Model1;
var $efd3ba4ec2608b1d$var$Model2;
var $efd3ba4ec2608b1d$var$MapIdH2;
var $efd3ba4ec2608b1d$var$MapIdH1;
var $efd3ba4ec2608b1d$var$MapIdCo2;
var $efd3ba4ec2608b1d$var$MapIdCo1;
if ($efd3ba4ec2608b1d$var$WindMaps) {
    $efd3ba4ec2608b1d$var$Model2_Def = "HRDPS S0";
    $efd3ba4ec2608b1d$var$Model1_Def = "HRDPS S0";
    $efd3ba4ec2608b1d$var$Model1 = localStorage.getItem("Model1_V");
    $efd3ba4ec2608b1d$var$Model2 = localStorage.getItem("Model2_V");
    $efd3ba4ec2608b1d$var$MapIdH2 = localStorage.getItem("MapIdH2_V");
    $efd3ba4ec2608b1d$var$MapIdH1 = localStorage.getItem("MapIdH1_V");
    $efd3ba4ec2608b1d$var$MapIdCo2 = localStorage.getItem("MapIdCo2_V");
    $efd3ba4ec2608b1d$var$MapIdCo1 = localStorage.getItem("MapIdCo1_V");
    $efd3ba4ec2608b1d$var$INFO_version = localStorage.getItem("INFO_version");
    console.log(" WindMaps mode local Model1: " + $efd3ba4ec2608b1d$var$Model1 + " Model2: " + $efd3ba4ec2608b1d$var$Model2);
    console.log(" WindMaps mode local maps MapIdH1: " + $efd3ba4ec2608b1d$var$MapIdH1 + " MapIdH2: " + $efd3ba4ec2608b1d$var$MapIdH2);
    console.log(" WindMaps mode local maps MapIdCo1: " + $efd3ba4ec2608b1d$var$MapIdCo1 + " MapIdCo2: " + $efd3ba4ec2608b1d$var$MapIdCo2);
    console.log(" Nowcast mode INFO_version: ", $efd3ba4ec2608b1d$var$INFO_version);
} else if ($efd3ba4ec2608b1d$var$Nowcast) {
    $efd3ba4ec2608b1d$var$Model1_Def = "RADAR CO";
    $efd3ba4ec2608b1d$var$Model2_Def = "GOESR CO";
    $efd3ba4ec2608b1d$var$Model1 = localStorage.getItem("Model1_N");
    $efd3ba4ec2608b1d$var$Model2 = localStorage.getItem("Model2_N");
    $efd3ba4ec2608b1d$var$MapIdH2 = localStorage.getItem("MapIdH2_N");
    $efd3ba4ec2608b1d$var$MapIdH1 = localStorage.getItem("MapIdH1_N");
    $efd3ba4ec2608b1d$var$MapIdCo2 = localStorage.getItem("MapIdCo2_N");
    $efd3ba4ec2608b1d$var$MapIdCo1 = localStorage.getItem("MapIdCo1_N");
    $efd3ba4ec2608b1d$var$INFO_version = localStorage.getItem("INFO_version");
    console.log(" Nowcast mode local Model1: " + $efd3ba4ec2608b1d$var$Model1 + " Model2: " + $efd3ba4ec2608b1d$var$Model2);
    console.log(" Nowcast mode local maps MapIdH1: " + $efd3ba4ec2608b1d$var$MapIdH1 + " MapIdH2: " + $efd3ba4ec2608b1d$var$MapIdH2);
    console.log(" Nowcast mode local maps MapIdCo1: " + $efd3ba4ec2608b1d$var$MapIdCo1 + " MapIdCo2: " + $efd3ba4ec2608b1d$var$MapIdCo2);
    console.log(" Nowcast mode INFO_version: ", $efd3ba4ec2608b1d$var$INFO_version);
} else {
    $efd3ba4ec2608b1d$var$Model1_Def = "RDPS";
    $efd3ba4ec2608b1d$var$Model2_Def = "RDPS";
    $efd3ba4ec2608b1d$var$Model1 = localStorage.getItem("Model1");
    $efd3ba4ec2608b1d$var$Model2 = localStorage.getItem("Model2");
    $efd3ba4ec2608b1d$var$MapIdH2 = localStorage.getItem("MapIdH2");
    $efd3ba4ec2608b1d$var$MapIdH1 = localStorage.getItem("MapIdH1");
    $efd3ba4ec2608b1d$var$MapIdCo2 = localStorage.getItem("MapIdCo2");
    $efd3ba4ec2608b1d$var$MapIdCo1 = localStorage.getItem("MapIdCo1");
    $efd3ba4ec2608b1d$var$Warning_ECMWF_TYPES = localStorage.getItem("Warning_ECMWF_TYPES");
    $efd3ba4ec2608b1d$var$INFO_version = localStorage.getItem("INFO_version");
    console.log(" Prog mode local Model1: " + $efd3ba4ec2608b1d$var$Model1 + " Model2: " + $efd3ba4ec2608b1d$var$Model2);
    console.log(" Prog mode local maps MapIdH1: " + $efd3ba4ec2608b1d$var$MapIdH1 + " MapIdH2: " + $efd3ba4ec2608b1d$var$MapIdH2);
    console.log(" Prog mode local maps MapIdCo1: " + $efd3ba4ec2608b1d$var$MapIdCo1 + " MapIdCo2: " + $efd3ba4ec2608b1d$var$MapIdCo2);
    console.log(" Prog mode local Warning ECMWF: ", $efd3ba4ec2608b1d$var$Warning_ECMWF_TYPES);
    console.log(" Prog mode INFO_version: ", $efd3ba4ec2608b1d$var$INFO_version);
}
function $efd3ba4ec2608b1d$var$supprimerAvantVersion(chaine) {
    if (chaine === undefined || chaine === null) chaine = " ";
    const index = chaine.indexOf("Version ");
    if (index !== -1) return chaine.substring(index + 8);
    return chaine; // Retourne la chaîne originale si "Version " n'est pas trouvé
}
//   Backward compatibility with previous versions including de string Version_   at the begining...
$efd3ba4ec2608b1d$var$INFO_version = $efd3ba4ec2608b1d$var$supprimerAvantVersion($efd3ba4ec2608b1d$var$INFO_version);
var $efd3ba4ec2608b1d$var$Couche2Void = false;
var $efd3ba4ec2608b1d$var$Model2localVoid = false;
var $efd3ba4ec2608b1d$var$Couche1CoVoid = false;
var $efd3ba4ec2608b1d$var$Couche2CoVoid = false;
var $efd3ba4ec2608b1d$var$foundModel = false;
for(let i = 0; i < $efd3ba4ec2608b1d$var$ListModeleId.length - 1; i++)if ($efd3ba4ec2608b1d$var$Model1 == $efd3ba4ec2608b1d$var$ListModeleId[i]) $efd3ba4ec2608b1d$var$foundModel = true;
if (!$efd3ba4ec2608b1d$var$foundModel) $efd3ba4ec2608b1d$var$Model1 = $efd3ba4ec2608b1d$var$Model1_Def;
$efd3ba4ec2608b1d$var$foundModel = false;
for(let i = 0; i < $efd3ba4ec2608b1d$var$ListModeleId.length; i++)if ($efd3ba4ec2608b1d$var$Model2 == $efd3ba4ec2608b1d$var$ListModeleId[i]) $efd3ba4ec2608b1d$var$foundModel = true;
if (!$efd3ba4ec2608b1d$var$foundModel) $efd3ba4ec2608b1d$var$Model2 = $efd3ba4ec2608b1d$var$Model2_Def;
if ($efd3ba4ec2608b1d$var$MapIdH1 === undefined || $efd3ba4ec2608b1d$var$MapIdH1 === null) $efd3ba4ec2608b1d$var$MapIdH1 = $efd3ba4ec2608b1d$var$ModToMapId.get($efd3ba4ec2608b1d$var$Model1);
if ($efd3ba4ec2608b1d$var$MapIdCo1 == null) {
    $efd3ba4ec2608b1d$var$Couche1CoVoid = true;
    $efd3ba4ec2608b1d$var$MapIdCo1 = "void";
}
if ($efd3ba4ec2608b1d$var$Model2 == "void") {
    $efd3ba4ec2608b1d$var$MapIdH2 = $efd3ba4ec2608b1d$var$MapIdH1;
    $efd3ba4ec2608b1d$var$MapIdCo2 = $efd3ba4ec2608b1d$var$MapIdCo1;
    $efd3ba4ec2608b1d$var$Model2localVoid = true;
    $efd3ba4ec2608b1d$var$Couche2Void = true;
} else {
    if ($efd3ba4ec2608b1d$var$MapIdH2 === undefined || $efd3ba4ec2608b1d$var$MapIdH2 === null) $efd3ba4ec2608b1d$var$MapIdH2 = $efd3ba4ec2608b1d$var$ModToMapId.get($efd3ba4ec2608b1d$var$Model2);
    if ($efd3ba4ec2608b1d$var$MapIdCo2 == null) {
        $efd3ba4ec2608b1d$var$Couche2CoVoid = true;
        $efd3ba4ec2608b1d$var$MapIdCo2 = "void";
    }
}
var $efd3ba4ec2608b1d$var$Opacitee1 = 1.0;
var $efd3ba4ec2608b1d$var$Opacitee2 = 1.0;
var $efd3ba4ec2608b1d$var$Smooting = true;
var $efd3ba4ec2608b1d$var$SmootingA = true;
var $efd3ba4ec2608b1d$var$Mod1Id = $efd3ba4ec2608b1d$var$ModToId.get($efd3ba4ec2608b1d$var$Model1);
var $efd3ba4ec2608b1d$var$Mod2Id = $efd3ba4ec2608b1d$var$ModToId.get($efd3ba4ec2608b1d$var$Model2);
if ($efd3ba4ec2608b1d$var$WindMaps) {
    $efd3ba4ec2608b1d$var$Opacitee1 = 1.0;
    $efd3ba4ec2608b1d$var$Opacitee2 = 1.0;
}
//
let $efd3ba4ec2608b1d$var$CountTiles1 = [];
let $efd3ba4ec2608b1d$var$CountTiles2 = [];
//MapIdH2="WDIR_10_";
//MapIdH1="WIN-_10_";
const $efd3ba4ec2608b1d$var$Couche2 = new $efd3ba4ec2608b1d$var$Couche($efd3ba4ec2608b1d$var$Mod2Id, $efd3ba4ec2608b1d$var$Model2, $efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Model2), $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Model2)), $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Model2)), $efd3ba4ec2608b1d$var$MapIdH2, $efd3ba4ec2608b1d$var$MapIdCo2, $efd3ba4ec2608b1d$var$ModAHourOId.get($efd3ba4ec2608b1d$var$Model2), $efd3ba4ec2608b1d$var$ModADebut.get($efd3ba4ec2608b1d$var$Model2), $efd3ba4ec2608b1d$var$ModAFin.get($efd3ba4ec2608b1d$var$Model2), $efd3ba4ec2608b1d$var$ModAInterv.get($efd3ba4ec2608b1d$var$Model2));
const $efd3ba4ec2608b1d$var$Couche1 = new $efd3ba4ec2608b1d$var$Couche($efd3ba4ec2608b1d$var$Mod1Id, $efd3ba4ec2608b1d$var$Model1, $efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Model1), $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Model1)), $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Model1)), $efd3ba4ec2608b1d$var$MapIdH1, $efd3ba4ec2608b1d$var$MapIdCo1, $efd3ba4ec2608b1d$var$ModAHourOId.get($efd3ba4ec2608b1d$var$Model1), $efd3ba4ec2608b1d$var$ModADebut.get($efd3ba4ec2608b1d$var$Model1), $efd3ba4ec2608b1d$var$ModAFin.get($efd3ba4ec2608b1d$var$Model1), $efd3ba4ec2608b1d$var$ModAInterv.get($efd3ba4ec2608b1d$var$Model1));
var $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
//      'TO_PRMSL__COMPO__3h_2021091412_' + nHour + '.png',
//      'TO_WIN-_10_2021091412_' + nHour + '.png',
//      'TO_WDIR_10_2021091412_' + nHour + '.png',
//      'TO_PRMSL__2021091506_' + nHour + '.png',
// -------------------------------------------------------------------
//
//showLgnd(1);
//showLgnd(2);
//------------------------------------------------------------------
// ---  checking for valid Houroid
var $efd3ba4ec2608b1d$var$VerboseHourOIdOk = true;
var $efd3ba4ec2608b1d$var$indexListHourOIdOk = 0;
var $efd3ba4ec2608b1d$var$SetMenuHourOIdRun1 = false;
var $efd3ba4ec2608b1d$var$SetMenuHourOIdRun2 = false;
$efd3ba4ec2608b1d$var$readSetLatestHourOId($efd3ba4ec2608b1d$var$ModAHourOId.get($efd3ba4ec2608b1d$var$Model1), $efd3ba4ec2608b1d$var$Model1, false, true);
$efd3ba4ec2608b1d$var$readSetLatestHourOId($efd3ba4ec2608b1d$var$ModAHourOId.get($efd3ba4ec2608b1d$var$Model2), $efd3ba4ec2608b1d$var$Model2, false, true);
//------------------------------------------------------------------------
//const LoadedAndReady = [false, false, false];
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$SetAttribution(mod2Id, icouche) {
    let attributionECCC = ' <a href="https://eccc-msc.github.io/open-data/">ECCC</a>';
    let attributionECMWF = ' <a href="https://www.ecmwf.int">ECMWF</a> <a href="https://creativecommons.org/licenses/by/4.0/">\xa9</a>';
    let attributionNCEP = ' <a href="https://www.ncei.noaa.gov/products/weather-climate-models/global-forecast">NOAA</a>';
    let attributionGOES = ' <a href="https://thredds.ucar.edu/thredds/catalog/catalog.html">GOES via UNIDATA</a>';
    let attributionFOUDRE = ' <a href="https://www.blitzortung.org/en/live_lightning_maps.php">Foudre via Blitzortung</a>';
    let attributionDebut = " Sources m\xe9t\xe9o: ";
    let attribution = "";
    if (mod2Id == "RDPS" || mod2Id == "GDPS" || mod2Id == "GDPSIA" || mod2Id == "GDPSE" || mod2Id == "HRDPS" || mod2Id == "WCPS" || mod2Id == "SHOP" || mod2Id == "RDWPS" || mod2Id == "DIAGW" || mod2Id == "RAQDPS" || mod2Id == "GDPSIAE") attribution = attributionDebut + attributionECCC;
    else if (mod2Id == "GFS") attribution = attributionDebut + attributionNCEP;
    else if (mod2Id == "ECMWF" || mod2Id == "ECMWFE" || mod2Id == "ECMWF3" || mod2Id == "AIFS" || mod2Id == "AIFSE") attribution = attributionDebut + attributionECMWF;
    else if (mod2Id == "RADAR") attribution = attributionDebut + attributionECCC;
    else if (mod2Id == "GOESR" || mod2Id == "GOESR_PLUS" || mod2Id == "GLM") attribution = attributionDebut + attributionGOES;
    else if (mod2Id == "FOUDRE") attribution = attributionDebut + attributionFOUDRE;
    else attribution = attributionDebut + " Non identifi\xe9e...";
    attribution = attribution + " pr\xe9par\xe9 par Imeteo. Overlay: ";
    return attribution;
}
// ________________________________________________________________________________
//-----------------------------------------------------------------------------------
var $efd3ba4ec2608b1d$var$AttributionMeteo1 = $efd3ba4ec2608b1d$var$SetAttribution($efd3ba4ec2608b1d$var$Couche1.modele, "1");
var $efd3ba4ec2608b1d$var$AttributionMeteo2 = $efd3ba4ec2608b1d$var$SetAttribution($efd3ba4ec2608b1d$var$Couche2.modele, "2");
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$calculResolutions(tileDimX, tileDimY, projExtent, resolution, number) {
    // Calcul la rsolution des mozaic pour les zoom 
    // la longueur de resolutions   detremine le nombre de zoom de la couche           
    let startResolution = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projExtent) / tileDimX;
    for(let i = 0, ii = number + 1; i < ii; ++i)resolution[i] = startResolution / Math.pow(2, i);
    return resolution;
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateSource(istep, i_couche) {
    var index = istep % $efd3ba4ec2608b1d$var$NoOfLayers;
    var message;
    if (i_couche == "1") {
        $efd3ba4ec2608b1d$var$ISTEP_ecout1 = istep;
        message = "updateSource Url change for layer no:" + i_couche.toString() + " step:" + istep + " index:" + index;
        console.log(message);
        if ($efd3ba4ec2608b1d$var$tileSource1[index] == null) {
            console.log("Warning: Refresh could not be made for layer 1. Will resetSource 1");
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo1[istep], $efd3ba4ec2608b1d$var$listUrl1[istep], istep, $efd3ba4ec2608b1d$var$Couche1, i_couche);
        } else if (!$efd3ba4ec2608b1d$var$Couche1CoVoid && $efd3ba4ec2608b1d$var$tileSourceCo1[index] == null) {
            console.log("Warning: Refresh could not be made for colayer 1. Will resetSource 1");
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo1[istep], $efd3ba4ec2608b1d$var$listUrl1[istep], istep, $efd3ba4ec2608b1d$var$Couche1, i_couche);
        } else {
            var urlTuile = $efd3ba4ec2608b1d$var$listUrl1[istep] + "/{z}/{x}/{y}.png";
            console.log("Refresh will be made for main layer 1 URL: " + $efd3ba4ec2608b1d$var$listUrl1[istep]);
            for(let indice = index; indice <= $efd3ba4ec2608b1d$var$ISTEP_max; indice = indice + $efd3ba4ec2608b1d$var$NoOfLayers){
                $efd3ba4ec2608b1d$var$listLoaded1[indice] = "non";
                $efd3ba4ec2608b1d$var$listNuLoadStart1[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadEnd1[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadErr1[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuWait1[indice] = 0;
            }
            $efd3ba4ec2608b1d$var$listLoaded1[istep] = "loading";
            $efd3ba4ec2608b1d$var$tileSource1[index].setUrl(urlTuile);
            $efd3ba4ec2608b1d$var$tileSource1[index].refresh();
            $efd3ba4ec2608b1d$var$tileLayers1[index].setOpacity(0.0);
            if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) {
                urlTuile = $efd3ba4ec2608b1d$var$listUrlCo1[istep] + "/{z}/{x}/{y}.png";
                console.log("Refresh will be made for co layer 1 URL: " + $efd3ba4ec2608b1d$var$listUrlCo1[istep]);
                for(let indice = index; indice <= $efd3ba4ec2608b1d$var$ISTEP_max; indice = indice + $efd3ba4ec2608b1d$var$NoOfLayers){
                    $efd3ba4ec2608b1d$var$listLoadedCo1[indice] = "non";
                    $efd3ba4ec2608b1d$var$listNuLoadStartCo1[indice] = 0;
                    $efd3ba4ec2608b1d$var$listNuLoadEndCo1[indice] = 0;
                    $efd3ba4ec2608b1d$var$listNuLoadErrCo1[indice] = 0;
                    $efd3ba4ec2608b1d$var$listNuWaitCo1[indice] = 0;
                }
                $efd3ba4ec2608b1d$var$listLoadedCo1[istep] = "loading";
                $efd3ba4ec2608b1d$var$tileSourceCo1[index].setUrl(urlTuile);
                $efd3ba4ec2608b1d$var$tileSourceCo1[index].refresh();
                $efd3ba4ec2608b1d$var$tileLayersCo1[index].setOpacity(0.0);
            }
        }
    } else if (i_couche == "2" && !$efd3ba4ec2608b1d$var$Couche2Void) {
        $efd3ba4ec2608b1d$var$ISTEP_ecout2 = istep;
        message = "updateSource Url change for layer no:" + i_couche.toString() + " step:" + istep + " index:" + index;
        console.log(message);
        if ($efd3ba4ec2608b1d$var$tileSource2[index] == null) {
            console.log("Warning: Refresh could not be made for layer 2. Will resetSource 2");
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo2[istep], $efd3ba4ec2608b1d$var$listUrl2[istep], istep, $efd3ba4ec2608b1d$var$Couche2, i_couche);
        } else if (!$efd3ba4ec2608b1d$var$Couche2CoVoid && $efd3ba4ec2608b1d$var$tileSourceCo2[index] == null) {
            console.log("Warning: Refresh could not be made for layer 2. Will resetSource 2");
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo2[istep], $efd3ba4ec2608b1d$var$listUrl2[istep], istep, $efd3ba4ec2608b1d$var$Couche2, i_couche);
        } else {
            var urlTuile = $efd3ba4ec2608b1d$var$listUrl2[istep] + "/{z}/{x}/{y}.png";
            console.log("Refresh will be made for main layer 2 URL: " + $efd3ba4ec2608b1d$var$listUrl2[istep]);
            for(let indice = index; indice <= $efd3ba4ec2608b1d$var$ISTEP_max; indice = indice + $efd3ba4ec2608b1d$var$NoOfLayers){
                $efd3ba4ec2608b1d$var$listLoaded2[indice] = "non";
                $efd3ba4ec2608b1d$var$listNuLoadStart2[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadEnd2[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadErr2[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuWait2[indice] = 0;
            }
            $efd3ba4ec2608b1d$var$listLoaded2[istep] = "loading";
            $efd3ba4ec2608b1d$var$tileSource2[index].setUrl(urlTuile);
            $efd3ba4ec2608b1d$var$tileSource2[index].refresh();
            $efd3ba4ec2608b1d$var$tileLayers2[index].setOpacity(0.0);
            if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) {
                urlTuile = $efd3ba4ec2608b1d$var$listUrlCo2[istep] + "/{z}/{x}/{y}.png";
                console.log("Refresh will be made for co layer 2 URL: " + $efd3ba4ec2608b1d$var$listUrlCo2[istep]);
                for(let indice = index; indice <= $efd3ba4ec2608b1d$var$ISTEP_max; indice = indice + $efd3ba4ec2608b1d$var$NoOfLayers){
                    $efd3ba4ec2608b1d$var$listLoadedCo2[indice] = "non";
                    $efd3ba4ec2608b1d$var$listNuLoadStartCo2[indice] = 0;
                    $efd3ba4ec2608b1d$var$listNuLoadEndCo2[indice] = 0;
                    $efd3ba4ec2608b1d$var$listNuLoadErrCo2[indice] = 0;
                    $efd3ba4ec2608b1d$var$listNuWaitCo2[indice] = 0;
                }
                $efd3ba4ec2608b1d$var$listLoadedCo2[istep] = "loading";
                $efd3ba4ec2608b1d$var$tileSourceCo2[index].setUrl(urlTuile);
                $efd3ba4ec2608b1d$var$tileSourceCo2[index].refresh();
                $efd3ba4ec2608b1d$var$tileLayersCo2[index].setOpacity(0.0);
            }
        }
    }
}
// ________________________________________________________________________________
/**
 * Configure les écouteurs d'événements de chargement de tuiles pour une source donnée
 * et initialise les listes de suivi des chargements.
 * ...
 */ function $efd3ba4ec2608b1d$var$setupTileLoadingEvents(source, listLoaded, listNuLoadStart, listNuLoadEnd, listNuLoadErr, listNuWait, layerName, index) {
    // 1. Détacher les écouteurs précédents (s'ils existent)
    // C'est CRUCIAL si cette fonction est appelée à plusieurs reprises pour la MÊME SOURCE
    // (par exemple, si tu réinitialises la configuration d'une source existante).
    if (source._customTileLoadStartHandler) source.un("tileloadstart", source._customTileLoadStartHandler);
    if (source._customTileLoadEndHandler) source.un("tileloadend", source._customTileLoadEndHandler);
    if (source._customTileLoadErrorHandler) source.un("tileloaderror", source._customTileLoadErrorHandler);
    // 2. Initialisation des listes (logique inchangée)
    // ...
    // 3. Définition des nouveaux handlers et stockage de leur référence sur la source
    source._customTileLoadStartHandler = function() {
        const nHour = forecastTimes[currentForecastIndex];
        const message = `tileload start fired for ${layerName} for hour: ${nHour}`;
        // console.log(message);
        if (currentForecastIndex !== -1 && currentForecastIndex < listNuLoadStart.length) listNuLoadStart[currentForecastIndex]++;
    };
    source.on("tileloadstart", source._customTileLoadStartHandler);
    source._customTileLoadEndHandler = function() {
        const nHour = forecastTimes[currentForecastIndex];
        const message = `tileload end fired for ${layerName} for hour: ${nHour}`;
        // console.log(message);
        if (currentForecastIndex !== -1 && currentForecastIndex < listNuLoadEnd.length) listNuLoadEnd[currentForecastIndex]++;
    };
    source.on("tileloadend", source._customTileLoadEndHandler);
    source._customTileLoadErrorHandler = function() {
        const nHour = forecastTimes[currentForecastIndex];
        const message = `tileload error fired for ${layerName} for hour: ${nHour}`;
        console.log(message);
        if (currentForecastIndex !== -1 && currentForecastIndex < listNuLoadErr.length) listNuLoadErr[currentForecastIndex]++;
    };
    source.on("tileloaderror", source._customTileLoadErrorHandler);
}
function $efd3ba4ec2608b1d$var$setEcouteursSource(sourceTile, i_couche, coucheCo) {
    if (i_couche == "1" && coucheCo == "mainLayer") {
        sourceTile.on("tileloadstart", $efd3ba4ec2608b1d$var$ecouteStart1);
        sourceTile.on("tileloadend", $efd3ba4ec2608b1d$var$ecouteEnd1);
        sourceTile.on("tileloaderror", $efd3ba4ec2608b1d$var$ecouteErr1);
    } else if (i_couche == "1" && coucheCo == "coLayer") {
        sourceTile.on("tileloadstart", $efd3ba4ec2608b1d$var$ecouteStartCo1);
        sourceTile.on("tileloadend", $efd3ba4ec2608b1d$var$ecouteEndCo1);
        sourceTile.on("tileloaderror", $efd3ba4ec2608b1d$var$ecouteErrCo1);
    } else if (i_couche == "2" && coucheCo == "mainLayer") {
        sourceTile.on("tileloadstart", $efd3ba4ec2608b1d$var$ecouteStart2);
        sourceTile.on("tileloadend", $efd3ba4ec2608b1d$var$ecouteEnd2);
        sourceTile.on("tileloaderror", $efd3ba4ec2608b1d$var$ecouteErr2);
    } else if (i_couche == "2" && coucheCo == "coLayer") {
        sourceTile.on("tileloadstart", $efd3ba4ec2608b1d$var$ecouteStartCo2);
        sourceTile.on("tileloadend", $efd3ba4ec2608b1d$var$ecouteEndCo2);
        sourceTile.on("tileloaderror", $efd3ba4ec2608b1d$var$ecouteErrCo2);
    }
}
function $efd3ba4ec2608b1d$var$unsetEcouteursSource(sourceTile, i_couche, coucheCo) {
    if (i_couche == "1" && coucheCo == "mainLayer") {
        sourceTile.un("tileloadstart", $efd3ba4ec2608b1d$var$ecouteStart1);
        sourceTile.un("tileloadend", $efd3ba4ec2608b1d$var$ecouteEnd1);
        sourceTile.un("tileloaderror", $efd3ba4ec2608b1d$var$ecouteErr1);
    } else if (i_couche == "1" && coucheCo == "coLayer") {
        sourceTile.un("tileloadstart", $efd3ba4ec2608b1d$var$ecouteStartCo1);
        sourceTile.un("tileloadend", $efd3ba4ec2608b1d$var$ecouteEndCo1);
        sourceTile.un("tileloaderror", $efd3ba4ec2608b1d$var$ecouteErrCo1);
    } else if (i_couche == "2" && coucheCo == "mainLayer") {
        sourceTile.un("tileloadstart", $efd3ba4ec2608b1d$var$ecouteStart2);
        sourceTile.un("tileloadend", $efd3ba4ec2608b1d$var$ecouteEnd2);
        sourceTile.un("tileloaderror", $efd3ba4ec2608b1d$var$ecouteErr2);
    } else if (i_couche == "2" && coucheCo == "coLayer") {
        sourceTile.un("tileloadstart", $efd3ba4ec2608b1d$var$ecouteStartCo2);
        sourceTile.un("tileloadend", $efd3ba4ec2608b1d$var$ecouteEndCo2);
        sourceTile.un("tileloaderror", $efd3ba4ec2608b1d$var$ecouteErrCo2);
    }
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$ecouteStart1() {
    $efd3ba4ec2608b1d$var$listNuLoadStart1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] = $efd3ba4ec2608b1d$var$listNuLoadStart1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + 1;
    var message = " Ecouteur 1 START main 1: " + $efd3ba4ec2608b1d$var$listNuLoadStart1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout1; // console.log(message);
    if ($efd3ba4ec2608b1d$var$listNuLoadStart1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] == 1) console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteEnd1() {
    $efd3ba4ec2608b1d$var$listNuLoadEnd1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] = $efd3ba4ec2608b1d$var$listNuLoadEnd1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + 1;
    var message = " Ecouteur 1 END main 1: " + $efd3ba4ec2608b1d$var$listNuLoadEnd1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout1; // console.log(message);
    if ($efd3ba4ec2608b1d$var$listNuLoadEnd1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] >= $efd3ba4ec2608b1d$var$listNuLoadStart1[$efd3ba4ec2608b1d$var$ISTEP_ecout1]) console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteErr1() {
    $efd3ba4ec2608b1d$var$listNuLoadErr1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] = $efd3ba4ec2608b1d$var$listNuLoadErr1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + 1;
    var message = " Ecouteur 1 ERROR main 1: " + $efd3ba4ec2608b1d$var$listNuLoadErr1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout1;
    console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteStartCo1() {
    $efd3ba4ec2608b1d$var$listNuLoadStartCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] = $efd3ba4ec2608b1d$var$listNuLoadStartCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + 1;
    var message = " Ecouteur 1 START co1: " + $efd3ba4ec2608b1d$var$listNuLoadStartCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout1; // console.log(message);
    if ($efd3ba4ec2608b1d$var$listNuLoadStartCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] == 1) console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteEndCo1() {
    $efd3ba4ec2608b1d$var$listNuLoadEndCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] = $efd3ba4ec2608b1d$var$listNuLoadEndCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + 1;
    var message = " Ecouteur 1 END co1: " + $efd3ba4ec2608b1d$var$listNuLoadEndCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout1; //  console.log(message);
    message = " Ecouteur 1 END main co1: " + $efd3ba4ec2608b1d$var$listNuLoadEndCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout1;
    if ($efd3ba4ec2608b1d$var$listNuLoadEndCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] >= $efd3ba4ec2608b1d$var$listNuLoadStartCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1]) console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteErrCo1() {
    $efd3ba4ec2608b1d$var$listNuLoadErrCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] = $efd3ba4ec2608b1d$var$listNuLoadErrCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + 1;
    var message = " Ecouteur 1 ERROR co1: " + $efd3ba4ec2608b1d$var$listNuLoadErrCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout1;
    console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteStart2() {
    $efd3ba4ec2608b1d$var$listNuLoadStart2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = $efd3ba4ec2608b1d$var$listNuLoadStart2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + 1;
    var message = " Ecouteur 2 start main 2: " + $efd3ba4ec2608b1d$var$listNuLoadStart2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout2; //  console.log(message);
    if ($efd3ba4ec2608b1d$var$listNuLoadStart2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] == 1) console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteEnd2() {
    $efd3ba4ec2608b1d$var$listNuLoadEnd2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = $efd3ba4ec2608b1d$var$listNuLoadEnd2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + 1;
    var message = " Ecouteur 2 END main 2: " + $efd3ba4ec2608b1d$var$listNuLoadEnd2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout2; // console.log(message);
    message = " Ecouteur 2 END main 2: " + $efd3ba4ec2608b1d$var$listNuLoadEnd2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout2;
    if ($efd3ba4ec2608b1d$var$listNuLoadEnd2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] >= $efd3ba4ec2608b1d$var$listNuLoadStart2[$efd3ba4ec2608b1d$var$ISTEP_ecout2]) console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteErr2() {
    $efd3ba4ec2608b1d$var$listNuLoadErr2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = $efd3ba4ec2608b1d$var$listNuLoadErr2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + 1;
    var message = " Ecouteur 2 ERROR main 2: " + $efd3ba4ec2608b1d$var$listNuLoadErr2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout2;
    console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteStartCo2() {
    $efd3ba4ec2608b1d$var$listNuLoadStartCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = $efd3ba4ec2608b1d$var$listNuLoadStartCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + 1;
    var message = " Ecouteur 2 start Co2: " + $efd3ba4ec2608b1d$var$listNuLoadStartCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout2; //  console.log(message);
    if ($efd3ba4ec2608b1d$var$listNuLoadStartCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] == 1) console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteEndCo2() {
    $efd3ba4ec2608b1d$var$listNuLoadEndCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = $efd3ba4ec2608b1d$var$listNuLoadEndCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + 1;
    var message = " Ecouteur 2 END Co2: " + $efd3ba4ec2608b1d$var$listNuLoadEndCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout2; // console.log(message);
    message = " Ecouteur 2 END main co2: " + $efd3ba4ec2608b1d$var$listNuLoadEndCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout2;
    if ($efd3ba4ec2608b1d$var$listNuLoadEndCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] >= $efd3ba4ec2608b1d$var$listNuLoadStartCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2]) console.log(message);
}
function $efd3ba4ec2608b1d$var$ecouteErrCo2() {
    $efd3ba4ec2608b1d$var$listNuLoadErrCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = $efd3ba4ec2608b1d$var$listNuLoadErrCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + 1;
    var message = " Ecouteur 2 ERROR Co2: " + $efd3ba4ec2608b1d$var$listNuLoadErrCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] + " for step: " + $efd3ba4ec2608b1d$var$ISTEP_ecout2;
    console.log(message);
}
//   TileLoadFunction series C   from the following source:
//   https://gis.stackexchange.com/questions/466467/retrying-failed-xyz-tile-load-in-openlayers
//   
async function $efd3ba4ec2608b1d$var$myTileLoadFunctionC1(tile, src) {
    //      retry codes for tileloadfunction...
    ///                 https://neilpatel.com/blog/http-response-codes/
    //      code 404 for missing file will be catch explicitely in the tileLoadFunction
    //      the others in the following list will trigger a retry
    const retryCodes = [
        408,
        429,
        500,
        502,
        503,
        504
    ];
    const image = tile.getImage();
    let response;
    let attempts = 0;
    let valid = false;
    try {
        while(true){
            attempts++;
            response = await fetch(src);
            valid = !retryCodes.includes(response.status);
            if (response.status == 404) {
                let message = " Image tile 1 tagged as missing 404 by tileLoadFunction:  " + $efd3ba4ec2608b1d$var$listUrl1[$efd3ba4ec2608b1d$var$ISTEP_ecout1];
                console.log(message);
                $efd3ba4ec2608b1d$var$listLoaded1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] = "missing";
                valid = false;
                break;
            } else if (valid) break;
            else if (attempts === 2) {
                let message = " To many tileLoadFunction attempts, tile1 will be assigned to missing:  " + $efd3ba4ec2608b1d$var$listUrl1[$efd3ba4ec2608b1d$var$ISTEP_ecout1];
                console.log(message);
                $efd3ba4ec2608b1d$var$listLoaded1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] = "missing";
                valid = false;
                break;
            }
            let message = " tile1 load retried attempts: " + attempts + " by tileLoadFunction, step: " + $efd3ba4ec2608b1d$var$listUrl1[$efd3ba4ec2608b1d$var$ISTEP_ecout1];
            console.log(message);
            await new Promise((resolve)=>setTimeout(resolve, attempts * 250));
        }
        if (valid) {
            const blob = await response.blob();
            const imageUrl = URL.createObjectURL(blob);
            image.addEventListener("load", ()=>URL.revokeObjectURL(imageUrl));
            image.src = imageUrl;
        } else tile.setState(3); // error
    } catch (error) {
        let message = " Error in the tileLoadFunction, tile1 will be assigned to missing:  " + $efd3ba4ec2608b1d$var$listUrl1[$efd3ba4ec2608b1d$var$ISTEP_ecout1];
        console.log(message);
        $efd3ba4ec2608b1d$var$listLoaded1[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = "missing";
        tile.setState(3); //  error
    }
}
async function $efd3ba4ec2608b1d$var$myTileLoadFunctionCCo1(tile, src) {
    //      retry codes for tileloadfunction...
    ///                 https://neilpatel.com/blog/http-response-codes/
    //      code 404 for missing file will be catch explicitely in the tileLoadFunction
    //      the others in the following list will trigger a retry
    const retryCodes = [
        408,
        429,
        500,
        502,
        503,
        504
    ];
    const image = tile.getImage();
    let response;
    let attempts = 0;
    let valid = false;
    try {
        while(true){
            attempts++;
            response = await fetch(src);
            valid = !retryCodes.includes(response.status);
            if (response.status == 404) {
                let message = " Image tile Co1 tagged as missing 404 by tileLoadFunction:  " + $efd3ba4ec2608b1d$var$listUrlCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1];
                console.log(message);
                $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1_ecout1] = "missing";
                valid = false;
                break;
            } else if (valid) break;
            else if (attempts === 2) {
                let message = " To many tileLoadFunction attempts, tile Co1 will be assigned to missing:  " + $efd3ba4ec2608b1d$var$listUrlCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1];
                console.log(message);
                $efd3ba4ec2608b1d$var$listLoadedCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] = "missing";
                valid = false;
                break;
            }
            let message = " tileCo1 load retried attempts: " + attempts + " by tileLoadFunction, step: " + $efd3ba4ec2608b1d$var$listUrlCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1];
            console.log(message);
            await new Promise((resolve)=>setTimeout(resolve, attempts * 250));
        }
        if (valid) {
            const blob = await response.blob();
            const imageUrl = URL.createObjectURL(blob);
            image.addEventListener("load", ()=>URL.revokeObjectURL(imageUrl));
            image.src = imageUrl;
        } else tile.setState(3); // error
    } catch (error) {
        let message = " Error in the tileLoadFunction, tileCo1 will be assigned to missing:  " + $efd3ba4ec2608b1d$var$listUrlCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1];
        console.log(message);
        $efd3ba4ec2608b1d$var$listLoadedCo1[$efd3ba4ec2608b1d$var$ISTEP_ecout1] = "missing";
        tile.setState(3); //  error
    }
}
async function $efd3ba4ec2608b1d$var$myTileLoadFunctionC2(tile, src) {
    //      retry codes for tileloadfunction...
    ///                 https://neilpatel.com/blog/http-response-codes/
    //      code 404 for missing file will be catch explicitely in the tileLoadFunction
    //      the others in the following list will trigger a retry
    const retryCodes = [
        408,
        429,
        500,
        502,
        503,
        504
    ];
    const image = tile.getImage();
    let response;
    let attempts = 0;
    let valid = false;
    try {
        while(true){
            attempts++;
            response = await fetch(src);
            valid = !retryCodes.includes(response.status);
            if (response.status == 404) {
                let message = " Image tile 2 tagged as missing 404 by tileLoadFunction:  " + $efd3ba4ec2608b1d$var$listUrl2[$efd3ba4ec2608b1d$var$ISTEP_ecout2];
                console.log(message);
                $efd3ba4ec2608b1d$var$listLoaded2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = "missing";
                valid = false;
                break;
            } else if (valid) break;
            else if (attempts === 2) {
                let message = " To many tileLoadFunction attempts, tile 2 will be assigned to missing:  " + $efd3ba4ec2608b1d$var$listUrl2[$efd3ba4ec2608b1d$var$ISTEP_ecout2];
                console.log(message);
                $efd3ba4ec2608b1d$var$listLoaded2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = "missing";
                valid = false;
                break;
            }
            let message = " tile2 load retried attempts: " + attempts + " by tileLoadFunction, step: " + $efd3ba4ec2608b1d$var$listUrl2[$efd3ba4ec2608b1d$var$ISTEP_ecout2];
            console.log(message);
            await new Promise((resolve)=>setTimeout(resolve, attempts * 250));
        }
        if (valid) {
            const blob = await response.blob();
            const imageUrl = URL.createObjectURL(blob);
            image.addEventListener("load", ()=>URL.revokeObjectURL(imageUrl));
            image.src = imageUrl;
        } else tile.setState(3); // error
    } catch (error) {
        let message = " Error in the tileLoadFunction, tile2 will be assigned to missing:  " + $efd3ba4ec2608b1d$var$listUrl2[$efd3ba4ec2608b1d$var$ISTEP_ecout2];
        console.log(message);
        $efd3ba4ec2608b1d$var$listLoaded2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = "missing";
        tile.setState(3); //  error
    }
}
async function $efd3ba4ec2608b1d$var$myTileLoadFunctionCCo2(tile, src) {
    //      retry codes for tileloadfunction...
    ///                 https://neilpatel.com/blog/http-response-codes/
    //      code 404 for missing file will be catch explicitely in the tileLoadFunction
    //      the others in the following list will trigger a retry
    const retryCodes = [
        408,
        429,
        500,
        502,
        503,
        504
    ];
    const image = tile.getImage();
    let response;
    let attempts = 0;
    let valid = false;
    try {
        while(true){
            attempts++;
            response = await fetch(src);
            valid = !retryCodes.includes(response.status);
            if (response.status == 404) {
                let message = " Image tile Co2 tagged as missing 404 by tileLoadFunction:  " + $efd3ba4ec2608b1d$var$listUrlCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2];
                console.log(message);
                $efd3ba4ec2608b1d$var$listLoadedCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = "missing";
                valid = false;
                break;
            } else if (valid) break;
            else if (attempts === 2) {
                let message = " To many tileLoadFunction attempts, tile Co2 will be assigned to missing:  " + $efd3ba4ec2608b1d$var$listUrlCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2];
                console.log(message);
                $efd3ba4ec2608b1d$var$listLoadedCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = "missing";
                valid = false;
                break;
            }
            let message = " tileCo2 load retried attempts: " + attempts + " by tileLoadFunction, step: " + $efd3ba4ec2608b1d$var$listUrlCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2];
            console.log(message);
            await new Promise((resolve)=>setTimeout(resolve, attempts * 250));
        }
        if (valid) {
            const blob = await response.blob();
            const imageUrl = URL.createObjectURL(blob);
            image.addEventListener("load", ()=>URL.revokeObjectURL(imageUrl));
            image.src = imageUrl;
        } else tile.setState(3); // error
    } catch (error) {
        let message = " Error in the tileLoadFunction, tileCo2 will be assigned to missing:  " + $efd3ba4ec2608b1d$var$listUrlCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2];
        console.log(message);
        $efd3ba4ec2608b1d$var$listLoadedCo2[$efd3ba4ec2608b1d$var$ISTEP_ecout2] = "missing";
        tile.setState(3); //  error
    }
}
// ________________________________________________________________________________
// --- Création des Sources Globales
const $efd3ba4ec2608b1d$var$tileSource1 = [];
const $efd3ba4ec2608b1d$var$tileSource2 = [];
const $efd3ba4ec2608b1d$var$tileSourceCo1 = [];
const $efd3ba4ec2608b1d$var$tileSourceCo2 = [];
var $efd3ba4ec2608b1d$var$SourcesAreCreated1 = false;
var $efd3ba4ec2608b1d$var$SourcesAreCreated2 = false;
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$resetSource(urlCo_, url_, istep, couche, i_couche) {
    let attribution = $efd3ba4ec2608b1d$var$AttributionMeteo1;
    if (i_couche == "2") attribution = $efd3ba4ec2608b1d$var$AttributionMeteo2;
    var verbose_ = true;
    var resolutions;
    var tileNX = $efd3ba4ec2608b1d$var$ModToDimX.get(couche.modeleZoom);
    var tileNY = $efd3ba4ec2608b1d$var$ModToDimY.get(couche.modeleZoom);
    var extent_ = couche.getExtent();
    var proj_ = couche.getProjection();
    var returnLoading = false;
    var index = istep % $efd3ba4ec2608b1d$var$NoOfLayers;
    var indice = 0;
    var message = "";
    var urlTuile;
    //     +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    //-------------------------------------------------------------------------------------/
    if (verbose_) {
        console.log("++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
        console.log(" Debut resetSource ... tiles for layer no: ", i_couche);
        console.log(" extent: ", extent_);
        console.log(" projection: ", proj_);
        console.log(" istep: ", istep, "  index: ", index, "  NoOfLayers: ", $efd3ba4ec2608b1d$var$NoOfLayers);
        console.log("----------------------------------------------------------------------");
    }
    if (i_couche == "1") {
        $efd3ba4ec2608b1d$var$ISTEP_ecout1 = istep;
        message = "resetSource   Url : " + url_;
        console.log(message);
        resolutions = $efd3ba4ec2608b1d$var$Resolutions1;
        urlTuile = url_ + "/{z}/{x}/{y}.png";
        if (verbose_) {
            console.log(" couche 1 ");
            console.log(" dimX: ", tileNX);
            console.log(" dimY: ", tileNY);
            console.log(" Resolutions: ", resolutions);
            console.log(" couche 1 ");
        }
        if ($efd3ba4ec2608b1d$var$tileSource1[index] != null) $efd3ba4ec2608b1d$var$unsetEcouteursSource($efd3ba4ec2608b1d$var$tileSource1[index], i_couche, "mainLayer");
        $efd3ba4ec2608b1d$var$tileSource1[index] = new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
            url: urlTuile,
            crossOrigin: "anonymous",
            projection: proj_,
            tileGrid: new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)({
                extent: extent_,
                resolutions: resolutions,
                tileSize: [
                    tileNX,
                    tileNY
                ]
            }),
            zDirection: 1,
            transition: 0,
            attributions: attribution
        });
        $efd3ba4ec2608b1d$var$setEcouteursSource($efd3ba4ec2608b1d$var$tileSource1[index], i_couche, "mainLayer");
        $efd3ba4ec2608b1d$var$tileSource1[index].setTileLoadFunction($efd3ba4ec2608b1d$var$myTileLoadFunctionC1);
        if (verbose_) {
            message = "resetSource   Url : " + url_;
            console.log(message);
            message = "resetSource  tileload Requested, for layer no: " + i_couche.toString() + " step:" + istep;
        }
        if ($efd3ba4ec2608b1d$var$listLoaded1[istep] == "non" || $efd3ba4ec2608b1d$var$listLoaded1[istep] == "lazyLoading") {
            if (verbose_) console.log(message);
            //              Ici tous les pas de temps dont le  modulo vaut la valeur index seront mis a non
            //              l image corrspondant a l<index sera en mode loading                
            for(indice = index; indice <= $efd3ba4ec2608b1d$var$ISTEP_max; indice = indice + $efd3ba4ec2608b1d$var$NoOfLayers){
                $efd3ba4ec2608b1d$var$listLoaded1[indice] = "non";
                $efd3ba4ec2608b1d$var$listNuLoadStart1[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadEnd1[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadErr1[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuWait1[indice] = 0;
            }
            $efd3ba4ec2608b1d$var$listLoaded1[istep] = "loading";
            returnLoading = true;
            $efd3ba4ec2608b1d$var$tileLayers1[index].setSource($efd3ba4ec2608b1d$var$tileSource1[index]);
        }
        $efd3ba4ec2608b1d$var$tileLayers1[index].setOpacity(0.0);
        message = "resetSource   Url : " + urlCo_;
        console.log(message);
        resolutions = $efd3ba4ec2608b1d$var$ResolutionsCo1;
        urlTuile = urlCo_ + "/{z}/{x}/{y}.png";
        if ($efd3ba4ec2608b1d$var$tileSourceCo1[index] != null) $efd3ba4ec2608b1d$var$unsetEcouteursSource($efd3ba4ec2608b1d$var$tileSourceCo1[index], i_couche, "coLayer");
        $efd3ba4ec2608b1d$var$tileSourceCo1[index] = new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
            url: urlTuile,
            crossOrigin: "anonymous",
            projection: proj_,
            tileGrid: new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)({
                extent: extent_,
                resolutions: resolutions,
                tileSize: [
                    tileNX,
                    tileNY
                ]
            }),
            zDirection: 1,
            transition: 0,
            attributions: attribution
        });
        $efd3ba4ec2608b1d$var$setEcouteursSource($efd3ba4ec2608b1d$var$tileSourceCo1[index], i_couche, "coLayer");
        $efd3ba4ec2608b1d$var$tileSourceCo1[index].setTileLoadFunction($efd3ba4ec2608b1d$var$myTileLoadFunctionCCo1);
        if ($efd3ba4ec2608b1d$var$listLoadedCo1[istep] == "non" || $efd3ba4ec2608b1d$var$listLoadedCo1[istep] == "lazyLoading") {
            //                  Ici tous les pas de temps dont le  modulo vaut la valeur index seront mis a non
            //                  l image corrspondant a l<index sera en mode loading                
            for(indice = index; indice <= $efd3ba4ec2608b1d$var$ISTEP_max; indice = indice + $efd3ba4ec2608b1d$var$NoOfLayers){
                $efd3ba4ec2608b1d$var$listLoadedCo1[indice] = "non";
                $efd3ba4ec2608b1d$var$listNuLoadStartCo1[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadEndCo1[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadErrCo1[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuWaitCo1[indice] = 0;
            }
            $efd3ba4ec2608b1d$var$listLoadedCo1[istep] = "loading";
            returnLoading = true;
            $efd3ba4ec2608b1d$var$tileLayersCo1[index].setSource($efd3ba4ec2608b1d$var$tileSourceCo1[index]);
        }
        $efd3ba4ec2608b1d$var$tileLayersCo1[index].setOpacity(0.0);
        $efd3ba4ec2608b1d$var$SourcesAreCreated1 = true;
    }
    if (i_couche == "2" && !$efd3ba4ec2608b1d$var$Couche2Void) {
        $efd3ba4ec2608b1d$var$ISTEP_ecout2 = istep;
        message = "resetSource   Url : " + url_;
        console.log(message);
        resolutions = $efd3ba4ec2608b1d$var$Resolutions2;
        urlTuile = url_ + "/{z}/{x}/{y}.png";
        if (verbose_) {
            console.log(" 2 ");
            console.log(" dimX: ", tileNX);
            console.log(" dimY: ", tileNY);
            console.log(" Resolutions: ", resolutions);
            console.log(" 2 ");
        }
        if ($efd3ba4ec2608b1d$var$tileSource2[index] != null) $efd3ba4ec2608b1d$var$unsetEcouteursSource($efd3ba4ec2608b1d$var$tileSource2[index], i_couche, "mainLayer");
        $efd3ba4ec2608b1d$var$tileSource2[index] = new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
            url: urlTuile,
            crossOrigin: "anonymous",
            projection: proj_,
            tileGrid: new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)({
                extent: extent_,
                resolutions: resolutions,
                tileSize: [
                    tileNX,
                    tileNY
                ]
            }),
            zDirection: 1,
            transition: 0,
            attributions: attribution
        });
        $efd3ba4ec2608b1d$var$setEcouteursSource($efd3ba4ec2608b1d$var$tileSource2[index], i_couche, "mainLayer");
        $efd3ba4ec2608b1d$var$tileSource2[index].setTileLoadFunction($efd3ba4ec2608b1d$var$myTileLoadFunctionC2);
        if (verbose_) {
            message = "resetSource   Url : " + url_;
            console.log(message);
            message = "resetSource  tileload Requested, for layer no: " + i_couche.toString() + " step:" + istep;
        }
        if ($efd3ba4ec2608b1d$var$listLoaded2[istep] == "non" || $efd3ba4ec2608b1d$var$listLoaded2[istep] == "lazyLoading") {
            for(indice = index; indice <= $efd3ba4ec2608b1d$var$ISTEP_max; indice = indice + $efd3ba4ec2608b1d$var$NoOfLayers){
                $efd3ba4ec2608b1d$var$listLoaded2[indice] = "non";
                $efd3ba4ec2608b1d$var$listNuLoadStart2[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadEnd2[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadErr2[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuWait2[indice] = 0;
            }
            $efd3ba4ec2608b1d$var$listLoaded2[istep] = "loading";
            returnLoading = true;
            $efd3ba4ec2608b1d$var$tileLayers2[index].setSource($efd3ba4ec2608b1d$var$tileSource2[index]);
        }
        $efd3ba4ec2608b1d$var$tileLayers2[index].setOpacity(0.0);
        message = "resetSource   Url : " + urlCo_;
        console.log(message);
        resolutions = $efd3ba4ec2608b1d$var$ResolutionsCo2;
        urlTuile = urlCo_ + "/{z}/{x}/{y}.png";
        if ($efd3ba4ec2608b1d$var$tileSourceCo2[index] != null) $efd3ba4ec2608b1d$var$unsetEcouteursSource($efd3ba4ec2608b1d$var$tileSourceCo2[index], i_couche, "coLayer");
        $efd3ba4ec2608b1d$var$tileSourceCo2[index] = new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
            url: urlTuile,
            crossOrigin: "anonymous",
            projection: proj_,
            tileGrid: new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)({
                extent: extent_,
                resolutions: resolutions,
                tileSize: [
                    tileNX,
                    tileNY
                ]
            }),
            zDirection: 1,
            transition: 0,
            attributions: attribution
        });
        $efd3ba4ec2608b1d$var$setEcouteursSource($efd3ba4ec2608b1d$var$tileSourceCo2[index], i_couche, "coLayer");
        $efd3ba4ec2608b1d$var$tileSourceCo2[index].setTileLoadFunction($efd3ba4ec2608b1d$var$myTileLoadFunctionCCo2);
        if ($efd3ba4ec2608b1d$var$listLoadedCo2[istep] == "non" || $efd3ba4ec2608b1d$var$listLoadedCo2[istep] == "lazyLoading") {
            for(indice = index; indice <= $efd3ba4ec2608b1d$var$ISTEP_max; indice = indice + $efd3ba4ec2608b1d$var$NoOfLayers){
                $efd3ba4ec2608b1d$var$listLoadedCo2[indice] = "non";
                $efd3ba4ec2608b1d$var$listNuLoadStartCo2[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadEndCo2[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuLoadErrCo2[indice] = 0;
                $efd3ba4ec2608b1d$var$listNuWaitCo2[indice] = 0;
            }
            $efd3ba4ec2608b1d$var$listLoadedCo2[istep] = "loading";
            returnLoading = true;
            $efd3ba4ec2608b1d$var$tileLayersCo2[index].setSource($efd3ba4ec2608b1d$var$tileSourceCo2[index]);
        }
        $efd3ba4ec2608b1d$var$tileLayersCo2[index].setOpacity(0.0);
        $efd3ba4ec2608b1d$var$SourcesAreCreated2 = true;
    }
    return returnLoading;
}
//  --------------------------------------------------------------------------
//   Legends settings et preparation 
//   ------------------------------------------------------------------------
var $efd3ba4ec2608b1d$var$Lgnd1Url = " ";
var $efd3ba4ec2608b1d$var$Lgnd2Url = " ";
var $efd3ba4ec2608b1d$var$Lgnd1Large = true;
var $efd3ba4ec2608b1d$var$Lgnd2Large = true;
const $efd3ba4ec2608b1d$var$lgnd1Select = document.getElementById("lgnd1Button");
const $efd3ba4ec2608b1d$var$lgnd2Select = document.getElementById("lgnd2Button");
const $efd3ba4ec2608b1d$var$lgnd1Img = document.getElementById("lgnd1Image");
const $efd3ba4ec2608b1d$var$lgnd2Img = document.getElementById("lgnd2Image");
$efd3ba4ec2608b1d$var$lgnd1Img.onload = function() {
    $efd3ba4ec2608b1d$var$showLgnd(1);
    $efd3ba4ec2608b1d$var$showLgnd(1);
};
$efd3ba4ec2608b1d$var$lgnd2Img.onload = function() {
    $efd3ba4ec2608b1d$var$showLgnd(2);
    $efd3ba4ec2608b1d$var$showLgnd(2);
};
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$showLgnd(lgndNumber) {
    var lgndId = "lgnd1Image";
    var lgndIdOther = "lgnd2Image";
    if (lgndNumber == 2) {
        lgndId = "lgnd2Image";
        lgndIdOther = "lgnd1Image";
    }
    const x = document.getElementById(lgndId);
    const xo = document.getElementById(lgndIdOther);
    const frame = document.getElementById("panel");
    const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    var gauche = true;
    var haut = true;
    var distH, distV, milieu;
    ////  findout in which quadrant the legend is prior to modification
    // for positionning at the end of the resizing process
    ////  want to ensure the collapsing-expanding is toward-from de edges - corners
    distH = parseInt(frame.style.left.replace("px", ""));
    milieu = (viewwidth - (x.width + xo.width)) / 2;
    if (distH > milieu) gauche = false;
    distV = parseInt(frame.style.top.replace("px", ""));
    milieu = (viewheight - (x.height + xo.height)) / 2;
    if (distV > milieu) haut = false;
    //    store the previous sizes for later use before resizing    
    var deltaX = x.width;
    var deltaY = x.height;
    var fact = Math.min(Math.max(viewwidth / 1000., 0.6), 1);
    if ($efd3ba4ec2608b1d$var$Lgnd1Large && lgndNumber == 1) {
        $efd3ba4ec2608b1d$var$Lgnd1Large = false;
        x.width = x.naturalWidth / 10;
        x.height = x.naturalHeight / 10;
    } else if (!$efd3ba4ec2608b1d$var$Lgnd1Large && lgndNumber == 1) {
        $efd3ba4ec2608b1d$var$Lgnd1Large = true;
        x.width = parseInt(x.naturalWidth * fact);
        x.height = parseInt(x.naturalHeight * fact);
    } else if ($efd3ba4ec2608b1d$var$Lgnd2Large && lgndNumber == 2) {
        $efd3ba4ec2608b1d$var$Lgnd2Large = false;
        x.width = x.naturalWidth / 10;
        x.height = x.naturalHeight / 10;
    } else if (!$efd3ba4ec2608b1d$var$Lgnd2Large && lgndNumber == 2) {
        $efd3ba4ec2608b1d$var$Lgnd2Large = true;
        x.width = parseInt(x.naturalWidth * fact);
        x.height = parseInt(x.naturalHeight * fact);
    }
    //  the resize is made but we need to manage the position of the legend panel
    //  the default is to collaspe towards the top-left and expand towards the lower right
    //  We want to have collapsing toward the nearest corner and expanding inversely
    //  we need to take into account the size and position of the other legend 
    // if the other legend has higher height than the current 
    // the other legend is dertermining the vertical position 
    if (xo.height > x.height) {
        // If other legend was not higher then this is a change
        // previous height is stored in deltaY 
        if (xo.height < deltaY) deltaY = xo.height - deltaY;
        else deltaY = 0;
    } else // In this case the current legend is determinant
    // If other legend was higher then this is a change
    if (xo.height > deltaY) deltaY = x.height - xo.height;
    else //  In this case the cyrrent is the determinant all the way
    deltaY = x.height - deltaY;
    deltaX = x.width - deltaX;
    if (!gauche) {
        distH = distH - deltaX;
        frame.style.left = distH + "px";
    //    console.log("distH et deltax" + distH + " " + deltaX) ;
    }
    if (!haut) {
        distV = distV - deltaY;
        frame.style.top = distV + "px";
    //    console.log("distV et deltaY" + distV + " " + deltaY) ;
    }
}
// ----------------------------------------------------------------------------
// Handle change event.
//
$efd3ba4ec2608b1d$var$lgnd1Select.onchange = function() {
    $efd3ba4ec2608b1d$var$showLgnd(1);
};
$efd3ba4ec2608b1d$var$lgnd2Select.onchange = function() {
    $efd3ba4ec2608b1d$var$showLgnd(2);
};
$("#lgnd1Button").click(function() {
    console.log("click lgnd1 button");
    $efd3ba4ec2608b1d$var$showLgnd(1);
});
$("#lgnd2Button").click(function() {
    console.log("click lgnd2 button");
    $efd3ba4ec2608b1d$var$showLgnd(2);
});
// Make the legend DIV container a draggable:
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("lgndMButton"), document.getElementById("panel"), "legende");
// Make some other feature draggable:
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveAfficheInfo"), document.getElementById("afficheInfo"), "NIL");
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveAfficheInit"), document.getElementById("afficheInit"), "NIL");
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveChoixDuoA"), document.getElementById("choixDuoA"), "NIL");
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveChoixDuoB"), document.getElementById("choixDuoB"), "NIL");
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveChoixDuoC"), document.getElementById("choixDuoC"), "NIL");
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveChoixDuoD"), document.getElementById("choixDuoD"), "NIL");
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveChoixDuoN"), document.getElementById("choixDuoN"), "NIL");
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveBtnGroup"), document.getElementById("btn-group"), "btnGroup");
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveAfficheHor"), document.getElementById("divAfficheHor"), "afficheHor");
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveAfficheHor1"), document.getElementById("divAfficheHor1"), "afficheHor1");
$efd3ba4ec2608b1d$var$dragElement(document.getElementById("moveAfficheHor2"), document.getElementById("divAfficheHor2"), "afficheHor2");
// ________________________________________________________________________________
// Handle change event.
//
function $efd3ba4ec2608b1d$var$RefreshLgnd(no) {
    var mapId = $efd3ba4ec2608b1d$var$Couche1.getMapId();
    if (no == 1) {
        // if ( !Couche1CoVoid ) { mapId = Couche1.getMapIdCo + " " + mapId; }
        $efd3ba4ec2608b1d$var$Lgnd1Url = $efd3ba4ec2608b1d$var$CreerUrlImageLeg($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche1.getModele(), $efd3ba4ec2608b1d$var$Couche1.getZoomId(), mapId, $efd3ba4ec2608b1d$var$Couche1.getHourOId());
        $efd3ba4ec2608b1d$var$lgnd1Img.src = $efd3ba4ec2608b1d$var$Lgnd1Url;
    } else if (no == 2) {
        if ($efd3ba4ec2608b1d$var$Couche2Void) $efd3ba4ec2608b1d$var$Lgnd2Url = "../missing.png";
        else {
            mapId = $efd3ba4ec2608b1d$var$Couche2.getMapId();
            // if ( !Couche2CoVoid ) { mapId = Couche2.getMapIdCo + " " + mapId; }
            $efd3ba4ec2608b1d$var$Lgnd2Url = $efd3ba4ec2608b1d$var$CreerUrlImageLeg($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche2.getModele(), $efd3ba4ec2608b1d$var$Couche2.getZoomId(), mapId, $efd3ba4ec2608b1d$var$Couche2.getHourOId());
            $efd3ba4ec2608b1d$var$lgnd2Img.src = $efd3ba4ec2608b1d$var$Lgnd2Url;
        }
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$dragElement(elmnt_anchor, elmnt2Move, initialPosition) {
    var posX1 = 0, posY1 = 0, posX2 = 0, posY2 = 0;
    var message = " ";
    if (initialPosition == "afficheHor1") {
        console.log(" add event listener mousedown and touchstart = dragMouseDown1 ");
        elmnt_anchor.addEventListener("mousedown", dragMouseDown1);
        elmnt_anchor.addEventListener("touchstart", dragMouseDown1);
    } else if (initialPosition == "afficheHor2") {
        console.log(" add event listener mousedown and touchstart = dragMouseDown2 ");
        elmnt_anchor.addEventListener("mousedown", dragMouseDown2);
        elmnt_anchor.addEventListener("touchstart", dragMouseDown2);
    } else {
        console.log(" add event listener mousedown and touchstart = dragMouseDown ");
        elmnt_anchor.addEventListener("mousedown", dragMouseDown);
        elmnt_anchor.addEventListener("touchstart", dragMouseDown);
    }
    //-----------------------
    function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        posX1 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
        posY1 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;
        document.addEventListener("mouseup", closeDragElement);
        elmnt_anchor.addEventListener("touchend", closeDragElement);
        // call a function whenever the cursor moves:
        document.addEventListener("mousemove", elementDrag);
        elmnt_anchor.addEventListener("touchmove", elementDrag);
    }
    //-----------------------
    function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        posX2 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
        posY2 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;
        var deltaX = posX2 - posX1;
        var deltaY = posY2 - posY1;
        const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const limitEnBas = viewheight - elmnt2Move.offsetHeight;
        const limitADroite = viewwidth - elmnt2Move.offsetWidth - 30;
        // set the element's new position:
        elmnt2Move.style.top = Math.max(Math.min(elmnt2Move.offsetTop + deltaY, limitEnBas), 100) + "px";
        elmnt2Move.style.left = Math.max(Math.min(elmnt2Move.offsetLeft + deltaX, limitADroite), 10) + "px";
        //  Storing current positions into latest position for next iteration
        posX1 = posX2;
        posY1 = posY2;
    }
    //-----------------------
    function closeDragElement() {
        // stop moving when mouse button is released:
        document.removeEventListener("mouseup", closeDragElement);
        elmnt_anchor.removeEventListener("touchend", closeDragElement);
        document.removeEventListener("mousemove", elementDrag);
        elmnt_anchor.removeEventListener("touchmove", elementDrag);
    }
    //-----------------------
    function dragMouseDown1(e) {
        e = e || window.event;
        e.preventDefault();
        posX1 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
        posY1 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;
        document.addEventListener("mouseup", closeDragElement1);
        elmnt_anchor.addEventListener("touchend", closeDragElement1);
        // call a function whenever the cursor moves:
        document.addEventListener("mousemove", elementDrag1);
        elmnt_anchor.addEventListener("touchmove", elementDrag1);
    }
    //-----------------------
    //-----------------------
    function elementDrag1(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        posX2 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
        posY2 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;
        var deltaX = posX2 - posX1;
        var deltaY = posY2 - posY1;
        const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const limitEnBas = viewheight - elmnt2Move.offsetHeight;
        const limitADroite = viewwidth * 0.48 - elmnt2Move.offsetWidth;
        // set the element's new position:
        elmnt2Move.style.top = Math.max(Math.min(elmnt2Move.offsetTop + deltaY, limitEnBas), 100) + "px";
        elmnt2Move.style.left = Math.max(Math.min(elmnt2Move.offsetLeft + deltaX, limitADroite), 10) + "px";
        //  Storing current positions into latest position for next iteration
        posX1 = posX2;
        posY1 = posY2;
    }
    //-----------------------
    function closeDragElement1() {
        // stop moving when mouse button is released:
        document.removeEventListener("mouseup", closeDragElement1);
        elmnt_anchor.removeEventListener("touchend", closeDragElement1);
        document.removeEventListener("mousemove", elementDrag1);
        elmnt_anchor.removeEventListener("touchmove", elementDrag1);
    }
    //-----------------------
    function dragMouseDown2(e) {
        e = e || window.event;
        e.preventDefault();
        posX1 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
        posY1 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;
        document.addEventListener("mouseup", closeDragElement2);
        elmnt_anchor.addEventListener("touchend", closeDragElement2);
        // call a function whenever the cursor moves:
        document.addEventListener("mousemove", elementDrag2);
        elmnt_anchor.addEventListener("touchmove", elementDrag2);
    }
    //-----------------------
    function elementDrag2(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        posX2 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
        posY2 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;
        var deltaX = posX2 - posX1;
        var deltaY = posY2 - posY1;
        const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const limitEnBas = viewheight - elmnt2Move.offsetHeight;
        const limitADroite = viewwidth * 0.48 - elmnt2Move.offsetWidth;
        // set the element's new position:
        elmnt2Move.style.top = Math.max(Math.min(elmnt2Move.offsetTop + deltaY, limitEnBas), 10) + "px";
        elmnt2Move.style.left = Math.max(Math.min(elmnt2Move.offsetLeft + deltaX, limitADroite), 10) + "px";
        //  Storing current positions into latest position for next iteration
        posX1 = posX2;
        posY1 = posY2;
    }
    //-----------------------
    function closeDragElement2() {
        // stop moving when mouse button is released:
        document.removeEventListener("mouseup", closeDragElement2);
        elmnt_anchor.removeEventListener("touchend", closeDragElement2);
        document.removeEventListener("mousemove", elementDrag2);
        elmnt_anchor.removeEventListener("touchmove", elementDrag2);
    }
    //-----------------------
    // set the element's  Initial position as requested by the 3 rd parameter 
    //
    var viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    var viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    var limitEnBas = Math.max(0, viewheight - elmnt2Move.offsetHeight);
    var limitADroite = Math.max(0, viewwidth - elmnt2Move.offsetWidth);
    if (initialPosition == "legende") {
        var basDeLegende = limitEnBas - 350;
        elmnt2Move.style.top = Math.max(basDeLegende, 150) + "px";
        elmnt2Move.style.left = Math.min(limitADroite, 30) + "px";
    } else if (initialPosition == "btnGroup") {
        var basDeBtnGroup = limitEnBas - 100;
        elmnt2Move.style.top = Math.max(basDeBtnGroup, 100) + "px";
        elmnt2Move.style.left = Math.min(limitADroite, 400) + "px";
    } else if (initialPosition == "afficheHor") {
        limitADroite = Math.max(0, viewwidth - elmnt2Move.offsetWidth);
        elmnt2Move.style.top = Math.min(limitEnBas, 100) + "px";
        elmnt2Move.style.left = Math.min(limitADroite, 50) + "px";
    } else if (initialPosition == "afficheHor1") {
        limitADroite = Math.max(0, viewwidth * 0.45 - elmnt2Move.offsetWidth);
        elmnt2Move.style.top = Math.min(limitEnBas, 100) + "px";
        elmnt2Move.style.left = Math.min(limitADroite, 50) + "px";
    } else if (initialPosition == "afficheHor2") {
        limitADroite = Math.max(0, viewwidth * 0.45 - elmnt2Move.offsetWidth);
        elmnt2Move.style.top = Math.min(limitEnBas, 0) + "px";
        elmnt2Move.style.left = Math.min(limitADroite, 50) + "px";
    }
}
// _________________________________________________________________________________
//
//
function $efd3ba4ec2608b1d$var$nombrePassesHistoriques(model) {
    var nb_histo = 0;
    if (model == "GDPS") {
        nb_histo = 20; // nombre de temps de départ en archive
        if ($efd3ba4ec2608b1d$var$ArchivesVerif) nb_histo = 20;
    } else if (model == "GDPSIA") {
        nb_histo = 20; // nombre de temps de départ en archive
        if ($efd3ba4ec2608b1d$var$ArchivesVerif) nb_histo = 20;
    } else if (model == "GDPSE") nb_histo = 20; // nombre de temps de départ en archive
    else if (model == "GDPSIAE") {
        nb_histo = 20; // nombre de temps de départ en archive
        if ($efd3ba4ec2608b1d$var$ArchivesVerif) nb_histo = 20;
    } else if (model == "GFS") nb_histo = 20; // nombre de temps de départ en archive
    else if (model == "AIFS") nb_histo = 20; // nombre de temps de départ en archive
    else if (model == "AIFSE") nb_histo = 20; // nombre de temps de départ en archive
    else if (model == "ECMWF") nb_histo = 20; // nombre de temps de départ en archive
    else if (model == "ECMWFE") nb_histo = 20; // nombre de temps de départ en archive
    else if (model == "ECMWF3") {
        nb_histo = 9; // nombre de temps de départ en archive
        if ($efd3ba4ec2608b1d$var$ArchivesVerif) nb_histo = 20;
    } else if (model == "RDPS" || model == "RAQDPS") {
        nb_histo = 9; // nombre de temps de départ en archive
        if ($efd3ba4ec2608b1d$var$ArchivesVerif) nb_histo = 56;
    } else if (model == "HRDPS E" || model == "HRDPS S" || model == "HRDPS S0" || model == "HRDPS S1" || model == "HRDPS S2" || model == "HRDPS S3" || model == "CIOPS") {
        nb_histo = 9; // nombre de temps de départ en archive
        if ($efd3ba4ec2608b1d$var$ArchivesVerif) nb_histo = 32;
    } else if (model == "HRDPS W") {
        nb_histo = 9; // nombre de temps de départ en archive
        if ($efd3ba4ec2608b1d$var$ArchivesVerif) nb_histo = 32;
    } else if (model == "WCPS") nb_histo = 8; // nombre de temps de départ en archive
    else if (model == "RDWPS") nb_histo = 8; // nombre de temps de départ en archive
    else if (model == "DIAGW") nb_histo = 8; // nombre de temps de départ en archive
    else if (model == "SHOP") {
        nb_histo = 4; // nombre de temps de départ en archive
        if ($efd3ba4ec2608b1d$var$ArchivesVerif) nb_histo = 4;
    } else if (model == "GOESR GLM" || model == "GOESR CO" || model == "GOESR_PLUS") nb_histo = 288; // nombre de temps de départ en archive
    else if (model == "FOUDRE CO") nb_histo = 288; // nombre de temps de départ en archive
    else if (model == "RADART CO" || model == "RADAR CO") nb_histo = 240; // nombre de temps de départ en archive
    return nb_histo;
}
// _________________________________________________________________________________
//
//
function $efd3ba4ec2608b1d$var$nombreMinutesEntrePasses(model) {
    var minutes_ecart_t0 = 0;
    if (model == "GDPS") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "GDPSIA") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "GDPSE") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "GDPSIAE") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "GFS") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "AIFS") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "AIFSE") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "ECMWF") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "ECMWFE") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "ECMWF3") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "RDPS") minutes_ecart_t0 = 360; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "RAQDPS") minutes_ecart_t0 = 720; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "HRDPS E" || model == "HRDPS S" || model == "HRDPS S0" || model == "HRDPS S1" || model == "HRDPS S2" || model == "HRDPS S3" || model == "CIOPS") minutes_ecart_t0 = 360; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "HRDPS W") minutes_ecart_t0 = 360; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "WCPS") minutes_ecart_t0 = 360; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "RDWPS") minutes_ecart_t0 = 360; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "DIAGW") minutes_ecart_t0 = 360; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "SHOP") minutes_ecart_t0 = 360; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "GOESR GLM" || model == "GOESR CO" || model == "FOUDRE CO" || model == "GOESR_PLUS") minutes_ecart_t0 = 5; //  écart en minutes_ecart_t0 entre les temps de départ t0
    else if (model == "RADART CO" || model == "RADAR CO") minutes_ecart_t0 = 6; //  écart en minutes_ecart_t0 entre les temps de départ t0
    return minutes_ecart_t0;
}
//
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbHeures(houroid_, nb_heure, plus) {
    let extra_string = ":00:00";
    if (houroid_.length == 12) extra_string = houroid_.substr(10, 2) + ":00";
    var string = houroid_.substr(4, 2) + "/" + houroid_.substr(6, 2) + "/" + houroid_.substring(0, 4) + " " + houroid_.substr(8, 2) + extra_string;
    var d1 = new Date(string);
    if (!plus) nb_heure = -nb_heure;
    if (houroid_.length == 12) d1.setHours(d1.getHours() + nb_heure);
    else {
        let nb_minutes = Math.round(nb_heure * 60);
        d1.setMinutes(d1.getMinutes() + nb_minutes);
    }
    let year = d1.getFullYear();
    let month = d1.getMonth() + 1;
    let day = d1.getDate();
    let hour = d1.getHours();
    let syear = year.toString();
    let smonth = month.toString();
    if (smonth.length < 2) smonth = "0" + smonth;
    let sday = day.toString();
    if (sday.length < 2) sday = "0" + sday;
    let shour = hour.toString();
    if (shour.length < 2) shour = "0" + shour;
    if (shour.length < 2) shour = "0" + shour;
    let string_ = syear + smonth + sday + shour;
    if (houroid_.length == 12) {
        let minutes = d1.getminutes();
        let sminutes = minutes.toString();
        if (sminutes.length < 2) sminutes = "0" + sminutes;
        string_ = string_ + sminutes;
    }
    return string_;
}
//var nb_heure_ms = nb_heure * 36e5;
//
//var string= houroid_.substr(4,2) +  "/" + houroid_.substr(6,2) + "/" + houroid_.substring(0,4) + " " + houroid_.substr(8,2) + ":00:00";
//var d1 = new Date(string);     
//var delta_ms = 0;
//
//if (plus) {
//delta_ms = d1.getTime() + nb_heure_ms; 
//} else {
//delta_ms = d1.getTime() - nb_heure_ms;
//}
//
//var d2 = new Date( delta_ms );
//
//var year = d2.getFullYear();
//var month = d2.getMonth() + 1 ;
//var day = d2.getDate();
//var hour = d2.getHours();
//
//var syear = year.toString();
//var smonth = month.toString();
//if ( smonth.length < 2 ) { smonth = "0"+smonth } 
//
//var sday = day.toString();
//if ( sday.length < 2 ) { sday = "0"+sday }
//var shour = hour.toString();
//if ( shour.length < 2 ) { shour = "0"+shour }
//if ( shour.length < 2 ) { shour = "0"+shour }
//
//var string_ = syear + smonth + sday + shour;
//
//return string_
//}
//
// ________________________________________________________________________________
//
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes(houroid_, nbMinutes, plus) {
    let string = "";
    if (!plus) nbMinutes = -nbMinutes;
    if (houroid_.length == 12) string = houroid_.substr(4, 2) + "/" + houroid_.substr(6, 2) + "/" + houroid_.substring(0, 4) + " " + houroid_.substr(8, 2) + ":" + houroid_.substr(10, 2) + ":00";
    else string = houroid_.substr(4, 2) + "/" + houroid_.substr(6, 2) + "/" + houroid_.substring(0, 4) + " " + houroid_.substr(8, 2) + ":00:00";
    let d1 = new Date(string);
    d1.setMinutes(d1.getMinutes() + nbMinutes);
    let syear = d1.getFullYear().toString();
    let smonth = (d1.getMonth() + 1).toString();
    let sday = d1.getDate().toString();
    let shour = d1.getHours().toString();
    let sminutes = d1.getMinutes().toString();
    if (smonth.length < 2) smonth = "0" + smonth;
    if (sday.length < 2) sday = "0" + sday;
    if (shour.length < 2) shour = "0" + shour;
    string = syear + smonth + sday + shour;
    if (houroid_.length == 12) {
        if (sminutes.length < 2) sminutes = "0" + sminutes;
        string = string + sminutes;
    }
    return string;
}
//
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$GuessHourOId(model, fact_nb_minutes_a_reculer) {
    // On retourne le mielleur guess pour le Houriod actuel pour le model et le fact_nb_heure_a_reculer
    // nb_heure_a_reculer est un facteur qui s'applique à l'écart entre les t0 ( heure_ecart_t0)
    // Habituellment il est égale à zéro pour le meilleur guess à l'heure courante
    // Si on cherche le houroid précédente,  alors il est égale à -1
    // Si l'on cherche le houroid précédent, le précédent il sera égale à -2,  etc
    var minutes_ecart_t0 = 0;
    var minutes_dispo_t0_plus = 0;
    minutes_ecart_t0 = $efd3ba4ec2608b1d$var$nombreMinutesEntrePasses(model);
    if (model == "GDPS") minutes_dispo_t0_plus = -300; // délai minimum de disponibilité après t0
    else if (model == "GDPSIA") minutes_dispo_t0_plus = -330;
    else if (model == "GDPSE") minutes_dispo_t0_plus = -300;
    else if (model == "GDPSIAE") minutes_dispo_t0_plus = -330;
    else if (model == "GFS") minutes_dispo_t0_plus = -300;
    else if (model == "AIFS") minutes_dispo_t0_plus = -420;
    else if (model == "AIFSE") minutes_dispo_t0_plus = -420;
    else if (model == "ECMWF") minutes_dispo_t0_plus = -420;
    else if (model == "ECMWFE") minutes_dispo_t0_plus = -420;
    else if (model == "ECMWF3") minutes_dispo_t0_plus = -420;
    else if (model == "RDPS") minutes_dispo_t0_plus = -180;
    else if (model == "RAQDPS") minutes_dispo_t0_plus = -280;
    else if (model == "HRDPS E" || model == "HRDPS S" || model == "HRDPS S0" || model == "HRDPS S1" || model == "HRDPS S2" || model == "HRDPS S3") minutes_dispo_t0_plus = -240;
    else if (model == "HRDPS W") minutes_dispo_t0_plus = -300;
    else if (model == "WCPS") minutes_dispo_t0_plus = -420;
    else if (model == "RDWPS") minutes_dispo_t0_plus = -180;
    else if (model == "DIAGW") minutes_dispo_t0_plus = -420;
    else if (model == "SHOP") minutes_dispo_t0_plus = -420;
    else if (model == "CIOPS") minutes_dispo_t0_plus = -360;
    else if (model == "GOESR GLM" || model == "GOESR CO" || model == "FOUDRE CO" || model == "GOESR_PLUS") minutes_dispo_t0_plus = -6;
    else if (model == "RADART CO" || model == "RADAR CO") minutes_dispo_t0_plus = -10;
    var d1 = new Date();
    var offset_UTC_ms = Math.round(d1.getTimezoneOffset() * 60000);
    var d2 = new Date(d1.getTime() + offset_UTC_ms + (minutes_dispo_t0_plus + fact_nb_minutes_a_reculer * minutes_ecart_t0) * 6e4);
    var year = d2.getFullYear();
    var syear = year.toString();
    var month = d2.getMonth() + 1;
    var smonth = month.toString();
    if (smonth.length < 2) smonth = "0" + smonth;
    var day = d2.getDate();
    var sday = day.toString();
    if (sday.length < 2) sday = "0" + sday;
    let chaine_a_retourner = syear + smonth + sday;
    let hour = d2.getHours();
    let shour = hour.toString();
    let nowcast = $efd3ba4ec2608b1d$var$isNowcast(model);
    if (nowcast) {
        if (shour.length < 2) shour = "0" + shour;
        let minutes = d2.getMinutes() - d2.getMinutes() % minutes_ecart_t0;
        let sminutes = minutes.toString();
        if (sminutes.length < 2) sminutes = "0" + sminutes;
        chaine_a_retourner = chaine_a_retourner + shour + sminutes;
    } else {
        let hours_ecart_t0 = Math.round(minutes_ecart_t0 / 60.);
        hour = hour - hour % hours_ecart_t0;
        shour = hour.toString();
        if (shour.length < 2) shour = "0" + shour;
        chaine_a_retourner = chaine_a_retourner + shour;
    }
    return chaine_a_retourner;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$soustractionHourOId(hourOId1_, hourOId2_, couches1et2) {
    let difference = 0;
    let diff = 0;
    if (couches1et2 && $efd3ba4ec2608b1d$var$Couche2.modeleZoom == "void") return diff;
    else {
        if (hourOId1_ != hourOId2_) {
            let string1 = hourOId1_.substr(4, 2) + "/" + hourOId1_.substr(6, 2) + "/" + hourOId1_.substring(0, 4) + " " + hourOId1_.substr(8, 2);
            let string2 = hourOId2_.substr(4, 2) + "/" + hourOId2_.substr(6, 2) + "/" + hourOId2_.substring(0, 4) + " " + hourOId2_.substr(8, 2);
            if (hourOId1_.length == 10) string1 = string1 + ":00:00";
            else string1 = string1 + ":" + hourOId1_.substr(10, 2) + ":00";
            if (hourOId2_.length == 10) string2 = string2 + ":00:00";
            else string2 = string2 + ":" + hourOId2_.substr(10, 2) + ":00";
            let d1 = new Date(string1);
            let d2 = new Date(string2);
            diff = d1 - d2;
            let d1_offset_UTC_m = parseInt(d1.getTimezoneOffset());
            let d2_offset_UTC_m = parseInt(d2.getTimezoneOffset());
            diff = Math.round(diff / 6e4) - (d1_offset_UTC_m - d2_offset_UTC_m);
        }
        return diff;
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$getAfficheValidDateTime(houroid_, nb_minutes) {
    let nb_ms = nb_minutes * 6e4;
    //console.log(" getAfficheValidTime,  houroid_ : " + houroid_);
    //console.log(" getAfficheValidTime,  nb_minutes : " + nb_minutes);
    let string = houroid_.substring(0, 4) + "-" + houroid_.substr(4, 2) + "-" + houroid_.substr(6, 2) + "T" + houroid_.substr(8, 2);
    //console.log(" getAfficheValidTime,  string 1 : " + string);
    //console.log(" getAfficheValidTime, houroid_.length: " + houroid_.length);
    if (houroid_.length == 10) string = string + ":00:00";
    else string = string + ":" + houroid_.substr(10, 2) + ":00";
    //console.log(" getAfficheValidTime,  string 2 : " + string);
    let d1 = new Date(string);
    let days = [
        "Dim.",
        "Lun.",
        "Mar.",
        "Mer.",
        "Jeu.",
        "Ven.",
        "Sam."
    ];
    d1.setMinutes(d1.getMinutes() + parseInt(nb_minutes));
    let offset_UTC_m = d1.getTimezoneOffset();
    d1.setMinutes(d1.getMinutes() - offset_UTC_m);
    offset_UTC_m = Math.round(offset_UTC_m / 60.);
    let offset_UTC_string = offset_UTC_m.toString();
    //console.log(" d1: " + d1);
    let d4 = d1.toLocaleDateString("en-GB");
    let d5 = d1.toLocaleTimeString("en-US", {
        hour12: false
    });
    //console.log(" d4: " + d4);
    //console.log(" d5: " + d5);
    if (d5.slice(0, 2) == 24) d5 = "00" + d5.slice(2, 5);
    d4 = d4.slice(0, 15) + " ";
    //console.log(" d4: " + d4);
    //console.log(" d5: " + d5);
    let d6 = days[d1.getDay()] + " le " + d4 + " \xe0 " + d5.slice(0, 5) + "h (UTC-" + offset_UTC_string + "h)";
    //console.log(" d6: " + d6);
    return d6;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$isNowcast(modele_) {
    var nowcast_ = false;
    if (modele_ == "GOESR GLM" || modele_ == "GOESR CO" || modele_ == "GOESR_PLUS" || modele_ == "RADART CO" || modele_ == "RADAR CO" || modele_ == "FOUDRE CO") nowcast_ = true;
    return nowcast_;
}
// -----------------------------------------------------------------------------------
//   Selector  for Prediction systems
const $efd3ba4ec2608b1d$var$ModeleZoom1Select = document.getElementById("modelezoom1");
const $efd3ba4ec2608b1d$var$ModeleZoom2Select = document.getElementById("modelezoom2");
$efd3ba4ec2608b1d$var$setMenuModeleZoom(1, $efd3ba4ec2608b1d$var$ModeleZoom1Select);
$efd3ba4ec2608b1d$var$setMenuModeleZoom(2, $efd3ba4ec2608b1d$var$ModeleZoom2Select);
// ________________________________________________________________________________
// Handle change event.
//
$efd3ba4ec2608b1d$var$ModeleZoom1Select.onchange = function() {
    $efd3ba4ec2608b1d$var$updateModeleZoomFromMenu(1);
};
$efd3ba4ec2608b1d$var$ModeleZoom2Select.onchange = function() {
    $efd3ba4ec2608b1d$var$updateModeleZoomFromMenu(2);
};
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateModeleZoomFromMenu(no_) {
    var couche_change_pas = true;
    var message = "";
    var verbose_ = true;
    $efd3ba4ec2608b1d$var$StopAnimate();
    let modele1 = $efd3ba4ec2608b1d$var$ModeleZoom1Select.options[$efd3ba4ec2608b1d$var$ModeleZoom1Select.options.selectedIndex].value;
    let modele2 = $efd3ba4ec2608b1d$var$ModeleZoom2Select.options[$efd3ba4ec2608b1d$var$ModeleZoom2Select.options.selectedIndex].value;
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    if (verbose_) {
        console.log("+++++++++++++++++++++++++++++++++++++++++++++++");
        console.log("     updateModeleZoomFromMenu                  ");
        console.log("-----------------------------------------------");
    }
    if ((nowcast1 || nowcast2) && $efd3ba4ec2608b1d$var$DprogDt) {
        alert(" Les couches Nowcasting, Radar ou satellite, ne sont pas encore disponibles en mode DprogDt");
        for(let ii = 0; ii < $efd3ba4ec2608b1d$var$ModeleZoom1Select.options.length; ii++)if ($efd3ba4ec2608b1d$var$ModeleZoom1Select.options[ii].value == $efd3ba4ec2608b1d$var$Couche1.modele) {
            $efd3ba4ec2608b1d$var$ModeleZoom1Select.options.selectedIndex = ii;
            console.log(" modele layer 1 is set back to:" + $efd3ba4ec2608b1d$var$Couche1.modele + " ii: " + ii);
        }
        for(let ii = 0; ii < $efd3ba4ec2608b1d$var$ModeleZoom2Select.options.length; ii++)if ($efd3ba4ec2608b1d$var$ModeleZoom2Select.options[ii].value == $efd3ba4ec2608b1d$var$Couche2.modele) {
            $efd3ba4ec2608b1d$var$ModeleZoom2Select.options.selectedIndex = ii;
            console.log(" modele layer 2 is set to:" + $efd3ba4ec2608b1d$var$Couche2.modele + " ii: " + ii);
        }
    } else {
        if (no_ == 1 || no_ == 0) {
            var prevModel = $efd3ba4ec2608b1d$var$Couche1.modele;
            message = "Update Model,  Couche1.modeleZoom: " + $efd3ba4ec2608b1d$var$Couche1.modeleZoom;
            $efd3ba4ec2608b1d$var$Couche1.modeleZoom = $efd3ba4ec2608b1d$var$ModeleZoom1Select.options[$efd3ba4ec2608b1d$var$ModeleZoom1Select.options.selectedIndex].value;
            $efd3ba4ec2608b1d$var$Couche1.modele = $efd3ba4ec2608b1d$var$ModToId.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
            $efd3ba4ec2608b1d$var$Couche1.zoomId = $efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
            $efd3ba4ec2608b1d$var$Couche1.extent = $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom()));
            $efd3ba4ec2608b1d$var$Couche1.projection = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom()));
            if (verbose_) {
                console.log(" modeleZoom: ", $efd3ba4ec2608b1d$var$Couche1.modeleZoom);
                console.log(" modele: ", $efd3ba4ec2608b1d$var$Couche1.modele);
                console.log(" zoomid: ", $efd3ba4ec2608b1d$var$Couche1.zoomId);
                console.log(" extent: ", $efd3ba4ec2608b1d$var$Couche1.extent);
                console.log(" projection: ", $efd3ba4ec2608b1d$var$Couche1.projection);
            }
            if ($efd3ba4ec2608b1d$var$Couche1.modele == "WCPS" && prevModel != "WCPS") {
                $efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect1.options.length - 1;
                $efd3ba4ec2608b1d$var$Opacitee1 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect1.options[$efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex].value) / 10.;
            } else if ($efd3ba4ec2608b1d$var$Couche1.modele != "WCPS" && prevModel == "WCPS") {
                $efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect1.options.length - 1;
                $efd3ba4ec2608b1d$var$Opacitee1 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect1.options[$efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex].value) / 10.;
            }
            if ($efd3ba4ec2608b1d$var$Couche1.modeleZoom == $efd3ba4ec2608b1d$var$Couche2.modeleZoom) {
                $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
                couche_change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(true, 2, $efd3ba4ec2608b1d$var$HourOId2Select);
            } else $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
            couche_change_pas = $efd3ba4ec2608b1d$var$setMenuMapIdH(1, $efd3ba4ec2608b1d$var$MapIdH1Select);
            couche_change_pas = $efd3ba4ec2608b1d$var$setMenuMapIdCo(1, $efd3ba4ec2608b1d$var$MapIdCo1Select);
            couche_change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(false, 1, $efd3ba4ec2608b1d$var$HourOId1Select);
            $efd3ba4ec2608b1d$var$setMenuValeurs(1, $efd3ba4ec2608b1d$var$ValeurSelect1);
            $efd3ba4ec2608b1d$var$AttributionMeteo1 = $efd3ba4ec2608b1d$var$SetAttribution($efd3ba4ec2608b1d$var$Couche1.modele, "1");
            if ($efd3ba4ec2608b1d$var$Couche1.modeleZoom == "ECMWF" || $efd3ba4ec2608b1d$var$Couche1.modeleZoom == "ECMWF3" || $efd3ba4ec2608b1d$var$Couche1.modeleZoom == "AIFS") $efd3ba4ec2608b1d$var$messageECMWF($efd3ba4ec2608b1d$var$Couche1.getMapIdH());
        }
        if (no_ == 2 || no_ == 0) {
            var prevModel = $efd3ba4ec2608b1d$var$Couche2.modele;
            $efd3ba4ec2608b1d$var$Couche2.modeleZoom = $efd3ba4ec2608b1d$var$ModeleZoom2Select.options[$efd3ba4ec2608b1d$var$ModeleZoom2Select.options.selectedIndex].value;
            if ($efd3ba4ec2608b1d$var$Couche2.modeleZoom == "void") {
                $efd3ba4ec2608b1d$var$Couche2Void = true;
                //setMenuInterca("storage");
                if ($efd3ba4ec2608b1d$var$L_Interca) {
                    // set to superpo,  since Interca is not allowed when second layer is off
                    $efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex = 1;
                    $efd3ba4ec2608b1d$var$updateIntercaFromMenu("Refresh");
                }
                document.getElementById("mapidh2").disabled = true;
                document.getElementById("mapidh2").style.visibility = "hidden";
                document.getElementById("mapidco2").disabled = true;
                document.getElementById("mapidco2").style.visibility = "hidden";
                document.getElementById("houroid2").disabled = true;
                document.getElementById("houroid2").style.visibility = "hidden";
                document.getElementById("valeur2").disabled = true;
                document.getElementById("valeur2").style.visibility = "hidden";
                document.getElementById("opacite2").disabled = true;
                document.getElementById("opacite2").style.visibility = "hidden";
                if ($efd3ba4ec2608b1d$var$Lgnd2Large) $efd3ba4ec2608b1d$var$showLgnd(2);
                $efd3ba4ec2608b1d$var$RefreshLgnd(2);
            } else {
                if ($efd3ba4ec2608b1d$var$Couche2Void) {
                    $efd3ba4ec2608b1d$var$Couche2Void = false;
                    document.getElementById("mapidh2").disabled = false;
                    document.getElementById("mapidh2").style.visibility = "visible";
                    document.getElementById("mapidco2").disabled = false;
                    document.getElementById("mapidco2").style.visibility = "visible";
                    document.getElementById("houroid2").disabled = false;
                    document.getElementById("houroid2").style.visibility = "visible";
                    document.getElementById("valeur2").disabled = false;
                    document.getElementById("valeur2").style.visibility = "visible";
                    document.getElementById("opacite2").disabled = false;
                    document.getElementById("opacite2").style.visibility = "visible";
                }
                $efd3ba4ec2608b1d$var$Couche2.modele = $efd3ba4ec2608b1d$var$ModToId.get($efd3ba4ec2608b1d$var$Couche2.getModeleZoom());
                $efd3ba4ec2608b1d$var$Couche2.zoomId = $efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Couche2.getModeleZoom());
                $efd3ba4ec2608b1d$var$Couche2.extent = $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Couche2.getModeleZoom()));
                $efd3ba4ec2608b1d$var$Couche2.projection = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$ModToZoom.get($efd3ba4ec2608b1d$var$Couche2.getModeleZoom()));
                if (verbose_) {
                    console.log(" modeleZoom: ", $efd3ba4ec2608b1d$var$Couche2.modeleZoom);
                    console.log(" modele: ", $efd3ba4ec2608b1d$var$Couche2.modele);
                    console.log(" zoomid: ", $efd3ba4ec2608b1d$var$Couche2.zoomId);
                    console.log(" extent: ", $efd3ba4ec2608b1d$var$Couche2.extent);
                    console.log(" projection: ", $efd3ba4ec2608b1d$var$Couche2.projection);
                }
                if ($efd3ba4ec2608b1d$var$Couche2.modele == "WCPS" && prevModel != "WCPS") {
                    $efd3ba4ec2608b1d$var$OpaciteSelect2.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect2.options.length - 1;
                    $efd3ba4ec2608b1d$var$Opacitee2 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect2.options[$efd3ba4ec2608b1d$var$OpaciteSelect2.options.selectedIndex].value) / 10.;
                } else if ($efd3ba4ec2608b1d$var$Couche2.modele != "WCPS" && prevModel == "WCPS") {
                    $efd3ba4ec2608b1d$var$OpaciteSelect2.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect2.options.length - 1;
                    $efd3ba4ec2608b1d$var$Opacitee2 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect2.options[$efd3ba4ec2608b1d$var$OpaciteSelect2.options.selectedIndex].value) / 10.;
                }
                if ($efd3ba4ec2608b1d$var$Couche1.modeleZoom == $efd3ba4ec2608b1d$var$Couche2.modeleZoom) {
                    $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
                    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(true, 1, $efd3ba4ec2608b1d$var$HourOId1Select);
                } else $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
                couche_change_pas = $efd3ba4ec2608b1d$var$setMenuMapIdH(2, $efd3ba4ec2608b1d$var$MapIdH2Select);
                couche_change_pas = $efd3ba4ec2608b1d$var$setMenuMapIdCo(2, $efd3ba4ec2608b1d$var$MapIdCo2Select);
                couche_change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(false, 2, $efd3ba4ec2608b1d$var$HourOId2Select);
                $efd3ba4ec2608b1d$var$setMenuValeurs(2, $efd3ba4ec2608b1d$var$ValeurSelect2);
                $efd3ba4ec2608b1d$var$AttributionMeteo2 = $efd3ba4ec2608b1d$var$SetAttribution($efd3ba4ec2608b1d$var$Couche2.modele, "2");
                if ($efd3ba4ec2608b1d$var$Couche2.modeleZoom == "ECMWF" || $efd3ba4ec2608b1d$var$Couche2.modeleZoom == "ECMWF3" || $efd3ba4ec2608b1d$var$Couche2.modeleZoom == "AIFS") $efd3ba4ec2608b1d$var$messageECMWF($efd3ba4ec2608b1d$var$Couche2.getMapIdH());
            }
        }
        //archives
        if ($efd3ba4ec2608b1d$var$ModAInterv.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom()) < $efd3ba4ec2608b1d$var$ModAInterv.get(prevModel)) $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
        couche_change_pas = $efd3ba4ec2608b1d$var$setMenuInterval();
        if (nowcast1 && nowcast2) {
            $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
            $efd3ba4ec2608b1d$var$Couche1.Debut = -180;
        }
        couche_change_pas = $efd3ba4ec2608b1d$var$setMenuDebut();
        if ($efd3ba4ec2608b1d$var$ModAFin.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom()) > $efd3ba4ec2608b1d$var$ModAFin.get(prevModel)) $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
        couche_change_pas = $efd3ba4ec2608b1d$var$setMenuFin();
        $efd3ba4ec2608b1d$var$setListProgTimes();
        $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
        //if ( (ViewProjSelect.value == "Syst.Prev")  &&  ( (no_ == 1) || (no_ == 0) ) )  {
        //SetVu(  Couche1.projection, ZoomToViewExtent.get( Couche1.zoomId ), false) ;
        //} 
        $efd3ba4ec2608b1d$var$updateViewProjection();
        // Ici mettre le LoadLayers de toute les couches 
        $efd3ba4ec2608b1d$var$LoadLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
        $efd3ba4ec2608b1d$var$LoadLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
        if ($efd3ba4ec2608b1d$var$ActiveLoop) setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
        else {
            if (no_ == 0) console.log(" UpdateModeleZoomFromMenu no 0  juste apres SetVu");
            else console.log(" UpdateModeleZoomFromMenu no 1 ou 2 ");
            setTimeout($efd3ba4ec2608b1d$var$Refresh, 500);
        }
        setTimeout($efd3ba4ec2608b1d$var$RefreshSpotWx, 510);
        if ($efd3ba4ec2608b1d$var$WindMaps) {
            localStorage.setItem("Model1_V", $efd3ba4ec2608b1d$var$Couche1.modeleZoom);
            localStorage.setItem("Model2_V", $efd3ba4ec2608b1d$var$Couche2.modeleZoom);
        } else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) {
            localStorage.setItem("Model1_N", $efd3ba4ec2608b1d$var$Couche1.modeleZoom);
            localStorage.setItem("Model2_N", $efd3ba4ec2608b1d$var$Couche2.modeleZoom);
        } else {
            localStorage.setItem("Model1", $efd3ba4ec2608b1d$var$Couche1.modeleZoom);
            localStorage.setItem("Model2", $efd3ba4ec2608b1d$var$Couche2.modeleZoom);
        }
    }
    if (verbose_) {
        console.log("+++++++++++++++++++++++++++++++++++++++++++++++");
        console.log(" FIN updateModeleZoomFromMenu  FIN FIN         ");
        console.log("-----------------------------------------------");
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$setMenuModeleZoom(no, modeleZoomSelect) {
    var layerModeleZoom = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    if (no == 2) layerModeleZoom = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    modeleZoomSelect.options.length = 0;
    if ($efd3ba4ec2608b1d$var$WindMaps) {
        document.getElementById("labelSystPrev").innerHTML = "syst\xe8me";
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("Air", "HRDPS S0");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("NEMO", "WCPS");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("RDWPS", "RDWPS");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("DIAGW", "DIAGW");
        if ($efd3ba4ec2608b1d$var$L_SHOP) modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("SHOP", "SHOP");
    } else {
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("RDPS", "RDPS");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("HRDPS E", "HRDPS E");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("HRSUDQC", "HRDPS S0");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("GDPS", "GDPS");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("GFS", "GFS");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("AIFS", "AIFS");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("ECMWF", "ECMWF");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("ECMWF3", "ECMWF3");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("NEMO", "WCPS");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("RDWPS", "RDWPS");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("DIAGW", "DIAGW");
        if ($efd3ba4ec2608b1d$var$L_SHOP) modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("SHOP", "SHOP");
        //  retrait RAQDPS ici
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("RAQDPS", "RAQDPS");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("GOES", "GOESR CO");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("GOES+", "GOESR_PLUS");
        ////modeleZoomSelect.options[modeleZoomSelect.options.length]  = new Option( 'GLM', 'GOESR GLM');
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("FOUDRE", "FOUDRE CO");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("RADAR", "RADAR CO");
        modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("RADART", "RADART CO");
        if ($efd3ba4ec2608b1d$var$L_GDPSE) {
            modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("GDPSE", "GDPSE");
            modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("ECMWFE", "ECMWFE");
            modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("AIFSE", "AIFSE");
        }
    }
    if (no == 2) modeleZoomSelect.options[modeleZoomSelect.options.length] = new Option("void", "void");
    var altModeleZoom = modeleZoomSelect.options[0].value;
    var changee = $efd3ba4ec2608b1d$var$resetMenuModeleZoom(no, layerModeleZoom, altModeleZoom, modeleZoomSelect);
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$resetMenuModeleZoom(no, layerModeleZoom, altModeleZoom, modeleZoomSelect) {
    /// la   fonction cherche dans le menu,  la valeur du ModeleZoom de la couche (layerModeleZoom)
    //  si elle est trouvée,  cet indice du menu sera "selected".
    // sinon, ce sera le ModeleZoom  passé sous altModeleZoom  qui sera  "selected"
    //  et dans ce cas la valeur de modeleZoom de la couche sera changé !!!
    // ------------------------------------------------------------------------------
    var trouve = false;
    var indice = 0;
    var indice2iem = 0;
    for(indice = 0; indice < modeleZoomSelect.options.length; indice++){
        if (altModeleZoom == modeleZoomSelect.options[indice].value) indice2iem = indice;
        if (layerModeleZoom == modeleZoomSelect.options[indice].value) {
            modeleZoomSelect.options.selectedIndex = indice;
            trouve = true;
        }
    }
    if (!trouve) {
        modeleZoomSelect.options.selectedIndex = indice2iem;
        var message = " Le systeme " + layerModeleZoom + "(couche " + no + ") change et devient: " + altModeleZoom;
        console.log(message);
    //openAfficheInfo(message,10);
    }
    if (no == 1) $efd3ba4ec2608b1d$var$Couche1.modeleZoom = modeleZoomSelect.options[modeleZoomSelect.options.selectedIndex].value;
    else $efd3ba4ec2608b1d$var$Couche2.modeleZoom = modeleZoomSelect.options[modeleZoomSelect.options.selectedIndex].value;
    return trouve;
}
// -----------------------------------------------------------------------------------
//   Selector  for MapIdH
const $efd3ba4ec2608b1d$var$MapIdH1Select = document.getElementById("mapidh1");
const $efd3ba4ec2608b1d$var$MapIdH2Select = document.getElementById("mapidh2");
var $efd3ba4ec2608b1d$var$change_pas = $efd3ba4ec2608b1d$var$setMenuMapIdH(1, $efd3ba4ec2608b1d$var$MapIdH1Select);
var $efd3ba4ec2608b1d$var$change_pas = $efd3ba4ec2608b1d$var$setMenuMapIdH(2, $efd3ba4ec2608b1d$var$MapIdH2Select);
// -----------------------------------------------------------------------------------
//   Selector  for MapIdCo
const $efd3ba4ec2608b1d$var$MapIdCo1Select = document.getElementById("mapidco1");
const $efd3ba4ec2608b1d$var$MapIdCo2Select = document.getElementById("mapidco2");
$efd3ba4ec2608b1d$var$change_pas = $efd3ba4ec2608b1d$var$setMenuMapIdCo(1, $efd3ba4ec2608b1d$var$MapIdCo1Select);
$efd3ba4ec2608b1d$var$change_pas = $efd3ba4ec2608b1d$var$setMenuMapIdCo(2, $efd3ba4ec2608b1d$var$MapIdCo2Select);
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateMapIdHFromMenu(no) {
    $efd3ba4ec2608b1d$var$StopAnimate();
    var oldMapIdH = " ";
    var otherMapIdH = " ";
    var newMapIdH = " ";
    var unchangedInterval = true;
    var unchangedDebut = true;
    var unchangedFin = true;
    var message = " ";
    let modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    let modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    if (no == 1 || no == 0) {
        oldMapIdH = $efd3ba4ec2608b1d$var$Couche1.getMapIdH();
        $efd3ba4ec2608b1d$var$Couche1.mapIdH = $efd3ba4ec2608b1d$var$MapIdH1Select.options[$efd3ba4ec2608b1d$var$MapIdH1Select.options.selectedIndex].value;
        newMapIdH = $efd3ba4ec2608b1d$var$Couche1.getMapIdH();
        otherMapIdH = $efd3ba4ec2608b1d$var$Couche2.getMapIdH();
        message = "newMapIdH: " + newMapIdH + "oldMapId: " + oldMapIdH + " otherMapIdH: " + otherMapIdH;
        console.log(message);
        if ($efd3ba4ec2608b1d$var$WindMaps) localStorage.setItem("MapIdH1_V", $efd3ba4ec2608b1d$var$Couche1.mapIdH);
        else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) {
            localStorage.setItem("MapIdH1_N", $efd3ba4ec2608b1d$var$Couche1.mapIdH);
            localStorage.setItem("MapIdH2_N", $efd3ba4ec2608b1d$var$Couche2.mapIdH);
        } else {
            localStorage.setItem("MapIdH1", $efd3ba4ec2608b1d$var$Couche1.mapIdH);
            localStorage.setItem("MapIdH2", $efd3ba4ec2608b1d$var$Couche2.mapIdH);
        }
        //  check for possible new constraints on current,  interval, debut and fin
        //  when introducing a cumulative precipation on layer 1 while it was not present neither on layer 2 (otherMapIdH)
        if (newMapIdH.indexOf("_h") != -1 && oldMapIdH.indexOf("_h") == -1 && otherMapIdH.indexOf("_h") == -1) {
            unchangedInterval = $efd3ba4ec2608b1d$var$checkInterv($efd3ba4ec2608b1d$var$Couche1.getInterval(), parseInt($efd3ba4ec2608b1d$var$IntervalSelect.options[0].value));
            unchangedDebut = $efd3ba4ec2608b1d$var$checkDebut($efd3ba4ec2608b1d$var$Couche1.getDebut(), parseInt($efd3ba4ec2608b1d$var$DebutSelect.options[0].value));
            unchangedFin = $efd3ba4ec2608b1d$var$checkFin($efd3ba4ec2608b1d$var$Couche1.getFin(), parseInt($efd3ba4ec2608b1d$var$FinSelect.options[0].value));
        }
        //windmap
        if ($efd3ba4ec2608b1d$var$WindMaps) {
            if (oldMapIdH.indexOf("WDIR") != -1 && oldMapIdH.indexOf("WIN") == -1) {
                $efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect1.options.length - 1;
                $efd3ba4ec2608b1d$var$Opacitee1 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect1.options[$efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex].value) / 10.;
            }
            if (newMapIdH.indexOf("WDIR") != -1 && newMapIdH.indexOf("WIN") == -1 && $efd3ba4ec2608b1d$var$Couche2.modeleZoom != "void") {
                $efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect1.options.length - 1;
                $efd3ba4ec2608b1d$var$Opacitee1 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect1.options[$efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex].value) / 10.;
            }
        }
        if ($efd3ba4ec2608b1d$var$Couche1.modeleZoom == "ECMWF" || $efd3ba4ec2608b1d$var$Couche1.modeleZoom == "ECMWF3" || $efd3ba4ec2608b1d$var$Couche1.modeleZoom == "AIFS") $efd3ba4ec2608b1d$var$messageECMWF(newMapIdH);
        if ($efd3ba4ec2608b1d$var$L_Interca) {
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = false;
        }
    }
    if (no == 2 || no == 0) {
        oldMapIdH = $efd3ba4ec2608b1d$var$Couche2.getMapIdH();
        $efd3ba4ec2608b1d$var$Couche2.mapIdH = $efd3ba4ec2608b1d$var$MapIdH2Select.options[$efd3ba4ec2608b1d$var$MapIdH2Select.options.selectedIndex].value;
        newMapIdH = $efd3ba4ec2608b1d$var$Couche2.getMapIdH();
        otherMapIdH = $efd3ba4ec2608b1d$var$Couche1.getMapIdH();
        if ($efd3ba4ec2608b1d$var$WindMaps) localStorage.setItem("MapIdH2_V", $efd3ba4ec2608b1d$var$Couche2.mapIdH);
        else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) localStorage.setItem("MapIdH2_N", $efd3ba4ec2608b1d$var$Couche2.mapIdH);
        else localStorage.setItem("MapIdH2", $efd3ba4ec2608b1d$var$Couche2.mapIdH);
        //  check for possible new constraints on current,  interval, debut and fin
        //  when introducing a cumulative precipation on layer 2 while it was not present neither on layer 1 (otherMapIdH)#
        if (newMapIdH.indexOf("_h") != -1 && oldMapIdH.indexOf("_h") == -1 && otherMapIdH.indexOf("_h") == -1) {
            unchangedInterval = $efd3ba4ec2608b1d$var$checkInterv($efd3ba4ec2608b1d$var$Couche2.getInterval(), parseInt($efd3ba4ec2608b1d$var$IntervalSelect.options[0].value));
            unchangedDebut = $efd3ba4ec2608b1d$var$checkDebut($efd3ba4ec2608b1d$var$Couche2.getDebut(), parseInt($efd3ba4ec2608b1d$var$DebutSelect.options[0].value));
            unchangedFin = $efd3ba4ec2608b1d$var$checkFin($efd3ba4ec2608b1d$var$Couche2.getFin(), parseInt($efd3ba4ec2608b1d$var$FinSelect.options[0].value));
        }
        if ($efd3ba4ec2608b1d$var$Couche2.modeleZoom == "ECMWF" || $efd3ba4ec2608b1d$var$Couche2.modeleZoom == "ECMWF3" || $efd3ba4ec2608b1d$var$Couche2.modeleZoom == "AIFS") $efd3ba4ec2608b1d$var$messageECMWF(newMapIdH);
        if ($efd3ba4ec2608b1d$var$L_Interca) {
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = false;
        }
    }
    if (nowcast1) $efd3ba4ec2608b1d$var$resetDebutFinInterNowcast();
    $efd3ba4ec2608b1d$var$RefreshLgnd(no);
    $efd3ba4ec2608b1d$var$setListProgTimes();
    // Ici mettre le LoadLayers de toute les couches 
    $efd3ba4ec2608b1d$var$LoadLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
    $efd3ba4ec2608b1d$var$LoadLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
    if ($efd3ba4ec2608b1d$var$ActiveLoop) setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
    else setTimeout($efd3ba4ec2608b1d$var$Refresh, 500);
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateMapIdCoFromMenu(no) {
    $efd3ba4ec2608b1d$var$StopAnimate();
    var oldMapIdCo = " ";
    var newMapIdCo = " ";
    var unchangedInterval = true;
    var unchangedDebut = true;
    var unchangedFin = true;
    var message = " ";
    let modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    let modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    if (no == 1 || no == 0) {
        oldMapIdCo = $efd3ba4ec2608b1d$var$Couche1.mapIdCo;
        $efd3ba4ec2608b1d$var$Couche1.mapIdCo = $efd3ba4ec2608b1d$var$MapIdCo1Select.options[$efd3ba4ec2608b1d$var$MapIdCo1Select.options.selectedIndex].value;
        newMapIdCo = $efd3ba4ec2608b1d$var$Couche1.mapIdCo;
        if ($efd3ba4ec2608b1d$var$WindMaps) localStorage.setItem("MapIdCo1_V", $efd3ba4ec2608b1d$var$Couche1.mapIdCo);
        else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) localStorage.setItem("MapIdCo1_N", $efd3ba4ec2608b1d$var$Couche1.mapIdCo);
        else localStorage.setItem("MapIdCo1", $efd3ba4ec2608b1d$var$Couche1.mapIdCo);
        if ($efd3ba4ec2608b1d$var$Couche1.mapIdCo == "void") $efd3ba4ec2608b1d$var$Couche1CoVoid = true;
        else $efd3ba4ec2608b1d$var$Couche1CoVoid = false;
        //windmap
        if ($efd3ba4ec2608b1d$var$WindMaps) {
            if (oldMapIdCo.indexOf("WDIR") != -1 && newMapIdCo.indexOf("WDIR") == -1) {
                $efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect1.options.length - 1;
                $efd3ba4ec2608b1d$var$Opacitee1 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect1.options[$efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex].value) / 10.;
            }
            if (oldMapIdCo.indexOf("WDIR") == -1 && newMapIdCo.indexOf("WDIR") != -1) {
                $efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect1.options.length - 1;
                $efd3ba4ec2608b1d$var$Opacitee1 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect1.options[$efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex].value) / 10.;
            }
        }
        if ($efd3ba4ec2608b1d$var$L_Interca) {
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = false;
        }
    }
    if (no == 2 || no == 0) {
        oldMapIdCo = $efd3ba4ec2608b1d$var$Couche2.mapIdCo;
        $efd3ba4ec2608b1d$var$Couche2.mapIdCo = $efd3ba4ec2608b1d$var$MapIdCo2Select.options[$efd3ba4ec2608b1d$var$MapIdCo2Select.options.selectedIndex].value;
        console.log(" Couche2.mapIdCo ", $efd3ba4ec2608b1d$var$Couche2.mapIdCo);
        newMapIdCo = $efd3ba4ec2608b1d$var$Couche2.mapIdCo;
        if ($efd3ba4ec2608b1d$var$WindMaps) localStorage.setItem("MapIdCo2_V", $efd3ba4ec2608b1d$var$Couche2.mapIdCo);
        else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) localStorage.setItem("MapIdCo2_N", $efd3ba4ec2608b1d$var$Couche2.mapIdCo);
        else localStorage.setItem("MapIdCo2", $efd3ba4ec2608b1d$var$Couche2.mapIdCo);
        if ($efd3ba4ec2608b1d$var$Couche2.mapIdCo == "void") $efd3ba4ec2608b1d$var$Couche2CoVoid = true;
        else $efd3ba4ec2608b1d$var$Couche2CoVoid = false;
        if ($efd3ba4ec2608b1d$var$WindMaps) {
            if (oldMapIdCo.indexOf("WDIR") != -1 && newMapIdCo.indexOf("WDIR") == -1) {
                $efd3ba4ec2608b1d$var$OpaciteSelect2.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect1.options.length - 1;
                $efd3ba4ec2608b1d$var$Opacitee2 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect2.options[$efd3ba4ec2608b1d$var$OpaciteSelect2.options.selectedIndex].value) / 10.;
            }
            if (oldMapIdCo.indexOf("WDIR") == -1 && newMapIdCo.indexOf("WDIR") != -1) {
                $efd3ba4ec2608b1d$var$OpaciteSelect2.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect2.options.length - 1;
                $efd3ba4ec2608b1d$var$Opacitee2 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect2.options[$efd3ba4ec2608b1d$var$OpaciteSelect2.options.selectedIndex].value) / 10.;
            }
        }
        if ($efd3ba4ec2608b1d$var$L_Interca) {
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = false;
        }
    }
    if (nowcast1) $efd3ba4ec2608b1d$var$resetDebutFinInterNowcast();
    $efd3ba4ec2608b1d$var$setListProgTimes();
    // Ici mettre le LoadLayers de toute les couches 
    $efd3ba4ec2608b1d$var$LoadLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
    $efd3ba4ec2608b1d$var$LoadLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
    if ($efd3ba4ec2608b1d$var$ActiveLoop) setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
    else setTimeout($efd3ba4ec2608b1d$var$Refresh, 500);
}
// ________________________________________________________________________________
// Handle change event.
//
$efd3ba4ec2608b1d$var$MapIdH1Select.onchange = function() {
    $efd3ba4ec2608b1d$var$updateMapIdHFromMenu(1);
};
$efd3ba4ec2608b1d$var$MapIdH2Select.onchange = function() {
    $efd3ba4ec2608b1d$var$updateMapIdHFromMenu(2);
};
$efd3ba4ec2608b1d$var$MapIdCo1Select.onchange = function() {
    $efd3ba4ec2608b1d$var$updateMapIdCoFromMenu(1);
};
$efd3ba4ec2608b1d$var$MapIdCo2Select.onchange = function() {
    $efd3ba4ec2608b1d$var$updateMapIdCoFromMenu(2);
};
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$setMenuMapIdH(no, mapIdHSelect) {
    var model = "";
    var layerMapIdH = "";
    if (no == 1) {
        model = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
        layerMapIdH = $efd3ba4ec2608b1d$var$Couche1.getMapIdH();
    } else if (no == 2) {
        model = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
        layerMapIdH = $efd3ba4ec2608b1d$var$Couche2.getMapIdH();
    }
    mapIdHSelect.options.length = 0;
    if (model == "GDPS" || model == "GDPSE" || model == "GDPSIA" || model == "GDPSIAE") {
        if (!$efd3ba4ec2608b1d$var$ArchivesVerif) {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vort500", "ABSV_500_ABSV_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("\xc9pai500", "HGT_1000-500_HGT_1000-500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Nuages", "TCDC_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ250mb", "HGT_250");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ850mb", "HGT_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PNM", "PRMSL_");
            if (model == "GDPSIA" || model == "GDPSIAE") mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Del500", "D-HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V+ 10m", "WIND_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V- 10m", "WIN-_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("VD 10m", "WDIR_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vraf", "GUST_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V 250", "WIND_250");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("VD 250", "WDIR_250");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V 850", "WIND_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("VD 850", "WDIR_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 850", "TMP_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 1,2m", "TMP_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TD 1,2m", "DPT_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("CAPE", "CAPE_10000");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("HUMIDEX", "HUDX_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Li indX", "MU-VT-LI_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Cum5Jr-", "APCP-_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Cum5Jr", "APCP_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Pluie", "WEARN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Neige", "WEASN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Verglas", "WEAFR__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Gresil", "WEAPE__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        } else {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        }
    } else if (model == "GFS") {
        if (!$efd3ba4ec2608b1d$var$ArchivesVerif) {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vort500", "ABSV_500_ABSV_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("\xc9pai500", "HGT_1000-500_HGT_1000-500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Nuages", "TCDC_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ850mb", "HGT_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ250mb", "HGT_250");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Del500", "D-HGT_500"); //Overlay Couleur UNique
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 850", "TMP_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 1,2m", "TMP_sfc");
            //mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Cum5Jr-', 'APCP-_');
            //mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'Cum5Jr', 'APCP_');
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Pluie", "WEARN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Neige", "WEASN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Verglas", "WEAFR__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Gresil", "WEAPE__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        } else {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        }
    } else if (model == "ECMWF" || model == "ECMWF3" || model == "ECMWFE") {
        if (!$efd3ba4ec2608b1d$var$ArchivesVerif) {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vort500", "ABSV_500_ABSV_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("\xc9pai500", "HGT_1000-500_HGT_1000-500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ850mb", "HGT_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ250mb", "HGT_250");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Del500", "D-HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 850", "TMP_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 1,2m", "TMP_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TD 1,2m", "DPT_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Cum5Jr-", "APCP-_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Cum5Jr", "APCP_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Pluie", "WEARN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Neige", "WEASN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Verglas", "WEAFR__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Gresil", "WEAPE__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        } else {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        }
    } else if (model == "AIFS" || model == "AIFSE") {
        if (!$efd3ba4ec2608b1d$var$ArchivesVerif) {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("\xc9pai500", "HGT_1000-500_HGT_1000-500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Nuages", "TCDC_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ850mb", "HGT_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ250mb", "HGT_250");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Del500", "D-HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 850", "TMP_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 1,2m", "TMP_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TD 1,2m", "DPT_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Cum5Jr-", "APCP-_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Cum5Jr", "APCP_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Pluie", "WEARN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Neige", "WEASN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Verglas", "WEAFR__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Gresil", "WEAPE__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        } else {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        }
    } else if (model == "RDPS") {
        if (!$efd3ba4ec2608b1d$var$ArchivesVerif) {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vort500", "ABSV_500_ABSV_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("\xc9pai500", "HGT_1000-500_HGT_1000-500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Nuages", "TCDC_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ250mb", "HGT_250");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ850mb", "HGT_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V+ 10m", "WIND_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V- 10m", "WIN-_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("VD 10m", "WDIR_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Raf", "GUST_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V 250", "WIND_250");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("VD 250", "WDIR_250");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V 850", "WIND_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("VD 850", "WDIR_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 850", "TMP_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 1,2m", "TMP_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TD 1,2m", "DPT_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("CAPE", "CAPE_10000");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("HUMIDEX", "HUDX_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Li indX", "MU-VT-LI_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Pluie", "WEARN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Neige", "WEASN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Verglas", "WEAFR__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Gresil", "WEAPE__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        } else {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        }
    } else if (model == "HRDPS E" || model == "HRDPS W") {
        if (!$efd3ba4ec2608b1d$var$ArchivesVerif) {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Nuages tot", "TCDC_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ 500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V+ (10m)", "WIND_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V- (10m)", "WIN-_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Raf (10m)", "GUST_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("V 850", "WIND_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vd (10m)", "WDIR_10");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vd 850", "WDIR_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT 850mb", "TMP_850");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TT (1,2m)", "TMP_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TD (1,2m)", "DPT_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Nei o sol", "SNOD_sfc");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Pluie", "WEARN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Neige", "WEASN__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Verglas", "WEAFR__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Gresil", "WEAPE__h");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("4 Types", "COMPO__h");
        } else {
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ 500mb", "HGT_500");
            mapIdHSelect.options[mapIdHSelect.options.length] = new Option("cumul Types", "COMPO__h");
        }
    } else if (model == "HRDPS S") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Nuages tot", "HGT_500_TCDC_");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GZ 500mb", "HGT_500");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PNM", "PRMSL_");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Wind+ (10m)", "WIND_10");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Wind- (10m)", "WIN-_10");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Wraf (10m)", "GUST_10");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Wdir (10m)", "WDIR_10");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TMP (1,2m)", "TMP_sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("DPT (1,2m)", "DPT_sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Neige o sol", "SNOD_sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("cumul Pluie", "WEARN__h");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("cumul Neige", "WEASN__h");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("cumul Vergl.", "WEAFR__h");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("cumul Gresil", "WEAPE__h");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("cumul Types", "PRMSL__COMPO__h");
    } else if (model == "HRDPS S0" || model == "HRDPS S1" || model == "HRDPS S2" || model == "HRDPS S3") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vit_Rafal_10m", "GUST_10");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vit_Vent+_10m", "WIND_10");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vit_Vent_10m", "WIN-_10");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Dir_Vent_10m", "WDIR_10");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PNM", "PRMSL_");
    } else if (model == "RAQDPS") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PM2.5 Sfc", "PM2.5_SFC");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PM10 Sfc", "PM10_SFC");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PM2.5 Atm", "PM2.5_ATM");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("PM10 Atm", "PM10_ATM");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("NO Sfc", "NO_SFC");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("NO2 Sfc", "NO2_SFC");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("SO2 Sfc", "SO2_SFC");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("O3 Sfc", "O3_SFC");
    } else if (model == "WCPS") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Glace", "IICECONC_");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TMP 50cm", "VOTEMPER_0.5");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Dir_Cou", "CDIR_0.5");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vit_Cou", "CSPEED_0.5");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Niveau", "SOSSHEIG_");
    } else if (model == "DIAGW") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Courants", "");
        // 2. On cible cette option (qui est maintenant la dernière du tableau) pour la désactiver
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Dir_Cou", "CDIR_0.5");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vit_Cou", "CSPEED_0.5");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Bath+mar\xe9e", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Profond", "Bathy_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vague Vent", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("L0V", "L0V_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("LcV", "LcV_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("CambV", "CmbrV_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("X_V", "Ic_V_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("VW Dir", "WVDIR_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("VW H", "WVHGT_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("AmpliV", "AMPLV_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Agita_V", "Ia_V_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option(" Houle 1 ", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("L01H", "L01H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Lc1H", "Lc1H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Camb1H", "Cmbr1H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("X_1H", "Ic_1H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("H1W Dir", "H1DIR_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("H1W H", "SWHFSWEL_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Agita_1H", "Ia_1H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Ampli1H", "AMPL1H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option(" Houle 2 ", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("L02H", "L02H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Lc2H", "Lc2H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Camb2H", "Cmbr2H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("X_2H", "Ic_2H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("H2W Dir", "H2DIR_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("H2W H", "SWHSSWEL_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Ampli2H", "AMPL2H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Agita_2H", "Ia_2H_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Combin\xe9s  ", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("AmpliX", "AMPL_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("AgitaH", "IaH_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Groupes", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("__________", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("2ie groupe", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("__________", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Agita2Mask", "Ia2_mask_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Agita2Dir", "Ia2Dir_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Agita2G", "Ia2G_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("1ie groupe", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("__________", "");
        mapIdHSelect.options[mapIdHSelect.options.length - 1].disabled = true;
        mapIdHSelect.options[mapIdHSelect.options.length - 1].className = "titre-menu";
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("AgitaLc", "IaLc_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("AgitaMask", "Ia_mask_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("AgitaDir", "IaDir_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("AgitaG", "IaG_Sfc");
    } else if (model == "RDWPS") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GWavH", "HTSGW_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("WWavH", "WVHGT_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("H1WavH", "SWHFSWEL_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("H2WavH", "SWHSSWEL_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GWavPer", "PWPER_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("WWavPer", "PPERWW_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("H1WavPer", "PWPFSWEL_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("H2WavPer", "PWPSSWEL_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("GWavDir", "PWAVEDIR_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("WWavDir", "WVDIR_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("H1WavDir", "MWDFSWEL_Sfc");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("H2WavDir", "MWDSSWEL_Sfc");
    } else if (model == "SHOP") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Niveau", "SOSSHEIG_");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Dir_Cou", "CDIR_Avg");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vit_Cou", "CSPEED_Avg");
    } else if (model == "CIOPS") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Ice Con.", "IICECONC_");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TMP 50cm", "VOTEMPER_0.5");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Dir_Cou", "CDIR_0.5");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("Vit_Cou", "CSPEED_0.5");
    } else if (model == "FOUDRE CO") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("FOUDRE", "FOUDRE_PTS_CO");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("FOUDRE", "FOUDRE_PTS_CO");
    } else if (model == "GOESR CO" || model == "GOESR_PLUS") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("VI 02", "C02_CO");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("IR 13", "C13_CO");
    ////} else if ( model == "GOESR GLM" ) {
    ////mapIdHSelect.options[mapIdHSelect.options.length]  = new Option( 'GLM', 'GLM_G19');
    } else if (model == "RADAR CO") {
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("S Net", "RSNO_NET");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("S", "RSNO");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("R Net", "RRAI_NET");
        mapIdHSelect.options[mapIdHSelect.options.length] = new Option("R", "RRAI");
    } else if (model == "RADART CO") mapIdHSelect.options[mapIdHSelect.options.length] = new Option("TYPE", "RTYP");
    else if (model == "void") mapIdHSelect.options[mapIdHSelect.options.length] = new Option("void", "void");
    var altMapIdH = mapIdHSelect.options[mapIdHSelect.options.length - 1].value;
    var inchangee = "true";
    if (model != "void") inchangee = $efd3ba4ec2608b1d$var$resetMenuMapIdH(no, layerMapIdH, altMapIdH, mapIdHSelect);
    var message = " Le menu Carte m\xe9t\xe9o de la couche " + no.toString() + " a \xe9t\xe9 mis \xe0 jour ";
    console.log(message);
    //   The legend is always refreshed here to reflect either map menu initialisation or model change (calling the present function)
    $efd3ba4ec2608b1d$var$RefreshLgnd(no);
    if (inchangee) {
        var message = " Le choix de la Carte m\xe9t\xe9o demeure intacte";
        console.log(message);
    } else {
        var message = " Le choix de la Carte m\xe9t\xe9o a due \xeatre modifi\xe9e";
        console.log(message);
    }
    return inchangee;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$setMenuMapIdCo(no, mapIdCoSelect) {
    var model = "";
    var layerMapIdCo = "";
    if (no == 1) {
        model = $efd3ba4ec2608b1d$var$Couche1.modeleZoom;
        layerMapIdCo = $efd3ba4ec2608b1d$var$Couche1.mapIdCo;
    } else if (no == 2) {
        model = $efd3ba4ec2608b1d$var$Couche2.modeleZoom;
        layerMapIdCo = $efd3ba4ec2608b1d$var$Couche2.mapIdCo;
    }
    mapIdCoSelect.options.length = 0;
    if (model == "GDPS" || model == "GDPSE" || model == "RDPS" || model == "GDPSIA" || model == "GDPSIAE") {
        if (!$efd3ba4ec2608b1d$var$ArchivesVerif) {
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ250mb", "HGT_250");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ850mb", "HGT_850");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("VD 10m", "WDIR_10");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("VD 250", "WDIR_250");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("VD 850", "WDIR_850");
        } else {
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ500mb", "HGT_500");
        }
    } else if (model == "GFS") {
        if (!$efd3ba4ec2608b1d$var$ArchivesVerif) {
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ250mb", "HGT_250");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ850mb", "HGT_850");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
        } else {
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ500mb", "HGT_500");
        }
    } else if (model == "ECMWF" || model == "ECMWF3" || model == "ECMWFE") {
        if (!$efd3ba4ec2608b1d$var$ArchivesVerif) {
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ250mb", "HGT_250");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ850mb", "HGT_850");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
        } else {
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ500mb", "HGT_500");
        }
    } else if (model == "AIFS" || model == "AIFSE") {
        if (!$efd3ba4ec2608b1d$var$ArchivesVerif) {
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ250mb", "HGT_250");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ500mb", "HGT_500");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ850mb", "HGT_850");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
        } else {
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
            mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ500mb", "HGT_500");
        }
    } else if (model == "HRDPS E" || model == "HRDPS W") {
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GZ500mb", "HGT_500");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("VD 10m", "WDIR_10");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("VD 850", "WDIR_850");
    } else if (model == "HRDPS S") {
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("VD 10m", "WDIR_10");
    } else if (model == "HRDPS S0" || model == "HRDPS S1" || model == "HRDPS S2" || model == "HRDPS S3") {
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("Dir_Vent (10m)", "WDIR_10");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("PNM", "PRMSL_");
    } else if (model == "WCPS") mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("Dir_Cou", "CDIR_0.5");
    else if (model == "DIAGW") {
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("Dir_Cou", "CDIR_0.5");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("VW Dir", "WVDIR_Sfc");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("H1W Dir", "H1DIR_Sfc");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("H2W Dir", "H2DIR_Sfc");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("AgitaDir", "IaDir_Sfc");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("Agita2Dir", "Ia2Dir_Sfc");
    } else if (model == "RDWPS") {
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("GWavDir", "PWAVEDIR_Sfc");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("WWavDir", "WVDIR_Sfc");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("H1WavDir", "MWDFSWEL_Sfc");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("H2WavDir", "MWDSSWEL_Sfc");
    } else if (model == "SHOP") mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("Dir_Cou", "CDIR_Avg");
    else if (model == "CIOPS") mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("Dir_Cou", "CDIR_0.5");
    else if (model == "GOESR_PLUS") {
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("FOUDRE", "FOUDRE_PTS_CO");
        ////mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'GLM', 'GLM_G19');
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("S Net", "RSNO_NET");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("S", "RSNO");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("R Net", "RRAI_NET");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("R", "RRAI");
    } else if (model == "RADAR CO") {
        //mapIdCoSelect.options[mapIdCoSelect.options.length]  = new Option( 'FOUDRE', 'FOUDRE_PTS_CO');
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("S Net", "RSNO_NET");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("S", "RSNO");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("R Net", "RRAI_NET");
        mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("R", "RRAI");
    } else if (model == "RADART CO") mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("TYPE", "RTYP");
    mapIdCoSelect.options[mapIdCoSelect.options.length] = new Option("void", "void");
    var altMapIdCo = mapIdCoSelect.options[mapIdCoSelect.options.length - 1].value;
    var inchangee = "true";
    if (model != "void") inchangee = $efd3ba4ec2608b1d$var$resetMenuMapIdCo(no, layerMapIdCo, altMapIdCo, mapIdCoSelect);
    var message = " Le menu Carte m\xe9t\xe9o Fl\xe8ches et Contours de la couche " + no.toString() + " a \xe9t\xe9 mis \xe0 jour ";
    console.log(message);
    //   The legend is always refreshed here to reflect either map menu initialisation or model change (calling the present function)
    $efd3ba4ec2608b1d$var$RefreshLgnd(no);
    if (inchangee) {
        var message = " Le choix de la Carte m\xe9t\xe9o Fl\xe8ches et Contours demeure intacte";
        console.log(message);
    } else {
        var message = " Le choix de la Carte m\xe9t\xe9o Fl\xe8ches et Contours a due \xeatre modifi\xe9e";
        console.log(message);
    }
    return inchangee;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$resetMenuMapIdH(no, layerMapIdH, altMapIdH, mapIdHSelect) {
    /// la   fonction cherche dans le menu,  la valeur du MapIdH de la couche (layerMapIdH)
    //  si elle est trouvée,  cet indice du menu sera "selected".
    // sinon, ce sera le mapid  passé sous altMapIdH  qui sera  "selected"
    //  et dans ce cas la valeur de mapidh de la couche sera changé !!!
    // ------------------------------------------------------------------------------
    var trouve = false;
    var indice = 0;
    var indice2iem = 0;
    for(indice = 0; indice < mapIdHSelect.options.length; indice++){
        if (altMapIdH == mapIdHSelect.options[indice].value) indice2iem = indice;
        if (layerMapIdH == mapIdHSelect.options[indice].value) {
            mapIdHSelect.options.selectedIndex = indice;
            trouve = true;
        }
    }
    if (!trouve) {
        mapIdHSelect.options.selectedIndex = indice2iem;
        var message = " La carte " + layerMapIdH + " (couche " + no + ") change et devient: " + altMapIdH;
        console.log("message");
    //openAfficheInfo(message,10);
    }
    if (no == 1) $efd3ba4ec2608b1d$var$Couche1.mapIdH = mapIdHSelect.options[mapIdHSelect.options.selectedIndex].value;
    else $efd3ba4ec2608b1d$var$Couche2.mapIdH = mapIdHSelect.options[mapIdHSelect.options.selectedIndex].value;
    return trouve;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$resetMenuMapIdCo(no, layerMapIdCo, altMapIdCo, mapIdCoSelect) {
    /// la   fonction cherche dans le menu,  la valeur du MapIdCo de la couche (layerMapIdCo)
    //  si elle est trouvée,  cet indice du menu sera "selected".
    // sinon, ce sera le mapid  passé sous altMapIdCo  qui sera  "selected"
    //  et dans ce cas la valeur de mapidCo de la couche sera changé !!!
    // ------------------------------------------------------------------------------
    var trouve = false;
    var indice = 0;
    var indice2iem = 0;
    let modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    let modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    for(indice = 0; indice < mapIdCoSelect.options.length; indice++){
        if (altMapIdCo == mapIdCoSelect.options[indice].value) indice2iem = indice;
        if (layerMapIdCo == mapIdCoSelect.options[indice].value) {
            mapIdCoSelect.options.selectedIndex = indice;
            trouve = true;
        }
    }
    if (!trouve) {
        mapIdCoSelect.options.selectedIndex = indice2iem;
        var message = " La carte " + layerMapIdCo + " (couche " + no + ") change et devient: " + altMapIdCo;
        console.log("message");
    //openAfficheInfo(message,10);
    }
    if (no == 1) {
        $efd3ba4ec2608b1d$var$Couche1.mapIdCo = mapIdCoSelect.options[mapIdCoSelect.options.selectedIndex].value;
        if ($efd3ba4ec2608b1d$var$WindMaps) localStorage.setItem("MapIdCo1_V", $efd3ba4ec2608b1d$var$Couche1.mapIdCo);
        else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) localStorage.setItem("MapIdCo1_N", $efd3ba4ec2608b1d$var$Couche1.mapIdCo);
        else localStorage.setItem("MapIdCo1", $efd3ba4ec2608b1d$var$Couche1.mapIdCo);
        if ($efd3ba4ec2608b1d$var$Couche1.mapIdCo == "void") $efd3ba4ec2608b1d$var$Couche1CoVoid = true;
        else $efd3ba4ec2608b1d$var$Couche1CoVoid = false;
    } else {
        $efd3ba4ec2608b1d$var$Couche2.mapIdCo = mapIdCoSelect.options[mapIdCoSelect.options.selectedIndex].value;
        if ($efd3ba4ec2608b1d$var$WindMaps) localStorage.setItem("MapIdCo2_V", $efd3ba4ec2608b1d$var$Couche2.mapIdCo);
        else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) localStorage.setItem("MapIdCo2_N", $efd3ba4ec2608b1d$var$Couche2.mapIdCo);
        else localStorage.setItem("MapIdCo2", $efd3ba4ec2608b1d$var$Couche2.mapIdCo);
        if ($efd3ba4ec2608b1d$var$Couche2.mapIdCo == "void") $efd3ba4ec2608b1d$var$Couche2CoVoid = true;
        else $efd3ba4ec2608b1d$var$Couche2CoVoid = false;
    }
    return trouve;
}
// -----------------------------------------------------------------------------------
//   Selector  for houroid
const $efd3ba4ec2608b1d$var$HourOId1Select = document.getElementById("houroid1");
const $efd3ba4ec2608b1d$var$HourOId2Select = document.getElementById("houroid2");
$efd3ba4ec2608b1d$var$change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(true, 1, $efd3ba4ec2608b1d$var$HourOId1Select);
$efd3ba4ec2608b1d$var$change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(true, 2, $efd3ba4ec2608b1d$var$HourOId2Select);
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateHourOIdFromMenu(no) {
    $efd3ba4ec2608b1d$var$StopAnimate();
    $efd3ba4ec2608b1d$var$UnsetValeurs("0");
    let modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    let modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    if ($efd3ba4ec2608b1d$var$DprogDt) alert(" Menu inactif en mode Dprog Dt puisque l'animation porte sur la date d origine!");
    else if (nowcast1 && no == 1) alert(" Menu inactif lorsque GOESR, FOUDRE ou RADAR est s\xe9lectionn\xe9 sur la couche 1 puisque l'animation porte sur la date d origine!");
    else if (nowcast2 && no == 2) alert(" Menu inactif lorsque GOESR, FOUDRE ou RADAR est s\xe9lectionn\xe9 sur la couche 2 puisque l'animation porte sur la date d origine!");
    else {
        var message = " Changing houroid: " + no.toString();
        console.log(message);
        var unchangedInterval = true;
        var unchangedDebut = true;
        var unchangedFin = true;
        var proposedHourOId = $efd3ba4ec2608b1d$var$HourOId1Select.options[$efd3ba4ec2608b1d$var$HourOId1Select.options.selectedIndex].value;
        var altHourOId = $efd3ba4ec2608b1d$var$Couche1.getHourOId();
        var proposedOk = false;
        if (no == 1) proposedOk = $efd3ba4ec2608b1d$var$checkHourOId(no, proposedHourOId, altHourOId, $efd3ba4ec2608b1d$var$HourOId1Select);
        else if (no == 2) {
            proposedHourOId = $efd3ba4ec2608b1d$var$HourOId2Select.options[$efd3ba4ec2608b1d$var$HourOId2Select.options.selectedIndex].value;
            altHourOId = $efd3ba4ec2608b1d$var$Couche2.getHourOId();
            proposedOk = $efd3ba4ec2608b1d$var$checkHourOId(no, proposedHourOId, altHourOId, $efd3ba4ec2608b1d$var$HourOId2Select);
        }
        if (proposedOk && proposedHourOId != altHourOId) {
            if ($efd3ba4ec2608b1d$var$Couche1.getHourOId() == $efd3ba4ec2608b1d$var$Couche2.getHourOId()) $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
            else $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
            unchangedInterval = $efd3ba4ec2608b1d$var$checkInterv($efd3ba4ec2608b1d$var$Couche1.getInterval(), parseInt($efd3ba4ec2608b1d$var$IntervalSelect.options[0].value));
            unchangedDebut = $efd3ba4ec2608b1d$var$checkDebut($efd3ba4ec2608b1d$var$Couche1.getDebut(), parseInt($efd3ba4ec2608b1d$var$DebutSelect.options[0].value));
            unchangedFin = $efd3ba4ec2608b1d$var$checkFin(parseInt($efd3ba4ec2608b1d$var$FinSelect.options[0].value), parseInt($efd3ba4ec2608b1d$var$FinSelect.options[0].value));
        }
        $efd3ba4ec2608b1d$var$RefreshLgnd(no);
        $efd3ba4ec2608b1d$var$setListProgTimes();
        $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
        if ($efd3ba4ec2608b1d$var$ActiveLoop) {
            if (no == 1) {
                $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 1);
                $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 1);
            } else if (no == 2) {
                $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 2);
                $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 2);
            }
            setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
        } else $efd3ba4ec2608b1d$var$Refresh();
    }
}
// ________________________________________________________________________________
// Handle change event.
//
$efd3ba4ec2608b1d$var$HourOId1Select.onchange = function() {
    $efd3ba4ec2608b1d$var$updateHourOIdFromMenu(1);
};
$efd3ba4ec2608b1d$var$HourOId2Select.onchange = function() {
    $efd3ba4ec2608b1d$var$updateHourOIdFromMenu(2);
};
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$setMenuHourOId(init, no, hourOIdSelect) {
    var message = " ";
    if (no == 1) $efd3ba4ec2608b1d$var$SetMenuHourOIdRun1 = true;
    else $efd3ba4ec2608b1d$var$SetMenuHourOIdRun2 = true;
    $efd3ba4ec2608b1d$var$HourOId1Select.disabled = false;
    if ($efd3ba4ec2608b1d$var$DprogDt && no == 1) {
        var modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
        var modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
        let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
        let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
        var iHourOId1Hist = $efd3ba4ec2608b1d$var$nombrePassesHistoriques(modele1);
        var iHourOId2Hist = $efd3ba4ec2608b1d$var$nombrePassesHistoriques(modele2);
        var hourOId1 = "";
        var hourOId2 = "";
        $efd3ba4ec2608b1d$var$HourOId1Select.options.length = 0;
        $efd3ba4ec2608b1d$var$HourOId2Select.options.length = 0;
        var i1 = 0;
        var i2 = 0;
        for(i1 = 0; i1 < iHourOId1Hist; i1++){
            ecart_ = i1 * $efd3ba4ec2608b1d$var$nombreMinutesEntrePasses(modele1);
            hourOId1 = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$ModAHourOId.get(modele1), ecart_, false);
            if ($efd3ba4ec2608b1d$var$Couche2Void) $efd3ba4ec2608b1d$var$HourOId1Select.options[$efd3ba4ec2608b1d$var$HourOId1Select.options.length] = new Option(hourOId1, hourOId1);
            else for(i2 = 0; i2 < iHourOId2Hist; i2++){
                ecart_ = i2 * $efd3ba4ec2608b1d$var$nombreMinutesEntrePasses(modele2);
                hourOId2 = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$ModAHourOId.get(modele2), ecart_, false);
                if (nowcast1 || nowcast2) {
                    $efd3ba4ec2608b1d$var$HourOId1Select.options[$efd3ba4ec2608b1d$var$HourOId1Select.options.length] = new Option(hourOId1, hourOId1);
                    $efd3ba4ec2608b1d$var$HourOId2Select.options[$efd3ba4ec2608b1d$var$HourOId2Select.options.length] = new Option(hourOId1, hourOId1);
                } else if (hourOId1 == hourOId2) {
                    $efd3ba4ec2608b1d$var$HourOId1Select.options[$efd3ba4ec2608b1d$var$HourOId1Select.options.length] = new Option(hourOId1, hourOId1);
                    $efd3ba4ec2608b1d$var$HourOId2Select.options[$efd3ba4ec2608b1d$var$HourOId2Select.options.length] = new Option(hourOId1, hourOId1);
                }
            }
        }
        if ($efd3ba4ec2608b1d$var$HourOId1Select.options.length == 0) {
            message = " Probl\xe8me ici, avec le menu de la date d'origine, je dois repartir le tout, d\xe9sol\xe9";
            alert(message);
            location.reload(true);
        }
        $efd3ba4ec2608b1d$var$HourOId1Select.disabled = true;
    } else {
        var layerHourOId = $efd3ba4ec2608b1d$var$Couche1.getHourOId();
        var modele = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
        if (no == 2) {
            layerHourOId = $efd3ba4ec2608b1d$var$Couche2.getHourOId();
            modele = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
        }
        var hourOIdEcart = $efd3ba4ec2608b1d$var$nombreMinutesEntrePasses(modele);
        var HourOIdHist = $efd3ba4ec2608b1d$var$nombrePassesHistoriques(modele);
        //  getting the latest houroid for this model  and update the menu
        var hourOId_latest = $efd3ba4ec2608b1d$var$ModAHourOId.get(modele);
        hourOIdSelect.options.length = 0;
        hourOIdSelect.options[hourOIdSelect.options.length] = new Option(hourOId_latest, hourOId_latest);
        var i = 0;
        var houroid_m_ = " ";
        var ecart_ = 0;
        var message = " ";
        for(i = 1; i < HourOIdHist; i++){
            ecart_ = i * hourOIdEcart;
            houroid_m_ = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes(hourOId_latest, ecart_, false);
            hourOIdSelect.options[hourOIdSelect.options.length] = new Option(houroid_m_, houroid_m_);
        }
        message = " Le menu date d'origine de la couche " + no + " a \xe9t\xe9 mis \xe0 jour ";
        console.log(message);
        //   try to establish coherence between the menu and the current layer houroid  except if init is true,  then reset
        var proposedOk = true;
        if ((init || $efd3ba4ec2608b1d$var$ResetModeleDefaults) && layerHourOId != hourOId_latest) proposedOk = $efd3ba4ec2608b1d$var$checkHourOId(no, hourOId_latest, hourOId_latest, hourOIdSelect);
        else proposedOk = $efd3ba4ec2608b1d$var$checkHourOId(no, layerHourOId, hourOId_latest, hourOIdSelect);
        if (no == 1 && $efd3ba4ec2608b1d$var$Couche1.hourOId == layerHourOId || no == 2 && $efd3ba4ec2608b1d$var$Couche2.hourOId == layerHourOId) {
            message = " La valeur de la date d'origine de cette couche demeure intacte";
            console.log(message);
            proposedOk = true;
        } else {
            message = " La valeur de la date d'origine a due \xeatre modifi\xe9e";
            console.log(message);
            proposedOk = false;
        }
        if (no == 1) $efd3ba4ec2608b1d$var$SetMenuHourOIdRun1 = false;
        else $efd3ba4ec2608b1d$var$SetMenuHourOIdRun2 = false;
    }
    $efd3ba4ec2608b1d$var$RefreshLgnd(no);
    return proposedOk;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$checkHourOId(no, proposedHourOId, altHourOId, hourOIdSelectO) {
    var ihourOId = 0;
    var ihourOId_correcte = 0;
    var message = " ";
    var proposedOkA = $efd3ba4ec2608b1d$var$resetMenuHourOId(no, proposedHourOId, altHourOId, hourOIdSelectO);
    return proposedOkA;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$resetMenuHourOId(no, proposedHourOId, altHourOId, hourOIdSelect) {
    /// la   fonction cherche dans le menu,  la valeur du houroid (proposedHourOId)
    //  si elle est trouvé,  cet indice du menu sera "selected".
    // sinon, ce sera l'houroid  passé sous altHourOId_   qui sera  "selected"
    //  et dans ce cas la valeur de houroid de la couche sera changé !!!
    // ------------------------------------------------------------------------------
    var trouve = false;
    var indice = 0;
    var indice2iem = 0;
    var indice_limite = hourOIdSelect.options.length;
    for(indice = 0; indice < indice_limite; indice++){
        if (altHourOId == hourOIdSelect.options[indice].value) indice2iem = indice;
        if (proposedHourOId == hourOIdSelect.options[indice].value) {
            hourOIdSelect.options.selectedIndex = indice;
            trouve = true;
        }
    }
    if (!trouve) hourOIdSelect.options.selectedIndex = indice2iem;
    if (no == 1) $efd3ba4ec2608b1d$var$Couche1.hourOId = hourOIdSelect.options[hourOIdSelect.options.selectedIndex].value;
    else $efd3ba4ec2608b1d$var$Couche2.hourOId = hourOIdSelect.options[hourOIdSelect.options.selectedIndex].value;
    return trouve;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$resetMenuDprogSurDt(no, istep) {
    var trouve1 = true;
    var trouve2 = true;
    if ($efd3ba4ec2608b1d$var$L_Interca) {
        if (no == 1) trouve1 = $efd3ba4ec2608b1d$var$resetMenuHourOId(1, $efd3ba4ec2608b1d$var$listHourOId1[istep], $efd3ba4ec2608b1d$var$listHourOId1[istep], $efd3ba4ec2608b1d$var$HourOId1Select);
        else trouve2 = $efd3ba4ec2608b1d$var$resetMenuHourOId(2, $efd3ba4ec2608b1d$var$listHourOId2[istep], $efd3ba4ec2608b1d$var$listHourOId2[istep], $efd3ba4ec2608b1d$var$HourOId2Select);
    } else {
        trouve1 = $efd3ba4ec2608b1d$var$resetMenuHourOId(1, $efd3ba4ec2608b1d$var$listHourOId1[istep], $efd3ba4ec2608b1d$var$listHourOId1[istep], $efd3ba4ec2608b1d$var$HourOId1Select);
        if (!$efd3ba4ec2608b1d$var$Couche2Void) trouve2 = $efd3ba4ec2608b1d$var$resetMenuHourOId(2, $efd3ba4ec2608b1d$var$listHourOId2[istep], $efd3ba4ec2608b1d$var$listHourOId2[istep], $efd3ba4ec2608b1d$var$HourOId2Select);
    }
}
// -----------------------------------------------------------------------------------
//   Selector  for Fin
const $efd3ba4ec2608b1d$var$FinSelect = document.getElementById("fin");
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateFinFromMenu() {
    $efd3ba4ec2608b1d$var$StopAnimate();
    var proposedFin = parseInt($efd3ba4ec2608b1d$var$FinSelect.options[$efd3ba4ec2608b1d$var$FinSelect.options.selectedIndex].value);
    var changeFin = $efd3ba4ec2608b1d$var$checkFin(proposedFin, $efd3ba4ec2608b1d$var$Couche1.getFin());
    if (changeFin) {
        $efd3ba4ec2608b1d$var$setListProgTimes();
        if ($efd3ba4ec2608b1d$var$ActiveLoop) {
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
            setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
        } else $efd3ba4ec2608b1d$var$Refresh();
    } else console.log(" updateFinFromMenu: proposedFin: " + proposedFin + " Not accepted ");
}
// --------------------------------------------------------------------------------
// Handle change event.
//
$efd3ba4ec2608b1d$var$FinSelect.onchange = function() {
    $efd3ba4ec2608b1d$var$updateFinFromMenu();
};
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$setMenuFin() {
    let changement = false;
    let layerFin = $efd3ba4ec2608b1d$var$Couche1.getFin();
    let modelFin = $efd3ba4ec2608b1d$var$ModAFin.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
    let modelDebut = $efd3ba4ec2608b1d$var$ModADebut.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
    let interv_ = $efd3ba4ec2608b1d$var$ModAInterv.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
    let delta_ = 0;
    let fin_for_ = 0;
    let sFin_ = "";
    let modelFinH = 0;
    let modelFinM = 0;
    let smodelFinH = "";
    let smodelFinM = "";
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
    if (nowcast1 || $efd3ba4ec2608b1d$var$Couche1.getModeleZoom() == "HRDPS E" || $efd3ba4ec2608b1d$var$Couche1.getModeleZoom() == "SUDQC" || $efd3ba4ec2608b1d$var$Couche1.getModeleZoom() == "SLFE") delta_ = Math.max(interv_, 60);
    else delta_ = Math.max(interv_, 180);
    fin_for_ = Math.round((modelFin - modelDebut) / delta_) + 1;
    $efd3ba4ec2608b1d$var$FinSelect.options.length = 0;
    let i = 0;
    let fin_suivant = modelFin;
    for(i = 0; i < fin_for_; i++){
        modelFinH = Math.abs(Math.round(fin_suivant / 60.));
        modelFinM = Math.abs(Math.round(fin_suivant % 60));
        smodelFinH = modelFinH.toString();
        smodelFinM = modelFinM.toString();
        if (smodelFinH.length < 2) smodelFinH = "0" + smodelFinH;
        if (smodelFinM.length < 2) smodelFinM = "0" + smodelFinM;
        if (modelFin == 0) sFin_ = "-";
        else sFin_ = "";
        if (Math.abs(fin_suivant) >= modelDebut) {
            if (nowcast1) sFin_ = sFin_ + smodelFinH + ":" + smodelFinM + "h";
            else sFin_ = sFin_ + smodelFinH + "h";
            $efd3ba4ec2608b1d$var$FinSelect.options[$efd3ba4ec2608b1d$var$FinSelect.options.length] = new Option(sFin_, fin_suivant.toString());
        }
        fin_suivant = fin_suivant - delta_;
    }
    if ($efd3ba4ec2608b1d$var$ResetModeleDefaults) {
        if (layerFin != modelFin) {
            changement = true;
            layerFin = modelFin;
        }
    }
    let unchangedFin = $efd3ba4ec2608b1d$var$checkFin(layerFin, modelFin);
    if (changement) unchangedFin = false;
    return unchangedFin;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$resetMenuFin(layerFin, modelFin) {
    /// la   fonction cherche dans le menu,  la valeur de fin (layerFin)
    //  si elle est trouvée,  cet indice du menu sera "selected".
    // sinon, ce sera la fin  passée sous modelFin   qui sera  "selected"
    //  et dans ce cas la valeur de fin de la couche sera changé !!!
    // ------------------------------------------------------------------------------
    let trouve = false;
    let indice = 0;
    let indice2iem = 0;
    for(indice = 0; indice < parseInt($efd3ba4ec2608b1d$var$FinSelect.options.length); indice++){
        if (modelFin == parseInt($efd3ba4ec2608b1d$var$FinSelect.options[indice].value)) indice2iem = indice;
        if (layerFin == parseInt($efd3ba4ec2608b1d$var$FinSelect.options[indice].value)) {
            $efd3ba4ec2608b1d$var$FinSelect.options.selectedIndex = indice;
            trouve = true;
        }
    }
    if (!trouve) $efd3ba4ec2608b1d$var$FinSelect.options.selectedIndex = indice2iem;
    $efd3ba4ec2608b1d$var$Couche1.fin = parseInt($efd3ba4ec2608b1d$var$FinSelect.options[$efd3ba4ec2608b1d$var$FinSelect.options.selectedIndex].value);
    let differenceHourOId = $efd3ba4ec2608b1d$var$soustractionHourOId($efd3ba4ec2608b1d$var$Couche1.getHourOId(), $efd3ba4ec2608b1d$var$Couche2.getHourOId(), true);
    $efd3ba4ec2608b1d$var$Couche2.fin = $efd3ba4ec2608b1d$var$Couche1.getFin() + differenceHourOId;
    return trouve;
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$checkFin(proposedFin, altFin) {
    //   la fin doit s'ajuster au début,  à l'interval et au décalage du temps d'origine entre les couches.
    //   la couche 2 s'ajuste à la couche 1
    //
    //   Cette fonction établie les valeurs de fin de couche 1 et 2
    //   Elle établie la fin la plus éloignée en fonction de la demande de fin : proposedFin 
    //
    //   La demande proposedFin peut toutefois être diminuée ...
    //   afin de s'ajuster à la limite maximale de la couche 2 (fin_1_max)
    //   ou afin de s'ajuster à l'un ou l'autre des début de boucle ( couche 1 ou 2: fin_1_min
    //   ou bien finalment afin d etre un multiple entier d interval entre le début et la fin
    //
    //   Une fois la fin correcte établie,   on en dédui fin_2_correcte
    //   via le décalage entre les temps d'origine
    let modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    let modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    let interv_ = $efd3ba4ec2608b1d$var$Couche1.getInterval();
    let interv_min = $efd3ba4ec2608b1d$var$ModAInterv.get(modele1);
    if ($efd3ba4ec2608b1d$var$Couche1.getMapIdH().indexOf("_h") != -1 || $efd3ba4ec2608b1d$var$Couche2.getMapIdH().indexOf("_h") != -1 && !$efd3ba4ec2608b1d$var$Couche2Void) interv_min = interv_;
    let fin_correcte = 0;
    let fin_min = $efd3ba4ec2608b1d$var$Couche1.getDebut();
    let fin_max = $efd3ba4ec2608b1d$var$ModAFin.get(modele1);
    let shouroid_latest = "";
    let houroid_fin = 0;
    let shouroid_fin = "";
    let shouroid1_min = "";
    let shouroid2_min = "";
    let shouroid1_max = "";
    let shouroid2_max = "";
    if (!$efd3ba4ec2608b1d$var$Couche2Void) {
        if (nowcast1 || nowcast2) {
            if (nowcast1) {
                shouroid_latest = $efd3ba4ec2608b1d$var$ModAHourOId.get(modele1).slice(0, 10) + "00";
                shouroid1_min = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$ModAHourOId.get(modele1), $efd3ba4ec2608b1d$var$ModADebut.get(modele1), true);
            } else {
                shouroid_latest = $efd3ba4ec2608b1d$var$Couche1.getHourOId().slice(0, 10) + "00";
                shouroid1_min = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$Couche1.getHourOId(), interv_, true);
            }
            if (nowcast2) shouroid2_min = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$ModAHourOId.get(modele2), $efd3ba4ec2608b1d$var$ModADebut.get(modele2), true);
            else shouroid2_min = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$Couche2.getHourOId(), $efd3ba4ec2608b1d$var$ModADebut.get(modele2), true);
            shouroid1_min = shouroid1_min.slice(0, 10) + "00";
            shouroid2_min = shouroid2_min.slice(0, 10) + "00";
            houroid_fin = Math.max(parseInt(shouroid1_min), parseInt(shouroid2_min));
            shouroid_fin = houroid_fin.toString().slice(0, 10) + "00";
            fin_min = Math.max(fin_min, $efd3ba4ec2608b1d$var$soustractionHourOId(shouroid_fin, shouroid_latest, false));
            shouroid1_max = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$ModAHourOId.get(modele1), $efd3ba4ec2608b1d$var$ModAFin.get(modele1), true);
            shouroid1_max = shouroid1_max.slice(0, 10) + "00";
            shouroid2_max = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$ModAHourOId.get(modele2), $efd3ba4ec2608b1d$var$ModAFin.get(modele2), true);
            shouroid1_max = shouroid1_max.slice(0, 10) + "00";
            shouroid2_max = shouroid2_max.slice(0, 10) + "00";
            houroid_fin = Math.min(parseInt(shouroid1_max), parseInt(shouroid2_max));
            shouroid_fin = houroid_fin.toString().slice(0, 10) + "00";
            fin_max = Math.min(fin_max, $efd3ba4ec2608b1d$var$soustractionHourOId(shouroid_fin, shouroid_latest, false));
        } else {
            let differenceHourOId = $efd3ba4ec2608b1d$var$soustractionHourOId($efd3ba4ec2608b1d$var$Couche1.getHourOId(), $efd3ba4ec2608b1d$var$Couche2.getHourOId(), true);
            fin_min = Math.max(fin_min, Math.max($efd3ba4ec2608b1d$var$Couche2.getDebut(), $efd3ba4ec2608b1d$var$Couche2.getDebut() - differenceHourOId));
            fin_max = Math.min(fin_max, Math.min($efd3ba4ec2608b1d$var$ModAFin.get(modele2), $efd3ba4ec2608b1d$var$ModAFin.get(modele2) - differenceHourOId));
        }
    }
    fin_correcte = Math.min(fin_max, proposedFin);
    console.log(" fin_correct: " + fin_correcte + " proposed: " + proposedFin + " max: " + fin_max);
    fin_correcte = Math.max(fin_min, fin_correcte);
    console.log(" fin_correct: " + fin_correcte + " min: " + fin_min);
    fin_correcte = fin_correcte - parseInt((fin_correcte - $efd3ba4ec2608b1d$var$Couche1.getDebut()) % interv_);
    console.log(" fin_correct: " + fin_correcte + " interv " + interv_);
    let acceptProposed = true;
    if (fin_correcte != proposedFin) acceptProposed = false;
    let acceptProposed2 = $efd3ba4ec2608b1d$var$resetMenuFin(fin_correcte, altFin);
    return acceptProposed && acceptProposed2;
}
// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//   Selector  for Debut
const $efd3ba4ec2608b1d$var$DebutSelect = document.getElementById("debut");
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateDebutFromMenu() {
    $efd3ba4ec2608b1d$var$StopAnimate();
    var proposedDebut = parseInt($efd3ba4ec2608b1d$var$DebutSelect.options[$efd3ba4ec2608b1d$var$DebutSelect.options.selectedIndex].value);
    var changeDebut = $efd3ba4ec2608b1d$var$checkDebut(proposedDebut, $efd3ba4ec2608b1d$var$Couche1.getDebut());
    if (changeDebut) {
        var unchangedFin = $efd3ba4ec2608b1d$var$checkFin($efd3ba4ec2608b1d$var$Couche1.getFin(), parseInt($efd3ba4ec2608b1d$var$FinSelect.options[0].value));
        $efd3ba4ec2608b1d$var$setListProgTimes();
        if ($efd3ba4ec2608b1d$var$ActiveLoop) {
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
            setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
        } else $efd3ba4ec2608b1d$var$Refresh();
    } else console.log(" updateDebutFromMenu , proposedDebuT: " + proposedDebut + " not accepted");
}
// ________________________________________________________________________________
// Handle change event.
//
$efd3ba4ec2608b1d$var$DebutSelect.onchange = function() {
    $efd3ba4ec2608b1d$var$updateDebutFromMenu();
};
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateDebut(proposedDebut) {
    var changeDebut = $efd3ba4ec2608b1d$var$checkDebut(proposedDebut, $efd3ba4ec2608b1d$var$Couche1.getDebut());
    if (changeDebut) {
        var unchangedFin = $efd3ba4ec2608b1d$var$checkFin($efd3ba4ec2608b1d$var$Couche1.getFin(), parseInt($efd3ba4ec2608b1d$var$FinSelect.options[0].value));
        $efd3ba4ec2608b1d$var$setListProgTimes();
        if ($efd3ba4ec2608b1d$var$ActiveLoop) {
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
            setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
        } else $efd3ba4ec2608b1d$var$Refresh();
    } else console.log(" updateDebutFromMenu , proposedDebuT: " + proposedDebut + " not accepted");
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$setMenuDebut() {
    let changement = false;
    let layerDebut = $efd3ba4ec2608b1d$var$Couche1.getDebut();
    let modelDebut = $efd3ba4ec2608b1d$var$ModADebut.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
    let modelFin = $efd3ba4ec2608b1d$var$ModAFin.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
    let interv_ = $efd3ba4ec2608b1d$var$ModAInterv.get($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
    let interv_inc = Math.max(60, interv_);
    let fin_for_ = 0;
    let sdebut_ = "";
    let modelDebutH = 0;
    let modelDebutM = 0;
    let smodelDebutH = "";
    let smodelDebutM = "";
    let debut_suivant = modelDebut;
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
    if (nowcast1) {
        fin_for_ = Math.round((modelFin - modelDebut) / interv_inc);
        debut_suivant = -1 * fin_for_ * interv_inc;
    } else fin_for_ = Math.round(modelFin / interv_inc);
    $efd3ba4ec2608b1d$var$DebutSelect.options.length = 0;
    let i = 0;
    for(i = 0; i < fin_for_; i++){
        modelDebutH = Math.abs(Math.round(debut_suivant / 60.));
        modelDebutM = Math.abs(Math.round(debut_suivant % 60));
        smodelDebutH = modelDebutH.toString();
        smodelDebutM = modelDebutM.toString();
        if (smodelDebutH.length < 2) smodelDebutH = "0" + smodelDebutH;
        if (smodelDebutM.length < 2) smodelDebutM = "0" + smodelDebutM;
        if (modelDebut < 0) sdebut_ = "-";
        else sdebut_ = "";
        if (debut_suivant <= modelFin) {
            if (nowcast1) sdebut_ = sdebut_ + smodelDebutH + ":" + smodelDebutM + "h";
            else sdebut_ = sdebut_ + smodelDebutH + "h";
            $efd3ba4ec2608b1d$var$DebutSelect.options[$efd3ba4ec2608b1d$var$DebutSelect.options.length] = new Option(sdebut_, debut_suivant.toString());
        }
        debut_suivant = debut_suivant + interv_inc;
    }
    if ($efd3ba4ec2608b1d$var$ResetModeleDefaults) {
        if (nowcast1) modelDebut = -60;
        if (layerDebut != modelDebut) {
            changement = true;
            layerDebut = modelDebut;
        }
    }
    var unchangedDebut = $efd3ba4ec2608b1d$var$checkDebut(layerDebut, modelDebut);
    if (changement) unchangedDebut = false;
    return unchangedDebut;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$resetMenuDebut(layerDebut, modelDebut) {
    /// la   fonction cherche dans le menu,  la valeur de debut (layerDebut)
    //  si elle est trouvée,  cet indice du menu sera "selected".
    // sinon, ce sera la debut  passée sous modelDebut   qui sera  "selected"
    //  et dans ce cas la valeur de debut de la couche sera changé !!!
    // ------------------------------------------------------------------------------
    let trouve = false;
    let indice = 0;
    let indice2iem = 0;
    let differenceHourOId = $efd3ba4ec2608b1d$var$soustractionHourOId($efd3ba4ec2608b1d$var$Couche1.getHourOId(), $efd3ba4ec2608b1d$var$Couche2.getHourOId(), true);
    for(indice = 0; indice < parseInt($efd3ba4ec2608b1d$var$DebutSelect.options.length); indice++){
        if (modelDebut == parseInt($efd3ba4ec2608b1d$var$DebutSelect.options[indice].value)) indice2iem = indice;
        if (layerDebut == parseInt($efd3ba4ec2608b1d$var$DebutSelect.options[indice].value)) {
            $efd3ba4ec2608b1d$var$DebutSelect.options.selectedIndex = indice;
            trouve = true;
        }
    }
    if (!trouve) $efd3ba4ec2608b1d$var$DebutSelect.options.selectedIndex = indice2iem;
    $efd3ba4ec2608b1d$var$Couche1.debut = parseInt($efd3ba4ec2608b1d$var$DebutSelect.options[$efd3ba4ec2608b1d$var$DebutSelect.options.selectedIndex].value);
    $efd3ba4ec2608b1d$var$Couche2.debut = $efd3ba4ec2608b1d$var$Couche1.getDebut() + differenceHourOId;
    return trouve;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$checkDebut(proposedDebut, altDebut) {
    //   le Debut doit s'ajuster à l'interval et au décalage de temps d'origine entre les couche 1 et 2
    //   la couche 2 s'ajuste à la couche 1
    //
    //   Cette fonction établie les valeurs de Debut de couche 1 qui tient compte de la couche 2. 
    //   Elle établie le debut le plus près de l'origine en fonction de la demande de Debut :  proposedDebut
    //
    //   La demande proposedDebut peut toutefois être  retarder (augmenté)
    //   afin de s'ajuster à la limite maximale de fin des couche  1 et 2:  debut_1_max
    //   ou afin de s'ajuster à l'un ou l'autre des début de boucle ( couche 1 ou 2: debut_1_min
    //   ou bien finalment afin d etre plus grand ou egal à l interval dans le cas ou il y a des accumulations
    //
    //   Une fois le debut correcte établie, on fait appel au menu pour trouver
    //
    let modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    let modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    let interv_ = $efd3ba4ec2608b1d$var$Couche1.getInterval();
    let interv_min = $efd3ba4ec2608b1d$var$ModAInterv.get(modele1);
    if ($efd3ba4ec2608b1d$var$Couche1.getMapIdH().indexOf("_h") != -1 || $efd3ba4ec2608b1d$var$Couche2.getMapIdH().indexOf("_h") != -1 && !$efd3ba4ec2608b1d$var$Couche2Void) interv_min = interv_;
    let debut_correct = 0;
    let debut_min = $efd3ba4ec2608b1d$var$ModADebut.get(modele1);
    let debut_max = $efd3ba4ec2608b1d$var$ModAFin.get(modele1);
    let shouroid_latest = "";
    let houroid_debut = 0;
    let shouroid_debut = "";
    let shouroid1_min = "";
    let shouroid2_min = "";
    let shouroid1_max = "";
    let shouroid2_max = "";
    if (!$efd3ba4ec2608b1d$var$Couche2Void) {
        if (nowcast1 || nowcast2) {
            if (nowcast1) {
                shouroid_latest = $efd3ba4ec2608b1d$var$ModAHourOId.get(modele1).slice(0, 10) + "00";
                shouroid1_min = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$ModAHourOId.get(modele1), $efd3ba4ec2608b1d$var$ModADebut.get(modele1), true);
            } else {
                shouroid_latest = $efd3ba4ec2608b1d$var$Couche1.getHourOId().slice(0, 10) + "00";
                shouroid1_min = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$Couche1.getHourOId(), interv_, true);
            }
            if (nowcast2) shouroid2_min = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$ModAHourOId.get(modele2), $efd3ba4ec2608b1d$var$ModADebut.get(modele2), true);
            else shouroid2_min = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$Couche2.getHourOId(), Math.max($efd3ba4ec2608b1d$var$ModADebut.get(modele2), interv_), true);
            shouroid1_min = shouroid1_min.slice(0, 10) + "00";
            shouroid2_min = shouroid2_min.slice(0, 10) + "00";
            houroid_debut = Math.max(parseInt(shouroid1_min), parseInt(shouroid2_min));
            shouroid_debut = houroid_debut.toString().slice(0, 10) + "00";
            debut_min = Math.max(debut_min, $efd3ba4ec2608b1d$var$soustractionHourOId(shouroid_debut, shouroid_latest, false));
            shouroid1_max = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$ModAHourOId.get(modele1), $efd3ba4ec2608b1d$var$ModAFin.get(modele1), true);
            shouroid1_max = shouroid1_max.slice(0, 10) + "00";
            shouroid2_max = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$ModAHourOId.get(modele2), $efd3ba4ec2608b1d$var$ModAFin.get(modele2), true);
            shouroid1_max = shouroid1_max.slice(0, 10) + "00";
            shouroid2_max = shouroid2_max.slice(0, 10) + "00";
            houroid_debut = Math.min(parseInt(shouroid1_max), parseInt(shouroid2_max));
            shouroid_debut = houroid_debut.toString().slice(0, 10) + "00";
            debut_max = Math.min(debut_max, $efd3ba4ec2608b1d$var$soustractionHourOId(shouroid_debut, shouroid_latest, false));
        } else {
            let differenceHourOId = $efd3ba4ec2608b1d$var$soustractionHourOId($efd3ba4ec2608b1d$var$Couche1.getHourOId(), $efd3ba4ec2608b1d$var$Couche2.getHourOId(), true);
            debut_min = Math.max(debut_min, Math.max($efd3ba4ec2608b1d$var$ModADebut.get(modele2), $efd3ba4ec2608b1d$var$ModADebut.get(modele2) - differenceHourOId));
            debut_max = Math.min(debut_max, Math.min($efd3ba4ec2608b1d$var$ModAFin.get(modele2), $efd3ba4ec2608b1d$var$ModAFin.get(modele2) - differenceHourOId));
        }
    }
    if (Math.abs(debut_min) < interv_min) {
        if (debut_min > 0) debut_min = interv_min;
        else debut_min = -interv_min;
    } else if (Math.abs(debut_min) % interv_min != 0) debut_min = debut_min + interv_min - Math.abs(debut_min) % interv_min;
    if (Math.abs(debut_max) < interv_min) {
        if (debut_max > 0) debut_max = interv_min;
        else debut_max = -interv_min;
    } else if (debut_max % interv_min != 0) debut_max = debut_max - Math.abs(debut_max) % interv_min;
    debut_correct = proposedDebut - proposedDebut % interv_min;
    debut_correct = Math.max(debut_min, debut_correct);
    debut_correct = Math.min(debut_max, debut_correct);
    var acceptProposed = true;
    if (debut_correct != proposedDebut) acceptProposed = false;
    var acceptProposed2 = $efd3ba4ec2608b1d$var$resetMenuDebut(debut_correct, altDebut);
    return acceptProposed && acceptProposed2;
}
// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//   Selector  for Interval
const $efd3ba4ec2608b1d$var$IntervalSelect = document.getElementById("interval");
$efd3ba4ec2608b1d$var$change_pas = $efd3ba4ec2608b1d$var$setMenuInterval();
$efd3ba4ec2608b1d$var$change_pas = $efd3ba4ec2608b1d$var$setMenuDebut();
$efd3ba4ec2608b1d$var$change_pas = $efd3ba4ec2608b1d$var$setMenuFin();
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateIntervalFromMenu() {
    $efd3ba4ec2608b1d$var$StopAnimate();
    var proposedInterval = parseInt($efd3ba4ec2608b1d$var$IntervalSelect.options[$efd3ba4ec2608b1d$var$IntervalSelect.options.selectedIndex].value);
    var changeInterval = $efd3ba4ec2608b1d$var$checkInterv(proposedInterval, $efd3ba4ec2608b1d$var$Couche1.getInterval());
    var unchangedDebut = true;
    var unchangedFin = true;
    if (changeInterval) {
        unchangedDebut = $efd3ba4ec2608b1d$var$checkDebut($efd3ba4ec2608b1d$var$Couche1.getDebut(), parseInt($efd3ba4ec2608b1d$var$DebutSelect.options[0].value));
        unchangedFin = $efd3ba4ec2608b1d$var$checkFin($efd3ba4ec2608b1d$var$Couche1.getFin(), parseInt($efd3ba4ec2608b1d$var$FinSelect.options[0].value));
        $efd3ba4ec2608b1d$var$setListProgTimes();
        if ($efd3ba4ec2608b1d$var$ActiveLoop) {
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
            setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
        } else $efd3ba4ec2608b1d$var$Refresh();
        if ($efd3ba4ec2608b1d$var$Couche1.getMapIdH().indexOf("_h") != -1) $efd3ba4ec2608b1d$var$RefreshLgnd(1);
        if ($efd3ba4ec2608b1d$var$Couche2.getMapIdH().indexOf("_h") != -1 && !$efd3ba4ec2608b1d$var$Couche2Void) $efd3ba4ec2608b1d$var$RefreshLgnd(2);
    } else console.log(" updateInrevalFromMenu , proposedInterval " + proposedInterval + " not accepted");
}
// ________________________________________________________________________________
// Handle change event.
//
$efd3ba4ec2608b1d$var$IntervalSelect.onchange = function() {
    $efd3ba4ec2608b1d$var$updateIntervalFromMenu();
};
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$setMenuInterval() {
    var changement = false;
    var layerInterval = $efd3ba4ec2608b1d$var$Couche1.getInterval();
    var model1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    var model2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    var interv_min = $efd3ba4ec2608b1d$var$ModAInterv.get(model1);
    var interv_max = 0;
    if (model1 == "GDPS" || model1 == "ECMWF" || model1 == "AIFS" || model1 == "GDPSIA" || model1 == "GFS") interv_max = 2880;
    else if (model1 == "GDPSE" || model1 == "GDPSIAE" || model1 == "ECMWFE" || model1 == "AIFSE") interv_max = 2880;
    else if (model1 == "RDPS" || model1 == "ECMWF3" || model1 == "RAQDPS") interv_max = 1440;
    else if (model1 == "HRDPS E" || model1 == "HRDPS W") interv_max = 720;
    else if (model1 == "HRDPS S") interv_max = 720;
    else if (model1 == "HRDPS S0" || model1 == "HRDPS S1" || model1 == "HRDPS S2" || model1 == "HRDPS S3") interv_max = 720;
    else if (model1 == "WCPS" || model1 == "CIOPS" || model1 == "SHOP" || model1 == "RDWPS" || model1 == "DIAGW") interv_max = 720;
    else if (model1 == "GOESR GLM" || model1 == "GOESR CO" || model1 == "FOUDRE CO" || model1 == "GOESR_PLUS") interv_max = 720;
    else if (model1 == "RADART CO" || model1 == "RADAR CO") interv_max = 720;
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(model1);
    if (!$efd3ba4ec2608b1d$var$Couche2Void && !nowcast1) {
        interv_min = Math.max(interv_min, $efd3ba4ec2608b1d$var$ModAInterv.get(model2));
        if (model2 == "GDPS" || model2 == "ECMWF" || model2 == "AIFS" || model2 == "GDPSIA" || model2 == "GFS") interv_max = Math.min(2880, interv_max);
        else if (model2 == "GDPSE" || model2 == "GDPSIAE" || model2 == "ECMWFE" || model2 == "AIFSE") interv_max = Math.min(2880, interv_max);
        else if (model2 == "RDPS" || model2 == "ECMWF3" || model2 == "RAQDPS") interv_max = Math.min(1440, interv_max);
        else if (model2 == "HRDPS E" || model2 == "HRDPS W") interv_max = Math.min(720, interv_max);
        else if (model2 == "HRDPS S") interv_max = Math.min(720, interv_max);
        else if (model2 == "HRDPS S0" || model2 == "HRDPS S1" || model2 == "HRDPS S2" || model2 == "HRDPS S3") interv_max = Math.min(720, interv_max);
        else if (model2 == "WCPS" || model2 == "CIOPS" || model2 == "SHOP" || model2 == "RDWPS" || model2 == "DIAGW") interv_max = Math.min(720, interv_max);
        else if (model2 == "GOESR GLM" || model2 == "GOESR CO" || model2 == "FOUDRE CO" || model2 == "GOESR_PLUS") interv_max = Math.min(720, interv_max);
        else if (model2 == "RADART CO" || model2 == "RADAR CO") interv_max = Math.min(720, interv_max);
    }
    let intervalH = Math.round(interv_min / 60.);
    let sinterval = intervalH.toString() + "h";
    $efd3ba4ec2608b1d$var$IntervalSelect.options.length = 0;
    if (!nowcast1) {
        sinterval = intervalH.toString() + "h";
        $efd3ba4ec2608b1d$var$IntervalSelect.options[$efd3ba4ec2608b1d$var$IntervalSelect.options.length] = new Option(sinterval, interv_min);
    } else {
        sinterval = interv_min.toString() + "m";
        $efd3ba4ec2608b1d$var$IntervalSelect.options[$efd3ba4ec2608b1d$var$IntervalSelect.options.length] = new Option(sinterval, interv_min);
    }
    let interval_suivant = interv_min;
    let i = 0;
    for(i = 1; i < 5; i++){
        interval_suivant = interval_suivant * 2;
        if (interval_suivant == 10) interval_suivant = 30;
         // 5m, 30m, 60m, 180m, 360m pour GOES  
        if (interval_suivant == 12) interval_suivant = 30;
         //  6m, 30m, 60m, 180m, 360m pour RADAR
        if (interval_suivant == 120) interval_suivant = 180;
         // 60m, 180m, 360m, 720m pour HRDPS-S 
        if (interval_suivant < interv_max + 1) {
            if (!nowcast1) {
                intervalH = Math.round(interval_suivant / 60.);
                sinterval = intervalH.toString() + "h";
                $efd3ba4ec2608b1d$var$IntervalSelect.options[$efd3ba4ec2608b1d$var$IntervalSelect.options.length] = new Option(sinterval, interval_suivant);
            } else {
                sinterval = interval_suivant.toString() + "m";
                $efd3ba4ec2608b1d$var$IntervalSelect.options[$efd3ba4ec2608b1d$var$IntervalSelect.options.length] = new Option(sinterval, interval_suivant);
            }
        }
    }
    if ($efd3ba4ec2608b1d$var$ResetModeleDefaults) {
        if (layerInterval != interv_min) {
            changement = true;
            layerInterval = interv_min;
        }
    }
    var unchangedInterval = $efd3ba4ec2608b1d$var$checkInterv(layerInterval, interv_min);
    if (changement) unchangedInterval = false;
    if ($efd3ba4ec2608b1d$var$Couche1.getMapIdH().indexOf("_h") != -1) $efd3ba4ec2608b1d$var$RefreshLgnd(1);
    if (!$efd3ba4ec2608b1d$var$Couche2Void) {
        if ($efd3ba4ec2608b1d$var$Couche2.getMapIdH().indexOf("_h") != -1) $efd3ba4ec2608b1d$var$RefreshLgnd(2);
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$resetMenuInterval(layerInterval, modelInterval) {
    /// la   fonction cherche dans le menu,  la valeur de Interval (layerInterval)
    //  si elle est trouvée,  cet indice du menu sera "selected".
    // sinon, ce sera la interval  passée sous modelInterval   qui sera  "selected"
    //  et dans ce cas la valeur de L interval de la couche sera changé !!!
    // ------------------------------------------------------------------------------
    var trouve = false;
    var indice = 0;
    var indice2iem = 0;
    for(indice = 0; indice < parseInt($efd3ba4ec2608b1d$var$IntervalSelect.options.length); indice++){
        if (modelInterval == parseInt($efd3ba4ec2608b1d$var$IntervalSelect.options[indice].value)) indice2iem = indice;
        if (layerInterval == parseInt($efd3ba4ec2608b1d$var$IntervalSelect.options[indice].value)) {
            $efd3ba4ec2608b1d$var$IntervalSelect.options.selectedIndex = indice;
            trouve = true;
        }
    }
    if (!trouve) $efd3ba4ec2608b1d$var$IntervalSelect.options.selectedIndex = indice2iem;
    $efd3ba4ec2608b1d$var$Couche1.interval = parseInt($efd3ba4ec2608b1d$var$IntervalSelect.options[$efd3ba4ec2608b1d$var$IntervalSelect.options.selectedIndex].value);
    $efd3ba4ec2608b1d$var$Couche2.interval = parseInt($efd3ba4ec2608b1d$var$IntervalSelect.options[$efd3ba4ec2608b1d$var$IntervalSelect.options.selectedIndex].value);
    return trouve;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$checkInterv(proposedInterval, altInterval) {
    var differenceHourOId = $efd3ba4ec2608b1d$var$soustractionHourOId($efd3ba4ec2608b1d$var$Couche1.getHourOId(), $efd3ba4ec2608b1d$var$Couche2.getHourOId(), true);
    var interv_correcte = 0;
    var interv_max = 0;
    var interv_max2 = 0;
    var model1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    var model2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    var interv_min = $efd3ba4ec2608b1d$var$ModAInterv.get(model1);
    if (model1 == "GDPS" || model1 == "ECMWF" || model1 == "AIFS" || model1 == "GDPSIA" || model1 == "GFS") interv_max = 2880;
    else if (model1 == "GDPSE" || model1 == "GDPSIAE" || model1 == "ECMWFE" || model1 == "AIFSE") interv_max = 2880;
    else if (model1 == "RDPS" || model1 == "ECMWF3" || model1 == "RAQDPS") interv_max = 1440;
    else if (model1 == "HRDPS E" || model1 == "HRDPS W") interv_max = 720;
    else if (model1 == "HRDPS S" || model1 == "CIOPS") interv_max = 720;
    else if (model1 == "HRDPS S0" || model1 == "HRDPS S1" || model1 == "HRDPS S2" || model1 == "HRDPS S3") interv_max = 720;
    else if (model1 == "WCPS" || model1 == "SHOP" || model1 == "RDWPS" || model1 == "DIAGW") interv_max = 720;
    else if (model1 == "GOESR GLM" || model1 == "GOESR CO" || model1 == "FOUDRE CO" || model1 == "GOESR_PLUS") interv_max = 720;
    else if (model1 == "RADART CO" || model1 == "RADAR CO") interv_max = 720;
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(model1);
    if (!$efd3ba4ec2608b1d$var$Couche2Void && !nowcast1) {
        interv_min = Math.max(interv_min, $efd3ba4ec2608b1d$var$ModAInterv.get(model2));
        if (model2 == "GDPS" || model2 == "ECMWF" || model2 == "AIFS" || model2 == "GDPSIA" || model2 == "GFS") interv_max = Math.min(2880, interv_max);
        else if (model2 == "GDPSE" || model2 == "GDPSIAE" || model2 == "ECMWFE" || model2 == "AIFSE") interv_max = Math.min(2880, interv_max);
        else if (model2 == "RDPS" || model2 == "ECMWF3" || model2 == "RAQDPS") interv_max = Math.min(1440, interv_max);
        else if (model2 == "HRDPS E" || model2 == "HRDPS W") interv_max = Math.min(720, interv_max);
        else if (model2 == "HRDPS S" || model2 == "CIOPS") interv_max = Math.min(720, interv_max);
        else if (model2 == "HRDPS S0" || model2 == "HRDPS S1" || model2 == "HRDPS S2" || model2 == "HRDPS S3") interv_max = Math.min(720, interv_max);
        else if (model2 == "WCPS" || model2 == "SHOP" || model2 == "RDWPS" || model2 == "DIAGW") interv_max = Math.min(720, interv_max);
        else if (model2 == "GOESR GLM" || model2 == "GOESR CO" || model2 == "GOESR_PLUS") interv_max = Math.min(720, interv_max);
        else if (model2 == "RADART CO" || model2 == "RADAR CO") interv_max = Math.min(720, interv_max);
    }
    interv_max2 = interv_max;
    if (differenceHourOId != 0) {
        if ($efd3ba4ec2608b1d$var$Couche1.getMapIdH().indexOf("_h") != -1 || $efd3ba4ec2608b1d$var$Couche2.getMapIdH().indexOf("_h") != -1 && !$efd3ba4ec2608b1d$var$Couche2Void && !nowcast1) // when a layer has precip accum, and there is difference between the  between the origin hour (houroid) 
        // then the interval must be smaller or equal to the difference between the origin hour (houroid)  
        //   then the max interv should not exceed the difference between houroid
        //
        interv_max2 = Math.min(Math.abs(differenceHourOId), interv_max);
    }
    interv_correcte = Math.min(Math.max(proposedInterval, interv_min), interv_max2);
    var unchangedInterval = true;
    if (interv_correcte != proposedInterval) unchangedInterval = false;
    var unchangedInterval2 = $efd3ba4ec2608b1d$var$resetMenuInterval(interv_correcte, altInterval);
    return unchangedInterval && unchangedInterval2;
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$refreshHouroid(no) {
    var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = $efd3ba4ec2608b1d$var$DprogDt;
    let ResetModeleDefaultsWasTrue = $efd3ba4ec2608b1d$var$ResetModeleDefaults;
    message = " refreshHouroid est en action ";
    console.log(message);
    $efd3ba4ec2608b1d$var$StopAnimate();
    if (no == 1 || no == 0) couche_change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(true, 1, $efd3ba4ec2608b1d$var$HourOId1Select);
    if (!$efd3ba4ec2608b1d$var$Couche2Void && (no == 2 || no == 0)) couche_change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(true, 2, $efd3ba4ec2608b1d$var$HourOId2Select);
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuInterval();
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuDebut();
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuFin();
    $efd3ba4ec2608b1d$var$setListProgTimes();
    if ($efd3ba4ec2608b1d$var$ActiveLoop) {
        if (no == 1 || no == 0) {
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 1);
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 1);
        }
        if (no == 2 || no == 0) {
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 2);
            $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 2);
        }
        setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
    } else $efd3ba4ec2608b1d$var$Refresh();
}
// ________________________________________________________________________________
$("#resetHouroid").click(function() {
    let model_ = $efd3ba4ec2608b1d$var$Couche1.modeleZoom;
    $efd3ba4ec2608b1d$var$readSetLatestHourOId($efd3ba4ec2608b1d$var$ModAHourOId.get(model_), model_, true, true);
    if ($efd3ba4ec2608b1d$var$Couche2.modeleZoom != $efd3ba4ec2608b1d$var$Couche1.modeleZoom) {
        model_ = $efd3ba4ec2608b1d$var$Couche2.modeleZoom;
        $efd3ba4ec2608b1d$var$readSetLatestHourOId($efd3ba4ec2608b1d$var$ModAHourOId.get(model_), model_, true, true);
    }
});
$("#resetInterv").click(function() {
    $efd3ba4ec2608b1d$var$resetInterv();
});
$("#resetDebut").click(function() {
    $efd3ba4ec2608b1d$var$resetDebut();
});
$("#resetFin").click(function() {
    $efd3ba4ec2608b1d$var$resetFin();
});
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$resetInterv() {
    var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = $efd3ba4ec2608b1d$var$DprogDt;
    //  if ( DprogDt ) {
    //   DprogDtSelect.options.selectedIndex = 0;
    //        updateDprogDtFromMenu();
    //  } 
    message = " resetInterv est en action ";
    console.log(message);
    $efd3ba4ec2608b1d$var$StopAnimate();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuInterval();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuDebut();
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuFin();
    //  if ( dprogDTwasTrue ) {
    //     DprogDtSelect.options.selectedIndex = 1;
    //        updateDprogDtFromMenu();
    //     }
    $efd3ba4ec2608b1d$var$setListProgTimes();
    if ($efd3ba4ec2608b1d$var$ActiveLoop) {
        $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
        $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
        setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
    } else $efd3ba4ec2608b1d$var$Refresh();
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$resetDebut() {
    var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = $efd3ba4ec2608b1d$var$DprogDt;
    //  if ( DprogDt ) {
    //   DprogDtSelect.options.selectedIndex = 0;
    //        updateDprogDtFromMenu();
    //  } 
    message = " resetDebut est en action ";
    console.log(message);
    $efd3ba4ec2608b1d$var$StopAnimate();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuDebut();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuFin();
    //  if ( dprogDTwasTrue ) {
    //     DprogDtSelect.options.selectedIndex = 1;
    //        updateDprogDtFromMenu();
    //     }
    $efd3ba4ec2608b1d$var$setListProgTimes();
    if ($efd3ba4ec2608b1d$var$ActiveLoop) {
        $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
        $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
        setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
    } else $efd3ba4ec2608b1d$var$Refresh();
}
//_____________________________________________________________________________________
function $efd3ba4ec2608b1d$var$resetFin() {
    var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = $efd3ba4ec2608b1d$var$DprogDt;
    //  if ( DprogDt ) {
    //   DprogDtSelect.options.selectedIndex = 0;
    //        updateDprogDtFromMenu();
    //  } 
    message = " resetFin est en action ";
    console.log(message);
    $efd3ba4ec2608b1d$var$StopAnimate();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuFin();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
    //  if ( dprogDTwasTrue ) {
    //     DprogDtSelect.options.selectedIndex = 1;
    //        updateDprogDtFromMenu();
    //     }
    $efd3ba4ec2608b1d$var$setListProgTimes();
    if ($efd3ba4ec2608b1d$var$ActiveLoop) {
        $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
        $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
        setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
    } else $efd3ba4ec2608b1d$var$Refresh();
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$resetDebutFinInterNowcast() {
    var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = $efd3ba4ec2608b1d$var$DprogDt;
    let ResetModeleDefaultsWasTrue = $efd3ba4ec2608b1d$var$ResetModeleDefaults;
    message = " resetDebutFinInt est en action ";
    console.log(message);
    $efd3ba4ec2608b1d$var$StopAnimate();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuInterval();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuDebut();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuFin();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = ResetModeleDefaultsWasTrue;
    $efd3ba4ec2608b1d$var$setListProgTimes();
    if ($efd3ba4ec2608b1d$var$ActiveLoop) {
        $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
        $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
        setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
    } else $efd3ba4ec2608b1d$var$Refresh();
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$resetTimeMenus() {
    var couche_change_pas = true;
    var message = " ";
    var dprogDTwasTrue = $efd3ba4ec2608b1d$var$DprogDt;
    message = " resetTimesMenus est en action ";
    console.log(message);
    $efd3ba4ec2608b1d$var$StopAnimate();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(true, 1, $efd3ba4ec2608b1d$var$HourOId1Select);
    if (!$efd3ba4ec2608b1d$var$Couche2Void) couche_change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(true, 2, $efd3ba4ec2608b1d$var$HourOId2Select);
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuInterval();
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuDebut();
    couche_change_pas = $efd3ba4ec2608b1d$var$setMenuFin();
    $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
    $efd3ba4ec2608b1d$var$setListProgTimes();
    if ($efd3ba4ec2608b1d$var$ActiveLoop) {
        $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
        $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
        setTimeout($efd3ba4ec2608b1d$var$StartAnimate, 500);
    } else setTimeout($efd3ba4ec2608b1d$var$Refresh, 500);
}
// -----------------------------------------------------------------------------------
$("#resetTimeMenus").click(function() {
    $efd3ba4ec2608b1d$var$resetTimeMenus();
});
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$AfficheEffaceChoixDuo(lettre) {
    var message = " ";
    if ($efd3ba4ec2608b1d$var$DprogDt) {
        message = " Cette action ne fonctionne pas en mode valid constant ";
        alert(message);
    } else {
        message = " Presets est en action ";
        console.log(message);
        $efd3ba4ec2608b1d$var$StopAnimate();
        if (lettre == "A") document.getElementById("choixDuoA").style.display = "block";
        else if (lettre == "B") document.getElementById("choixDuoB").style.display = "block";
        else if (lettre == "C") document.getElementById("choixDuoC").style.display = "block";
        else if (lettre == "D") document.getElementById("choixDuoD").style.display = "block";
        else if (lettre == "N") document.getElementById("choixDuoN").style.display = "block";
    }
}
// -----------------------------------------------------------------------------------
$("#ChoixDuoA").click(function() {
    $efd3ba4ec2608b1d$var$AfficheEffaceChoixDuo("A");
});
$("#ChoixDuoB").click(function() {
    $efd3ba4ec2608b1d$var$AfficheEffaceChoixDuo("B");
});
$("#ChoixDuoC").click(function() {
    $efd3ba4ec2608b1d$var$AfficheEffaceChoixDuo("C");
});
$("#ChoixDuoD").click(function() {
    $efd3ba4ec2608b1d$var$AfficheEffaceChoixDuo("D");
});
$("#ChoixDuoN").click(function() {
    $efd3ba4ec2608b1d$var$AfficheEffaceChoixDuo("N");
});
// -----------------------------------------------------------------------------------
//   Selector  for Valeur
const $efd3ba4ec2608b1d$var$ValeurSelect1 = document.getElementById("valeur1");
const $efd3ba4ec2608b1d$var$ValeurSelect2 = document.getElementById("valeur2");
var $efd3ba4ec2608b1d$var$Valeur1 = "off";
var $efd3ba4ec2608b1d$var$Valeur2 = "off";
var $efd3ba4ec2608b1d$var$Valeur1Hist = "off";
var $efd3ba4ec2608b1d$var$Valeur2Hist = "off";
// ________________________________________________________________________________
// Handle change event.
//
$efd3ba4ec2608b1d$var$ValeurSelect1.onchange = function() {
    $efd3ba4ec2608b1d$var$updateValeurFromMenu(1);
};
$efd3ba4ec2608b1d$var$ValeurSelect2.onchange = function() {
    $efd3ba4ec2608b1d$var$updateValeurFromMenu(2);
};
$efd3ba4ec2608b1d$var$setMenuValeurs(1, $efd3ba4ec2608b1d$var$ValeurSelect1);
$efd3ba4ec2608b1d$var$setMenuValeurs(2, $efd3ba4ec2608b1d$var$ValeurSelect2);
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$setMenuValeurs(no, valeurSelect) {
    var model = "";
    var layerValeur = "";
    if (no == 1) {
        model = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
        layerValeur = $efd3ba4ec2608b1d$var$Valeur1;
    } else if (no == 2) {
        model = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
        layerValeur = $efd3ba4ec2608b1d$var$Valeur2;
    }
    valeurSelect.options.length = 0;
    if (model == "GDPS" || model == "GDPSE" || model == "GDPSIA" || model == "GDPSIAE") {
        valeurSelect.options[valeurSelect.options.length] = new Option("off", "off");
        valeurSelect.options[valeurSelect.options.length] = new Option("Popup", "Popup");
        valeurSelect.options[valeurSelect.options.length] = new Option("TimSer", "TimSer");
        valeurSelect.options[valeurSelect.options.length] = new Option("TimSer_e", "TimSer_e");
        valeurSelect.options[valeurSelect.options.length] = new Option("MeteoGrm", "MeteoGrm");
    } else if (model == "WCPS") {
        valeurSelect.options[valeurSelect.options.length] = new Option("off", "off");
        valeurSelect.options[valeurSelect.options.length] = new Option("Popup", "Popup");
    } else if (model == "RDWPS") {
        valeurSelect.options[valeurSelect.options.length] = new Option("off", "off");
        valeurSelect.options[valeurSelect.options.length] = new Option("Popup", "Popup");
    } else if (model == "DIAGW") {
        valeurSelect.options[valeurSelect.options.length] = new Option("off", "off");
        valeurSelect.options[valeurSelect.options.length] = new Option("Popup", "Popup");
    } else if (model == "SHOP") {
        valeurSelect.options[valeurSelect.options.length] = new Option("off", "off");
        valeurSelect.options[valeurSelect.options.length] = new Option("Popup", "Popup");
    } else if (model == "ECMWF" || model == "ECMWF3" || model == "ECMWFE") {
        valeurSelect.options[valeurSelect.options.length] = new Option("off", "off");
        valeurSelect.options[valeurSelect.options.length] = new Option("Popup", "Popup");
        valeurSelect.options[valeurSelect.options.length] = new Option("TimSer", "TimSer");
        valeurSelect.options[valeurSelect.options.length] = new Option("TimSer_e", "TimSer_e");
        valeurSelect.options[valeurSelect.options.length] = new Option("MeteoGrm", "MeteoGrm");
        valeurSelect.options[valeurSelect.options.length] = new Option("ProfVert", "ProfVert");
    } else if (model == "AIFS" || model == "AIFSE") {
        valeurSelect.options[valeurSelect.options.length] = new Option("off", "off");
        valeurSelect.options[valeurSelect.options.length] = new Option("Popup", "Popup");
        valeurSelect.options[valeurSelect.options.length] = new Option("TimSer", "TimSer");
        valeurSelect.options[valeurSelect.options.length] = new Option("TimSer_e", "TimSer_e");
        valeurSelect.options[valeurSelect.options.length] = new Option("MeteoGrm", "MeteoGrm");
    } else {
        valeurSelect.options[valeurSelect.options.length] = new Option("off", "off");
        valeurSelect.options[valeurSelect.options.length] = new Option("Popup", "Popup");
        valeurSelect.options[valeurSelect.options.length] = new Option("TimSer", "TimSer");
        valeurSelect.options[valeurSelect.options.length] = new Option("TimSer_e", "TimSer_e");
    }
    var altValeur = valeurSelect.options[0].value;
    var inchangee = $efd3ba4ec2608b1d$var$resetMenuValeurs(no, layerValeur, altValeur, valeurSelect);
    var message = " Le menu Valeurs de la couche " + no.toString() + " a \xe9t\xe9 mis \xe0 jour ";
    console.log(message);
    if (inchangee) {
        var message = " Le choix de Valeurs demeure intact";
        console.log(message);
    } else {
        var message = " Le choix de valeur a due \xeatre modifi\xe9";
        console.log(message);
    }
    return inchangee;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$resetMenuValeurs(no, layerValeur, altValeur, valeurSelect) {
    /// la   fonction cherche dans le menu,  la valeur de valeur de la couche ()
    //  si elle est trouvée,  cet indice du menu sera "selected".
    // sinon, ce sera le Valeur  passé sous altValeur  qui sera  "selected"
    //  et dans ce cas la valeur de Valeur de la couche sera changé !!!
    // ------------------------------------------------------------------------------
    var trouve = false;
    var indice = 0;
    var indice2iem = 0;
    for(indice = 0; indice < valeurSelect.options.length; indice++){
        if (altValeur == valeurSelect.options[indice].value) indice2iem = indice;
        if (layerValeur == valeurSelect.options[indice].value) {
            valeurSelect.options.selectedIndex = indice;
            trouve = true;
        }
    }
    if (!trouve) {
        valeurSelect.options.selectedIndex = indice2iem;
        var message = " (resetMenuValeurs) La Valeur: " + layerValeur + " (couche " + no + ") change et devient: " + altValeur;
        console.log(message);
        //openAfficheInfo(message,10);
        $efd3ba4ec2608b1d$var$UnsetValeurs("0");
        $efd3ba4ec2608b1d$var$Valeur1Hist = "off";
        $efd3ba4ec2608b1d$var$Valeur2Hist = "off";
    }
    if (no == 1) $efd3ba4ec2608b1d$var$Valeur1 = valeurSelect.options[valeurSelect.options.selectedIndex].value;
    else $efd3ba4ec2608b1d$var$Valeur2 = valeurSelect.options[valeurSelect.options.selectedIndex].value;
    return trouve;
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$ResetValeurs() {
    if ($efd3ba4ec2608b1d$var$Valeur1Hist != "off" && !$efd3ba4ec2608b1d$var$L_Juxtapo) {
        //                                   si Valeur1Hist est autre que off,  alors Valeur1 est off et on va le réactiver
        //                                   réactivation du menu
        $efd3ba4ec2608b1d$var$resetMenuValeurs(1, $efd3ba4ec2608b1d$var$Valeur1Hist, "off", $efd3ba4ec2608b1d$var$ValeurSelect1);
        //                                    ici le menu a été réajusté à ValeurHist,   mais Valeur1 a été mis à jour trop tot...
        $efd3ba4ec2608b1d$var$Valeur1 = "off";
        //                          Valeur1 a été remis a off ci-haut pour réfleter le vrai passage de off à Valeur1Hist dans l appel qui suit
        //                          réactivation de Valeur1 à partir du menu et organisation des callback, fenetres
        $efd3ba4ec2608b1d$var$updateValeurFromMenu(1);
        $efd3ba4ec2608b1d$var$Valeur1Hist = "off";
    }
    if ($efd3ba4ec2608b1d$var$Valeur2Hist != "off" && !$efd3ba4ec2608b1d$var$L_Juxtapo) {
        //                                   si Valeur2Hist est autre que off,  alors Valeur2 est off et on va le réactiver
        //                                   réactivation du menu
        $efd3ba4ec2608b1d$var$resetMenuValeurs(2, $efd3ba4ec2608b1d$var$Valeur2Hist, "off", $efd3ba4ec2608b1d$var$ValeurSelect2);
        //                                    ici le menu a été réajusté à ValeurHist,   mais Valeur2 a été mis à jour trop tot...
        $efd3ba4ec2608b1d$var$Valeur2 = "off";
        //                          Valeur2 a été remis a off ci-haut pour réfleter le vrai passage de off à Valeur1Hist dans l appel qui suit
        //                          réactivation de Valeur1 à partir du menu et organisation des callback, fenetres
        $efd3ba4ec2608b1d$var$updateValeurFromMenu(2);
        $efd3ba4ec2608b1d$var$Valeur2Hist = "off";
    }
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$UnsetValeurs(no_) {
    //   no_ == 0  ou 1
    if (no_ != "2" && $efd3ba4ec2608b1d$var$Valeur1 != "off") {
        $efd3ba4ec2608b1d$var$Valeur1Hist = $efd3ba4ec2608b1d$var$Valeur1;
        $efd3ba4ec2608b1d$var$ValeurSelect1.options.selectedIndex = 0;
        $efd3ba4ec2608b1d$var$updateValeurFromMenu(1);
    }
    //   no_  == 0 ou 2
    if (no_ != "1" && $efd3ba4ec2608b1d$var$Valeur2 != "off") {
        $efd3ba4ec2608b1d$var$Valeur2Hist = $efd3ba4ec2608b1d$var$Valeur2;
        if ($efd3ba4ec2608b1d$var$Couche2Void) $efd3ba4ec2608b1d$var$Valeur2Hist = "off";
        $efd3ba4ec2608b1d$var$ValeurSelect2.options.selectedIndex = 0;
        $efd3ba4ec2608b1d$var$updateValeurFromMenu(2);
    }
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateValeurFromMenu(no) {
    var model_1 = $efd3ba4ec2608b1d$var$Couche1.getModele();
    var model_2 = $efd3ba4ec2608b1d$var$Couche2.getModele();
    $efd3ba4ec2608b1d$var$ActiveLoop = false;
    $efd3ba4ec2608b1d$var$StopAnimate();
    document.getElementById("StopAnimate").style.display = "none";
    document.getElementById("StartAnimate").style.display = "initial";
    document.getElementById("spot_iframe").style.display = "inherit";
    document.getElementById("spot_iframe").style.visibility = "hidden";
    var message = " Change valeur pour la couche  " + no.toString();
    console.log(message);
    const otherWrapper = document.getElementById("map_et_map2_wrapper");
    //      Before updating Valeur1 and Valeur2, 
    //      remove previous singleclick event
    //      and remove spotwx screen space if needed
    //map2
    if ($efd3ba4ec2608b1d$var$Valeur1 == "Popup" && no == "1") {
        $efd3ba4ec2608b1d$var$Popup1Overlay.setPosition(undefined);
        $efd3ba4ec2608b1d$var$Popup1Closer.blur();
        $efd3ba4ec2608b1d$var$map.un("singleclick", $efd3ba4ec2608b1d$var$ValeurClick);
        message = " Retire l action Popup pour singleClic  pour la couche  " + no.toString();
        console.log(message);
        clearInterval($efd3ba4ec2608b1d$var$RunToggleLgnd1);
        $efd3ba4ec2608b1d$var$RefreshLgnd(1);
    }
    if ($efd3ba4ec2608b1d$var$Valeur2 == "Popup" && no == "2") {
        $efd3ba4ec2608b1d$var$Popup2Overlay.setPosition(undefined);
        $efd3ba4ec2608b1d$var$Popup2Closer.blur();
        //map2-
        if ($efd3ba4ec2608b1d$var$L_Juxtapo) $efd3ba4ec2608b1d$var$map2.un("singleclick", $efd3ba4ec2608b1d$var$ValeurClick);
        else $efd3ba4ec2608b1d$var$map.un("singleclick", $efd3ba4ec2608b1d$var$ValeurClick);
        message = " Retire l action Popup pour singleClic  pour la couche  " + no.toString();
        console.log(message);
        clearInterval($efd3ba4ec2608b1d$var$RunToggleLgnd2);
        $efd3ba4ec2608b1d$var$RefreshLgnd(2);
    }
    if (($efd3ba4ec2608b1d$var$Valeur1 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur1 == "MeteoGrm" || $efd3ba4ec2608b1d$var$Valeur1 == "ProfVert" || $efd3ba4ec2608b1d$var$Valeur1 == "TimSer") && no == "1") {
        $efd3ba4ec2608b1d$var$Popup1Overlay.setPosition(undefined);
        $efd3ba4ec2608b1d$var$Popup1Closer.blur();
        $efd3ba4ec2608b1d$var$map.un("singleclick", $efd3ba4ec2608b1d$var$callSpotWX);
        message = " Retire l action affichage fenetre externe (TimeSer_e, MeteoGrm ou ProfVert  pour singleClic  pour la couche  " + no.toString();
        console.log(message);
    }
    if (($efd3ba4ec2608b1d$var$Valeur2 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur2 == "MeteoGrm" || $efd3ba4ec2608b1d$var$Valeur2 == "ProfVert" || $efd3ba4ec2608b1d$var$Valeur2 == "TimSer") && no == "2") {
        $efd3ba4ec2608b1d$var$Popup2Overlay.setPosition(undefined);
        $efd3ba4ec2608b1d$var$Popup2Closer.blur();
        if ($efd3ba4ec2608b1d$var$L_Juxtapo) $efd3ba4ec2608b1d$var$map2.un("singleclick", $efd3ba4ec2608b1d$var$callSpotWX);
        else $efd3ba4ec2608b1d$var$map.un("singleclick", $efd3ba4ec2608b1d$var$callSpotWX);
        message = " Retire l action affichage fenetre externe (TimeSer_e, MeteoGrm ou ProfVert  pour singleClic  pour la couche  " + no.toString();
        console.log(message);
    }
    if ($efd3ba4ec2608b1d$var$Valeur1 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur2 == "TimSer") {
        otherWrapper.style.width = "100%";
        document.getElementById("spot_wrapper").style.width = "0%";
        window.dispatchEvent(new Event("resize"));
    }
    if (no == 1) {
        // 2 valeurs
        //    ValeurSelect2.options.selectedIndex = 0;
        //     Valeur2 = "off";
        $efd3ba4ec2608b1d$var$Valeur1 = $efd3ba4ec2608b1d$var$ValeurSelect1.options[$efd3ba4ec2608b1d$var$ValeurSelect1.options.selectedIndex].value;
        message = " active l action Popup pour singleClic  pour la couche  " + no.toString();
        console.log(message);
        if ($efd3ba4ec2608b1d$var$Valeur1 == "Popup") $efd3ba4ec2608b1d$var$map.on("singleclick", $efd3ba4ec2608b1d$var$ValeurClick);
        else if ($efd3ba4ec2608b1d$var$Valeur1 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur1 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur1 == "MeteoGrm" || $efd3ba4ec2608b1d$var$Valeur1 == "ProfVert") $efd3ba4ec2608b1d$var$map.on("singleclick", $efd3ba4ec2608b1d$var$callSpotWX);
    } else if (no == 2) {
        // 2 valeurs
        //       ValeurSelect1.options.selectedIndex = 0;
        //       Valeur1 = "off";
        if ($efd3ba4ec2608b1d$var$Couche2Void) {
            $efd3ba4ec2608b1d$var$ValeurSelect2.options.selectedIndex = 0;
            console.log("Valeur d\xe9sactiv\xe9es.  La couche 2 est inactive (Voir menu Syst Prev)");
        }
        $efd3ba4ec2608b1d$var$Valeur2 = $efd3ba4ec2608b1d$var$ValeurSelect2.options[$efd3ba4ec2608b1d$var$ValeurSelect2.options.selectedIndex].value;
        if ($efd3ba4ec2608b1d$var$Valeur2 == "Popup") {
            if ($efd3ba4ec2608b1d$var$L_Juxtapo) $efd3ba4ec2608b1d$var$map2.on("singleclick", $efd3ba4ec2608b1d$var$ValeurClick);
            else $efd3ba4ec2608b1d$var$map.on("singleclick", $efd3ba4ec2608b1d$var$ValeurClick);
            message = " active l action Popup pour singleClick  pour la couche  " + no.toString();
            console.log(message);
        } else if ($efd3ba4ec2608b1d$var$Valeur2 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur2 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur2 == "MeteoGrm" || $efd3ba4ec2608b1d$var$Valeur2 == "ProfVert") {
            if ($efd3ba4ec2608b1d$var$L_Juxtapo) $efd3ba4ec2608b1d$var$map2.on("singleclick", $efd3ba4ec2608b1d$var$callSpotWX);
            else $efd3ba4ec2608b1d$var$map.on("singleclick", $efd3ba4ec2608b1d$var$callSpotWX);
            message = " active l action spotWx  pour singleClick  pour la couche  " + no.toString();
            console.log(message);
        }
    }
    // prepare and assign space on the screen for the spotwx graphs or meteogram graphs
    if ($efd3ba4ec2608b1d$var$Valeur1 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur2 == "TimSer") {
        const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        var w_spotwx = parseInt(Math.min(Math.max(viewwidth / 2, 500), 1220));
        if ((model_1 == "GDPS" || model_1 == "GDPSE" || model_1 == "GFS" || model_1 == "ECMWF") && $efd3ba4ec2608b1d$var$Valeur1 == "TimSer" || (model_2 == "GDPS" || model_2 == "GDPSE" || model_2 == "GFS" || model_2 == "ECMWF") && $efd3ba4ec2608b1d$var$Valeur2 == "TimSer") w_spotwx = parseInt(Math.min(Math.max(0.66 * viewwidth, 666), 1220));
        var w_maps = viewwidth - w_spotwx;
        if (viewwidth < 800) {
            w_spotwx = 100;
            w_maps = 100;
        } else {
            w_spotwx = parseInt(100. * parseFloat(w_spotwx) / parseFloat(viewwidth));
            w_maps = 100 - w_spotwx;
        }
        otherWrapper.style.width = w_maps.toString() + "%";
        document.getElementById("spot_wrapper").style.width = w_spotwx.toString() + "%";
        window.dispatchEvent(new Event("resize"));
        $efd3ba4ec2608b1d$var$map.updateSize();
        if ($efd3ba4ec2608b1d$var$L_Juxtapo) $efd3ba4ec2608b1d$var$map2.updateSize();
        //map2
        $efd3ba4ec2608b1d$var$RefreshSpotWx();
    // preload layers image prior to click for color extraction
    } else if ($efd3ba4ec2608b1d$var$Valeur1 == "Popup") {
        $efd3ba4ec2608b1d$var$RefreshValeur();
        if (!$efd3ba4ec2608b1d$var$Lgnd1Large) $efd3ba4ec2608b1d$var$showLgnd(1);
    } else if ($efd3ba4ec2608b1d$var$Valeur2 == "Popup") {
        $efd3ba4ec2608b1d$var$RefreshValeur();
        if (!$efd3ba4ec2608b1d$var$Lgnd2Large) $efd3ba4ec2608b1d$var$showLgnd(2);
    } else if ($efd3ba4ec2608b1d$var$Valeur1 != "off" || $efd3ba4ec2608b1d$var$Valeur2 != "off") $efd3ba4ec2608b1d$var$RefreshSpotWx();
}
//-----------------------------------------------------------------------------------------
//
var $efd3ba4ec2608b1d$var$LgndCanvas1 = false;
var $efd3ba4ec2608b1d$var$LgndCanvas2 = false;
var $efd3ba4ec2608b1d$var$RunToggleLgnd1 = setInterval(function() {
    $efd3ba4ec2608b1d$var$ToggleLgnd("1");
}, 10000);
var $efd3ba4ec2608b1d$var$RunToggleLgnd2 = setInterval(function() {
    $efd3ba4ec2608b1d$var$ToggleLgnd("2");
}, 10000);
clearInterval($efd3ba4ec2608b1d$var$RunToggleLgnd1);
clearInterval($efd3ba4ec2608b1d$var$RunToggleLgnd2);
let $efd3ba4ec2608b1d$var$MyWindow_ecmwf;
let $efd3ba4ec2608b1d$var$MyWindow_aifs;
let $efd3ba4ec2608b1d$var$MyWindow_gdps;
let $efd3ba4ec2608b1d$var$MyWindow_gefs;
let $efd3ba4ec2608b1d$var$MyWindow_rdps;
let $efd3ba4ec2608b1d$var$MyWindow_hrdps;
let $efd3ba4ec2608b1d$var$MyWindow_gfs;
//
/**
 * Elements that make up the popup.
 */ const $efd3ba4ec2608b1d$var$Popup1Container = document.getElementById("popup");
const $efd3ba4ec2608b1d$var$Popup1Content = document.getElementById("popup-content");
const $efd3ba4ec2608b1d$var$Popup1Closer = document.getElementById("popup-closer");
const $efd3ba4ec2608b1d$var$Popup1Hider = document.getElementById("popup-hider");
const $efd3ba4ec2608b1d$var$Popup2Container = document.getElementById("popup2");
const $efd3ba4ec2608b1d$var$Popup2Content = document.getElementById("popup2-content");
const $efd3ba4ec2608b1d$var$Popup2Closer = document.getElementById("popup2-closer");
const $efd3ba4ec2608b1d$var$Popup2Hider = document.getElementById("popup2-hider");
const $efd3ba4ec2608b1d$var$ImgValeur1 = new Image();
const $efd3ba4ec2608b1d$var$Canvas1 = document.createElement("canvas");
//const Canvas1Context = document.createElement('canvas0');
const $efd3ba4ec2608b1d$var$CanvasL1 = document.createElement("canvas");
$efd3ba4ec2608b1d$var$ImgValeur1.onload = function() {
    console.log("image Valeur 1 is loaded");
    $efd3ba4ec2608b1d$var$Canvas1.width = $efd3ba4ec2608b1d$var$ImgValeur1.width;
    $efd3ba4ec2608b1d$var$Canvas1.height = $efd3ba4ec2608b1d$var$ImgValeur1.height;
    $efd3ba4ec2608b1d$var$message = " Largeur: " + $efd3ba4ec2608b1d$var$Canvas1.width + " Hauteur: " + $efd3ba4ec2608b1d$var$Canvas1.height;
    console.log($efd3ba4ec2608b1d$var$message);
    $efd3ba4ec2608b1d$var$Canvas1.getContext("2d", {
        willReadFrequently: true
    }).drawImage($efd3ba4ec2608b1d$var$ImgValeur1, 0, 0, $efd3ba4ec2608b1d$var$ImgValeur1.width, $efd3ba4ec2608b1d$var$ImgValeur1.height);
    $efd3ba4ec2608b1d$var$message = " Canvas got the context";
    console.log($efd3ba4ec2608b1d$var$message);
    $efd3ba4ec2608b1d$var$UpdateToggleValeur("1");
};
const $efd3ba4ec2608b1d$var$ImgValeur2 = new Image();
const $efd3ba4ec2608b1d$var$Canvas2 = document.createElement("canvas");
const $efd3ba4ec2608b1d$var$CanvasL2 = document.createElement("canvas");
$efd3ba4ec2608b1d$var$ImgValeur2.onload = function() {
    console.log("image Valeur 2 is loaded");
    $efd3ba4ec2608b1d$var$Canvas2.width = $efd3ba4ec2608b1d$var$ImgValeur2.width;
    $efd3ba4ec2608b1d$var$Canvas2.height = $efd3ba4ec2608b1d$var$ImgValeur2.height;
    $efd3ba4ec2608b1d$var$message = " Largeur: " + $efd3ba4ec2608b1d$var$Canvas2.width + " Hauteur: " + $efd3ba4ec2608b1d$var$Canvas2.height;
    console.log($efd3ba4ec2608b1d$var$message);
    $efd3ba4ec2608b1d$var$Canvas2.getContext("2d", {
        willReadFrequently: true
    }).drawImage($efd3ba4ec2608b1d$var$ImgValeur2, 0, 0, $efd3ba4ec2608b1d$var$ImgValeur2.width, $efd3ba4ec2608b1d$var$ImgValeur2.height);
    $efd3ba4ec2608b1d$var$message = " Canvas got the context";
    console.log($efd3ba4ec2608b1d$var$message);
    $efd3ba4ec2608b1d$var$UpdateToggleValeur("2");
};
var $efd3ba4ec2608b1d$var$PopupLat = 45.0;
var $efd3ba4ec2608b1d$var$PopupLon = -73;
let $efd3ba4ec2608b1d$var$TuileZXY1 = [
    0,
    0,
    0
];
let $efd3ba4ec2608b1d$var$TuileZXY2 = [
    0,
    0,
    0
];
if ($efd3ba4ec2608b1d$var$WindMaps) {
    $efd3ba4ec2608b1d$var$PopupLat = localStorage.getItem("PopupLat_V");
    $efd3ba4ec2608b1d$var$PopupLon = localStorage.getItem("PopupLon_V");
} else {
    $efd3ba4ec2608b1d$var$PopupLat = localStorage.getItem("PopupLat");
    $efd3ba4ec2608b1d$var$PopupLon = localStorage.getItem("PopupLon");
    console.log(" local Items PopupLat: " + $efd3ba4ec2608b1d$var$PopupLat + " PopupLon: " + $efd3ba4ec2608b1d$var$PopupLon);
}
/**
 * Create overlays to anchor the popup to the maps.
 */ const $efd3ba4ec2608b1d$var$Popup1Overlay = new (0, $c80d3ed2a84f41ed$export$2e2bcd8739ae039)({
    element: $efd3ba4ec2608b1d$var$Popup1Container,
    autoPan: false,
    autoPanAnimation: {
        duration: 250
    }
});
const $efd3ba4ec2608b1d$var$Popup2Overlay = new (0, $c80d3ed2a84f41ed$export$2e2bcd8739ae039)({
    element: $efd3ba4ec2608b1d$var$Popup2Container,
    autoPan: false,
    autoPanAnimation: {
        duration: 250
    }
});
/**    Closer is here
 * Add a click handler to hide the popup.
 * @return {boolean} Don't follow the href.
 */ $efd3ba4ec2608b1d$var$Popup1Closer.onclick = function() {
    $efd3ba4ec2608b1d$var$UnsetValeurs("1");
    $efd3ba4ec2608b1d$var$Valeur1Hist = "off";
    return false;
};
$efd3ba4ec2608b1d$var$Popup2Closer.onclick = function() {
    $efd3ba4ec2608b1d$var$UnsetValeurs("2");
    $efd3ba4ec2608b1d$var$Valeur2Hist = "off";
    return false;
};
$efd3ba4ec2608b1d$var$Popup1Hider.onclick = function() {
    $efd3ba4ec2608b1d$var$Popup1Overlay.setPosition(undefined);
    $efd3ba4ec2608b1d$var$Popup1Hider.blur();
    return false;
};
$efd3ba4ec2608b1d$var$Popup2Hider.onclick = function() {
    $efd3ba4ec2608b1d$var$Popup2Overlay.setPosition(undefined);
    $efd3ba4ec2608b1d$var$Popup2Hider.blur();
    return false;
};
$efd3ba4ec2608b1d$var$map.addOverlay($efd3ba4ec2608b1d$var$Popup1Overlay);
$efd3ba4ec2608b1d$var$map.addOverlay($efd3ba4ec2608b1d$var$Popup2Overlay);
//map2 
///________________________________________________________________________________________
///________________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$getZLayerCoLayer(no_) {
    var message = "";
    var zDirection1_ = 1;
    var zDirection2_ = 1;
    var zDirection_ = 1;
    let seuil = 0;
    let zLayer = [
        0,
        0
    ];
    zLayer[0] = 0;
    zLayer[1] = zLayer[0];
    if (no_ == "1" || no_ == "2" && !$efd3ba4ec2608b1d$var$Couche2Void) {
        var viewResol = $efd3ba4ec2608b1d$var$map.getView().getResolution();
        const viewProj_ = $efd3ba4ec2608b1d$var$map.getView().getProjection().getCode();
        var coucheCoVoid = $efd3ba4ec2608b1d$var$Couche1CoVoid;
        var coucheProj_ = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$Couche1.zoomId);
        var resolutions_ = $efd3ba4ec2608b1d$var$Resolutions1;
        var resol_ = $efd3ba4ec2608b1d$var$Resolutions1;
        var resolutionsCo_ = $efd3ba4ec2608b1d$var$Resolutions1;
        var resolCo_ = $efd3ba4ec2608b1d$var$Resolutions1;
        if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) {
            resolutionsCo_ = $efd3ba4ec2608b1d$var$ResolutionsCo1;
            resolCo_ = $efd3ba4ec2608b1d$var$ResolutionsCo1;
        }
        if (no_ == "2" && !$efd3ba4ec2608b1d$var$Couche2Void) {
            zDirection_ = zDirection2_;
            resolutions_ = $efd3ba4ec2608b1d$var$Resolutions2;
            resol_ = $efd3ba4ec2608b1d$var$Resolutions2;
            coucheCoVoid = $efd3ba4ec2608b1d$var$Couche2CoVoid;
            resolutionsCo_ = $efd3ba4ec2608b1d$var$Resolutions2;
            resolCo_ = $efd3ba4ec2608b1d$var$Resolutions2;
            if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) {
                resolutionsCo_ = $efd3ba4ec2608b1d$var$ResolutionsCo2;
                resolCo_ = $efd3ba4ec2608b1d$var$ResolutionsCo2;
            }
            coucheProj_ = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$Couche2.zoomId);
        }
        if (viewProj_ != coucheProj_) {
            let coucheMPU = coucheProj_.getMetersPerUnit();
            let viewMPU = viewProj_.getMetersPerUnit();
            viewResol = viewResol * viewMPU / coucheMPU;
        }
        if (zDirection_ == -1) for(let iz = 1; iz <= resol_.length - 1; iz = iz + 1){
            seuil = resol_[iz - 1];
            if (viewResol < seuil) zLayer[0] = iz;
        }
        else if (zDirection_ == 0) for(let iz = 1; iz <= resol_.length - 1; iz = iz + 1){
            seuil = (resol_[iz - 1] + resol_[iz]) / 2;
            if (viewResol < seuil) zLayer[0] = iz;
        }
        else if (zDirection_ == 1) for(let iz = 1; iz <= resol_.length - 1; iz = iz + 1){
            seuil = resol_[iz];
            if (viewResol < seuil) zLayer[0] = iz;
        }
        if (!coucheCoVoid) {
            if (zDirection_ == -1) for(let iz = 1; iz <= resolCo_.length - 1; iz = iz + 1){
                seuil = resolCo_[iz - 1];
                if (viewResol < seuil) zLayer[1] = iz;
            }
            else if (zDirection_ == 0) for(let iz = 1; iz <= resolCo_.length - 1; iz = iz + 1){
                seuil = (resolCo_[iz - 1] + resolCo_[iz]) / 2;
                if (viewResol < seuil) zLayer[1] = iz;
            }
            else if (zDirection_ == 1) for(let iz = 1; iz <= resolCo_.length - 1; iz = iz + 1){
                seuil = resolCo_[iz];
                if (viewResol < seuil) zLayer[1] = iz;
            }
        } else zLayer[1] = -1;
    } else {
        zLayer[0] = -1;
        zLayer[1] = -1;
    }
    message = " getZLayerCoLayer--Zoom level layer: " + zLayer[0] + " and coLayer: " + zLayer[1];
    console.log(message);
    return zLayer;
}
///________________________________________________________________________________________
//
/////function getNuTileLoaded() {
/////var message ="";
/////let varNuTiles = [-1,-1,-1,-1];
///////const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
///////const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);                           
/////
// var viewnter = map.getView().getCenter();
/////var viewResol_ = map.getView().getResolution();
/////let viewExtent_ = map.getView().calculateExtent(map.getSize());
//    let viewZoom_ = map.getView().getZoom();
//let upperLeft[0] = viewCenter[0] - viewResol * viewwidth / 2;
//let upperLeft[1] = viewCenter[1] + viewResol * viewHeight /2;
//let lowerRight[0] = viewCenter[0] + viewResol * viewwidth / 2;
//let lowerRight[1] = viewCenter[1] - viewResol * viewHeight /2;
/////let resolutions_ = Resolutions1;
/////let coucheExtent_ = ZoomToExtent.get( Couche1.zoomId );
/////let coucheProj_ = ZoomToProjec.get( Couche1.zoomId ) ;
/////let coucheModeleZoom_ = Couche1.modeleZoom;
/////let zoomTuile_ = 0;
/////if ( no_ == "2" ) {
/////resolutions_ = Resolutions2;
/////coucheExtent_ = ZoomToExtent.get( Couche2.zoomId );
/////coucheProj_ = ZoomToProjec.get( Couche2.zoomId ) ;
/////coucheModeleZoom = Couche2.modeleZoom;
/////if ( coucheProj_ != viewProj_) { coucheExtent_ = transformExtent(coucheExtent_, coucheProj_, viewProj_); }
/////}
/////let viewProj_ = map.getView().getProjection();
/////if ( viewProj_ == coucheProj_ ) {
/////var  coucheResol=resolutions_[0];
/////var diffMoin = Math.abs(resolutions_[0] - viewResol );
/////var diffPlus; 
/////for ( let iz=1 ; iz <= (resolutions_.length-1) ; iz = iz + 1) { 
/////diffPlus = Math.abs(resolutions_[iz] - viewResol); 
/////if ( diffPlus < diffMoin ) { 
/////coucheResol = resolutions_[iz];
/////zoomTuile_ = iz;
/////diffMoin = diffPlus;
/////}
/////}
/////message =  " -- from Resolution array :  closest Zoom level " + zoomTuile + " and closest Resol: " + coucheResol;
/////console.log(message);
/////// minlon = extent_[0]=West; minlat = extent_[1]=Sud; maxlon = extent_[2]=Est; maxlat = extent_[3]=Nord; 
/////var deltaPix = (viewExtent_[0] - coucheExtent_[0])/coucheResol;
/////if ( deltaPix <= 0 ) { 
/////west_ = 0;
/////} else {
/////west_ = Math.floor( deltaPix/ModToDimX.get(coucheModeleZoom) ); 
/////}
///////maxlon = extent_[2]=Est
/////deltaPix = (coucheExtent_[2] - viewExtent_[2])/coucheResol;
/////if ( deltaPix <= 0 ) { 
/////est_ = Math.pow(2, zoomTuile_);
/////} else {
/////est_ = Math.floor( deltaPix/ModToDimX.get(coucheModeleZoom) ); 
/////}
/////// minlat = extent_[1]=Sud; maxlat = extent_[3]=Nord; 
/////var deltaPix = (viewExtent_[1] - coucheExtent_[1])/coucheResol;
/////if ( deltaPix <= 0 ) { 
/////sud_ = Math.pow(2, zoomTuile_);
/////} else {
/////sud_ = Math.floor( deltaPix/ModToDimY.get(coucheModeleZoom) ); 
/////}
/////// minlat = extent_[1]=Sud; maxlat = extent_[3]=Nord; 
/////deltaPix = (coucheExtent_[3] - viewExtent_[3])/coucheResol;
/////if ( deltaPix <= 0 ) { 
/////nord_ = 0;
/////} else {
/////nord_ = Math.floor( deltaPix/ModToDimX.get(coucheModeleZoom) ); 
/////}
/////var est_west_ = est_ - west;
/////var sud_nord = sud_ - nord_;
/////message = " Nomber of horizontal tiles: " + est_west_;
/////console.log(message);
/////message = " Nomber of vertical tiles: " + sud_nord;
/////console.log(message);
/////varNuTiles[0] = est_west * sud_nord;
/////} 
/////return varNuTiles
/////}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$CountTilesInView(no_) {
    //
    var viewExtent_ = $efd3ba4ec2608b1d$var$map.getView().calculateExtent($efd3ba4ec2608b1d$var$map.getSize());
    var viewProj_ = $efd3ba4ec2608b1d$var$map.getView().getProjection();
    var message = "";
    let nu = [
        0,
        0
    ];
    var nTiles_ = 0;
    var tileHorWidth = 0;
    var tileVerHeight = 0;
    // minlon = extent_[0]=West; minlat = extent_[1]=Sud; maxlon = extent_[2]=Est; maxlat = extent_[3]=Nord; 
    var coucheExtent_ = $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$Couche1.zoomId);
    var coucheProj_ = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$Couche1.zoomId);
    if (no_ == 2 && !$efd3ba4ec2608b1d$var$Couche2Void) {
        coucheExtent_ = $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$Couche2.zoomId);
        coucheProj_ = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$Couche2.zoomId);
    }
    var tuileExtent_ = coucheExtent_;
    var west_ = coucheExtent_[0];
    var sud_ = coucheExtent_[1];
    if (no_ == 1 || no_ == 2 && !$efd3ba4ec2608b1d$var$Couche2Void) {
        let zLevel_ = $efd3ba4ec2608b1d$var$getZLayerCoLayer(no_);
        for(let ii_ = 0; ii_ <= 1; ii_ = ii_ + 1)if (zLevel_[ii_] >= 0) {
            nTiles_ = Math.pow(2, zLevel_[ii_]);
            tileHorWidth = (coucheExtent_[2] - coucheExtent_[0]) / nTiles_;
            tileVerHeight = (coucheExtent_[3] - coucheExtent_[1]) / nTiles_;
            for(let iTileY = 0; iTileY <= nTiles_ - 1; iTileY = iTileY + 1)for(let iTileX = 0; iTileX <= nTiles_ - 1; iTileX = iTileX + 1){
                west_ = coucheExtent_[0] + iTileX * tileHorWidth;
                sud_ = coucheExtent_[1] + iTileY * tileVerHeight;
                tuileExtent_ = [
                    west_,
                    sud_,
                    west_ + tileHorWidth,
                    sud_ + tileVerHeight
                ];
                if (coucheProj_ != viewProj_) tuileExtent_ = (0, $9c4744460e43e41b$export$751c68e0e0efff79)(tuileExtent_, coucheProj_, viewProj_);
                if ($efd3ba4ec2608b1d$var$IsCoucheExtentInExtent(viewExtent_, tuileExtent_)) {
                    //message=" viewExtent: " + viewExtent_;
                    //console.log(message);
                    //message=" tuileExtent : " + tuileExtent_;
                    //console.log(message);
                    message = " tile XY no: " + iTileX + " , " + iTileY + " is in view";
                    //console.log(message);
                    nu[ii_] = nu[ii_] + 1;
                } else message = " tile XY no: " + iTileX + " , " + iTileY + " is not in view";
            }
        } else nu[ii_] = -1;
    } else {
        nu[0] = -1;
        nu[1] = -1;
    }
    return nu;
}
///________________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$LonLat2ZXY(what, no_) {
    //  what peut etre les coordonnée de la tuile en Z Y et X (nombres entiers)  qui identifie l image contenant les Lon et Lat du popup
    //  what peut aussi etre les coordonnée en pixelles a l intérieur de la tuile (l Image) 
    var message = "";
    let varZXY = [
        0,
        0,
        0
    ];
    let popupProj = [
        0,
        0
    ];
    var viewResol = $efd3ba4ec2608b1d$var$map.getView().getResolution();
    message = " -- Resolution from view : " + viewResol;
    console.log(message);
    let resolutions_ = $efd3ba4ec2608b1d$var$Resolutions1;
    let coucheExtent_ = $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$Couche1.zoomId);
    let coucheProj_ = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$Couche1.zoomId);
    let coucheModeleZoom = $efd3ba4ec2608b1d$var$Couche1.modeleZoom;
    if (no_ == "2" && $efd3ba4ec2608b1d$var$Valeur2 == "Popup") {
        resolutions_ = $efd3ba4ec2608b1d$var$Resolutions2;
        coucheExtent_ = $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$Couche2.zoomId);
        coucheProj_ = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$Couche2.zoomId);
        coucheModeleZoom = $efd3ba4ec2608b1d$var$Couche2.modeleZoom;
    }
    if (no_ == "2" && $efd3ba4ec2608b1d$var$Valeur2 == "Popup" || no_ == "1" && $efd3ba4ec2608b1d$var$Valeur1 == "Popup") {
        var coucheResol = resolutions_[0];
        varZXY[0] = 0;
        let zLevel_ = $efd3ba4ec2608b1d$var$getZLayerCoLayer(no_);
        varZXY[0] = zLevel_[0];
        let coucheResol1 = resolutions_[varZXY[0]];
        message = " -- Zoom level " + varZXY[0] + " and Layer Resol: " + coucheResol1;
        console.log(message);
        if (coucheProj_ != "EPSG:4326") popupProj = (0, $9c4744460e43e41b$export$51186ad6e864892a)([
            $efd3ba4ec2608b1d$var$PopupLon,
            $efd3ba4ec2608b1d$var$PopupLat
        ], "EPSG:4326", coucheProj_);
        // minlon = extent_[0]=West; minlat = extent_[1]=Sud; maxlon = extent_[2]=Est; maxlat = extent_[3]=Nord; 
        var deltaPixLon = (popupProj[0] - coucheExtent_[0]) / coucheResol1;
        var deltaPixLat = (coucheExtent_[3] - popupProj[1]) / coucheResol1;
        message = " Nomber of pixels from western limit: " + deltaPixLon;
        console.log(message);
        message = " Nomber of pixels from Northern limit: " + deltaPixLat;
        console.log(message);
        var tileSizeNX = $efd3ba4ec2608b1d$var$ModToDimX.get(coucheModeleZoom);
        var tileSizeNY = $efd3ba4ec2608b1d$var$ModToDimY.get(coucheModeleZoom);
        message = " -- From couche no " + no_ + "  TileSize w et h : " + tileSizeNX + " " + tileSizeNY;
        console.log(message);
        varZXY[1] = Math.floor(deltaPixLon / tileSizeNX);
        varZXY[2] = Math.floor(deltaPixLat / tileSizeNY);
        message = " -- coord of tile Z, Y, X: " + varZXY;
        console.log(message);
        if (what == "pixelles") {
            varZXY[1] = parseInt(deltaPixLon % tileSizeNX);
            varZXY[2] = parseInt(deltaPixLat % tileSizeNY);
            message = " -- pixels ii and jj :  " + varZXY[1] + " " + varZXY[2];
            console.log(message);
        }
        return varZXY;
    } else return [
        0,
        0,
        0
    ];
}
///________________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$ImgValeurLoad(no_) {
    var message = "";
    if (no_ == "1" && $efd3ba4ec2608b1d$var$Valeur1 == "Popup") {
        $efd3ba4ec2608b1d$var$TuileZXY1 = $efd3ba4ec2608b1d$var$LonLat2ZXY("tuiles", "1");
        var newString = $efd3ba4ec2608b1d$var$listUrl1[$efd3ba4ec2608b1d$var$ISTEP] + "/" + $efd3ba4ec2608b1d$var$TuileZXY1[0] + "/" + $efd3ba4ec2608b1d$var$TuileZXY1[1] + "/" + $efd3ba4ec2608b1d$var$TuileZXY1[2] + ".png";
        message = " -- Image Valeur 1: " + newString + "  loading";
        console.log(message);
        $efd3ba4ec2608b1d$var$ImgValeur1.src = newString;
    }
    if (no_ == "2" && $efd3ba4ec2608b1d$var$Valeur2 == "Popup") {
        $efd3ba4ec2608b1d$var$TuileZXY2 = $efd3ba4ec2608b1d$var$LonLat2ZXY("tuiles", "2");
        var newString = $efd3ba4ec2608b1d$var$listUrl2[$efd3ba4ec2608b1d$var$ISTEP] + "/" + $efd3ba4ec2608b1d$var$TuileZXY2[0] + "/" + $efd3ba4ec2608b1d$var$TuileZXY2[1] + "/" + $efd3ba4ec2608b1d$var$TuileZXY2[2] + ".png";
        message = " -- Image Valeur 2: " + newString + "  loading";
        console.log(message);
        $efd3ba4ec2608b1d$var$ImgValeur2.src = newString;
    }
}
///________________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$UpdatePopupValeur(evt) {
    var message = "";
    // get the click  lat&lon and display the popup
    var lon_lat = (0, $9c4744460e43e41b$export$51186ad6e864892a)(evt.coordinate, evt.map.getView().getProjection(), "EPSG:4326");
    $efd3ba4ec2608b1d$var$PopupLon = lon_lat[0].toFixed(3);
    $efd3ba4ec2608b1d$var$PopupLat = lon_lat[1].toFixed(3);
    //map2
    if ($efd3ba4ec2608b1d$var$WindMaps) {
        localStorage.setItem("PopupLat_V", $efd3ba4ec2608b1d$var$PopupLat);
        localStorage.setItem("PopupLon_V", $efd3ba4ec2608b1d$var$PopupLon);
    } else {
        localStorage.setItem("PopupLat", $efd3ba4ec2608b1d$var$PopupLat);
        localStorage.setItem("PopupLon", $efd3ba4ec2608b1d$var$PopupLon);
    }
    message = " <br> Lat et Lon: " + $efd3ba4ec2608b1d$var$PopupLat + " " + $efd3ba4ec2608b1d$var$PopupLon + " <br> Valeur ";
    console.log(message);
    if ($efd3ba4ec2608b1d$var$Image1_est_visible && $efd3ba4ec2608b1d$var$Valeur1 == "Popup") {
        $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = message + " 1 ...;";
        $efd3ba4ec2608b1d$var$Popup1Overlay.setPosition(evt.coordinate);
    } else if ($efd3ba4ec2608b1d$var$Valeur1 == "Popup") {
        message = message + " 1: couche invisible";
        $efd3ba4ec2608b1d$var$Popup1Overlay.setPosition(undefined);
    }
    if ($efd3ba4ec2608b1d$var$Image2_est_visible && $efd3ba4ec2608b1d$var$Valeur2 == "Popup") {
        $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = message + " 2 ...";
        $efd3ba4ec2608b1d$var$Popup2Overlay.setPosition(evt.coordinate);
    } else if ($efd3ba4ec2608b1d$var$Valeur2 == "Popup") {
        message = message + " 2: couche invisible";
        $efd3ba4ec2608b1d$var$Popup2Overlay.setPosition(undefined);
    }
    return message;
}
///________________________________________________________________________________________
//
//
function $efd3ba4ec2608b1d$var$RefreshPopupValeur(no_) {
    var message = "";
    if ($efd3ba4ec2608b1d$var$Valeur1 == "Popup" && no_ == "1") {
        var viewProj_ = $efd3ba4ec2608b1d$var$map.getView().getProjection();
        var coord_ = [
            $efd3ba4ec2608b1d$var$PopupLon,
            $efd3ba4ec2608b1d$var$PopupLat
        ];
        if (viewProj_ != "EPSG:4326") coord_ = (0, $9c4744460e43e41b$export$51186ad6e864892a)([
            $efd3ba4ec2608b1d$var$PopupLon,
            $efd3ba4ec2608b1d$var$PopupLat
        ], "EPSG:4326", viewProj_);
        if ($efd3ba4ec2608b1d$var$Image1_est_visible) {
            message = " <br> lat et lon: " + $efd3ba4ec2608b1d$var$PopupLat + " " + $efd3ba4ec2608b1d$var$PopupLon + " <br> Valeur 1:...";
            $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = message;
            $efd3ba4ec2608b1d$var$Popup1Overlay.setPosition(coord_);
        } else {
            message = message + " <br> refresh Valeur 1: couche invisible...";
            console.log(message);
            $efd3ba4ec2608b1d$var$Popup1Overlay.setPosition(undefined);
        }
    }
    if ($efd3ba4ec2608b1d$var$Valeur2 == "Popup" && no_ == "2") {
        var viewProj_ = $efd3ba4ec2608b1d$var$map.getView().getProjection();
        var coord_ = [
            $efd3ba4ec2608b1d$var$PopupLon,
            $efd3ba4ec2608b1d$var$PopupLat
        ];
        if (viewProj_ != "EPSG:4326") coord_ = (0, $9c4744460e43e41b$export$51186ad6e864892a)([
            $efd3ba4ec2608b1d$var$PopupLon,
            $efd3ba4ec2608b1d$var$PopupLat
        ], "EPSG:4326", viewProj_);
        if ($efd3ba4ec2608b1d$var$Image2_est_visible) {
            message = " <br> lat et lon: " + $efd3ba4ec2608b1d$var$PopupLat + " " + $efd3ba4ec2608b1d$var$PopupLon + " <br> Valeur 2...";
            $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = message;
            $efd3ba4ec2608b1d$var$Popup2Overlay.setPosition(coord_);
        } else {
            message = message + " <br> refresh Valeur 2: couche invisible...";
            console.log(message);
            $efd3ba4ec2608b1d$var$Popup2Overlay.setPosition(undefined);
        }
    }
    return message;
}
///________________________________________________________________________________________
//
//
function $efd3ba4ec2608b1d$var$ValeurClick(evt) {
    var message = " ";
    var messagePop = " ";
    if ($efd3ba4ec2608b1d$var$Valeur1 == "Popup" || $efd3ba4ec2608b1d$var$Valeur2 == "Popup") messagePop = $efd3ba4ec2608b1d$var$UpdatePopupValeur(evt);
    if ($efd3ba4ec2608b1d$var$Valeur1 == "Popup") {
        let sameTile = true;
        let tileZXY_ = $efd3ba4ec2608b1d$var$LonLat2ZXY("tuile", "1");
        for(let ii = 0; ii < tileZXY_.length; ii = ii + 1)if (tileZXY_[ii] != $efd3ba4ec2608b1d$var$TuileZXY1[ii]) sameTile = false;
        message = " Check if Tile 1 has changed. Old: ZXY " + $efd3ba4ec2608b1d$var$TuileZXY1 + " new ZXY: " + tileZXY_ + " sameTile: " + sameTile;
        console.log(message);
        if (!sameTile) {
            message = " Tile has changed,  need to reload new tile: ";
            console.log(message);
            $efd3ba4ec2608b1d$var$ImgValeurLoad("1");
        } else if ($efd3ba4ec2608b1d$var$ImgValeur1.complete) $efd3ba4ec2608b1d$var$UpdateToggleValeur("1");
        else {
            message = messagePop + " <br> lecture de l image 1 non complet\xe9e, (avancez et reculez, ou recliquz) ";
            $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = message;
        }
    }
    message = " ";
    if ($efd3ba4ec2608b1d$var$Valeur2 == "Popup") {
        let sameTile = true;
        let tileZXY_ = $efd3ba4ec2608b1d$var$LonLat2ZXY("tuile", "2");
        for(let ii = 0; ii < tileZXY_.length; ii = ii + 1)if (tileZXY_[ii] != $efd3ba4ec2608b1d$var$TuileZXY2[ii]) sameTile = false;
        message = " Check if Tile 2 has changed. Old: ZXY " + $efd3ba4ec2608b1d$var$TuileZXY2 + " new ZXY: " + tileZXY_ + " sameTile: " + sameTile;
        console.log(message);
        if (!sameTile) {
            message = " Tile has changed,  need to reload new tile: ";
            console.log(message);
            $efd3ba4ec2608b1d$var$ImgValeurLoad("2");
        } else if ($efd3ba4ec2608b1d$var$ImgValeur2.complete) $efd3ba4ec2608b1d$var$UpdateToggleValeur("2");
        else {
            message = messagePop + " <br> lecture de l image 2 non complet\xe9e, (avancez et reculez, ou recliquz) ";
            $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = message;
        }
    }
}
///________________________________________________________________________________________
//
//
function $efd3ba4ec2608b1d$var$RefreshValeur() {
    if ($efd3ba4ec2608b1d$var$Valeur1 == "Popup") {
        var message = $efd3ba4ec2608b1d$var$RefreshPopupValeur("1");
        message = message + " <br> lecture de l image 1 est en cours,  patientez SVP! ";
        $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = message;
        $efd3ba4ec2608b1d$var$ImgValeurLoad("1");
    }
    if ($efd3ba4ec2608b1d$var$Valeur2 == "Popup") {
        var message = $efd3ba4ec2608b1d$var$RefreshPopupValeur("2");
        message = message + " <br> lecture de l image 2 est en cours,  patientez SVP! ";
        $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = message;
        $efd3ba4ec2608b1d$var$ImgValeurLoad("2");
    }
}
///________________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$ToggleLgnd(no_) {
    if (no_ == "1" && $efd3ba4ec2608b1d$var$Valeur1 == "Popup" && $efd3ba4ec2608b1d$var$LgndCanvas1) {
        $efd3ba4ec2608b1d$var$RefreshLgnd(1);
        $efd3ba4ec2608b1d$var$LgndCanvas1 = false;
    } else if (no_ == "1" && $efd3ba4ec2608b1d$var$Valeur1 == "Popup") {
        $efd3ba4ec2608b1d$var$lgnd1Img.src = $efd3ba4ec2608b1d$var$CanvasL1.toDataURL("image/png");
        $efd3ba4ec2608b1d$var$LgndCanvas1 = true;
    }
    if (no_ == "2" && $efd3ba4ec2608b1d$var$Valeur2 == "Popup" && $efd3ba4ec2608b1d$var$LgndCanvas2) {
        $efd3ba4ec2608b1d$var$RefreshLgnd(2);
        $efd3ba4ec2608b1d$var$LgndCanvas2 = false;
    } else if (no_ == "2" && $efd3ba4ec2608b1d$var$Valeur2 == "Popup") {
        $efd3ba4ec2608b1d$var$lgnd2Img.src = $efd3ba4ec2608b1d$var$CanvasL2.toDataURL("image/png");
        $efd3ba4ec2608b1d$var$LgndCanvas2 = true;
    }
}
///________________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$UpdateToggleValeur(no_) {
    var message = "";
    var messageRGB = "";
    var messagePop = "";
    var imgWidth = 0;
    var imgHeight = 0;
    var mapid = $efd3ba4ec2608b1d$var$Couche1.getMapIdH();
    var interval = $efd3ba4ec2608b1d$var$Couche1.getInterval();
    if (no_ == "1" && $efd3ba4ec2608b1d$var$Valeur1 != "Popup") {
        message = " Valuer 1 n est pas activ\xe9...";
        console.log(message);
        return;
    }
    if (no_ == "2" && $efd3ba4ec2608b1d$var$Valeur2 != "Popup") {
        message = " Valuer 2 n est pas activ\xe9...";
        console.log(message);
        return;
    }
    // stop the toggling of legend &modified legend  and refresh the unmodified legend
    if (no_ == "1") {
        clearInterval($efd3ba4ec2608b1d$var$RunToggleLgnd1);
        $efd3ba4ec2608b1d$var$LgndCanvas1 = true;
        $efd3ba4ec2608b1d$var$ToggleLgnd(no_);
        if (!$efd3ba4ec2608b1d$var$Image1_est_visible) {
            message = message + " <br> Valeurs Popup activ\xe9es pour la couche1 qui est invisible...";
            $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = message;
            console.log(message);
            return;
        } else if (!$efd3ba4ec2608b1d$var$ImgValeur1.complete) {
            message = " <br> lecture de l image non complet\xe9e ! (avancez puis reculez pour revenir sur l image) ";
            $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = message;
            console.log(message);
            return;
        }
        imgWidth = $efd3ba4ec2608b1d$var$ImgValeur1.width;
        imgHeight = $efd3ba4ec2608b1d$var$ImgValeur1.height;
    } else if (no_ == "2") {
        mapid = $efd3ba4ec2608b1d$var$Couche2.getMapIdH();
        interval = $efd3ba4ec2608b1d$var$Couche2.getInterval();
        clearInterval($efd3ba4ec2608b1d$var$RunToggleLgnd2);
        $efd3ba4ec2608b1d$var$LgndCanvas2 = true;
        $efd3ba4ec2608b1d$var$ToggleLgnd(no_);
        if (!$efd3ba4ec2608b1d$var$Image2_est_visible) {
            message = message + " <br> Valeurs Popup activ\xe9es pour la couche1 qui est invisible...";
            $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = message;
            console.log(message);
            return;
        } else if (!$efd3ba4ec2608b1d$var$ImgValeur2.complete) {
            message = " <br> lecture de l image non complet\xe9e ! (avancez puis reculez pour revenir sur l image) ";
            $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = message;
            console.log(message);
            return;
        }
        imgWidth = $efd3ba4ec2608b1d$var$ImgValeur2.width;
        imgHeight = $efd3ba4ec2608b1d$var$ImgValeur2.height;
    }
    ///   Ici si une image n'a pas la dimension de la trame de tuile.....
    ///   prendre en considereation  imgWidth   et imgHeight.... ci-haut pour corriger le PosJ et PosI
    let varZXY = $efd3ba4ec2608b1d$var$LonLat2ZXY("pixelles", no_);
    let PosJ = varZXY[2];
    let PosI = varZXY[1];
    message = "J: " + PosJ + " I: " + PosI;
    console.log(message);
    if (PosI < 1 || PosJ < 1 || PosI > imgWidth - 1 || PosJ > imgHeight - 1) {
        message = " <br> click \xe0 l'ext\xe9rieur de la superfie de la couche " + no_;
        messagePop = message;
        if (no_ == "1") $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = messagePop;
        else if (no_ == "2") $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = messagePop;
        console.log(message);
        return;
    }
    if (mapid.indexOf("WDIR") != -1) {
        message = " <br> Valeurs Popup ne fonctionne pas en pr\xe9sence de fl\xe8ches de vents.  Activez Popup pour une autre carte. ";
        messagePop = message;
        if (no_ == "1") $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = messagePop;
        else if (no_ == "2") $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = messagePop;
        console.log(message);
        return;
    }
    ////    context = canvas.getContext('2d' [, { [ alpha: true ] [, desynchronized: false ] [, colorSpace: 'srgb'] [, willReadFrequently: false ]} ])
    ////    Returns a CanvasRenderingContext2D object that is permanently bound to a particular canvas element.
    ////    If the alpha member is false, then the context is forced to always be opaque.
    ////    If the desynchronized member is true, then the context might be desynchronized.
    ////    The colorSpace member specifies the color space of the rendering context.
    ////    If the willReadFrequently member is true, then the context is marked for readback optimization.
    ///Canvas.width = ImgValeur.width;
    ///Canvas.height = ImgValeur.height;
    ///message = " Largeur: " + Canvas.width + " Hauteur: " + Canvas.height + " Nombre: "; console.log(message);
    ///Canvas.getContext('2d', { willReadFrequently: true }).drawImage(ImgValeur,0,0,ImgValeur.width, ImgValeur.height);
    // extract the pixel clicked colors
    let pixelData = [];
    let CanvasLdata = [];
    if (no_ == "1") {
        //Canvas1.width  = imgWidth;
        //Canvas1.height = imgHeight;
        //message = " Largeur: " + Canvas1.width + " Hauteur: " + Canvas1.height; console.log(message);
        //Canvas1.getContext('2d', { willReadFrequently: true }).drawImage(ImgValeur1,0,0,imgWidth, imgHeight);
        //message = " Canvas got the context" ; console.log(message);
        pixelData = $efd3ba4ec2608b1d$var$Canvas1.getContext("2d", {
            willReadFrequently: true
        }).getImageData(PosI, PosJ, 1, 1).data;
        message = "R: " + pixelData[0] + " G: " + pixelData[1] + " B: " + pixelData[2] + " O: " + pixelData[3];
        console.log(message);
        message = " pixelle data length: " + pixelData.length;
        console.log(message);
        // prepare Legend Canvas assign Legend image and color data
        $efd3ba4ec2608b1d$var$showLgnd(1);
        $efd3ba4ec2608b1d$var$showLgnd(1);
        $efd3ba4ec2608b1d$var$CanvasL1.width = $efd3ba4ec2608b1d$var$lgnd1Img.naturalWidth;
        $efd3ba4ec2608b1d$var$CanvasL1.height = $efd3ba4ec2608b1d$var$lgnd1Img.naturalHeight;
        $efd3ba4ec2608b1d$var$CanvasL1.getContext("2d", {
            willReadFrequently: true
        }).drawImage($efd3ba4ec2608b1d$var$lgnd1Img, 0, 0, $efd3ba4ec2608b1d$var$lgnd1Img.naturalWidth, $efd3ba4ec2608b1d$var$lgnd1Img.naturalHeight);
        CanvasLdata = $efd3ba4ec2608b1d$var$CanvasL1.getContext("2d").getImageData(0, 0, $efd3ba4ec2608b1d$var$lgnd1Img.naturalWidth, $efd3ba4ec2608b1d$var$lgnd1Img.naturalHeight);
        message = " Largeur: " + $efd3ba4ec2608b1d$var$CanvasL1.width + " Hauteur: " + $efd3ba4ec2608b1d$var$CanvasL1.height + " Nombre: " + CanvasLdata.data.length;
        console.log(message);
    } else if (no_ == "2") {
        //Canvas2.width  = imgWidth;
        //Canvas2.height = imgHeight;
        //message = " Largeur: " + Canvas2.width + " Hauteur: " + Canvas2.height; console.log(message);
        //Canvas2.getContext('2d', { willReadFrequently: true }).drawImage(ImgValeur2,0,0,imgWidth, imgHeight);
        //message = " Canvas got the context" ; console.log(message);
        pixelData = $efd3ba4ec2608b1d$var$Canvas2.getContext("2d", {
            willReadFrequently: true
        }).getImageData(PosI, PosJ, 1, 1).data;
        message = "R: " + pixelData[0] + " G: " + pixelData[1] + " B: " + pixelData[2] + " O: " + pixelData[3];
        console.log(message);
        message = " pixelle data length: " + pixelData.length;
        console.log(message);
        // prepare Legend Canvas assign Legend image and color data
        $efd3ba4ec2608b1d$var$showLgnd(2);
        $efd3ba4ec2608b1d$var$showLgnd(2);
        $efd3ba4ec2608b1d$var$CanvasL2.width = $efd3ba4ec2608b1d$var$lgnd2Img.naturalWidth;
        $efd3ba4ec2608b1d$var$CanvasL2.height = $efd3ba4ec2608b1d$var$lgnd2Img.naturalHeight;
        $efd3ba4ec2608b1d$var$CanvasL2.getContext("2d", {
            willReadFrequently: true
        }).drawImage($efd3ba4ec2608b1d$var$lgnd2Img, 0, 0, $efd3ba4ec2608b1d$var$lgnd2Img.naturalWidth, $efd3ba4ec2608b1d$var$lgnd2Img.naturalHeight);
        CanvasLdata = $efd3ba4ec2608b1d$var$CanvasL2.getContext("2d").getImageData(0, 0, $efd3ba4ec2608b1d$var$lgnd2Img.naturalWidth, $efd3ba4ec2608b1d$var$lgnd2Img.naturalHeight);
        message = " Largeur: " + $efd3ba4ec2608b1d$var$CanvasL2.width + " Hauteur: " + $efd3ba4ec2608b1d$var$CanvasL2.height + " Nombre: " + CanvasLdata.data.length;
        console.log(message);
    }
    message = " data:  " + CanvasLdata.data[CanvasLdata.data.length / 2];
    console.log(message);
    //  look for a match between the layer's click color (pixelData) throughout the legend pixels and assign black color if match is close enough
    var trouve = false;
    var precision = 10;
    if (mapid == "HGT_500_TCDC_") precision = 5;
    var precisionOpacite = 30;
    if (pixelData[0] < 10 && pixelData[1] < 10 && pixelData[2] < 10) {
        message = "  Couleur absente ";
        message = message + " " + pixelData[0] + " " + pixelData[1] + " " + pixelData[2];
        console.log(message);
        messagePop = " <br> Couleur absente  <br>  Possiblement une valeur sous le seuil le plus bas. ";
    } else if (pixelData[0] > 250 && pixelData[1] > 250 && pixelData[2] > 250) {
        message = " Couleur ambigue ";
        message = message + " " + pixelData[0] + " " + pixelData[1] + " " + pixelData[2];
        console.log(message);
        messagePop = " <br> Couleur ambigue  <br>  Possiblement pr\xe8s d'un contour,  veuillez essayer sur une pixelle voisine. ";
    } else {
        for(var i = 0; i < CanvasLdata.data.length; i += 4){
            if (Math.abs(pixelData[0] - parseInt(CanvasLdata.data[i])) < precision) {
                if (Math.abs(pixelData[1] - parseInt(CanvasLdata.data[i + 1])) < precision) {
                    if (Math.abs(pixelData[2] - parseInt(CanvasLdata.data[i + 2])) < precision) {
                        if (Math.abs(pixelData[3] - parseInt(CanvasLdata.data[i + 3])) < precisionOpacite) {
                            CanvasLdata.data[i] = "0";
                            CanvasLdata.data[i + 1] = "0";
                            CanvasLdata.data[i + 2] = "0";
                            CanvasLdata.data[i + 3] = "255";
                            trouve = true;
                        }
                    }
                }
            }
        }
        if (trouve) {
            if (no_ == "1") {
                //  assign the modifified legend colors back into the Legend Canvas
                $efd3ba4ec2608b1d$var$CanvasL1.getContext("2d").putImageData(CanvasLdata, 0, 0);
                //  trigger a toggle display of the original lgend and the modified legend ( Legend Canavas)
                $efd3ba4ec2608b1d$var$LgndCanvas1 = false;
                $efd3ba4ec2608b1d$var$RunToggleLgnd1 = setInterval(function() {
                    $efd3ba4ec2608b1d$var$ToggleLgnd("1");
                }, 250);
            } else {
                //  assign the modifified legend colors back into the Legend Canvas
                $efd3ba4ec2608b1d$var$CanvasL2.getContext("2d").putImageData(CanvasLdata, 0, 0);
                //  trigger a toggle display of the original lgend and the modified legend ( Legend Canavas)
                $efd3ba4ec2608b1d$var$LgndCanvas2 = false;
                $efd3ba4ec2608b1d$var$RunToggleLgnd2 = setInterval(function() {
                    $efd3ba4ec2608b1d$var$ToggleLgnd("2");
                }, 250);
            }
        } else {
            message = " pas trouve couleur dans la legende couche  " + no_;
            messagePop = message;
            console.log(message);
        }
        messageRGB = $efd3ba4ec2608b1d$var$RGB2Valeur(pixelData[0], pixelData[1], pixelData[2], pixelData[3], mapid, interval);
        console.log(messageRGB);
        messagePop = messageRGB;
    }
    if (no_ == "1") $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = messagePop;
    else if (no_ == "2") {
        console.log(" update of popup 2 here message RGB: " + messageRGB);
        console.log(" update of popup 2 here message Pop : " + messagePop);
        $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = messagePop;
        console.log(" Popup2Content.innerHTML  " + $efd3ba4ec2608b1d$var$Popup2Content.innerHTML);
    }
}
// ________________________________________________________________________________
//
//    \|/
function $efd3ba4ec2608b1d$var$RGB2Valeur(rouge, vert, bleu, opac, mapid, interval) {
    var Liste_RGB = [
        0
    ];
    var Liste_VAL = [
        0
    ];
    var indice_trouve = [
        -1
    ];
    var precision = 10;
    var unite = " ";
    var str_debut = " ";
    var unite = " ";
    var message = " ";
    var plein = false;
    var raison_pas_trouve = " ";
    var valeur_a_afficher, valeur_a_afficher_plus;
    interval = Math.round(interval / 60.);
    if (mapid == "WIND_10") {
        Liste_RGB = [
            "#D0D0FF66",
            "#C5C5FF99",
            "#BABAFFaa",
            "#9ACBFFff",
            "#8BF4FFff",
            "#57FFA4ff",
            "#18FF2Dff",
            "#00E300ff",
            "#00B600ff",
            "#3CB600ff",
            "#B4E300ff",
            "#FFEC00ff",
            "#FFBD00ff",
            "#FF8700ff",
            "#FF3F00ff",
            "#FF000Eff",
            "#FF0086ff",
            "#FF00FFff"
        ];
        Liste_VAL = [
            9,
            12,
            15,
            18,
            21,
            24,
            27,
            30,
            35,
            40,
            45,
            50,
            60,
            70,
            80,
            90,
            120,
            150,
            210
        ];
        str_debut = " Vents \xe0 10m <br />";
        unite = " noeuds ";
        plein = false;
        raison_pas_trouve = " Vous pointez sur une fl\xe8che, ou sur un contour...";
    } else if (mapid == "WIN-_10") {
        //seuil <- c(seq(4, 30, 2), seq(35, 45, 5), 55, 200)
        Liste_RGB = [
            "#D0D0FF66",
            "#C5C5FF99",
            "#BABAFFaa",
            "#9ACBFFff",
            "#8BF4FFff",
            "#57FFA4ff",
            "#18FF2Dff",
            "#00E300ff",
            "#00B600ff",
            "#3CB600ff",
            "#B4E300ff",
            "#FFEC00ff",
            "#FFBD00ff",
            "#FF8700ff",
            "#FF3F00ff",
            "#FF000Eff",
            "#FF0086ff",
            "#FF00FFff"
        ];
        Liste_VAL = [
            4,
            6,
            8,
            10,
            12,
            14,
            16,
            18,
            20,
            22,
            24,
            26,
            28,
            30,
            35,
            40,
            45,
            55,
            200
        ];
        str_debut = " Vents \xe0 10m <br />";
        unite = " noeuds ";
        plein = false;
        raison_pas_trouve = " Vous pointez sur une fl\xe8che, ou sur un contour...";
    } else if (mapid == "GUST_10") {
        Liste_RGB = [
            "#D0D0FF66",
            "#C5C5FF99",
            "#BABAFFaa",
            "#9ACBFFff",
            "#8BF4FFff",
            "#57FFA4ff",
            "#18FF2Dff",
            "#00E300ff",
            "#00B600ff",
            "#3CB600ff",
            "#B4E300ff",
            "#FFEC00ff",
            "#FFBD00ff",
            "#FF8700ff",
            "#FF3F00ff",
            "#FF000Eff",
            "#FF0086ff",
            "#FF00FFff"
        ];
        Liste_VAL = [
            4,
            6,
            8,
            10,
            12,
            14,
            16,
            18,
            20,
            22,
            24,
            26,
            28,
            30,
            35,
            40,
            45,
            55,
            200
        ];
        str_debut = " Rafales \xe0 10m <br />";
        unite = " noeuds ";
        plein = false;
        raison_pas_trouve = " Vous pointez sur un contour...";
    } else if (mapid == "GUST_MAX_10") {
        Liste_RGB = [
            "#D0D0FF66",
            "#C5C5FF99",
            "#BABAFFaa",
            "#9ACBFFff",
            "#8BF4FFff",
            "#57FFA4ff",
            "#18FF2Dff",
            "#00E300ff",
            "#00B600ff",
            "#3CB600ff",
            "#B4E300ff",
            "#FFEC00ff",
            "#FFBD00ff",
            "#FF8700ff",
            "#FF3F00ff",
            "#FF000Eff",
            "#FF0086ff",
            "#FF00FFff"
        ];
        Liste_VAL = [
            3,
            6,
            9,
            12,
            15,
            18,
            21,
            24,
            27,
            30,
            35,
            40,
            45,
            50,
            60,
            70,
            80,
            90,
            200
        ];
        str_debut = " Rafales maximale \xe0 10m <br />";
        unite = " noeuds ";
        plein = false;
        raison_pas_trouve = " Vous pointez sur un contour....";
    } else if (mapid == "WIND_850") {
        Liste_RGB = [
            "#D0D0FF66",
            "#C5C5FF96",
            "#BABAFFc8",
            "#9ACBFFdf",
            "#8BF4FFff",
            "#57FFA4ff",
            "#18FF2Dff",
            "#00E300ff",
            "#00B600ff",
            "#3CB600ff",
            "#B4E300ff",
            "#FFEC00ff",
            "#FFBD00ff",
            "#FF8700ff",
            "#FF3F00ff",
            "#FF000Eff",
            "#FF0086ff",
            "#FF00FFff"
        ];
        Liste_VAL = [
            12,
            16,
            20,
            24,
            28,
            32,
            36,
            40,
            44,
            48,
            52,
            56,
            60,
            70,
            80,
            100,
            120,
            140,
            200
        ];
        str_debut = " Vents \xe0 850mb <br />";
        unite = " noeuds <br />";
        plein = false;
        raison_pas_trouve = " Vous pointez sur une fl\xe8che, ou sur un contour...";
    } else if (mapid == "WIND_250") {
        Liste_RGB = [
            "#D0D0FF66",
            "#C5C5FF96",
            "#BABAFFc8",
            "#9ACBFFdf",
            "#8BF4FFff",
            "#57FFA4ff",
            "#18FF2Dff",
            "#00E300ff",
            "#00B600ff",
            "#3CB600ff",
            "#B4E300ff",
            "#FFEC00ff",
            "#FFBD00ff",
            "#FF8700ff",
            "#FF3F00ff",
            "#FF000Eff",
            "#FF0086ff",
            "#FF00FFff"
        ];
        Liste_VAL = [
            50,
            65,
            75,
            85,
            95,
            105,
            115,
            125,
            135,
            145,
            155,
            165,
            175,
            185,
            195,
            205,
            215,
            225,
            300
        ];
        str_debut = " Vents \xe0 250mb <br />";
        unite = " noeuds ";
        plein = false;
        raison_pas_trouve = " Vous pointez sur une fl\xe8che, ou sur un contour...";
    } else if (mapid == "TMP_850") {
        Liste_RGB = [
            "#AA60FA",
            "#A86CFA",
            "#A778FA",
            "#A683FA",
            "#A590FA",
            "#A49CFA",
            "#A3A8FA",
            "#A2B3FA",
            "#A1C0FA",
            "#A0CCFA",
            "#A0CCFA",
            "#98C0FA",
            "#91B4FA",
            "#8AA8FA",
            "#839CFA",
            "#7C90FA",
            "#7584FA",
            "#6E78FA",
            "#676CFA",
            "#6060FA",
            "#6070FA",
            "#607FFA",
            "#608EFA",
            "#609EFA",
            "#60ADFA",
            "#60BCFA",
            "#60CBFA",
            "#60DBFA",
            "#60EAFA",
            "#60FAFA",
            "#60FAF0",
            "#60FAD3",
            "#60FAB6",
            "#60FA99",
            "#60FA7C",
            "#60FA60",
            "#60F060",
            "#60E060",
            "#60D060",
            "#60C060",
            "#70CA70",
            "#7CCF7C",
            "#88D488",
            "#95DA95",
            "#A1DFA1",
            "#AEE4AE",
            "#BAEABA",
            "#C7EFC7",
            "#D3F4D3",
            "#E0FAE0",
            "#FAFAFA",
            "#FAFAE0",
            "#FAFAD4",
            "#FAFAC8",
            "#FAFABC",
            "#FAFAB0",
            "#FAFAA5",
            "#FAFA99",
            "#FAFA8D",
            "#FAFA81",
            "#FAFA75",
            "#FAFA6A",
            "#FAFA5E",
            "#FAFA52",
            "#FAFA46",
            "#FAFA3A",
            "#FAFA2F",
            "#FAFA23",
            "#FAFA17",
            "#FAFA0B",
            "#FAFA00",
            "#FFFF00",
            "#FFF400",
            "#FFE900",
            "#FFDF00",
            "#FFD400",
            "#FFCA00",
            "#FFBF00",
            "#FFB500",
            "#FFAA00",
            "#FFA000",
            "#FF8000",
            "#FF7100",
            "#FF6300",
            "#FF5500",
            "#FF4700",
            "#FF3800",
            "#FF2A00",
            "#FF1C00",
            "#FF0E00",
            "#FF0000",
            "#FA6060",
            "#FA7272",
            "#FA8484",
            "#FA9797",
            "#FAAAAA",
            "#FD6C30",
            "#FA00AA",
            "#FC4060",
            "#FD6C30",
            "#FF9900"
        ];
        Liste_VAL = [
            -50,
            -48,
            -46,
            -44,
            -42,
            -40,
            -38,
            -36,
            -34,
            -32,
            -30,
            -29,
            -28,
            -27,
            -26,
            -25,
            -24,
            -23,
            -22,
            -21,
            -20,
            -19,
            -18,
            -17,
            -16,
            -15,
            -14,
            -13,
            -12,
            -11,
            -10,
            -9.5,
            -9,
            -8.5,
            -8,
            -7.5,
            -7,
            -6.5,
            -6,
            -5.5,
            -5,
            -4.5,
            -4,
            -3.5,
            -3,
            -2.5,
            -2,
            -1.5,
            -1,
            -0.5,
            0,
            0.5,
            1,
            1.5,
            2,
            2.5,
            3,
            3.5,
            4,
            4.5,
            5.0,
            5.5,
            6,
            6.5,
            7,
            7.5,
            8,
            8.5,
            9,
            9.5,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            32,
            34,
            36,
            38,
            40,
            42,
            44,
            46,
            48,
            50,
            52
        ];
        //                Liste_RGB = ["#a056A7", "#A086a0", "#B9B7D9", "#4040f0", "#7070f5", "#a0a0ff", "#85CA7B", "#B8E194", 
        //                             "#EEEEEE", "#F7F4AD", "#FBD179", "#FDAB49", "#F67334", "#F03B20", "#fa9fb5", "#c51b8a"];
        //                Liste_VAL = [-50, -40, -35, -30, -25, -20, -15, -10, -5, 0, 5,  10,  15,  20,  25,  30,  35 ];
        str_debut = " Temp\xe9rature \xe0 850mb <br /> ";
        unite = " deg. C ";
        plein = true;
        raison_pas_trouve = " Vous pointez sur un contour...";
        precision = 10;
    } else if (mapid == "TMP_sfc" || mapid == "PRMSL__TMP_sfc") {
        //Liste_RGB = ["#AA60FA","#A86CFA","#A778FA","#A683FA","#A590FA","#A49CFA","#A3A8FA",
        //            "#A2B3FA","#A1C0FA","#A0CCFA","#A0CCFA","#98C0FA","#91B4FA","#8AA8FA",
        //           "#839CFA","#7C90FA","#7584FA","#6E78FA","#676CFA","#6060FA","#6060FA",
        //          "#6071FA","#6082FA","#6093FA","#60A4FA","#60B5FA","#60C6FA","#60D7FA",
        //         "#60E8FA","#60FAFA","#60FAFA","#60FAE8","#60FAD7","#60FAC6","#60FAB5",
        //        "#60FAA4","#60FA93","#60FA82","#60FA71","#60FA60","#60FA60","#6EFA6E",
        //       "#7CFA7C","#8AFA8A","#98FA98","#A7FAA7","#B5FAB5","#C3FAC3","#D1FAD1",
        //      "#E0FAE0","#FAFAFA","#FAFAE8","#FAFAD7","#FAFAC6","#FAFAB5","#FAFAA4",
        //             "#FAFA93","#FAFA82","#FAFA71","#FAFA60","#FAFA60","#FAF160","#FAE860",
        //            "#FADF60","#FAD660","#FACD60","#FAC460","#FABB60","#FAB260","#FAAA60",
        //           "#FAAA60","#FAA160","#FA9960","#FA9160","#FA8960","#FA8060","#FA7860",
        //          "#FA7060","#FA6860","#FA6060","#FA6060","#FA6C67","#FA786E","#FA8375",
        //         "#FA907C","#FA9C83","#FAA88A","#FAB391","#FAC098","#FACCA0","#FACCA0",
        //        "#FAC0A1","#FAB4A2","#FAA8A3","#FA9CA4","#FA90A5","#FA84A6","#FA78A7",
        //       "#FA6CA8","#FA60AA"];
        Liste_RGB = [
            "#AA60FA",
            "#A86CFA",
            "#A778FA",
            "#A683FA",
            "#A590FA",
            "#A49CFA",
            "#A3A8FA",
            "#A2B3FA",
            "#A1C0FA",
            "#A0CCFA",
            "#A0CCFA",
            "#98C0FA",
            "#91B4FA",
            "#8AA8FA",
            "#839CFA",
            "#7C90FA",
            "#7584FA",
            "#6E78FA",
            "#676CFA",
            "#6060FA",
            "#6070FA",
            "#607FFA",
            "#608EFA",
            "#609EFA",
            "#60ADFA",
            "#60BCFA",
            "#60CBFA",
            "#60DBFA",
            "#60EAFA",
            "#60FAFA",
            "#60FAF0",
            "#60FAD3",
            "#60FAB6",
            "#60FA99",
            "#60FA7C",
            "#60FA60",
            "#60F060",
            "#60E060",
            "#60D060",
            "#60C060",
            "#70CA70",
            "#7CCF7C",
            "#88D488",
            "#95DA95",
            "#A1DFA1",
            "#AEE4AE",
            "#BAEABA",
            "#C7EFC7",
            "#D3F4D3",
            "#E0FAE0",
            "#FAFAFA",
            "#FAFAE0",
            "#FAFAD4",
            "#FAFAC8",
            "#FAFABC",
            "#FAFAB0",
            "#FAFAA5",
            "#FAFA99",
            "#FAFA8D",
            "#FAFA81",
            "#FAFA75",
            "#FAFA6A",
            "#FAFA5E",
            "#FAFA52",
            "#FAFA46",
            "#FAFA3A",
            "#FAFA2F",
            "#FAFA23",
            "#FAFA17",
            "#FAFA0B",
            "#FAFA00",
            "#FFFF00",
            "#FFF400",
            "#FFE900",
            "#FFDF00",
            "#FFD400",
            "#FFCA00",
            "#FFBF00",
            "#FFB500",
            "#FFAA00",
            "#FFA000",
            "#FF8000",
            "#FF7100",
            "#FF6300",
            "#FF5500",
            "#FF4700",
            "#FF3800",
            "#FF2A00",
            "#FF1C00",
            "#FF0E00",
            "#FF0000",
            "#FA6060",
            "#FA7272",
            "#FA8484",
            "#FA9797",
            "#FAAAAA",
            "#FD6C30",
            "#FA00AA",
            "#FC4060",
            "#FD6C30",
            "#FF9900"
        ];
        Liste_VAL = [
            -50,
            -48,
            -46,
            -44,
            -42,
            -40,
            -38,
            -36,
            -34,
            -32,
            -30,
            -29,
            -28,
            -27,
            -26,
            -25,
            -24,
            -23,
            -22,
            -21,
            -20,
            -19,
            -18,
            -17,
            -16,
            -15,
            -14,
            -13,
            -12,
            -11,
            -10,
            -9.5,
            -9,
            -8.5,
            -8,
            -7.5,
            -7,
            -6.5,
            -6,
            -5.5,
            -5,
            -4.5,
            -4,
            -3.5,
            -3,
            -2.5,
            -2,
            -1.5,
            -1,
            -0.5,
            0,
            0.5,
            1,
            1.5,
            2,
            2.5,
            3,
            3.5,
            4,
            4.5,
            5.0,
            5.5,
            6,
            6.5,
            7,
            7.5,
            8,
            8.5,
            9,
            9.5,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            32,
            34,
            36,
            38,
            40,
            42,
            44,
            46,
            48,
            50,
            52
        ];
        //                Liste_RGB = ["#754CC8", "#88DDDD", "#a056A7", "#A086a0", "#B9B7D9", "#4040f0", "#7070f5", "#a0a0ff", "#85CA7B", "#B8E194", 
        //                             "#EEEEEE", "#F7F4AD", "#FBD179", "#FDAB49", "#F67334", "#F03B20", "#fa9fb5", "#E05DA0", "#c51b8a", "#996633"];
        //                Liste_VAL = [-50, -45, -40, -35, -30, -25, -20, -15, -10, -5, 0, 5,  10,  15,  20,  25,  30,  35, 40, 45, 50 ];
        str_debut = " Temp\xe9rature \xe0 1,5m <br />";
        unite = " deg. C ";
        plein = true;
        raison_pas_trouve = " Vous pointez sur un contour...";
        precision = 10;
    } else if (mapid == "DPT_sfc") {
        //                Liste_RGB = ["#7070f5", "#a0a0ff", "#85CA7B", "#B8E194", 
        //                             "#EEEEEE", "#F7F4AD", "#FBD179", "#FDAB49", "#F67334", "#F03B20", "#fa9fb5", "#c51b8a"];
        //                Liste_VAL = [-5., 0., 5., 10., 12., 14., 16., 18., 20., 22., 24., 26., 28. ];
        //                Liste_RGB = ["#754CC8", "#88DDDD", "#a056A7", "#A086a0", "#B9B7D9", "#4040f0", "#7070f5", "#a0a0ff", "#85CA7B", "#B8E194", 
        //                             "#EEEEEE", "#F7F4AD", "#FBD179", "#FDAB49", "#F67334", "#F03B20", "#fa9fb5", "#E05DA0", "#c51b8a", "#996633"];
        //                Liste_VAL = [-50, -45, -40, -35, -30, -25, -20, -15, -10, -5, 0, 5,  10,  15,  20,  25,  30,  35, 40, 45, 50 ];
        Liste_RGB = [
            "#AA60FA",
            "#A86CFA",
            "#A778FA",
            "#A683FA",
            "#A590FA",
            "#A49CFA",
            "#A3A8FA",
            "#A2B3FA",
            "#A1C0FA",
            "#A0CCFA",
            "#A0CCFA",
            "#98C0FA",
            "#91B4FA",
            "#8AA8FA",
            "#839CFA",
            "#7C90FA",
            "#7584FA",
            "#6E78FA",
            "#676CFA",
            "#6060FA",
            "#6070FA",
            "#607FFA",
            "#608EFA",
            "#609EFA",
            "#60ADFA",
            "#60BCFA",
            "#60CBFA",
            "#60DBFA",
            "#60EAFA",
            "#60FAFA",
            "#60FAF0",
            "#60FAD3",
            "#60FAB6",
            "#60FA99",
            "#60FA7C",
            "#60FA60",
            "#60F060",
            "#60E060",
            "#60D060",
            "#60C060",
            "#70CA70",
            "#7CCF7C",
            "#88D488",
            "#95DA95",
            "#A1DFA1",
            "#AEE4AE",
            "#BAEABA",
            "#C7EFC7",
            "#D3F4D3",
            "#E0FAE0",
            "#FAFAFA",
            "#FAFAE0",
            "#FAFAD4",
            "#FAFAC8",
            "#FAFABC",
            "#FAFAB0",
            "#FAFAA5",
            "#FAFA99",
            "#FAFA8D",
            "#FAFA81",
            "#FAFA75",
            "#FAFA6A",
            "#FAFA5E",
            "#FAFA52",
            "#FAFA46",
            "#FAFA3A",
            "#FAFA2F",
            "#FAFA23",
            "#FAFA17",
            "#FAFA0B",
            "#FAFA00",
            "#FFFF00",
            "#FFF400",
            "#FFE900",
            "#FFDF00",
            "#FFD400",
            "#FFCA00",
            "#FFBF00",
            "#FFB500",
            "#FFAA00",
            "#FFA000",
            "#FF8000",
            "#FF7100",
            "#FF6300",
            "#FF5500",
            "#FF4700",
            "#FF3800",
            "#FF2A00",
            "#FF1C00",
            "#FF0E00",
            "#FF0000",
            "#FA6060",
            "#FA7272",
            "#FA8484",
            "#FA9797",
            "#FAAAAA",
            "#FD6C30",
            "#FA00AA",
            "#FC4060",
            "#FD6C30",
            "#FF9900"
        ];
        Liste_VAL = [
            -50,
            -48,
            -46,
            -44,
            -42,
            -40,
            -38,
            -36,
            -34,
            -32,
            -30,
            -29,
            -28,
            -27,
            -26,
            -25,
            -24,
            -23,
            -22,
            -21,
            -20,
            -19,
            -18,
            -17,
            -16,
            -15,
            -14,
            -13,
            -12,
            -11,
            -10,
            -9.5,
            -9,
            -8.5,
            -8,
            -7.5,
            -7,
            -6.5,
            -6,
            -5.5,
            -5,
            -4.5,
            -4,
            -3.5,
            -3,
            -2.5,
            -2,
            -1.5,
            -1,
            -0.5,
            0,
            0.5,
            1,
            1.5,
            2,
            2.5,
            3,
            3.5,
            4,
            4.5,
            5.0,
            5.5,
            6,
            6.5,
            7,
            7.5,
            8,
            8.5,
            9,
            9.5,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            32,
            34,
            36,
            38,
            40,
            42,
            44,
            46,
            48,
            50,
            52
        ];
        str_debut = " Temp\xe9rature du point de ros\xe9 \xe0 1,5m <br />";
        unite = " deg. C ";
        plein = true;
        raison_pas_trouve = " Vous pointez sur un contour...";
        precision = 10;
    } else if (mapid == "HGT_500_TCDC_") {
        Liste_RGB = [
            "#D0D0FF33",
            "#C5C5FF4c",
            "#BABAFF66",
            "#B0B0FF7f",
            "#A5A5FF9f",
            "#A4A9F9bf",
            "#ADBCEFdf",
            "#B6CFE5ff",
            "#BFE2DBff",
            "#C8F6D1ff"
        ];
        Liste_VAL = [
            10,
            20,
            30,
            40,
            50,
            60,
            70,
            80,
            90,
            100,
            105
        ];
        str_debut = " Fraction nuageuse totale <br />";
        unite = " % ";
        plein = false;
        precision = 5;
        raison_pas_trouve = " Vous pointez sur un contour...";
    } else if (mapid == "APCP_") {
        Liste_RGB = [
            "#B2FF66",
            "#66CC00",
            "#00aa00",
            "#FFFF00",
            "#00FF00",
            "#00CC00",
            "#009900"
        ];
        if (interval == 1) Liste_VAL = [
            0.125,
            .5,
            1.,
            2.5,
            5,
            10,
            20,
            90
        ];
        else if (interval == 3) Liste_VAL = [
            0.25,
            .5,
            1.,
            5.,
            10,
            20,
            30,
            90
        ];
        else if (interval == 6) Liste_VAL = [
            0.5,
            1,
            5,
            10,
            15,
            25,
            40,
            90
        ];
        else if (interval == 12) Liste_VAL = [
            1,
            5,
            20,
            35,
            50,
            65,
            80,
            150
        ];
        else if (interval == 24) Liste_VAL = [
            1,
            10,
            25,
            35,
            50,
            75,
            100,
            200
        ];
        else if (interval == 48) Liste_VAL = [
            1,
            10,
            25,
            50,
            75,
            100,
            150,
            250
        ];
        str_debut = " Pr\xe9cipitation totale cumulative sur " + interval + "h :";
        unite = " mm <br />";
        plein = false;
        raison_pas_trouve = " Vous pointez sur un contour...";
    } else if (mapid == "WEARN__h" || mapid == "PRMSL__WEARN__h") {
        Liste_RGB = [
            "#B2FF66",
            "#66CC00",
            "#00aa00",
            "#FFFF00",
            "#00FF00",
            "#00CC00",
            "#009900"
        ];
        if (interval == 1) Liste_VAL = [
            0.125,
            .5,
            1.,
            2.5,
            5,
            10,
            20,
            90
        ];
        else if (interval == 3) Liste_VAL = [
            0.25,
            1.,
            2.5,
            5.,
            10,
            20,
            30,
            120
        ];
        else if (interval == 6) Liste_VAL = [
            0.5,
            2.5,
            5,
            10,
            20,
            30,
            50,
            150
        ];
        else if (interval == 12) Liste_VAL = [
            1,
            5,
            10,
            20,
            30,
            50,
            75,
            180
        ];
        else if (interval == 24) Liste_VAL = [
            1,
            5,
            15,
            30,
            50,
            75,
            100,
            200
        ];
        else if (interval == 48) Liste_VAL = [
            5,
            20,
            50,
            75,
            100,
            150,
            200,
            400
        ];
        str_debut = " Pluie cumulative sur " + interval + "h :";
        unite = " mm <br />";
        plein = false;
        raison_pas_trouve = " Vous pointez sur un contour...";
    } else if (mapid == "WEASN__h" || mapid == "PRMSL__WEASN__h") {
        Liste_RGB = [
            "#99FFFF",
            "#3399FF",
            "#0066CC",
            "#004C99",
            "#00FFFF",
            "#6666FF",
            "#3366CC"
        ];
        if (interval == 1) Liste_VAL = [
            0.125,
            0.25,
            0.5,
            1,
            1.25,
            2.5,
            5,
            95
        ];
        else if (interval == 3) Liste_VAL = [
            0.25,
            0.5,
            1,
            2.5,
            5,
            7.5,
            15,
            95
        ];
        else if (interval == 6) Liste_VAL = [
            0.5,
            1,
            2.5,
            5,
            7.5,
            15,
            30,
            95
        ];
        else if (interval == 12) Liste_VAL = [
            0.5,
            2.5,
            5,
            10,
            15,
            25,
            40,
            95
        ];
        else if (interval == 24) Liste_VAL = [
            1,
            5,
            15,
            25,
            35,
            45,
            60,
            95
        ];
        else if (interval == 48) Liste_VAL = [
            1,
            10,
            20,
            30,
            40,
            60,
            75,
            90
        ];
        str_debut = " Neige cumulative sur " + interval + "h : <br />  (\xe9quivalent en eau) <br />";
        unite = " mm <br /> ";
        plein = false;
        raison_pas_trouve = " Vous pointez sur un contour...";
    } else if (mapid == "WEAFR__h" || mapid == "PRMSL__WEAFR__h") {
        Liste_RGB = [
            "#FF9999",
            "#FF3333",
            "#CC0000",
            "#990000",
            "#FF0000",
            "#FF6666",
            "#FFcccc"
        ];
        if (interval == 1) Liste_VAL = [
            0.125,
            0.25,
            0.5,
            1,
            1.25,
            2.5,
            5,
            95
        ];
        else if (interval == 3) Liste_VAL = [
            0.25,
            0.5,
            1,
            2.5,
            5,
            7.5,
            15,
            95
        ];
        else if (interval == 6) Liste_VAL = [
            0.5,
            1,
            2.5,
            5,
            7.5,
            15,
            30,
            95
        ];
        else if (interval == 12) Liste_VAL = [
            0.5,
            2.5,
            5,
            10,
            15,
            25,
            40,
            95
        ];
        else if (interval == 24) Liste_VAL = [
            1,
            5,
            15,
            25,
            35,
            45,
            60,
            95
        ];
        else if (interval == 48) Liste_VAL = [
            1,
            10,
            20,
            30,
            40,
            60,
            75,
            90
        ];
        str_debut = " Pluie vergal\xe7ante cumulative sur " + interval + "h :<br /> (\xe9quivalent en eau) <br />";
        unite = " mm <br /> ";
        plein = false;
        raison_pas_trouve = " Vous pointez sur un contour...";
    } else if (mapid == "WEAPE__h" || mapid == "PRMSL__WEAPE__h") {
        Liste_RGB = [
            "#FF99FF",
            "#FF33FF",
            "#CC00CC",
            "#990099",
            "#FF00FF",
            "#FF66FF",
            "#FFCCFF"
        ];
        if (interval == 1) Liste_VAL = [
            0.125,
            0.25,
            0.5,
            1,
            1.25,
            2.5,
            5,
            95
        ];
        else if (interval == 3) Liste_VAL = [
            0.25,
            0.5,
            1,
            2.5,
            5,
            7.5,
            15,
            95
        ];
        else if (interval == 6) Liste_VAL = [
            0.5,
            1,
            2.5,
            5,
            7.5,
            15,
            30,
            95
        ];
        else if (interval == 12) Liste_VAL = [
            0.5,
            2.5,
            5,
            10,
            15,
            25,
            40,
            95
        ];
        else if (interval == 24) Liste_VAL = [
            1,
            5,
            15,
            25,
            35,
            45,
            60,
            95
        ];
        else if (interval == 48) Liste_VAL = [
            1,
            10,
            20,
            30,
            40,
            60,
            75,
            90
        ];
        str_debut = " Gr\xe9sil cumulatif sur " + interval + "h : <br />  (\xe9quivalent en eau) <br />";
        unite = " mm <br /> ";
        plein = false;
        raison_pas_trouve = " Vous pointez sur un contour...";
    } else if (mapid == "COMPO__h" || mapid == "PRMSL__COMPO__h") {
        Liste_RGB = [
            "#FF9999",
            "#FF3333",
            "#CC0000",
            "#990000",
            "#FF0000",
            "#FF6666",
            "#FFcccc",
            "#ffffff",
            "#FF99FF",
            "#FF33FF",
            "#CC00CC",
            "#990099",
            "#FF00FF",
            "#FF66FF",
            "#FFCCFF",
            "#ffffff",
            "#99FFFF",
            "#3399FF",
            "#0066CC",
            "#004C99",
            "#00FFFF",
            "#6666FF",
            "#3366CC",
            "#ffffff",
            "#B2FF66",
            "#66CC00",
            "#00aa00",
            "#FFFF00",
            "#00FF00",
            "#00CC00",
            "#009900",
            "#ffffff",
            "#f0f0d0",
            "#e0e090",
            "#c0c010",
            "#a0a000",
            "#f0f0a0",
            "#c0c060"
        ];
        if (interval == 1) Liste_VAL = [
            0.125,
            0.25,
            0.5,
            1,
            1.5,
            2.5,
            5,
            95.,
            100.125,
            100.25,
            100.5,
            101.,
            101.5,
            102.5,
            105.,
            195.,
            200.125,
            200.25,
            200.5,
            201.,
            201.5,
            202.5,
            205.,
            295.,
            300.125,
            300.5,
            301.,
            302.5,
            305.,
            310.,
            320.,
            390.,
            600.125,
            600.5,
            601.,
            602.5,
            605,
            610.,
            690.
        ];
        else if (interval == 3) Liste_VAL = [
            0.25,
            0.5,
            1.,
            2.5,
            5.,
            7.5,
            15.,
            95.,
            100.25,
            100.5,
            101.,
            102.5,
            105.,
            107.5,
            115.,
            195.,
            200.25,
            200.5,
            201.,
            202.5,
            205.,
            207.5,
            215.,
            295.,
            300.25,
            301.0,
            302.5,
            305.0,
            310.,
            320.0,
            330.,
            390.,
            600.25,
            601.0,
            602.5,
            605.0,
            610.,
            620.0,
            690.
        ];
        else if (interval == 6) Liste_VAL = [
            0.5,
            1,
            2.5,
            5.,
            7.5,
            15,
            30,
            95.,
            100.5,
            101,
            102.5,
            105.,
            107.5,
            115,
            130,
            195.,
            200.5,
            201,
            202.5,
            205.,
            207.5,
            215,
            230,
            295.,
            300.5,
            302.5,
            305.,
            310.,
            320.,
            330,
            350,
            390.,
            600.5,
            602.5,
            605.,
            610.,
            620.,
            630,
            690.
        ];
        else if (interval == 12) Liste_VAL = [
            0.5,
            2.5,
            5.,
            10.,
            15.,
            25.,
            40.,
            90.,
            100.5,
            102.5,
            105.,
            110.,
            115.,
            125.,
            140.,
            190.,
            200.5,
            202.5,
            205.,
            210.,
            215.,
            225.,
            240.,
            290.,
            301.0,
            305.,
            310.,
            320.,
            330.,
            350.,
            375.,
            490.,
            601.0,
            605.,
            610.,
            620.,
            630.,
            650.,
            690.
        ];
        else if (interval == 24) Liste_VAL = [
            1.,
            5.,
            15.,
            25.,
            35.,
            45,
            60,
            95.,
            101.,
            105.,
            115.,
            125.,
            135.,
            145.,
            160,
            195.,
            201.,
            205.,
            215.,
            225.,
            235.,
            245.,
            260,
            295.,
            301.0,
            305.,
            315.,
            330.,
            350.,
            375.,
            400.,
            500.,
            601.0,
            605.,
            615.,
            630.,
            650.,
            675.,
            690.
        ];
        else if (interval == 48) Liste_VAL = [
            1,
            10.,
            20.,
            30.,
            40.,
            60.,
            75.,
            90.,
            101.,
            110.,
            120.,
            130.,
            140.,
            160.,
            175.,
            190.,
            201.,
            210.,
            220.,
            230.,
            240.,
            260.,
            275.,
            290.,
            301.0,
            310.,
            325.,
            350.,
            375.,
            400.,
            450.,
            590.,
            601.0,
            610.,
            625.,
            650.,
            675.,
            700.,
            750.
        ];
        str_debut = " Pr\xe9cipitation cumulative dominante sur " + interval + "h :<br /> (\xe9quivalent en eau) <br />";
        unite = " mm <br /> ";
        plein = false;
        raison_pas_trouve = " Vous pointez sur un contour...";
    }
    var RGBlength = Liste_RGB.length;
    if (RGBlength == 1) message = " <br> voir l\xe9gende";
    else if (RGBlength == 2) message = " <br> Cette couche n'a pas de plages de valeurs color\xe9es,  Choisir une autre couche pour obtenir des valeurs";
    else if (rouge <= 10 && vert <= 10 && bleu <= 10) {
        if (plein) message = "<br> pas de valeur trouv\xe9es";
        else message = " <br> pas de valeur trouv\xe9es OU " + str_debut + " plus petit que " + Liste_VAL[0] + unite;
    } else {
        var rouge_clique, vert_clique, bleu_clique, opac_clique;
        var j = -1;
        for(var i = 0; i < RGBlength; i++){
            rouge_clique = parseInt(Liste_RGB[i].substr(1, 2), 16);
            vert_clique = parseInt(Liste_RGB[i].substr(3, 2), 16);
            bleu_clique = parseInt(Liste_RGB[i].substr(5, 2), 16);
            if (mapid == "HGT_500_TCDC_" || mapid == "WIND_10" || mapid == "WIND_850" || mapid == "WIND_250" || mapid == "GUST_10" || mapid == "GUST_MAX_10") {
                opac_clique = parseInt(Liste_RGB[i].substr(7, 2), 16);
                if (rouge > rouge_clique - precision && rouge < rouge_clique + precision && vert > vert_clique - precision && vert < vert_clique + precision && bleu > bleu_clique - precision && bleu < bleu_clique + precision && opac > opac_clique - precision && opac < opac_clique + precision) {
                    j = j + 1;
                    indice_trouve = i;
                }
            } else if (rouge > rouge_clique - precision && rouge < rouge_clique + precision && vert > vert_clique - precision && vert < vert_clique + precision && bleu > bleu_clique - precision && bleu < bleu_clique + precision) {
                j = j + 1;
                if (j < 1) indice_trouve = i;
            }
        }
        if (j < 0) message = raison_pas_trouve;
        else if (j > 0 && mapid != "TMP_sfc" && mapid != "PRMSL__TMP_sfc" && mapid != "TMP_850" && mapid != "DPT_sfc") message = "valeur ambigue: voir si la legende aide dans ce cas. " + j;
        else {
            if (mapid == "COMPO__h" || mapid == "PRMSL__COMPO__h") {
                if (Liste_VAL[indice_trouve] < 100) {
                    str_debut = str_debut + " Verglas ";
                    unite = " mm <br /> ";
                    valeur_a_afficher = Liste_VAL[indice_trouve];
                    valeur_a_afficher_plus = Liste_VAL[indice_trouve + 1];
                } else if (Liste_VAL[indice_trouve] < 200) {
                    str_debut = str_debut + " Gr\xe9sil ";
                    unite = " mm  <br /> ";
                    valeur_a_afficher = Liste_VAL[indice_trouve] - 100;
                    valeur_a_afficher_plus = Liste_VAL[indice_trouve + 1] - 100;
                } else if (Liste_VAL[indice_trouve] < 300) {
                    str_debut = str_debut + " Neige ";
                    unite = " mm <br /> ";
                    valeur_a_afficher = Liste_VAL[indice_trouve] - 200;
                    valeur_a_afficher_plus = Liste_VAL[indice_trouve + 1] - 200;
                } else if (Liste_VAL[indice_trouve] < 600) {
                    str_debut = str_debut + " Pluie";
                    unite = " mm ";
                    valeur_a_afficher = Liste_VAL[indice_trouve] - 300;
                    valeur_a_afficher_plus = Liste_VAL[indice_trouve + 1] - 300;
                } else if (Liste_VAL[indice_trouve] > 600) {
                    str_debut = str_debut + " Pluie et-ou Neige fondante <br /> ou autre m\xe9lange ";
                    unite = " mm <br />";
                    valeur_a_afficher = Liste_VAL[indice_trouve] - 600;
                    valeur_a_afficher_plus = Liste_VAL[indice_trouve + 1] - 600;
                }
            } else {
                valeur_a_afficher = Liste_VAL[indice_trouve];
                valeur_a_afficher_plus = Liste_VAL[indice_trouve + 1 + j];
            }
            if (indice_trouve < RGBlength) message = "<br>" + str_debut + " entre  " + valeur_a_afficher + " et  " + valeur_a_afficher_plus + unite;
            else if (indice_trouve == RGBlength) message = "<br>" + str_debut + " plus grand que:  " + valeur_a_afficher;
            else message = " <br> error";
        }
    }
    return message;
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$callSpotWX(evt) {
    $efd3ba4ec2608b1d$var$updateSpotWxPopup(evt);
    if ($efd3ba4ec2608b1d$var$Valeur1 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur1 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur1 == "ProfVert" || $efd3ba4ec2608b1d$var$Valeur1 == "MeteoGrm") {
        var message = " RefreshTimSer for layer 1; console.log(message);";
        $efd3ba4ec2608b1d$var$RefreshSpotWxGraph("1");
    }
    if ($efd3ba4ec2608b1d$var$Valeur2 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur2 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur2 == "ProfVert" || $efd3ba4ec2608b1d$var$Valeur2 == "MeteoGrm") {
        var message = " RefreshTimSer for layer 1; console.log(message);";
        $efd3ba4ec2608b1d$var$RefreshSpotWxGraph("2");
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$updateSpotWxPopup(evt) {
    let lat_lon = [];
    let message = "";
    lat_lon = (0, $9c4744460e43e41b$export$51186ad6e864892a)(evt.coordinate, evt.map.getView().getProjection(), "EPSG:4326");
    $efd3ba4ec2608b1d$var$PopupLon = lat_lon[0].toFixed(3);
    $efd3ba4ec2608b1d$var$PopupLat = lat_lon[1].toFixed(3);
    if ($efd3ba4ec2608b1d$var$Valeur1 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur1 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur1 == "MeteoGrm" || $efd3ba4ec2608b1d$var$Valeur1 == "ProfVert") {
        if (!$efd3ba4ec2608b1d$var$Image1_est_visible) {
            message = " <br> Valeurs graphiques activ\xe9es pour la couche1 qui est invisible...";
            console.log(message);
        }
        message = " <br> ValeurClick1: " + $efd3ba4ec2608b1d$var$PopupLat + " " + $efd3ba4ec2608b1d$var$PopupLon + " <br> Voir graphiques couche 1 ";
        console.log(message);
        $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = message;
        $efd3ba4ec2608b1d$var$Popup1Overlay.setPosition(evt.coordinate);
    }
    if ($efd3ba4ec2608b1d$var$Valeur2 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur2 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur2 == "MeteoGrm" || $efd3ba4ec2608b1d$var$Valeur2 == "ProfVert") {
        if (!$efd3ba4ec2608b1d$var$Image2_est_visible) {
            message = " <br> Valeurs graphiques activ\xe9es pour la couche2 qui est invisible... ";
            console.log(message);
        }
        message = " <br> ValeurClick2: " + $efd3ba4ec2608b1d$var$PopupLat + " " + $efd3ba4ec2608b1d$var$PopupLon + " <br> Voir graphiques couche 2 ";
        console.log(message);
        $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = message;
        $efd3ba4ec2608b1d$var$Popup2Overlay.setPosition(evt.coordinate);
    }
    if ($efd3ba4ec2608b1d$var$WindMaps) {
        localStorage.setItem("PopupLat_V", $efd3ba4ec2608b1d$var$PopupLat);
        localStorage.setItem("PopupLon_V", $efd3ba4ec2608b1d$var$PopupLon);
    } else {
        localStorage.setItem("PopupLat", $efd3ba4ec2608b1d$var$PopupLat);
        localStorage.setItem("PopupLon", $efd3ba4ec2608b1d$var$PopupLon);
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$RefreshSpotWx() {
    $efd3ba4ec2608b1d$var$RefreshSpotWxPopup();
    if ($efd3ba4ec2608b1d$var$Valeur1 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur1 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur1 == "ProfVert" || $efd3ba4ec2608b1d$var$Valeur1 == "MeteoGrm") {
        var message = " RefreshTimSer for layer 1;";
        $efd3ba4ec2608b1d$var$RefreshSpotWxGraph("1");
    }
    if ($efd3ba4ec2608b1d$var$Valeur2 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur2 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur2 == "ProfVert" || $efd3ba4ec2608b1d$var$Valeur2 == "MeteoGrm") {
        var message = " RefreshTimSer for layer 2;";
        $efd3ba4ec2608b1d$var$RefreshSpotWxGraph("2");
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$RefreshSpotWxPopup() {
    var message = "";
    if ($efd3ba4ec2608b1d$var$Valeur1 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur1 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur1 == "MeteoGrm" || $efd3ba4ec2608b1d$var$Valeur1 == "ProfVert") {
        if (!$efd3ba4ec2608b1d$var$Image1_est_visible) {
            message = " <br> Graphique demand\xe9 pour couche 1 invisible ";
            console.log(message);
        }
        var lat_lon = [];
        lat_lon[0] = $efd3ba4ec2608b1d$var$PopupLon;
        lat_lon[1] = $efd3ba4ec2608b1d$var$PopupLat;
        var coord_ = (0, $9c4744460e43e41b$export$51186ad6e864892a)(lat_lon, "EPSG:4326", $efd3ba4ec2608b1d$var$map.getView().getProjection());
        message = " <br> ValeurClick(r1): " + $efd3ba4ec2608b1d$var$PopupLat + " " + $efd3ba4ec2608b1d$var$PopupLon + " <br> Voir graphiques pour couche 1";
        $efd3ba4ec2608b1d$var$Popup1Overlay.setPosition(coord_);
        $efd3ba4ec2608b1d$var$Popup1Content.innerHTML = message;
    }
    if ($efd3ba4ec2608b1d$var$Valeur2 == "TimSer" || $efd3ba4ec2608b1d$var$Valeur2 == "TimSer_e" || $efd3ba4ec2608b1d$var$Valeur2 == "MeteoGrm" || $efd3ba4ec2608b1d$var$Valeur2 == "ProfVert") {
        if (!$efd3ba4ec2608b1d$var$Image2_est_visible) {
            message = " <br> Graphique demand\xe9 pour couche2 invisible ";
            console.log(message);
        }
        var lat_lon = [];
        lat_lon[0] = $efd3ba4ec2608b1d$var$PopupLon;
        lat_lon[1] = $efd3ba4ec2608b1d$var$PopupLat;
        var coord_ = (0, $9c4744460e43e41b$export$51186ad6e864892a)(lat_lon, "EPSG:4326", $efd3ba4ec2608b1d$var$map.getView().getProjection());
        message = " <br> ValeurClick(r2): " + $efd3ba4ec2608b1d$var$PopupLat + " " + $efd3ba4ec2608b1d$var$PopupLon + " <br> Voir graphiques pour couche 2";
        $efd3ba4ec2608b1d$var$Popup2Overlay.setPosition(coord_);
        $efd3ba4ec2608b1d$var$Popup2Content.innerHTML = message;
    }
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$WillOpenWin(link, model_, myWin) {
    if (myWin) {
        console.log(" Call for opening window. It was opened in the past!");
        if (myWin.closed) {
            console.log(" but it was closed ...Re-opening with settings to defaults");
            $efd3ba4ec2608b1d$var$OpenWin(link, model_, "init");
        } else {
            console.log(" it is still opened, just refreshing ");
            $efd3ba4ec2608b1d$var$OpenWin(link, model_, "refresh");
        }
    } else {
        console.log(" Call for opening window, was not opened before,  setting to defaults");
        $efd3ba4ec2608b1d$var$OpenWin(link, model_, "init");
    }
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$OpenWin(link_, model, todo_) {
    if (todo_ == "refresh") {
        if (model == "ECMWF" || model == "ECMWF3" || model == "ECMWFE") $efd3ba4ec2608b1d$var$MyWindow_ecmwf = window.open(link_, model);
        else if (model == "AIFS" || model == "AIFSE") $efd3ba4ec2608b1d$var$MyWindow_aifs = window.open(link_, model);
        else if (model == "GDPS") $efd3ba4ec2608b1d$var$MyWindow_gdps = window.open(link_, model);
        else if (model == "GDPSE") $efd3ba4ec2608b1d$var$MyWindow_gdps = window.open(link_, model);
        else if (model == "GEFS") $efd3ba4ec2608b1d$var$MyWindow_gefs = window.open(link_, model);
        else if (model == "RDPS") $efd3ba4ec2608b1d$var$MyWindow_rdps = window.open(link_, model);
        else if (model == "HRDPS") $efd3ba4ec2608b1d$var$MyWindow_hrdps = window.open(link_, model);
        else if (model == "GFS") $efd3ba4ec2608b1d$var$MyWindow_gfs = window.open(link_, model);
    } else {
        var specs = "";
        var w_ = 0;
        var h_ = 0;
        const viewwidth = Math.max(screen.availWidth || 0, document.documentElement.clientWidth || 0);
        const viewheight = Math.max(screen.availHeight || 0, document.documentElement.clientHeight || 0);
        w_ = parseInt(Math.min(Math.max(viewwidth / 3, 600), 1500));
        w_ = Math.min(viewwidth - 30, w_);
        var left_ = Math.max(viewwidth - w_, 0);
        h_ = parseInt(Math.min(Math.max(viewheight - 30, 600), 2000));
        h_ = Math.min(viewheight - 50, h_);
        var top_ = 50;
        specs = "width=" + w_ + ",height=" + h_ + ",left=" + left_ + ",top=" + top_;
        if (model == "ECMWF" || model == "ECMWF3" || model == "ECMWFE") $efd3ba4ec2608b1d$var$MyWindow_ecmwf = window.open(link_, model, specs);
        else if (model == "AIFS" || model == "AIFSE") $efd3ba4ec2608b1d$var$MyWindow_aifs = window.open(link_, model, specs);
        else if (model == "GDPS") $efd3ba4ec2608b1d$var$MyWindow_gdps = window.open(link_, model, specs);
        else if (model == "GDPSE") $efd3ba4ec2608b1d$var$MyWindow_gdps = window.open(link_, model, specs);
        else if (model == "GEFS") $efd3ba4ec2608b1d$var$MyWindow_gefs = window.open(link_, model, specs);
        else if (model == "RDPS") $efd3ba4ec2608b1d$var$MyWindow_rdps = window.open(link_, model, specs);
        else if (model == "HRDPS") $efd3ba4ec2608b1d$var$MyWindow_hrdps = window.open(link_, model, specs);
        else if (model == "GFS") $efd3ba4ec2608b1d$var$MyWindow_gfs = window.open(link_, model, specs);
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$RefreshSpotWxGraph(no_) {
    var model_ = $efd3ba4ec2608b1d$var$Couche1.getModele();
    var hourOId_ = $efd3ba4ec2608b1d$var$Couche1.getHourOId();
    var progMin_ = $efd3ba4ec2608b1d$var$listProg1minu[$efd3ba4ec2608b1d$var$ISTEP];
    if (no_ == "2") {
        model_ = $efd3ba4ec2608b1d$var$Couche2.getModele();
        hourOId_ = $efd3ba4ec2608b1d$var$Couche2.getHourOId();
        progMin_ = $efd3ba4ec2608b1d$var$listProg2minu[$efd3ba4ec2608b1d$var$ISTEP];
    }
    var timSer = no_ == "1" && $efd3ba4ec2608b1d$var$Valeur1 == "TimSer" || no_ == "2" && $efd3ba4ec2608b1d$var$Valeur2 == "TimSer";
    var timSer_e = no_ == "1" && $efd3ba4ec2608b1d$var$Valeur1 == "TimSer_e" || no_ == "2" && $efd3ba4ec2608b1d$var$Valeur2 == "TimSer_e";
    var meteoGrm = no_ == "1" && $efd3ba4ec2608b1d$var$Valeur1 == "MeteoGrm" || no_ == "2" && $efd3ba4ec2608b1d$var$Valeur2 == "MeteoGrm";
    var spotwx_model = "void";
    var link_prev = "https://spotwx.com/products/grib_index.php?model=" + spotwx_model + "&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon + "&tz=America/Montreal";
    var myWindow = false;
    if (model_ == "HRDPS") {
        spotwx_model = "gem_lam_continental";
        link_prev = "https://spotwx.com/products/grib_index.php?model=" + spotwx_model + "&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon + "&tz=America/Montreal";
        if (timSer_e) $efd3ba4ec2608b1d$var$WillOpenWin(link_prev, model_, $efd3ba4ec2608b1d$var$MyWindow_hrdps);
    } else if (model_ == "RDPS") {
        spotwx_model = "gem_reg_10km";
        link_prev = "https://spotwx.com/products/grib_index.php?model=" + spotwx_model + "&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon + "&tz=America/Montreal";
        if (timSer_e) $efd3ba4ec2608b1d$var$WillOpenWin(link_prev, model_, $efd3ba4ec2608b1d$var$MyWindow_rdps);
    } else if (model_ == "GDPS") {
        if (meteoGrm) {
            spotwx_model = "geps_0p5_raw";
            link_prev = "https://spotwx.com/products/grib_index.php?model=" + spotwx_model + "&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon + "&tz=America/Montreal";
            $efd3ba4ec2608b1d$var$WillOpenWin(link_prev, "GEFS", $efd3ba4ec2608b1d$var$MyWindow_gefs);
        } else {
            spotwx_model = "gem_glb_25km";
            link_prev = "https://spotwx.com/products/grib_index.php?model=" + spotwx_model + "&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon + "&tz=America/Montreal";
            if (timSer_e) $efd3ba4ec2608b1d$var$WillOpenWin(link_prev, model_, $efd3ba4ec2608b1d$var$MyWindow_gdps);
        }
    } else if (model_ == "GFS") {
        spotwx_model = "gfs_pgrb2_0p25_f";
        link_prev = "https://spotwx.com/products/grib_index.php?model=" + spotwx_model + "&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon + "&tz=America/Montreal";
        if (timSer_e) $efd3ba4ec2608b1d$var$WillOpenWin(link_prev, model_, $efd3ba4ec2608b1d$var$MyWindow_gfs);
    } else if (model_ == "ECMWF" || model_ == "ECMWF3") {
        if (meteoGrm) {
            link_prev = "https://charts.ecmwf.int/products/opencharts_meteogram?base_time=" + hourOId_ + "00&epsgram=classical_10d&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon;
            $efd3ba4ec2608b1d$var$message = " Lien ECMWF: " + link_prev;
            console.log($efd3ba4ec2608b1d$var$message);
            $efd3ba4ec2608b1d$var$WillOpenWin(link_prev, model_, $efd3ba4ec2608b1d$var$MyWindow_ecmwf);
        } else if (no_ == "1" && $efd3ba4ec2608b1d$var$Valeur1 == "ProfVert" || no_ == "2" && $efd3ba4ec2608b1d$var$Valeur2 == "ProfVert") {
            var valid_time_ = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes(hourOId_, progMin_, true);
            if (parseInt(progMin_ / 60) > 120) //alert( " Les profils verticaux ECMWF ne sont pas produit au delà de 120 heures d'échéance");
            $efd3ba4ec2608b1d$var$openAfficheInfo(" Les profils verticaux ECMWF ne sont pas produit au del\xe0 de 120 heures d'\xe9ch\xe9ance", 6);
            else {
                link_prev = "https://charts.ecmwf.int/products/opencharts_vertical-profile-meteogram?base_time=" + hourOId_ + "00&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon + "&valid_time=" + valid_time_ + "00";
                $efd3ba4ec2608b1d$var$message = " Lien ECMWF: " + link_prev;
                console.log($efd3ba4ec2608b1d$var$message);
                $efd3ba4ec2608b1d$var$WillOpenWin(link_prev, model_, $efd3ba4ec2608b1d$var$MyWindow_ecmwf);
            }
        } else {
            spotwx_model = "ecmwf_ifs";
            link_prev = "https://spotwx.com/products/grib_index.php?model=" + spotwx_model + "&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon + "&tz=America/Montreal";
            if (timSer_e) $efd3ba4ec2608b1d$var$WillOpenWin(link_prev, model_, $efd3ba4ec2608b1d$var$MyWindow_ecmwf);
        }
    //   https://charts.ecmwf.int/products/opencharts_vertical-profile-meteogram?base_time=202401160000&lat=51.4333&lon=-1.0&station_name=Reading&valid_time=202401160000
    //            https://charts.ecmwf.int/products/opencharts_meteogram?base_time=202302040000&epsgram=classical_10d&lat=45.4333&lon=-73&valid_time=yyyymmddhh00
    } else if (model_ == "AIFS") {
        if (meteoGrm) {
            ///                    https://charts.ecmwf.int/products/aifs_opencharts_meteogram?base_time=202412100000&epsgram=aifs_classical_10d&lat=51.4333&lon=-1.0&station_name=Reading
            link_prev = "https://charts.ecmwf.int/products/aifs_opencharts_meteogram?base_time=" + hourOId_ + "00&epsgram=aifs_classical_10d&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon;
            $efd3ba4ec2608b1d$var$message = " Lien AIFS: " + link_prev;
            console.log($efd3ba4ec2608b1d$var$message);
            $efd3ba4ec2608b1d$var$WillOpenWin(link_prev, model_, $efd3ba4ec2608b1d$var$MyWindow_aifs);
        } else {
            spotwx_model = "ecmwf_aifs_single";
            link_prev = "https://spotwx.com/products/grib_index.php?model=" + spotwx_model + "&lat=" + $efd3ba4ec2608b1d$var$PopupLat + "&lon=" + $efd3ba4ec2608b1d$var$PopupLon + "&tz=America/Montreal";
            if (timSer_e) $efd3ba4ec2608b1d$var$WillOpenWin(link_prev, model_, $efd3ba4ec2608b1d$var$MyWindow_aifs);
        }
    }
    if (timSer) {
        document.getElementById("spot_iframe").style.display = "inherit";
        document.getElementById("spot_iframe").style.visibility = "hidden";
        document.getElementById("spot_iframe").src = link_prev;
    }
}
// ________________________________________________________________________________
// ________________________________________________________________________________
document.getElementById("spot_iframe").onload = function() {
    document.getElementById("spot_iframe").style.visibility = "visible";
    console.log("TimSer loaded");
};
// ________________________________________________________________________________
// -----------------------------------------------------------------------------------
//   Selector  for Opacitee
const $efd3ba4ec2608b1d$var$OpaciteSelect1 = document.getElementById("opacite1");
const $efd3ba4ec2608b1d$var$OpaciteSelect2 = document.getElementById("opacite2");
if ($efd3ba4ec2608b1d$var$WindMaps) $efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect1.options.length - 1;
$efd3ba4ec2608b1d$var$Opacitee1 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect1.options[$efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex].value) / 10.;
$efd3ba4ec2608b1d$var$Opacitee2 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect2.options[$efd3ba4ec2608b1d$var$OpaciteSelect2.options.selectedIndex].value) / 10.;
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateOpaciteeFromMenu(no, resume) {
    $efd3ba4ec2608b1d$var$StopAnimate();
    var message = " Changing opacit\xe9 de la couche: " + no.toString();
    console.log(message);
    if (no == 1) $efd3ba4ec2608b1d$var$Opacitee1 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect1.options[$efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex].value) / 10.;
    else if (no == 2) $efd3ba4ec2608b1d$var$Opacitee2 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect2.options[$efd3ba4ec2608b1d$var$OpaciteSelect2.options.selectedIndex].value) / 10.;
    if (resume) {
        if ($efd3ba4ec2608b1d$var$ActiveLoop) $efd3ba4ec2608b1d$var$StartAnimate();
        else $efd3ba4ec2608b1d$var$Refresh();
    }
}
// ________________________________________________________________________________
// Handle change event.
//
$efd3ba4ec2608b1d$var$OpaciteSelect1.onchange = function() {
    $efd3ba4ec2608b1d$var$updateOpaciteeFromMenu(1, true);
};
$efd3ba4ec2608b1d$var$OpaciteSelect2.onchange = function() {
    $efd3ba4ec2608b1d$var$updateOpaciteeFromMenu(2, true);
};
// -----------------------------------------------------------------------------------
//   Selector  for Ani mod => Animation mode
const $efd3ba4ec2608b1d$var$DprogDtSelect = document.getElementById("dprogdt");
var $efd3ba4ec2608b1d$var$DprogDt = false;
var $efd3ba4ec2608b1d$var$DprogDt_ferme = false;
var $efd3ba4ec2608b1d$var$DprogDt_ouvre = false;
var $efd3ba4ec2608b1d$var$SDprogDt = $efd3ba4ec2608b1d$var$DprogDtSelect.options[$efd3ba4ec2608b1d$var$DprogDtSelect.options.selectedIndex].value;
if ($efd3ba4ec2608b1d$var$SDprogDt == "true") $efd3ba4ec2608b1d$var$DprogDt = true;
var $efd3ba4ec2608b1d$var$DprogDt_ISTEP = 0;
var $efd3ba4ec2608b1d$var$DprogDt_ISTEP_max = $efd3ba4ec2608b1d$var$ISTEP_max;
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateDprogDtFromMenu() {
    let modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    let modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    if (nowcast1 || nowcast2) {
        $efd3ba4ec2608b1d$var$SDprogDt = "false";
        $efd3ba4ec2608b1d$var$DprogDt = false;
        $efd3ba4ec2608b1d$var$DprogDtSelect.options.selectedIndex = 0;
        alert(" Le mode DprogDt n est pas disponible lorsqu une couche nowcasting est pr\xe9sente Radar ou satellite). ");
    } else {
        $efd3ba4ec2608b1d$var$ActiveLoop = false;
        $efd3ba4ec2608b1d$var$StopAnimate();
        document.getElementById("StopAnimate").style.display = "none";
        document.getElementById("StartAnimate").style.display = "initial";
        var couche_change_pas = true;
        var message = " Changement du mode d'animation ";
        console.log(message);
        $efd3ba4ec2608b1d$var$DprogDt = false;
        $efd3ba4ec2608b1d$var$SDprogDt = $efd3ba4ec2608b1d$var$DprogDtSelect.options[$efd3ba4ec2608b1d$var$DprogDtSelect.options.selectedIndex].value;
        if ($efd3ba4ec2608b1d$var$SDprogDt == "true") {
            $efd3ba4ec2608b1d$var$DprogDt_ISTEP = $efd3ba4ec2608b1d$var$ISTEP;
            $efd3ba4ec2608b1d$var$DprogDt_ISTEP_max = $efd3ba4ec2608b1d$var$ISTEP_max;
            $efd3ba4ec2608b1d$var$DprogDt = true;
            $efd3ba4ec2608b1d$var$DebutSelect.style.display = "none";
            $efd3ba4ec2608b1d$var$FinSelect.style.display = "none";
            document.getElementById("resetDebut").style.display = "none";
            document.getElementById("resetFin").style.display = "none";
            $efd3ba4ec2608b1d$var$setMenuHourOId(true, 1, $efd3ba4ec2608b1d$var$HourOId1Select);
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$HourOId1Select.options.length - 1;
            $efd3ba4ec2608b1d$var$ISTEP_max = $efd3ba4ec2608b1d$var$ISTEP;
            $efd3ba4ec2608b1d$var$DprogDt_ouvre = true;
        } else {
            $efd3ba4ec2608b1d$var$DprogDt = false;
            $efd3ba4ec2608b1d$var$DebutSelect.style.display = "block";
            $efd3ba4ec2608b1d$var$FinSelect.style.display = "block";
            document.getElementById("resetDebut").style.display = "block";
            document.getElementById("resetFin").style.display = "block";
            $efd3ba4ec2608b1d$var$ResetModeleDefaults = true;
            couche_change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(true, 1, $efd3ba4ec2608b1d$var$HourOId1Select);
            if (!$efd3ba4ec2608b1d$var$Couche2Void) couche_change_pas = $efd3ba4ec2608b1d$var$setMenuHourOId(true, 2, $efd3ba4ec2608b1d$var$HourOId2Select);
            couche_change_pas = $efd3ba4ec2608b1d$var$setMenuInterval();
            couche_change_pas = $efd3ba4ec2608b1d$var$setMenuDebut();
            couche_change_pas = $efd3ba4ec2608b1d$var$setMenuFin();
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$DprogDt_ISTEP;
            $efd3ba4ec2608b1d$var$ISTEP_max = $efd3ba4ec2608b1d$var$DprogDt_ISTEP_max;
            $efd3ba4ec2608b1d$var$DprogDt_ferme = true;
        }
        $efd3ba4ec2608b1d$var$ResetModeleDefaults = false;
        $efd3ba4ec2608b1d$var$setListProgTimes();
        $efd3ba4ec2608b1d$var$Refresh();
    }
}
// ________________________________________________________________________________
// Handle change event.
//
if ($efd3ba4ec2608b1d$var$WindMaps) {
    document.getElementById("dprogdt").style.display = "none";
    document.getElementById("labelAnimMode").style.display = "none";
} else $efd3ba4ec2608b1d$var$DprogDtSelect.onchange = function() {
    $efd3ba4ec2608b1d$var$updateDprogDtFromMenu();
};
// ________________________________________________________________________________
//
//   couche Intercallé superposé  ou juxtaposé ------------------------------------------------------
//    couche superposées par défaut
//
var $efd3ba4ec2608b1d$var$L_Interca = false;
var $efd3ba4ec2608b1d$var$L_Juxtapo = false;
var $efd3ba4ec2608b1d$var$Intercalage = "non";
var $efd3ba4ec2608b1d$var$Juxtaposition = "non";
//   Selector  for L_Interca   et L_Juxtapo
const $efd3ba4ec2608b1d$var$IntercaSelect = document.getElementById("interca");
$efd3ba4ec2608b1d$var$setMenuInterca("noStorage");
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$gereFenetreJuxtapo(ouvre) {
    const map_et_map2_Wrapper = document.getElementById("map_et_map2_wrapper");
    const map2_Target = document.getElementById("map2");
    const map_Target = document.getElementById("map");
    const affiche_temps_valide2 = document.getElementById("affiche_temps_valide2");
    const affiche_temps_valide1 = document.getElementById("affiche_temps_valide1");
    const affiche_temps_valide = document.getElementById("affiche_temps_valide");
    const afficheHor2 = document.getElementById("divAfficheHor2");
    const afficheHor = document.getElementById("divAfficheHor");
    const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if (ouvre) {
        $efd3ba4ec2608b1d$var$L_Juxtapo = true;
        $efd3ba4ec2608b1d$var$L_Interca = false;
        $efd3ba4ec2608b1d$var$UnsetValeurs("0");
        $efd3ba4ec2608b1d$var$map.removeLayer($efd3ba4ec2608b1d$var$imageLayers2Group);
        $efd3ba4ec2608b1d$var$map2.addLayer($efd3ba4ec2608b1d$var$imageLayers2Group);
        $efd3ba4ec2608b1d$var$map.removeLayer($efd3ba4ec2608b1d$var$tileLayers2Group);
        $efd3ba4ec2608b1d$var$map2.addLayer($efd3ba4ec2608b1d$var$tileLayers2Group);
        $efd3ba4ec2608b1d$var$map.removeOverlay($efd3ba4ec2608b1d$var$Popup2Overlay);
        $efd3ba4ec2608b1d$var$map2.addOverlay($efd3ba4ec2608b1d$var$Popup2Overlay);
        var largeur = 50;
        if (viewwidth < 800) largeur = 100;
        map_Target.style.width = largeur.toString() + "%";
        map2_Target.style.width = largeur.toString() + "%";
        map2_Target.style.display = "inherit";
        affiche_temps_valide2.style.display = "inherit";
        affiche_temps_valide1.style.display = "inherit";
        affiche_temps_valide.style.display = "none";
        window.dispatchEvent(new Event("resize"));
        $efd3ba4ec2608b1d$var$map.updateSize();
        $efd3ba4ec2608b1d$var$map2.updateSize();
        $efd3ba4ec2608b1d$var$updateViewProjection();
    } else {
        $efd3ba4ec2608b1d$var$L_Juxtapo = false;
        $efd3ba4ec2608b1d$var$ResetValeurs();
        $efd3ba4ec2608b1d$var$map2.removeLayer($efd3ba4ec2608b1d$var$imageLayers2Group);
        $efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$imageLayers2Group);
        $efd3ba4ec2608b1d$var$map2.removeLayer($efd3ba4ec2608b1d$var$tileLayers2Group);
        $efd3ba4ec2608b1d$var$map.addLayer($efd3ba4ec2608b1d$var$tileLayers2Group);
        $efd3ba4ec2608b1d$var$map2.removeOverlay($efd3ba4ec2608b1d$var$Popup2Overlay);
        $efd3ba4ec2608b1d$var$map.addOverlay($efd3ba4ec2608b1d$var$Popup2Overlay);
        map_Target.style.width = "100%";
        map2_Target.style.display = "none";
        affiche_temps_valide2.style.display = "none";
        affiche_temps_valide1.style.display = "none";
        affiche_temps_valide.style.display = "inherit";
        window.dispatchEvent(new Event("resize"));
        $efd3ba4ec2608b1d$var$map.updateSize();
    }
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateIntercaFromMenu(wantRefresh) {
    $efd3ba4ec2608b1d$var$StopAnimate();
    var proposedInterca = $efd3ba4ec2608b1d$var$IntercaSelect.options[$efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex].value;
    let modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    let modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    if (proposedInterca == "interca") {
        if ($efd3ba4ec2608b1d$var$Couche2Void) {
            $efd3ba4ec2608b1d$var$L_Interca = false;
            if ($efd3ba4ec2608b1d$var$L_Juxtapo) $efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex = 2;
            else $efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex = 1;
            alert(" Le mode Intercal\xe9 fonctionne uniquement lorsque la couche 2 est pr\xe9sente. ");
        } else {
            $efd3ba4ec2608b1d$var$L_Interca = true;
            if ($efd3ba4ec2608b1d$var$L_Juxtapo) $efd3ba4ec2608b1d$var$gereFenetreJuxtapo(false);
            if ($efd3ba4ec2608b1d$var$WindMaps) {
                localStorage.setItem("Intercalage_V", "oui");
                localStorage.setItem("Juxtaposition_V", "non");
            } else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) {
                localStorage.setItem("Intercalage_N", "oui");
                localStorage.setItem("Juxtaposition_N", "non");
            } else {
                localStorage.setItem("Intercalage", "oui");
                localStorage.setItem("Juxtaposition", "non");
            }
        }
    } else {
        $efd3ba4ec2608b1d$var$L_Interca = false;
        $efd3ba4ec2608b1d$var$affichage_meta_informations(-1);
        $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
        $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
        if ($efd3ba4ec2608b1d$var$WindMaps) localStorage.setItem("Intercalage_V", "non");
        else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) localStorage.setItem("Intercalage_N", "non");
        else localStorage.setItem("Intercalage", "non");
        if (proposedInterca == "juxtap") {
            //              Juxtapo
            $efd3ba4ec2608b1d$var$gereFenetreJuxtapo(true);
            if ($efd3ba4ec2608b1d$var$WindMaps) localStorage.setItem("Juxtaposition_V", "oui");
            else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) localStorage.setItem("Juxtaposition_N", "oui");
            else localStorage.setItem("Juxtaposition", "oui");
        } else {
            //              superpo
            if ($efd3ba4ec2608b1d$var$L_Juxtapo) $efd3ba4ec2608b1d$var$gereFenetreJuxtapo(false);
            if ($efd3ba4ec2608b1d$var$WindMaps) localStorage.setItem("Juxtaposition_V", "non");
            else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) localStorage.setItem("Juxtaposition_N", "non");
            else localStorage.setItem("Juxtaposition", "non");
        }
    }
    if ($efd3ba4ec2608b1d$var$ActiveLoop) $efd3ba4ec2608b1d$var$StartAnimate();
    else if (wantRefresh == "refresh") $efd3ba4ec2608b1d$var$Refresh();
}
// ________________________________________________________________________________
// Handle change event.
//
////if ( WindMaps ) {
////   document.getElementById("interca").style.display = "none";
////   document.getElementById("labelCouches").style.display = "none";
////} else {
$efd3ba4ec2608b1d$var$IntercaSelect.onchange = function() {
    $efd3ba4ec2608b1d$var$updateIntercaFromMenu("refresh");
};
if ($efd3ba4ec2608b1d$var$Nowcast) {
    $efd3ba4ec2608b1d$var$Intercalage = localStorage.getItem("Intercalage_N");
    $efd3ba4ec2608b1d$var$Juxtaposition = localStorage.getItem("Juxtaposition_N");
} else {
    $efd3ba4ec2608b1d$var$Intercalage = localStorage.getItem("Intercalage");
    $efd3ba4ec2608b1d$var$Juxtaposition = localStorage.getItem("Juxtaposition");
}
if ($efd3ba4ec2608b1d$var$Intercalage == "oui") {
    $efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex = 0;
    $efd3ba4ec2608b1d$var$updateIntercaFromMenu("noRefresh");
} else if ($efd3ba4ec2608b1d$var$Juxtaposition == "oui") {
    $efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex = 2;
    $efd3ba4ec2608b1d$var$updateIntercaFromMenu("noRefresh");
}
////}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$setMenuInterca(storage_) {
    $efd3ba4ec2608b1d$var$IntercaSelect.options.length = 0;
    $efd3ba4ec2608b1d$var$IntercaSelect.options[$efd3ba4ec2608b1d$var$IntercaSelect.options.length] = new Option("Interca", "interca");
    $efd3ba4ec2608b1d$var$IntercaSelect.options[$efd3ba4ec2608b1d$var$IntercaSelect.options.length] = new Option("Superp", "superp");
    $efd3ba4ec2608b1d$var$IntercaSelect.options[$efd3ba4ec2608b1d$var$IntercaSelect.options.length] = new Option("Juxtap", "juxtap");
    $efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex = 1;
    $efd3ba4ec2608b1d$var$L_Interca = false;
    $efd3ba4ec2608b1d$var$L_Juxtapo = false;
    $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
    $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
    $efd3ba4ec2608b1d$var$affichage_meta_informations(-1);
    let modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    let modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    if (storage_ != "noStorage") {
        if ($efd3ba4ec2608b1d$var$WindMaps) localStorage.setItem("Intercalage_V", "non");
        else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) localStorage.setItem("Intercalage_N", "non");
        else localStorage.setItem("Intercalage", "non");
    }
}
// ________________________________________________________________________________
//
//
//   TIME   ------------------------------------------------------
//
const $efd3ba4ec2608b1d$var$listProg1minu = []; //  pronostic time en minutes
const $efd3ba4ec2608b1d$var$listProg2minu = [];
const $efd3ba4ec2608b1d$var$listProg1 = []; //  pronostic time en heures (string 3 caract'eres)
const $efd3ba4ec2608b1d$var$listProg2 = [];
const $efd3ba4ec2608b1d$var$listHourOId1 = []; // heure d origines YYYYMMDD sauf pour GOESR et RADAR YYYYMMDDHH
const $efd3ba4ec2608b1d$var$listHourOId2 = [];
const $efd3ba4ec2608b1d$var$listUrl1 = []; //   full path vers les images a aficher
const $efd3ba4ec2608b1d$var$listUrl2 = [];
const $efd3ba4ec2608b1d$var$listLoaded1 = []; //  flag a propos du load de l image
const $efd3ba4ec2608b1d$var$listLoaded2 = [];
const $efd3ba4ec2608b1d$var$listNuLoadEnd1 = []; //  flag a propos du nombre de tuile loaded
const $efd3ba4ec2608b1d$var$listNuLoadEnd2 = [];
const $efd3ba4ec2608b1d$var$listNuLoadStart1 = []; //  flag a propos du nombre de tuile load started
const $efd3ba4ec2608b1d$var$listNuLoadStart2 = [];
const $efd3ba4ec2608b1d$var$listNuLoadErr1 = []; //  flag a propos du nombre de tuile load en erreur
const $efd3ba4ec2608b1d$var$listNuLoadErr2 = [];
const $efd3ba4ec2608b1d$var$listNuWait1 = []; // compteur du nombre de fois ou l image n etait pas prete a afficher
const $efd3ba4ec2608b1d$var$listNuWait2 = [];
const $efd3ba4ec2608b1d$var$listUrlCo1 = []; //   full path vers les Co images a afich
const $efd3ba4ec2608b1d$var$listUrlCo2 = [];
const $efd3ba4ec2608b1d$var$listLoadedCo1 = []; //  flag a propos du load de l image Co
const $efd3ba4ec2608b1d$var$listLoadedCo2 = [];
const $efd3ba4ec2608b1d$var$listNuLoadEndCo1 = []; //  flag a propos du nombre de tuile Co loaded
const $efd3ba4ec2608b1d$var$listNuLoadEndCo2 = [];
const $efd3ba4ec2608b1d$var$listNuLoadStartCo1 = []; //  flag a propos du nombre de tuile Co load started
const $efd3ba4ec2608b1d$var$listNuLoadStartCo2 = [];
const $efd3ba4ec2608b1d$var$listNuLoadErrCo1 = []; //  flag a propos du nombre de tuile Co load en erreur
const $efd3ba4ec2608b1d$var$listNuLoadErrCo2 = [];
const $efd3ba4ec2608b1d$var$listNuWaitCo1 = []; // compteur du nombre de fois ou l image n etait pas prete a afficher
const $efd3ba4ec2608b1d$var$listNuWaitCo2 = [];
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$feedListProgTimes(no_, ii_, houroid_, progMinutes) {
    let hours = 0;
    let s_hours = "";
    if (no_ == "0" || no_ == "1") {
        $efd3ba4ec2608b1d$var$listProg1minu[ii_] = progMinutes;
        hours = Math.round(progMinutes / 60.);
        s_hours = hours.toString();
        if (s_hours.length < 3) s_hours = "0" + s_hours;
        if (s_hours.length < 3) s_hours = "0" + s_hours;
        $efd3ba4ec2608b1d$var$listProg1[ii_] = s_hours;
        $efd3ba4ec2608b1d$var$listHourOId1[ii_] = houroid_;
        $efd3ba4ec2608b1d$var$listUrl1[ii_] = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche1.getModele(), $efd3ba4ec2608b1d$var$Couche1.getZoomId(), $efd3ba4ec2608b1d$var$Couche1.getMapId(), $efd3ba4ec2608b1d$var$listHourOId1[ii_], $efd3ba4ec2608b1d$var$listProg1[ii_]);
        $efd3ba4ec2608b1d$var$listLoaded1[ii_] = "non";
        $efd3ba4ec2608b1d$var$listNuWait1[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuLoadEnd1[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuLoadStart1[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuLoadErr1[ii_] = 0;
        if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) $efd3ba4ec2608b1d$var$listUrlCo1[ii_] = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche1.getModele(), $efd3ba4ec2608b1d$var$Couche1.getZoomId(), $efd3ba4ec2608b1d$var$Couche1.mapIdCo, $efd3ba4ec2608b1d$var$listHourOId1[ii_], $efd3ba4ec2608b1d$var$listProg1[ii_]);
        else $efd3ba4ec2608b1d$var$listUrlCo1[ii_] = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche1.getModele(), $efd3ba4ec2608b1d$var$Couche1.getZoomId(), $efd3ba4ec2608b1d$var$Couche1.getMapId(), $efd3ba4ec2608b1d$var$listHourOId1[ii_], $efd3ba4ec2608b1d$var$listProg1[ii_]);
        $efd3ba4ec2608b1d$var$listLoadedCo1[ii_] = "non";
        $efd3ba4ec2608b1d$var$listNuLoadEndCo1[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuLoadStartCo1[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuLoadErrCo1[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuWaitCo1[ii_] = 0;
    }
    if (no_ == "0" || no_ == "2") {
        $efd3ba4ec2608b1d$var$listProg2minu[ii_] = progMinutes;
        hours = Math.round(progMinutes / 60.);
        s_hours = hours.toString();
        if (s_hours.length < 3) s_hours = "0" + s_hours;
        if (s_hours.length < 3) s_hours = "0" + s_hours;
        $efd3ba4ec2608b1d$var$listProg2[ii_] = s_hours;
        $efd3ba4ec2608b1d$var$listHourOId2[ii_] = houroid_;
        $efd3ba4ec2608b1d$var$listUrl2[ii_] = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche2.getModele(), $efd3ba4ec2608b1d$var$Couche2.getZoomId(), $efd3ba4ec2608b1d$var$Couche2.getMapId(), $efd3ba4ec2608b1d$var$listHourOId2[ii_], $efd3ba4ec2608b1d$var$listProg2[ii_]);
        $efd3ba4ec2608b1d$var$listLoaded2[ii_] = "non";
        $efd3ba4ec2608b1d$var$listNuWait2[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuLoadEnd2[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuLoadStart2[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuLoadErr2[ii_] = 0;
        if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) $efd3ba4ec2608b1d$var$listUrlCo2[ii_] = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche2.getModele(), $efd3ba4ec2608b1d$var$Couche2.getZoomId(), $efd3ba4ec2608b1d$var$Couche2.mapIdCo, $efd3ba4ec2608b1d$var$listHourOId2[ii_], $efd3ba4ec2608b1d$var$listProg2[ii_]);
        else $efd3ba4ec2608b1d$var$listUrlCo2[ii_] = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche2.getModele(), $efd3ba4ec2608b1d$var$Couche2.getZoomId(), $efd3ba4ec2608b1d$var$Couche2.getMapId(), $efd3ba4ec2608b1d$var$listHourOId2[ii_], $efd3ba4ec2608b1d$var$listProg2[ii_]);
        $efd3ba4ec2608b1d$var$listLoadedCo2[ii_] = "non";
        $efd3ba4ec2608b1d$var$listNuLoadEndCo2[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuLoadStartCo2[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuLoadErrCo2[ii_] = 0;
        $efd3ba4ec2608b1d$var$listNuWaitCo2[ii_] = 0;
    }
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$setListProgTimes() {
    //  recalcul des liste de houroid et prog time pour la séqunce tem,portelles de cartes pour
    //  les couches 1 et 2
    //
    //
    $efd3ba4ec2608b1d$var$StopAnimate();
    let minutes1 = 0;
    let minutes2 = 0;
    var hours1 = 0;
    var hours2 = 0;
    var ii = 0;
    var s_heure_prog = 0;
    var istep_max = 0;
    var istep_max_1 = 0;
    var istep_max_2 = 0;
    var message = " ";
    var validTime1 = " ";
    var validTime2 = " ";
    var trouve = false;
    var debut_1 = $efd3ba4ec2608b1d$var$Couche1.getDebut();
    var debut_2 = $efd3ba4ec2608b1d$var$Couche2.getDebut();
    var fin_1 = $efd3ba4ec2608b1d$var$Couche1.getFin();
    var fin_2 = $efd3ba4ec2608b1d$var$Couche2.getFin();
    var houroid_1 = $efd3ba4ec2608b1d$var$Couche1.getHourOId();
    var houroid_2 = $efd3ba4ec2608b1d$var$Couche2.getHourOId();
    var modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    var modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    var zoomMax = 0;
    var oldZoomMax = 0;
    var verbose_ = true;
    if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get(modele1) != "Image") {
        oldZoomMax = $efd3ba4ec2608b1d$var$Resolutions1.length - 1;
        for(let ii = oldZoomMax; ii >= 0; ii = ii - 1)$efd3ba4ec2608b1d$var$Resolutions1.pop();
        oldZoomMax = $efd3ba4ec2608b1d$var$ResolutionsCo1.length - 1;
        for(let ii = oldZoomMax; ii >= 0; ii = ii - 1)$efd3ba4ec2608b1d$var$ResolutionsCo1.pop();
        message = "++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++";
        console.log(message);
        message = "SetListProg: Resolutions des tuiles couche 1 au d\xe9part:" + $efd3ba4ec2608b1d$var$Couche1.mapIdH + " " + $efd3ba4ec2608b1d$var$Resolutions1;
        console.log(message);
        zoomMax = 2;
        for(let ii = 0; ii <= $efd3ba4ec2608b1d$var$ListCarteCon.length - 1; ii = ii + 1)if ($efd3ba4ec2608b1d$var$Couche1.mapIdH.indexOf($efd3ba4ec2608b1d$var$ListCarteCon[ii]) != -1) zoomMax = 3;
        for(let ii = 0; ii <= $efd3ba4ec2608b1d$var$ListCartePix.length - 1; ii = ii + 1)if ($efd3ba4ec2608b1d$var$Couche1.mapIdH.indexOf($efd3ba4ec2608b1d$var$ListCartePix[ii]) != -1) zoomMax = 2;
        if (verbose_) console.log(" dimx: ", $efd3ba4ec2608b1d$var$ModToDimX.get(modele1), " dimY: ", $efd3ba4ec2608b1d$var$ModToDimY.get(modele1), " extent: ", $efd3ba4ec2608b1d$var$Couche1.extent, "Zmax: ", zoomMax);
        $efd3ba4ec2608b1d$var$Resolutions1 = $efd3ba4ec2608b1d$var$calculResolutions($efd3ba4ec2608b1d$var$ModToDimX.get(modele1), $efd3ba4ec2608b1d$var$ModToDimY.get(modele1), $efd3ba4ec2608b1d$var$Couche1.extent, $efd3ba4ec2608b1d$var$Resolutions1, zoomMax);
        zoomMax = 2;
        if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) {
            for(let ii = 0; ii <= $efd3ba4ec2608b1d$var$ListCarteCon.length - 1; ii = ii + 1)if ($efd3ba4ec2608b1d$var$Couche1.mapIdCo.indexOf($efd3ba4ec2608b1d$var$ListCarteCon[ii]) != -1) zoomMax = 3;
            for(let ii = 0; ii <= $efd3ba4ec2608b1d$var$ListCartePix.length - 1; ii = ii + 1)if ($efd3ba4ec2608b1d$var$Couche1.mapIdCo.indexOf($efd3ba4ec2608b1d$var$ListCartePix[ii]) != -1) zoomMax = 2;
        }
        $efd3ba4ec2608b1d$var$ResolutionsCo1 = $efd3ba4ec2608b1d$var$calculResolutions($efd3ba4ec2608b1d$var$ModToDimX.get(modele1), $efd3ba4ec2608b1d$var$ModToDimY.get(modele1), $efd3ba4ec2608b1d$var$Couche1.extent, $efd3ba4ec2608b1d$var$ResolutionsCo1, zoomMax);
        message = "################################################################################";
        console.log(message);
        message = "SetListProg: mapId couche 1:" + $efd3ba4ec2608b1d$var$Couche1.mapIdH + "  zoomMax: " + zoomMax + " MapIdCo: " + $efd3ba4ec2608b1d$var$Couche1.mapIdCo;
        console.log(message);
        message = "SetListProg: Resolutions des tuiles couche 1:" + $efd3ba4ec2608b1d$var$Couche1.mapIdH + " " + $efd3ba4ec2608b1d$var$Resolutions1;
        console.log(message);
        message = "SetListProg: Resolutions des Co tuiles couche 1:" + $efd3ba4ec2608b1d$var$Couche1.mapIdCo + " " + $efd3ba4ec2608b1d$var$ResolutionsCo1;
        console.log(message);
    } else {
        message = "SetListProg, couche 1: " + modele1 + " Image simple ";
        console.log(message);
        message = "SetListProg: mapId couche 1:" + $efd3ba4ec2608b1d$var$Couche1.mapIdH;
        console.log(message);
    }
    if ($efd3ba4ec2608b1d$var$ModToLyrTyp.get(modele2) != "Image") {
        zoomMax = 0;
        oldZoomMax = $efd3ba4ec2608b1d$var$Resolutions2.length - 1;
        for(let ii = oldZoomMax; ii >= 0; ii = ii - 1)$efd3ba4ec2608b1d$var$Resolutions2.pop();
        oldZoomMax = $efd3ba4ec2608b1d$var$ResolutionsCo2.length - 1;
        for(let ii = oldZoomMax; ii >= 0; ii = ii - 1)$efd3ba4ec2608b1d$var$ResolutionsCo2.pop();
        if (!$efd3ba4ec2608b1d$var$Couche2Void) {
            zoomMax = 2;
            for(let ii = 0; ii <= $efd3ba4ec2608b1d$var$ListCarteCon.length - 1; ii = ii + 1)if ($efd3ba4ec2608b1d$var$Couche2.mapIdH.indexOf($efd3ba4ec2608b1d$var$ListCarteCon[ii]) != -1) zoomMax = 3;
            for(let ii = 0; ii <= $efd3ba4ec2608b1d$var$ListCartePix.length - 1; ii = ii + 1)if ($efd3ba4ec2608b1d$var$Couche2.mapIdH.indexOf($efd3ba4ec2608b1d$var$ListCartePix[ii]) != -1) zoomMax = 2;
            $efd3ba4ec2608b1d$var$Resolutions2 = $efd3ba4ec2608b1d$var$calculResolutions($efd3ba4ec2608b1d$var$ModToDimX.get(modele2), $efd3ba4ec2608b1d$var$ModToDimY.get(modele2), $efd3ba4ec2608b1d$var$Couche2.extent, $efd3ba4ec2608b1d$var$Resolutions2, zoomMax);
            zoomMax = 2;
            if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) {
                for(let ii = 0; ii <= $efd3ba4ec2608b1d$var$ListCarteCon.length - 1; ii = ii + 1)if ($efd3ba4ec2608b1d$var$Couche2.mapIdCo.indexOf($efd3ba4ec2608b1d$var$ListCarteCon[ii]) != -1) zoomMax = 3;
                for(let ii = 0; ii <= $efd3ba4ec2608b1d$var$ListCartePix.length - 1; ii = ii + 1)if ($efd3ba4ec2608b1d$var$Couche2.mapIdCo.indexOf($efd3ba4ec2608b1d$var$ListCartePix[ii]) != -1) zoomMax = 2;
            }
            $efd3ba4ec2608b1d$var$ResolutionsCo2 = $efd3ba4ec2608b1d$var$calculResolutions($efd3ba4ec2608b1d$var$ModToDimX.get(modele2), $efd3ba4ec2608b1d$var$ModToDimY.get(modele2), $efd3ba4ec2608b1d$var$Couche2.extent, $efd3ba4ec2608b1d$var$ResolutionsCo2, zoomMax);
            message = "################################################################################";
            console.log(message);
            message = "SetListProg: mapId couche 2:" + $efd3ba4ec2608b1d$var$Couche2.mapIdH + "  zoomMax: " + zoomMax + " MapIdCo: " + $efd3ba4ec2608b1d$var$Couche2.mapIdCo;
            console.log(message);
            message = "SetListProg: Resolutions des tuiles couche 2:" + $efd3ba4ec2608b1d$var$Couche2.mapIdH + " " + $efd3ba4ec2608b1d$var$Resolutions2;
            console.log(message);
            message = "SetListProg: Resolutions des Co tuiles couche 2:" + $efd3ba4ec2608b1d$var$Couche2.mapIdCo + " " + $efd3ba4ec2608b1d$var$ResolutionsCo2;
            console.log(message);
        }
    } else {
        message = "SetListProg, couche 2: " + modele2 + " Image simple ";
        console.log(message);
        message = "SetListProg: mapId couche 2:" + $efd3ba4ec2608b1d$var$Couche1.mapIdH;
        console.log(message);
    }
    //-----------------------------------------------------------------------------------
    var interval = $efd3ba4ec2608b1d$var$Couche1.getInterval();
    //  Dans un contexte où l houroid  ou l'interval entre les pas de temps changent
    //  il arrive que le pas de temps ISTEP actuel ne corresponde pas
    //  du tout au même temps valide avant et après le changement.
    //  Exemple, si l'intervale de temps passe du 3 heures à 24 heures,
    //  on doit s'attendre à ce que le ISTEP soit 8 fois plus petit pour le même temps valide.
    //  Le but ici est de tenter de fournir un ISTEP qui préserve
    //  autant que possible le temps valide suite à un changement de houroid et-ou interval
    //   ou encore un changement de modèle
    //  la variable step est ce guess du pas de temps à la sortie de la fonction
    //
    var step = 0;
    var delta_t;
    // delta_t est le nombre d'heure à partir du houroid jusqu'au temps valide actuel
    // puisque les couches ont été mise à jour avant l'appel de la présente fonction
    // on utilise les listes listProg  et listHourOId afin de retrouver les valeurs
    // précédentes du temps de prog (listProg1minu[ISTEP]) en minutes et du debut (listProg1minu[0]) 
    // et ainsi estimer la valeur de step pour préserver le temps valid avec le nouvel interval.
    // et compte tenu d'un possible changement de la date d'origine (listHourOId1[0]  )
    //
    if ($efd3ba4ec2608b1d$var$DprogDt_ferme) {
        $efd3ba4ec2608b1d$var$DprogDt_ferme = false;
        step = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
    } else if ($efd3ba4ec2608b1d$var$DprogDt) {
        message = "SetListProg: ValidTime au debut..." + $efd3ba4ec2608b1d$var$ValidTime;
        console.log(message);
        var tempsValid = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$listProg1minu[$efd3ba4ec2608b1d$var$ISTEP], true);
        $efd3ba4ec2608b1d$var$ValidTime = $efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$listProg1minu[$efd3ba4ec2608b1d$var$ISTEP]);
        if ($efd3ba4ec2608b1d$var$DprogDt_ouvre) {
            $efd3ba4ec2608b1d$var$DprogDt_ouvre = false;
            tempsValid = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$DprogDt_ISTEP], $efd3ba4ec2608b1d$var$listProg1minu[$efd3ba4ec2608b1d$var$DprogDt_ISTEP], true);
            $efd3ba4ec2608b1d$var$ValidTime = $efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$DprogDt_ISTEP], $efd3ba4ec2608b1d$var$listProg1minu[$efd3ba4ec2608b1d$var$DprogDt_ISTEP]);
        }
        message = "SetListProg:   temps valide au debut... " + tempsValid;
        console.log(message);
        message = "SetListProg:   ValidTime recalcule au debut... " + $efd3ba4ec2608b1d$var$ValidTime;
        console.log(message);
        var portee = parseInt($efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes(houroid_1, parseInt(fin_1), true));
        if (portee < tempsValid) {
            message = " Le temps valide demand\xe9 est au del\xe0 de la portee maximale de la couche 1";
            alert(message);
            $efd3ba4ec2608b1d$var$ValidTime = $efd3ba4ec2608b1d$var$getAfficheValidDateTime(houroid_1, fin_1);
        }
        if (!$efd3ba4ec2608b1d$var$Couche2Void) {
            portee = parseInt($efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes(houroid_2, parseInt(fin_2), true));
            if (portee < tempsValid) {
                message = " Le temps valide demand\xe9 est au del\xe0 de la portee maximale de la couche 2";
                $efd3ba4ec2608b1d$var$ValidTime = $efd3ba4ec2608b1d$var$getAfficheValidDateTime(houroid_2, fin_2);
            }
        }
        step = $efd3ba4ec2608b1d$var$ISTEP_max;
    } else if (nowcast1) {
        $efd3ba4ec2608b1d$var$ISTEP = 0;
        step = 0;
        delta_t = 0;
    } else if ($efd3ba4ec2608b1d$var$ISTEP != 0) {
        delta_t = parseInt($efd3ba4ec2608b1d$var$listProg1minu[Math.min(Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max), $efd3ba4ec2608b1d$var$listProg1minu.length - 1)]) + $efd3ba4ec2608b1d$var$soustractionHourOId($efd3ba4ec2608b1d$var$listHourOId1[0], houroid_1, false);
        step = Math.max(parseInt((delta_t - parseInt(debut_1)) / interval), 0);
    }
    // destruction des anciennes listes
    for(ii = 0; ii <= $efd3ba4ec2608b1d$var$listProg1.length - 1; ii = ii + 1){
        $efd3ba4ec2608b1d$var$listProg1.pop();
        $efd3ba4ec2608b1d$var$listProg1minu.pop();
        $efd3ba4ec2608b1d$var$listHourOId1.pop();
        $efd3ba4ec2608b1d$var$listUrl1.pop();
        $efd3ba4ec2608b1d$var$listUrlCo1.pop();
        $efd3ba4ec2608b1d$var$listLoaded1.pop();
        $efd3ba4ec2608b1d$var$listLoadedCo1.pop();
        $efd3ba4ec2608b1d$var$listNuWait1.pop();
        $efd3ba4ec2608b1d$var$listNuWaitCo1.pop();
        $efd3ba4ec2608b1d$var$listNuLoadStart1.pop();
        $efd3ba4ec2608b1d$var$listNuLoadStartCo1.pop();
        $efd3ba4ec2608b1d$var$listNuLoadEnd1.pop();
        $efd3ba4ec2608b1d$var$listNuLoadEndCo1.pop();
        $efd3ba4ec2608b1d$var$listNuLoadErr1.pop();
        $efd3ba4ec2608b1d$var$listNuLoadErrCo1.pop();
    }
    for(ii = 0; ii <= $efd3ba4ec2608b1d$var$listProg2.length - 1; ii = ii + 1){
        $efd3ba4ec2608b1d$var$listProg2.pop();
        $efd3ba4ec2608b1d$var$listProg2minu.pop();
        $efd3ba4ec2608b1d$var$listHourOId2.pop();
        $efd3ba4ec2608b1d$var$listUrl2.pop();
        $efd3ba4ec2608b1d$var$listUrlCo2.pop();
        $efd3ba4ec2608b1d$var$listLoaded2.pop();
        $efd3ba4ec2608b1d$var$listLoadedCo2.pop();
        $efd3ba4ec2608b1d$var$listNuWait2.pop();
        $efd3ba4ec2608b1d$var$listNuWaitCo2.pop();
        $efd3ba4ec2608b1d$var$listNuLoadStart2.pop();
        $efd3ba4ec2608b1d$var$listNuLoadStartCo2.pop();
        $efd3ba4ec2608b1d$var$listNuLoadEnd2.pop();
        $efd3ba4ec2608b1d$var$listNuLoadEndCo2.pop();
        $efd3ba4ec2608b1d$var$listNuLoadErr2.pop();
        $efd3ba4ec2608b1d$var$listNuLoadErrCo2.pop();
    }
    for(ii = 0; ii <= $efd3ba4ec2608b1d$var$NoLimitOfLayers - 1; ii++){
        $efd3ba4ec2608b1d$var$imageLayers2[ii].setOpacity(0.);
        $efd3ba4ec2608b1d$var$imageLayers1[ii].setOpacity(0.);
        $efd3ba4ec2608b1d$var$tileLayers2[ii].setOpacity(0.);
        $efd3ba4ec2608b1d$var$tileLayers1[ii].setOpacity(0.);
        $efd3ba4ec2608b1d$var$tileLayersCo2[ii].setOpacity(0.);
        $efd3ba4ec2608b1d$var$tileLayersCo1[ii].setOpacity(0.);
    }
    //    Ok menage complété on va ré essigner des valeurs dans les listes...
    //    Debut de la grande section
    //    #######################################################
    if ($efd3ba4ec2608b1d$var$DprogDt && nowcast1) {
        let shouroid1 = "";
        let shouroid2 = "";
        let iicount = 0;
        for(ii = $efd3ba4ec2608b1d$var$HourOId1Select.options.length - 1; ii >= 0; ii--){
            shouroid1 = $efd3ba4ec2608b1d$var$HourOId1Select.options[ii].value;
            if ($efd3ba4ec2608b1d$var$getAfficheValidDateTime(shouroid1, 0) == $efd3ba4ec2608b1d$var$ValidTime) {
                //            ici on a trouve le shouroid qui correspond au temps valide...que l'on cherche
                //            il faut trouver les prog qui y correspondent sur la couche 2
                // ici on change temporairement l interval pour obtenir une interval de pcpn correct  si c est le cas
                $efd3ba4ec2608b1d$var$Couche2.interval = Math.max($efd3ba4ec2608b1d$var$ModAInterv.get(modele2), interval);
                for(let ii2 = $efd3ba4ec2608b1d$var$HourOId2Select.options.length - 1; ii2 >= 0; ii2--){
                    shouroid2 = $efd3ba4ec2608b1d$var$HourOId2Select.options[ii2].value;
                    for(minutes2 = $efd3ba4ec2608b1d$var$ModAInterv.get(modele2); minutes2 <= $efd3ba4ec2608b1d$var$ModAFin.get(modele2); minutes2 = minutes2 + $efd3ba4ec2608b1d$var$ModAInterv.get(modele2))if ($efd3ba4ec2608b1d$var$getAfficheValidDateTime(shouroid2, minutes2) == $efd3ba4ec2608b1d$var$ValidTime) {
                        $efd3ba4ec2608b1d$var$feedListProgTimes("1", iicount, shouroid1, 0);
                        $efd3ba4ec2608b1d$var$feedListProgTimes("2", iicount, shouroid2, minutes2);
                        iicount = iicount + 1;
                    }
                }
            }
        }
        //  ici on remet l intervale de la couche 2 a sa valeur
        $efd3ba4ec2608b1d$var$Couche2.interval = interval;
        istep_max_1 = iicount - 1;
        istep_max_2 = iicount - 1;
    //      fin de DprogDt && Nowcast1
    } else if ($efd3ba4ec2608b1d$var$DprogDt && nowcast2) {
        let shouroid1 = "";
        let shouroid2 = "";
        let iicount = 0;
        for(let ii2 = $efd3ba4ec2608b1d$var$HourOId2Select.options.length - 1; ii2 >= 0; ii2--){
            shouroid2 = $efd3ba4ec2608b1d$var$HourOId2Select.options[ii2].value;
            if ($efd3ba4ec2608b1d$var$getAfficheValidDateTime(shouroid2, 0) == $efd3ba4ec2608b1d$var$ValidTime) for(ii = $efd3ba4ec2608b1d$var$HourOId1Select.options.length - 1; ii >= 0; ii--){
                shouroid1 = $efd3ba4ec2608b1d$var$HourOId1Select.options[ii].value;
                for(minutes1 = interval; minutes1 <= $efd3ba4ec2608b1d$var$ModAFin.get(modele1); minutes1 = minutes1 + interval)if ($efd3ba4ec2608b1d$var$getAfficheValidDateTime(shouroid1, minutes1) == $efd3ba4ec2608b1d$var$ValidTime) {
                    $efd3ba4ec2608b1d$var$feedListProgTimes("1", iicount, shouroid1, minutes1);
                    $efd3ba4ec2608b1d$var$feedListProgTimes("2", iicount, shouroid2, 0);
                    iicount = iicount + 1;
                }
            }
        }
        istep_max_1 = iicount - 1;
        istep_max_2 = iicount - 1;
    //      fin de DprogDt && Nowcast2
    } else if ($efd3ba4ec2608b1d$var$DprogDt) {
        let houroid_ = "";
        let iicount = 0;
        for(ii = $efd3ba4ec2608b1d$var$HourOId1Select.options.length - 1; ii >= 0; ii--){
            houroid_ = $efd3ba4ec2608b1d$var$HourOId1Select.options[ii].value;
            for(minutes1 = debut_1; minutes1 <= fin_1; minutes1 = minutes1 + interval)if ($efd3ba4ec2608b1d$var$getAfficheValidDateTime(houroid_, minutes1) == $efd3ba4ec2608b1d$var$ValidTime) {
                if (!$efd3ba4ec2608b1d$var$Couche2Void) {
                    trouve = false;
                    for(var ii2 = $efd3ba4ec2608b1d$var$HourOId2Select.options.length - 1; ii2 >= 0; ii2--)if (houroid_ == $efd3ba4ec2608b1d$var$HourOId2Select.options[ii2].value) trouve = true;
                    if (trouve) {
                        for(minutes2 = debut_2; minutes2 <= fin_2; minutes2 = minutes2 + interval)if ($efd3ba4ec2608b1d$var$getAfficheValidDateTime(houroid_, minutes2) == $efd3ba4ec2608b1d$var$ValidTime) {
                            $efd3ba4ec2608b1d$var$feedListProgTimes("1", iicount, houroid_, minutes1);
                            $efd3ba4ec2608b1d$var$feedListProgTimes("2", iicount, houroid_, minutes2);
                            iicount = iicount + 1;
                        }
                    }
                } else {
                    $efd3ba4ec2608b1d$var$feedListProgTimes("1", iicount, houroid_, minutes1);
                    iicount = iicount + 1;
                }
            }
        }
        istep_max_1 = iicount - 1;
        istep_max_2 = iicount - 1;
    //   fin de DprogDt 
    } else if (nowcast1) {
        let shouroid_debut = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$HourOId1Select.options[0].value, debut_1, true);
        let shouroid_fin = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes($efd3ba4ec2608b1d$var$HourOId1Select.options[0].value, fin_1, true);
        let houroid_debut = parseInt(shouroid_debut);
        let houroid_fin = parseInt(shouroid_fin);
        let houroid_ = houroid_debut;
        let nb_min_int = 0;
        let snb_min = "";
        let nb_min = 0;
        let nb_hour_int = 0;
        let snb_hour = "";
        if (interval != $efd3ba4ec2608b1d$var$ModAInterv.get(modele1)) {
            //         ici on cherche l houroid de debut qui donnera un nombre d interval entier pour arriver a la fin
            //         notons que la fin est le temps le plus pres du temps reel  alors que le debut est le plus loin dans le temps passe
            nb_min = parseInt(shouroid_fin.substring(8, 10)) * 60 + parseInt(shouroid_fin.toString().slice(-2));
            nb_hour_int = parseInt(parseInt(nb_min / interval) * interval / 60);
            snb_hour = nb_hour_int.toString();
            if (snb_hour.length < 2) snb_hour = "0" + snb_hour;
            nb_min_int = parseInt(nb_min / interval) * interval % 60;
            snb_min = nb_min_int.toString();
            if (snb_min.length < 2) snb_min = "0" + snb_min;
            shouroid_fin = shouroid_fin.substring(0, 8) + snb_hour + snb_min;
            houroid_fin = parseInt(shouroid_fin);
            shouroid_debut = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes(shouroid_fin, parseInt(fin_1) - parseInt(debut_1), false);
            houroid_debut = parseInt(shouroid_debut);
            houroid_ = houroid_debut;
        } else houroid_ = Math.max(parseInt($efd3ba4ec2608b1d$var$HourOId1Select.options[$efd3ba4ec2608b1d$var$HourOId1Select.options.length - 1].value), houroid_);
        let shouroid_ = houroid_.toString();
        let iicount = 0;
        let jj = 0;
        for(ii = $efd3ba4ec2608b1d$var$HourOId1Select.options.length - 1; ii >= 0; ii--){
            if (houroid_ <= houroid_fin) {
                if (shouroid_ == $efd3ba4ec2608b1d$var$HourOId1Select.options[ii].value) {
                    $efd3ba4ec2608b1d$var$feedListProgTimes("1", iicount, shouroid_, 0);
                    nb_min = parseInt(shouroid_.slice(-2));
                    nb_hour_int = parseInt(shouroid_.substring(8, 10));
                    if (nowcast2) {
                        nb_min_int = Math.round(nb_min / $efd3ba4ec2608b1d$var$ModAInterv.get(modele2)) * $efd3ba4ec2608b1d$var$ModAInterv.get(modele2);
                        if (nb_min_int >= 60) nb_min_int = parseInt(nb_min / $efd3ba4ec2608b1d$var$ModAInterv.get(modele2)) * $efd3ba4ec2608b1d$var$ModAInterv.get(modele2);
                        snb_min = nb_min_int.toString();
                        if (snb_min.length < 2) snb_min = "0" + snb_min;
                        $efd3ba4ec2608b1d$var$feedListProgTimes("2", iicount, shouroid_.substring(0, 10) + snb_min, 0);
                    //console.log( " houroid1 " + listHourOId1[iicount] + " houroid2 " + listHourOId2[iicount] + " icount " + iicount); 
                    } else if (!$efd3ba4ec2608b1d$var$Couche2Void) {
                        minutes2 = $efd3ba4ec2608b1d$var$soustractionHourOId(shouroid_, houroid_2, true);
                        nb_min = Math.round(minutes2 / $efd3ba4ec2608b1d$var$ModAInterv.get(modele2)) * $efd3ba4ec2608b1d$var$ModAInterv.get(modele2);
                        // ici on change temporairement l interval pour obtenir une interval de pcpn correct  si c est le cas
                        $efd3ba4ec2608b1d$var$Couche2.interval = Math.max($efd3ba4ec2608b1d$var$ModAInterv.get(modele2), interval);
                        $efd3ba4ec2608b1d$var$feedListProgTimes("2", iicount, houroid_2, nb_min);
                        //  ici on remet l intervale de la couche 2 a sa valeur
                        $efd3ba4ec2608b1d$var$Couche2.interval = interval;
                    }
                    iicount = iicount + 1;
                    shouroid_ = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes(shouroid_, interval, true);
                    houroid_ = parseInt(shouroid_);
                }
            }
        }
        istep_max_1 = iicount - 1;
        istep_max_2 = istep_max_1;
    //    fin de nowcast  et debut de mode prog
    } else {
        ii = 0;
        for(minutes1 = debut_1; minutes1 <= fin_1; minutes1 = minutes1 + interval){
            $efd3ba4ec2608b1d$var$feedListProgTimes("1", ii, houroid_1, minutes1);
            if (nowcast2) {
                $efd3ba4ec2608b1d$var$feedListProgTimes("2", ii, houroid_1, 0);
                $efd3ba4ec2608b1d$var$listHourOId2[ii] = $efd3ba4ec2608b1d$var$getHourOIdPlusMoinsNbMinutes(houroid_1 + "00", minutes1, true);
                $efd3ba4ec2608b1d$var$listUrl2[ii] = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche2.getModele(), $efd3ba4ec2608b1d$var$Couche2.getZoomId(), $efd3ba4ec2608b1d$var$Couche2.getMapId(), $efd3ba4ec2608b1d$var$listHourOId2[ii], $efd3ba4ec2608b1d$var$listProg2[ii]);
                $efd3ba4ec2608b1d$var$listUrlCo2[ii] = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche2.getModele(), $efd3ba4ec2608b1d$var$Couche2.getZoomId(), $efd3ba4ec2608b1d$var$Couche2.mapIdCo, $efd3ba4ec2608b1d$var$listHourOId2[ii], $efd3ba4ec2608b1d$var$listProg2[ii]);
            }
            ii = ii + 1;
        }
        istep_max_1 = ii - 1;
        if (!$efd3ba4ec2608b1d$var$Couche2Void && !nowcast2) {
            ii = 0;
            for(minutes2 = debut_2; minutes2 <= fin_2; minutes2 = minutes2 + interval){
                $efd3ba4ec2608b1d$var$feedListProgTimes("2", ii, houroid_2, minutes2);
                ii = ii + 1;
            }
        }
        istep_max_2 = ii - 1;
    }
    ///   FIN de la grande boucle 
    //   ##########################
    $efd3ba4ec2608b1d$var$NoOfLayers = parseInt(Math.min(istep_max_1 + 1, $efd3ba4ec2608b1d$var$NoLimitOfLayers));
    let nu_steps_ = istep_max_1 + 1;
    message = " number of time steps: " + nu_steps_ + "Initial NoOfLayers = " + $efd3ba4ec2608b1d$var$NoOfLayers;
    console.log(message);
    while(nu_steps_ % $efd3ba4ec2608b1d$var$NoOfLayers != 0){
        message = " number of time steps: " + nu_steps_ + "In while NoOfLayers = " + $efd3ba4ec2608b1d$var$NoOfLayers;
        console.log(message);
        $efd3ba4ec2608b1d$var$NoOfLayers = $efd3ba4ec2608b1d$var$NoOfLayers - 1;
    }
    message = " number of time steps: " + nu_steps_ + "after while NoOfLayers = " + $efd3ba4ec2608b1d$var$NoOfLayers;
    console.log(message);
    if ($efd3ba4ec2608b1d$var$NoOfLayers == 1) {
        // ici on change temporairement l interval pour obtenir une interval de pcpn correct  si c est le cas
        $efd3ba4ec2608b1d$var$Couche2.interval = Math.max($efd3ba4ec2608b1d$var$ModAInterv.get(modele2), interval);
        $efd3ba4ec2608b1d$var$feedListProgTimes("1", istep_max_1 + 1, $efd3ba4ec2608b1d$var$listHourOId1[istep_max_1], $efd3ba4ec2608b1d$var$listProg1minu[istep_max_1]);
        istep_max_1 = istep_max_1 + 1;
        if (!$efd3ba4ec2608b1d$var$Couche2Void) {
            $efd3ba4ec2608b1d$var$feedListProgTimes("2", istep_max_2 + 1, $efd3ba4ec2608b1d$var$listHourOId2[istep_max_2], $efd3ba4ec2608b1d$var$listProg2minu[istep_max_2]);
            istep_max_2 = istep_max_2 + 1;
        } else istep_max_2 = istep_max_1;
        $efd3ba4ec2608b1d$var$NoOfLayers = 2;
        //  ici on remet l intervale de la couche 2 a sa valeur
        $efd3ba4ec2608b1d$var$Couche2.interval = interval;
    }
    if (nowcast1) step = istep_max_1;
    if ($efd3ba4ec2608b1d$var$ActiveLoop) {
        step = step - 1;
        if (step < 0) step = istep_max_1;
    }
    $efd3ba4ec2608b1d$var$ISTEP = Math.max(0, step);
    $efd3ba4ec2608b1d$var$ISTEP = Math.min(istep_max_1, $efd3ba4ec2608b1d$var$ISTEP);
    message = " istep_max_1: " + istep_max_1 + " ISTEP = " + $efd3ba4ec2608b1d$var$ISTEP;
    console.log(message);
    $efd3ba4ec2608b1d$var$ISTEP_max = istep_max_1;
    message = " SetListProgTimes:  ISTEP_max = " + $efd3ba4ec2608b1d$var$ISTEP_max + " NoOfLayers = " + $efd3ba4ec2608b1d$var$NoOfLayers;
    console.log(message);
    if ($efd3ba4ec2608b1d$var$Avance) $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP + 1;
    else $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP - 1;
    if ($efd3ba4ec2608b1d$var$ISTEP_next > $efd3ba4ec2608b1d$var$ISTEP_max) $efd3ba4ec2608b1d$var$ISTEP_next = 0;
    if ($efd3ba4ec2608b1d$var$ISTEP_next < 0) $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP_max;
    message = " SetListProgTimes:  ISTEP_max = " + $efd3ba4ec2608b1d$var$ISTEP_max + " ISTEP = " + $efd3ba4ec2608b1d$var$ISTEP + " ISTEP_next = " + $efd3ba4ec2608b1d$var$ISTEP_next;
    console.log(message);
    message = " 1: range = HourOId, Prog: " + $efd3ba4ec2608b1d$var$listHourOId1[0] + " , " + $efd3ba4ec2608b1d$var$listProg1[0] + " \xe0 " + $efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$ISTEP_max] + " , " + $efd3ba4ec2608b1d$var$listProg1[$efd3ba4ec2608b1d$var$ISTEP_max];
    console.log(message);
    message = " 2: range = HourOId, Prog: " + $efd3ba4ec2608b1d$var$listHourOId2[0] + " , " + $efd3ba4ec2608b1d$var$listProg2[0] + " \xe0 " + $efd3ba4ec2608b1d$var$listHourOId2[$efd3ba4ec2608b1d$var$ISTEP_max] + " , " + $efd3ba4ec2608b1d$var$listProg2[$efd3ba4ec2608b1d$var$ISTEP_max];
    console.log(message);
    if (!$efd3ba4ec2608b1d$var$Couche2Void) {
        if (istep_max_1 != istep_max_2) {
            message = " Re-initialisation conseillee, et SVP rapporter \xe0 l administrateur (istep_max).";
            alert(message);
        }
        if (!nowcast1) {
            if ($efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId1[0], $efd3ba4ec2608b1d$var$listProg1minu[0]) != $efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId2[0], $efd3ba4ec2608b1d$var$listProg2minu[0])) {
                message = " Re-initialisation conseillee, et SVP rapporter \xe0 l administrateur (depart incoherent).";
                alert(message);
            }
            if ($efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId1[istep_max_1], $efd3ba4ec2608b1d$var$listProg1minu[istep_max_1]) != $efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId2[istep_max_2], $efd3ba4ec2608b1d$var$listProg2minu[istep_max_2])) {
                message = " Re-initialisation conseillee, et SVP rapporter \xe0 l administrateur (fin incoherente).";
                alert(message);
            }
        }
    }
    $efd3ba4ec2608b1d$var$CountTiles1 = $efd3ba4ec2608b1d$var$CountTilesInView("1");
    document.getElementById("zoomLvl1").innerHTML = $efd3ba4ec2608b1d$var$CountTiles1[0];
    document.getElementById("zoomLvlCo1").innerHTML = $efd3ba4ec2608b1d$var$CountTiles1[1];
    $efd3ba4ec2608b1d$var$CountTiles2 = $efd3ba4ec2608b1d$var$CountTilesInView("2");
    document.getElementById("zoomLvl2").innerHTML = $efd3ba4ec2608b1d$var$CountTiles2[0];
    document.getElementById("zoomLvlCo2").innerHTML = $efd3ba4ec2608b1d$var$CountTiles2[1];
}
//
// ------------------------------------------------------------------------------
//  TIME et    ANIMATION ----------------------------------------------------------
//
var $efd3ba4ec2608b1d$var$ISTEP = 0;
var $efd3ba4ec2608b1d$var$ISTEP_max = 0;
var $efd3ba4ec2608b1d$var$ISTEP_next = 1;
var $efd3ba4ec2608b1d$var$ISTEP_ecout1 = $efd3ba4ec2608b1d$var$ISTEP_next;
var $efd3ba4ec2608b1d$var$ISTEP_ecout2 = $efd3ba4ec2608b1d$var$ISTEP_next;
//------------------------------------------------------------------
// --- Preparing for the animation trigger
var $efd3ba4ec2608b1d$var$ISTEP_increment = 0;
var $efd3ba4ec2608b1d$var$ISTEP_repeatEndLoop = 5;
var $efd3ba4ec2608b1d$var$Avance = true;
var $efd3ba4ec2608b1d$var$LoopRunning = false;
var $efd3ba4ec2608b1d$var$ActiveLoop = false;
var $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
var $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
$efd3ba4ec2608b1d$var$setListProgTimes();
var $efd3ba4ec2608b1d$var$ValidTime = $efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId1[0], $efd3ba4ec2608b1d$var$listProg1minu[0]);
//
// ___________________________________________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$TimeStep(increment, rafraichir) {
    var verbose_ = true;
    var ii = 0;
    var message = "";
    let message2 = "";
    let validTime2 = "";
    var index = $efd3ba4ec2608b1d$var$ISTEP % $efd3ba4ec2608b1d$var$NoOfLayers;
    var index_next = $efd3ba4ec2608b1d$var$ISTEP_next % $efd3ba4ec2608b1d$var$NoOfLayers;
    var indexPrev = index;
    var istep_prev;
    let stringAffi1 = $efd3ba4ec2608b1d$var$Couche1.modele + " Prog: ";
    let stringAffi2 = $efd3ba4ec2608b1d$var$Couche2.modele + " Prog: ";
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast($efd3ba4ec2608b1d$var$Couche2.getModeleZoom());
    if (nowcast1) stringAffi1 = $efd3ba4ec2608b1d$var$Couche1.modele + ": ";
    if (nowcast2) stringAffi2 = $efd3ba4ec2608b1d$var$Couche2.modele + ": ";
    var changeStep = !$efd3ba4ec2608b1d$var$L_Interca || $efd3ba4ec2608b1d$var$L_Interca && $efd3ba4ec2608b1d$var$AfficheraLayer2 && $efd3ba4ec2608b1d$var$Avance || $efd3ba4ec2608b1d$var$L_Interca && $efd3ba4ec2608b1d$var$AfficheraLayer1 && !$efd3ba4ec2608b1d$var$Avance;
    var allLoadedOk = false;
    var ISTEP1 = $efd3ba4ec2608b1d$var$ISTEP_next;
    var ISTEP2 = $efd3ba4ec2608b1d$var$ISTEP_next;
    if ($efd3ba4ec2608b1d$var$L_Interca) {
        if ($efd3ba4ec2608b1d$var$AfficheraLayer2 && $efd3ba4ec2608b1d$var$Avance) ISTEP2 = $efd3ba4ec2608b1d$var$ISTEP_next;
        else if ($efd3ba4ec2608b1d$var$AfficheraLayer2) ISTEP2 = $efd3ba4ec2608b1d$var$ISTEP;
        else if ($efd3ba4ec2608b1d$var$AfficheraLayer1 && $efd3ba4ec2608b1d$var$Avance) ISTEP1 = $efd3ba4ec2608b1d$var$ISTEP;
        else if ($efd3ba4ec2608b1d$var$AfficheraLayer1) ISTEP1 = $efd3ba4ec2608b1d$var$ISTEP_next;
    }
    //if ( !L_Interca ) {
    if ($efd3ba4ec2608b1d$var$AfficheraLayer1 && $efd3ba4ec2608b1d$var$ISTEP_ecout1 !== ISTEP1) {
        console.log("...............................................................................");
        console.log("===============================================================================");
        console.log("...............................................................................");
        console.log("Error TimeStep: \xe9couteur couche 1:" + $efd3ba4ec2608b1d$var$ISTEP_ecout1 + " et ISTEP1: " + ISTEP1 + " doivent etre \xe9gaux");
        console.log("...............................................................................");
        console.log("===============================================================================");
        console.log("...............................................................................");
    //            if ( LoopRunning && !L_Interca ) {
    //              DesactiveAndStopAnimate();
    //              return
    //            }
    }
    if (!$efd3ba4ec2608b1d$var$Couche2Void && $efd3ba4ec2608b1d$var$AfficheraLayer2 && $efd3ba4ec2608b1d$var$ISTEP_ecout2 !== ISTEP2) {
        console.log("...............................................................................");
        console.log("===============================================================================");
        console.log("...............................................................................");
        console.log("Error TimeStep: \xe9couteur couche 2:" + $efd3ba4ec2608b1d$var$ISTEP_ecout2 + " et ISTEP_next: " + $efd3ba4ec2608b1d$var$ISTEP_next + " doivent etre \xe9gaux");
        console.log("...............................................................................");
        console.log("===============================================================================");
        console.log("...............................................................................");
    //            if ( LoopRunning && !L_Interca ) {
    //              DesactiveAndStopAnimate();
    //              return
    //            }
    }
    //}
    if ($efd3ba4ec2608b1d$var$AfficheraLayer1) {
        message = " +++++++++++++++++++++++++++++++++++++++++++++++++++++++";
        console.log(message);
        message = " ----------- TIME STEP : " + ISTEP1 + " ------------";
        console.log(message);
        message = " -- Start1 End1 Err1 nuTiles: ";
        console.log(message);
        message = "     " + $efd3ba4ec2608b1d$var$listNuLoadStart1[ISTEP1] + "     " + $efd3ba4ec2608b1d$var$listNuLoadEnd1[ISTEP1] + "     " + $efd3ba4ec2608b1d$var$listNuLoadErr1[ISTEP1] + "     " + $efd3ba4ec2608b1d$var$CountTiles1[0];
        console.log(message);
        if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) {
            message = " -- StartCo1 EndCo1 ErrCo1 nuTiles: ";
            console.log(message);
            message = "       " + $efd3ba4ec2608b1d$var$listNuLoadStartCo1[ISTEP1] + "       " + $efd3ba4ec2608b1d$var$listNuLoadEndCo1[ISTEP1] + "       " + $efd3ba4ec2608b1d$var$listNuLoadErrCo1[ISTEP1] + "       " + $efd3ba4ec2608b1d$var$CountTiles1[1];
            console.log(message);
        }
        if ($efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] != "missing" && $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] != "yes") {
            if ($efd3ba4ec2608b1d$var$listNuLoadStart1[ISTEP1] != 0 && $efd3ba4ec2608b1d$var$listNuLoadStart1[ISTEP1] == $efd3ba4ec2608b1d$var$listNuLoadEnd1[ISTEP1] + $efd3ba4ec2608b1d$var$listNuLoadErr1[ISTEP1]) {
                if ($efd3ba4ec2608b1d$var$listNuLoadEnd1[ISTEP1] == $efd3ba4ec2608b1d$var$listNuLoadStart1[ISTEP1]) {
                    $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] = "yes";
                    $efd3ba4ec2608b1d$var$listNuWait1[ISTEP1] = 0;
                } else if ($efd3ba4ec2608b1d$var$listNuLoadErr1[ISTEP1] > 0) {
                    $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] = "some_errors";
                    if ($efd3ba4ec2608b1d$var$listNuLoadErr1[ISTEP1] == $efd3ba4ec2608b1d$var$listNuLoadStart1[ISTEP1]) $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] = "full_errors";
                }
            } else if ($efd3ba4ec2608b1d$var$listNuLoadEnd1[ISTEP1] == $efd3ba4ec2608b1d$var$CountTiles1[0]) {
                $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] = "yes";
                $efd3ba4ec2608b1d$var$listNuWait1[ISTEP1] = 0;
                message = " The 1 end count balance the requirements " + $efd3ba4ec2608b1d$var$listNuLoadEnd1[ISTEP1] + " " + $efd3ba4ec2608b1d$var$CountTiles1[0] + " <<========== ";
                console.log(message);
            } else {
                if ($efd3ba4ec2608b1d$var$listNuLoadEnd1[ISTEP1] > 0) $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] = "still_loading";
                if ($efd3ba4ec2608b1d$var$listNuLoadEnd1[ISTEP1] == 0 && $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] == "loading") $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] = "still_loading";
                if ($efd3ba4ec2608b1d$var$listNuLoadStart1[ISTEP1] == 0) {
                    $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] = "still_loading";
                    message = " The start of loading counts were not resgistered  1 <<========== ";
                    console.log(message);
                }
            }
        }
        message = " --------- ListLoaded1 is now:  " + $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] + " ------------";
        console.log(message);
        if (rafraichir) {
            if ($efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] == "still_loading" || $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] == "loading") {
                message = " --------- ListLoaded1 is forced to yes because the flag rafaichir is true ";
                console.log(message);
                $efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] = "yes";
                $efd3ba4ec2608b1d$var$listNuWait1[ISTEP1] = 0;
            }
            if ($efd3ba4ec2608b1d$var$listLoaded1[ISTEP1] != "yes") {
                message = " <br> Chargement probl\xe9matique couche 1. (Re) faire un pas avant ou arriere. <br> <br>";
                $efd3ba4ec2608b1d$var$openAfficheInfo(message, 10);
            }
        }
        if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) {
            if ($efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] != "missing" && $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] != "yes") {
                if ($efd3ba4ec2608b1d$var$listNuLoadStartCo1[ISTEP1] != 0 && $efd3ba4ec2608b1d$var$listNuLoadStartCo1[ISTEP1] == $efd3ba4ec2608b1d$var$listNuLoadEndCo1[ISTEP1] + $efd3ba4ec2608b1d$var$listNuLoadErrCo1[ISTEP1]) {
                    if ($efd3ba4ec2608b1d$var$listNuLoadEndCo1[ISTEP1] == $efd3ba4ec2608b1d$var$listNuLoadStartCo1[ISTEP1]) {
                        $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] = "yes";
                        $efd3ba4ec2608b1d$var$listNuWaitCo1[ISTEP1] = 0;
                    } else if ($efd3ba4ec2608b1d$var$listNuLoadErrCo1[ISTEP1] > 0) {
                        $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] = "some_errors";
                        if ($efd3ba4ec2608b1d$var$listNuLoadErrCo1[ISTEP1] == $efd3ba4ec2608b1d$var$listNuLoadStartCo1[ISTEP1]) $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] = "full_errors";
                    }
                } else if ($efd3ba4ec2608b1d$var$listNuLoadEndCo1[ISTEP1] == $efd3ba4ec2608b1d$var$CountTiles1[1]) {
                    $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] = "yes";
                    $efd3ba4ec2608b1d$var$listNuWaitCo1[ISTEP1] = 0;
                    message = " The Co1 end count balance the requirements " + $efd3ba4ec2608b1d$var$listNuLoadEndCo1[ISTEP1] + " " + $efd3ba4ec2608b1d$var$CountTiles1[1] + " <<========== ";
                    console.log(message);
                } else {
                    if ($efd3ba4ec2608b1d$var$listNuLoadEndCo1[ISTEP1] > 0) $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] = "still_loading";
                    if ($efd3ba4ec2608b1d$var$listNuLoadEndCo1[ISTEP1] == 0 && $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] == "loading") $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] = "still_loading";
                    if ($efd3ba4ec2608b1d$var$listNuLoadStartCo1[ISTEP1] == 0) {
                        $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] = "still_loading";
                        message = " The start of loading counts were not resgistered Co1<<========== ";
                        console.log(message);
                    }
                }
            }
            message = " --------- ListLoadedCo1 is now:  " + $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] + " ------------";
            console.log(message);
            if (rafraichir) {
                if ($efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] == "still_loading" || $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] == "loading") {
                    message = " --------- ListLoadedCo1 is forced to yes because the flag rafaichir is true ";
                    console.log(message);
                    $efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] = "yes";
                    $efd3ba4ec2608b1d$var$listNuWaitCo1[ISTEP1] = 0;
                }
                if ($efd3ba4ec2608b1d$var$listLoadedCo1[ISTEP1] != "yes") {
                    message = " <br> Chargement probl\xe9matique Co couche1. (Re) faire un pas avant ou arriere. <br> <br>";
                    $efd3ba4ec2608b1d$var$openAfficheInfo(message, 10);
                }
            }
        }
    }
    if ($efd3ba4ec2608b1d$var$AfficheraLayer2 && !$efd3ba4ec2608b1d$var$Couche2Void) {
        message = " +++++++++++++++++++++++++++++++++++++++++++++++++++++++";
        console.log(message);
        message = " ----------- TIME STEP : " + ISTEP2 + " ------------";
        console.log(message);
        message = " -- Start2 End2 Err2 nuTiles: ";
        console.log(message);
        message = "     " + $efd3ba4ec2608b1d$var$listNuLoadStart2[ISTEP2] + "   " + $efd3ba4ec2608b1d$var$listNuLoadEnd2[ISTEP2] + "   " + $efd3ba4ec2608b1d$var$listNuLoadErr2[ISTEP2] + "   " + $efd3ba4ec2608b1d$var$CountTiles2[0];
        console.log(message);
        if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) {
            message = " -- StartCo2 EndCo2 ErrCo2 nuTiles: ";
            console.log(message);
            message = "       " + $efd3ba4ec2608b1d$var$listNuLoadStartCo2[ISTEP2] + "     " + $efd3ba4ec2608b1d$var$listNuLoadEndCo2[ISTEP2] + "     " + $efd3ba4ec2608b1d$var$listNuLoadErrCo2[ISTEP2] + "     " + $efd3ba4ec2608b1d$var$CountTiles2[1];
            console.log(message);
        }
        if ($efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] != "missing" && $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] != "yes") {
            if ($efd3ba4ec2608b1d$var$listNuLoadStart2[ISTEP2] != 0 && $efd3ba4ec2608b1d$var$listNuLoadStart2[ISTEP2] == $efd3ba4ec2608b1d$var$listNuLoadEnd2[ISTEP2] + $efd3ba4ec2608b1d$var$listNuLoadErr2[ISTEP2]) {
                if ($efd3ba4ec2608b1d$var$listNuLoadEnd2[ISTEP2] == $efd3ba4ec2608b1d$var$listNuLoadStart2[ISTEP2]) {
                    $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] = "yes";
                    $efd3ba4ec2608b1d$var$listNuWait2[ISTEP2] = 0;
                } else if ($efd3ba4ec2608b1d$var$listNuLoadErr2[ISTEP2] > 0) {
                    $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] = "some_errors";
                    if ($efd3ba4ec2608b1d$var$listNuLoadErr2[ISTEP2] == $efd3ba4ec2608b1d$var$listNuLoadStart2[ISTEP2]) $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] = "full_errors";
                }
            } else if ($efd3ba4ec2608b1d$var$listNuLoadEnd2[ISTEP2] == $efd3ba4ec2608b1d$var$CountTiles2[0]) {
                $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] = "yes";
                $efd3ba4ec2608b1d$var$listNuWait2[ISTEP2] = 0;
                message = " The end count balance the requirements " + $efd3ba4ec2608b1d$var$listNuLoadEnd2[ISTEP2] + " " + $efd3ba4ec2608b1d$var$CountTiles2[0] + " <<========== ";
                console.log(message);
            } else {
                if ($efd3ba4ec2608b1d$var$listNuLoadEnd2[ISTEP2] > 0) $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] = "still_loading";
                if ($efd3ba4ec2608b1d$var$listNuLoadEnd2[ISTEP2] == 0 && $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] == "loading") $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] = "still_loading";
                if ($efd3ba4ec2608b1d$var$listNuLoadStart2[ISTEP2] == 0) {
                    $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] = "still_loading";
                    message = " The start of loading counts were not resgistered  2 <<========== ";
                    console.log(message);
                }
            }
        }
        message = " --------- ListLoaded2 is now:  " + $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] + " ------------";
        console.log(message);
        if (rafraichir) {
            if ($efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] == "still_loading" || $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] == "loading") {
                message = " --------- ListLoaded2 is forced to yes because the flag rafaichir si true ";
                console.log(message);
                $efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] = "yes";
                $efd3ba4ec2608b1d$var$listNuWait2[ISTEP2] = 0;
            }
            if ($efd3ba4ec2608b1d$var$listLoaded2[ISTEP2] != "yes") {
                message = " <br> Chargement probl\xe9matique couche 2. (Re) faire un pas avant ou arriere. <br> <br>";
                $efd3ba4ec2608b1d$var$openAfficheInfo(message, 10);
            }
        }
        if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) {
            if ($efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] != "missing" && $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] != "yes") {
                if ($efd3ba4ec2608b1d$var$listNuLoadStartCo2[ISTEP2] != 0 && $efd3ba4ec2608b1d$var$listNuLoadStartCo2[ISTEP2] == $efd3ba4ec2608b1d$var$listNuLoadEndCo2[ISTEP2] + $efd3ba4ec2608b1d$var$listNuLoadErrCo2[ISTEP2]) {
                    if ($efd3ba4ec2608b1d$var$listNuLoadEndCo2[ISTEP2] == $efd3ba4ec2608b1d$var$listNuLoadStartCo2[ISTEP2]) {
                        $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] = "yes";
                        $efd3ba4ec2608b1d$var$listNuWaitCo2[ISTEP2] = 0;
                    } else if ($efd3ba4ec2608b1d$var$listNuLoadErrCo2[ISTEP2] > 0) {
                        $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] = "some_errors";
                        if ($efd3ba4ec2608b1d$var$listNuLoadErrCo2[ISTEP2] == $efd3ba4ec2608b1d$var$listNuLoadStartCo2[ISTEP2]) $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] = "full_errors";
                    }
                } else if ($efd3ba4ec2608b1d$var$listNuLoadEndCo2[ISTEP2] == $efd3ba4ec2608b1d$var$CountTiles2[1]) {
                    $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] = "yes";
                    $efd3ba4ec2608b1d$var$listNuWaitCo2[ISTEP2] = 0;
                    message = " The end count balance the requirements " + $efd3ba4ec2608b1d$var$listNuLoadEndCo2[ISTEP2] + " " + $efd3ba4ec2608b1d$var$CountTiles2[1] + " <<========== ";
                    console.log(message);
                } else {
                    if ($efd3ba4ec2608b1d$var$listNuLoadEndCo2[ISTEP2] > 0) $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] = "still_loading";
                    if ($efd3ba4ec2608b1d$var$listNuLoadEndCo2[ISTEP2] == 0 && $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] == "loading") $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] = "still_loading";
                    if ($efd3ba4ec2608b1d$var$listNuLoadStartCo2[ISTEP2] == 0) {
                        $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] = "still_loading";
                        message = " The start of loading counts were not resgistered Co2<<========== ";
                        console.log(message);
                    }
                }
            }
            message = " --------- ListLoadedCo2 is now:  " + $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] + " ------------";
            console.log(message);
            if (rafraichir) {
                if ($efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] == "still_loading" || $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] == "loading") {
                    message = " --------- ListLoadedCo2 is forced to yes because the flag rafaichir si true ";
                    console.log(message);
                    $efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] = "yes";
                    $efd3ba4ec2608b1d$var$listNuWaitCo2[ISTEP2] = 0;
                }
                if ($efd3ba4ec2608b1d$var$listLoadedCo2[ISTEP2] != "yes") {
                    message = " <br> Chargement probl\xe9matique Co couche 2. (Re) faire un pas avant ou arriere. <br> <br>";
                    $efd3ba4ec2608b1d$var$openAfficheInfo(message, 10);
                }
            }
        }
    }
    let go1_next = false;
    go1_next = $efd3ba4ec2608b1d$var$listLoaded1[$efd3ba4ec2608b1d$var$ISTEP_next] == "yes" || $efd3ba4ec2608b1d$var$listLoaded1[$efd3ba4ec2608b1d$var$ISTEP_next] == "lazyLoading" || $efd3ba4ec2608b1d$var$listLoaded1[$efd3ba4ec2608b1d$var$ISTEP_next] == "some_errors";
    let go1 = false;
    go1 = $efd3ba4ec2608b1d$var$listLoaded1[$efd3ba4ec2608b1d$var$ISTEP] == "yes" || $efd3ba4ec2608b1d$var$listLoaded1[$efd3ba4ec2608b1d$var$ISTEP] == "lazyLoading" || $efd3ba4ec2608b1d$var$listLoaded1[$efd3ba4ec2608b1d$var$ISTEP] == "some_errors";
    let go1Co_next = false;
    let go1Co = false;
    if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) {
        go1Co_next = $efd3ba4ec2608b1d$var$listLoadedCo1[$efd3ba4ec2608b1d$var$ISTEP_next] == "yes" || $efd3ba4ec2608b1d$var$listLoadedCo1[$efd3ba4ec2608b1d$var$ISTEP_next] == "lazyLoading" || $efd3ba4ec2608b1d$var$listLoadedCo1[$efd3ba4ec2608b1d$var$ISTEP_next] == "some_errors";
        go1Co = $efd3ba4ec2608b1d$var$listLoadedCo1[$efd3ba4ec2608b1d$var$ISTEP] == "yes" || $efd3ba4ec2608b1d$var$listLoadedCo1[$efd3ba4ec2608b1d$var$ISTEP] == "lazyLoading" || $efd3ba4ec2608b1d$var$listLoadedCo1[$efd3ba4ec2608b1d$var$ISTEP] == "some_errors";
    }
    let go2_next = false;
    let go2 = false;
    let go2Co_next = false;
    let go2Co = false;
    if (!$efd3ba4ec2608b1d$var$Couche2Void) {
        go2_next = $efd3ba4ec2608b1d$var$listLoaded2[$efd3ba4ec2608b1d$var$ISTEP_next] == "yes" || $efd3ba4ec2608b1d$var$listLoaded2[$efd3ba4ec2608b1d$var$ISTEP_next] == "lazyLoading" || $efd3ba4ec2608b1d$var$listLoaded2[$efd3ba4ec2608b1d$var$ISTEP_next] == "some_errors";
        go2 = $efd3ba4ec2608b1d$var$listLoaded2[$efd3ba4ec2608b1d$var$ISTEP] == "yes" || $efd3ba4ec2608b1d$var$listLoaded2[$efd3ba4ec2608b1d$var$ISTEP] == "lazyLoading" || $efd3ba4ec2608b1d$var$listLoaded2[$efd3ba4ec2608b1d$var$ISTEP] == "some_errors";
        if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) {
            go2Co_next = $efd3ba4ec2608b1d$var$listLoadedCo2[$efd3ba4ec2608b1d$var$ISTEP_next] == "yes" || $efd3ba4ec2608b1d$var$listLoadedCo2[$efd3ba4ec2608b1d$var$ISTEP_next] == "lazyLoading" || $efd3ba4ec2608b1d$var$listLoadedCo2[$efd3ba4ec2608b1d$var$ISTEP_next] == "some_errors";
            go2Co = $efd3ba4ec2608b1d$var$listLoadedCo2[$efd3ba4ec2608b1d$var$ISTEP] == "yes" || $efd3ba4ec2608b1d$var$listLoadedCo2[$efd3ba4ec2608b1d$var$ISTEP] == "lazyLoading" || $efd3ba4ec2608b1d$var$listLoadedCo2[$efd3ba4ec2608b1d$var$ISTEP] == "some_errors";
        }
    }
    if (!$efd3ba4ec2608b1d$var$L_Interca) {
        if (!$efd3ba4ec2608b1d$var$Couche2Void) {
            allLoadedOk = go1_next && go2_next;
            if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) allLoadedOk = allLoadedOk && go1Co_next;
            if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) allLoadedOk = allLoadedOk && go2Co_next;
        } else {
            allLoadedOk = go1_next;
            if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) allLoadedOk = allLoadedOk && go1Co_next;
        }
    } else {
        if ($efd3ba4ec2608b1d$var$AfficheraLayer2 && $efd3ba4ec2608b1d$var$Avance) {
            allLoadedOk = go2_next;
            if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) allLoadedOk = allLoadedOk && go2Co_next;
        } else if ($efd3ba4ec2608b1d$var$AfficheraLayer2) {
            allLoadedOk = go2;
            if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) allLoadedOk = allLoadedOk && go2Co;
        } else if ($efd3ba4ec2608b1d$var$AfficheraLayer1 && $efd3ba4ec2608b1d$var$Avance) {
            allLoadedOk = go1;
            if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) allLoadedOk = allLoadedOk && go1Co;
        } else if ($efd3ba4ec2608b1d$var$AfficheraLayer1) {
            allLoadedOk = go1_next;
            if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) allLoadedOk = allLoadedOk && go1Co_next;
        }
    }
    if (allLoadedOk) {
        if (changeStep) {
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP + increment;
            if ($efd3ba4ec2608b1d$var$ISTEP > $efd3ba4ec2608b1d$var$ISTEP_max + $efd3ba4ec2608b1d$var$ISTEP_repeatEndLoop) {
                indexPrev = $efd3ba4ec2608b1d$var$ISTEP_max % $efd3ba4ec2608b1d$var$NoOfLayers;
                $efd3ba4ec2608b1d$var$ISTEP = 0;
            }
            if ($efd3ba4ec2608b1d$var$ISTEP < 0) $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP_max;
            $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP + increment;
            if ($efd3ba4ec2608b1d$var$ISTEP_next > $efd3ba4ec2608b1d$var$ISTEP_max) $efd3ba4ec2608b1d$var$ISTEP_next = 0;
            if ($efd3ba4ec2608b1d$var$ISTEP_next < 0) $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP_max;
        }
        istep_prev = $efd3ba4ec2608b1d$var$ISTEP - increment;
        if (istep_prev < 0) istep_prev = $efd3ba4ec2608b1d$var$ISTEP_max;
        if (istep_prev > $efd3ba4ec2608b1d$var$ISTEP_max) istep_prev = $efd3ba4ec2608b1d$var$ISTEP_max - 1;
        if ($efd3ba4ec2608b1d$var$ISTEP < $efd3ba4ec2608b1d$var$ISTEP_max + 1) {
            index = $efd3ba4ec2608b1d$var$ISTEP % $efd3ba4ec2608b1d$var$NoOfLayers;
            index_next = $efd3ba4ec2608b1d$var$ISTEP_next % $efd3ba4ec2608b1d$var$NoOfLayers;
            if (verbose_) {
                message = " will be displaying. Istep: " + $efd3ba4ec2608b1d$var$ISTEP + " nhour1 : " + $efd3ba4ec2608b1d$var$listProg1[$efd3ba4ec2608b1d$var$ISTEP] + " nhour2 : " + $efd3ba4ec2608b1d$var$listProg2[$efd3ba4ec2608b1d$var$ISTEP] + "Index: " + index;
                message = " will be displaying. Istep: " + $efd3ba4ec2608b1d$var$ISTEP + " houroid1 : " + $efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$ISTEP] + " houroid2 : " + $efd3ba4ec2608b1d$var$listHourOId2[$efd3ba4ec2608b1d$var$ISTEP];
                console.log(message);
                message = " will be requesting load. Istep next: " + $efd3ba4ec2608b1d$var$ISTEP_next + " nhour1 next: " + $efd3ba4ec2608b1d$var$listProg1[$efd3ba4ec2608b1d$var$ISTEP_next] + " nhour2 next: " + $efd3ba4ec2608b1d$var$listProg2[$efd3ba4ec2608b1d$var$ISTEP_next] + "Index next: " + index_next;
                console.log(message);
                message = " will be requesting load. Istep next: " + $efd3ba4ec2608b1d$var$ISTEP_next + " houroid1 : " + $efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$ISTEP_next] + " houroid2 : " + $efd3ba4ec2608b1d$var$listHourOId2[$efd3ba4ec2608b1d$var$ISTEP_next];
                console.log(message);
            }
            if (!$efd3ba4ec2608b1d$var$L_Interca) {
                if ($efd3ba4ec2608b1d$var$DprogDt) $efd3ba4ec2608b1d$var$resetMenuDprogSurDt(0, $efd3ba4ec2608b1d$var$ISTEP);
                if (nowcast1) $efd3ba4ec2608b1d$var$resetMenuDprogSurDt(1, $efd3ba4ec2608b1d$var$ISTEP);
                if (nowcast2) $efd3ba4ec2608b1d$var$resetMenuDprogSurDt(2, $efd3ba4ec2608b1d$var$ISTEP);
                $efd3ba4ec2608b1d$var$ValidTime = $efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$listProg1minu[$efd3ba4ec2608b1d$var$ISTEP]);
                message = stringAffi1 + $efd3ba4ec2608b1d$var$listProg1[$efd3ba4ec2608b1d$var$ISTEP] + "h valide " + $efd3ba4ec2608b1d$var$ValidTime;
                if (!$efd3ba4ec2608b1d$var$Couche2Void) {
                    validTime2 = $efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId2[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$listProg2minu[$efd3ba4ec2608b1d$var$ISTEP]);
                    message2 = stringAffi2 + $efd3ba4ec2608b1d$var$listProg2[$efd3ba4ec2608b1d$var$ISTEP] + "h valide " + validTime2;
                } else message2 = " ";
                if ($efd3ba4ec2608b1d$var$L_Juxtapo) {
                    document.getElementById("affiche_temps_valide1").innerHTML = " 1- " + message;
                    document.getElementById("affiche_temps_valide2").innerHTML = " 2- " + message2;
                } else if (message != message2 && message2 != " ") document.getElementById("affiche_temps_valide").innerHTML = " 1- " + message + "<br>" + " 2- " + message2;
                else document.getElementById("affiche_temps_valide").innerHTML = " 1- " + message;
                if (!$efd3ba4ec2608b1d$var$Couche2Void) {
                    $efd3ba4ec2608b1d$var$tileLayers2[indexPrev].setOpacity(0.);
                    $efd3ba4ec2608b1d$var$tileLayers2[index].setOpacity($efd3ba4ec2608b1d$var$Opacitee2);
                    if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) {
                        $efd3ba4ec2608b1d$var$tileLayersCo2[indexPrev].setOpacity(0.);
                        $efd3ba4ec2608b1d$var$tileLayersCo2[index].setOpacity($efd3ba4ec2608b1d$var$Opacitee2);
                    }
                }
                $efd3ba4ec2608b1d$var$tileLayers1[indexPrev].setOpacity(0.);
                $efd3ba4ec2608b1d$var$tileLayers1[index].setOpacity($efd3ba4ec2608b1d$var$Opacitee1);
                if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) {
                    $efd3ba4ec2608b1d$var$tileLayersCo1[indexPrev].setOpacity(0.);
                    $efd3ba4ec2608b1d$var$tileLayersCo1[index].setOpacity($efd3ba4ec2608b1d$var$Opacitee1);
                }
                $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
                $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
                $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
            } else if ($efd3ba4ec2608b1d$var$AfficheraLayer1) {
                if ($efd3ba4ec2608b1d$var$DprogDt) $efd3ba4ec2608b1d$var$resetMenuDprogSurDt(1, $efd3ba4ec2608b1d$var$ISTEP);
                if (nowcast1) $efd3ba4ec2608b1d$var$resetMenuDprogSurDt(1, $efd3ba4ec2608b1d$var$ISTEP);
                $efd3ba4ec2608b1d$var$affichage_meta_informations(1);
                $efd3ba4ec2608b1d$var$ValidTime = $efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$listProg1minu[$efd3ba4ec2608b1d$var$ISTEP]);
                document.getElementById("affiche_temps_valide").innerHTML = " 1- " + stringAffi1 + $efd3ba4ec2608b1d$var$listProg1[$efd3ba4ec2608b1d$var$ISTEP] + "h valide " + $efd3ba4ec2608b1d$var$ValidTime;
                $efd3ba4ec2608b1d$var$tileLayers2[indexPrev].setOpacity(0.);
                $efd3ba4ec2608b1d$var$tileLayers2[index].setOpacity(0.);
                if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) $efd3ba4ec2608b1d$var$tileLayersCo2[indexPrev].setOpacity(0.);
                if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) $efd3ba4ec2608b1d$var$tileLayersCo2[index].setOpacity(0.);
                $efd3ba4ec2608b1d$var$tileLayers1[index].setOpacity($efd3ba4ec2608b1d$var$Opacitee1);
                if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) $efd3ba4ec2608b1d$var$tileLayersCo1[index].setOpacity($efd3ba4ec2608b1d$var$Opacitee1);
                $efd3ba4ec2608b1d$var$AfficheraLayer1 = false;
                $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
                $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 1);
            } else {
                if ($efd3ba4ec2608b1d$var$DprogDt) $efd3ba4ec2608b1d$var$resetMenuDprogSurDt(2, $efd3ba4ec2608b1d$var$ISTEP);
                if (nowcast2) $efd3ba4ec2608b1d$var$resetMenuDprogSurDt(2, $efd3ba4ec2608b1d$var$ISTEP);
                $efd3ba4ec2608b1d$var$affichage_meta_informations(2);
                $efd3ba4ec2608b1d$var$ValidTime = $efd3ba4ec2608b1d$var$getAfficheValidDateTime($efd3ba4ec2608b1d$var$listHourOId2[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$listProg2minu[$efd3ba4ec2608b1d$var$ISTEP]);
                document.getElementById("affiche_temps_valide").innerHTML = " 2- " + stringAffi2 + $efd3ba4ec2608b1d$var$listProg2[$efd3ba4ec2608b1d$var$ISTEP] + "h valide " + $efd3ba4ec2608b1d$var$ValidTime;
                $efd3ba4ec2608b1d$var$tileLayers1[indexPrev].setOpacity(0.);
                $efd3ba4ec2608b1d$var$tileLayers1[index].setOpacity(0.);
                if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) $efd3ba4ec2608b1d$var$tileLayersCo1[indexPrev].setOpacity(0.);
                if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) $efd3ba4ec2608b1d$var$tileLayersCo1[index].setOpacity(0.);
                $efd3ba4ec2608b1d$var$tileLayers2[index].setOpacity($efd3ba4ec2608b1d$var$Opacitee2);
                if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) $efd3ba4ec2608b1d$var$tileLayersCo2[index].setOpacity($efd3ba4ec2608b1d$var$Opacitee2);
                $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
                $efd3ba4ec2608b1d$var$AfficheraLayer2 = false;
                $efd3ba4ec2608b1d$var$updateLayers($efd3ba4ec2608b1d$var$ISTEP_next, 2);
            }
        }
        if ($efd3ba4ec2608b1d$var$CurrentDelay > $efd3ba4ec2608b1d$var$Delay) {
            if ($efd3ba4ec2608b1d$var$listNuWait1[ISTEP1] < 2 && $efd3ba4ec2608b1d$var$listNuWaitCo1[ISTEP1] && $efd3ba4ec2608b1d$var$listNuWait2[ISTEP2] < 2 && $efd3ba4ec2608b1d$var$listNuWaitCo2[ISTEP2]) {
                message = " All right... gradually resetting pace of animation toward requested " + $efd3ba4ec2608b1d$var$Delay + " ms. Current is: " + $efd3ba4ec2608b1d$var$CurrentDelay + " ms.";
                console.log(message);
                $efd3ba4ec2608b1d$var$CurrentDelay = Math.max($efd3ba4ec2608b1d$var$Delay, $efd3ba4ec2608b1d$var$CurrentDelay / (2 * $efd3ba4ec2608b1d$var$FactLongerDelay));
                $efd3ba4ec2608b1d$var$SpeedReset($efd3ba4ec2608b1d$var$CurrentDelay);
            //openAfficheInfo(message, 10);
            }
        }
    } else {
        $efd3ba4ec2608b1d$var$StopAnimate();
        var goBack2TimeStep1 = false;
        var goBack2TimeStep2 = false;
        var tilesNotOk1 = false;
        var tilesNotOk2 = false;
        message = " *******************************************************";
        console.log(message);
        message = " ----------- TIME STEP NOT NOT NOT NOT READY FOR STEP: " + $efd3ba4ec2608b1d$var$ISTEP_next + " ------------";
        console.log(message);
        message = " *******************************************************";
        console.log(message);
        message = " ----------- ListLoaded1 :  " + $efd3ba4ec2608b1d$var$listLoaded1[$efd3ba4ec2608b1d$var$ISTEP_next] + " ------------";
        console.log(message);
        if (!$efd3ba4ec2608b1d$var$Couche1CoVoid) {
            message = " --------- ListLoadedCo1 is:  " + $efd3ba4ec2608b1d$var$listLoadedCo1[$efd3ba4ec2608b1d$var$ISTEP_next] + " ------------";
            console.log(message);
        }
        if (!$efd3ba4ec2608b1d$var$Couche2Void) {
            message = " ----------- ListLoaded2 is:  " + $efd3ba4ec2608b1d$var$listLoaded2[$efd3ba4ec2608b1d$var$ISTEP_next] + " ------------";
            console.log(message);
            if (!$efd3ba4ec2608b1d$var$Couche2CoVoid) {
                message = " --------- ListLoadedCo2 is:  " + $efd3ba4ec2608b1d$var$listLoadedCo2[$efd3ba4ec2608b1d$var$ISTEP_next] + " ------------";
                console.log(message);
            }
        }
        message = " *******************************************************";
        console.log(message);
        message = " *******************************************************";
        console.log(message);
        if ($efd3ba4ec2608b1d$var$AfficheraLayer1) tilesNotOk1 = $efd3ba4ec2608b1d$var$TilesNotAllOk(ISTEP1, 1);
        if ($efd3ba4ec2608b1d$var$AfficheraLayer2 && !$efd3ba4ec2608b1d$var$Couche2Void) tilesNotOk2 = $efd3ba4ec2608b1d$var$TilesNotAllOk(ISTEP2, 2);
        if ($efd3ba4ec2608b1d$var$ActiveLoop) //CurrentDelay = Math.max( CurrentDelay*FactLongerDelay, Delay);
        //CurrentDelay = Math.min( CurrentDelay, 20480);
        //message = " setting slower animation pace at : " + CurrentDelay + " ms compared to requested: " + Delay + " ms.";
        //console.log(message);
        //SpeedReset(CurrentDelay);
        $efd3ba4ec2608b1d$var$StartAnimate();
    }
    if ($efd3ba4ec2608b1d$var$listNuWait1[ISTEP1] > 100 || $efd3ba4ec2608b1d$var$listNuWaitCo1[ISTEP1] > 100 > 100 || $efd3ba4ec2608b1d$var$listNuWait2[ISTEP2] > 100 || $efd3ba4ec2608b1d$var$listNuWaitCo2[ISTEP2] > 100) {
        message = " Warning...the  number of try is too high... need to stop animation";
        console.log(message);
        $efd3ba4ec2608b1d$var$listNuWait1[$efd3ba4ec2608b1d$var$ISTEP] = 0;
        $efd3ba4ec2608b1d$var$listNuWait1[$efd3ba4ec2608b1d$var$ISTEP_next] = 0;
        $efd3ba4ec2608b1d$var$listNuWait1[istep_prev] = 0;
        $efd3ba4ec2608b1d$var$listNuWait2[$efd3ba4ec2608b1d$var$ISTEP] = 0;
        $efd3ba4ec2608b1d$var$listNuWait2[$efd3ba4ec2608b1d$var$ISTEP_next] = 0;
        $efd3ba4ec2608b1d$var$listNuWait2[istep_prev] = 0;
        $efd3ba4ec2608b1d$var$listNuWaitCo1[$efd3ba4ec2608b1d$var$ISTEP] = 0;
        $efd3ba4ec2608b1d$var$listNuWaitCo1[$efd3ba4ec2608b1d$var$ISTEP_next] = 0;
        $efd3ba4ec2608b1d$var$listNuWaitCo1[istep_prev] = 0;
        $efd3ba4ec2608b1d$var$listNuWaitCo2[$efd3ba4ec2608b1d$var$ISTEP] = 0;
        $efd3ba4ec2608b1d$var$listNuWaitCo2[$efd3ba4ec2608b1d$var$ISTEP_next] = 0;
        $efd3ba4ec2608b1d$var$listNuWaitCo2[istep_prev] = 0;
        $efd3ba4ec2608b1d$var$DesactiveAndStopAnimate();
    }
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$TilesNotAllOk(istep, no) {
    let message = "";
    let flag2Return_ = false;
    let flag_ = "";
    if (no == 1) {
        if ($efd3ba4ec2608b1d$var$listLoaded1[istep] == "missing" && $efd3ba4ec2608b1d$var$listLoadedCo1[istep] == "missing") flag_ = "mainLayer_coLayer";
        else if ($efd3ba4ec2608b1d$var$listLoaded1[istep] == "missing") flag_ = "mainLayer";
        else if ($efd3ba4ec2608b1d$var$listLoadedCo1[istep] == "missing") flag_ = "coLayer";
        if ($efd3ba4ec2608b1d$var$listLoaded1[istep] == "still_loading" || $efd3ba4ec2608b1d$var$listLoaded1[istep] == "non") {
            $efd3ba4ec2608b1d$var$listNuWait1[istep] = $efd3ba4ec2608b1d$var$listNuWait1[istep] + 1;
            message = " Layer no: " + no + " is not ok  for after " + $efd3ba4ec2608b1d$var$listNuWait1[istep] + " tries";
            console.log(message);
            if ($efd3ba4ec2608b1d$var$listNuWait1[istep] > 3000 / $efd3ba4ec2608b1d$var$CurrentDelay) {
                $efd3ba4ec2608b1d$var$listLoaded1[istep] = "non";
                flag_ = "reload";
            }
        }
        if ($efd3ba4ec2608b1d$var$listLoadedCo1[istep] == "still_loading" || $efd3ba4ec2608b1d$var$listLoadedCo1[istep] == "non") {
            $efd3ba4ec2608b1d$var$listNuWaitCo1[istep] = $efd3ba4ec2608b1d$var$listNuWaitCo1[istep] + 1;
            message = " CoLayer no: " + no + " is not ok after " + $efd3ba4ec2608b1d$var$listNuWaitCo1[istep] + " tries";
            console.log(message);
            if ($efd3ba4ec2608b1d$var$listNuWaitCo1[istep] > 3000 / $efd3ba4ec2608b1d$var$CurrentDelay) {
                $efd3ba4ec2608b1d$var$listLoadedCo1[istep] = "non";
                flag_ = "reload";
            }
        }
        if ($efd3ba4ec2608b1d$var$listLoaded1[istep] == "full_errors" && $efd3ba4ec2608b1d$var$listLoadedCo1[istep] == "full_errors") {
            message = " Layer and colayer no: " + no + " have full errors ";
            console.log(message);
            flag_ = "mainLayer_coLayer";
        } else if ($efd3ba4ec2608b1d$var$listLoadedCo1[istep] == "full_errors") {
            message = " CoLayer no: " + no + "  has full errors ";
            console.log(message);
            if (flag_ == "mainLayer") flag_ = "mainLayer_coLayer";
            else flag_ = "coLayer";
        } else if ($efd3ba4ec2608b1d$var$listLoaded1[istep] == "full_errors") {
            $efd3ba4ec2608b1d$var$listNuWait1[istep] = $efd3ba4ec2608b1d$var$listNuWait1[istep] + 1;
            message = " Layer no: " + no + " has full errors ";
            console.log(message);
            if (flag_ == "coLayer") flag_ = "mainLayer_coLayer";
            else flag_ = "mainLayer";
        }
    }
    if (no == 2) {
        if ($efd3ba4ec2608b1d$var$listLoaded2[istep] == "missing" && $efd3ba4ec2608b1d$var$listLoadedCo2[istep] == "missing") flag_ = "mainLayer_coLayer";
        else if ($efd3ba4ec2608b1d$var$listLoaded2[istep] == "missing") flag_ = "mainLayer";
        else if ($efd3ba4ec2608b1d$var$listLoadedCo2[istep] == "missing") flag_ = "coLayer";
        if ($efd3ba4ec2608b1d$var$listLoaded2[istep] == "still_loading" || $efd3ba4ec2608b1d$var$listLoaded2[istep] == "non") {
            $efd3ba4ec2608b1d$var$listNuWait2[istep] = $efd3ba4ec2608b1d$var$listNuWait2[istep] + 1;
            message = " Layer no: " + no + " is still loading after " + $efd3ba4ec2608b1d$var$listNuWait2[istep] + " tries";
            console.log(message);
            if ($efd3ba4ec2608b1d$var$listNuWait2[istep] > 3000 / $efd3ba4ec2608b1d$var$CurrentDelay) {
                $efd3ba4ec2608b1d$var$listLoaded2[istep] = "non";
                flag_ = "reload";
            }
        }
        if ($efd3ba4ec2608b1d$var$listLoadedCo2[istep] == "still_loading" || $efd3ba4ec2608b1d$var$listLoadedCo2[istep] == "non") {
            $efd3ba4ec2608b1d$var$listNuWaitCo2[istep] = $efd3ba4ec2608b1d$var$listNuWaitCo2[istep] + 1;
            message = " CoLayer no: " + no + " is still loading after " + $efd3ba4ec2608b1d$var$listNuWaitCo2[istep] + " tries";
            console.log(message);
            if ($efd3ba4ec2608b1d$var$listNuWaitCo2[istep] > 3000 / $efd3ba4ec2608b1d$var$CurrentDelay) {
                $efd3ba4ec2608b1d$var$listLoadedCo2[istep] = "non";
                flag_ = "reload";
            }
        }
        if ($efd3ba4ec2608b1d$var$listLoaded2[istep] == "full_errors" && $efd3ba4ec2608b1d$var$listLoadedCo2[istep] == "full_errors") {
            message = " Layer and colayer no: " + no + " have full errors after " + $efd3ba4ec2608b1d$var$listNuWait2[istep] + " tries";
            console.log(message);
            flag_ = "mainLayer_coLayer";
        } else if ($efd3ba4ec2608b1d$var$listLoadedCo2[istep] == "full_errors") {
            message = " CoLayer no: " + no + "  has full errors ";
            console.log(message);
            if (flag_ == "mainLayer") flag_ = "mainLayer_coLayer";
            else flag_ = "coLayer";
        } else if ($efd3ba4ec2608b1d$var$listLoaded2[istep] == "full_errors") {
            message = " Layer no: " + no + " has full errors ";
            console.log(message);
            if (flag_ == "coLayer") flag_ = "mainLayer_coLayer";
            else flag_ = "mainLayer";
        }
    }
    if (flag_ == "mainLayer_coLayer") flag2Return_ = $efd3ba4ec2608b1d$var$FixErrorLayer(no, istep, "mainLayer_coLayer");
    else if (flag_ == "mainLayer") flag2Return_ = $efd3ba4ec2608b1d$var$FixErrorLayer(no, istep, "mainLayer");
    else if (flag_ == "coLayer") flag2Return_ = $efd3ba4ec2608b1d$var$FixErrorLayer(no, istep, "coLayer");
    else if (flag_ == "reload") flag2Return_ = $efd3ba4ec2608b1d$var$ReloadBecauseWaiting(no, istep);
    else flag2Return_ = false;
    return flag2Return_;
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$ReloadBecauseWaiting(no, istep) {
    var message = " WARNING  Reloading " + istep + " for layer no: " + no + " <========================== ";
    console.log(message);
    message = " <br> " + message + " <br> <br>";
    //openAfficheInfo(message, 12);
    if (no == 1) {
        message = " Url: " + $efd3ba4ec2608b1d$var$listUrl1[istep];
        console.log(message);
        message = " Houroid: " + $efd3ba4ec2608b1d$var$listHourOId1[istep] + " Prog: " + $efd3ba4ec2608b1d$var$listProg1[istep] + " istep : " + istep;
        console.log(message);
        message = " Model, zoom, carte: " + $efd3ba4ec2608b1d$var$Couche1.getModele() + " " + $efd3ba4ec2608b1d$var$Couche1.getZoomId() + " " + $efd3ba4ec2608b1d$var$Couche1.getMapId();
        console.log(message);
        $efd3ba4ec2608b1d$var$updateSource(istep, 1);
    } else if (no == 2) {
        message = " Url: " + $efd3ba4ec2608b1d$var$listUrl2[istep];
        console.log(message);
        message = " Houroid: " + $efd3ba4ec2608b1d$var$listHourOId2[istep] + " Prog: " + $efd3ba4ec2608b1d$var$listProg2[istep] + " istep : " + istep;
        console.log(message);
        message = " Model, zoom, carte: " + $efd3ba4ec2608b1d$var$Couche2.getModele() + " " + $efd3ba4ec2608b1d$var$Couche2.getZoomId() + " " + $efd3ba4ec2608b1d$var$Couche2.getMapId();
        console.log(message);
        $efd3ba4ec2608b1d$var$updateSource(istep, 2);
    }
    return true;
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$FixErrorLayer(no, istep, layer_) {
    var message = " Missing tiles will be assigned.  Istep in ERROR" + istep + " layer: " + no + " <========================== ";
    console.log(message);
    if (no == 1) {
        message = " Url: " + $efd3ba4ec2608b1d$var$listUrl1[istep];
        console.log(message);
        message = " Houroid: " + $efd3ba4ec2608b1d$var$listHourOId1[istep] + " Prog: " + $efd3ba4ec2608b1d$var$listProg1[istep];
        console.log(message);
        if (layer_ == "mainLayer") {
            message = layer_ + " Model, zoom, carte: " + $efd3ba4ec2608b1d$var$Couche1.getModele() + " " + $efd3ba4ec2608b1d$var$Couche1.getZoomId() + " " + $efd3ba4ec2608b1d$var$Couche1.getMapId();
            console.log(message);
            $efd3ba4ec2608b1d$var$listUrl1[istep] = "../missing";
            $efd3ba4ec2608b1d$var$listLoaded1[istep] = "non";
        } else if (layer_ == "coLayer") {
            message = layer_ + " Model, zoom, carte: " + $efd3ba4ec2608b1d$var$Couche1.getModele() + " " + $efd3ba4ec2608b1d$var$Couche1.getZoomId() + " " + $efd3ba4ec2608b1d$var$Couche1.getMapIdCo();
            console.log(message);
            $efd3ba4ec2608b1d$var$listUrlCo1[istep] = "../missing";
            $efd3ba4ec2608b1d$var$listLoadedCo1[istep] = "non";
        } else if (layer_ == "mainLayer_coLayer") {
            message = layer_ + " Model, zoom, carte: " + $efd3ba4ec2608b1d$var$Couche1.getModele() + " " + $efd3ba4ec2608b1d$var$Couche1.getZoomId() + " " + $efd3ba4ec2608b1d$var$Couche1.getMapId();
            console.log(message);
            message = layer_ + " Model, zoom, carte: " + $efd3ba4ec2608b1d$var$Couche1.getModele() + " " + $efd3ba4ec2608b1d$var$Couche1.getZoomId() + " " + $efd3ba4ec2608b1d$var$Couche1.getMapIdCo();
            console.log(message);
            $efd3ba4ec2608b1d$var$listUrl1[istep] = "../missing";
            $efd3ba4ec2608b1d$var$listLoaded1[istep] = "non";
            $efd3ba4ec2608b1d$var$listUrlCo1[istep] = "../missing";
            $efd3ba4ec2608b1d$var$listLoadedCo1[istep] = "non";
        }
        $efd3ba4ec2608b1d$var$updateSource(istep, 1);
    } else {
        message = " Url: " + $efd3ba4ec2608b1d$var$listUrl2[istep];
        console.log(message);
        message = " Houroid: " + $efd3ba4ec2608b1d$var$listHourOId2[istep] + " Prog: " + $efd3ba4ec2608b1d$var$listProg2[istep];
        console.log(message);
        if (layer_ == "mainLayer") {
            message = layer_ + " Model, zoom, carte: " + $efd3ba4ec2608b1d$var$Couche2.getModele() + " " + $efd3ba4ec2608b1d$var$Couche2.getZoomId() + " " + $efd3ba4ec2608b1d$var$Couche2.getMapId();
            console.log(message);
            $efd3ba4ec2608b1d$var$listUrl2[istep] = "../missing";
            $efd3ba4ec2608b1d$var$listLoaded2[istep] = "non";
        } else if (layer_ == "coLayer") {
            message = layer_ + " Model, zoom, carte: " + $efd3ba4ec2608b1d$var$Couche2.getModele() + " " + $efd3ba4ec2608b1d$var$Couche2.getZoomId() + " " + $efd3ba4ec2608b1d$var$Couche2.getMapIdCo();
            console.log(message);
            $efd3ba4ec2608b1d$var$listUrlCo2[istep] = "../missing";
            $efd3ba4ec2608b1d$var$listLoadedCo2[istep] = "non";
        } else if (layer_ == "mainLayer_coLayer") {
            message = layer_ + " Model, zoom, carte: " + $efd3ba4ec2608b1d$var$Couche2.getModele() + " " + $efd3ba4ec2608b1d$var$Couche2.getZoomId() + " " + $efd3ba4ec2608b1d$var$Couche2.getMapId();
            console.log(message);
            message = layer_ + " Model, zoom, carte: " + $efd3ba4ec2608b1d$var$Couche2.getModele() + " " + $efd3ba4ec2608b1d$var$Couche2.getZoomId() + " " + $efd3ba4ec2608b1d$var$Couche2.getMapIdCo();
            console.log(message);
            $efd3ba4ec2608b1d$var$listUrl2[istep] = "../missing";
            $efd3ba4ec2608b1d$var$listLoaded2[istep] = "non";
            $efd3ba4ec2608b1d$var$listUrlCo2[istep] = "../missing";
            $efd3ba4ec2608b1d$var$listLoadedCo2[istep] = "non";
        }
        $efd3ba4ec2608b1d$var$updateSource(istep, 2);
    }
    return true;
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$CheckLazyLoading(no, istep) {
    //map2
    var viewExtent_ = $efd3ba4ec2608b1d$var$map.getView().calculateExtent($efd3ba4ec2608b1d$var$map.getSize());
    var viewProj_ = $efd3ba4ec2608b1d$var$map.getView().getProjection();
    //  if ( viewProj_ != 'EPSG:4326' ) { viewExtent_ = transformExtent(viewExtent_, viewProj_, 'EPSG:4326'); }
    var message = "waiting. istep to be loaded: " + istep + " layer no: " + no;
    console.log(message);
    var retour = true;
    if (no == 1) {
        var couche1Extent_ = $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$Couche1.zoomId);
        var couche1Proj_ = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$Couche1.zoomId);
        if (couche1Proj_ != viewProj_) couche1Extent_ = (0, $9c4744460e43e41b$export$751c68e0e0efff79)(couche1Extent_, couche1Proj_, viewProj_);
        if ($efd3ba4ec2608b1d$var$IsCoucheExtentInExtent(viewExtent_, couche1Extent_)) {
            message = " Layer no: 1 is not considered for lazy Loading status";
            console.log(message);
            $efd3ba4ec2608b1d$var$listNuWait1[istep] = $efd3ba4ec2608b1d$var$listNuWait1[istep] + 1;
            if ($efd3ba4ec2608b1d$var$listNuWait1[istep] > 10) {
                //listLoaded1[istep] = "non";
                $efd3ba4ec2608b1d$var$listLoaded1[istep] = "error";
                $efd3ba4ec2608b1d$var$listNuWait1[istep] = 0;
                message = " Layer no: 1   had more than 10 iteration in lazy loading check";
                console.log(message);
            }
        } else {
            $efd3ba4ec2608b1d$var$listLoaded1[istep] = "lazyLoading";
            $efd3ba4ec2608b1d$var$listLoadedCo1[istep] = "lazyLoading";
            message = " Layer no: 1  has acquired lazyLoading status";
            console.log(message);
        }
    } else if (no == 2) {
        var couche2Extent_ = $efd3ba4ec2608b1d$var$ZoomToExtent.get($efd3ba4ec2608b1d$var$Couche2.zoomId);
        var couche2Proj_ = $efd3ba4ec2608b1d$var$ZoomToProjec.get($efd3ba4ec2608b1d$var$Couche2.zoomId);
        if (couche2Proj_ != viewProj_) couche2Extent_ = (0, $9c4744460e43e41b$export$751c68e0e0efff79)(couche2Extent_, couche2Proj_, viewProj_);
        if ($efd3ba4ec2608b1d$var$IsCoucheExtentInExtent(viewExtent_, couche2Extent_)) {
            message = " Layer no: 2 is not considered for lazy Loading status";
            console.log(message);
            $efd3ba4ec2608b1d$var$listNuWait2[istep] = $efd3ba4ec2608b1d$var$listNuWait2[istep] + 1;
            if ($efd3ba4ec2608b1d$var$listNuWait2[istep] > 10) {
                //listLoaded2[istep] = "non";
                $efd3ba4ec2608b1d$var$listLoaded2[istep] = "error";
                $efd3ba4ec2608b1d$var$listNuWait2[istep] = 0;
                message = " Layer no: 2   had more than 10 iteration in lazy loading check";
                console.log(message);
            }
        } else {
            $efd3ba4ec2608b1d$var$listLoaded2[istep] = "lazyLoading";
            $efd3ba4ec2608b1d$var$listLoadedCo2[istep] = "lazyLoading";
            message = " Layer no:  2 has acquired lazyLoading status";
            console.log(message);
        }
    }
    return retour;
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$GoToLastTimeStep() {
    $efd3ba4ec2608b1d$var$DesactiveAndStopAnimate();
    var index = $efd3ba4ec2608b1d$var$ISTEP % $efd3ba4ec2608b1d$var$NoOfLayers;
    $efd3ba4ec2608b1d$var$tileLayers1[index].setOpacity(0.);
    $efd3ba4ec2608b1d$var$tileLayers2[index].setOpacity(0.);
    $efd3ba4ec2608b1d$var$tileLayersCo1[index].setOpacity(0.);
    $efd3ba4ec2608b1d$var$tileLayersCo2[index].setOpacity(0.);
    var message = " loading: " + $efd3ba4ec2608b1d$var$ISTEP_max;
    console.log(message);
    //     The last step is loaded above but still not visible. The step toward the last timestep is made via
    //     the following call to TimeStep() in forward mode. This will make the last layer of the last timestep visible,  and trigger the load of the 
    //     step 0.
    $efd3ba4ec2608b1d$var$Avance = true;
    let increment = 1;
    $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
    $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP_max - 1;
    $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP_max;
    $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
    $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
    if ($efd3ba4ec2608b1d$var$L_Interca) $efd3ba4ec2608b1d$var$AfficheraLayer1 = false;
    else $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
    setTimeout(function() {
        $efd3ba4ec2608b1d$var$TimeStep(increment, true);
        $efd3ba4ec2608b1d$var$RefreshValeur();
    }, 500);
}
// ________________________________________________________________________________
//
$("#GoToLastTimeStep").click(function() {
    $efd3ba4ec2608b1d$var$GoToLastTimeStep();
});
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$GoToFirstTimeStep() {
    //  if ( ISTEP != 0 ) {
    $efd3ba4ec2608b1d$var$DesactiveAndStopAnimate();
    var index = $efd3ba4ec2608b1d$var$ISTEP % $efd3ba4ec2608b1d$var$NoOfLayers;
    $efd3ba4ec2608b1d$var$tileLayers1[index].setOpacity(0.);
    $efd3ba4ec2608b1d$var$tileLayers2[index].setOpacity(0.);
    $efd3ba4ec2608b1d$var$tileLayersCo1[index].setOpacity(0.);
    $efd3ba4ec2608b1d$var$tileLayersCo2[index].setOpacity(0.);
    var message = " loading:  step 0";
    console.log(message);
    $efd3ba4ec2608b1d$var$Avance = true;
    let increment = 1;
    $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
    $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP_max;
    $efd3ba4ec2608b1d$var$ISTEP_next = 0;
    $efd3ba4ec2608b1d$var$ISTEP_repeatEndLoop = 0; // to ensure the call to TimeStep will be going from ISTEP = ISTEP_max   to ISTEP = 0
    $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
    $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
    //     The 0 step is loaded above but still not visible. In the following, the step from the last timestep to the initial step is made via
    //     the following call to TimeStep() from ISTEP = ISTEP_max  to 0. This will make timestep 0 visible,  and trigger the load of the next time step 
    if ($efd3ba4ec2608b1d$var$L_Interca) $efd3ba4ec2608b1d$var$AfficheraLayer1 = false;
    else $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
    setTimeout(function() {
        $efd3ba4ec2608b1d$var$TimeStep(increment, true);
        $efd3ba4ec2608b1d$var$RefreshValeur();
    }, 500);
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$Reload() {
    $efd3ba4ec2608b1d$var$DesactiveAndStopAnimate();
    $efd3ba4ec2608b1d$var$ISTEP_repeatEndLoop = 0;
    var message = " requesting a Relaod for time step: " + $efd3ba4ec2608b1d$var$ISTEP;
    console.log(message);
    var increment;
    if (!$efd3ba4ec2608b1d$var$L_Interca) {
        $efd3ba4ec2608b1d$var$ISTEP = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
        $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP;
        if ($efd3ba4ec2608b1d$var$Avance) {
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP - 1;
            if ($efd3ba4ec2608b1d$var$ISTEP < 0) $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP_max;
            increment = 1;
        } else {
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP + 1;
            if ($efd3ba4ec2608b1d$var$ISTEP > $efd3ba4ec2608b1d$var$ISTEP_max) $efd3ba4ec2608b1d$var$ISTEP = 0;
            increment = -1;
        }
        $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo2[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$listUrl2[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$ISTEP_next, $efd3ba4ec2608b1d$var$Couche2, 2);
        $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo1[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$listUrl1[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$ISTEP_next, $efd3ba4ec2608b1d$var$Couche1, 1);
    } else {
        if ($efd3ba4ec2608b1d$var$AfficheraLayer2 && $efd3ba4ec2608b1d$var$Avance) {
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = false;
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
            $efd3ba4ec2608b1d$var$ISTEP = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo1[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$listUrl1[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$Couche1, 1);
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo1[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$listUrl1[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$ISTEP_next, $efd3ba4ec2608b1d$var$Couche1, 1);
            increment = 1;
        } else if ($efd3ba4ec2608b1d$var$AfficheraLayer2) {
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = false;
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
            $efd3ba4ec2608b1d$var$ISTEP = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
            $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP;
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP + 1;
            if ($efd3ba4ec2608b1d$var$ISTEP > $efd3ba4ec2608b1d$var$ISTEP_max) $efd3ba4ec2608b1d$var$ISTEP = 0;
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo1[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$listUrl1[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$Couche1, 1);
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo1[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$listUrl1[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$ISTEP_next, $efd3ba4ec2608b1d$var$Couche1, 1);
            increment = -1;
        } else if ($efd3ba4ec2608b1d$var$AfficheraLayer1 && $efd3ba4ec2608b1d$var$Avance) {
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = false;
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
            $efd3ba4ec2608b1d$var$ISTEP = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
            $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP;
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP - 1;
            if ($efd3ba4ec2608b1d$var$ISTEP < 0) $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP_max;
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo2[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$listUrl2[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$Couche2, 2);
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo2[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$listUrl2[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$ISTEP_next, $efd3ba4ec2608b1d$var$Couche2, 2);
            increment = 1;
        } else if ($efd3ba4ec2608b1d$var$AfficheraLayer1) {
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = false;
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
            $efd3ba4ec2608b1d$var$ISTEP = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo2[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$listUrl2[$efd3ba4ec2608b1d$var$ISTEP], $efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$Couche2, 2);
            $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo2[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$listUrl2[$efd3ba4ec2608b1d$var$ISTEP_next], $efd3ba4ec2608b1d$var$ISTEP_next, $efd3ba4ec2608b1d$var$Couche2, 2);
            increment = -1;
        }
    }
    setTimeout(function() {
        $efd3ba4ec2608b1d$var$TimeStep(increment, true);
        $efd3ba4ec2608b1d$var$RefreshValeur();
    }, 500);
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$Refresh() {
    $efd3ba4ec2608b1d$var$DesactiveAndStopAnimate();
    $efd3ba4ec2608b1d$var$ISTEP_repeatEndLoop = 0;
    var message = " requesting a refresh for time step: " + $efd3ba4ec2608b1d$var$ISTEP;
    console.log(message);
    var increment;
    if (!$efd3ba4ec2608b1d$var$L_Interca) {
        $efd3ba4ec2608b1d$var$ISTEP = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
        $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP;
        if ($efd3ba4ec2608b1d$var$Avance) {
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP - 1;
            if ($efd3ba4ec2608b1d$var$ISTEP < 0) $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP_max;
            increment = 1;
        } else {
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP + 1;
            if ($efd3ba4ec2608b1d$var$ISTEP > $efd3ba4ec2608b1d$var$ISTEP_max) $efd3ba4ec2608b1d$var$ISTEP = 0;
            increment = -1;
        }
        $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
        $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
    //tileLayers1[index].setOpacity(0.);
    //tileLayers2[index].setOpacity(0.);
    //tileLayersCo1[index].setOpacity(0.);
    //tileLayersCo2[index].setOpacity(0.);
    } else {
        if ($efd3ba4ec2608b1d$var$AfficheraLayer2 && $efd3ba4ec2608b1d$var$Avance) {
            $efd3ba4ec2608b1d$var$ISTEP = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = false;
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP, 1);
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
            increment = 1;
        } else if ($efd3ba4ec2608b1d$var$AfficheraLayer2) {
            $efd3ba4ec2608b1d$var$ISTEP = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
            $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP;
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP + 1;
            if ($efd3ba4ec2608b1d$var$ISTEP > $efd3ba4ec2608b1d$var$ISTEP_max) $efd3ba4ec2608b1d$var$ISTEP = 0;
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = false;
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
            increment = -1;
        } else if ($efd3ba4ec2608b1d$var$AfficheraLayer1 && $efd3ba4ec2608b1d$var$Avance) {
            $efd3ba4ec2608b1d$var$ISTEP = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
            $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP;
            $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP - 1;
            if ($efd3ba4ec2608b1d$var$ISTEP < 0) $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP_max;
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = false;
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
            increment = 1;
        } else if ($efd3ba4ec2608b1d$var$AfficheraLayer1) {
            $efd3ba4ec2608b1d$var$ISTEP = Math.min($efd3ba4ec2608b1d$var$ISTEP, $efd3ba4ec2608b1d$var$ISTEP_max);
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = false;
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
            increment = -1;
        }
    }
    setTimeout(function() {
        $efd3ba4ec2608b1d$var$TimeStep(increment, true);
        $efd3ba4ec2608b1d$var$RefreshValeur();
    }, 300);
}
// ________________________________________________________________________________
//
$("#GoToFirstTimeStep").click(function() {
    $efd3ba4ec2608b1d$var$GoToFirstTimeStep();
});
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$StepForward(increment) {
    $efd3ba4ec2608b1d$var$DesactiveAndStopAnimate();
    $efd3ba4ec2608b1d$var$ISTEP_repeatEndLoop = 0;
    if (!$efd3ba4ec2608b1d$var$Avance) {
        $efd3ba4ec2608b1d$var$Avance = true;
        if ($efd3ba4ec2608b1d$var$ISTEP > $efd3ba4ec2608b1d$var$ISTEP_max) $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP_max;
        $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP + increment;
        if ($efd3ba4ec2608b1d$var$ISTEP_next > $efd3ba4ec2608b1d$var$ISTEP_max) $efd3ba4ec2608b1d$var$ISTEP_next = 0;
        if ($efd3ba4ec2608b1d$var$L_Interca) {
            if ($efd3ba4ec2608b1d$var$AfficheraLayer1) {
                $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP, 1);
                $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
            } else if ($efd3ba4ec2608b1d$var$AfficheraLayer2) {
                $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
                $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
            }
        } else {
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
        }
        setTimeout(function() {
            $efd3ba4ec2608b1d$var$TimeStep(increment, true);
            $efd3ba4ec2608b1d$var$RefreshValeur();
        }, 350);
    } else setTimeout(function() {
        $efd3ba4ec2608b1d$var$TimeStep(increment, true);
        $efd3ba4ec2608b1d$var$RefreshValeur();
    }, 250);
}
// ________________________________________________________________________________
//
$("#StepForward").click(function() {
    $efd3ba4ec2608b1d$var$StepForward(1);
});
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$StepBackward(increment) {
    $efd3ba4ec2608b1d$var$DesactiveAndStopAnimate();
    $efd3ba4ec2608b1d$var$ISTEP_repeatEndLoop = 0;
    if ($efd3ba4ec2608b1d$var$Avance) {
        $efd3ba4ec2608b1d$var$Avance = false;
        if ($efd3ba4ec2608b1d$var$ISTEP > $efd3ba4ec2608b1d$var$ISTEP_max) $efd3ba4ec2608b1d$var$ISTEP = $efd3ba4ec2608b1d$var$ISTEP_max;
        $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP + increment;
        if ($efd3ba4ec2608b1d$var$ISTEP_next < 0) $efd3ba4ec2608b1d$var$ISTEP_next = $efd3ba4ec2608b1d$var$ISTEP_max;
        if ($efd3ba4ec2608b1d$var$L_Interca) {
            if ($efd3ba4ec2608b1d$var$AfficheraLayer1) {
                $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
                $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
            } else if ($efd3ba4ec2608b1d$var$AfficheraLayer2) {
                $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
                $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
            }
        } else {
            $efd3ba4ec2608b1d$var$AfficheraLayer1 = true;
            $efd3ba4ec2608b1d$var$AfficheraLayer2 = true;
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 2);
            $efd3ba4ec2608b1d$var$updateSource($efd3ba4ec2608b1d$var$ISTEP_next, 1);
        }
        setTimeout(function() {
            $efd3ba4ec2608b1d$var$TimeStep(increment, true);
            $efd3ba4ec2608b1d$var$RefreshValeur();
        }, 350);
    } else setTimeout(function() {
        $efd3ba4ec2608b1d$var$TimeStep(increment, true);
        $efd3ba4ec2608b1d$var$RefreshValeur();
    }, 250);
}
// ________________________________________________________________________________
//
$("#StepBackward").click(function() {
    $efd3ba4ec2608b1d$var$StepBackward(-1);
});
// ________________________________________________________________________________
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$StepPre() {
    $efd3ba4ec2608b1d$var$ActiveLoop = false;
    $efd3ba4ec2608b1d$var$StopAnimate();
    document.getElementById("StopAnimate").style.display = "none";
    document.getElementById("StartAnimate").style.display = "initial";
    $efd3ba4ec2608b1d$var$ISTEP_repeatEndLoop = 0;
    if ($efd3ba4ec2608b1d$var$Avance) $efd3ba4ec2608b1d$var$StepBackward(-1);
    else $efd3ba4ec2608b1d$var$StepForward(1);
}
// ________________________________________________________________________________
//
$("#StepPre").click(function() {
    $efd3ba4ec2608b1d$var$StepPre();
});
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$Animate() {
    if ($efd3ba4ec2608b1d$var$ISTEP_increment != 0) {
        $efd3ba4ec2608b1d$var$LoopRunning = true;
        $efd3ba4ec2608b1d$var$ActiveLoop = true;
        $efd3ba4ec2608b1d$var$ISTEP_repeatEndLoop = parseInt(Math.max(5, Math.min(10, $efd3ba4ec2608b1d$var$InitDelay / $efd3ba4ec2608b1d$var$Delay)));
        $efd3ba4ec2608b1d$var$Avance = true;
        $efd3ba4ec2608b1d$var$TimeStep($efd3ba4ec2608b1d$var$ISTEP_increment, false);
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$DesactiveAndStopAnimate() {
    $efd3ba4ec2608b1d$var$ActiveLoop = false;
    $efd3ba4ec2608b1d$var$StopAnimate();
    $efd3ba4ec2608b1d$var$ResetValeurs();
    document.getElementById("StopAnimate").style.display = "none";
    document.getElementById("StartAnimate").style.display = "initial";
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$StopAnimate() {
    $efd3ba4ec2608b1d$var$LoopRunning = false;
    $efd3ba4ec2608b1d$var$ISTEP_increment = 0;
    $efd3ba4ec2608b1d$var$LoadExtra = false;
}
// ________________________________________________________________________________
//
$("#StopAnimate").click(function() {
    $efd3ba4ec2608b1d$var$DesactiveAndStopAnimate();
});
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$StartAnimate() {
    if (!$efd3ba4ec2608b1d$var$Avance) $efd3ba4ec2608b1d$var$StepForward(1);
    $efd3ba4ec2608b1d$var$UnsetValeurs("0");
    $efd3ba4ec2608b1d$var$ActiveLoop = true;
    $efd3ba4ec2608b1d$var$LoopRunning = true;
    $efd3ba4ec2608b1d$var$ISTEP_increment = 1;
    $efd3ba4ec2608b1d$var$LoadExtra = false;
}
function $efd3ba4ec2608b1d$var$ActivateAndStartAnimate() {
    $efd3ba4ec2608b1d$var$StartAnimate();
    document.getElementById("StartAnimate").style.display = "none";
    document.getElementById("StopAnimate").style.display = "initial";
}
// ________________________________________________________________________________
//
$("#StartAnimate").click(function() {
    $efd3ba4ec2608b1d$var$ActivateAndStartAnimate();
});
//
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$SpeedReset(delay_) {
    $efd3ba4ec2608b1d$var$StopAnimate();
    clearInterval($efd3ba4ec2608b1d$var$RunAnim);
    $efd3ba4ec2608b1d$var$RunAnim = setInterval(function() {
        $efd3ba4ec2608b1d$var$Animate();
    }, delay_);
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$Slower(delay_) {
    $efd3ba4ec2608b1d$var$StopAnimate();
    clearInterval($efd3ba4ec2608b1d$var$RunAnim);
    var tentativeDelay = delay_ * 1.26;
    if (tentativeDelay > 20480) tentativeDelay = 20480;
    let message0 = " Requested animation Delay was " + $efd3ba4ec2608b1d$var$Delay + " ms. It will be set to: " + tentativeDelay + " ms. ";
    console.log(message0);
    if ($efd3ba4ec2608b1d$var$CurrentDelay > tentativeDelay) {
        console.log(" ---------------------------------------------------------------------------");
        console.log(" ---------------------------------------------------------------------------");
        let message1 = " However the effective Current Delay is set slower to " + $efd3ba4ec2608b1d$var$CurrentDelay + " ms. ";
        let message2 = " Your desired pace will be effective if performance is allowing it. ";
        console.log(message1);
        console.log(message2);
        console.log(" ---------------------------------------------------------------------------");
        console.log(" ---------------------------------------------------------------------------");
        let message = "<br>" + message0 + "<br>" + message1 + "<br>" + message2 + "<br> <br>";
        $efd3ba4ec2608b1d$var$openAfficheInfo(message, 10);
    } else $efd3ba4ec2608b1d$var$CurrentDelay = tentativeDelay;
    $efd3ba4ec2608b1d$var$Delay = tentativeDelay;
    $efd3ba4ec2608b1d$var$RunAnim = setInterval(function() {
        $efd3ba4ec2608b1d$var$Animate();
    }, $efd3ba4ec2608b1d$var$CurrentDelay);
    if ($efd3ba4ec2608b1d$var$ActiveLoop) $efd3ba4ec2608b1d$var$StartAnimate();
}
// ________________________________________________________________________________
//
$("#Slower").click(function() {
    $efd3ba4ec2608b1d$var$Slower($efd3ba4ec2608b1d$var$Delay);
});
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$Faster(delay_) {
    $efd3ba4ec2608b1d$var$StopAnimate();
    clearInterval($efd3ba4ec2608b1d$var$RunAnim);
    var tentativeDelay = delay_ / 2.;
    if (tentativeDelay < 40) tentativeDelay = 40;
    if ($efd3ba4ec2608b1d$var$CurrentDelay > $efd3ba4ec2608b1d$var$Delay) {
        console.log(" ---------------------------------------------------------------------------");
        console.log(" ---------------------------------------------------------------------------");
        let message = " Requested animation pace will remain at " + $efd3ba4ec2608b1d$var$Delay + " ms due to current performance slowliness. ";
        let message2 = " Try a speed up later when the requested pace could be met. Effective Current pace is " + $efd3ba4ec2608b1d$var$CurrentDelay + " ms. ";
        console.log(message);
        console.log(message2);
        console.log(" ---------------------------------------------------------------------------");
        console.log(" ---------------------------------------------------------------------------");
        message = "<br>" + message + "<br>" + message2 + "<br> <br>";
        $efd3ba4ec2608b1d$var$openAfficheInfo(message, 10);
    } else {
        console.log(" Requested animation pace of " + $efd3ba4ec2608b1d$var$Delay + " ms will be set to: " + tentativeDelay + " ms if performance allows. ");
        $efd3ba4ec2608b1d$var$CurrentDelay = tentativeDelay;
        $efd3ba4ec2608b1d$var$Delay = tentativeDelay;
    }
    $efd3ba4ec2608b1d$var$RunAnim = setInterval(function() {
        $efd3ba4ec2608b1d$var$Animate();
    }, $efd3ba4ec2608b1d$var$CurrentDelay);
    if ($efd3ba4ec2608b1d$var$ActiveLoop) $efd3ba4ec2608b1d$var$StartAnimate();
}
// ________________________________________________________________________________
//
$("#Faster").click(function() {
    $efd3ba4ec2608b1d$var$Faster($efd3ba4ec2608b1d$var$Delay);
});
// ________________________________________________________________________________
//
//   INITIALISATION DE ANIMATION ----------------------------------------------------------
///old
$efd3ba4ec2608b1d$var$ActiveLoadLayers = true;
// Ici mettre le LoadLayers de toute les couches 
console.log(" ici premier appel a LoadLayers");
$efd3ba4ec2608b1d$var$LoadLayers($efd3ba4ec2608b1d$var$ISTEP, 0);
$efd3ba4ec2608b1d$var$LoadLayers($efd3ba4ec2608b1d$var$ISTEP_next, 0);
console.log(" ici apr\xe8s premier appel a LoadLayers");
setTimeout(function() {
    $efd3ba4ec2608b1d$var$resetTimeMenus();
}, 1000);
var $efd3ba4ec2608b1d$var$InitDelay = 640;
var $efd3ba4ec2608b1d$var$Delay = $efd3ba4ec2608b1d$var$InitDelay;
var $efd3ba4ec2608b1d$var$CurrentDelay = $efd3ba4ec2608b1d$var$InitDelay;
//   FactLongerDelay was 200
var $efd3ba4ec2608b1d$var$FactLongerDelay = 1.0;
$efd3ba4ec2608b1d$var$StopAnimate();
let $efd3ba4ec2608b1d$var$RunAnim = setInterval(function() {
    $efd3ba4ec2608b1d$var$Animate();
}, $efd3ba4ec2608b1d$var$CurrentDelay);
//setTimeout(function() { StartAnimate(); }, 3000);
//
//
//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
///  const TEMPS_INACTIVITE = 144 * 5 * 60 * 1000; // 5 minutes
///  let timer;
function $efd3ba4ec2608b1d$var$fermerCompletement() {
    // Nettoyage des données locales
    sessionStorage.clear();
    // Tentative de fermeture d'onglet, sinon écran noir
    window.close();
    document.body.innerHTML = '<div style="color:#fff;text-align:center;padding-top:20%;"><h1>Interface ferm\xe9e pour inactivit\xe9</h1></div>';
    document.body.style.backgroundColor = "#111";
}
function $efd3ba4ec2608b1d$var$reinitialiserTimer() {
    clearTimeout(timer);
    timer = setTimeout($efd3ba4ec2608b1d$var$fermerCompletement, TEMPS_INACTIVITE);
}
//   le timer d'inactivité est réinititalisé lors des actions suivnates de l'utilisateur
///  ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'].forEach(evt => {
///    window.addEventListener(evt, reinitialiserTimer, { passive: true });
///});
///reinitialiserTimer();
//  Ici on ajoute une action de l'utilisateur qui remet le timer à zéro
///document.addEventListener("visibilitychange", () => {
///if (document.hidden) {
///// L'onglet est masqué / minimisé
///console.log("L'utilisateur a quitté l'onglet");
///} else {
///// L'utilisateur revient sur l'onglet -> on réinitialise le timer
///reinitialiserTimer();
///}
///});
//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//   INITIALISATION du système de mise à jour des date d'origines  ----------------------------
var $efd3ba4ec2608b1d$var$BackgroundCheckH = setInterval(function() {
    $efd3ba4ec2608b1d$var$BackgroundCheckIfHourOIdOk(false);
}, 2000);
setTimeout(function() {
    $efd3ba4ec2608b1d$var$reStartBackgroundCheckH();
}, 20000);
setTimeout(function() {
    if ($efd3ba4ec2608b1d$var$Lgnd2Large) $efd3ba4ec2608b1d$var$showLgnd(2);
    if ($efd3ba4ec2608b1d$var$Lgnd1Large) $efd3ba4ec2608b1d$var$showLgnd(1);
}, 2000);
var $efd3ba4ec2608b1d$var$StorageZoomId = "CurrZoom";
var $efd3ba4ec2608b1d$var$StorageProjId = "CurrProj";
var $efd3ba4ec2608b1d$var$StorageCenterIdX = "CurrCenterX";
var $efd3ba4ec2608b1d$var$StorageCenterIdY = "CurrCenterY";
if ($efd3ba4ec2608b1d$var$WindMaps) {
    $efd3ba4ec2608b1d$var$StorageZoomId = "CurrZoom_V";
    $efd3ba4ec2608b1d$var$StorageProjId = "CurrProj_V";
    $efd3ba4ec2608b1d$var$StorageCenterIdX = "CurrCenterX_V";
    $efd3ba4ec2608b1d$var$StorageCenterIdY = "CurrCenterY_V";
} else if ($efd3ba4ec2608b1d$var$Nowcast) {
    $efd3ba4ec2608b1d$var$StorageZoomId = "CurrZoom_N";
    $efd3ba4ec2608b1d$var$StorageProjId = "CurrProj_N";
    $efd3ba4ec2608b1d$var$StorageCenterIdX = "CurrCenterX_N";
    $efd3ba4ec2608b1d$var$StorageCenterIdY = "CurrCenterY_N";
}
$efd3ba4ec2608b1d$var$SetVu($efd3ba4ec2608b1d$var$Couche1.projection, $efd3ba4ec2608b1d$var$ZoomToViewExtent.get($efd3ba4ec2608b1d$var$Couche1.zoomId), true);
var $efd3ba4ec2608b1d$var$CurrZoom = $efd3ba4ec2608b1d$var$map.getView().getZoom();
var $efd3ba4ec2608b1d$var$CurrCenter = $efd3ba4ec2608b1d$var$map.getView().getCenter();
var $efd3ba4ec2608b1d$var$CurrProj = $efd3ba4ec2608b1d$var$map.getView().getProjection().getCode();
localStorage.setItem($efd3ba4ec2608b1d$var$StorageProjId, $efd3ba4ec2608b1d$var$CurrProj);
$efd3ba4ec2608b1d$var$map.on("movestart", function(e) {
    $efd3ba4ec2608b1d$var$StopAnimate();
});
$efd3ba4ec2608b1d$var$map.on("moveend", function(e) {
    $efd3ba4ec2608b1d$var$StopAnimate();
    var newZoom = $efd3ba4ec2608b1d$var$map.getView().getZoom();
    if ($efd3ba4ec2608b1d$var$CurrZoom != newZoom) {
        console.log("zoom end, new zoom: " + newZoom);
        $efd3ba4ec2608b1d$var$CurrZoom = newZoom;
        localStorage.setItem($efd3ba4ec2608b1d$var$StorageZoomId, $efd3ba4ec2608b1d$var$CurrZoom);
        let zoomLayer1 = $efd3ba4ec2608b1d$var$getZLayerCoLayer("1");
        console.log("zoom Layer 1:  " + zoomLayer1[0] + " coLayer 1: " + zoomLayer1[1]);
        $efd3ba4ec2608b1d$var$CountTiles1 = $efd3ba4ec2608b1d$var$CountTilesInView("1");
        document.getElementById("zoomLvl1").innerHTML = $efd3ba4ec2608b1d$var$CountTiles1[0];
        document.getElementById("zoomLvlCo1").innerHTML = $efd3ba4ec2608b1d$var$CountTiles1[1];
        let zoomLayer2 = $efd3ba4ec2608b1d$var$getZLayerCoLayer("2");
        console.log("zoom Layer 2:  " + zoomLayer2[0] + " coLayer 2: " + zoomLayer2[1]);
        $efd3ba4ec2608b1d$var$CountTiles2 = $efd3ba4ec2608b1d$var$CountTilesInView("2");
        document.getElementById("zoomLvl2").innerHTML = $efd3ba4ec2608b1d$var$CountTiles2[0];
        document.getElementById("zoomLvlCo2").innerHTML = $efd3ba4ec2608b1d$var$CountTiles2[1];
    }
    var newProj = $efd3ba4ec2608b1d$var$map.getView().getProjection().getCode();
    console.log("newProj1 : et CurrProj " + newProj + "  " + $efd3ba4ec2608b1d$var$CurrProj);
    if ($efd3ba4ec2608b1d$var$CurrProj != newProj) {
        console.log("Proj2 : " + newProj);
        $efd3ba4ec2608b1d$var$CurrProj = newProj;
        localStorage.setItem($efd3ba4ec2608b1d$var$StorageProjId, $efd3ba4ec2608b1d$var$CurrProj);
    }
    var newCenter = $efd3ba4ec2608b1d$var$map.getView().getCenter();
    if ($efd3ba4ec2608b1d$var$CurrCenter != newCenter) {
        console.log("new center: " + newCenter);
        $efd3ba4ec2608b1d$var$CurrCenter = newCenter;
        localStorage.setItem($efd3ba4ec2608b1d$var$StorageCenterIdX, $efd3ba4ec2608b1d$var$CurrCenter[0]);
        localStorage.setItem($efd3ba4ec2608b1d$var$StorageCenterIdY, $efd3ba4ec2608b1d$var$CurrCenter[1]);
    }
    if ($efd3ba4ec2608b1d$var$ActiveLoop) setTimeout(function() {
        $efd3ba4ec2608b1d$var$StartAnimate();
    }, 500);
});
//if ( Model2localVoid ) {
// ChoixDuo("void", "void", "void",  Couche1.modeleZoom, Couche1.mapIdH, Couche1.mapIdHCo,  "1");
//} 
//map.on('singleclick',  StepForward(1));
//map.on('dblclick', StepForward(1) );
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$CreerUrlImage(tronc, modele, zoomid, mapid, houroid, prog) {
    var string_ = houroid.substring(0, 10);
    return "../" + tronc + "/" + modele + "_" + zoomid + "/" + string_ + "/TO_" + mapid + "_" + houroid + "_" + prog;
//} else {
//  return '../'+ tronc +'/'+ modele +'_'+ zoomid + '/TO_'+ mapid +'_'+ houroid +'_'+ prog;  
//}
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$CreerUrlImageLeg(tronc, modele, zoomid, mapid, houroid) {
    //console.log('../'+ tronc +'/'+ modele +'_'+ zoomid +'/L_'+ mapid +'_'+ houroid + '.png');
    var string_ = houroid.substring(0, 10);
    return "../" + tronc + "/" + modele + "_" + zoomid + "/" + string_ + "/L_" + mapid + "_" + houroid + ".png";
//  } else {
//      return '../'+ tronc +'/'+ modele +'_'+ zoomid + '/L_'+ mapid +'_'+ houroid + '.png';  
//  }
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$CreerUrlImageLatest(tronc, modele, zoomid) {
    //console.log('../'+ tronc +'/'+ modele +'_'+ zoomid +'/latest');
    return "../" + tronc + "/" + modele + "_" + zoomid + "/latest.txt";
}
// ________________________________________________________________________________
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$checkIfImageExists() {
    var message = " ";
    if ($efd3ba4ec2608b1d$var$ActiveImgExist) {
        if ($efd3ba4ec2608b1d$var$Img.complete) {
            message = " Complete: " + $efd3ba4ec2608b1d$var$UrlImgExist;
            if ($efd3ba4ec2608b1d$var$VerboseImgExist) console.log(message);
            if ($efd3ba4ec2608b1d$var$ImgExist) {
                message = " Image exist ";
                if ($efd3ba4ec2608b1d$var$VerboseImgExist) console.log(message);
            } else {
                message = " Image does not exist ";
                if ($efd3ba4ec2608b1d$var$VerboseImgExist) console.log(message);
            }
            if ($efd3ba4ec2608b1d$var$CountImgExist < $efd3ba4ec2608b1d$var$MaxCountImgExist) {
                $efd3ba4ec2608b1d$var$CountImgExist = $efd3ba4ec2608b1d$var$CountImgExist + 1;
                if ($efd3ba4ec2608b1d$var$ICoucheImgExist == 1) $efd3ba4ec2608b1d$var$UrlImgExist = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche1.getModele(), $efd3ba4ec2608b1d$var$Couche1.getZoomId(), $efd3ba4ec2608b1d$var$Couche1.getMapId(), $efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$CountImgExist], $efd3ba4ec2608b1d$var$listProg1[$efd3ba4ec2608b1d$var$CountImgExist]);
                else $efd3ba4ec2608b1d$var$UrlImgExist = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche2.getModele(), $efd3ba4ec2608b1d$var$Couche2.getZoomId(), $efd3ba4ec2608b1d$var$Couche2.getMapId(), $efd3ba4ec2608b1d$var$listHourOId2[$efd3ba4ec2608b1d$var$CountImgExist], $efd3ba4ec2608b1d$var$listProg2[$efd3ba4ec2608b1d$var$CountImgExist]);
                message = " Checking for Image: " + $efd3ba4ec2608b1d$var$UrlImgExist;
                if ($efd3ba4ec2608b1d$var$VerboseImgExist) console.log(message);
                $efd3ba4ec2608b1d$var$ImgExist = false;
                $efd3ba4ec2608b1d$var$Img.src = $efd3ba4ec2608b1d$var$UrlImgExist;
            } else clearInterval(CheckIfImageExistsUntilLoaded);
        }
    }
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$TriggerCheckIfImageExists(countImgExist, maxCountImgExist, iCoucheImgExist) {
    var message = " ";
    $efd3ba4ec2608b1d$var$Img.onload = ()=>{
        $efd3ba4ec2608b1d$var$ImgExist = true;
        message = " Img onload detected Image exist";
        if ($efd3ba4ec2608b1d$var$VerboseImgExist) console.log(message);
        message = " Loaded ok: " + $efd3ba4ec2608b1d$var$UrlImgExist;
        if ($efd3ba4ec2608b1d$var$VerboseImgExist) console.log(message);
    };
    $efd3ba4ec2608b1d$var$Img.onerror = ()=>{
        $efd3ba4ec2608b1d$var$ImgExist = false;
        message = " Img onerror detected Image does not exist";
        if ($efd3ba4ec2608b1d$var$VerboseImgExist) console.log(message);
    };
    $efd3ba4ec2608b1d$var$ActiveImgExist = false;
    $efd3ba4ec2608b1d$var$CountImgExist = countImgExist;
    $efd3ba4ec2608b1d$var$MaxCountImgExist = maxCountImgExist;
    $efd3ba4ec2608b1d$var$ICoucheImgExist = iCoucheImgExist;
    if ($efd3ba4ec2608b1d$var$ICoucheImgExist == 1) $efd3ba4ec2608b1d$var$UrlImgExist = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche1.getModele(), $efd3ba4ec2608b1d$var$Couche1.getZoomId(), $efd3ba4ec2608b1d$var$Couche1.getMapId(), $efd3ba4ec2608b1d$var$listHourOId1[$efd3ba4ec2608b1d$var$CountImgExist], $efd3ba4ec2608b1d$var$listProg1[$efd3ba4ec2608b1d$var$CountImgExist]);
    else $efd3ba4ec2608b1d$var$UrlImgExist = $efd3ba4ec2608b1d$var$CreerUrlImage($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$Couche2.getModele(), $efd3ba4ec2608b1d$var$Couche2.getZoomId(), $efd3ba4ec2608b1d$var$Couche2.getMapId(), $efd3ba4ec2608b1d$var$listHourOId2[$efd3ba4ec2608b1d$var$CountImgExist], $efd3ba4ec2608b1d$var$listProg2[$efd3ba4ec2608b1d$var$CountImgExist]);
    message = " Checking for Image: " + $efd3ba4ec2608b1d$var$UrlImgExist;
    if ($efd3ba4ec2608b1d$var$VerboseImgExist) console.log(message);
    $efd3ba4ec2608b1d$var$StopAnimate();
    $efd3ba4ec2608b1d$var$ActiveLoop = false;
    document.getElementById("StopAnimate").style.display = "none";
    document.getElementById("StartAnimate").style.display = "initial";
    $efd3ba4ec2608b1d$var$ImgExist = false;
    $efd3ba4ec2608b1d$var$Img.src = $efd3ba4ec2608b1d$var$UrlImgExist;
    $efd3ba4ec2608b1d$var$ActiveImgExist = true;
    CheckIfImageExistsUntilLoaded = setInterval(function() {
        $efd3ba4ec2608b1d$var$checkIfImageExists();
    }, 500);
}
//------------------------------------------------------------------
var $efd3ba4ec2608b1d$var$ImgExist = false;
var $efd3ba4ec2608b1d$var$UrlImgExist = " ";
var $efd3ba4ec2608b1d$var$ActiveImgExist = false;
var $efd3ba4ec2608b1d$var$ICoucheImgExist = 0;
var $efd3ba4ec2608b1d$var$CountImgExist = 0;
var $efd3ba4ec2608b1d$var$MaxCountImgExist = 0;
var $efd3ba4ec2608b1d$var$VerboseImgExist = true;
const $efd3ba4ec2608b1d$var$Img = new Image();
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$updateLayers(istep2Load, icouche) {
    var message = " ";
    if (icouche == 0 || icouche == 1) $efd3ba4ec2608b1d$var$updateSource(istep2Load, 1);
    if (icouche == 0 || icouche == 2) $efd3ba4ec2608b1d$var$updateSource(istep2Load, 2);
}
// ________________________________________________________________________________
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$LoadLayers(istep2Load, icouche) {
    var trouve1 = false;
    var trouve2 = false;
    if (icouche == 0 || icouche == 1) trouve1 = $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo1[istep2Load], $efd3ba4ec2608b1d$var$listUrl1[istep2Load], istep2Load, $efd3ba4ec2608b1d$var$Couche1, 1);
    if (icouche == 0 || icouche == 2) trouve2 = $efd3ba4ec2608b1d$var$resetSource($efd3ba4ec2608b1d$var$listUrlCo2[istep2Load], $efd3ba4ec2608b1d$var$listUrl2[istep2Load], istep2Load, $efd3ba4ec2608b1d$var$Couche2, 2);
}
// ________________________________________________________________________________
//
//
function $efd3ba4ec2608b1d$var$reStartBackgroundCheckH() {
    clearInterval($efd3ba4ec2608b1d$var$BackgroundCheckH);
    $efd3ba4ec2608b1d$var$BackgroundCheckH = setInterval(function() {
        $efd3ba4ec2608b1d$var$BackgroundCheckIfHourOIdOk(false);
    }, 10000);
}
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$BackgroundCheckIfHourOIdOk(affiche) {
    var message = " ";
    var modele = "";
    var metAJour = false;
    $efd3ba4ec2608b1d$var$indexListHourOIdOk = $efd3ba4ec2608b1d$var$indexListHourOIdOk + 1;
    if ($efd3ba4ec2608b1d$var$indexListHourOIdOk > $efd3ba4ec2608b1d$var$ListModeleId.length - 1) $efd3ba4ec2608b1d$var$indexListHourOIdOk = 0;
    modele = $efd3ba4ec2608b1d$var$ListModeleId[$efd3ba4ec2608b1d$var$indexListHourOIdOk];
    let currentLatestH = $efd3ba4ec2608b1d$var$ModAHourOId.get(modele);
    if (currentLatestH != $efd3ba4ec2608b1d$var$GuessHourOId(modele, 0)) $efd3ba4ec2608b1d$var$readSetLatestHourOId(currentLatestH, modele, affiche, metAJour);
    else {
        message = " According to guess, Houroid of model: " + modele + " is the latest available: " + currentLatestH;
        if ($efd3ba4ec2608b1d$var$VerboseHourOIdOk) console.log(message);
    }
}
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$readSetLatestHourOId(currentLatestH, modele, affiche, metAJour) {
    let fichier = $efd3ba4ec2608b1d$var$CreerUrlImageLatest($efd3ba4ec2608b1d$var$Tronc, $efd3ba4ec2608b1d$var$ModToId.get(modele), $efd3ba4ec2608b1d$var$ModToZoom.get(modele));
    let latestDate = "";
    if (modele != "void") {
        function fetchFileContent(path, callback) {
            var httpRequest = new XMLHttpRequest();
            httpRequest.onreadystatechange = function() {
                if (httpRequest.readyState === 4) {
                    if (httpRequest.status === 200) {
                        // Ne pas utiliser JSON.parse() ici !
                        var data = httpRequest.responseText;
                        if (callback) callback(data);
                    } else {
                        console.error("Erreur HTTP lors de la r\xe9cup\xe9ration du fichier:", httpRequest.status, httpRequest.statusText);
                        // Gérer l'erreur, peut-être appeler le callback avec null ou une erreur
                        if (callback) callback(null, new Error(`HTTP error: ${httpRequest.status}`));
                    }
                }
            };
            let numb_ = Math.random();
            let spath = path + "?v=" + numb_.toString();
            console.log(" Modele: " + modele + " URL latest: " + spath);
            httpRequest.open("GET", spath);
            httpRequest.send();
        }
        // this requests the file and executes a callback with the parsed result once
        //    it is available
        fetchFileContent(fichier, function(data, error) {
            if (error) {
                console.error("\xc9chec de la lecture du fichier :", error);
                return;
            }
            console.log(" Contenu du fichier re\xe7u pour le mod\xe8le " + modele + ": " + data);
            let latestDate = " ";
            if (data.length <= 11) latestDate = data.substring(0, 10);
            else if (data.length == 13) latestDate = data.substring(0, 12);
            else console.log(" fichier latest corrompu avec datestamp: " + data);
            $efd3ba4ec2608b1d$var$ModAHourOId.set(modele, latestDate);
            $efd3ba4ec2608b1d$var$CheckIfHourOIdOk(currentLatestH, modele, affiche, metAJour);
        });
    }
}
// ________________________________________________________________________________
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$CheckIfHourOIdOk(currentLatestH, modele, affiche, metAJour) {
    let prevLatestH = currentLatestH;
    var message = " ";
    let nowcast = $efd3ba4ec2608b1d$var$isNowcast(modele);
    currentLatestH = $efd3ba4ec2608b1d$var$ModAHourOId.get(modele);
    if (prevLatestH != currentLatestH) {
        if (nowcast || metAJour) {
            message = " Nouvelle date: " + currentLatestH + " disponible pour: " + modele;
            affiche = false;
            if ($efd3ba4ec2608b1d$var$Couche1.modeleZoom == modele && $efd3ba4ec2608b1d$var$Couche2.modeleZoom == modele) {
                $efd3ba4ec2608b1d$var$refreshHouroid(0);
                affiche = true;
                message = message + " <br> mise a jour des couches 1 et 2, en cour ...  ";
            } else if ($efd3ba4ec2608b1d$var$Couche1.modeleZoom == modele) {
                $efd3ba4ec2608b1d$var$refreshHouroid(1);
                affiche = true;
                message = message + " <br> mise a jour de la couche 1, en cour... ";
            } else if ($efd3ba4ec2608b1d$var$Couche2.modeleZoom == modele) {
                $efd3ba4ec2608b1d$var$refreshHouroid(2);
                affiche = true;
                message = message + " <br> mise a jour de la couche 2, en cour ...";
            }
            if ($efd3ba4ec2608b1d$var$VerboseHourOIdOk) console.log(message);
        } else {
            message = " Nouvelle date: " + currentLatestH + " disponible pour: " + modele;
            if ($efd3ba4ec2608b1d$var$VerboseHourOIdOk) console.log(message);
        }
    } else {
        message = " After checking Houroid of model: " + modele + " is the latest available: " + currentLatestH;
        if ($efd3ba4ec2608b1d$var$VerboseHourOIdOk) console.log(message);
    }
}
// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//   Selector  for afficheInfo
const $efd3ba4ec2608b1d$var$AfficheInfo = document.getElementById("afficheInfo");
const $efd3ba4ec2608b1d$var$AfficheInfoTxt = document.getElementById("afficheInfoTxt");
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$openAfficheInfo(message, nbSecondes) {
    console.log(" openAfficheInfo: " + message + $efd3ba4ec2608b1d$var$AfficheInfo.innerHTML);
    $efd3ba4ec2608b1d$var$AfficheInfoTxt.innerHTML = $efd3ba4ec2608b1d$var$AfficheInfoTxt.innerHTML + message;
    $efd3ba4ec2608b1d$var$AfficheInfo.style.display = "block";
    setTimeout(function() {
        $efd3ba4ec2608b1d$var$closeAfficheInfo();
    }, nbSecondes * 1000);
}
// -----------------------------------------------------------------------------------
//
// $("#openAfficheInfo").click(function(){ openAfficheInfo(); });
function $efd3ba4ec2608b1d$var$closeAfficheInfo() {
    $efd3ba4ec2608b1d$var$AfficheInfo.style.display = "none";
    $efd3ba4ec2608b1d$var$AfficheInfoTxt.innerHTML = " Information: <br>";
}
// -----------------------------------------------------------------------------------
//
$("#closebtnAfficheInfo").click(function() {
    $efd3ba4ec2608b1d$var$closeAfficheInfo();
});
// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//   Selector  for afficheInit
const $efd3ba4ec2608b1d$var$AfficheInit = document.getElementById("afficheInit");
const $efd3ba4ec2608b1d$var$AfficheInitTxt = document.getElementById("afficheInitTxt");
// ________________________________________________________________________________
function $efd3ba4ec2608b1d$var$openAfficheInit(message, nbSecondes) {
    console.log(" openAfficheInit: " + message + $efd3ba4ec2608b1d$var$AfficheInit.innerHTML);
    $efd3ba4ec2608b1d$var$AfficheInitTxt.innerHTML = $efd3ba4ec2608b1d$var$AfficheInitTxt.innerHTML + message;
    $efd3ba4ec2608b1d$var$AfficheInit.style.display = "block";
    setTimeout(function() {
        $efd3ba4ec2608b1d$var$closeAfficheInit();
    }, nbSecondes * 1000);
}
// -----------------------------------------------------------------------------------
//
function $efd3ba4ec2608b1d$var$closeAfficheInit() {
    $efd3ba4ec2608b1d$var$AfficheInitTxt.innerHTML = " Informations initiales: <br>";
    $efd3ba4ec2608b1d$var$AfficheInit.style.display = "none";
}
// -----------------------------------------------------------------------------------
//
$("#closebtnAfficheInit").click(function() {
    $efd3ba4ec2608b1d$var$closeAfficheInit();
});
let $efd3ba4ec2608b1d$var$VersionCourant = parseInt(parseFloat($efd3ba4ec2608b1d$var$Version) * 10);
let $efd3ba4ec2608b1d$var$VersionHistori = parseInt(parseFloat($efd3ba4ec2608b1d$var$INFO_version) * 10);
console.log(" Version x10: ", $efd3ba4ec2608b1d$var$VersionCourant, " Version ant\xe9rieur x10:", $efd3ba4ec2608b1d$var$VersionHistori);
if ($efd3ba4ec2608b1d$var$VersionCourant !== $efd3ba4ec2608b1d$var$VersionHistori && !$efd3ba4ec2608b1d$var$WindMaps) {
    var $efd3ba4ec2608b1d$var$message = " Nouveau: " + $efd3ba4ec2608b1d$var$Version + " Bienvenue !" + "<br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "<br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + " Version 3.2 <br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   avec ajout de diagnostiques sur l'\xe9tat de la mer DIAGW (Saint-Laurent) <br> ";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   ajout de produit de pr\xe9vision de vague (r\xe9gional d\xe9terministe),  <br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   ajout d'acc\xe9l\xe9rateurs DuoC avec le nouveau mode ....<b>imeteomaps?flots</b> <br> ";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   acc\xe8s aux produits WCPS (NEMO) 4 fois par jour,  <br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   l\xe9ger agrandissement vers l'Est de la grille SUDQC pour inclure le Golfe, (Saint-Laurent), <br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   ajout de cumul de deux p\xe9riodes de 5 jours de pr\xe9cipitation total (mod\xe8les globaux), <br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   ajustement de seuils de pallette de couleurs pour les cumules de pluies de 12h et 24h, <br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   ajustement aux acc\xe9l\xe9rateurs (DuoA, DuoB, etc) afin de mieux g\xe9rer la juxtaposition, <br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   r\xe9duction significative du nombre de fen\xeatres popup informatives. <br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "<br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "  Documentation de l'interface: <a href='../image_res/documentation_imeteomaps_latest.htm' target='_blank'> documentation</a> <br> ";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "<b> S\xe9lectionnez ici la Documentation sp\xe9cifique de DIAGW (extraits, ou fichier complet): </b><br><br>";
    // Boutons de choix
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "<button onclick='changerDocument(\"../image_res/../image_res/vague_vent_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>complet</button>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "<button onclick='changerDocument(\"../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>extraits</button>";
    // Cadre iFrame unique (chargé par défaut avec le deuxieme document)
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "<iframe id='cadreDoc' src='../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH' width='100%' height='550px' style='border: 1px solid #ccc; border-radius: 4px;'></iframe>";
    console.log(" Version: ", $efd3ba4ec2608b1d$var$Version, " Version ant\xe9rieur :", $efd3ba4ec2608b1d$var$INFO_version);
    $efd3ba4ec2608b1d$var$openAfficheInit($efd3ba4ec2608b1d$var$message, 300);
    $efd3ba4ec2608b1d$var$closeAfficheInfo();
    $efd3ba4ec2608b1d$var$INFO_version = $efd3ba4ec2608b1d$var$Version;
    localStorage.setItem("INFO_version", $efd3ba4ec2608b1d$var$INFO_version);
    console.log(" Version: ", $efd3ba4ec2608b1d$var$Version, " Version mise \xe0 jour :", $efd3ba4ec2608b1d$var$INFO_version);
} else if ($efd3ba4ec2608b1d$var$VersionCourant !== $efd3ba4ec2608b1d$var$VersionHistori) {
    // WindMaps  est vrai ici
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + " Version 3.2 <br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   avec ajout de diagnostiques sur l'\xe9tat de la mer DIAGW (Saint-Laurent) <br> ";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   ajout de produit de pr\xe9vision de vague (r\xe9gional d\xe9terministe), <br> ";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   ajout d'acc\xe9l\xe9rateurs DuoC avec le nouveau mode ....<b>imeteomaps?flots</b> <br> ";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   acc\xe8s aux produits WCPS (NEMO) 4 fois par jour, <br> ";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "   l\xe9ger agrandissement vers l'Est de la grille SUDQC pour inclure le Golfe (Saint-Laurent). <br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "<br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "  Documentation de l'interface: <a href='../image_res/documentation_imeteomaps_latest.htm' target='_blank'> documentation</a> <br> ";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "<b>Documentation d\xe9taill\xe9e de DIAGW:</b> <a href='../image_res/vague_vent_v3.2b.pdf' target='_blank' style='font-size: 0.9em;'>(Ouvrir plein \xe9cran)</a><br>";
    $efd3ba4ec2608b1d$var$message = $efd3ba4ec2608b1d$var$message + "<iframe src='../image_res/vague_vent_v3.2b.pdf#view=FitH' width='100%' height='500px' style='border: 1px solid #ccc; margin-top: 5px;'></iframe>";
    console.log(" Version: ", $efd3ba4ec2608b1d$var$Version, " Version ant\xe9rieur :", $efd3ba4ec2608b1d$var$INFO_version);
    $efd3ba4ec2608b1d$var$openAfficheInit($efd3ba4ec2608b1d$var$message, 300);
    $efd3ba4ec2608b1d$var$INFO_version = $efd3ba4ec2608b1d$var$Version;
    localStorage.setItem("INFO_version", $efd3ba4ec2608b1d$var$INFO_version);
    console.log(" Version: ", $efd3ba4ec2608b1d$var$Version, " Version mise \xe0 jour :", $efd3ba4ec2608b1d$var$INFO_version);
    $efd3ba4ec2608b1d$var$closeAfficheInfo();
} else {
    $efd3ba4ec2608b1d$var$closeAfficheInfo();
    $efd3ba4ec2608b1d$var$closeAfficheInit();
    console.log(" Version: ", $efd3ba4ec2608b1d$var$Version, " Version ant\xe9rieur :", $efd3ba4ec2608b1d$var$INFO_version);
}
//------------------------------------------------------------------
//
function $efd3ba4ec2608b1d$var$messageECMWF(mapIdH) {
    if ($efd3ba4ec2608b1d$var$Warning_ECMWF_TYPES != "DONE" && (mapIdH.indexOf("WEARN") != -1 || mapIdH.indexOf("WEASN") != -1 || mapIdH.indexOf("WEAFR") != -1 || mapIdH.indexOf("WEAPE") != -1 || mapIdH.indexOf("COMPO") != -1)) {
        let message = " <br> Ce message sera affich\xe9 une seule fois par session.";
        message = message + "<br> <br> Les types de pr\xe9cipitation ne sont pas offert directement par le service de donn\xe9es ouvertes de ECMWFA(IFS et AIFS)";
        message = message + "<br> mais sont diagnostiqu\xe9es ici en utilisant les donn\xe9es ECMWF disponibles (voir documentation section G) ";
        message = message + " <br> <br> This message will be displayed once per sesssion.";
        message = message + "<br> Precipition types are not provided directly by ECMWF OpenData grib service (IFS and AIFS)";
        message = message + "<br> but are diagnosed using other available ECMWF fields (see documentation section G) ";
        $efd3ba4ec2608b1d$var$openAfficheInfo(message, 20);
        $efd3ba4ec2608b1d$var$Warning_ECMWF_TYPES = "DONE";
        localStorage.setItem("Warning_ECMWF_TYPES", $efd3ba4ec2608b1d$var$Warning_ECMWF_TYPES);
    }
}
//------------------------------------------------------------------
//
var $efd3ba4ec2608b1d$var$Image1_est_visible = true;
var $efd3ba4ec2608b1d$var$Image2_est_visible = true;
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$affichage_meta_informations(chiffre) {
    var entier = chiffre % 2;
    var couleur_actif = "yellow";
    if (chiffre < 0) {
        $efd3ba4ec2608b1d$var$Image1_est_visible = true;
        $efd3ba4ec2608b1d$var$Image2_est_visible = true;
        document.getElementById("modelezoom1").style.color = "blue";
        document.getElementById("modelezoom1").style.backgroundColor = couleur_actif;
        document.getElementById("mapidh1").style.color = "blue";
        document.getElementById("mapidh1").style.backgroundColor = couleur_actif;
        document.getElementById("houroid1").style.color = "blue";
        document.getElementById("houroid1").style.backgroundColor = couleur_actif;
        document.getElementById("valeur1").style.color = "blue";
        document.getElementById("valeur1").style.backgroundColor = couleur_actif;
        document.getElementById("opacite1").style.color = "blue";
        document.getElementById("opacite1").style.backgroundColor = couleur_actif;
        document.getElementById("modelezoom2").style.color = "blue";
        document.getElementById("modelezoom2").style.backgroundColor = couleur_actif;
        document.getElementById("mapidh2").style.color = "blue";
        document.getElementById("mapidh2").style.backgroundColor = couleur_actif;
        document.getElementById("houroid2").style.color = "blue";
        document.getElementById("houroid2").style.backgroundColor = couleur_actif;
        document.getElementById("valeur2").style.color = "blue";
        document.getElementById("valeur2").style.backgroundColor = couleur_actif;
        document.getElementById("opacite2").style.color = "blue";
        document.getElementById("opacite2").style.backgroundColor = couleur_actif;
    } else if (entier == 1) {
        $efd3ba4ec2608b1d$var$Image1_est_visible = true;
        $efd3ba4ec2608b1d$var$Image2_est_visible = false;
        document.getElementById("modelezoom1").style.color = "blue";
        document.getElementById("modelezoom1").style.backgroundColor = couleur_actif;
        document.getElementById("modelezoom2").style.color = "black";
        document.getElementById("modelezoom2").style.backgroundColor = "white";
        document.getElementById("mapidh1").style.color = "blue";
        document.getElementById("mapidh1").style.backgroundColor = couleur_actif;
        document.getElementById("mapidh2").style.color = "black";
        document.getElementById("mapidh2").style.backgroundColor = "white";
        document.getElementById("houroid1").style.color = "blue";
        document.getElementById("houroid1").style.backgroundColor = couleur_actif;
        document.getElementById("houroid2").style.color = "black";
        document.getElementById("houroid2").style.backgroundColor = "white";
        document.getElementById("valeur1").style.color = "blue";
        document.getElementById("valeur1").style.backgroundColor = couleur_actif;
        document.getElementById("valeur2").style.color = "black";
        document.getElementById("valeur2").style.backgroundColor = "white";
        document.getElementById("opacite1").style.color = "blue";
        document.getElementById("opacite1").style.backgroundColor = couleur_actif;
        document.getElementById("opacite2").style.color = "black";
        document.getElementById("opacite2").style.backgroundColor = "white";
    } else {
        $efd3ba4ec2608b1d$var$Image1_est_visible = false;
        $efd3ba4ec2608b1d$var$Image2_est_visible = true;
        document.getElementById("modelezoom1").style.color = "black";
        document.getElementById("modelezoom1").style.backgroundColor = "white";
        document.getElementById("modelezoom2").style.color = "blue";
        document.getElementById("modelezoom2").style.backgroundColor = couleur_actif;
        document.getElementById("mapidh1").style.color = "black";
        document.getElementById("mapidh1").style.backgroundColor = "white";
        document.getElementById("mapidh2").style.color = "blue";
        document.getElementById("mapidh2").style.backgroundColor = couleur_actif;
        document.getElementById("houroid1").style.color = "black";
        document.getElementById("houroid1").style.backgroundColor = "white";
        document.getElementById("houroid2").style.color = "blue";
        document.getElementById("houroid2").style.backgroundColor = couleur_actif;
        document.getElementById("valeur1").style.color = "black";
        document.getElementById("valeur1").style.backgroundColor = "white";
        document.getElementById("valeur2").style.color = "blue";
        document.getElementById("valeur2").style.backgroundColor = couleur_actif;
        document.getElementById("opacite1").style.color = "black";
        document.getElementById("opacite1").style.backgroundColor = "white";
        document.getElementById("opacite2").style.color = "blue";
        document.getElementById("opacite2").style.backgroundColor = couleur_actif;
    }
}
//
////__________________________________________________________________________________________________________________
//
//
window.changerDocument = function(cheminFichier) {
    var iframe = document.getElementById("cadreDoc");
    if (iframe) iframe.src = cheminFichier;
};
function $efd3ba4ec2608b1d$var$affiche_aide(aideCode) {
    var Aide_text = " Affichage de l'aide ici,   il suffit de cliquer <b> au dessus </b> d'un bouton ou d'un menu sur le symbole <b> ? </b>.<br><br>";
    Aide_text = Aide_text + " Pour d\xe9sactiver ce mode,  il suffit de recliquer sur l'interrupteur d'aide. <br>";
    if (aideCode == "BurgerNav") Aide_text = " Activation d'un menu de naviguation sur le c\xf4t\xe9 gauche. <br><br>";
    else if (aideCode == "Label1") Aide_text = " \xc9tiquette pour identifier la ligne horizontale de menus pour la s\xe9lection de la <b> couche</b> <strong>1</strong>. <br><br>";
    else if (aideCode == "Label2") Aide_text = " \xc9tiquette pour identifier la ligne horizontale de menus pour la s\xe9lection de la <b> couche</b> <strong>2</strong>. <br><br>";
    else if ((aideCode == "Couche1Model" || aideCode == "Couche2Model") && !$efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = " Menu Syst pr\xe9v <br><br>";
        if (aideCode == "Couche1Model") {
            Aide_text = Aide_text + "  Ce menu permet la s\xe9lection du syst\xe8me de pr\xe9vision et du zoom pour la <b> couche</b> <strong>1</strong>. <br><br>";
            Aide_text = Aide_text + " Voici ce qui est offert: <br>";
        } else {
            Aide_text = Aide_text + "  Ce menu permet la s\xe9lection du syst\xe8me de pr\xe9vision et du zoom pour la <b> couche</b> <strong>2</strong>. <br><br>";
            Aide_text = Aide_text + " Voici ce qui est offert: <br>";
            Aide_text = Aide_text + " <b> Void  - </b> Couche 2 d\xe9sactiv\xe9es.  <br>";
            Aide_text = Aide_text + " <b> ____ - </b> cette s\xe9lection de void effacera la couche 2. <br>";
        }
        Aide_text = Aide_text + " <b> RDPS - </b> syst\xe8me regional du CMC, un seul zoom continental. <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_rdps/readme_rdps_fr' target='_blank'> RDPS r\xe9f\xe9rence </a> <br> ";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 10km, offerte 10km; Cartes aux 3h jusqu'a 84h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 6 heures  <br>";
        Aide_text = Aide_text + " <b> HRDPS E - </b> syst\xe8me \xe0 haute r\xe9solution du CMC: zoom Est canadien. <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 2,5km, offerte 2,5km; Cartes aux 1h jusqu'a 48h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 6 heures  <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_hrdps/readme_hrdps_fr' target='_blank'> HRDPS r\xe9f\xe9rence </a> <br>";
        Aide_text = Aide_text + " <b> HRDPS SUDQC - </b> syst\xe8me \xe0 haute r\xe9solution du CMC: zoom sud du Quebec <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 2,5km, offerte 1km; Cartes aux 1h jusqu'a 48h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 6 heures  <br>";
        Aide_text = Aide_text + " <b> GDPS - </b> systeme global du CMC, un seul zoom sur Amerique du Nord. <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_gdps/readme_gdps_fr' target='_blank'> GDPS: r\xe9f\xe9rence </a> <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 15km, offerte 15km; Cartes aux 6h jusqu'a 240h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
        Aide_text = Aide_text + " <b> GFS - </b> systeme global de NCEP un seul zoom sur Amerique du Nord. <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 25km, offerte 20km; Cartes aux 6h jusqu'a 240h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
        Aide_text = Aide_text + " <b> AIFS - </b> systeme global AI de ECMWF un seul zoom sur Amerique du Nord. <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 28km, offerte 20km; Cartes aux 6h jusqu'a 240h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
        Aide_text = Aide_text + " <b> ECMWF - </b> systeme global de ECMWF un seul zoom sur Amerique du Nord. <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 28km, offerte 20km; Cartes aux 6h jusqu'a 240h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
        Aide_text = Aide_text + " <b> ECMWF3 - </b> systeme global de ECMWF un seul zoom sur Amerique du Nord. <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 28km, offerte 20km; Cartes aux <b> 3 </b> h jusqu'a <b> 90 </b>h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
        Aide_text = Aide_text + " <b> NEMO - </b> composante oc\xe9anique du syst\xe8me de Pr\xe9vision du cycle de l'eau. <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 1km, offerte 1km; Cartes aux heures jusqu'a 60h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 12 heures  <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_ciops/readme_ciops_fr' target='_blank'> CIOPS r\xe9f\xe9rence </a> <br>";
        Aide_text = Aide_text + " <b> RDWPS - </b> syst\xe8me de pr\xe9vision d\xe9terministe de vague, bas\xe9 sur WaveWatch III.  <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_rdwps/readme_rdwps_fr' target='_blank'> RDWPS r\xe9f\xe9rence </a> <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 2,5km, offerte 1km; Cartes aux heures jusqu'a 48h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 6 heures  <br>";
        Aide_text = Aide_text + " <b> DIAGW - </b> Diagnostiques \xe9tat de la mer de imeteo bas\xe9s sur RDWPS (Vagues) et NEMO inclu dans WCPS (courants).  <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_rdwps/readme_rdwps_fr' target='_blank'> RDWPS r\xe9f\xe9rence </a> <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_wcps/readme_wcps_fr' target='_blank'> WCPS r\xe9f\xe9rence </a> <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 2,5km, offerte 1km; Cartes aux heures jusqu'a 48h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 6 heures  <br>";
        Aide_text += "<br>";
        Aide_text = Aide_text + "<b> S\xe9lectionnez ici la Documentation sp\xe9cifique de DIAGW : </b><br><br>";
        // Boutons de choix
        Aide_text = Aide_text + "<button onclick='changerDocument(\"../image_res/../image_res/vague_vent_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>complet</button>";
        Aide_text = Aide_text + "<button onclick='changerDocument(\"../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>extraits</button>";
        // Cadre iFrame unique (chargé par défaut avec le deuxieme document)
        Aide_text = Aide_text + "<iframe id='cadreDoc' src='../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH' width='100%' height='550px' style='border: 1px solid #ccc; border-radius: 4px;'></iframe>";
        if ($efd3ba4ec2608b1d$var$L_SHOP) {
            Aide_text = Aide_text + " <b> SHOP - </b> syst\xe8me de Simulation Hydrodynamique sur une portion du Saint-Laurent.  <br>";
            Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_ohps/readme_ohps_fr' target='_blank'> SHOP r\xe9f\xe9rence </a> <br>";
            Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 100m, offerte 200m; Cartes aux heures jusqu'a 60h.  <br>";
            Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 12 heures  <br>";
        }
        Aide_text = Aide_text + " <b> RAQDPS - </b> Syst\xe8me R\xe9gional de pr\xe9vision de qualit\xe9 de l'air du CMC <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 10km, offerte 10km; Cartes aux 3 heures jusqu'a 72h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 12 heures  <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_raqdps/readme_raqdps_fr' target='_blank'> RAQDPS r\xe9f\xe9rence </a> <br>";
        Aide_text = Aide_text + " <b>  GOES - </b> Image a partir de donnees GOES-Est continental     <br>";
        Aide_text = Aide_text + " <b> _____ - </b> r\xe9solution variable atteignant 1,5km dans le visible;  aux 5 minutes.  <br>";
        Aide_text = Aide_text + " <b> RADAR CO - </b> Extrait COntinental du Composite Radar du CMC    <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution offerte autour de 2km (source 1km);  aux 6 minutes.  <br>";
        Aide_text = Aide_text + " <b> RADART CO - </b> Extrait COntinental du Composite Radar du CMC pour type de pcpn <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution offerte autour de 2km (source 1km); aux 6 minutes.  <br>";
        Aide_text = Aide_text + " <b> FOUDRE CO - </b> Extrait du Composite Radar du CMC    <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution offerte variable pr\xe8s de 1km ;  aux 5 minutes.  <br>";
        Aide_text = Aide_text + " <b> GOES+ - </b> Permet la superposition des produits, GOES,  Foudre et-ou Radar <br>";
        Aide_text = Aide_text + " <b> ____ - </b> d\xe9crits ci-haut.  <br>";
        if ($efd3ba4ec2608b1d$var$L_GDPSE) {
            Aide_text = Aide_text + " <b> GDPSE </b> systeme global du CMC, un seul zoom sur EUROPE. <br>";
            Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_gdps/readme_gdps_fr' target='_blank'> GDPS: r\xe9f\xe9rence </a> <br>";
            Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 15km, offerte 15km; Cartes aux 6h jusqu'a 240h.  <br>";
            Aide_text = Aide_text + " <b> ____ - </b> Passes: aux 12 heures  <br>";
            Aide_text = Aide_text + " <b> ECMWFE - </b> systeme global de ECMWF un seul zoom sur Europe. <br>";
            Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 28km, offerte 20km; Cartes aux 6h jusqu'a 240h.  <br>";
            Aide_text = Aide_text + " <b> ____ - </b> Passes: possible aux 12h mais sporadique pour le moment<br>";
            Aide_text = Aide_text + " <b> AIFSE - </b> systeme global AI de ECMWF un seul zoom sur EUROPE. <br>";
            Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 28km, offerte 20km; Cartes aux 6h jusqu'a 240h.  <br>";
            Aide_text = Aide_text + " <b> ____ - </b> Passes: possibles aux 12 heures mais sporadiques pour le moment   <br>";
        }
    } else if ((aideCode == "Couche1Model" || aideCode == "Couche2Model") && $efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = " Menu Theme <br><br>";
        if (aideCode == "Couche1Model") {
            Aide_text = Aide_text + "  Ce menu permet la s\xe9lection du syst\xe8me de pr\xe9vision de la <b> couche</b> <strong>1</strong>. <br><br>";
            Aide_text = Aide_text + " Voici ce qui est offert: <br>";
        } else {
            Aide_text = Aide_text + "  Ce menu permet la s\xe9lection du syst\xe8me de pr\xe9vision de la <b> couche</b> <strong>2</strong>. <br><br>";
            Aide_text = Aide_text + " Voici ce qui est offert: <br>";
            Aide_text = Aide_text + " <br> <b> Void  - </b> Couche 2 d\xe9sactiv\xe9es. ";
            Aide_text = Aide_text + " <br> <b> ____ - </b> La s\xe9lection de void effacera la couche 2.<br>";
        }
        Aide_text = Aide_text + " <br> <b> Air: - </b> syst\xe8me de pr\xe9vision atmosph\xe9rique \xe0 haute r\xe9solution du CMC: zoom sur sud du Qu\xe9bec. ";
        Aide_text = Aide_text + " <br> <b> ____ - </b> Les donn\xe9es sont offertes par le Centre M\xe9t\xe9orologique Canadien (ECCC): <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_hrdps/readme_hrdps_fr' target='_blank'> HRDPS: r\xe9f\xe9rence </a> <br> ";
        Aide_text = Aide_text + " <br> <b> ____ - </b> r\xe9solution native: 2,5km; Cartes aux 1h jusqu'a 48h de pr\xe9vision.  ";
        Aide_text = Aide_text + " <br> <b> ____ - </b> Rafraichissement aux 6 heures  <br>";
        Aide_text = Aide_text + " <br> <b> NEMO: - </b> mod\xe8le oc\xe9anique du syst\xe8me de pr\xe9vision du cycle de l'eau CMC: zoom sur sud du Qu\xe9bec. ";
        Aide_text = Aide_text + " <br> <b> ____ - </b> Les donn\xe9es sont offertes par le Centre M\xe9t\xe9orologique Canadien (ECCC). <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_wcps/readme_wcps_fr/' target='_blank'> WCPS: r\xe9f\xe9rence</a> <br>";
        Aide_text = Aide_text + " <br> <b> ____ - </b> r\xe9solution native: 1km; Cartes aux 1h jusqu'a 60h de pr\xe9vision.  ";
        Aide_text = Aide_text + " <br> <b> ____ - </b> Rafraichissement aux 12 heures  (temps d'origine 06Z et 18Z) <br>";
        Aide_text = Aide_text + " <b> RDWPS - </b> syst\xe8me de pr\xe9vision d\xe9terministe de vague, bas\xe9 sur WaveWatch III.  <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_rdwps/readme_rdwps_fr' target='_blank'> RDWPS r\xe9f\xe9rence </a> <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 2,5km, offerte 1km; Cartes aux heures jusqu'a 48h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 6 heures  <br>";
        Aide_text = Aide_text + " <b> DIAGW - </b> Diagnostiques \xe9tat de la mer de imeteo bas\xe9s sur RDWPS (Vagues) et NEMO inclu dans WCPS (courants).  <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_rdwps/readme_rdwps_fr' target='_blank'> RDWPS r\xe9f\xe9rence </a> <br>";
        Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_wcps/readme_wcps_fr' target='_blank'> WCPS r\xe9f\xe9rence </a> <br>";
        Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 2,5km, offerte 1km; Cartes aux heures jusqu'a 48h.  <br>";
        Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 6 heures  <br>";
        Aide_text += "<br><br>";
        Aide_text = Aide_text + "<b> S\xe9lectionnez ici la Documentation sp\xe9cifique de DIAGW : </b><br><br>";
        // Boutons de choix
        Aide_text = Aide_text + "<button onclick='changerDocument(\"../image_res/../image_res/vague_vent_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>complet</button>";
        Aide_text = Aide_text + "<button onclick='changerDocument(\"../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH\")' style='padding: 6px 12px; margin-right: 8px; cursor: pointer;'>extraits</button>";
        // Cadre iFrame unique (chargé par défaut avec le deuxieme document)
        Aide_text = Aide_text + "<iframe id='cadreDoc' src='../image_res/../image_res/extraits_documentation_DIAGW_v3.2b.pdf#view=FitH' width='100%' height='550px' style='border: 1px solid #ccc; border-radius: 4px;'></iframe>";
        if ($efd3ba4ec2608b1d$var$L_SHOP) {
            Aide_text = Aide_text + " <b> SHOP - </b> syst\xe8me de Simulation Hydrodynamique sur une portion du Saint-Laurent.  <br>";
            Aide_text = Aide_text + " <a href='https://eccc-msc.github.io/open-data/msc-data/nwp_ohps/readme_ohps_fr/' target='_blank'> SHOP: r\xe9f\xe9rence</a> <br>";
            Aide_text = Aide_text + " <b> ____ - </b> r\xe9solution source 100m, offerte 200m; Cartes aux heures jusqu'a 60h.  <br>";
            Aide_text = Aide_text + " <b> ____ - </b> Rafraichissement aux 12 heures  <br>";
        }
    } else if (aideCode == "Couche1Carte" || aideCode == "Couche2Carte") {
        Aide_text = " Menu Cartes m\xe9t\xe9o <br><br>";
        var mapid = $efd3ba4ec2608b1d$var$Couche1.mapIdH;
        if (aideCode == "Couche1Carte") {
            Aide_text = Aide_text + " Ce menu permet la s\xe9lection de la carte pour la <b> couche</b> <strong>1</strong>. ";
            Aide_text = Aide_text + " Le choix de carte peut varier. <b> Certaine </b> s\xe9lections de cartes seront d\xe9crites plus loin. ";
            Aide_text = Aide_text + " Pour savoir si une carte est document\xe9es ici,";
            Aide_text = Aide_text + " il suffit de s\xe9lectionner la carte en question, <b> avant </b> de r\xe9actionner ce bouton d aide. <br> <br> ";
            Aide_text = Aide_text + " Notez que la carte de la couche 1 s'affichera: <br> <br> ";
            Aide_text = Aide_text + " ------> par dessus (apr\xe8s) la carte de la couche 2 en mode, couches <b> superpos\xe9es </b> (voir menu Couches)<br> ";
            Aide_text = Aide_text + " ou <br> ";
            Aide_text = Aide_text + " ------> \xe0 la suite de son comparable de la couche 2,  en mode couches en <b> alternances ou intercall\xe9es </b> (voir menu Couches) <br>";
            Aide_text = Aide_text + " ou encore,<br> ";
            Aide_text = Aide_text + " ------> sur la carte de gauche (couche 2 sur la carte de droite), en mode <b> juxtaposition </b> de couches (voir menu Couches)<br> <br>";
        } else {
            Aide_text = Aide_text + " Ce menu permet la s\xe9lection de la carte pour la <b> couche </b> <strong>2</strong>. ";
            Aide_text = Aide_text + " Le choix de carte peut varier. <b> Certaine </b> s\xe9lections de cartes seront d\xe9crites plus loin. ";
            Aide_text = Aide_text + " Pour savoir si une carte est document\xe9es ici,";
            Aide_text = Aide_text + " il suffit de s\xe9lectionner la carte en question, <b> avant </b> de r\xe9actionner ce bouton d aide. <br> <br> ";
            Aide_text = Aide_text + " Le menu fonctionnera si la couche 2 est active. ";
            Aide_text = Aide_text + " On active la couche 2 avec le menu <b> Syst pr\xe9v.</b> de la couche 2.  Notez que la carte de la couche 2 s'affichera: <br><br>";
            Aide_text = Aide_text + " ------> en dessous (avant) la carte de la couche 1 en mode, couches <b> superpos\xe9es </b> (voir menu Couches)<br> ";
            Aide_text = Aide_text + " ou <br> ";
            Aide_text = Aide_text + " ------> avant son comparable de la couche 1, en mode <b> alternances ou intercall\xe9es </b> de couches (voir menu Couches)<br> <br>";
            Aide_text = Aide_text + " ou encore,<br> ";
            Aide_text = Aide_text + " ------> sur la carte de droite (couche 1 sur la carte de gauche), en mode <b> juxtaposition </b> de couches (voir menu Couches)<br> <br>";
            mapid = $efd3ba4ec2608b1d$var$Couche2.mapIdH;
        }
        if (mapid == "HWLA_") {
            Aide_text = Aide_text + " <br>  <b> HWLA : </b> Horizontal Water Level Anomaly (HWLA) with respect to the Intantaneous <b> Mean </b> Lake Water Level (IMLWL) ";
            Aide_text = Aide_text + " for Lakes Superior, Michigan,  Huron, St-Clair, Erie, Ontario. ";
            Aide_text = Aide_text + "   HWLA are the Level differences relative to the IMLWL.  They are obtained by subtracting de IMLWL from the current valid time Levels for all lake points.<br> <br>";
            Aide_text = Aide_text + " Intantaneous  <b> Mean </b>  Lake Water Level (IMLWL) are computed for each lake taken individualy, as the average of all lake point levels <b> at a given time </b>. ";
            Aide_text = Aide_text + " The IMLWL depicted values are relative to the International Great Lakes Datum (IGLD, 1985). <br>";
            Aide_text = Aide_text + "   (those in parenthesis are IMLWL differences with the 0h prognosis (analysis time) given in mm for each lakes taken individualy) <br>";
        } else if (mapid == "WLTC_") {
            Aide_text = Aide_text + " <br>  <b> WLTC : </b> Water Level Time Change (WLTC) since the initial water level (0h prognosis)";
            Aide_text = Aide_text + "   for Lakes:  Superior, Michigan,  Huron, St-Clair, Erie, Ontario. ";
            Aide_text = Aide_text + "   WLTC are the Level differences since analysis time.  They are obtained by subtracting de 0h pronostic Levels from the current valid time Levels for all lake points.<br> <br>";
            Aide_text = Aide_text + " Intantaneous  <b> Mean </b>  Lake Water Level (IMLWL) are computed for each lake taken individualy, as the average of all lake point levels <b> at a given time </b>. ";
            Aide_text = Aide_text + " The IMLWL depicted values are relative to the International Great Lakes Datum (IGLD, 1985). <br>";
            Aide_text = Aide_text + "   (those in parenthesis are IMLWL differences with the 0h prognosis (analysis time) given in mm for each lakes taken individualy) <br>";
        } else if (mapid == "SOSSHEIG_" || mapid == "IICECONC_" || mapid == "VOTEMPER_0.5" || mapid == "CDIR_0.5" || mapid == "CSPEED_0.5") {
            Aide_text = Aide_text + " <br> <b> Niveau </b>: Hauteur d'eau relative au <b> z\xe9ro des cartes (Charts Datum) </b> ";
            Aide_text = Aide_text + "    pour le Lac Ontario, ";
            Aide_text = Aide_text + "  et relatif au <b> Niveau moyen de la mer </b> ";
            Aide_text = Aide_text + "    pour le reste du domaine \xe0 l'Est de la ville de Qu\xe9bec. <br>";
            Aide_text = Aide_text + " <br> <b> Glace </b>: Couverture de Glace de mer (fraction entre 0 et 1). <br>";
            Aide_text = Aide_text + " <br> <b> TMP 50cm </b>: temp\xe9rature en degr\xe9s Kelvin, 50cm sous la surface de l'eau. <br>";
            Aide_text = Aide_text + " <br> <b> Dir_Cou </b>: Direction du courant 50cm sous la surface de l'eau. <br>";
            Aide_text = Aide_text + " <br> <b> Vit_Cou </b>: Vitesse du courant 50cm sous la surface de l'eau (noeuds). <br>";
        } else if (mapid == "C02_CO" || mapid == "C13_CO") {
            Aide_text = Aide_text + " <br> <b> VI 02 </b>: produit satellite VIsible (VI canal 2)  <br>";
            Aide_text = Aide_text + " <br> <b> IR 13 </b>: produit satellite Infra-Rouge (IR canal 13) <br>";
        } else if (mapid == "FOUDRE_PTS_CO") {
            Aide_text = Aide_text + " <br> <b> FOUDRE </b>:  Foudre plus r\xe9cente \xe0 moins r\xe9cente: rouge, orange, jaune, vert, bleu";
            Aide_text = Aide_text + " par interval 10 minutes pour un total de 60 minutes. <br>";
        } else if (mapid == "RRAI" || mapid == "RRAI_NET" || mapid == "RSNO" || mapid == "RSNO_NET") {
            Aide_text = Aide_text + " <br> <b> R </b>: Taux de pr\xe9cipitation liquide estim\xe9 \xe0 partir de la r\xe9flectivit\xe9 \xe9quivalente RADAR (resol:2km) <br>";
            Aide_text = Aide_text + " <br> <b> S </b>: Taux de pr\xe9cipitation solide estim\xe9 \xe0 partir de la r\xe9flectivit\xe9 \xe9quivalente RADAR  (resol:2km)<br>";
            Aide_text = Aide_text + " <br> <b> R Net </b>: Taux de pr\xe9cipitation liquide estim\xe9 \xe0 partir de la r\xe9flectivit\xe9 \xe9quivalente RADAR  <br>";
            Aide_text = Aide_text + " <br> La cat\xe9gorie de couleur du taux le plus faible (plus bruit\xe9) est retir\xe9 pour mieux voir le signal (resol:2km)<br>";
            Aide_text = Aide_text + " <br> <b> S Net</b>: Taux de pr\xe9cipitation solide estim\xe9 \xe0 partir de la r\xe9flectivit\xe9 \xe9quivalente RADAR (resol:2km) <br>";
            Aide_text = Aide_text + " <br> La cat\xe9gorie de couleur du taux le plus faible (plus bruit\xe9) est retir\xe9 pour mieux voir le signal <br>";
        } else if (mapid == "RTYP") Aide_text = Aide_text + " <br> <b> TYPE </b>: Taux de pr\xe9cipitation estim\xe9 par cat\xe9gories de types de pr\xe9cipitation (resol:2km)<br>";
        else if (mapid == "HGT_1000-500_HGT_1000-500") Aide_text = Aide_text + " <br> <b> \xc9pai500 </b>:  \xc9paisseur de la couche atmosph\xe9rique entre les niveaux de pressions 1000mb et 500mb en dam";
        else if (mapid == "D-HGT_500") {
            Aide_text = Aide_text + " <br> <b> Del500 </b>:  en couleur, <b> la Diff\xe9rence </b> de la hauteur \xe0 500mb entre le mod\xe8le s\xe9lectionn\xe9 au menu syst. prev. et";
            Aide_text = Aide_text + " le mod\xe8le global du CMC (GDPS):   GZ500 mod\xe8le courant - GZ500 mod\xe8le GDPS.  <br><br>";
            Aide_text = Aide_text + " Les tons verts-bleut\xe9s (froids) indiquent que le niveau 500mb du mod\xe8le est plus bas, plus creux, que celui du GDPS, ";
            Aide_text = Aide_text + " alors que les tons jaunes-rouges (chauds)  indiquent que le niveau 500mb du mod\xe8le est plus haut que celui du GDPS. <br><br>";
        }
    } else if (aideCode == "CoucheCo1Carte" || aideCode == "CoucheCo2Carte") {
        Aide_text = " Menu Co-Cartes <br><br>";
        var mapid = $efd3ba4ec2608b1d$var$Couche1.mapIdH;
        if (aideCode == "CoucheCo1Carte") {
            Aide_text = Aide_text + " Ce menu permet la s\xe9lection d une carte associ\xe9e a la carte 1,  s\xe9lectionn\xe9e pour la <b> couche</b> <strong>1</strong>. <br><br>";
            Aide_text = Aide_text + " Le choix de la co carte est plus restrictif puisqu'il s'agit normalement d'une carte comportant des contours,  fl\xe8ches, symboles. <br>";
            Aide_text = Aide_text + " Cette s\xe9lection permet donc la superposition de hauteurs g\xe9opotentielles, de la pression, de directions de vents ou de courants, de la foudre, ";
            Aide_text = Aide_text + " par dessus la couche 1, de base, a l'int\xe9rieur des produits disponible pour un syst\xe8me de pr\xe9vision.";
            Aide_text = Aide_text + " Cette carte sera syst\xe9matiquement superpos\xe9e a la carte 1 de base, pour les memes temps de validit\xe9s.";
            Aide_text = Aide_text + " Les s\xe9lections de date d'origine et d'opacit\xe9 s'appliqueront a la co-carte de la meme facon que pour la carte 1.";
            Aide_text = Aide_text + " La s\xe9lection au menu Valeur s'apliquera uniquement a la carte 1. <br> <br>";
        } else {
            Aide_text = Aide_text + " Ce menu permet la s\xe9lection d une carte associ\xe9e a la carte 2, s\xe9lectionn\xe9e pour la <b> couche</b> <strong>2</strong>. <br><br>";
            Aide_text = Aide_text + " Le choix de la co carte est plus restrictif puisqu'il s'agit normalement d'une carte comportant des contours,  fl\xe8ches, symboles. <br> ";
            Aide_text = Aide_text + " Cette s\xe9lection permet donc l'affichage de hauteurs g\xe9opotentielles, de la pression, de directions de vents ou de courants, de la foudre,  ";
            Aide_text = Aide_text + " par dessus la couche 2, de base, a l'int\xe9rieur des produits disponible pour un syst\xe8me de pr\xe9vision.";
            Aide_text = Aide_text + " Cette carte sera syst\xe9matiquement superpos\xe9e a la carte 2, pour les memes temps de validit\xe9s.";
            Aide_text = Aide_text + " Les s\xe9lections de date d'origine et d'opacit\xe9 s'appliqueront a la co-carte de la meme facon que pour la carte 2.";
            Aide_text = Aide_text + " La s\xe9lection au menu Valeur s'apliquera uniquement a la carte 2. <br><br>";
            mapid = $efd3ba4ec2608b1d$var$Couche2.mapIdH;
        }
        Aide_text = Aide_text + " Enfin, il n'y a pas d'affichage de l\xe9gendes pour les co-cartes.  Pour voir ces legendes,";
        Aide_text = Aide_text + " il suffit d'en faire la s\xe9lection comme carte de base au menu voisin ...carte m\xe9t\xe9o. ";
        Aide_text = Aide_text + " <br> <br>";
    } else if (aideCode == "Couche1Dateo" || aideCode == "Couche2Dateo") {
        Aide_text = " Menu Date d'origine <br><br>";
        if (aideCode == "Couche1Dateo") Aide_text = Aide_text + " Ce menu permet la s\xe9lection de la date d'origine (de d\xe9part) de la pr\xe9vison pour la <b> couche</b> <strong>1</strong>.<br> <br>";
        else Aide_text = Aide_text + " Ce menu permet la s\xe9lection de la date d'origine (de d\xe9part) de la pr\xe9vison pour la <b> couche</b> <strong>2</strong>.<br> <br>";
        if (!$efd3ba4ec2608b1d$var$WindMaps) {
            Aide_text = Aide_text + "  Lors du d\xe9marrage de l'interface, les plus r\xe9centes dates et heures de disponibilit\xe9s des produits sont mises \xe0 jours. Ce processus prend g\xe9n\xe9rales quelques secondess, mais peut prendre jusqu'\xe0 10 ou 20 secondes selon le contexte...";
            Aide_text = Aide_text + " Par la suite, il n'est pas n\xe9cessaire de redemarrer l'Interface afin d'obtenir les plus r\xe9centes pr\xe9visions.  Le tout se fait automatiquement. ";
            Aide_text = Aide_text + " Il suffit de s\xe9lectionner le syst\xe8me de pr\xe9vision, et de v\xe9rifier le menu Date d'origine pour voir si il y a du nouveau. <br>";
            Aide_text = Aide_text + " Notez toutefois qu il pourrait \xeatre n\xe9cessaire de red\xe9marrer l'interface suite \xe0 une inactivit\xe9 de quelques heures. <br>";
            Aide_text = Aide_text + " <br> Dans le cas o\xf9 le syst\xe8me de pr\xe9vision est d\xe9j\xe0 s\xe9lectionn\xe9 et actif, il faut  D\xe9lectionner et res\xe9lectionner pour obtenir le plus r\xe9cent temps d<origine,  la plus r\xe9cente pr\xe9vision. Le bouton  <b> Init. T </b> (voir un peu plus loin) suivi d'un clic sur le bouton date d'origine juste au dessus du pr\xe9sent bouton, permet aussi d'assurer que la date d'origine est \xe0 jour. <br> <br>";
            Aide_text = Aide_text + " Ce menu devient <b> inop\xe9rant </b> lorsque l'animation est en mode <b> Validit\xe9 fix\xe9e </b> (voir menu Anim. mode, s\xe9lection Valid).";
            Aide_text = Aide_text + " En mode <b> Validit\xe9 fix\xe9e </b> la date d'origine changera au gr\xe9s de l'animation, puisque cette derni\xe8re porte ";
            Aide_text = Aide_text + " sur les dates d'origines offertes \xe0 ce menu. Il est donc jug\xe9 impertinent d'utiliser ce menu pendant cette animation. <br>";
            Aide_text = Aide_text + " Enfin, un clique sur l \xe9tiquette <b><i> Date d origine </i></b> situ\xe9e au dessus du menu, fera en sorte que la date sera ajust\xe9e de mani\xe8re automatique. Il faudra toutefois selectionner au menu,  la date la plus recente si celle ci a changee depuis votre derniere selection de ce modele.   Dans le cas des donnees Radar ou Satellitaires,  l<ajustement de la plus recente date d<origine se fait automatiquement. ";
        } else {
            Aide_text = Aide_text + " <br> Les pr\xe9visions sont refaites \xe0 toutes les 6 heures. <br> <br> ";
            Aide_text = Aide_text + "  Lors du d\xe9marrage de l'interface, les plus r\xe9centes dates et heures de disponibilit\xe9s des produits sont mises \xe0 jours. Ce processus prend g\xe9n\xe9rales quelques secondess, mais peut prendre jusqu'\xe0 10 ou 20 secondes selon le contexte...";
            Aide_text = Aide_text + " Par la suite, il n'est pas n\xe9cessaire de redemarrer l'Interface afin d'obtenir les plus r\xe9centes pr\xe9visions.  Le tout se fait automatiquement. ";
            Aide_text = Aide_text + " Il suffit de s\xe9lectionner le menu Th\xe8me ou faire une nouvelle s\xe9lection au Bouton DuoD, et de v\xe9rifier le menu Date d'origine pour voir si il y a du nouveau. <br>";
            Aide_text = Aide_text + " Notez toutefois qu il pourrait \xeatre n\xe9cessaire de red\xe9marrer l'interface suite \xe0 une inactivit\xe9 de quelques heures. <br>";
            Aide_text = Aide_text + " <br> Dans le cas o\xf9 un th\xe8me est d\xe9j\xe0 s\xe9lectionn\xe9 et actif, il faut  D\xe9lectionneri (en s\xe9lectionnat un autre)  et res\xe9lectionner pour obtenir le plus r\xe9cent temps d origine,  la plus r\xe9cente pr\xe9vision. Le bouton  <b> Init. T </b> (voir un peu plus loin) suivi d'un clic sur le bouton date d'orgine juste au dessus du pr\xe9sent bouton, permet aussi d'assurer que la date d'origine est \xe0 jour. <br> <br>";
        }
    } else if (aideCode == "Couche1Valeurs" || aideCode == "Couche2Valeurs") {
        Aide_text = " Menu Valeur <br><br>";
        Aide_text = Aide_text + " Ce menu permet d'activer l'obtention de: <br>";
        Aide_text = Aide_text + "                                      valeurs aux pixelles (selection Popup), ou  <br>";
        Aide_text = Aide_text + "                                      s\xe9ries temporelles de SpotWx (TimSer ou TimSer_e) ou <br>";
        if (!$efd3ba4ec2608b1d$var$WindMaps) Aide_text = Aide_text + "                                      s\xe9ries temporelles M\xe9t\xe9ogrammes (ensembles) ";
        if (aideCode == "Couche1Valeurs") Aide_text = Aide_text + "  pour la <b> couche</b> <strong>1</strong> .<br><br>";
        else Aide_text = Aide_text + "  pour la <b> couche</b> <strong>2</strong> .<br><br>";
        Aide_text = Aide_text + " En s\xe9lectionnant  <b> Popup </b>... vous obtenez une aide \xe0 l'interpr\xe9tation des couleurs afin d'y associer des valeurs. ";
        Aide_text = Aide_text + " Il suffit ensuite de cliquer sur la carte. Les valeurs pourront \xeatre d\xe9duites sur l'\xe9chelle de la l\xe9gende, o\xf9 la couleur ";
        Aide_text = Aide_text + " s\xe9lectionn\xe9e sur la carte y sera rehauss\xe9e. <br>";
        Aide_text = Aide_text + " Les valeurs aux pixelles  ne sont donc disponibles que pour les cartes color\xe9s, comportant des l\xe9gendes.<br> <br>";
        Aide_text = Aide_text + " Le <b> Popup </b> s'affichera: <br>";
        Aide_text = Aide_text + " ----------------  lorsque l'option est activ\xe9e pour la couche 1 (ou-et 2) ET la couche 1 (ou 2) est visible <br>";
        Aide_text = Aide_text + " ----------------  lorsque l'option est activ\xe9es pour <b> les deux couches </b> les boites de popup seront superpos\xe9es si le mode affichage de couche est superpos\xe9e (voir menu Couches), alors dans ce cas, vaut mieux avoir le mode intercall\xe9 ou juxtapos\xe9 pour l'affichage des couches. <br>";
        Aide_text = Aide_text + " La boite du  <b> Popup </b> peut est temporairement effac\xe9e en cliquant sur le - situ\xe9 en haut \xe0 gauche de la boite. <br>";
        Aide_text = Aide_text + " Le mode popup peut \xeatre d\xe9sactiv\xe9 \xe0 partir du menu ou en cliquant sur le x en haut \xe0 droite de la boite du popup. <br> <br>";
        Aide_text = Aide_text + " La s\xe9lection <b> TimSer </b> entrainera l'affichage de s\xe9ries temporelles de SpotWx dans la m\xeame fen\xeatre (m\xeame onglet) que imeteomaps. <br> ";
        Aide_text = Aide_text + " La s\xe9lection <b> TimSer_e </b> entrainera l'affichage de s\xe9ries temporelles de SpotWx dans une fen\xeatre <b> externe </b> (autre onglet) \xe0 imeteomaps. <br> ";
        Aide_text = Aide_text + "       La demande pour fen\xeatre externe (TimSer_e) se r\xe9alise dans un nouvel onglet, sur un t\xe9l\xe9phone ou une tablette.";
        Aide_text = Aide_text + "       Sur un t\xe9l\xe9phone en mode portrait, la s\xe9lection TimSer affichera le graphique au bas de la page imeteomaps.";
        Aide_text = Aide_text + "       Sur une tablette en mode paysage, la s\xe9lection TimSer affichera le graphique cote \xe0 cote avec le page imeteomaps.";
        Aide_text = Aide_text + "       Le mode plein \xe9cran se d\xe9sactivera automatique si TimSer_e est demand\xe9...";
        if (!$efd3ba4ec2608b1d$var$WindMaps) {
            Aide_text = Aide_text + "       Les s\xe9ries temporelles de SpotWx sont disponibles pour les syst\xe8mes,  HRDPS, RDPS GDPS et GFS <br>";
            Aide_text = Aide_text + " La s\xe9lection <b> MeteoGrm </b> entrainera l'affichYage de M\xe9t\xe9ogrammes (ensembles) dans une fen\xeatre <b> externe </b> (autre onglet) \xe0 imeteomaps. <br> ";
            Aide_text = Aide_text + "       Pour le syst\xe8me IFS ECMWF les m\xe9t\xe9ogrammes s`afficheront <b> via l'application OpenData Charts de ECMWF </b>.";
            Aide_text = Aide_text + "       La s\xe9rie temporelle du mod\xe8le d\xe9terministe ECMWF y est trac\xe9e en bleu (il s agit du m\xeame mod\xe8le que celui qui est ";
            Aide_text = Aide_text + "       affich\xe9 sur la carte imeteomaps). Les autres donn\xe9es trac\xe9s proviennent des ensembles de ECMWF (qui ne sont pas encore";
            Aide_text = Aide_text + "       dispnibles sur imeteomaps sous forme de cartes). <br>";
            Aide_text = Aide_text + "       Pour le syst\xe8me GDPS ce sont les plutot les m\xe9t\xe9ogrammes du syst\xe8me d'ensemble GEPS qui s`afficheront <b> via l'application SpotWx </b>.";
            Aide_text = Aide_text + "       Cet ajout permet de conparer les donn\xe9es des syst\xe8mes d'ensembles ECMWF et GEPS.  <br> <br>";
            Aide_text = Aide_text + " La s\xe9lection <b> ProfVert </b> entrainera l'affichage de Profile Verticaux de ECMWF dans une fen\xeatre <b> externe </b> (autre onglet) \xe0 imeteomaps. <br> ";
        }
        Aide_text = Aide_text + " Les donn\xe9es affich\xe9es correspondent au syst\xe8me de pr\xe9vision de la couche <b> 1 ou 2 (selon la couche s\xe9lectionn\xe9e) </b>,";
        Aide_text = Aide_text + " au point g\xe9ographique s\xe9lectionn\xe9 correspondant au clique sur la carte g\xe9ographique. ";
        Aide_text = Aide_text + " Notez qu'il peut parfois y avoir de l\xe9g\xe8res incoh\xe9rences entre les cartes imeteomaps et les s\xe9rie temporelles de spotwx en raison ";
        Aide_text = Aide_text + " des interpolations. Les inh\xe9rences peuvent \xeatre plus importante en raison de l'impossibilit\xe9 de la synchronisation des dates d'origines";
        Aide_text = Aide_text + " des produits en tout temps.";
        Aide_text = Aide_text + " Cela est caus\xe9 par le fait que spotwx ne dispose pas d'archives. Votre requ\xeate \xe0 SpotWx vous donnera les plus r\xe9centes donn\xe9es disponibles";
        Aide_text = Aide_text + " pour ce syst\xe8me de pr\xe9vision, et cela ne tiendra pas compte de la date d'origine que vous avez s\xe9lectionn\xe9e dans imeteomaps. <br>";
        Aide_text = Aide_text + " Puisqu'il est in\xe9vitable que les mise \xe0 jour des syst\xe8mes de pr\xe9visions ne soient pas synchronis\xe9es exactement, cela se produira potentiellement ";
        Aide_text = Aide_text + " plusieurs fois par jours. ";
        if (!$efd3ba4ec2608b1d$var$WindMaps) {
            Aide_text = Aide_text + " Ajoutons que SpotWx offre le GFS aux heures de d\xe9parts de 06 et 18Z  alors que imeteomaps ne l'offre pas pour";
            Aide_text = Aide_text + " ces date d'origines \xe0 ce jour. <br>";
            Aide_text = Aide_text + " Notez que dans le cas des m\xe9t\xe9ogrammes de ECMWF, il y a une archive. L'interface Open Charts requiert la date d'origine de votre choix,";
            Aide_text = Aide_text + " et peut accomoder quelques passe en archives.  Ainsi,  dans le cas de ce mod\xe8le,  votre choix de date d'origine \xe0 l'interface imeteomaps";
            Aide_text = Aide_text + " sera coherent (en principe) avec les series temporelles obtenus. <br>";
        }
    } else if (aideCode == "Couche1Opacit") {
        Aide_text = " Menu Opacit <br><br>";
        Aide_text = Aide_text + " S\xe9lection de l'opacit\xe9 de la <b> couche</b> <strong>1</strong>.<br> Les s\xe9lections vont de 0 (transparent) \xe0 10 (opaque). <br>";
        Aide_text = Aide_text + " La s\xe9lection 0 permet de voir uniquement les rep\xe8res g\xe9ographiques. <br>";
    } else if (aideCode == "Couche2Opacit") {
        Aide_text = " Menu Opacit <br><br>";
        Aide_text = Aide_text + " S\xe9lection de l'opacit\xe9 de la <b> couche </b> <strong>2</strong>. <br> Les s\xe9lections vont de 0 (transparent) \xe0 10 (opaque).<br> ";
        Aide_text = Aide_text + " La s\xe9lection 0 permet de voir uniquement les rep\xe8res g\xe9ographiques. <br>";
    } else if (aideCode == "AnimMode") {
        Aide_text = " Menu Ani mod <br><br>";
        Aide_text = Aide_text + " ce menu permet la s\xe9lection du mode d'animation, dans l'un o\xf9 l'autre des modes suivants: <br> <br> ";
        Aide_text = Aide_text + " _______<b> D\xe9but: </b> Date et heure d'origine fix\xe9es. L'animation porte sur les temps de pr\xe9visions,  les \xe9ch\xe9ances. <br>";
        Aide_text = Aide_text + "  Il s'agit de l'animation usuelle, qui montre l'\xe9volution des param\xe8tres par couches successives dans le temps de validit\xe9. <br><br>";
        Aide_text = Aide_text + " _______<b> Valid: </b> Date et heure de validit\xe9 fix\xe9es. L'animation porte sur les r\xe9centes dates et heures d'origines donnant ";
        Aide_text = Aide_text + " des pr\xe9visions d'\xe9ch\xe9ances vari\xe9es <b> ayant en commun la date et heure de validit\xe9 affich\xe9e </b>. <br> ";
        Aide_text = Aide_text + " Il s'agit d'une animation de la s\xe9quence historique de pr\xe9visions faites pour une date donn\xe9e. <br> <br>";
        Aide_text = Aide_text + "  <b> Avant </b>  d'activer le mode -Valid- il faut afficher \xe0 l'\xe9cran la date et l'heure de validit\xe9 d'int\xe9r\xeat, parce qu'ils seront ainsi fix\xe9es pour le mode -Valid-. Plus tard, pour changer ou pour fixer le temps valide d'int\xe9r\xeat, il faut revenir en mode -D\xe9but-, s\xe9lectionner la date d'origine, et ajuster le prog pour obtenir la validit\xe9 d\xe9sir\xe9.  <br> <br>";
        Aide_text = Aide_text + "  <b> Truc: </b> Avant d'activer le mode -Valid- s\xe9lectionne le syst\xe8me, la carte, et la date d'origine des couches 1 et 2 (ensuite).   Plus tard, ajuster le prog au moyen de la fl\xe8che avant ou arri\xe8re. Il faut tenir compte du nombre de passes historique qui sont conserv\xe9es...<br> <br>";
    } else if (aideCode == "CoucheAffichage") {
        Aide_text = " Menu Couches <br><br>";
        Aide_text = Aide_text + " Il permet la s\xe9lection du mode d'affichage des couches 1 et 2, dans l'un ou l'autre des modes suivants: <br> <br> ";
        Aide_text = Aide_text + " _______<b> Interca: pour couches intercall\xe9es </b> L'animation affiche <b> successivement </b> les couches 1 et 2 en commencant par la couche 2. <br>";
        Aide_text = Aide_text + " _______<b> Surperp: pour couches superpos\xe9es </b> L'animation affiche en simultan\xe9ment les couches 1 et 2 en superposition la couche 1 au dessus. <br> <br>";
        Aide_text = Aide_text + " _______<b> Juxtapo: pour couches juxtapos\xe9es </b> L'animation affiche en simultan\xe9ment les couches 1 et 2 simultan\xe9ment la couche 1 \xe0 gauche et la couche 2 \xe0 droite, dans deux cartes g\xe9ographiques distinctes. <br> <br>";
        Aide_text = Aide_text + "  Notez que la carte de la couche 2 s'affichera:<br> <br> ";
        Aide_text = Aide_text + "  - en dessous (avant) la carte de la couche 1 en mode, couches <b> superpos\xe9es </b> (voir menu Couches)<br> ";
        Aide_text = Aide_text + " ou <br> ";
        Aide_text = Aide_text + "  - avant son comparable de la couche 1, en mode <b> intercall\xe9 </b> de couches (voir menu Couches)<br> <br>";
        Aide_text = Aide_text + "  La carte de la couche 2 devrait normalement \xeatre s\xe9lectionn\xe9e \xe0 un Syst. pr\xe8v autre que VOID (couche 2 active) en mode superposition, sans quoi <br>";
        Aide_text = Aide_text + "  puisqu'il n'y a alors qu'une seule s\xe9rie d'images, la superposition portera sur des cartes ayant des temps de validit\xe9s successifs dans la liste de l'animation. ";
        Aide_text = Aide_text + "  On a choisi de laisser l'interface le permettre, m\xeame si on n'en voit pas l'utilit\xe9... Toutefois, lors de l'effacage de la couche 2, le mode de Couche ";
        Aide_text = Aide_text + "  sera fix\xe9 \xe0 Intercal automatiquement.   Il faudra s\xe9lectionner la Superpo dans le menu Couche pour obtenir la superposition apr\xe8s avoir effac\xe9 la couche 2 (s\xe9lection void). <br>";
    } else if (aideCode == "ViewProjection") {
        Aide_text = " Menu Proj:<br><br>";
        Aide_text = Aide_text + " Il permet de modifier la s\xe9lection de la projection g\xe9ographique de la visualisation. <br> <br>";
        Aide_text = Aide_text + " Chaque syst\xe8me de pr\xe9vision a une projection g\xe9ographique associ\xe9e, d\xe9termin\xe9e lors de la cr\xe9ation des <b> images </b> \xe0 partir des donn\xe9es du service de pr\xe9visions. De mani\xe8re g\xe9n\xe9rale, on tentera, \xe0 l'avenir, de conserver la projection g\xe9ographique offerte par le service de pr\xe9vision tel que d\xe9cod\xe9e dans le fichier GRIB. \xc0 ce stade-ci, ce travail n'est pas fait, toutes les images sont encore produites sur une projection EPSG:3857 (Web Mercator). <br> <br> ";
        Aide_text = Aide_text + " Dans cette interface, de fa\xe7on automatique, la carte m\xe9t\xe9o du syst\xe8me s\xe9lectionn\xe9e \xe0 la <b> couche 1 </b> sera pr\xe9sent\xe9e \xe0 l'\xe9cran dans <b> -sa- projection </b> g\xe9ographique (i.e. sans interpolation \xe0 l'affichage).  Cette projection g\xe9ographique correspond \xe0 celle de <b> l'image m\xe9t\xe9o de la couche 1 </b>.  C'est le mode de d\xe9part qui correspond \xe0 la s\xe9lection <b> Syst.Prev </b>  du menu. Dans ce contexte, la projection de visualisation sera d\xe9termin\xe9e par la projection du Syst\xe8me de pr\xe9vision de la couche 1. ";
        Aide_text = Aide_text + " La carte m\xe9t\xe9o du syst\xe8me s\xe9lectionn\xe9 \xe0 la couche  <b> 2 </b> sera pr\xe9sent\xe9e \xe0 l'\xe9cran dans <b> -la- projection g\xe9ographique de la couche 1 </b>. Cela pourrait impliquer des interpolations lors de l'affichage. Cela est in\xe9vitable lors de la superposition de syst\xe8mes de pr\xe9visions diff\xe9rents, ayant des projections distinctes.  On peut intervertir les syst\xe8mes des couches 1 et 2,  afin de changer lequel se projette sur l'autre.  <br> <br> ";
        Aide_text = Aide_text + " La s\xe9lection d'une projection particuli\xe8re faite au menu Proj (autre que Syst.Prev), imposera cette projection g\xe9ographique de votre choix pour la pr\xe9sentation des deux couches.  On peut revenir au mode de d\xe9part en re-s\xe9lectionnant Sys.Prev au menu. <br> <br>";
        Aide_text = Aide_text + " Notez que la pr\xe9sentation \xe0 l'\xe9cran dans une projection diff\xe9rente de celle de l'image \xe0 la source entraine une interpolation \xe0 l'affichage.  Cela peut avoir un impact sur la rapidit\xe9 de l'animation. </b>  ";
    } else if (aideCode == "Interval" && !$efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = " Menu Interv<br><br>";
        Aide_text = Aide_text + " Il permet la s\xe9lection de l'interval de temps pour 2 aspects: <br> <br>";
        Aide_text = Aide_text + " - pour l'accumulation de la pr\xe9cipitation, <br> ";
        Aide_text = Aide_text + " - <b> ainsi </b> que pour le temps entre chaque pr\xe9vision dans le cas de l'animation en mode <b> D\xe9but fixe </b> (voir menu Anim. mode). <br> <br>";
        Aide_text = Aide_text + " Le choix de valeurs diff\xe9re d'un syst\xe8me de pr\xe9vision \xe0 l'autre,  et parfois d'un zoom \xe0 l'autre. <br> <br> ";
        Aide_text = Aide_text + "  Un algorithme doit parfois ajuster l'interval afin d'obtenir une valeur commune,";
        Aide_text = Aide_text + " dans le cas o\xf9 deux syst\xe8mes diff\xe9rents sont selectionn\xe9s sur les couches 1 et 2.  <br> <br> ";
        Aide_text = Aide_text + " Lorsque l'interval est ajust\xe9   automatiquement ,  il prend la valeur la plus petite possible.  En g\xe9n\xe9ral l'interval valide est \xe9tablie compte tenu (dans l'ordre) de: les syst\xe8mes de pr\xe9visions, les dates d'origines (d\xe9callage), la carte m\xe9t\xe9o (pour cumul precip). Les parm\xe8tres Debut et Fin s'ajusteront \xe0 la valeur de l'interval,  si il y a lieu. <br> ";
        Aide_text = Aide_text + " Enfin, un clique sur l \xe9tiquette <b><i> Interv. </i></b> situ\xe9e au dessus du menu, fera en sorte que l`intervalle sera ajust\xe9e de mani\xe8re automatique.";
    } else if (aideCode == "Interval" && $efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = " Menu Interv vent<br><br>";
        Aide_text = Aide_text + " Il permet la s\xe9lection de l'interval de temps pour entre chaque pr\xe9vision l'animation  <br>";
    } else if (aideCode == "Debut" && !$efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = " Menu D\xe9but.<br><br>";
        Aide_text = Aide_text + " Ce menu est absent lorsque l'animation est en mode <b> Validit\xe9 fix\xe9s </b> (voir menu Anim. mode).<br>";
        Aide_text = Aide_text + " Il permet la s\xe9lection du <b> premier temps de pr\xe9vision </b> de l'animation dans le cas de l'animation en mode <b> D\xe9but fix\xe9 </b>. <br><br> ";
        Aide_text = Aide_text + " Le choix de valeurs diff\xe9re d'un syst\xe8me de pr\xe9vision \xe0 l'autre,  et parfois d'un zoom \xe0 l'autre. <br> <br>";
        Aide_text = Aide_text + "  Un algorithme doit parfois ajuster l'interval afin d'obtenir une valeur commune, ";
        Aide_text = Aide_text + " dans le cas o\xf9 deux syst\xe8mes diff\xe9rents sont selectionn\xe9s sur les couches 1 et 2.  <br> <br> ";
        Aide_text = Aide_text + " Lorsque D\xe9but est ajust\xe9 automatiquement,  il prend la valeur <b> la plus petite possible</b>. En g\xe9n\xe9ral, le D\xe9but valide est \xe9tabli compte tenu (dans L'ordre) de: les syst\xe8mes de pr\xe9visions, les dates d'origines (d\xe9callage), la carte m\xe9t\xe9o (pour cumul precip) et l'interval de temps. La Fin s'justera \xe0 la valeur du D\xe9but si il y a lieu. <br> ";
        Aide_text = Aide_text + " Enfin, un clique sur l \xe9tiquette <b><i> D\xe9but </i></b> situ\xe9 au dessus du menu, fera en sorte que le valeur de d\xe9but sera ajust\xe9e de mani\xe8re automatique.";
    } else if (aideCode == "Debut" && $efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = " Menu D\xe9but. vent<br><br>";
        Aide_text = Aide_text + " Il permet la s\xe9lection du <b> premier temps de pr\xe9vision </b> de l'animation  <br><br> ";
        Aide_text = Aide_text + "  Un algorithme doit parfois ajuster le d\xe9but afin d'obtenir des temps de validit\xe9 communs, ";
        Aide_text = Aide_text + " dans le cas o\xf9 deux dates d'origines diff\xe9rentes sont selectionn\xe9es sur les couches 1 et 2.  <br> <br> ";
        Aide_text = Aide_text + " Lorsque D\xe9but est ajust\xe9 automatiquement,  il prend la valeur <b> la plus petite possible</b>. En g\xe9n\xe9ral, le D\xe9but valide est \xe9tabli compte tenu (dans L'ordre) de: les syst\xe8mes de pr\xe9visions, les dates d'origines (d\xe9callage), et l'interval de temps. La Fin s'ajustera \xe0 la valeur du D\xe9but si il y a lieu. <br> ";
        Aide_text = Aide_text + " Enfin, un clique sur l \xe9tiquette <b><i> D\xe9but </i></b> situ\xe9 au dessus du menu, fera en sorte que le valeur de d\xe9but sera ajust\xe9e de mani\xe8re automatique.";
    } else if (aideCode == "Fin" && !$efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = " Menu Fin.<br><br>";
        Aide_text = Aide_text + " Ce menu est absent lorsque l'animation est en mode <b> Validit\xe9 fix\xe9s </b> (voir menu Anim. mode).<br>";
        Aide_text = Aide_text + " Il permet la s\xe9lection du <b> dernier temps </b> de pr\xe9vision (la fin) de l'animation dans le cas de l'animation en mode <b> D\xe9but fixe </b>. <br> <br>";
        Aide_text = Aide_text + " Le choix de valeurs diff\xe9re d'un syst\xe8me de pr\xe9vision \xe0 l'autre,  et parfois d'un zoom \xe0 l'autre. <br><br> ";
        Aide_text = Aide_text + "  Un algorithme doit parfois ajuster l'interval afin d'obtenir une valeur commune,  ";
        Aide_text = Aide_text + " dans le cas o\xf9 deux syst\xe8mes diff\xe9rents sont selectionn\xe9s sur les couches 1 et 2.  <br> <br> ";
        Aide_text = Aide_text + " Lorsque la Fin est ajust\xe9e,  elle prend la valeur <b> la plus grande possible </b>, compte tenu (dans L'ordre) de: les syst\xe8mes de pr\xe9visions, les dates d'origines (d\xe9callage), la carte m\xe9t\xe9o (pour cumul precip) et l'interval de temps,  le D\xe9but. <br> ";
        Aide_text = Aide_text + " Enfin, un clique sur l \xe9tiquette <b><i> Fin </i></b> situ\xe9 au dessus du menu, fera en sorte que le valeur de Fin sera ajust\xe9e de mani\xe8re automatique.";
    } else if (aideCode == "Fin" && $efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = " Menu Fin. vent <br><br>";
        Aide_text = Aide_text + " Il permet la s\xe9lection du <b> dernier temps </b> de pr\xe9vision (la fin) de l'animation <br> <br>";
        Aide_text = Aide_text + "  Un algorithme doit parfois ajuster la fin afin d'obtenir des temps de validit\xe9s communs,  ";
        Aide_text = Aide_text + " dans le cas o\xf9 deux dates d'origines diff\xe9rentes sont selectionn\xe9es sur les couches 1 et 2.  <br> <br> ";
        Aide_text = Aide_text + " Lorsque la Fin est ajust\xe9e,  elle prend la valeur <b> la plus grande possible </b>, compte tenu (dans L'ordre) : des dates d'origines (d\xe9callage),  et l'interval de temps,  du D\xe9but. <br> ";
        Aide_text = Aide_text + " Enfin, un clique sur l \xe9tiquette <b><i> Fin </i></b> situ\xe9 au dessus du menu, fera en sorte que le valeur de Fin sera ajust\xe9e de mani\xe8re automatique.";
    } else if (aideCode == "ResetTimeMenus" && !$efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = " Bouton Init. Temps <br><br>";
        Aide_text = Aide_text + " Ce Bouton permet, d'une seule touche de mettre \xe0 jour les param\xe8tres suivants: <br> <br>";
        Aide_text = Aide_text + " La <b> date d'origine </b> sera mise \xe0 jour \xe0 l'heure (et date) <b> la plus r\xe9cente </b> pour le(s) syst\xe8me(s) de pr\xe9visions s\xe9lectionn\xe9(s).  <br> ";
        Aide_text = Aide_text + " L' <b> interval </b> de temps (pas de temps d'animation, et p\xe9riode d'accumulation des pr\xe9cipitation) sera ajust\xe9 \xe0 la valeur la <b> plus courte possible </b>,  selon les choix de syst\xe8mes de pr\xe9visions, du possible d\xe9callage de leurs date d'origine, et de carte m\xe9t\xe9o. <br> ";
        Aide_text = Aide_text + " Le <b> D\xe9but </b> de l'animation sera ajust\xe9 \xe0 <b> la valeur la plus petite possible </b>,  selon les choix de syst\xe8mes de pr\xe9visions, du possible d\xe9callage de leurs dates d'origines et de leurs carte m\xe9t\xe9o, et de l'interval. <br> ";
        Aide_text = Aide_text + " Enfin, la <b> Fin </b> de l'animation sera ajust\xe9 \xe0 <b> la valeur la plus grande possible </b>,  selon les choix de syst\xe8mes de pr\xe9visions, du possible d\xe9callage de leurs dates d'origines, des cartes m\xe9t\xe9o, et de l'interval, ainsi que du d\xe9but. <br> ";
    } else if (aideCode == "ResetTimeMenus" && $efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = " Bouton Init. Temps  (vent)<br><br>";
        Aide_text = Aide_text + " Ce Bouton permet, d'une seule touche de mettre \xe0 jour les param\xe8tres suivants: <br> <br>";
        Aide_text = Aide_text + " La <b> date d'origine </b> sera mise \xe0 jour \xe0 l'heure (et date) <b> la plus r\xe9cente </b> pour le(s) secteur(s) s\xe9lectionn\xe9(s).  <br> ";
        Aide_text = Aide_text + " Le <b> D\xe9but </b> de l'animation sera ajust\xe9 \xe0 <b> la valeur la plus petite possible </b>,  selon le possible d\xe9callage de temps entre les dates d'origines des couche 1 et 2  et de l'interval. <br> ";
        Aide_text = Aide_text + " Enfin, la <b> Fin </b> de l'animation sera ajust\xe9 \xe0 <b> la valeur la plus grande possible </b> <br> ";
    } else if (aideCode == "DuoA") {
        Aide_text = " Bouton DuoA <br><br>";
        Aide_text = Aide_text + " Ce bouton permet, d'une seule touche, d'obtenir un panneau de boutons offrant des associations <b> Cartes M\xe9t\xe9o. </b>  Il s'agit de raccourcis par rapport \xe0 l'utilisation des menus  <b> Syst. Prev. et Cartes M\xe9t\xe9o </b>. <br> <br>";
        Aide_text = Aide_text + " La <b> date d'origine </b> ainsi que les autres param\xe8tres de temps (interval,prog de d\xe9but et de fin,  etc) ne seront ajust\xe9s qu'en cas de n\xe9c\xe9ssit\xe9 seulement.  Ainsi, lorsque l'on passe du syst\xe8me Global GDPS \xe0 un Syst\xe8me HRDPS, par exemple, la date d'origine pourrait ne pas \xeatre la plus r\xe9cente,   et l'interval de temps pour les accumulations de pr\xe9cipitations/pour les pas de temps de l'animation pourraient ne pas \xeatre ceux qui sont d\xe9sir\xe9s. On peut toujours corrig\xe9 au moyen des menus,   ou y aller d'un seul coup avec le bouton voisin <b> Init. T. </b>  qui r\xe9tablira les valeurs typiques.";
    } else if (aideCode == "DuoB") {
        Aide_text = " Bouton DuoB <br><br>";
        Aide_text = Aide_text + " Ce bouton permet, d'une seule touche, d'obtenir un panneau de boutons des s\xe9lections pour <b> comparaisons (ou de juxtaposition) de Syst\xe8mes de pr\xe9visions </b>.  Il s'agit de raccourcis par rapport \xe0l'utilisation des menus <b> Syst. Prev. et Cartes M\xe9t\xe9o </b>. Dans la majorit\xe9 des cas,  l'intercalage des cartes sera s\xe9lectionn\xe9 automatiquement. L'essayer c'est l'adopter !  <br> <br>";
        Aide_text = Aide_text + " La <b> date d'origine </b> ainsi que les autres param\xe8tres de temps (interval,prog de d\xe9but et de fin,  etc) ne seront ajust\xe9s qu'en cas de n\xe9c\xe9ssit\xe9 seulement.  Ainsi, lorsque l'on passe du syst\xe8me Global GDPS \xe0 un Syst\xe8me HRDPS, par exemple, la date d'origine pourrait ne pas \xeatre la plus r\xe9cente,   et l'interval de temps pour les accumulations de pr\xe9cipitations/pour les pas de temps de l'animation pourraient ne pas \xeatre ceux qui sont d\xe9sir\xe9s. On peut toujours corrig\xe9 au moyen des menus,   ou y aller d'un seul coup avec le bouton voisin <b> Init. T. </b>  qui r\xe9tablira les valeurs typiques.";
    } else if (aideCode == "DuoC") {
        Aide_text = " Button DuoC <br><br>";
        Aide_text = Aide_text + " Ce bouton permet, d'une seule touche, d'obtenir un panneau de boutons des s\xe9lections de produits";
        Aide_text = Aide_text + "  <b> d \xe9tats de la mer </b>. Il s'agit de raccourcis par rapport \xe0 l'utilisation des menus";
        Aide_text = Aide_text + "  <b> Syst. Prev. et Cartes M\xe9t\xe9o </b>. <br> <br>";
        Aide_text = Aide_text + " Dans la majorit\xe9 des cas,  l'intercalage des cartes sera s\xe9lectionn\xe9 automatiquement.";
        Aide_text = Aide_text + " La <b> date d'origine </b> ainsi que les autres param\xe8tres de temps (interval,prog de d\xe9but et de fin,  etc)";
        Aide_text = Aide_text + " ne seront ajust\xe9s qu'en cas de n\xe9c\xe9ssit\xe9 seulement. Les dates d'origine ajust\xe9es automatiquement pourraient";
        Aide_text = Aide_text + " ne pas etre d\xe9sir\xe9es.  Le mod\xe8le de vague (RDWPS)  \xe9tant disponible environs trois heures plus t\xf4t,";
        Aide_text = Aide_text + " il faut parfois s\xe9lectionner la passe pr\xe9c\xe9dente afin d'assurer la coh\xe9rence avec le plus r\xe9cent diagnostique (DIAGW).";
    } else if (aideCode == "DuoD") {
        Aide_text = " Bouton DuoD <br><br>";
        Aide_text = Aide_text + " Ce bouton permet, d'une seule touche, d'obtenir un panneau de boutons offrant des pr\xe9 s\xe9lections pour les <b> couches Cartes m\xe9t\xe9o </b>";
    } else if (aideCode == "DuoN") {
        Aide_text = " Bouton DuoN <br><br>";
        Aide_text = Aide_text + " Ce bouton permet, d'une seule touche, d'obtenir un panneau de boutons offrant des pr\xe9 s\xe9lections pour les <b> couches Satellites et Radar</b>.  Il s'agit de raccourcis par rapport \xe0 l'utilisation des menus <b> Secteur (zoom) et Cartes M\xe9t\xe9o </b>.";
    } else if (aideCode == "Archives") {
        Aide_text = " Bouton Archives <br><br>";
        Aide_text = Aide_text + " Ce bouton permet de revenir en arri\xe8re afin de comparer les performance r\xe9centes des syst\xe8mes de pr\xe9visions.  Ce n'est qu'u essai pour le moment. En mode  <b> Archives </b>,  le nombre de <b> Carte M\xe9t\xe9o </b> sera limit\xe9,  mais l'historique de temps de d\xe9parts, offert au menu <b> Dates d'origine </b>, est beaucoup plus g\xe9n\xe9reux.";
    } else if (aideCode == "Loc") {
        Aide_text = " Bouton Loc <br><br>";
        Aide_text = Aide_text + " Ce bouton permet d activer des <b> marqueurs (Marker) de localisation </b> sur les cartes m\xe9t\xe9o.  Il y a 2 marqueurs:  un noirxi et blanc et un deuxi\xe8me qui est noir et rouge. Ces marqueurs peuvent \xeatre positionn\xe9s selon votre pr\xe9f\xe9rence: soit avec la souris (grab & move),  ou \xe0 l aide des zones d entr\xe9es de donn\xe9es pour les longitudes et latitudes. Ces zones d entr\xe9es de donn\xe9es sont situ\xe9s juste en dessous du bouton Loc. Les localisations que vous choisissez au cours d'une session sur un ordinateur/tablette/t\xe9l\xe9phone sont conserv\xe9es sur l'appareil,  et elles vous seront offertes lors d'une session ult\xe9rieur sur cet appareil en particulier, si vous activez \xe0 nouveau les marqueurs.";
    } else if (aideCode == "AllerDebut") Aide_text = " Aller directement <b> au d\xe9but </b> de l'animation. <br> <br>";
    else if (aideCode == "AllerFin") Aide_text = " Aller directement <b> \xe0 la fin </b> de l'animation. <br> <br>";
    else if (aideCode == "Arreter") Aide_text = " <b> Arr\xeat ou d\xe9marrage </b> de l'animation. <br> <br>";
    else if (aideCode == "Demarrer") Aide_text = " <b> Arr\xeat ou d\xe9marrage </b> de l'animation. <br> <br>";
    else if (aideCode == "Avance") Aide_text = " <b> Avancer d'un pas  </b> dans l'animation. <br> <br>";
    else if (aideCode == "Recule") Aide_text = " <b> Reculer d'un pas  </b> dans l'animation. <br> <br>";
    else if (aideCode == "Ralentir") {
        Aide_text = " <b> Ralentir </b> l'animation. <br> <br>";
        Aide_text = Aide_text + " - Avec un clique la cadence diminue d'un facteur 1.26 environs <br>";
        Aide_text = Aide_text + " - Avec 3 cliques, la cadence diminue d'un facteur 2. <br>";
    } else if (aideCode == "Accelerer") {
        Aide_text = " <b> Acc\xe9l\xe9rer </b> l'animation. <br> <br>";
        Aide_text = Aide_text + " - \xc0 chaque clique, la cadence se augmente d'un facteur 2.   <br>";
    } else if (aideCode == "Last") Aide_text = " <b> Revenir \xe0 l'image pr\xe9c\xe9dente dans la s\xe9quence d'animation </b> <br> <br>";
    if (!$efd3ba4ec2608b1d$var$WindMaps) {
        Aide_text = Aide_text + " <br> Pour changer le sujet de l aide ,  il suffit de cliquer <b> au dessus </b> d'un bouton ou d'un menu sur le symbole <b> ? </b>.<br>";
        Aide_text = Aide_text + " Pour d\xe9sactiver ce mode,  il suffit de cliquer \xe0 nouveau sur l'interrupteur d'aide. <br>";
        Aide_text = Aide_text + " <br> Plus de d\xe9tails sont disponibles dans la <a href='../image_res/documentation_imeteomaps_latest.htm' target='_blank'> documentation</a> ";
    }
    document.getElementById("afficher_aide").innerHTML = " <b> Aide: </b> " + Aide_text;
}
////
//-----------------------------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
//
$("#helpLabel1").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Label1");
});
$("#helpLabel2").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Label2");
});
$("#helpCouche1Model").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Couche1Model");
});
$("#helpCouche2Model").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Couche2Model");
});
$("#helpCouche1Carte").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Couche1Carte");
});
$("#helpCouche2Carte").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Couche2Carte");
});
$("#helpCoucheCo1Carte").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("CoucheCo1Carte");
});
$("#helpCoucheCo2Carte").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("CoucheCo2Carte");
});
$("#helpCouche1Dateo").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Couche1Dateo");
});
$("#helpCouche2Dateo").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Couche2Dateo");
});
$("#helpCouche1Valeurs").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Couche1Valeurs");
});
$("#helpCouche2Valeurs").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Couche2Valeurs");
});
$("#helpCouche1Opacit").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Couche1Opacit");
});
$("#helpCouche2Opacit").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Couche2Opacit");
});
$("#helpAnimMode").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("AnimMode");
});
$("#helpCoucheAffichage").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("CoucheAffichage");
});
$("#helpViewProjection").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("ViewProjection");
});
$("#helpInterval").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Interval");
});
$("#helpDebut").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Debut");
});
$("#helpFin").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Fin");
});
$("#helpResetTimeMenus").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("ResetTimeMenus");
});
$("#helpDuoA").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("DuoA");
});
$("#helpDuoB").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("DuoB");
});
$("#helpDuoC").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("DuoC");
});
$("#helpDuoD").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("DuoD");
});
$("#helpDuoN").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("DuoN");
});
// $("#helpArchives").click(function(){ affiche_aide("Archives"); });
$("#helpLoc").click(function() {
    $efd3ba4ec2608b1d$var$affiche_aide("Loc");
});
var $efd3ba4ec2608b1d$var$Helpswitch = document.getElementById("helpswitch");
var $efd3ba4ec2608b1d$var$Helpswitchlabel = document.getElementById("helpswitchlabel");
$efd3ba4ec2608b1d$var$Helpswitchlabel.style.backgroundColor = "#fffff";
var $efd3ba4ec2608b1d$var$HelpClass = document.getElementsByClassName("help");
var $efd3ba4ec2608b1d$var$HelpClass0 = document.getElementsByClassName("help0");
var $efd3ba4ec2608b1d$var$HelpClass2 = document.getElementsByClassName("help2");
var $efd3ba4ec2608b1d$var$HelpClass3 = document.getElementsByClassName("help3");
for(var $efd3ba4ec2608b1d$var$i = 0; $efd3ba4ec2608b1d$var$i < $efd3ba4ec2608b1d$var$HelpClass.length; $efd3ba4ec2608b1d$var$i++){
    $efd3ba4ec2608b1d$var$HelpClass[$efd3ba4ec2608b1d$var$i].style.backgroundColor = "#ffffff";
    $efd3ba4ec2608b1d$var$HelpClass[$efd3ba4ec2608b1d$var$i].style.display = "none";
}
for(var $efd3ba4ec2608b1d$var$i = 0; $efd3ba4ec2608b1d$var$i < $efd3ba4ec2608b1d$var$HelpClass0.length; $efd3ba4ec2608b1d$var$i++){
    $efd3ba4ec2608b1d$var$HelpClass0[$efd3ba4ec2608b1d$var$i].style.backgroundColor = "#ffffff";
    $efd3ba4ec2608b1d$var$HelpClass0[$efd3ba4ec2608b1d$var$i].style.display = "none";
}
for(var $efd3ba4ec2608b1d$var$i = 0; $efd3ba4ec2608b1d$var$i < $efd3ba4ec2608b1d$var$HelpClass2.length; $efd3ba4ec2608b1d$var$i++){
    $efd3ba4ec2608b1d$var$HelpClass2[$efd3ba4ec2608b1d$var$i].style.backgroundColor = "#ffffff";
    $efd3ba4ec2608b1d$var$HelpClass2[$efd3ba4ec2608b1d$var$i].style.display = "none";
}
for(var $efd3ba4ec2608b1d$var$i = 0; $efd3ba4ec2608b1d$var$i < $efd3ba4ec2608b1d$var$HelpClass3.length; $efd3ba4ec2608b1d$var$i++){
    $efd3ba4ec2608b1d$var$HelpClass3[$efd3ba4ec2608b1d$var$i].style.backgroundColor = "#ffffff";
    $efd3ba4ec2608b1d$var$HelpClass3[$efd3ba4ec2608b1d$var$i].style.display = "none";
}
////
//____________________________________________________________________________________________________
//
//
function $efd3ba4ec2608b1d$var$switch_help() {
    if ($efd3ba4ec2608b1d$var$Helpswitch.checked == true) {
        $efd3ba4ec2608b1d$var$Helpswitchlabel.style.backgroundColor = "#fefbd8";
        for(var i = 0; i < $efd3ba4ec2608b1d$var$HelpClass.length; i++){
            $efd3ba4ec2608b1d$var$HelpClass[i].style.backgroundColor = "#f1f1f1";
            $efd3ba4ec2608b1d$var$HelpClass[i].style.display = "block";
            $efd3ba4ec2608b1d$var$affiche_aide("start");
        }
        for(var i = 0; i < $efd3ba4ec2608b1d$var$HelpClass0.length; i++){
            $efd3ba4ec2608b1d$var$HelpClass0[i].style.backgroundColor = "#f1f1f1";
            $efd3ba4ec2608b1d$var$HelpClass0[i].style.display = "block";
            $efd3ba4ec2608b1d$var$affiche_aide("start");
        }
        if (!$efd3ba4ec2608b1d$var$WindMaps) {
            for(var i = 0; i < $efd3ba4ec2608b1d$var$HelpClass2.length; i++){
                $efd3ba4ec2608b1d$var$HelpClass2[i].style.backgroundColor = "#f1f1f1";
                $efd3ba4ec2608b1d$var$HelpClass2[i].style.display = "block";
                $efd3ba4ec2608b1d$var$affiche_aide("start");
            }
            for(var i = 0; i < $efd3ba4ec2608b1d$var$HelpClass3.length; i++){
                $efd3ba4ec2608b1d$var$HelpClass3[i].style.backgroundColor = "#f1f1f1";
                $efd3ba4ec2608b1d$var$HelpClass3[i].style.display = "block";
                $efd3ba4ec2608b1d$var$affiche_aide("start");
            }
        } else for(var i = 0; i < $efd3ba4ec2608b1d$var$HelpClass3.length; i++){
            $efd3ba4ec2608b1d$var$HelpClass3[i].style.backgroundColor = "#f1f1f1";
            $efd3ba4ec2608b1d$var$HelpClass3[i].style.display = "block";
            $efd3ba4ec2608b1d$var$affiche_aide("start");
        }
    } else {
        $efd3ba4ec2608b1d$var$Helpswitchlabel.style.backgroundColor = "#f1f1f1";
        for(var i = 0; i < $efd3ba4ec2608b1d$var$HelpClass.length; i++){
            $efd3ba4ec2608b1d$var$HelpClass[i].style.backgroundColor = "#f1f1f1";
            $efd3ba4ec2608b1d$var$HelpClass[i].style.display = "none";
        }
        for(var i = 0; i < $efd3ba4ec2608b1d$var$HelpClass0.length; i++){
            $efd3ba4ec2608b1d$var$HelpClass0[i].style.backgroundColor = "#f1f1f1";
            $efd3ba4ec2608b1d$var$HelpClass0[i].style.display = "none";
        }
        if (!$efd3ba4ec2608b1d$var$WindMaps) {
            for(var i = 0; i < $efd3ba4ec2608b1d$var$HelpClass2.length; i++){
                $efd3ba4ec2608b1d$var$HelpClass2[i].style.backgroundColor = "#f1f1f1";
                $efd3ba4ec2608b1d$var$HelpClass2[i].style.display = "none";
            }
            for(var i = 0; i < $efd3ba4ec2608b1d$var$HelpClass3.length; i++){
                $efd3ba4ec2608b1d$var$HelpClass3[i].style.backgroundColor = "#f1f1f1";
                $efd3ba4ec2608b1d$var$HelpClass3[i].style.display = "none";
            }
        } else for(var i = 0; i < $efd3ba4ec2608b1d$var$HelpClass3.length; i++){
            $efd3ba4ec2608b1d$var$HelpClass3[i].style.backgroundColor = "#f1f1f1";
            $efd3ba4ec2608b1d$var$HelpClass3[i].style.display = "none";
        }
    }
}
// -----------------------------------------------------------------------------------
//
$("#helpswitch").click(function() {
    $efd3ba4ec2608b1d$var$switch_help();
});
////var ArchivesSwitch = document.getElementById("archivesSwitch");
////var ArchivesSwitchLabel = document.getElementById("archivesSwitchlabel");
////ArchivesSwitchLabel.style.backgroundColor = "#fffff";
//____________________________________________________________________________________________________
//
////function switch_archives() {
////  var message=" ";
////var couche_change_pas = true;
////if (ArchivesSwitch.checked == true){
////ArchivesSwitchLabel.style.backgroundColor = "#ff3300";  
////ArchivesVerif = true;
////Tronc = 'maps_archives';
////message=" l archives est activees:  le tronc sera: " +  Tronc;
////console.log(message);
////ModAInterv.set("RDPS", 360);
////ModAInterv.set("GDPS", 720);
////ModAInterv.set("GDPSE", 720);
////ModAInterv.set("GFS", 720);
////ModAInterv.set("AIFS", 720);
////ModAInterv.set("AIFSE", 720);
////ModAInterv.set("ECMWF", 720);
////ModAInterv.set("ECMWFE", 720);
////ModAInterv.set("ECMWF3", 360);
////ModADebut.set("RDPS", 360);
////ModADebut.set("GDPS", 720);
////ModADebut.set("GDPSE", 720);
////ModADebut.set("GFS", 720);
////ModADebut.set("AIFS", 720);
////ModADebut.set("AIFSE", 720);
////ModADebut.set("ECMWF", 720);
////ModADebut.set("ECMWFE", 720);
////ModADebut.set("ECMWF3", 360);
////ModADebut.set("GOESR NE", 60);
////ModADebut.set("GOESR CO", 60);
////ModADebut.set("GOESR_PLUS", 60);
////ModADebut.set("FOUDRE CO", 60);
////ModADebut.set("RADAR NE", 60);
////ModADebut.set("RADAR CO", 60);
////IntercaSelect.options.selectedIndex = 0;
////updateIntercaFromMenu("refresh");
////couche_change_pas = setMenuMapIdH(1,   MapIdH1Select );
////couche_change_pas = setMenuMapIdH(2,   MapIdH2Select );
////resetTimeMenus();
////} else {
////ArchivesSwitchLabel.style.backgroundColor = "#f1f1f1";
////ArchivesVerif = false;
////Tronc = 'maps';
////message=" l archive est desactivees:  le tronc sera: " +  Tronc;
////console.log(message);
////ModAInterv.set("RDPS", 180);
////ModAInterv.set("GDPS", 360);
////ModAInterv.set("GDPSE", 360);
////ModAInterv.set("GFS", 360);
////ModAInterv.set("AIFS", 360);
////ModAInterv.set("AIFSE", 360);
////ModAInterv.set("ECMWF", 360);
////ModAInterv.set("ECMWFE", 360);
////ModAInterv.set("ECMWF3", 180);
////ModADebut.set("RDPS", 180);
////ModADebut.set("GDPS", 360);
////ModADebut.set("GDPSE", 360);
////ModADebut.set("GFS", 360);
////ModADebut.set("AIFS", 360);
////ModADebut.set("AIFSE", 360);
////ModADebut.set("ECMWF", 360);
////ModADebut.set("ECMWFE", 360);
////ModADebut.set("ECMWF3", 180);
////ModADebut.set("GOESR NE", 60);
////ModADebut.set("GOESR CO", 60);
////ModADebut.set("GOESR_PLUS", 60);
////ModADebut.set("FOUDRE CO", 60);
////ModADebut.set("RADAR NE", 60);
////ModADebut.set("RADAR CO", 60);
////couche_change_pas = setMenuMapIdH(1,   MapIdH1Select );
////couche_change_pas = setMenuMapIdH(2,   MapIdH2Select );
////resetTimeMenus();
////}
////}
// -----------------------------------------------------------------------------------
//
////if ( WindMaps ) {
////   document.getElementById("archivesSwitchlabel").style.display = "none";
////   document.getElementById("archivesSwitch").style.display = "none";
////} else {
//// $("#archivesSwitch").click(function(){  switch_archives();  });
//}
//   Loc Loc   for marker controls from switch...
var $efd3ba4ec2608b1d$var$LocActif = false;
var $efd3ba4ec2608b1d$var$LocSwitch = document.getElementById("locSwitch");
var $efd3ba4ec2608b1d$var$LocSwitchLabel = document.getElementById("locSwitchlabel");
$efd3ba4ec2608b1d$var$LocSwitchLabel.style.backgroundColor = "#fffff";
//____________________________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$switch_loc() {
    var message = " ";
    if ($efd3ba4ec2608b1d$var$LocSwitch.checked == true) {
        $efd3ba4ec2608b1d$var$LocSwitchLabel.style.backgroundColor = "#ffCC00";
        $efd3ba4ec2608b1d$var$LocActif = true;
        message = " la switch loc est  activees ";
        console.log(message);
        document.getElementById("longitudeALabel").style.display = "block";
        document.getElementById("longitudeBLabel").style.display = "block";
        document.getElementById("latitudeALabel").style.display = "block";
        document.getElementById("latitudeBLabel").style.display = "block";
        document.getElementById("longitudeA").style.display = "block";
        document.getElementById("longitudeB").style.display = "block";
        document.getElementById("latitudeA").style.display = "block";
        document.getElementById("latitudeB").style.display = "block";
        $efd3ba4ec2608b1d$var$MiseAJourFeaturesFromInputs();
    } else {
        $efd3ba4ec2608b1d$var$LocSwitchLabel.style.backgroundColor = "#ffffff";
        $efd3ba4ec2608b1d$var$LocActif = false;
        message = " la switch loc  est desactivees";
        console.log(message);
        document.getElementById("longitudeALabel").style.display = "none";
        document.getElementById("longitudeBLabel").style.display = "none";
        document.getElementById("latitudeALabel").style.display = "none";
        document.getElementById("latitudeBLabel").style.display = "none";
        document.getElementById("longitudeA").style.display = "none";
        document.getElementById("longitudeB").style.display = "none";
        document.getElementById("latitudeA").style.display = "none";
        document.getElementById("latitudeB").style.display = "none";
        $efd3ba4ec2608b1d$var$MiseEnPauseFeatures();
    }
}
// -----------------------------------------------------------------------------------
//
$efd3ba4ec2608b1d$var$switch_loc();
$("#locSwitch").click(function() {
    $efd3ba4ec2608b1d$var$switch_loc();
});
// ________________________________________________________________________________
/* Set the width of the side navigation to 300px and the left margin of the page content to 300px */ function $efd3ba4ec2608b1d$var$openSideNav() {
    document.getElementById("mySidenav").style.width = "300px";
    document.getElementById("total-wrapper").style.marginLeft = "300px";
    window.dispatchEvent(new Event("resize"));
}
// -----------------------------------------------------------------------------------
//
$("#openSideNav").click(function() {
    $efd3ba4ec2608b1d$var$openSideNav();
});
/* Set the width of the side navigation to 0 and the left margin of the page content to 0 */ function $efd3ba4ec2608b1d$var$closeSideNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("total-wrapper").style.marginLeft = "0";
    window.dispatchEvent(new Event("resize"));
}
// -----------------------------------------------------------------------------------
//
$("#closeSideNav").click(function() {
    $efd3ba4ec2608b1d$var$closeSideNav();
});
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$closeChoixDuo(lettre) {
    if (lettre == "A") document.getElementById("choixDuoA").style.display = "none";
    else if (lettre == "B") document.getElementById("choixDuoB").style.display = "none";
    else if (lettre == "C") document.getElementById("choixDuoC").style.display = "none";
    else if (lettre == "D") document.getElementById("choixDuoD").style.display = "none";
    else if (lettre == "N") document.getElementById("choixDuoN").style.display = "none";
    else {
        document.getElementById("choixDuoA").style.display = "none";
        document.getElementById("choixDuoB").style.display = "none";
        document.getElementById("choixDuoC").style.display = "none";
        document.getElementById("choixDuoD").style.display = "none";
        document.getElementById("choixDuoN").style.display = "none";
    }
    if ($efd3ba4ec2608b1d$var$ActiveLoop) $efd3ba4ec2608b1d$var$StartAnimate();
}
// -----------------------------------------------------------------------------------
//
$("#closeChoixDuoA").click(function() {
    $efd3ba4ec2608b1d$var$closeChoixDuo("A");
});
$("#closeChoixDuoB").click(function() {
    $efd3ba4ec2608b1d$var$closeChoixDuo("B");
});
$("#closeChoixDuoC").click(function() {
    $efd3ba4ec2608b1d$var$closeChoixDuo("C");
});
$("#closeChoixDuoD").click(function() {
    $efd3ba4ec2608b1d$var$closeChoixDuo("D");
});
$("#closeChoixDuoN").click(function() {
    $efd3ba4ec2608b1d$var$closeChoixDuo("N");
});
// ________________________________________________________________________________
//
function $efd3ba4ec2608b1d$var$ChoixDuo(model2, mapId2, mapIdCo2, model1, mapId1, mapIdCo1, superpo) {
    $efd3ba4ec2608b1d$var$ChoixDuoEnCour = true;
    //DesactiveAndStopAnimate();
    var indice = 0;
    var indice_trouve1 = 0;
    var indice_trouve2 = 0;
    var trouve1 = false;
    var trouve2 = false;
    var indice_trouveCo1 = 0;
    var indice_trouveCo2 = 0;
    var trouveCo1 = false;
    var trouveCo2 = false;
    for(let indice = 0; indice < $efd3ba4ec2608b1d$var$ModeleZoom1Select.options.length; indice++)if (model1 == $efd3ba4ec2608b1d$var$ModeleZoom1Select.options[indice].value) {
        indice_trouve1 = indice;
        trouve1 = true;
    }
    for(let indice = 0; indice < $efd3ba4ec2608b1d$var$ModeleZoom2Select.options.length; indice++)if (model2 == $efd3ba4ec2608b1d$var$ModeleZoom2Select.options[indice].value) {
        indice_trouve2 = indice;
        trouve2 = true;
    }
    var oldMapIdH = $efd3ba4ec2608b1d$var$Couche1.mapIdH;
    if ($efd3ba4ec2608b1d$var$WindMaps) {
        if (oldMapIdH.indexOf("WDIR") != -1 && oldMapIdH.indexOf("WIN") == -1) {
            $efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect1.options.length - 1;
            $efd3ba4ec2608b1d$var$Opacitee1 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect1.options[$efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex].value) / 10.;
        }
        if (mapId1.indexOf("WDIR") != -1 && mapId1.indexOf("WIN") == -1 && $efd3ba4ec2608b1d$var$Couche2.modeleZoom != "void") {
            $efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex = $efd3ba4ec2608b1d$var$OpaciteSelect1.options.length - 1;
            $efd3ba4ec2608b1d$var$Opacitee1 = parseInt($efd3ba4ec2608b1d$var$OpaciteSelect1.options[$efd3ba4ec2608b1d$var$OpaciteSelect1.options.selectedIndex].value) / 10.;
        }
    }
    if (trouve1 && trouve2) {
        $efd3ba4ec2608b1d$var$Couche1.mapIdH = mapId1;
        $efd3ba4ec2608b1d$var$Couche1.mapIdCo = mapIdCo1;
        $efd3ba4ec2608b1d$var$ModeleZoom1Select.options.selectedIndex = indice_trouve1;
        $efd3ba4ec2608b1d$var$Couche2.mapIdH = mapId2;
        $efd3ba4ec2608b1d$var$Couche2.mapIdCo = mapIdCo2;
        $efd3ba4ec2608b1d$var$ModeleZoom2Select.options.selectedIndex = indice_trouve2;
        $efd3ba4ec2608b1d$var$updateModeleZoomFromMenu(0);
        let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast($efd3ba4ec2608b1d$var$Couche1.getModeleZoom());
        if (nowcast1) $efd3ba4ec2608b1d$var$updateDebut(-60);
        console.log(" Modele Zoom trouvees: ", model1, model2);
        trouve1 = false;
        indice_trouve1 = 0;
        for(let indice = 0; indice < $efd3ba4ec2608b1d$var$MapIdH1Select.options.length; indice++)if (mapId1 == $efd3ba4ec2608b1d$var$MapIdH1Select.options[indice].value) {
            indice_trouve1 = indice;
            trouve1 = true;
        }
        trouveCo1 = false;
        indice_trouveCo1 = 0;
        if (mapIdCo1 == "void") trouveCo1 = true;
        else {
            for(let indice = 0; indice < $efd3ba4ec2608b1d$var$MapIdCo1Select.options.length; indice++)if (mapIdCo1 == $efd3ba4ec2608b1d$var$MapIdCo1Select.options[indice].value) {
                indice_trouveCo1 = indice;
                trouveCo1 = true;
            }
        }
        trouve2 = false;
        indice_trouve2 = 0;
        if (mapId2 == "void") trouve2 = true;
        else {
            for(let indice = 0; indice < $efd3ba4ec2608b1d$var$MapIdH2Select.options.length; indice++)if (mapId2 == $efd3ba4ec2608b1d$var$MapIdH2Select.options[indice].value) {
                indice_trouve2 = indice;
                trouve2 = true;
            }
        }
        trouveCo2 = false;
        indice_trouveCo2 = 0;
        if (mapIdCo2 == "void") trouveCo2 = true;
        else {
            for(indice = 0; indice < $efd3ba4ec2608b1d$var$MapIdCo2Select.options.length; indice++)if (mapIdCo2 == $efd3ba4ec2608b1d$var$MapIdCo2Select.options[indice].value) {
                indice_trouveCo2 = indice;
                trouveCo2 = true;
            }
        }
        if (trouve1 && trouveCo1 && trouve2 && trouveCo2) {
            // superpo vaut 0  ou 1
            //  le cas 0 est sans superposition,  et donc intercallé (menu 0)  OU justaposé (menu 2)
            if (superpo == 1) {
                if ($efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex != 1) {
                    $efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex = superpo;
                    $efd3ba4ec2608b1d$var$updateIntercaFromMenu("refresh");
                }
            } else if ($efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex == 1) {
                $efd3ba4ec2608b1d$var$IntercaSelect.options.selectedIndex = 2;
                $efd3ba4ec2608b1d$var$updateIntercaFromMenu("refresh");
            }
            console.log(" MapId trouvees: ", mapId1, mapIdCo1, mapId2, mapIdCo2);
            $efd3ba4ec2608b1d$var$closeChoixDuo("ALL");
            if ($efd3ba4ec2608b1d$var$ActiveLoop) $efd3ba4ec2608b1d$var$StartAnimate();
        } else alert("ChoixDuo pas trouve mapid couche 1: " + mapId1 + " ou couche 2: " + mapId2);
    } else alert("ChoixDuo pas trouve model couche 1: " + model1 + " ou couche 2: " + model2);
    let modele1 = $efd3ba4ec2608b1d$var$Couche1.getModeleZoom();
    let modele2 = $efd3ba4ec2608b1d$var$Couche2.getModeleZoom();
    let nowcast1 = $efd3ba4ec2608b1d$var$isNowcast(modele1);
    let nowcast2 = $efd3ba4ec2608b1d$var$isNowcast(modele2);
    if ($efd3ba4ec2608b1d$var$WindMaps) {
        localStorage.setItem("Model1_V", $efd3ba4ec2608b1d$var$Couche1.modeleZoom);
        localStorage.setItem("Model2_V", $efd3ba4ec2608b1d$var$Couche1.modeleZoom);
        localStorage.setItem("MapIdH1_V", $efd3ba4ec2608b1d$var$Couche1.mapIdH);
        localStorage.setItem("MapIdH2_V", $efd3ba4ec2608b1d$var$Couche2.mapIdH);
        localStorage.setItem("MapIdCo1_V", $efd3ba4ec2608b1d$var$Couche1.mapIdCo);
        localStorage.setItem("MapIdCo2_V", $efd3ba4ec2608b1d$var$Couche2.mapIdCo);
    } else if ($efd3ba4ec2608b1d$var$Nowcast && (nowcast1 || nowcast2) || $efd3ba4ec2608b1d$var$ModelMode && nowcast1 && nowcast2) {
        localStorage.setItem("Model1_N", $efd3ba4ec2608b1d$var$Couche1.modeleZoom);
        localStorage.setItem("Model2_N", $efd3ba4ec2608b1d$var$Couche2.modeleZoom);
        localStorage.setItem("MapIdH1_N", $efd3ba4ec2608b1d$var$Couche1.mapIdH);
        localStorage.setItem("MapIdH2_N", $efd3ba4ec2608b1d$var$Couche2.mapIdH);
        localStorage.setItem("MapIdCo1_N", $efd3ba4ec2608b1d$var$Couche1.mapIdCo);
        localStorage.setItem("MapIdCo2_N", $efd3ba4ec2608b1d$var$Couche2.mapIdCo);
    } else {
        localStorage.setItem("Model1", $efd3ba4ec2608b1d$var$Couche1.modeleZoom);
        localStorage.setItem("Model2", $efd3ba4ec2608b1d$var$Couche2.modeleZoom);
        localStorage.setItem("MapIdH1", $efd3ba4ec2608b1d$var$Couche1.mapIdH);
        localStorage.setItem("MapIdH2", $efd3ba4ec2608b1d$var$Couche2.mapIdH);
        localStorage.setItem("MapIdCo1", $efd3ba4ec2608b1d$var$Couche1.mapIdCo);
        localStorage.setItem("MapIdCo2", $efd3ba4ec2608b1d$var$Couche2.mapIdCo);
    }
    $efd3ba4ec2608b1d$var$ChoixDuoEnCour = false;
}
// -----------------------------------------------------------------------------------
//
// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//
if ($efd3ba4ec2608b1d$var$WindMaps) {
    document.getElementById("ChoixDuoA").style.display = "none";
    document.getElementById("ChoixDuoB").style.display = "none";
    document.getElementById("ChoixDuoN").style.display = "none";
} else document.getElementById("ChoixDuoC").style.display = "none";
// DuoD  pour vents sur sud du quebec
$("#HRDPSve10mvd10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "HRDPS S0", "WIN-_10", "WDIR_10", 1);
});
$("#HRDPSvp10mvd10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "HRDPS S0", "WIND_10", "WDIR_10", 1);
});
$("#HRDPSvd10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "HRDPS S0", "WDIR_10", "void", 1);
});
$("#HRDPSvr10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "HRDPS S0", "GUST_10", "void", 1);
});
$("#HRDPSve10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "HRDPS S0", "WIN-_10", "void", 1);
});
$("#HRDPSvp10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "HRDPS S0", "WIND_10", "void", 1);
});
$("#WCPSCSPEED").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "WCPS", "CSPEED_0.5", "CDIR_0.5", 1);
});
$("#WCPSCDIR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "WCPS", "CDIR_0.5", "void", 1);
});
$("#WCPSCSPEEDCDIR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "WCPS", "CSPEED_0.5", "CDIR_0.5", 1);
});
$("#WCPSCSPEEDCDIRHRDPSve10mvd10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("WCPS", "CSPEED_0.5", "CDIR_0.5", "HRDPS S0", "WIN-_10", "WDIR_10", 0);
});
$("#WCPSCDIRHRDPSvd10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("WCPS", "CDIR_0.5", "void", "HRDPS S0", "WDIR_10", "void", 0);
});
$("#WCPSWLvl").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "WCPS", "SOSSHEIG_", "void", 1);
});
$("#WCPSTTp5m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "WCPS", "VOTEMPER_0.5", "void", 1);
});
$("#WCPSIcc").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "WCPS", "IICECONC_", "void", 1);
});
$("#WCPSWCPSTTp5mIcc").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("WCPS", "VOTEMPER_0.5", "void", "WCPS", "IICECONC_", "void", 1);
});
//  DuoA combinaison de cartes pour un modèle    ET DuoB comparaison de modèles:
$("#RDPSRDPScompoTCDC").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "TCDC_", "HGT_500", "RDPS", "COMPO__h", "PRMSL_", 1);
});
$("#HRDEHRDEcompoTCDC").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "TCDC_", "HGT_500", "HRDPS E", "COMPO__h", "PRMSL_", 1);
});
$("#GDPSGDPScompoTCDC").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "TCDC_", "HGT_500", "GDPS", "COMPO__h", "PRMSL_", 1);
});
$("#GFSGFScompoTCDC").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "TCDC_", "HGT_500", "GFS", "COMPO__h", "PRMSL_", 1);
});
$("#ECMWFECMWFcompoTCDC").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "COMPO__h", "HGT_500", "ECMWF", "COMPO__h", "PRMSL_", 1);
});
$("#AIFSAIFScompoTCDC").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "TCDC_", "HGT_500", "AIFS", "COMPO__h", "PRMSL_", 1);
});
$("#HRDPSERDPScompo").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "COMPO__h", "PRMSL_", "RDPS", "COMPO__h", "PRMSL_", 0);
});
$("#GDPSRDPScompo").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "COMPO__h", "PRMSL_", "RDPS", "COMPO__h", "PRMSL_", 0);
});
$("#GFSGDPScompo").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "COMPO__h", "PRMSL_", "GDPS", "COMPO__h", "PRMSL_", 0);
});
$("#ECMWFGDPScompo").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "COMPO__h", "PRMSL_", "GDPS", "COMPO__h", "PRMSL_", 0);
});
$("#AIFSGDPScompo").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "COMPO__h", "PRMSL_", "GDPS", "COMPO__h", "PRMSL_", 0);
});
$("#RDPSRDPScompoSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "WEASN__h", "PRMSL_", "RDPS", "COMPO__h", "PRMSL_", 0);
});
$("#HRDEHRDEcompoSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WEASN__h", "PRMSL_", "HRDPS E", "COMPO__h", "PRMSL_", 0);
});
$("#GDPSGDPScompoSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WEASN__h", "PRMSL_", "GDPS", "COMPO__h", "PRMSL_", 0);
});
$("#GFSGFScompoSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "WEASN__h", "PRMSL_", "GFS", "COMPO__h", "PRMSL_", 0);
});
$("#ECMWFECMWFcompoSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "WEASN__h", "PRMSL_", "ECMWF", "COMPO__h", "PRMSL_", 0);
});
$("#AIFSAIFScompoSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "WEASN__h", "PRMSL_", "AIFS", "COMPO__h", "PRMSL_", 0);
});
$("#HRDPSERDPSSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WEASN__h", "PRMSL_", "void", "RDPS", "WEASN__h", "PRMSL_", 0);
});
$("#GDPSRDPSSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GRDPS", "WEASN__h", "PRMSL_", "RDPS", "WEASN__h", "PRMSL_", 0);
});
$("#GFSGDPSSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "WEASN__h", "PRMSL_", "GDPS", "WEASN__h", "PRMSL_", 0);
});
$("#ECMWFGDPSSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "WEASN__h", "PRMSL_", "GDPS", "WEASN__h", "PRMSL_", 0);
});
$("#AIFSGDPSSNOW").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "WEASN__h", "PRMSL_", "GDPS", "WEASN__h", "PRMSL_", 0);
});
$("#RDPSRDPScompoFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "WEAFR__h", "PRMSL_", "RDPS", "COMPO__h", "PRMSL_", 0);
});
$("#HRDEHRDEcompoFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WEAFR__h", "PRMSL_", "HRDPS E", "COMPO__h", "PRMSL_", 0);
});
$("#GDPSGDPScompoFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WEAFR__h", "PRMSL_", "GDPS", "COMPO__h", "PRMSL_", 0);
});
$("#GFSGFScompoFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "WEAFR__h", "PRMSL_", "GFS", "COMPO__h", "PRMSL_", 0);
});
$("#ECMWFECMWFcompoFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "WEAFR__h", "PRMSL_", "ECMWF", "COMPO__h", "PRMSL_", 0);
});
$("#AIFSAIFScompoFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "WEAFR__h", "PRMSL_", "AIFS", "COMPO__h", "PRMSL_", 0);
});
$("#HRDPSERDPSFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WEAFR__h", "PRMSL_", "RDPS", "WEAFR__h", "PRMSL_", 0);
});
$("#GDPSRDPSFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WEAFR__h", "PRMSL_", "RDPS", "WEAFR__h", "PRMSL_", 0);
});
$("#GFSGDPSFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "WEAFR__h", "PRMSL_", "GDPS", "WEAFR__h", "PRMSL_", 0);
});
$("#ECMWFGDPSFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "WEAFR__h", "PRMSL_", "GDPS", "WEAFR__h", "PRMSL_", 0);
});
$("#AIFSGDPSFRZR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "WEAFR__h", "PRMSL_", "GDPS", "WEAFR__h", "PRMSL_", 0);
});
$("#RDPSRDPScompoIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "WEAPE__h", "PRMSL_", "RDPS", "COMPO__h", "PRMSL_", 0);
});
$("#HRDEHRDEcompoIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WEAPE__h", "PRMSL_", "HRDPS E", "COMPO__h", "PRMSL_", 0);
});
$("#GDPSGDPScompoIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WEAPE__h", "PRMSL_", "GDPS", "COMPO__h", "PRMSL_", 0);
});
$("#GFSGFScompoIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "WEAPE__h", "PRMSL_", "GFS", "COMPO__h", "PRMSL_", 0);
});
$("#ECMWFECMWFcompoIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "WEAPE__h", "PRMSL_", "ECMWF", "COMPO__h", "PRMSL_", 0);
});
$("#AIFSAIFScompoIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "WEAPE__h", "PRMSL_", "AIFS", "COMPO__h", "PRMSL_", 0);
});
$("#HRDPSERDPSIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WEAPE__h", "PRMSL_", "RDPS", "WEAPE__h", "PRMSL_", 0);
});
$("#GDPSRDPSIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WEAPE__h", "PRMSL_", "RDPS", "WEAPE__h", "PRMSL_", 0);
});
$("#GFSGDPSIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "WEAPE__h", "PRMSL_", "GDPS", "WEAPE__h", "PRMSL_", 0);
});
$("#ECMWFGDPSIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "WEAPE__h", "PRMSL_", "GDPS", "WEAPE__h", "PRMSL_", 0);
});
$("#AIFSGDPSIPIP").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "WEAPE__h", "PRMSL_", "GDPS", "WEAPE__h", "PRMSL_", 0);
});
$("#RDPSRDPScompoRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "WEARN__h", "PRMSL_", "RDPS", "COMPO__h", "PRMSL_", 0);
});
$("#HRDEHRDEcompoRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WEARN__h", "PRMSL_", "HRDPS E", "COMPO__h", "PRMSL_", 0);
});
$("#GDPSGDPScompoRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WEARN__h", "PRMSL_", "GDPS", "COMPO__h", "PRMSL_", 0);
});
$("#GFSGFScompoRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "WEARN__h", "PRMSL_", "GFS", "COMPO__h", "PRMSL_", 0);
});
$("#ECMWFECMWFcompoRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "WEARN__h", "PRMSL_", "ECMWF", "COMPO__h", "PRMSL_", 0);
});
$("#AIFSAIFScompoRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "WEARN__h", "PRMSL_", "AIFS", "COMPO__h", "PRMSL_", 0);
});
$("#HRDPSERDPSRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WEARN__h", "PRMSL_", "RDPS", "WEARN__h", "PRMSL_", 0);
});
$("#GDPSRDPSRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WEARN__h", "PRMSL_", "RDPS", "WEARN__h", "PRMSL_", 0);
});
$("#GFSGDPSRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "WEARN__h", "PRMSL_", "GDPS", "WEARN__h", "PRMSL_", 0);
});
$("#ECMWFGDPSRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "WEARN__h", "PRMSL_", "GDPS", "WEARN__h", "PRMSL_", 0);
});
$("#AIFSGDPSRAIN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "WEARN__h", "PRMSL_", "GDPS", "WEARN__h", "PRMSL_", 0);
});
$("#RDPSRDPSEpaPNPN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "RDPS", "HGT_1000-500_HGT_1000-500", "PRMSL_", 1);
});
$("#GDPSGDPSEpaPNPN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "GDPS", "HGT_1000-500_HGT_1000-500", "PRMSL_", 1);
});
$("#GFSGFSEpaPNPN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "GFS", "HGT_1000-500_HGT_1000-500", "PRMSL_", 1);
});
$("#ECMWFECMWFEpaPNPN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "ECMWF", "HGT_1000-500_HGT_1000-500", "PRMSL_", 1);
});
$("#AIFSAIFSEpaPNPN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "AIFS", "HGT_1000-500_HGT_1000-500", "PRMSL_", 1);
});
$("#GDPSRDPSEpaPN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "HGT_1000-500_HGT_1000-500", "void", "RDPS", "HGT_1000-500_HGT_1000-500", "void", 0);
});
$("#GFSGDPSEpaPN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "HGT_1000-500_HGT_1000-500", "void", "GDPS", "HGT_1000-500_HGT_1000-500", "void", 0);
});
$("#ECMWFGDPSEpaPN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "HGT_1000-500_HGT_1000-500", "void", "GDPS", "HGT_1000-500_HGT_1000-500", "void", 0);
});
$("#AIFSGDPSEpaPN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "HGT_1000-500_HGT_1000-500", "void", "GDPS", "HGT_1000-500_HGT_1000-500", "void", 0);
});
$("#GFSGDPSdelta500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "D-HGT_500", "HGT_500", "GDPS", "HGT_500", "void", 1);
});
$("#ECMWFGDPSdelta500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "D-HGT_500", "HGT_500", "GDPS", "HGT_500", "void", 1);
});
$("#AIFSGDPSdelta500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "D-HGT_500", "HGT_500", "GDPS", "HGT_500", "void", 1);
});
$("#RDPSRDPSLIFXPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "MU-VT-LI_500", "PRMSL_", "RDPS", "HGT_500", "void", 1);
});
$("#GDPSGDPSLIFXPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "MU-VT-LI_500", "PRMSL_", "GDPS", "HGT_500", "void", 1);
});
$("#GDPSRDPSLIFX").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "MU-VT-LI_500", "PRMSL_", "RDPS", "MU-VT-LI_500", "PRMSL_", 0);
});
$("#RDPSRDPSDPTsfcPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "DPT_sfc", "PRMSL_", "RDPS", "HGT_500", "void", 1);
});
$("#HRDEHRDEDPTsfcPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "DPT_sfc", "PRMSL_", "HRDPS E", "HGT_500", "void", 1);
});
$("#GDPSGDPSDPTsfcPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "DPT_sfc", "PRMSL_", "GDPS", "HGT_500", "void", 1);
});
$("#ECMWFECMWFDPTsfcPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "DPT_sfc", "PRMSL_", "ECMWF", "HGT_500", "void", 1);
});
$("#AIFSAIFSDPTsfcPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "DPT_sfc", "PRMSL_", "AIFS", "HGT_500", "void", 1);
});
$("#HRDPSERDPSDPTsfc").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "DPT_sfc", "PRMSL_", "RDPS", "DPT_sfc", "PRMSL_", 0);
});
$("#GDPSRDPSDPTsfc").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "DPT_sfc", "PRMSL_", "RDPS", "DPT_sfc", "PRMSL_", 0);
});
$("#ECMWFGDPSDPTsfc").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "DPT_sfc", "PRMSL_", "GDPS", "DPT_sfc", "PRMSL_", 0);
});
$("#AIFSGDPSDPTsfc").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "DPT_sfc", "PRMSL_", "GDPS", "DPT_sfc", "PRMSL_", 0);
});
$("#RDPSRDPSTT12mPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "TMP_sfc", "PRMSL_", "RDPS", "HGT_500", "void", 1);
});
$("#HRDEHRDETT12mPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "TMP_sfc", "PRMSL_", "HRDPS E", "HGT_500", "void", 1);
});
$("#GDPSGDPSTT12mPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "TMP_sfc", "PRMSL_", "GDPS", "HGT_500", "void", 1);
});
$("#GFSGFSTT12mPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "TMP_sfc", "PRMSL_", "GFS", "HGT_500", "void", 1);
});
$("#ECMWFECMWFTT12mPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "TMP_sfc", "PRMSL_", "ECMWF", "HGT_500", "void", 1);
});
$("#AIFSAIFSTT12mPNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "TMP_sfc", "PRMSL_", "AIFS", "HGT_500", "void", 1);
});
// $("#HRDPSWHRDPSETT12m").click(function(){ ChoixDuo("HRDPS W", "TMP_sfc", "HRDPS E", "TMP_sfc", 1); });
$("#HRDPSERDPSTT12m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "TMP_sfc", "PRMSL_", "RDPS", "TMP_sfc", "PRMSL_", 0);
});
$("#GDPSRDPSTT12m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "TMP_sfc", "PRMSL_", "RDPS", "TMP_sfc", "PRMSL_", 0);
});
$("#GFSGDPSTT12m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "TMP_sfc", "PRMSL_", "GDPS", "TMP_sfc", "PRMSL_", 0);
});
$("#ECMWFGDPSTT12m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "TMP_sfc", "PRMSL_", "GDPS", "TMP_sfc", "PRMSL_", 0);
});
$("#AIFSGDPSTT12m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "TMP_sfc", "PRMSL_", "GDPS", "TMP_sfc", "PRMSL_", 0);
});
$("#RDPSRDPSTT850PNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "TMP_850", "PRMSL_", "RDPS", "HGT_500", "void", 1);
});
$("#HRDEHRDETT850PNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "TMP_850", "PRMSL_", "HRDPS E", "HGT_500", "void", 1);
});
$("#GDPSGDPSTT850PNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "TMP_850", "PRMSL_", "GDPS", "HGT_500", "void", 1);
});
$("#GFSGFSTT850PNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "TMP_850", "PRMSL_", "GFS", "HGT_500", "void", 1);
});
$("#ECMWFECMWFTT850PNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "TMP_850", "PRMSL_", "ECMWF", "HGT_500", "void", 1);
});
$("#AIFSAIFSTT850PNGZ500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "TMP_850", "PRMSL_", "AIFS", "HGT_500", "void", 1);
});
$("#HRDPSERDPSTT850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "TMP_850", "PRMSL_", "RDPS", "TMP_850", "PRMSL_", 0);
});
$("#GDPSRDPSTT850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "TMP_850", "PRMSL_", "RDPS", "TMP_850", "PRMSL_", 0);
});
$("#GFSGDPSTT850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GFS", "TMP_850", "PRMSL_", "GDPS", "TMP_850", "PRMSL_", 0);
});
$("#ECMWFGDPSTT850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("ECMWF", "TMP_850", "PRMSL_", "GDPS", "TMP_850", "PRMSL_", 0);
});
$("#AIFSGDPSTT850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("AIFS", "TMP_850", "PRMSL_", "GDPS", "TMP_850", "PRMSL_", 0);
});
$("#RDPSRDPSve10mvd10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "RDPS", "WIN-_10", "WDIR_10", 1);
});
$("#HRDEHRDEve10mvd10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "HRDPS E", "WIN-_10", "WDIR_10", 1);
});
$("#GDPSGDPSve10mvd10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "GDPS", "WIN-_10", "WDIR_10", 1);
});
$("#HRDPSERDPSve10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WIN-_10", "WDIR_10", "RDPS", "WIN-_10", "WDIR_10", 0);
});
$("#GDPSRDPSve10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WIN-_10", "WDIR_10", "RDPS", "WIN-_10", "WDIR_10", 0);
});
$("#HRDPSERDPSvd10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WDIR_10", "void", "RDPS", "WDIR_10", "void", 0);
});
$("#GDPSRDPSvd10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WDIR_10", "void", "RDPS", "WDIR_10", "void", 0);
});
$("#RDPSRDPSvv850gz850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "WIND_850", "WDIR_850", "RDPS", "HGT_850", "void", 1);
});
$("#GDPSGDPSvv850gz850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WIND_850", "WDIR_850", "GDPS", "HGT_850", "void", 1);
});
$("#HRDPSERDPSve850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "WIND_850", "WDIR_850", "RDPS", "WIND_850", "WDIR_850", 0);
});
$("#GDPSRDPSve850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WIND_850", "WDIR_850", "RDPS", "WIND_850", "WDIR_850", 0);
});
$("#RDPSRDPSvv250gz250").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "WIND_250", "WDIR_250", "RDPS", "HGT_250", "void", 1);
});
$("#GDPSGDPSvv250gz250").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WIND_250", "WDIR_250", "GDPS", "HGT_250", "void", 1);
});
$("#RDPSRDPSvv850windgz850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "WIND_850", "WDIR_850", "RDPS", "WIND_850", "HGT_850", 0);
});
$("#GDPSGDPSvv850windgz850").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WIND_850", "WDIR_850", "GDPS", "WIND_850", "HGT_850", 0);
});
$("#RDPSRDPSvv250windgz250").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "WIND_250", "WDIR_250", "RDPS", "WIND_250", "HGT_250", 0);
});
$("#GDPSGDPSvv250windgz250").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "WIND_250", "WDIR_250", "GDPS", "WIND_250", "HGT_250", 0);
});
$("#RDPSRDPSvr10mGP500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RDPS", "GUST_10", "PRMSL_", "RDPS", "HGT_500", "void", 1);
});
$("#HRDEHRDEvr10mGP500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "GUST_10", "PRMSL_", "HRDPS E", "HGT_500", "void", 1);
});
$("#GDPSGDPSvr10mGP500").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "GUST_10", "PRMSL_", "GDPS", "HGT_500", "void", 1);
});
$("#HRDPSERDPSvr10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("HRDPS E", "GUST_10", "void", "RDPS", "GUST_10", "void", 0);
});
$("#GDPSRDPSvr10m").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GDPS", "GUST_10", "void", "RDPS", "GUST_10", "void", 0);
});
// DuoC   pour état de la mer             
//Ici Variable combinées   
$("#DIAGWDIAGWIaGIaDirIaH").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "IaH_Sfc", "void", "DIAGW", "IaG_Sfc", "IaDir_Sfc", 0);
});
$("#DIAGWDIAGWIaGIaDirIaLc").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "IaLc_Sfc", "void", "DIAGW", "IaG_Sfc", "IaDir_Sfc", 0);
});
$("#DIAGWDIAGWIaGIaDirAMPLCDIR").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "AMPL_Sfc", "CDIR_0.5", "DIAGW", "IaG_Sfc", "IaDir_Sfc", 0);
});
$("#DIAGWDIAGWIaGIaDirIamask").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Ia_mask_Sfc", "void", "DIAGW", "IaG_Sfc", "IaDir_Sfc", 0);
});
$("#DIAGWDIAGWIa2GIa2DirIa2mask").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Ia2_mask_Sfc", "void", "DIAGW", "Ia2G_Sfc", "Ia2Dir_Sfc", 0);
});
$("#DIAGWDIAGWIa2GIa2DirIaGIaDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Ia2G_Sfc", "Ia2Dir_Sfc", "DIAGW", "IaG_Sfc", "IaDir_Sfc", 0);
});
//------------------------------------------------------------Par groupes --------------------------------------
// ici agitation et hauteur
$("#DIAGWDIAGWIaVWavHVWavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "WVHGT_Sfc", "WVDIR_Sfc", "DIAGW", "Ia_V_Sfc", "void", 0);
});
$("#DIAGWDIAGWIa1HWavHH1WavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", "DIAGW", "Ia_1H_Sfc", "void", 0);
});
$("#DIAGWDIAGWIa2HWavHH2WavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", "DIAGW", "Ia_2H_Sfc", "void", 0);
});
//Ici agitation et cambrure 
$("#DIAGWDIAGWIaVCmbrV").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "CmbrV_Sfc", "WVDIR_Sfc", "DIAGW", "Ia_V_Sfc", "WVDIR_Sfc", 0);
});
$("#DIAGWDIAGWIa1HCmbr1H").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Cmbr1H_Sfc", "H1DIR_Sfc", "DIAGW", "Ia_1H_Sfc", "H1DIR_Sfc", 0);
});
$("#DIAGWDIAGWIa2HCmbr2H").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Cmbr2H_Sfc", "H2DIR_Sfc", "DIAGW", "Ia_2H_Sfc", "H2DIR_Sfc", 0);
});
//Ici courant et cambrure 
$("#DIAGWDIAGWCSPEEDCmbrV").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "CmbrV_Sfc", "WVDIR_Sfc", "DIAGW", "CSPEED_0.5", "CDIR_0.5", 0);
});
$("#DIAGWDIAGWCSPEEDCmbr1H").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Cmbr1H_Sfc", "H1DIR_Sfc", "DIAGW", "CSPEED_0.5", "CDIR_0.5", 0);
});
$("#DIAGWDIAGWCSPEEDCmbr2H").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Cmbr2H_Sfc", "H2DIR_Sfc", "DIAGW", "CSPEED_0.5", "CDIR_0.5", 0);
});
//Ici hauteur et cambrure 
$("#DIAGWDIAGWWWavHWWavDirCambV").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "CmbrV_Sfc", "WVDIR_Sfc", "DIAGW", "WVHGT_Sfc", "WVDIR_Sfc", 0);
});
$("#DIAGWDIAGWH1WavHH1WavDirCamb1H").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Cmbr1H_Sfc", "H1DIR_Sfc", "DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", 0);
});
$("#DIAGWDIAGWH2WavHH2WavDirCamb2H").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Cmbr2H_Sfc", "H2DIR_Sfc", "DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", 0);
});
//Ici hauteur et amplification+ dircou 
$("#DIAGWDIAGWWavHWWavDirAMPLV").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "AMPLV_Sfc", "CDIR_0.5", "DIAGW", "WVHGT_Sfc", "WVDIR_Sfc", 0);
});
$("#DIAGWDIAGWWavHH1WavDirAMPL1H").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "AMPL1H_Sfc", "CDIR_0.5", "DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", 0);
});
$("#DIAGWDIAGWWavHH2WavDirAMPL2H").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "AMPL2H_Sfc", "CDIR_0.5", "DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", 0);
});
//Ici hauteur+dir  d origine et hauteur recalculés+dircou 
$("#DIAGWRDWPSWavHWWavDirWVHGT").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "WVHGT_Sfc", "WVDIR_Sfc", "RDWPS", "WVHGT_Sfc", "WVDIR_Sfc", 0);
});
$("#DIAGWRDWPSWavHH1WavDirSWHFSWEL").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", "RDWPS", "SWHFSWEL_Sfc", "MWDFSWEL_Sfc", 0);
});
$("#DIAGWRDWPSWavHH2WavDirSWHSSWEL").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", "RDWPS", "SWHSSWEL_Sfc", "MWDSSWEL_Sfc", 0);
});
// ici agitation et croisement 
$("#DIAGWDIAGWIaVXV").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Ic_V_Sfc", "WVDIR_Sfc", "DIAGW", "Ia_V_Sfc", "void", 0);
});
$("#DIAGWDIAGWIa1HX1H").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Ic_1H_Sfc", "H1DIR_Sfc", "DIAGW", "Ia_1H_Sfc", "void", 0);
});
$("#DIAGWDIAGWIa2HX2H").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Ic_2H_Sfc", "H2DIR_Sfc", "DIAGW", "Ia_2H_Sfc", "void", 0);
});
// ici comparaison de groupe :  Periodes  et directions
//$("#RWDPSRDWPSPerWWWavDirPerH1H1WavDir").click(function(){    ChoixDuo("RDWPS", "PWPFSWEL_Sfc", "MWDFSWEL_Sfc", "RDWPS", "PPERWW_Sfc",   "WVDIR_Sfc", 0); });
//$("#RWDPSRDWPSPerH1H1WavDirPerH2H2WavDir").click(function(){  ChoixDuo("RDWPS", "PWPSSWEL_Sfc", "MWDSSWEL_Sfc", "RDWPS", "PWPFSWEL_Sfc", "MWDFSWEL_Sfc", 0); });
//$("#RWDPSRDWPSPerH2H2WavDirPerWWWavDir").click(function(){    ChoixDuo("RDWPS", "PPERWW_Sfc",   "WVDIR_Sfc",    "RDWPS", "PWPSSWEL_Sfc", "MWDSSWEL_Sfc", 0); });
// ici comparaison de groupe :  Agitation  et directions
$("#DIAGWDIAGWIa_VVWavDirIa_1HH1WavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Ia_1H_Sfc", "H1DIR_Sfc", "DIAGW", "Ia_V_Sfc", "WVDIR_Sfc", 0);
});
$("#DIAGWDIAGWIa_1HH1VWavDirIa_2HH2WavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Ia_2H_Sfc", "H2DIR_Sfc", "DIAGW", "Ia_1H_Sfc", "H1DIR_Sfc", 0);
});
$("#DIAGWDIAGWIa_2HH2WavDirIa_VVWavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "Ia_V_Sfc", "WVDIR_Sfc", "DIAGW", "Ia_2H_Sfc", "H2DIR_Sfc", 0);
});
// ici comparaison de groupe :  Hauteurs  et directions
$("#DIAGWDIAGWWavHVVWavDirH1WavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", "DIAGW", "WVHGT_Sfc", "WVDIR_Sfc", 0);
});
$("#DIAGWDIAGWWavHH1WavDirH2WavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", "DIAGW", "SWHFSWEL_Sfc", "H1DIR_Sfc", 0);
});
$("#DIAGWDIAGWWavHH2WavDirVWavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "WVHGT_Sfc", "WVDIR_Sfc", "DIAGW", "SWHSSWEL_Sfc", "H2DIR_Sfc", 0);
});
// ici comparaison de groupe :  directions
$("#DIAGWDIAGWVWavDirH1WavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "H1DIR_Sfc", "H1DIR_Sfc", "DIAGW", "WVDIR_Sfc", "WVDIR_Sfc", 1);
});
$("#DIAGWDIAGWH1WavDirH2WavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "H2DIR_Sfc", "H2DIR_Sfc", "DIAGW", "H1DIR_Sfc", "H1DIR_Sfc", 1);
});
$("#DIAGWDIAGWH2WavDirVWavDir").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("DIAGW", "WVDIR_Sfc", "WVDIR_Sfc", "DIAGW", "H2DIR_Sfc", "H2DIR_Sfc", 1);
});
//-----------------------------------------------------------------------------------------------
// DuoN : active COntinental
$("#voidRADARvoidRco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "RADAR CO", "RRAI", "void", 1);
});
$("#GOESRADARIRcoRco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "GOESR_PLUS", "C13_CO", "RRAI", 1);
});
$("#GOESRADARVIcoRco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "GOESR_PLUS", "C02_CO", "RRAI", 1);
});
$("#RADARRADARRcoRcoN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RADAR CO", "RRAI", "void", "RADAR CO", "RRAI_NET", "void", 0);
});
$("#GOESRADARFOcoRco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("FOUDRE CO", "FOUDRE_PTS_CO", "void", "RADAR CO", "RRAI", "void", 0);
});
$("#voidRADARvoidSco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "RADAR CO", "RSNO", "void", 1);
});
$("#GOESRADARIRcoSco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "GOESR_PLUS", "C13_CO", "RSNO", 1);
});
$("#GOESRADARVIcoSco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "GOESR_PLUS", "C02_CO", "RSNO", 1);
});
$("#RADARRADARScoScoN").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("RADAR CO", "RSNO", "void", "RADAR CO", "RSNO_NET", "void", 0);
});
$("#GOESRADARFOcoSco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("FOUDRE CO", "FOUDRE_PTS_CO", "void", "RADAR CO", "RSNO", "void", 0);
});
$("#GOESRADARIR_FOcoIR_Rco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C13_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C13_CO", "RRAI", 0);
});
$("#GOESRADARVI_FOcoVI_Rco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C02_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C02_CO", "RRAI", 0);
});
$("#GOESRADARIR_FOcoVI_Rco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C13_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C02_CO", "RRAI", 0);
});
$("#GOESRADARVI_FOcoIR_Rco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C02_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C13_CO", "RRAI", 0);
});
$("#RADARRADARVI_RcoIR_Rco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C02_CO", "RRAI", "GOESR_PLUS", "C13_CO", "RRAI", 0);
});
$("#GOESRADARIR_FOcoIR_Sco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C13_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C13_CO", "RSNO", 0);
});
$("#GOESRADARVI_FOcoVI_Sco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C02_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C02_CO", "RSNO", 0);
});
$("#GOESRADARIR_FOcoVI_Sco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C13_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C02_CO", "RSNO", 0);
});
$("#GOESRADARVI_FOcoIR_Sco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C02_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C13_CO", "RSNO", 0);
});
$("#RADARRADARVI_ScoIR_Sco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C02_CO", "RSNO", "GOESR_PLUS", "C13_CO", "RSNO", 0);
});
$("#voidGOESRvoidIRco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "GOESR CO", "C13_CO", "void", 1);
});
$("#voidGOESRvoidVIco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("void", "void", "void", "GOESR CO", "C02_CO", "void", 1);
});
$("#GOESGOESIRcoVIco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR CO", "C02_CO", "void", "GOESR CO", "C13_CO", "void", 0);
});
$("#GOESGOESIR_FOcoIR_Sco").click(function() {
    $efd3ba4ec2608b1d$var$ChoixDuo("GOESR_PLUS", "C02_CO", "FOUDRE_PTS_CO", "GOESR_PLUS", "C13_CO", "FOUDRE_PTS_CO", 0);
}); // DuoN   not active
 //$("#GOESRDPSIRcoNu").click(function(){ ChoixDuo("GOESR CO",   "C13_CO", "RDPS",    "HGT_500_TCDC_", 0); });
 //$("#GOESRDPSIRcocompo").click(function(){ ChoixDuo("GOESR CO",   "C13_CO", "RDPS",    "COMPO__h", 1); });
 //$("#GOESRDPSIRcoGZ500PN").click(function(){ ChoixDuo("GOESR CO",   "C13_CO", "RDPS",    "HGT_500_PRMSL_", 1); });
 //$("#GOESRDPSVIcoNu").click(function(){ ChoixDuo("GOESR CO",   "C02_CO", "RDPS",    "HGT_500_TCDC_", 0); });
 //$("#GOESRDPSVIcocompo").click(function(){ ChoixDuo("GOESR CO",   "C02_CO", "RDPS",    "COMPO__h", 1); });
 //$("#GOESRDPSVIcoGZ500PN").click(function(){ ChoixDuo("GOESR CO",   "C02_CO", "RDPS",    "HGT_500_PRMSL_", 1); });
 //$("#RADARRDPSRcocompo").click(function(){ ChoixDuo("RADAR CO",  "2KM_RRAI", "RDPS",    "COMPO__h", 0); });
 //$("#RADARRDPSRcoGZ500PN").click(function(){ ChoixDuo("RADAR CO",  "2KM_RRAI", "RDPS",    "HGT_500_PRMSL_", 1); });
 //$("#RADARRDPSRcoGZ500Vort").click(function(){ ChoixDuo("RADAR CO",  "2KM_RRAI", "RDPS",    "ABSV_500_HGT_500_ABSV_500", 1); });
 //$("#RADARRADARScoRco").click(function(){ ChoixDuo("RADAR CO",   "2KM_RSNO", "RADAR CO",    "2KM_RRAI", 0); });
 //$("#RADARRDPSScocompo").click(function(){ ChoixDuo("RADAR CO",  "2KM_RSNO", "RDPS",    "COMPO__h", 0); });
 //$("#RADARRDPSScoGZ500PN").click(function(){ ChoixDuo("RADAR CO",  "2KM_RSNO", "RDPS",    "HGT_500_PRMSL_", 1); });
 //$("#RADARRDPSScoGZ500Vort").click(function(){ ChoixDuo("RADAR CO",  "2KM_RSNO", "RDPS",    "ABSV_500_HGT_500_ABSV_500", 1); });
 //$("#RDPSRADARNuSco").click(function(){ ChoixDuo("RDPS",   "HGT_500_TCDC_", "RADAR CO",    "2KM_RSNO", 0); });
 //$("#RDPSRADARNuRco").click(function(){ ChoixDuo("RDPS",  "HGT_500_TCDC_", "RADAR CO",    "2KM_RRAI", 0); });
 //$("#RDPSGOESRNuIRco").click(function(){ ChoixDuo("RDPS", "HGT_500_TCDC_", "GOESR CO",    "C13_CO", 0); });
 //$("#RDPSGOESRNuVIco").click(function(){ ChoixDuo("RDPS", "HGT_500_TCDC_", "GOESR CO",    "C02_CO", 0); });
 //$("#RDPSRADARcompoSco").click(function(){ ChoixDuo("RDPS",   "COMPO__h", "RADAR CO",    "2KM_RSNO", 0); });
 //$("#RDPSRADARcompoRco").click(function(){ ChoixDuo("RDPS",  "COMPO__h", "RADAR CO",    "2KM_RRAI", 0); });
 //$("#RDPSGOESRcompoIRco").click(function(){ ChoixDuo("RDPS", "COMPO__h", "GOESR CO",    "C13_CO", 0); });
 //$("#RDPSGOESRcompoVIco").click(function(){ ChoixDuo("RDPS", "COMPO__h", "GOESR CO",    "C02_CO", 0); });


//# sourceMappingURL=index.aeead73b.js.map
